webpackJsonp([5],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

var ACCOUNT = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
	LOGIN_SSO: 'LOGIN_SSO',
	LOGIN: 'LOGIN',
	LOGOUT: 'LOGOUT',
	RSET_PSWD: 'RESET_PASSWORD',
	COMPEL_CHANGE_PSWD: 'COMPEL_CHANGE_PASSWORD',
	GET: 'GET_ACCOUNT',
	SET: 'SET_ACCOUNT',
	UPDATE: 'UPDATE_ACCOUNT',
	CURRENT: 'GET_CURRENT_ACCOUNT',
	GET_SUCH_ACCOUNT: 'GET_ONE_ACCUONT_ONFO',
	GET_MFA_SECRET: 'GET_MFA_SECRET',
	POST_MFA_CODE: 'POST_MFA_CODE',
	VERIFY_MFA_CODE: 'VERIFY_MFA_CODE',
	CODE: 'GET_CODE',
	VERIFY: 'VERIFY_MOBILE',
	FORGRTPASSWORD: 'FORGOT_PASSWORD',
	CAANGE_AVATAR: 'CHANGE_CURRENT_ACCOUNT_AVATAR',
	SHOW_CAPTCHA: 'SHOW_CAPTCHA',
	NOTIFY_BANNER: 'NOTIFY_BANNER',
	CHECK_SSO: 'CHECK_SSO'
});

var SSHKEY = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
	GET: 'GET_LIST',
	ADD: 'ADD_LIST',
	DEL: 'DEL_LIST',
	UPDATE: 'UPDATE_LIST'
});

var TEAM = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
	CURRENT: 'GET_CURRENT_COMPANY',
	LIST: 'GET_TEAM_LIST',
	GET_MEMBER_LIST: 'GET_TEAM_MEMBER_LIST',
	ADD: 'ADD_TEAM_MEMBER',
	UPDATE: 'UPDATE_TEAM_LIST',
	SET: 'SET_CURRENT_TEAM_INDO',
	DELETE: 'DELETE_TEAM_MEMBER',
	GET_MEMBER: 'GET_TEAM_MEMBER_INFO',
	EDIT_MEMBER: 'EDIT_TEAM_MEMBER_INFO',
	GROUP_LIST: 'GET_TEAM_GROUP_LIST',
	ADD_GROUP: 'ADD_TEAM_GROUP',
	EDIT_GROUP: 'EDIT_TEAM_GROUP_INFO',
	DELETE_GROUP: 'DELETE_TEAM_GROUP',
	GET_GROUP: 'GET_TEAM_GROUP_INFO',
	GET_GROUP_MEMBERS: 'GET_TEAM_GROUP_MEMBER_LIST',
	GROUP_ADD_MEMBER: 'TEAM_GROUP_ADD_MEMBER',
	DEL_GROUP_MEMBER: 'DELETE_TEAM_GROUP_MEMBER',
	GET_STATISTIC_TEAM: 'GET_STATISTIC_TEAM',
	GET_RESOURCE_STATISTIC_TEAM: 'GET_RESOURCE_STATISTIC_TEAM',
	GET_PLAN: 'GET_PLAN_INFO',
	UPDATE_TEAM_TOKEN: 'UPDATE_TEAM_TOKEN',
	UNBIND_WORKSPACE: 'UNBIND_WORKSPACE',
	RESET_MFA: 'RESET_MFA',
	GET_SSO_CONFIG: 'GET_SSO_CONFIG',
	UPDATE_SSO_CONFIG: 'UPDATE_SSO_CONFIG',
	GET_NTP_CONFIG: 'GET_NTP_CONFIG',
	UPDATE_NTP_CONFIG: 'UPDATE_NTP_CONFIG'
});

var LOG = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
	LOGIN: 'LOGIN_LOGS',
	TEAM: 'TEAM_LOGS',
	UNFREEZE: 'UNFREEZE',
	VIEW_LOG: 'VIEW_LOG',
	CLUSTER: 'CLUSTER_LOGS',
	RESOURCE: 'RESOURCE_LOGS',
	ALARM: 'ALARM',
	HANDLE_NOTICE: 'HANDLE_NOTICE',
	ACTION: 'ACTION_LOGS',
	GET_ACCOUNT_NAME: 'GET_ALL_ACCOUNT_NAME',
	GET_RESOURCE_NAME: 'GET_ALL_RESURCE_NAME',
	GET_ALARM_NOTIFY_UNREAD_COUNTS: 'GET_ALARM_NOTIFY_UNREAD_COUNTS',
	CLOSE_ALARM_NOTIFY: 'CLOSE_ALARM_NOTIFY',
	UNREAD_COUNTS: 'UNREAD_COUNTS'
});

var CLUSTER = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
	GET: 'GET_CLUSTER_LIST',
	GET_CLUSTER: 'GET_CLUSTER',
	ADD: 'ADD_CLUSTER',
	DELETE: 'DELETE_CLUSTER',
	CHANGE: 'CHANGE_CLUSTER_INFO',
	GET_DETAIL: 'GET_CLUSTER_DETAIL',
	DETAIL_LIST: 'GET_CLUSTER_DETAIL_LIST',
	GET_CLUSTER_RESOURCE: 'GET_CLUSTER_RESOURCE',
	DELETE_RESOURCE: 'DELETE_DETAIL_RESOURCE',
	BATCH_DELETE_RESOURCE: 'BATCH_DELETE_RESURCE',
	ADD_RESOURCE: 'ADD_CLUSTER_RESOURCE',
	PATCH_RESOURCE: 'PATCH_RESOURCE_DETAIL',
	GET_RESOURCE_DETAIL: 'GET_RESOURCE_DETAIL',
	GET_INTERCEPTS_COMMADN: 'GET_INTERCEPTS_COMMADN',
	ADD_LOG_FILTER: 'ADD_LOG_FILTER',
	DEL_LOG_FILTER: 'DEL_LOG_FILTER',
	DEL_BARCH_LOG_FILTER: 'DEL_BATCH_LOG_FILTER',
	UPDATE_DETAIL: 'UPDATE_DETAIL_RESOURCE_INFO',
	CHECK_AGENT: 'CHECK_AGENT_NEW_VERSION',
	GET_SHARING: 'GET_SHARING_CLUSTER_LIST',
	ADD_SHARING: 'ADD_SHARING_CLUSTER',
	CANCEL_SHARE: 'CANCEL_SHARING_CLUSTER',
	GET_SAFE_APPROVER: 'GET_SAFE_APPROVER',
	ADD_INTERCEPT: 'ADD_NEED_INTERCEPT_COMMAND',
	DEL_INTERCEPT: 'DEL_NEED_INTERCEPT_COMMAND',
	DEL_ALARM_INTERCEPT: 'DEL_NEED_INTERCEPT_COMMAND_ALARM',
	SCAN_SATRT: 'SCAN_IMPORT_START',
	SCAN_QUERY: 'SCAN_IMPORT_QUERY',
	POST_BATCH_RESOURCE: 'SCAN_IMPORT_BATCH_RESOURCE',
	TEST_CONNECTION: 'TEST_CONNECTION',
	QUERY_TEST: 'QUERY_TEST_CONNECTION',
	TEST_KEY_AVALIABLE: 'TEST_KEY_AVALIABLE',
	QUERY_KEY_AVALIABLE: 'QUERY_KEY_AVALIABLE',
	XLSX_BATCH_IMPORT: 'XLSX_BATCH_IMPORT_RESOIRCE',
	GET_CLUSTER_RESOURCE_STATISTIC: 'GET_CLUSTER_RESOURCE_STATISTIC',
	GET_CLUSTER_STATISTIC: 'GET_CLUSTER_STATISTIC',
	GET_RESOURCE_STATISTIC: 'GET_RESOURCE_STATISTIC',
	UOLOAD_SSHKEY: 'HOST_SETTING_UPLOAD_SSHKEY',
	QUERY_SSHKEY: 'QUERY_SSHKEY',
	GET_ALIYUN_ECS: 'GET_ALIYUN_ECS',
	SCAN_NEW_QUERY: 'SCAN_NEW_QUERY',
	BAECH_DELETE_ONLINE_USER: 'BAECH_DELETE_ONLINE_USER',
	AGENT_VERSION: 'AGENT_VERSION',
	CLOUD_IMPORT_ECS: 'CLOUD_IMPORT_ECS',
	CLOUD_IMPORT_RDS: 'CLOUD_IMPORT_RDS',
	CLOUD_GET_REGIONS: 'CLOUD_GET_REGIONS',
	SCAN_INSTANCE: 'SCAN_INSTANCE',
	LOAD_INSTANCE: 'LOAD_INSTANCE',
	GET_RESOURCE_LISTS: 'GET_RESOURCE_LISTS',
	EXPORT_CLUSTER_CONFIG: 'EXPORT_CLUSTER_CONFIG',
	IMPORT_CLUSTER_CONFIG: 'IMPORT_CLUSTER_CONFIG',
	POLLING_CLUSTER_CONFIG: 'POLLING_CLUSTER_CONFIG',
	SET_CONFIG_POLLING_INSTANCE: 'SET_CONFIG_POLLING_INSTANCE',
	CLEAR_CONFIG_POLLING_INSTANCE: 'CLEAR_CONFIG_POLLING_INSTANCE'
});

var DOCUMENT = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
	GET_LIST: 'GET_DOCUMENT_LIST',
	DEL: 'DELETE_DOCUMENT',
	UPLOAD: 'UPLOAD_DOCUMENT'
});

var WORKGROUP = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
	LIST_WORKGROUP: 'LIST_WORKGROUP',
	LIST_FAVOURITE_WORKGROUP: 'LIST_FAVOURITE_WORKGROUP',
	SET_FAVOURITE: 'SET_FAVOURITE',
	GET_WORKGROUP_DETAIL: 'GET_WORKGROUP_DETAIL',
	LIST_WORKGROUP_RESOURCE: 'LIST_WORKGROUP_RESOURCE',
	GET_TUNNEL_CODE: 'GET_TUNNEL_CODE',
	DELETE_WORKGROUP: 'DELETE_WORKGROUP',
	CREATE_CSOS_REPORT: 'CREATE_CSOS_REPORT',
	GET_CSOS_REPORT: 'GET_CSOS_REPORT',
	GET_CSOS_REPORT_STATE: 'GET_CSOS_REPORT_STATE',
	GET_VERSION_BY_TYPE: 'GET_VERSION_BY_TYPE',
	CREATED_WORKGROUP: 'CREATED_WORKGROUP',
	PATCH_WORKGROUP: 'PATCH_WORKGROUP',
	GET_CONNECT_LOG: 'GET_CONNECT_LOG',
	GET_TUNNEL_INFO: 'GET_TUNNEL_INFO',
	TEST_PASSWORD_CONNECTION: 'TEST_PASSWORD_CONNECTION',
	UPDATE_TUNNEL: 'UPDATE_TUNNEL',
	DEL_WORKGROUP_RESOURCE: 'DELETE_WORKGROUP_RESOURCE',
	ADD_WORKGTOUP_RESOURCE: 'ADD_WORKGROUP_RESOURCE',
	GET_MEMBER_LIST: 'GET_WORKGROUP_MEMBER_LIST',
	DEL_MEMBER: 'DEL_WORKGROUP_MEMBER',
	ADD_MEMBER: 'ADD_WORKGTOUP_MEMBER',
	PATCH_MEMBER: 'PATCH_WORKGROUP_MEMBER',
	GET_MEMBER_ADMIN: 'GET_MEMBER_ADMIN',
	GET_PROJECT_RESOURCE_INFO: 'GET_PROJECT_RESOURCE_INFO',
	GET_CLIENT_IP: 'GET_CLIENT_IP',
	CREATE_CODE: 'CREATE_CODE',
	DELETE_CODE: 'DELETE_CODE',
	GET_CODE_INFO: 'GET_CODE_INFO',
	MODIFY_CODE: 'MODIFY_CODE',
	SET_PROJECT_DEFAULT_NAME: 'SET_PROJECT_DEFAULT_NAME',
	GET_CODE_VERSION: 'GET_CODE_VERSION',
	GET_LITE_CONNECT_INFO: 'GET_LITE_CONNECT_INFO',
	GET_WORKGROUP_RESOURCE_ONLINE_CONNECTS: 'GET_RESOURCE_ONLINE_CONNECTS',
	GET_ASSIST_INFO: 'GET_ASSIST_INFO',
	GET_SHADOW_CONNECT: 'GET_SHADOW_CONNECT',
	QUERY_CSOS_CONNECT: 'QUERY_CSOS_CONNECT',
	GET_CSOS_SHADOW: 'GET_CSOS_SHADOW',
	GET_WORKGROUP_GROUP: 'GET_WORKGROUP_GROUP',
	GET_GROUP_LIST: 'GET_WORKGROUP_GROUP_LIST',
	ADD_GROUP: 'ADD_WORKGTOUP_GROUP',
	DEL_GROUP: 'DEL_WORKGROUP_GROUP',
	CHANGE_LOGIN_USER: 'CHANGE_LOGIN_USER',
	VERIFY_SQL: 'VERIFY_SQL',
	GET_ACCOUNT_WORKGROUP_LIST: 'GET_ACCOUNT_WORKGROUP_LIST',
	ADD_ACCOUNT_WORKGROUP: 'ADD_ACCOUNT_WORKGROUP',
	DEL_ACCOUNT_WORKGROUP: 'DEL_ACCOUNT_WORKGROUP',
	GET_WORKGROUP_LIST_BY_GROUP: 'GET_WORKGROUP_LIST_BY_GROUP',
	ADD_GROUP_WORKGROUP: 'ADD_GROUP_WORKGROUP',
	DEL_GROUP_WORKGROUP: 'DEL_GROUP_WORKGROUP'
});

var DASHBOARD = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
	LIST_ONLINE_CONNECT_COUNTS: 'LIST_ONLINE_CONNECT_COUNTS',
	LIST_ONLINE_CONNECT: 'LIST_ONLINE_CONNECT',
	CUT_ONLINE: 'CUE_ONLINE',
	CUT_ONLINE_MULTIPLE: 'CUT_ONLINE_MULTIPLE',
	LIST_WORKGROUP_RESOURCE: 'LIST_DASHBOARD_RESOURCE',
	LIST_TOP_MEMBERS: 'LIST_TOP_MEMBERS',
	LIST_TOP_RESOURCES: 'LIST_TOP_RESOURCES',
	GET_STATISTICS: 'GET_STATISTICS',
	GET_CONNECT_NUMBER: 'GET_CONNECT_NUMBER',
	GET_OPERATION_WEEK: 'GET_OPERATION_WEEK',
	GET_RESOURCE_TYPE_STATISTIC: 'GET_RESOURCE_TYPE_STATISTIC',
	GET_ONLINE_CONNECT: 'GET_ONLINE_CONNECT',
	GET_STATISTIC_SUMMARY: 'GET_STATISTIC_SUMMARY'
});

var REVIEW = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
	GET_PROJECT_LIST: 'GET_PROJECT_LIST',
	GET_RESOURCE_LIST: 'GET_RESOURCE_LIST',
	CREATE_SQL_APPLICATION: 'CREATE_SQL_APPLICATION',
	GET_MY_SQL_APPLICATION: 'GET_MY_SQL_APPLICATION',
	GET_SQL_APPROVING_APPLICATION: 'GET_SQL_APPROVING_APPLICATION',
	GET_SQL_APPROVED_APPLICATION: 'GET_SQL_APPROVED_APPLICATION',
	GET_SAFE_APPLICATION: 'GET_SAFE_APPLICATION',
	CREATE_SAFE_APPLY: 'CREATE_SAFE_APPLY',
	GET_MY_SAFE_APPLY: 'GET_MY_SAFE_APPLY',
	GET_SAFE_APPROVING_APPLY: 'GET_SAFE_APPROVING_APPLY',
	GET_SAFE_APPROVED_APPLY: 'GET_SAFE_APPROVED_APPLY',
	GET_MY_APPLY_DETAIL: 'GET_MY_APPLY_DETAIL',
	DELETE_SQL_APPLY: 'DELETE_SQL_APPLY',
	EXECUTE_SQL_APPLICATION: 'EXECUTE_SQL_APPLICATION',
	REJECT_SQL_APPLICATION: 'REJECT_SQL_APPLICATION',
	GET_SAFE_DETAIL: 'GET_SAFE_DETAIL',
	DELETE_SAFE_APPLY: 'DELETE_SAFE_APPLY',
	DO_SAFE_EXCUTE: 'DO_SAFE_EXCUTE',
	DO_SAFE_REJECT: 'DO_SAFE_REJECT',
	GET_ONLINE_CONNECT: 'GET_ONLINE_CONNECT'
});

/* harmony default export */ __webpack_exports__["a"] = ({
	ACCOUNT: ACCOUNT,
	TEAM: TEAM,
	LOG: LOG,
	CLUSTER: CLUSTER,
	DOCUMENT: DOCUMENT,
	SSHKEY: SSHKEY,
	DASHBOARD: DASHBOARD,
	REVIEW: REVIEW,
	WORKGROUP: WORKGROUP
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Utils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return enableHome; });
/* harmony export (immutable) */ __webpack_exports__["k"] = deepCopy;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Base64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SelectOptionsConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ClusterRegionConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ClusterAliyunSupport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PasswordStrengthMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PasswordStrengthRegExp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PasswordStrengthRegExpCallback; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);




var _event;

var Utils = {
	config: {
		maxPageSize: 65535,
		pageSize: 10,
		enableHome: true,
		development: {
			csosHost: 'preprod-csos.cloudcare.cn',
			apiUrl: '/api',

			homeApiUrl: 'https://preprod-home.cloudcare.cn/api',
			ccLogout: 'https://preprod-home.prof.wang/issue/list',
			csosTool: 'https://preprod-csos.cloudcare.cn/',
			h5Url: 'https://preprod-h5.cloudcare.cn/',
			litews: 'wss://preprod-csos-lite.cloudcare.cn/api',
			csosws: 'wss://preprod-csos.cloudcare.cn/api',
			agentInstallUrl: 'https://preprod-csos.cloudcare.cn/api/linkitScript/install.sh',
			backAgentUrl: 'https://preprod-csos.cloudcare.cn/api/linkitScript',
			databaseReportUrl: 'http://localhost:5175'
		},
		testing: {
			csosHost: 'testing-csos.cloudcare.cn',
			apiUrl: 'http://testing-csos.cloudcare.cn/api',
			homeApiUrl: 'http://testing-home.cloudcare.cn:85/api',
			ccLogout: 'http://testing-profwang-home.cloudcare.cn:10301/issue/list',
			csosTool: 'http://testing-csos.cloudcare.cn/',
			h5Url: 'http://testing-h5.cloudcare.cn:8086/',
			litews: 'ws://120.27.135.41:9527/api',
			csosws: 'ws://testing-csos.cloudcare.cn/api',
			agentInstallUrl: 'https://preprod-csos.cloudcare.cn/api/linkitScript/install.sh',
			backAgentUrl: 'https://preprod-csos.cloudcare.cn/api/linkitScript',
			databaseReportUrl: 'http://testing-enterprise-report.cloudcare.cn'
		},
		pre: {
			csosHost: 'preprod-csos.cloudcare.cn',
			apiUrl: 'https://preprod-csos.cloudcare.cn/api',
			homeApiUrl: 'https://preprod-home.cloudcare.cn/api',
			ccLogout: 'https://preprod-home.prof.wang/issue/list',
			csosTool: 'https://preprod-csos.cloudcare.cn/',
			h5Url: 'https://preprod-h5.cloudcare.cn/',
			litews: 'wss://preprod-preprod-csos-lite.cloudcare.cn/api',
			csosws: 'wss://preprod-csos.cloudcare.cn/api',
			agentInstallUrl: 'https://preprod-csos.cloudcare.cn/api/linkitScript/install.sh',
			backAgentUrl: 'https://preprod-csos.cloudcare.cn/api/linkitScript',
			databaseReportUrl: 'http://preprod-enterprise-report.cloudcare.cn'
		},
		alpha: {
			csosHost: 'csos.prof.wang',
			apiUrl: 'https://csos.cloudcare.cn/api',
			homeApiUrl: 'https://home.prof.wang/api',
			ccLogout: 'https://home.prof.wang/issue/list',
			csosTool: 'https://csos.prof.wang/',
			h5Url: 'https://h5.prof.wang/',
			litews: 'wss://preprod-csos-alpha-lite.cloudcare.cn/api',
			csosws: 'wss://preprod-csos-alpha.cloudcare.cn/api',
			agentInstallUrl: 'https://preprod-csos.cloudcare.cn/api/linkitScript/install.sh',
			backAgentUrl: 'https://preprod-csos.cloudcare.cn/api/linkitScript',
			databaseReportUrl: 'https://enterprise-report.cloudcare.cn'
		},
		poc: {
			csosHost: 'csos.prof.wang',
			apiUrl: 'https://csos.prof.wang/api',
			homeApiUrl: 'https://home.prof.wang/api',
			ccLogout: 'https://home.prof.wang/issue/list',
			csosTool: 'https://csos.prof.wang/',
			h5Url: 'https://h5.prof.wang/',
			litews: 'wss://csos-lite.prof.wang/api',
			csosws: 'wss://csos.prof.wang/api',
			agentInstallUrl: 'https://preprod-csos.cloudcare.cn/api/linkitScript/install.sh',
			backAgentUrl: 'https://preprod-csos.cloudcare.cn/api/linkitScript',
			databaseReportUrl: 'https://enterprise-report.cloudcare.cn'
		},
		local: {
			csosHost: 'csos-local.cloudcare.cn',
			apiUrl: 'https://csos-local.cloudcare.cn/api',
			homeApiUrl: 'https://preprod-home.cloudcare.cn/api',
			ccLogout: 'https://preprod-home.prof.wang/issue/list',
			csosTool: 'https://csos-local.cloudcare.cn/',
			h5Url: 'https://preprod-h5.cloudcare.cn/',
			litews: 'wss://csos-local-lite.cloudcare.cn/api',
			csosws: 'wss://csos-local.cloudcare.cn/api',
			agentInstallUrl: 'https://preprod-csos.cloudcare.cn/api/linkitScript/install.sh',
			backAgentUrl: 'https://preprod-csos.cloudcare.cn/api/linkitScript',
			databaseReportUrl: 'https://preprod-enterprise-report.cloudcare.cn'
		},
		production: {
			csosHost: 'csos.cloudcare.cn',
			apiUrl: 'https://csos.cloudcare.cn/api',
			homeApiUrl: 'https://home.cloudcare.cn/api',
			ccLogout: 'https://home.prof.wang/issue/list',
			csosTool: 'https://csos.cloudcare.cn/',
			h5Url: 'https://h5.cloudcare.cn/',
			litews: 'wss://csos-lite.cloudcare.cn/api',
			csosws: 'wss://csos.cloudcare.cn/api',
			agentInstallUrl: 'https://csos.cloudcare.cn/api/linkitScript/install.sh',
			backAgentUrl: 'https://csos.cloudcare.cn/api/linkitScript',
			databaseReportUrl: 'https://enterprise-report.cloudcare.cn'
		}
	}
};

var baseUrl = Utils.config["production"];
var enableHome = Utils.config.enableHome;

function deepCopy(obj) {
	var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

	if (obj === null || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(obj)) !== 'object') {
		return obj;
	}

	var hit = find(cache, function (c) {
		return c.original === obj;
	});
	if (hit) {
		return hit.copy;
	}
	var copy = Array.isArray(obj) ? [] : {};

	cache.push({
		original: obj,
		copy: copy
	});
	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
		copy[key] = deepCopy(obj[key], cache);
	});
	return copy;
}
var Base64 = {
	_keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

	encode: function encode(input) {
		var output = '';
		var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
		var i = 0;

		input = Base64._utf8_encode(input);

		while (i < input.length) {
			chr1 = input.charCodeAt(i++);
			chr2 = input.charCodeAt(i++);
			chr3 = input.charCodeAt(i++);

			enc1 = chr1 >> 2;
			enc2 = (chr1 & 3) << 4 | chr2 >> 4;
			enc3 = (chr2 & 15) << 2 | chr3 >> 6;
			enc4 = chr3 & 63;

			if (isNaN(chr2)) {
				enc3 = enc4 = 64;
			} else if (isNaN(chr3)) {
				enc4 = 64;
			}

			output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
		}

		return output;
	},

	_utf8_encode: function _utf8_encode(string) {
		string = string.replace(/\r\n/g, '\n');
		var utftext = '';

		for (var n = 0; n < string.length; n++) {
			var c = string.charCodeAt(n);

			if (c < 128) {
				utftext += String.fromCharCode(c);
			} else if (c > 127 && c < 2048) {
				utftext += String.fromCharCode(c >> 6 | 192);
				utftext += String.fromCharCode(c & 63 | 128);
			} else {
				utftext += String.fromCharCode(c >> 12 | 224);
				utftext += String.fromCharCode(c >> 6 & 63 | 128);
				utftext += String.fromCharCode(c & 63 | 128);
			}
		}
		return utftext;
	}
};
window.rootVue = window.rootVue ? window.rootVue : {
	$gettext: function $gettext(t) {
		return t;
	}
};
var SelectOptionsConfig = {
	teamLogs: {
		event: {
			addUser: {
				code: 'addUser',
				text: window.rootVue.$gettext('AddUser')
			},
			deleteUser: {
				code: 'deleteUser',
				text: window.rootVue.$gettext('DeleteUser')
			},
			createGroup: {
				code: 'createGroup',
				text: window.rootVue.$gettext('CreateGroup')
			},
			deleteGroup: {
				code: 'deleteGroup',
				text: window.rootVue.$gettext('DeleteGroup')
			},
			changePassword: {
				code: 'changePassword',
				text: window.rootVue.$gettext('ChangePassword')
			},
			addGroupMember: {
				code: 'addGroupMember',
				text: window.rootVue.$gettext('AddGroupMember')
			},
			deleteGroupMember: {
				code: 'deleteGroupMember',
				text: window.rootVue.$gettext('DeleteGroupMember')
			}
		},
		role: [{
			text: window.rootVue.$gettext('Administrator'),
			val: 'account'
		}, {
			text: window.rootVue.$gettext('Account Edited'),
			val: 'user'
		}]
	},
	clusterLogs: {
		event: {
			createNet: {
				code: 'createNet',
				text: window.rootVue.$gettext('CreateCluster')
			},
			deleteNet: {
				code: 'deleteNet',
				text: window.rootVue.$gettext('DeleteCluster')
			},
			addLinuxServer: {
				code: 'addLinuxServer',
				text: window.rootVue.$gettext('AddLinuxServer')
			},
			deleteLinuxServer: {
				code: 'deleteLinuxServer',
				text: window.rootVue.$gettext('DeleteLinuxServer')
			},
			addWinServer: {
				code: 'addWinServer',
				text: window.rootVue.$gettext('AddWinServer')
			},
			deleteWinServer: {
				code: 'deleteWinServer',
				text: window.rootVue.$gettext('DeleteWinServer')
			},
			addMySQLDatabase: {
				code: 'addMySQLDatabase',
				text: window.rootVue.$gettext('AddMySQLDatabase')
			},
			deleteMySQLDatabase: {
				code: 'deleteMySQLDatabase',
				text: window.rootVue.$gettext('DeleteMySQLDatabase')
			},
			deleteOracleDatabase: {
				code: 'deleteOracleDatabase',
				text: window.rootVue.$gettext('DeleteOracleDatabase')
			},
			addSQLServerDatabase: {
				code: 'addSQLServerDatabase',
				text: window.rootVue.$gettext('AddSQLServerDatabase')
			},
			deleteSQLServerDatabase: {
				code: 'deleteSQLServerDatabase',
				text: window.rootVue.$gettext('DeleteSQLServerDatabase')
			},
			shareNet: {
				code: 'shareNet',
				text: window.rootVue.$gettext('ShareCluster')
			},
			closeSafeMode: {
				code: 'closeSafeMode',
				text: window.rootVue.$gettext('CloseSecurityMode')
			},
			openSafeMode: {
				code: 'openSafeMode',
				text: window.rootVue.$gettext('OpenSecurityMode')
			},
			auditSafeMode: {
				code: 'auditSafeMode',
				text: window.rootVue.$gettext('AuditSecurityMode')
			},
			unauditSafeMode: {
				code: 'unauditSafeMode',
				text: window.rootVue.$gettext('UnauditSecurityMode')
			},
			addInterceptInstruction: {
				code: 'addInterceptInstruction',
				text: window.rootVue.$gettext('AddInterceptInstruction')
			},
			removeInterceptInstruction: {
				code: 'removeInterceptInstruction',
				text: window.rootVue.$gettext('RemoveInterceptInstruction')
			},
			modifySafeModeAuditor: {
				code: 'modifySafeModeAuditor',
				text: window.rootVue.$gettext('ModifySecurityModeAuditor')
			},
			modifySafeModeNotice: {
				code: 'modifySafeModeNotice',
				text: window.rootVue.$gettext('ModifySafeModeNotice')
			},
			addPostgreSQLDatabase: {
				code: 'addPostgreSQLDatabase',
				text: window.rootVue.$gettext('AddPostgreSQLDatabase')
			},
			addOracleDatabase: {
				code: 'addOracleDatabase',
				text: window.rootVue.$gettext('AddOracleDatabase')
			},
			addNoticeInstruction: {
				code: 'addNoticeInstruction',
				text: window.rootVue.$gettext('AddNoticeInstruction')
			},
			noticeSafeMode: {
				code: 'noticeSafeMode',
				text: window.rootVue.$gettext('NoticeSecurityMode')
			}
		},
		role: [{
			text: window.rootVue.$gettext('Account'),
			val: 'account'
		}, {
			text: window.rootVue.$gettext('Resource Name'),
			val: 'resource_name'
		}, {
			text: window.rootVue.$gettext('Cluster Name'),
			val: 'net_name'
		}, {
			text: window.rootVue.$gettext('Team Name'),
			val: 'shared_company_name'
		}]
	},
	resourceLogs: {
		event: {
			addProjectAccount: {
				code: 'addProjectAccount',
				text: window.rootVue.$gettext('AddWorkgroupAccount')
			},
			deleteProjectAccount: {
				code: 'deleteProjectAccount',
				text: window.rootVue.$gettext('DeleteWorkgroupAccount')
			},
			addProjectAdmin: {
				code: 'addProjectAdmin',
				text: window.rootVue.$gettext('AddWorkgroupAdmin')
			},
			deleteProjectAdmin: {
				code: 'deleteProjectAdmin',
				text: window.rootVue.$gettext('DeleteWorkgroupAdmin')
			},
			addProjectGroup: {
				code: 'addProjectGroup',
				text: window.rootVue.$gettext('AddWorkgroupGroup')
			},
			deleteProjectGroup: {
				code: 'deleteProjectGroup',
				text: window.rootVue.$gettext('DeleteWorkgroupGroup')
			},
			deleteProject: {
				code: 'deleteProject',
				text: window.rootVue.$gettext('DeleteWorkgroup')
			},
			createProject: {
				code: 'createProject',
				text: window.rootVue.$gettext('CreateWorkgroup')
			},
			addLinuxServerToProject: {
				code: 'addLinuxServerToProject',
				text: window.rootVue.$gettext('AddLinuxServerToWorkgroup')
			},
			removeLinuxServerFromProject: {
				code: 'removeLinuxServerFromProject',
				text: window.rootVue.$gettext('RemoveLinuxServerFromWorkgroup')
			},
			removeWinServerFromProject: {
				code: 'removeWinServerFromProject',
				text: window.rootVue.$gettext('RemoveWinServerFromWorkgroup')
			},
			addWinServerToProject: {
				code: 'addWinServerToProject',
				text: window.rootVue.$gettext('AddWinServerToWorkgroup')
			},
			addMySQLDatabaseToProject: {
				code: 'addMySQLDatabaseToProject',
				text: window.rootVue.$gettext('AddMySQLDatabaseToWorkgroup')
			},
			removeMySQLDatabaseFromProject: {
				code: 'removeMySQLDatabaseFromProject',
				text: window.rootVue.$gettext('RemoveMySQLDatabaseFromWorkgroup')
			},
			addOracleDatabaseToProject: {
				code: 'addOracleDatabaseToProject',
				text: window.rootVue.$gettext('AddOracleDatabaseToWorkgroup')
			},
			removeOracleDatabaseFromProject: {
				code: 'removeOracleDatabaseFromProject',
				text: window.rootVue.$gettext('RemoveOracleDatabaseFromWorkgroup')
			},
			addSQLServerDatabaseToProject: {
				code: 'addSQLServerDatabaseToProject',
				text: window.rootVue.$gettext('AddSQLServerDatabaseToWorkgroup')
			},
			removeSQLServerDatabaseFromProject: {
				code: 'removeSQLServerDatabaseFromProject',
				text: window.rootVue.$gettext('RemoveSQLServerDatabaseFromWorkgroup')
			}
		},
		role: [{
			text: window.rootVue.$gettext('Account'),
			val: 'account'
		}, {
			text: window.rootVue.$gettext('Workgroup Name'),
			val: 'project_name'
		}, {
			text: window.rootVue.$gettext('Resource Name'),
			val: 'resource_name'
		}, {
			text: window.rootVue.$gettext('Account Edited'),
			val: 'project_account'
		}]
	},
	alarmLogs: {
		event: (_event = {
			addProjectAccount: {
				code: 'addProjectAccount',
				text: window.rootVue.$gettext('AddWorkgroupAccount')
			},
			deleteProjectAccount: {
				code: 'deleteProjectAccount',
				text: window.rootVue.$gettext('DeleteWorkgroupAccount')
			},
			addProjectAdmin: {
				code: 'addProjectAdmin',
				text: window.rootVue.$gettext('AddWorkgroupAdmin')
			},
			deleteProjectAdmin: {
				code: 'deleteProjectAdmin',
				text: window.rootVue.$gettext('DeleteWorkgroupAdmin')
			},
			addProjectGroup: {
				code: 'addProjectGroup',
				text: window.rootVue.$gettext('AddWorkgroupGroup')
			},
			deleteProjectGroup: {
				code: 'deleteProjectGroup',
				text: window.rootVue.$gettext('DeleteWorkgroupGroup')
			},
			deleteProject: {
				code: 'deleteProject',
				text: window.rootVue.$gettext('DeleteWorkgroup')
			},
			createProject: {
				code: 'createProject',
				text: window.rootVue.$gettext('CreateWorkgroup')
			},
			addLinuxServerToProject: {
				code: 'addLinuxServerToProject',
				text: window.rootVue.$gettext('AddLinuxServerToWorkgroup')
			},
			removeLinuxServerFromProject: {
				code: 'removeLinuxServerFromProject',
				text: window.rootVue.$gettext('RemoveLinuxServerFromWorkgroup')
			},
			removeWinServerFromProject: {
				code: 'removeWinServerFromProject',
				text: window.rootVue.$gettext('RemoveWinServerFromWorkgroup')
			},
			addWinServerToProject: {
				code: 'addWinServerToProject',
				text: window.rootVue.$gettext('AddWinServerToWorkgroup')
			},
			addMySQLDatabaseToProject: {
				code: 'addMySQLDatabaseToProject',
				text: window.rootVue.$gettext('AddMySQLDatabaseToWorkgroup')
			},
			removeMySQLDatabaseFromProject: {
				code: 'removeMySQLDatabaseFromProject',
				text: window.rootVue.$gettext('RemoveMySQLDatabaseFromWorkgroup')
			},
			addOracleDatabaseToProject: {
				code: 'addOracleDatabaseToProject',
				text: window.rootVue.$gettext('AddOracleDatabaseToWorkgroup')
			},
			removeOracleDatabaseFromProject: {
				code: 'removeOracleDatabaseFromProject',
				text: window.rootVue.$gettext('RemoveOracleDatabaseFromWorkgroup')
			},
			addSQLServerDatabaseToProject: {
				code: 'addSQLServerDatabaseToProject',
				text: window.rootVue.$gettext('AddSQLServerDatabaseToWorkgroup')
			},
			removeSQLServerDatabaseFromProject: {
				code: 'removeSQLServerDatabaseFromProject',
				text: window.rootVue.$gettext('RemoveSQLServerDatabaseFromWorkgroup')
			},
			createNet: {
				code: 'createNet',
				text: window.rootVue.$gettext('CreateCluster')
			},
			deleteNet: {
				code: 'deleteNet',
				text: window.rootVue.$gettext('DeleteCluster')
			},
			addLinuxServer: {
				code: 'addLinuxServer',
				text: window.rootVue.$gettext('AddLinuxServer')
			},
			deleteLinuxServer: {
				code: 'deleteLinuxServer',
				text: window.rootVue.$gettext('DeleteLinuxServer')
			},
			addWinServer: {
				code: 'addWinServer',
				text: window.rootVue.$gettext('AddWinServer')
			},
			deleteWinServer: {
				code: 'deleteWinServer',
				text: window.rootVue.$gettext('DeleteWinServer')
			},
			addMySQLDatabase: {
				code: 'addMySQLDatabase',
				text: window.rootVue.$gettext('AddMySQLDatabase')
			},
			deleteMySQLDatabase: {
				code: 'deleteMySQLDatabase',
				text: window.rootVue.$gettext('DeleteMySQLDatabase')
			},
			deleteOracleDatabase: {
				code: 'deleteOracleDatabase',
				text: window.rootVue.$gettext('DeleteOracleDatabase')
			},
			addSQLServerDatabase: {
				code: 'addSQLServerDatabase',
				text: window.rootVue.$gettext('AddSQLServerDatabase')
			},
			deleteSQLServerDatabase: {
				code: 'deleteSQLServerDatabase',
				text: window.rootVue.$gettext('DeleteSQLServerDatabase')
			},
			shareNet: {
				code: 'shareNet',
				text: window.rootVue.$gettext('ShareCluster')
			},
			closeSafeMode: {
				code: 'closeSafeMode',
				text: window.rootVue.$gettext('CloseSecurityMode')
			},
			openSafeMode: {
				code: 'openSafeMode',
				text: window.rootVue.$gettext('OpenSecurityMode')
			},
			auditSafeMode: {
				code: 'auditSafeMode',
				text: window.rootVue.$gettext('AuditSecurityMode')
			},
			unauditSafeMode: {
				code: 'unauditSafeMode',
				text: window.rootVue.$gettext('UnauditSecurityMode')
			},
			addInterceptInstruction: {
				code: 'addInterceptInstruction',
				text: window.rootVue.$gettext('AddInterceptInstruction')
			},
			removeInterceptInstruction: {
				code: 'removeInterceptInstruction',
				text: window.rootVue.$gettext('RemoveInterceptInstruction')
			},
			modifySafeModeAuditor: {
				code: 'modifySafeModeAuditor',
				text: window.rootVue.$gettext('ModifySecurityModeAuditor')
			}
		}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'addProjectAccount', {
			code: 'addProjectAccount',
			text: window.rootVue.$gettext('AddWorkgroupAccount')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'deleteProjectAccount', {
			code: 'deleteProjectAccount',
			text: window.rootVue.$gettext('DeleteWorkgroupAccount')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'addProjectAdmin', {
			code: 'addProjectAdmin',
			text: window.rootVue.$gettext('AddWorkgroupAdmin')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'deleteProjectAdmin', {
			code: 'deleteProjectAdmin',
			text: window.rootVue.$gettext('DeleteWorkgroupAdmin')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'addProjectGroup', {
			code: 'addProjectGroup',
			text: window.rootVue.$gettext('AddWorkgroupGroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'deleteProjectGroup', {
			code: 'deleteProjectGroup',
			text: window.rootVue.$gettext('DeleteWorkgroupGroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'deleteProject', {
			code: 'deleteProject',
			text: window.rootVue.$gettext('DeleteWorkgroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'createProject', {
			code: 'createProject',
			text: window.rootVue.$gettext('CreateWorkgroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'addLinuxServerToProject', {
			code: 'addLinuxServerToProject',
			text: window.rootVue.$gettext('AddLinuxServerToWorkgroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'removeLinuxServerFromProject', {
			code: 'removeLinuxServerFromProject',
			text: window.rootVue.$gettext('RemoveLinuxServerFromWorkgroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'removeWinServerFromProject', {
			code: 'removeWinServerFromProject',
			text: window.rootVue.$gettext('RemoveWinServerFromWorkgroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'addWinServerToProject', {
			code: 'addWinServerToProject',
			text: window.rootVue.$gettext('AddWinServerToWorkgroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'addMySQLDatabaseToProject', {
			code: 'addMySQLDatabaseToProject',
			text: window.rootVue.$gettext('AddMySQLDatabaseToWorkgroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'removeMySQLDatabaseFromProject', {
			code: 'removeMySQLDatabaseFromProject',
			text: window.rootVue.$gettext('RemoveMySQLDatabaseFromWorkgroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'addOracleDatabaseToProject', {
			code: 'addOracleDatabaseToProject',
			text: window.rootVue.$gettext('AddOracleDatabaseToWorkgroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'removeOracleDatabaseFromProject', {
			code: 'removeOracleDatabaseFromProject',
			text: window.rootVue.$gettext('RemoveOracleDatabaseFromWorkgroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'addSQLServerDatabaseToProject', {
			code: 'addSQLServerDatabaseToProject',
			text: window.rootVue.$gettext('AddSQLServerDatabaseToWorkgroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'removeSQLServerDatabaseFromProject', {
			code: 'removeSQLServerDatabaseFromProject',
			text: window.rootVue.$gettext('RemoveSQLServerDatabaseFromWorkgroup')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'modifySafeModeNotice', {
			code: 'modifySafeModeNotice',
			text: window.rootVue.$gettext('ModifySafeModeNotice')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'addPostgreSQLDatabase', {
			code: 'addPostgreSQLDatabase',
			text: window.rootVue.$gettext('AddPostgreSQLDatabase')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'addOracleDatabase', {
			code: 'addOracleDatabase',
			text: window.rootVue.$gettext('AddOracleDatabase')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'addNoticeInstruction', {
			code: 'addNoticeInstruction',
			text: window.rootVue.$gettext('AddNoticeInstruction')
		}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_event, 'noticeSafeMode', {
			code: 'noticeSafeMode',
			text: window.rootVue.$gettext('NoticeSecurityMode')
		}), _event),
		role: [{
			text: window.rootVue.$gettext('Users'),
			val: 'account_name'
		}, {
			text: window.rootVue.$gettext('Source IP'),
			val: 'source_ip'
		}, {
			text: window.rootVue.$gettext('Notice Accounts'),
			val: 'notice_accounts'
		}, {
			text: window.rootVue.$gettext('Operation Obj'),
			val: 'resource_name'
		}, {
			text: window.rootVue.$gettext('Event Desc'),
			val: 'command'
		}]
	}
};

var ClusterRegionConfig = [{
	localName: window.rootVue.$gettext('China East 1(Hangzhou)'),
	regionId: 'cn-hangzhou'
}, {
	localName: window.rootVue.$gettext('China East 2(Shanghai)'),
	regionId: 'cn-shanghai'
}, {
	localName: window.rootVue.$gettext('China South 1(Shenzhen)'),
	regionId: 'cn-shenzhen'
}, {
	localName: window.rootVue.$gettext('China North 1(Qingdao)'),
	regionId: 'cn-qingdao'
}, {
	localName: window.rootVue.$gettext('China North 2(Beijing)'),
	regionId: 'cn-beijing'
}, {
	localName: window.rootVue.$gettext('Hong Kong'),
	regionId: 'cn-hongkong'
}, {
	localName: window.rootVue.$gettext('Asia Pacific SE 1(Singapore)'),
	regionId: 'ap-southeast-1'
}, {
	localName: window.rootVue.$gettext('US East 1(Virginia)'),
	regionId: 'us-east-1'
}, {
	localName: window.rootVue.$gettext('US West 1(Silicon Valley)'),
	regionId: 'us-west-1'
}];

var ClusterAliyunSupport = [{
	os: 'CentOS',
	version: '7.0 64bit',
	comment: ''
}, {
	os: 'CentOS',
	version: '6.5 64bit',
	comment: ''
}, {
	os: 'Debian',
	version: '7.5.0 64bit',
	comment: window.rootVue.$gettext('Curl must be installed')
}, {
	os: 'Debian',
	version: '6.0.9 64bit',
	comment: window.rootVue.$gettext('Curl must be installed')
}, {
	os: 'ubuntu',
	version: '14.04 64bit',
	comment: window.rootVue.$gettext('Curl must be installed')
}, {
	os: 'ubuntu',
	version: '12.04 64bit',
	comment: window.rootVue.$gettext('Curl must be installed')
}];

var PasswordStrengthMessage = {
	0: '',
	1: window.rootVue.$gettext('The password strength requirement is: the password length is lowest 6 bits , must contain two of uppercase letters, lowercase letters, and special characters.'),
	2: window.rootVue.$gettext('The password strength requirement is: the password length is lowest 8 bits, must contain uppercase letter, lowercase letter, special character.')
};

var PasswordStrengthRegExp = {
	uppercasePattern: /[A-Z]/,
	lowercasePattern: /[a-z]/,
	sysbolPattern: /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\\]/
};

var PasswordStrengthRegExpCallback = {
	level1_msg: window.rootVue.$gettext('The password must be at least 6 characters long and must contain two uppercase letters, lowercase letters, and special characters.'),
	level2_msg: window.rootVue.$gettext('The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters.')
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(401)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(593),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto_js__);




var Utils = function () {
	var _getAgentVersion = function _getAgentVersion(version) {
		if (version) {
			var firstVersionNum = version.split('-')[0];
			return firstVersionNum;
		}
	};
	var _getBackAgentVersion = function _getBackAgentVersion(version) {
		if (version) {
			var firstVersionNum = version.split('-')[0];
			var secondVersionNum = version.split('-')[1];
			if (secondVersionNum) {
				return firstVersionNum + '-' + secondVersionNum;
			} else {
				return firstVersionNum;
			}
		}
	};

	var _isNeedUpdate = function _isNeedUpdate(oldVersion, newVersion) {
		if (oldVersion && newVersion) {
			var oldV = oldVersion.split('-')[0];
			var newV = newVersion.split('-')[0];
			var oldArr = oldV.split('.');
			var newArr = newV.split('.');
			return oldArr.some(function (i, index) {
				return parseInt(i) < parseInt(newArr[index]);
			});
		}
	};

	var _hideStr = function _hideStr(str) {
		if (!str) return;
		var lg = str.length;
		if (lg && lg > 0) {
			if (lg == 1) {
				return '*';
			} else if (lg > 1 && lg <= 3) {
				return plusXing(str, 0, 1);
			} else if (lg > 3 && lg <= 5) {
				return plusXing(str, 1, 2);
			} else if (lg > 5 && lg <= 8) {
				return plusXing(str, 2, 2);
			} else {
				return plusXing(str, 4, 2);
			}
		} else {
			return '-';
		}
	};
	var plusXing = function plusXing(str, frontLen, endLen) {
		var len = str.length - frontLen - endLen;
		var xing = '';
		for (var i = 0; i < len; i++) {
			xing += '*';
		}
		return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
	};

	var _isOnMobile = function _isOnMobile() {
		var sUserAgent = navigator.userAgent.toLowerCase();
		var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os';
		var bIsMidp = sUserAgent.match(/midp/i) == 'midp';
		var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4';
		var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb';
		var bIsAndroid = sUserAgent.match(/android/i) == 'android';
		var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce';
		var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile';
		if (bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
			return true;
		}
		return false;
	};

	var dataConvert = function dataConvert(string) {
		var d = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.MD5(__WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8.parse(string)).toString().substring(8, 24);
		return d;
	};
	var _encryptAesCbc = function _encryptAesCbc(string, key, iv) {
		var keyWA = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8.parse(dataConvert(key));
		var ivWA = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8.parse(dataConvert(iv));
		var dataWA = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8.parse(string);

		var encrypted = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.AES.encrypt(dataWA, keyWA, {
			iv: ivWA,
			mode: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.mode.CBC,
			padding: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.pad.Pkcs7
		});

		return encrypted.toString();
	};

	var _filterAnsiEscapeCodes = function _filterAnsiEscapeCodes(str) {
		if (!str) return '暂无日志内容';

		var ansiRegex = /\x1B(?:[@-Z\\-_]|\[[0-?]*[ -/]*[@-~])/g;

		var controlCharsRegex = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g;

		return str.replace(ansiRegex, '').replace(controlCharsRegex, '').replace(/\r\n/g, '\n').trimStart();
	};

	var _getUrlParams = function _getUrlParams() {
		var params = {};

		var searchStr = window.location.search;
		if (!searchStr && window.location.hash) {
			var hash = window.location.hash;
			var hashSearchIndex = hash.indexOf('?');
			if (hashSearchIndex > -1) {
				searchStr = hash.substring(hashSearchIndex);
			}
		}

		if (searchStr) {
			var search = searchStr.substring(1);

			search.split('&').forEach(function (item) {
				var _item$split = item.split('='),
				    _item$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_item$split, 2),
				    key = _item$split2[0],
				    value = _item$split2[1];

				if (key && value) {
					params[key] = decodeURIComponent(value);
				}
			});
		}
		return params;
	};

	var utils = {
		getAgentVersion: function getAgentVersion(version) {
			return _getAgentVersion(version);
		},
		getBackAgentVersion: function getBackAgentVersion(version) {
			return _getBackAgentVersion(version);
		},
		isNeedUpdate: function isNeedUpdate(oldVersion, newVersion) {
			return _isNeedUpdate(oldVersion, newVersion);
		},
		isOnMobile: function isOnMobile() {
			return _isOnMobile();
		},
		hideStr: function hideStr(str) {
			return _hideStr(str);
		},
		encryptAesCbc: function encryptAesCbc(string, key, iv) {
			return _encryptAesCbc(string, key, iv);
		},
		filterAnsiEscapeCodes: function filterAnsiEscapeCodes(str) {
			return _filterAnsiEscapeCodes(str);
		},
		getUrlParams: function getUrlParams() {
			return _getUrlParams();
		}
	};
	return utils;
}();
/* harmony default export */ __webpack_exports__["a"] = ({
	Utils: Utils
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo4.ef1405f.png";

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.0ed64c3.gif";

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = axiosAjax;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errormsg__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(192);







function axiosAjax(url, method, options, noAlert) {
  var defaultOptions = {
    url: url,
    method: method || 'GET',
    withCredentials: true,
    timeout: 60000,
    baseURL: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* baseUrl */].apiUrl
  };
  if (options) {
    defaultOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultOptions, options);
  }
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default()(defaultOptions).then(function (res) {
      var data = res.data;
      if (data.code === "NeedLogin") {
        __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push("/login");
      } else {
        resolve(res);
      }
    }).catch(function (err) {
      var codeArr = ['NeedLogin', 'FileEmptyError', 'FileTypeError', 'FileDataError', 'FileResourceExist', 'ResourceExist', 'ResourceExceeded'];
      var havaCode = false;
      codeArr.forEach(function (item) {
        if (err.response.data.code === item) {
          havaCode = true;
        }
      });
      if (noAlert || noAlert && err.response.data.code === 'NeedPrivilege') {} else {
        if (havaCode) {} else {
          var data = err.response.data;
          __WEBPACK_IMPORTED_MODULE_4__errormsg__["a" /* default */].showErrorMsg(data.code || data.Code, data.error_message, 'error');
        }
      }

      reject(err.response);
    });
  });
}

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
	loginSSO: function loginSSO(params, notAlert) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/auth/pw_sso/' + params.token, 'post', {}, !!notAlert);
	},
	loginCFSSO: function loginCFSSO(params, notAlert) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/auth/cf_sso/' + params.token, 'post', {}, !!notAlert);
	},
	login: function login(params) {
		console.log('post data:', params);
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/auth/login', 'post', params);
	},
	register: function register(params) {
		console.log('post data:', params);
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/auth/register', 'post', { data: params });
	},
	logout: function logout() {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/auth/logout', 'post', {});
	},
	resetPassword: function resetPassword(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/auth/reset_passwd', 'post', { data: params });
	},
	compelChangePassword: function compelChangePassword(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/current_account/change_password', 'post', { data: params });
	},
	getCurrent: function getCurrent() {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/current_account');
	},
	getSuchAccount: function getSuchAccount(id) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/account/' + id);
	},
	updateAccount: function updateAccount(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/current_account', 'patch', params);
	},
	changeAvatar: function changeAvatar(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/file', 'post', { data: params });
	},
	getMfaSecret: function getMfaSecret() {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/mfa/secret');
	},
	postMfaCode: function postMfaCode(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/account/mfa', 'post', params);
	},
	verifyMfa: function verifyMfa(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/auth/mfa', 'post', { data: params });
	},
	getCode: function getCode() {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/current_account/send_verify_sms', 'post', {});
	},
	verifiCode: function verifiCode(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/current_account/verify_mobile', 'post', params);
	},
	forgotPassword: function forgotPassword(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/auth/reset_passwd_mail', 'post', { data: params });
	},
	showCaptcha: function showCaptcha(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/auth/show_captcha', 'get', { params: params });
	},
	notifyBanner: function notifyBanner(params) {
		if (__WEBPACK_IMPORTED_MODULE_2__config__["b" /* enableHome */]) {
			return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/v2/utils/notification_banner/csos', 'get', params, true);
		} else {
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {});
		}
	},
	checkSSO: function checkSSO(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/auth/is_open_sso/' + params.domain, 'get');
	}
});

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);






var Polling = function () {
	function Polling() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Polling);

		this.config = {
			interval: 5000,
			maxRetry: 3,
			requestFn: null,
			requestFnParams: null,
			onSuccess: null,
			onError: null,
			onComplete: null
		};

		__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.config, options);

		this.timer = null;
		this.isPolling = false;
		this.isPaused = false;
		this.errorRetryCount = 0;
	}

	__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Polling, [{
		key: 'start',
		value: function start() {
			var _this = this;

			var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (this.isPolling) return;

			this.isPolling = true;
			this.isPaused = false;
			this.errorRetryCount = 0;

			if (immediate) {
				this._executeRequest();
			} else {
				this.timer = setTimeout(function () {
					_this._executeRequest();
				}, this.config.interval);
			}
		}
	}, {
		key: 'pause',
		value: function pause() {
			if (!this.isPolling || this.isPaused) return;

			this.isPaused = true;
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
		}
	}, {
		key: 'resume',
		value: function resume() {
			if (!this.isPolling || !this.isPaused) return;

			this.isPaused = false;
			this._executeRequest();
		}
	}, {
		key: 'stop',
		value: function stop() {
			this.isPolling = false;
			this.isPaused = false;
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}

			this.config.onComplete();
		}
	}, {
		key: '_executeRequest',
		value: function () {
			var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var _this2 = this;

				var result, retryInterval;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!(!this.isPolling || this.isPaused)) {
									_context.next = 2;
									break;
								}

								return _context.abrupt('return');

							case 2:
								_context.prev = 2;
								_context.next = 5;
								return this.config.requestFn(this.config.requestFnParams);

							case 5:
								result = _context.sent;

								this.errorRetryCount = 0;

								this.config.onSuccess(result);

								this.timer = setTimeout(function () {
									_this2._executeRequest();
								}, this.config.interval);
								_context.next = 16;
								break;

							case 11:
								_context.prev = 11;
								_context.t0 = _context['catch'](2);

								this.config.onError(_context.t0);

								this.errorRetryCount++;
								if (this.errorRetryCount <= this.config.maxRetry) {
									retryInterval = this.config.interval * this.errorRetryCount;

									this.timer = setTimeout(function () {
										_this2._executeRequest();
									}, retryInterval);
								} else {
									this.stop();
									console.error('轮询请求失败次数达到上限，已停止轮询');
								}

							case 16:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this, [[2, 11]]);
			}));

			function _executeRequest() {
				return _ref.apply(this, arguments);
			}

			return _executeRequest;
		}()
	}]);

	return Polling;
}();

/* harmony default export */ __webpack_exports__["a"] = (Polling);

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(566),
  /* scopeId */
  "data-v-5495d4f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(363)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(554),
  /* scopeId */
  "data-v-3e2eddb1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(394)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(586),
  /* scopeId */
  "data-v-6b94d521",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(423)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(615),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(417)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(609),
  /* scopeId */
  "data-v-b62b0bcc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(413)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(605),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(416)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(608),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_operations_dashboard__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_operations_dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_operations_dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_operations_workgroup__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_operations_workgroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_operations_workgroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_operations_workgroup_detail__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_operations_workgroup_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_operations_workgroup_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_console__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_console___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_console__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_login__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_compelChangePassword__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_compelChangePassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_compelChangePassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_register__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_forgot_password__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_forgot_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_forgot_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_reset_password__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_reset_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_reset_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mfaComfirm__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mfaComfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_mfaComfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_mfaOpen__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_mfaOpen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_mfaOpen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_purchase__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_purchase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_purchase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_privacy_policy__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_privacy_policy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_privacy_policy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_user_agreement__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_user_agreement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_user_agreement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_operations_document__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_operations_document___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_operations_document__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_operations_logs__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_operations_logs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_operations_logs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_operations_review__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_operations_review___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_operations_review__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_settings_workgroup__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_settings_workgroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_settings_workgroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_settings_workgroup_detail__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_settings_workgroup_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_settings_workgroup_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_settings_cluster__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_settings_cluster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_settings_cluster__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_settings_cluster_detail__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_settings_cluster_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_settings_cluster_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_settings_team__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_settings_team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_settings_team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_settings_team_group_detail__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_settings_team_group_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_settings_team_group_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_settings_team_account_workgroup__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_settings_team_account_workgroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_settings_team_account_workgroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_settings_team_group_workgroup__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_settings_team_group_workgroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_settings_team_group_workgroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_system_statistics__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_system_statistics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_system_statistics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_system_system_log__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_system_system_log___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_system_system_log__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_system_alarm_notify__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_system_alarm_notify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_system_alarm_notify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_personal_account_info__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_personal_account_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_personal_account_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_personal_account_security__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_personal_account_security___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_personal_account_security__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_personal_sshKey__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_personal_sshKey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_personal_sshKey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_overviewExportPdf_vue__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_overviewExportPdf_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_overviewExportPdf_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_excel_log_view_vue__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_excel_log_view_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_excel_log_view_vue__);











































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/',
		name: 'console',
		component: __WEBPACK_IMPORTED_MODULE_5__components_console___default.a,
		children: [{
			path: '',
			redirect: '/operation/dashboard'
		}, {
			path: '/dashboard',
			redirect: '/operation/dashboard'
		}, {
			path: '/operation',
			name: 'operation',
			component: {
				render: function render(c) {
					return c('router-view');
				}
			},
			children: [{
				path: 'dashboard',
				name: 'dashboard',
				component: __WEBPACK_IMPORTED_MODULE_2__components_operations_dashboard___default.a,
				meta: {
					requireLogin: true
				}
			}, {
				path: 'workgroup',
				name: 'workgroup',
				component: __WEBPACK_IMPORTED_MODULE_3__components_operations_workgroup___default.a
			}, {
				path: 'workgroup/:id',
				name: 'workgroupdetail',
				component: __WEBPACK_IMPORTED_MODULE_4__components_operations_workgroup_detail___default.a
			}, {
				path: 'document',
				name: 'document',
				component: __WEBPACK_IMPORTED_MODULE_16__components_operations_document___default.a
			}, {
				path: 'log',
				name: 'logs',
				component: __WEBPACK_IMPORTED_MODULE_17__components_operations_logs___default.a
			}, {
				path: 'review',
				name: 'operation.review',
				component: __WEBPACK_IMPORTED_MODULE_18__components_operations_review___default.a
			}]
		}, {
			path: '/settings',
			name: 'settings',
			component: {
				render: function render(c) {
					return c('router-view');
				}
			},
			children: [{
				path: 'team',
				name: 'team',
				component: __WEBPACK_IMPORTED_MODULE_23__components_settings_team___default.a
			}, {
				path: 'cluster',
				name: 'cluster',
				component: __WEBPACK_IMPORTED_MODULE_21__components_settings_cluster___default.a
			}, {
				path: 'cluster/:id',
				name: 'clusterDetail',
				component: __WEBPACK_IMPORTED_MODULE_22__components_settings_cluster_detail___default.a
			}, {
				path: 'workgroup',
				name: 'settingWorkgroup',
				component: __WEBPACK_IMPORTED_MODULE_19__components_settings_workgroup___default.a
			}, {
				path: 'workgroup/:id',
				name: 'settingWorkgroupDetail',
				component: __WEBPACK_IMPORTED_MODULE_20__components_settings_workgroup_detail___default.a
			}, {
				path: 'group/:id',
				name: 'settingTeamGroupDetail',
				component: __WEBPACK_IMPORTED_MODULE_24__components_settings_team_group_detail___default.a
			}, {
				path: 'account/:id',
				name: 'settingTeamAccountWorkgroup',
				component: __WEBPACK_IMPORTED_MODULE_25__components_settings_team_account_workgroup___default.a
			}, {
				path: 'groupWork/:id',
				name: 'settingTeamGroupWorkgroup',
				component: __WEBPACK_IMPORTED_MODULE_26__components_settings_team_group_workgroup___default.a
			}]
		}, {
			path: '/system',
			name: 'system',
			component: {
				render: function render(c) {
					return c('router-view');
				}
			},
			children: [{
				path: 'statistics',
				name: 'statistics',
				component: __WEBPACK_IMPORTED_MODULE_27__components_system_statistics___default.a
			}, {
				path: 'log',
				name: 'log',
				component: __WEBPACK_IMPORTED_MODULE_28__components_system_system_log___default.a
			}, {
				path: 'alarmNotify',
				name: 'alarmNotify',
				component: __WEBPACK_IMPORTED_MODULE_29__components_system_alarm_notify___default.a
			}]
		}, {
			path: '/personal',
			name: 'personal',
			component: {
				render: function render(c) {
					return c('router-view');
				}
			},
			children: [{
				path: 'info',
				name: 'accountInfo',
				component: __WEBPACK_IMPORTED_MODULE_30__components_personal_account_info___default.a
			}, {
				path: 'security',
				name: 'accountSecurity',
				component: __WEBPACK_IMPORTED_MODULE_31__components_personal_account_security___default.a
			}, {
				path: 'sshkey',
				name: 'sshKey',
				component: __WEBPACK_IMPORTED_MODULE_32__components_personal_sshKey___default.a
			}]
		}]
	}, {
		path: '/login',
		name: 'login',
		component: __WEBPACK_IMPORTED_MODULE_6__components_login___default.a
	}, {
		path: '/compelChangePassword',
		name: 'compelChangePassword',
		component: __WEBPACK_IMPORTED_MODULE_7__components_compelChangePassword___default.a
	}, {
		path: '/register',
		name: 'register',
		component: __WEBPACK_IMPORTED_MODULE_8__components_register___default.a
	}, {
		path: '/forgetPsw',
		name: 'forgetPsw',
		component: __WEBPACK_IMPORTED_MODULE_9__components_forgot_password___default.a
	}, {
		path: '/mfaComfirm',
		name: 'mfaComfirm',
		component: __WEBPACK_IMPORTED_MODULE_11__components_mfaComfirm___default.a
	}, {
		path: '/mfaOpen',
		name: 'mfaOpen',
		component: __WEBPACK_IMPORTED_MODULE_12__components_mfaOpen___default.a
	}, {
		path: '/resetpassword',
		name: 'resetpassword',
		component: __WEBPACK_IMPORTED_MODULE_10__components_reset_password___default.a
	}, {
		path: '/purchase',
		name: 'purchase',
		component: __WEBPACK_IMPORTED_MODULE_13__components_purchase___default.a
	}, {
		path: '/privacy-policy',
		name: 'privacyPolicy',
		component: __WEBPACK_IMPORTED_MODULE_14__components_privacy_policy___default.a
	}, {
		path: '/user-agreement',
		name: 'userAgreement',
		component: __WEBPACK_IMPORTED_MODULE_15__components_user_agreement___default.a
	}, {
		path: '/exportOverview',
		name: 'exportOverview',
		component: __WEBPACK_IMPORTED_MODULE_33__components_overviewExportPdf_vue___default.a
	}, {
		path: '/excelLogView',
		name: 'excelLogView',
		component: __WEBPACK_IMPORTED_MODULE_34__components_excel_log_view_vue___default.a
	}]
});
router.beforeEach(function (to, from, next) {
	next();
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElButton',

  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElForm',

  componentName: 'ElForm',

  props: {
    model: Object,
    rules: Object,
    labelPosition: String,
    labelWidth: String,
    labelSuffix: {
      type: String,
      default: ''
    },
    inline: Boolean,
    showMessage: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    rules: function rules() {
      this.validate();
    }
  },
  data: function data() {
    return {
      fields: []
    };
  },
  created: function created() {
    var _this = this;

    this.$on('el.form.addField', function (field) {
      if (field) {
        _this.fields.push(field);
      }
    });

    this.$on('el.form.removeField', function (field) {
      if (field.prop) {
        _this.fields.splice(_this.fields.indexOf(field), 1);
      }
    });
  },

  methods: {
    resetFields: function resetFields() {
      if (!this.model) {
        "production" !== 'production' && console.warn('[Element Warn][Form]model is required for resetFields to work.');
        return;
      }
      this.fields.forEach(function (field) {
        field.resetField();
      });
    },
    validate: function validate(callback) {
      var _this2 = this;

      var valid = true;
      var count = 0;

      if (this.fields.length === 0 && callback) {
        callback(true);
      }
      this.fields.forEach(function (field, index) {
        field.validate('', function (errors) {
          if (errors) {
            valid = false;
          }
          if (typeof callback === 'function' && ++count === _this2.fields.length) {
            callback(valid);
          }
        });
      });
    },
    validateField: function validateField(prop, cb) {
      var field = this.fields.filter(function (field) {
        return field.prop === prop;
      })[0];
      if (!field) {
        throw new Error('must call validateField with valid prop string!');
      }

      field.validate('', cb);
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_src_mixins_emitter__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calcTextareaHeight__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_src_utils_merge__ = __webpack_require__(675);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElInput',

  componentName: 'ElInput',

  mixins: [__WEBPACK_IMPORTED_MODULE_0_element_ui_src_mixins_emitter__["a" /* default */]],

  data: function data() {
    return {
      currentValue: this.value,
      textareaCalcStyle: {}
    };
  },


  props: {
    value: [String, Number],
    placeholder: String,
    size: String,
    resize: String,
    readonly: Boolean,
    autofocus: Boolean,
    icon: String,
    disabled: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    name: String,
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    rows: {
      type: Number,
      default: 2
    },
    autoComplete: {
      type: String,
      default: 'off'
    },
    form: String,
    maxlength: Number,
    minlength: Number,
    max: {},
    min: {},
    step: {},
    validateEvent: {
      type: Boolean,
      default: true
    },
    onIconClick: Function
  },

  computed: {
    validating: function validating() {
      return this.$parent.validateState === 'validating';
    },
    textareaStyle: function textareaStyle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui_src_utils_merge__["a" /* default */])({}, this.textareaCalcStyle, { resize: this.resize });
    }
  },

  watch: {
    'value': function value(val, oldValue) {
      this.setCurrentValue(val);
    }
  },

  methods: {
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.blur', [this.currentValue]);
      }
    },
    inputSelect: function inputSelect() {
      this.$refs.input.select();
    },
    resizeTextarea: function resizeTextarea() {
      if (this.$isServer) return;
      var autosize = this.autosize,
          type = this.type;

      if (!autosize || type !== 'textarea') return;
      var minRows = autosize.minRows;
      var maxRows = autosize.maxRows;

      this.textareaCalcStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__calcTextareaHeight__["a" /* default */])(this.$refs.textarea, minRows, maxRows);
    },
    handleFocus: function handleFocus(event) {
      this.$emit('focus', event);
    },
    handleInput: function handleInput(event) {
      var value = event.target.value;
      this.$emit('input', value);
      this.setCurrentValue(value);
      this.$emit('change', value);
    },
    handleIconClick: function handleIconClick(event) {
      if (this.onIconClick) {
        this.onIconClick(event);
      }
      this.$emit('click', event);
    },
    setCurrentValue: function setCurrentValue(value) {
      var _this = this;

      if (value === this.currentValue) return;
      this.$nextTick(function (_) {
        _this.resizeTextarea();
      });
      this.currentValue = value;
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [value]);
      }
    }
  },

  created: function created() {
    this.$on('inputSelect', this.inputSelect);
  },
  mounted: function mounted() {
    this.resizeTextarea();
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_account__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	data: function data() {
		return {
			showCsos: false,
			showMessage: '',
			message: '',
			isOnMobile: true
		};
	},
	created: function created() {
		var _this = this;

		console.log('Utility.Utils.isOnMobile()', __WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.isOnMobile());
		this.isOnMobile = __WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.isOnMobile();
		var homeParams = {
			token: this.getUrlParams('cc_sso_token'),
			cf_token: this.getUrlParams('cf_sso_token')
		};
		if (homeParams.token) {
			console.log('has home params!!!');
			__WEBPACK_IMPORTED_MODULE_1__api_account__["a" /* default */].loginSSO({
				token: homeParams.token
			}, true).then(function (res) {
				if (res.data) {
					if (window.location.href.indexOf('ipad.html') >= 0) {
						_this.showCsos = true;
						_this.isPc = false;
					} else if (window.location.href.indexOf('mobile.html') >= 0) {
						_this.showCsos = true;
						_this.isPc = false;
					} else {
						window.location.href = '/console.html';
						_this.isPc = true;
					}
				}
			}, function () {
				console.log('ssologin error:');
				window.top.location.href = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* baseUrl */].ccLogout;
			});
		} else if (homeParams.cf_token) {
			__WEBPACK_IMPORTED_MODULE_1__api_account__["a" /* default */].loginCFSSO({ token: homeParams.cf_token }, true).then(function (res) {
				if (res.data) {
					if (window.location.href.indexOf('ipad.html') >= 0) {
						_this.showCsos = true;
						_this.isPc = false;
					} else if (window.location.href.indexOf('mobile.html') >= 0) {
						_this.showCsos = true;
						_this.isPc = false;
					} else {
						window.location.href = '/console.html';
						_this.isPc = true;
					}
				}
			}, function () {
				window.top.location.href = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* baseUrl */].ccLogout;
			});
		} else {
			console.log('not has home params!!!');
			this.showCsos = true;
		}
	},

	methods: {
		closeDevops: function closeDevops() {
			this.showMessage = false;
			var obj = {
				text: this.message.text,
				id: this.message.id
			};
			localStorage.setItem('CSOS-DEOPSALERT__KEY', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
		},
		getUrlParams: function getUrlParams(_key) {
			var reg = new RegExp('(^|&)' + _key + '=([^&]*)(&|$)', 'i');
			var r = window.location.search.substr(1).match(reg);
			if (r != null) {
				return unescape(r[2]);
			}
			return null;
		},
		checkShowNotify: function checkShowNotify(message) {
			if (localStorage.getItem('CSOS-DEOPSALERT__KEY')) {
				var obj = JSON.parse(localStorage.getItem('CSOS-DEOPSALERT__KEY'));
				if (obj.text && obj.text === message.text && obj.id === message.id) {
					this.showMessage = false;
				} else {
					this.showMessage = true;
				}
			} else {
				this.showMessage = true;
			}
		},
		getNotify: function getNotify() {
			var _this2 = this;

			var params = {
				baseURL: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* baseUrl */].homeApiUrl
			};
			console.log('this', this.$store);
			__WEBPACK_IMPORTED_MODULE_1__api_account__["a" /* default */].notifyBanner(params).then(function (res) {
				if (res && res.data && res.data.data) {
					_this2.message = res.data.data;
					_this2.checkShowNotify(_this2.message);
				}
			});
		}
	}
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Echarts',
	props: {
		type: {
			type: String,
			required: true,
			validator: function validator(val) {
				return ['line', 'pie', 'bar'].includes(val);
			}
		},

		options: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		width: {
			type: String,
			default: '100%'
		},

		height: {
			type: String,
			default: '400px'
		},

		autoResize: {
			type: Boolean,
			default: true
		}
	},
	data: function data() {
		return {
			chartInstance: null };
	},

	watch: {
		options: {
			deep: true,
			handler: function handler() {
				this.updateChart();
			}
		},
		type: function type() {
			this.initChart();
		}
	},
	mounted: function mounted() {
		this.initChart();

		if (this.autoResize) {
			window.addEventListener('resize', this.handleResize);
		}
	},
	beforeDestroy: function beforeDestroy() {
		if (this.chartInstance) {
			this.chartInstance.dispose();
			this.chartInstance = null;
		}
		if (this.autoResize) {
			window.removeEventListener('resize', this.handleResize);
		}
	},

	methods: {
		initChart: function initChart() {
			if (!this.$refs.chartRef) return;

			this.chartInstance = __WEBPACK_IMPORTED_MODULE_2_echarts__["init"](this.$refs.chartRef);

			var finalOptions = this.mergeDefaultOptions();

			this.chartInstance.setOption(finalOptions);
		},
		mergeDefaultOptions: function mergeDefaultOptions() {
			var baseOptions = {
				tooltip: {
					trigger: 'axis',
					textStyle: { fontSize: 12 }
				},
				legend: {
					top: 'top',
					textStyle: { fontSize: 12 }
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				}
			};

			var typeDefaultOptions = {
				line: {
					xAxis: {
						type: 'category',
						boundaryGap: false
					},
					yAxis: {
						type: 'value'
					},
					series: []
				},

				pie: {
					tooltip: {
						trigger: 'item'
					},
					series: [{
						type: 'pie',
						radius: ['40%', '70%'],
						center: ['50%', '50%'],
						label: {
							show: true,
							formatter: '{b}: {c} ({d}%)' }
					}]
				},

				bar: {
					xAxis: {
						type: 'category'
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						type: 'bar',
						itemStyle: {
							borderRadius: [4, 4, 0, 0] }
					}]
				}
			};

			var baseCompleteOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, baseOptions, typeDefaultOptions[this.type]);

			var finalSeries = [];
			var defaultSeries = baseCompleteOptions.series || [];
			var incomingSeries = this.options.series || [];

			var seriesLength = Math.max(defaultSeries.length, incomingSeries.length);

			for (var index = 0; index < seriesLength; index++) {
				var defaultItem = defaultSeries[index] || { type: this.type };
				var incomingItem = incomingSeries[index] || {};

				var mergedSeriesItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultItem, incomingItem);

				mergedSeriesItem.type = defaultItem.type;
				finalSeries.push(mergedSeriesItem);
			}

			var _options = this.options,
			    _ = _options.series,
			    incomingOptionsWithoutSeries = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_options, ['series']);

			var finalOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, baseCompleteOptions, incomingOptionsWithoutSeries, {
				series: finalSeries
			});

			return finalOptions;
		},
		updateChart: function updateChart() {
			if (!this.chartInstance) return;
			var finalOptions = this.mergeDefaultOptions();

			this.chartInstance.setOption(finalOptions, false);
		},
		handleResize: function handleResize() {
			if (this.chartInstance) {
				this.chartInstance.resize();
			}
		}
	}
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nvd3__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nvd3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nvd3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    options: {
      type: Object,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      default: {
        options: {},
        xAxis: {
          axisLabel: '',

          domain: null,
          fontSize: '12px',
          duration: '500',

          rotateLabels: 0,

          showMaxMin: false,
          ticks: null,
          tickValues: null
        },
        yAxis: {
          axisLabel: '',

          domain: null,
          fontSize: '12px',

          rotateYLabel: 0,

          showMaxMin: false,
          tickFormat: function tickFormat(d) {
            return __WEBPACK_IMPORTED_MODULE_1_d3___default.a.format(',.2f')(d);
          },
          ticks: null,
          tickValues: null
        }
      },
      chart: null
    };
  },
  mounted: function mounted() {
    this.setChartOptions();
  },

  methods: {
    setChartOptions: function setChartOptions() {
      var _this = this;

      var xAxis = Object.clone(this.options['chart']['xAxis']);
      var yAxis = Object.clone(this.options['chart']['yAxis']);
      var tooltip = Object.clone(this.options['chart']['tooltip']);
      var options = Object.clone(this.options['chart']);
      delete options.xAxis;
      delete options.yAxis;
      delete options.tooltip;
      var chartOptions = {
        options: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.default.options, options),
        tooltip: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.default.tooltip, tooltip),
        xAxis: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.default.xAxis, xAxis),
        yAxis: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.default.yAxis, yAxis)
      };

      var chart = __WEBPACK_IMPORTED_MODULE_2_nvd3___default.a.models.multiBarHorizontalChart().options(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        duration: 300
      }, chartOptions.options));
      chart.height(chartOptions.options.height);
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$refs.chart).height(chartOptions.options.height);

      Object.forEach(chartOptions.tooltip, function (val, key) {
        if (val) {
          chart.tooltip[key].call(_this, val);
        }
      });
      Object.forEach(chartOptions.xAxis, function (val, key) {
        if (val) {
          chart.xAxis[key].call(_this, val);
        }
      });
      Object.forEach(chartOptions.yAxis, function (val, key) {
        if (val) {
          chart.yAxis[key].call(_this, val);
        }
      });

      this.drawChart(chart, chartOptions.options.height);
      this.chart = chart;
      return chart;
    },
    drawChart: function drawChart(chart) {
      __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(this.$refs.chart).datum(this.data).transition().duration(500).call(chart);
      __WEBPACK_IMPORTED_MODULE_2_nvd3___default.a.utils.windowResize(chart.update);
    }
  },
  watch: {
    data: {
      handler: function handler() {
        if (this.chart) {
          this.drawChart(this.chart);
        }
      }
    },
    options: {
      handler: function handler(newVal) {
        if (this.chart) {
          this.setChartOptions();
          this.drawChart(this.chart);
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nvd3__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nvd3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nvd3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    options: {
      type: Object,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      default: {
        options: {},
        xAxis: {
          axisLabel: '',

          domain: null,
          fontSize: '12px',
          duration: '500',

          rotateLabels: 0,

          showMaxMin: false,
          staggerLabels: false,
          tickFormat: function tickFormat(d) {
            return __WEBPACK_IMPORTED_MODULE_1_d3___default.a.format(',.1f');
          },
          ticks: null,
          tickValues: null
        },
        yAxis: {
          axisLabel: '',

          domain: null,
          fontSize: '12px',

          rotateYLabel: 0,

          showMaxMin: false,
          staggerLabels: false,
          tickFormat: function tickFormat(d) {
            return __WEBPACK_IMPORTED_MODULE_1_d3___default.a.format(',.2f')(d);
          },
          ticks: null,
          tickValues: null
        }
      },
      chart: null
    };
  },
  mounted: function mounted() {
    this.setChartOptions();
  },

  methods: {
    setChartOptions: function setChartOptions() {
      var _this = this;

      var xAxis = Object.clone(this.options['chart']['xAxis']);
      var yAxis = Object.clone(this.options['chart']['yAxis']);
      var options = Object.clone(this.options['chart']);
      delete options.xAxis;
      delete options.yAxis;
      var chartOptions = {
        options: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.default.options, options),
        xAxis: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.default.xAxis, xAxis),
        yAxis: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.default.yAxis, yAxis)
      };

      __WEBPACK_IMPORTED_MODULE_2_nvd3___default.a.addGraph(function () {
        var chart = __WEBPACK_IMPORTED_MODULE_2_nvd3___default.a.models.lineChart().options(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
          duration: 300,
          useInteractiveGuideline: true
        }, chartOptions.options));

        __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$refs.chart).height(chartOptions.options.height);

        Object.forEach(chartOptions.xAxis, function (val, key) {
          if (val) {
            chart.xAxis[key].call(_this, val);
          }
        });
        Object.forEach(chartOptions.yAxis, function (val, key) {
          if (val) {
            chart.yAxis[key].call(_this, val);
          }
        });

        _this.drawChart(chart, chartOptions.options.height);
        _this.chart = chart;
        return chart;
      });
    },
    drawChart: function drawChart(chart) {
      __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(this.$refs.chart).datum(this.data).transition().duration(500).call(chart);
      __WEBPACK_IMPORTED_MODULE_2_nvd3___default.a.utils.windowResize(chart.update);
    }
  },
  watch: {
    data: {
      handler: function handler() {
        if (this.chart) {
          this.drawChart(this.chart);
        }
      }
    },
    options: {
      handler: function handler(newVal) {
        if (this.chart) {
          this.setChartOptions();
          this.drawChart(this.chart);
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nvd3__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nvd3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nvd3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    options: {
      type: Object,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      default: {
        options: {
          showLegend: true,
          donut: false,
          x: function x(d) {
            return d.x;
          },
          y: function y(d) {
            return d.y;
          },
          showTooltipPercent: false,
          labelsOutside: false
        }
      },
      chart: null
    };
  },
  mounted: function mounted() {
    this.setChartOptions();
  },

  methods: {
    setChartOptions: function setChartOptions() {
      var _this = this;

      var options = {},
          xAxis = {},
          yAxis = {};
      if (this.options && this.options['chart']) {
        options = Object.clone(this.options['chart']);
        delete options.xAxis;
        delete options.yAxis;
        if (this.options['chart'] && this.options['chart']['xAxis']) {
          xAxis = Object.clone(this.options['chart']['xAxis']);
        }
        if (this.options['chart'] && this.options['chart']['yAxis']) {
          yAxis = Object.clone(this.options['chart']['yAxis']);
        }
      }
      var chartOptions = {
        options: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.default.options, options),
        xAxis: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.default.xAxis, xAxis),
        yAxis: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.default.yAxis, yAxis)
      };

      __WEBPACK_IMPORTED_MODULE_2_nvd3___default.a.addGraph(function () {
        var chart = __WEBPACK_IMPORTED_MODULE_2_nvd3___default.a.models.pieChart().options(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
          duration: 300
        }, chartOptions.options));

        __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$refs.chart).height(chartOptions.options.height || 300);

        if (chartOptions.xAxis) {
          Object.forEach(chartOptions.xAxis, function (val, key) {
            if (val) {
              chart.xAxis[key].call(_this, val);
            }
          });
        }
        if (chartOptions.yAxis) {
          Object.forEach(chartOptions.yAxis, function (val, key) {
            if (val) {
              chart.yAxis[key].call(_this, val);
            }
          });
        }

        _this.drawChart(chart);
        _this.chart = chart;
        return chart;
      });
    },
    drawChart: function drawChart(chart) {
      __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(this.$refs.chart).datum(this.data).transition().call(chart);
      __WEBPACK_IMPORTED_MODULE_2_nvd3___default.a.utils.windowResize(chart.update);
    }
  },
  watch: {
    data: {
      handler: function handler() {
        if (this.chart) {
          this.drawChart(this.chart);
        }
      }
    },
    options: {
      handler: function handler(newVal) {
        if (this.chart) {
          this.setChartOptions();
          this.drawChart(this.chart);
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RightPanel',
  props: {
    items: {
      type: Object,
      required: false
    },
    hideFooter: {
      type: Boolean,
      required: false
    },
    datas: {
      required: false
    }
  },
  data: function data() {
    var formData = this.initFormData();
    return {
      isShow: false,
      submiting: false,
      rules: formData.rules,
      profileModel: formData.profileModel,
      formItems: formData.formItems
    };
  },

  computed: {},
  mounted: function mounted() {
    if (this.datas) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  },

  methods: {
    initFormData: function initFormData() {
      var rules = {},
          profileModel = {},
          formItems = {};
      if (!!this.items) {
        Object.forEach(this.items, function (val, key) {
          if (val.label) {
            val.labelWidth = '130px';
          }
          formItems[key] = val;
          if (!val.childs) {
            val.key = key;
            formItems[key].childs = [val];
          }
          formItems[key].childs.forEach(function (child, index) {
            if (child.key) {
              profileModel[child.key] = child.val;
              if (child.rule) {
                rules[child.key] = child.rule;
                delete child.rule;
              }
            }
          });
        });
      }
      return {
        rules: rules,
        profileModel: profileModel,
        formItems: formItems
      };
    },
    validate: function validate() {
      var that = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        that.$refs['profileForm'].validate(function (valid) {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    onSubmit: function onSubmit(formName) {
      var _this = this;

      this.validate().then(function () {
        _this.submiting = true;
        _this.$emit('onSubmit', formName);
      }, function () {});
    },
    onSubmitErr: function onSubmitErr() {
      this.submiting = false;
    },
    onClose: function onClose() {
      var _this2 = this;

      this.isShow = false;
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').unbind('click');
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.el-dialog__wrapper').unbind('click');

      window.setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').css('overflow-y', 'auto');
        _this2.$emit('onClose');
      }, 300);
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onShow: function onShow() {
      var _this3 = this;

      this.isShow = true;

      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').bind('click', function () {
        _this3.onClose();
      });

      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.el-dialog__wrapper').click(function (event) {
        event.stopPropagation();
      });
    }
  },
  watch: {
    'datas': {
      handler: function handler() {
        console.log('watch datas:', this.datas);
        if (this.datas) {
          this.onShow();
        } else {
          this.isShow = false;
        }
      },

      deep: true
    },
    'items': {
      handler: function handler() {
        var formData = this.initFormData();
        this.rules = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.rules, formData.rules);
        this.profileModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.profileModel, formData.profileModel);
        this.formItems = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.formItems, formData.formItems);
      },

      deep: true
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'compelChangePassword',
	data: function data() {
		var _this = this;

		var pass = function pass(rule, value, callback) {
			var level = _this.company_password_strength;
			var uppercasePattern = __WEBPACK_IMPORTED_MODULE_1__config__["c" /* PasswordStrengthRegExp */].uppercasePattern;
			var lowercasePattern = __WEBPACK_IMPORTED_MODULE_1__config__["c" /* PasswordStrengthRegExp */].lowercasePattern;
			var sysbolPattern = __WEBPACK_IMPORTED_MODULE_1__config__["c" /* PasswordStrengthRegExp */].sysbolPattern;
			var uppercaseRes = uppercasePattern.test(value);
			var lowercaseRes = lowercasePattern.test(value);
			var sysbolRes = sysbolPattern.test(value);
			if (value.length) {
				if (level === 1) {
					if (value.length >= 6 && (lowercaseRes && uppercaseRes || lowercaseRes && sysbolRes || uppercaseRes && sysbolRes)) {
						callback();
					} else {
						_this.show_password_warning = false;
						callback(new Error(_this.$gettext(__WEBPACK_IMPORTED_MODULE_1__config__["d" /* PasswordStrengthRegExpCallback */].level1_msg)));
					}
				} else if (level === 2) {
					if (value.length >= 8 && lowercaseRes && uppercaseRes && sysbolRes) {
						callback();
					} else {
						_this.show_password_warning = false;
						callback(new Error(_this.$gettext(__WEBPACK_IMPORTED_MODULE_1__config__["d" /* PasswordStrengthRegExpCallback */].level2_msg)));
					}
				} else {
					callback();
				}
			} else {
				callback(new Error(_this.$gettext('Please enter your password!')));
			}
			if (_this.formData.checkPass !== '') {
				_this.$refs.passForm.validateField('checkPass');
			}
		};
		var checkPass = function checkPass(rule, value, callback) {
			if (value === '') {
				callback(new Error(_this.$gettext('Please enter your password again!')));
			} else if (value !== _this.formData.pass) {
				callback(new Error(_this.$gettext('Two passwords are not consistent!')));
			} else {
				callback();
			}
		};
		return {
			loading: false,
			formData: {
				pass: '',
				checkPass: ''
			},
			rules: {
				pass: [{ validator: pass, trigger: 'change' }],
				checkPass: [{ validator: checkPass, trigger: 'change' }]
			},
			company_password_strength: this.$store.getters.team.setting.password_strength || 0,
			show_password_warning: this.$store.getters.team.setting.password_strength !== '0'
		};
	},


	methods: {
		onSubmitForm: function onSubmitForm(formName) {
			var _this2 = this;

			var params = {
				data: {
					pwd: this.formData.pass
				}
			};
			this.$refs[formName].validate(function (valid) {
				if (valid) {
					_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.COMPEL_CHANGE_PSWD, params).then(function (res) {
						console.log(res, 'res');
						_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.LOGOUT).then(function (res) {
							_this2.$router.push('/login');
							_this2.$notify({
								message: _this2.$gettext('Modify password successfully,Please Re Login'),
								type: 'success'
							});
						});
					});
				} else {
					return false;
				}
			});
		}
	}
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_left_nav__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_left_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_left_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Console',
	data: function data() {
		return {
			showRoute: false,
			open_text: '',
			remainingDays: '',
			packageInfo: ''
		};
	},
	created: function created() {
		var _this = this;

		this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.CURRENT).then(function (res) {
			_this.showRoute = true;
			_this.password_ok = res.password_strength ? res.password_strength.password_ok : undefined;
			_this.showPasswordModal(_this.password_ok, _this.$store.getters.team.setting.password_strength);
		}).catch(function (err) {
			if (_this.$route.name !== 'login') {
				console.log('login path--', err);
				_this.$notify({
					message: _this.$gettext(err.data.code),
					type: 'success'
				});
			} else {
				console.log('console', _this.$route.name);
			}
		});

		this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].DASHBOARD.GET_STATISTICS).then(function (res) {
			console.log(res, '套餐提醒');

			_this.packageInfo = res;

			if (!res.expire) {
				res.expire = 0;
			}
			if (res && res.current_plan) {
				var overflow_limit = res.accounts > res.current_plan.account_limit && res.current_plan.account_limit != 0 || res.networks > res.current_plan.network_limit && res.current_plan.network_limit != 0 || res.resources > res.current_plan.resource_limit && res.current_plan.resource_limit != 0;

				var currentPlan = {
					accountLimit: res.current_plan.account_limit == 0 ? '∞' : res.current_plan.account_limit,
					networkLimit: res.current_plan.network_limit == 0 ? '∞' : res.current_plan.network_limit,
					resourceLimit: res.current_plan.resource_limit == 0 ? '∞' : res.current_plan.resource_limit
				};

				_this.remainingDays = (res.expire - Date.now() / 1000) / 3600 / 24;
				var time = new Date(res.expire * 1000);
				var Y = time.getFullYear();
				var M = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
				var D = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();

				if (res.current_plan.name === '试用版') {
					if (overflow_limit) {
						_this.open_text = '\u60A8\u597D\uFF01\u60A8\u6240\u5C5E\u56E2\u961F\u7684 CloudLinker \u5957\u9910\u4E3A' + res.current_plan.name + '\uFF0C \u5F53\u524D\u5957\u9910\u914D\u989D\u60C5\u51B5\uFF1A\u96C6\u7FA4\u6570\u91CF\uFF1A ' + res.networks + ' / ' + currentPlan.networkLimit + '\uFF0C\u8D44\u6E90\u6570\u91CF: ' + res.resources + ' / ' + currentPlan.resourceLimit + '\uFF0C\u56E2\u961F\u6210\u5458\u6570: ' + res.accounts + ' / ' + currentPlan.accountLimit + '\uFF0C\u65E5\u5FD7\u53EF\u56DE\u653E\u5929\u6570' + res.current_plan.log_back_days + '\u3002\u5DF2\u8D85\u51FA' + res.current_plan.name + '\u5957\u9910\u914D\u989D\u9650\u5236\uFF0C\u4E3A\u907F\u514D\u5F71\u54CD\u4EA7\u54C1\u529F\u80FD\u4F7F\u7528\uFF0C\u8BF7\u53CA\u65F6\u8054\u7CFB\u5BA2\u670D\u5347\u7EA7\u5957\u9910\u3002';
					} else {
						_this.open_text = '\u60A8\u597D\uFF01\u60A8\u6240\u5C5E\u56E2\u961F\u7684 CloudLinker \u5957\u9910\u4E3A' + res.current_plan.name + '\uFF0C \u5F53\u524D\u5957\u9910\u914D\u989D\u60C5\u51B5\uFF1A\u96C6\u7FA4\u6570\u91CF\uFF1A ' + res.networks + ' / ' + currentPlan.networkLimit + '\uFF0C\u8D44\u6E90\u6570\u91CF: ' + res.resources + ' / ' + currentPlan.resourceLimit + '\uFF0C\u56E2\u961F\u6210\u5458\u6570: ' + res.accounts + ' / ' + currentPlan.accountLimit + '\uFF0C\u65E5\u5FD7\u53EF\u56DE\u653E\u5929\u6570' + res.current_plan.log_back_days + '\u3002\u4E3A\u907F\u514D\u5F71\u54CD\u4EA7\u54C1\u529F\u80FD\u4F7F\u7528\uFF0C\u5EFA\u8BAE\u53CA\u65F6\u8054\u7CFB\u5BA2\u670D\u5347\u7EA7\u5957\u9910\u3002';
					}
				} else {
					if (overflow_limit) {
						_this.open_text = '\u60A8\u597D\uFF01\u60A8\u6240\u5C5E\u56E2\u961F\u7684 CloudLinker \u5957\u9910\u4E3A' + res.current_plan.name + '\uFF0C \u5F53\u524D\u5957\u9910\u914D\u989D\u60C5\u51B5\uFF1A\u96C6\u7FA4\u6570\u91CF\uFF1A ' + res.networks + ' / ' + currentPlan.networkLimit + '\uFF0C\u8D44\u6E90\u6570\u91CF: ' + res.resources + ' / ' + currentPlan.resourceLimit + '\uFF0C\u56E2\u961F\u6210\u5458\u6570: ' + res.accounts + ' / ' + currentPlan.accountLimit + '\uFF0C\u65E5\u5FD7\u53EF\u56DE\u653E\u5929\u6570' + res.current_plan.log_back_days + '\u3002\u5DF2\u8D85\u51FA' + res.current_plan.name + '\u5957\u9910\u914D\u989D\u9650\u5236\uFF0C\u4E3A\u907F\u514D\u5F71\u54CD\u4EA7\u54C1\u529F\u80FD\u4F7F\u7528\uFF0C\u8BF7\u53CA\u65F6\u8054\u7CFB\u5BA2\u670D\u5347\u7EA7\u5957\u9910\u3002';
					}
				}
			}

			var hasComboModal = document.cookie.split(';').some(function (item) {
				return item.includes('comboModal=true');
			});
			if (_this.open_text && !hasComboModal) {
				setTimeout(function () {
					_this.open();
				}, 1000);
			}
		});
	},

	computed: {
		level: function level() {
			return this.$store.getters.team.setting.password_strength;
		}
	},
	watch: {
		level: function level(val) {
			if (val) {
				this.showPasswordModal(this.password_ok, val);
			}
		}
	},
	methods: {
		showPasswordModal: function showPasswordModal(passwordOk, companyPasswordStrength) {
			var _this2 = this;

			var currentHref = window.location.href.split('#')[1].indexOf('/personal/security') >= 0;
			console.log('--passwordOk--', passwordOk, '--companyPasswordStrength--', companyPasswordStrength);
			console.log('--currentHref--', currentHref);
			this.$nextTick(function () {
				if (passwordOk !== undefined && passwordOk === false && companyPasswordStrength && !currentHref) {
					var h = _this2.$createElement;
					_this2.$msgbox({
						title: _this2.$gettext('prompt'),
						center: true,
						showClose: false,
						showCancelButton: false,
						closeOnClickModal: false,
						confirmButtonText: _this2.$gettext('Change Password'),
						customClass: 'password_strength_modal',
						beforeClose: function beforeClose(action, instance, done) {
							console.log('--close-modal-');
							_this2.$router.push({
								path: '/personal/security',
								query: { changePwd: true }
							});
							done();
						},
						message: h('p', null, [h('p', { style: 'margin-bottom: 20px;' }, _this2.$gettext('Your current login password complexity does not meet the password strength requirements set by the team administrator. Please change the password before continuing to use.')), h('p', null, _this2.$gettext(__WEBPACK_IMPORTED_MODULE_3__config__["e" /* PasswordStrengthMessage */][companyPasswordStrength]))])
					});
				}
			});
		},
		open: function open() {
			var h = this.$createElement;
			this.$msgbox({
				title: '套餐提醒',
				closeOnClickModal: false,
				message: h('div', null, [h('p', null, [h('strong', { style: 'line-height:25px' }, this.open_text)]), h('p', { style: 'margin-top:20px;' }, [h('strong', { style: 'margin:0 40px' }, '咨询邮箱: support@jiagouyun.com'), h('strong', null, '热线电话: 021-50653160')])]),
				confirmButtonText: this.$gettext('No more reminders within 7 days'),

				beforeClose: function beforeClose(action, instance, done) {
					console.log('--close-modal-');
					var hasComboModal = document.cookie.split(';').some(function (item) {
						return item.includes('comboModal=true');
					});
					if (!hasComboModal) {
						var currentDate = new Date();

						var expirationDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000 * 7);
						document.cookie = 'comboModal=true; expires=' + expirationDate.toUTCString() + '; path=/';
					}
					done();
				}
			});
		}
	},
	components: {
		LeftNav: __WEBPACK_IMPORTED_MODULE_1__components_left_nav___default.a,
		AppHeader: __WEBPACK_IMPORTED_MODULE_2__components_header___default.a
	}
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_polling__ = __webpack_require__(108);










/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'purchase',
	data: function data() {
		return {
			loading: false,
			params: {},
			logContent: '',
			freezeShow: false,
			freezeShowRow: '',
			pollingTimer: null,
			pollingLoading: false,
			pollingCode: '' };
	},

	computed: {
		attrText: function attrText() {
			return this.getTransitionText();
		}
	},
	created: function created() {
		this.params = __WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.getUrlParams();

		this.getLog();
	},

	methods: {
		getTransitionText: function getTransitionText() {
			return {
				logContentView: this.$gettext('Viewing Of Log Content')
			};
		},
		copySuccess: function copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success'
			});
			e.clearSelection();
		},
		copyError: function copyError(e) {
			this.$notify({
				message: this.$gettext('Copy Failed!'),
				type: 'failed'
			});
		},
		closeDialog: function closeDialog() {
			this.freezeShow = false;
			clearTimeout(this.pollingTimer);
		},
		getLog: function getLog() {
			var _this = this;

			this.loading = true;
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.VIEW_LOG, {
				params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.params, { show: 1 })
			}).then(function (res) {
				if (res.code == 'OSSFileArchived') {
					_this.pollingCode = res.code;
					_this.freezeShow = true;
				} else if (res.code == 'OSSFileRestoring') {
					_this.pollingCode = res.code;
					_this.params.check = 1;
					_this.freezeShow = true;
					_this.pollingLoading = true;
					_this.pollingTimer = setTimeout(function () {
						_this.polling(params);
					}, 3000);
				} else {
					var cleanContent = __WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.filterAnsiEscapeCodes(res || '');
					_this.logContent = cleanContent || '暂无日志内容';
				}
				_this.loading = false;
			}).catch(function (err) {
				_this.$message.error('日志内容加载失败');
				_this.loading = false;
			});
		},
		polling: function polling(params) {
			var _this2 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.UNFREEZE, { params: params }).then(function (res) {
				console.log(res, 'res轮询');
				if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res).length) {
					if (res.code == 'OSSFileArchived') {
						_this2.pollingCode = res.code;

						_this2.freezeShow = true;
					} else if (res.code == 'OSSFileRestoring') {
						_this2.pollingCode = res.code;
						params.check = 1;
						_this2.freezeShow = true;
						_this2.pollingLoading = true;
						_this2.pollingTimer = setTimeout(function () {
							_this2.polling(params);
						}, 3000);
					}
				} else {
					_this2.pollingCode = 'OSSFileAvailable';
					_this2.pollingLoading = false;
					_this2.freezeShow = false;
					_this2.getLog(row);
				}
			});
		},
		handleFreezeConfirm: function handleFreezeConfirm() {
			this.polling(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.params, { check: 0 }));
		},
		downLoad: function downLoad() {
			var _this3 = this;

			var url = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].apiUrl + '/download_tunnel_log?' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.params).map(function (key) {
				return key + '=' + encodeURIComponent(_this3.params[key]);
			}).join('&');
			window.open(url, '_blank');
		}
	},
	components: {},
	destroyed: function destroyed() {
		clearTimeout(this.pollingTimer);
	}
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'forgetPsw',
  data: function data() {
    return {
      loading: false,
      forgetPswForm: {
        domain: '',
        account: '',
        captcha: ''
      },
      canSubmit: false,
      captchaSrc: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* baseUrl */].apiUrl + '/auth/captcha' + '?' + new Date().getTime(),
      rules: {
        domain: [{ required: true, trigger: 'blur' }],
        account: [{ required: true, trigger: 'blur' }, { type: 'email', trigger: 'change' }],
        captcha: [{ required: true, trigger: 'blur' }]
      }
    };
  },

  methods: {
    onKeyup: function onKeyup() {
      if (this.canSubmit) {
        this.resetPasswordMail();
      }
    },
    resetPasswordMail: function resetPasswordMail(m) {
      var _this = this;

      this.loading = true;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.FORGRTPASSWORD, this.forgetPswForm).then(function (res) {
        _this.loading = false;
        _this.$notify({
          message: _this.$gettext('Submitted successfully! Please click the link in the message to set the password. '),
          type: 'success'
        });
      }, function (err) {
        console.log(err);
        _this.loading = false;
        _this.refresh();
        _this.forgetPswForm.captcha = '';
      });
    },
    refresh: function refresh() {
      this.captchaSrc = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* baseUrl */].apiUrl + '/auth/captcha' + '?' + new Date().getTime();
    },
    resetFields: function resetFields() {
      this.$refs['forgetPswForm'].resetFields();
    }
  },
  watch: {
    'forgetPswForm': {
      handler: function handler(newVal, oldVal) {
        var that = this;
        if (this.$refs['forgetPswForm']) {
          this.$refs['forgetPswForm'].validate(function (valid) {
            that.canSubmit = valid;
          });
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_account__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_base64__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_js_base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_polling__ = __webpack_require__(108);
















window.jQuery = __WEBPACK_IMPORTED_MODULE_8_jquery___default.a;

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['packageInfo'],
	name: 'Header',
	data: function data() {
		return {
			connectList: [],
			workgroupIds: [],
			workgroupList: {},
			planTime: 0,
			batchDel: [],
			connectListDialogVisible: false,
			currentConnectPage: 1,
			loading: false,
			resourceWayMap: {
				terminal: 'Linux',
				rdp: 'Windows',
				mysql: 'MySQL',
				mssql: 'SQL server',
				wetty: 'Wetty',
				postgresql: 'PostgreSQL',
				oracle: 'Oracle'
			},
			isExpire: false,
			matured: false,
			alarmNotifyNotice: false,
			pollingInstance: null,
			isPolling: false,
			isPaused: false };
	},
	created: function created() {
		var _this = this;

		this.getOnlineConnectsCounts();
		this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].TEAM.CURRENT).then(function (res) {
			_this.planTime = res.current_plan;
		});

		this.initPolling();
	},

	computed: {
		currentConnectList: function currentConnectList() {
			console.log('currentConnectList', this.$store.getters.dashboard.onlineMembers);
			return this.$store.getters.dashboard.onlineMembers;
		},
		currentConnectCount: function currentConnectCount() {
			return this.$store.getters.dashboard.onlineMembersCount;
		},
		account: function account() {
			var currentAccount = this.$store.getters.account;
			return currentAccount;
		},
		attrText: function attrText() {
			return this.getText();
		},
		languageCurrent: function languageCurrent() {
			return this.$language.current;
		},
		memberExpireTime: function memberExpireTime() {
			var timestamp = this.packageInfo.expire;
			if (!timestamp) {
				return { text: '暂无', remainingDays: 0, isExpire: false, matured: false };
			}
			var remainingDays = (timestamp - Date.now() / 1000) / 3600 / 24;
			var isExpire = remainingDays > 0 && remainingDays <= 30;
			var matured = remainingDays <= 0;
			var text = __WEBPACK_IMPORTED_MODULE_11_moment___default()(timestamp * 1000).format('YYYY-MM-DD');
			return { text: text, remainingDays: remainingDays, isExpire: isExpire, matured: matured };
		}
	},
	methods: {
		getText: function getText() {
			return {
				unsafeMode: this.$gettext('Unsafe Mode'),
				member: this.$gettext('Member'),
				workgroup: this.$gettext('Workgroup'),
				resource: this.$gettext('Resource'),
				resourceIp: this.$gettext('Resource IP'),
				resourceWay: this.$gettext('Resource Way'),
				action: this.$gettext('Action'),
				noSession: this.$gettext('no online sessions'),
				onlineSessions: this.$gettext('Online Sessions'),
				updateTime: this.$gettext('Create Time')
			};
		},
		onLinkhref: function onLinkhref(url) {
			if (url) {
				window.open(url);
			}
		},
		createShadow: function createShadow(con) {
			var _this2 = this;

			var params = {
				master_connection_id: con.connection_id,
				readonly: false,
				expire_time: Math.floor(new Date().getTime() / 1000) + 30 * 60
			};
			var newWin = window.open('');
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_CSOS_SHADOW, params).then(function (res) {
				var shadowUrl = 'http://' + res.agent_host + ':' + res.agent_webtty_port + '/?code=' + __WEBPACK_IMPORTED_MODULE_10_js_base64___default.a.Base64.encode(res.code) + '&user=' + res.user + '&team_name=' + _this2.$store.getters.team.setting.full_name + '&account_name=' + _this2.$store.getters.account.name;
				newWin.location.href = shadowUrl;
			}, function () {
				newWin.close();
			});
		},
		onChangePage: function onChangePage(pageIndex) {
			this.currentConnectPage = pageIndex;
			this.getOnlineConnects(pageIndex);
		},
		selectMultiple: function selectMultiple(val) {
			this.batchDel = val.map(function (item) {
				return item.id;
			});
		},
		showConnectList: function showConnectList() {
			this.getOnlineConnects();
			this.connectListDialogVisible = true;
		},
		getOnlineConnectsCounts: function getOnlineConnectsCounts() {
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT_COUNTS).then(function (res) {});
		},
		getOnlineConnects: function getOnlineConnects(page) {
			var _this3 = this;

			this.currentConnectPage = page || 1;
			this.loading = true;
			var params = {
				page: page || 1
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT, params).then(function (res) {
				if (res && res.length) {
					var _connectList = Object.clone(res);
					_connectList.forEach(function (item, index) {
						var linkHref = '';
						if (item.guacamole && item.guacamole === 1) {
							linkHref = 'http://' + item.host + ':' + item.webrdp_port + '/?code=' + __WEBPACK_IMPORTED_MODULE_10_js_base64___default.a.Base64.encode(item.tunnel_code) + '&ip=' + item.resource_ip_address + '&resourceName=' + item.resource_name;
						} else {
							linkHref += 'playlog.html';
							linkHref += '?link=' + __WEBPACK_IMPORTED_MODULE_3__config__["a" /* baseUrl */].apiUrl;
							linkHref += '&way=' + item.way;
							linkHref += '&code=' + item.tunnel_code;
							linkHref += '&lang=' + _this3.languageCurrent;
							linkHref += '&type=monitor';
						}
						if (item.connection_id) {
							linkHref += '&connection_id=' + item.connection_id;
						}
						item.linkHref = linkHref;
						item.createTime = __WEBPACK_IMPORTED_MODULE_11_moment___default()(item.create_time * 1000).format('YYYY-MM-DD HH:mm');
						var showRdp = false;
						if (item.agent_version) {
							item.noResourceDisabled = false;
							if (__WEBPACK_IMPORTED_MODULE_9__Utils__["a" /* default */].Utils.getAgentVersion(item.agent_version) >= '2.4.2') {
								showRdp = true;
							}
							item.agentVersion = __WEBPACK_IMPORTED_MODULE_9__Utils__["a" /* default */].Utils.getAgentVersion(item.agent_version);
						}
						item.showRdp = showRdp;
					});
					_this3.connectList = _connectList;
					_this3.loading = false;
					console.log('connects------->+', _this3.connectList);
					_this3.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT, _this3.connectList);
				} else {
					_this3.loading = false;
				}
			});
		},
		cutOnline: function cutOnline(ids) {
			var _this4 = this;

			this.$confirm(this.$gettext('Are you sure to disconnect this connection?'), this.$gettext('Disconnect connection confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				_this4.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].DASHBOARD.CUT_ONLINE_MULTIPLE, { connection_ids: ids }).then(function () {
					var copy = Object.clone(_this4.$store.getters.dashboard.onlineMembers);
					var copyCount = Object.clone(_this4.$store.getters.dashboard.onlineMembersCount);
					ids.forEach(function (id) {
						copy.forEach(function (item, key) {
							if (item.id === id) {
								console.log('--id', id);
								copy.splice(key, 1);
							}
						});
					});
					_this4.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT, copy);
					_this4.getOnlineConnects();
					_this4.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT_COUNTS, copyCount - ids.length);
					_this4.$notify({
						type: 'success',
						message: _this4.$gettext('Disconnect successfully!')
					});
				}).catch(function (err) {
					console.log('err', err);
				});
			});
		},
		onSelectLanguage: function onSelectLanguage(language) {
			localStorage.setItem('currentLanguage', language);
			this.$language.current = localStorage.getItem('currentLanguage');
			if (this.$language.current === 'en_US') {
				__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en___default.a);
			} else {
				__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_zh_CN___default.a);
			}
		},
		handleClickMenu: function handleClickMenu(command) {
			var _this5 = this;

			if (command === 'logout') {
				__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].logout().then(function (res) {
					_this5.$notify({
						message: _this5.$gettext('LoginOut successfully!'),
						type: 'success'
					});

					_this5.$router.push('/login');
				});
			}
		},
		getAlarmNotifyUnreadCounts: function getAlarmNotifyUnreadCounts() {
			var _this6 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								return _context.abrupt('return', _this6.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.GET_ALARM_NOTIFY_UNREAD_COUNTS).then(function (res) {
									return res;
								}));

							case 1:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this6);
			}))();
		},
		closeAlarmNotify: function closeAlarmNotify() {
			var _this7 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.CLOSE_ALARM_NOTIFY).then(function (res) {
				if (res && res.status) {
					_this7.alarmNotifyStatus = res.status;
				}
			});
		},
		initPolling: function initPolling() {
			var _this8 = this;

			this.pollingInstance = new __WEBPACK_IMPORTED_MODULE_12__plugins_polling__["a" /* default */]({
				interval: 1000 * 10,
				maxRetry: 3,
				requestFn: this.getAlarmNotifyUnreadCounts,

				onSuccess: function onSuccess(result) {
					_this8.isPolling = true;
					_this8.isPaused = false;
					console.log('轮询获取状态：', result);
					_this8.alarmNotifyNotice = result.notice;
					_this8.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.UNREAD_COUNTS, result.num);
				},

				onError: function onError(error) {
					console.error('轮询请求失败：', error);
				},

				onComplete: function onComplete() {
					_this8.isPolling = false;
					_this8.isPaused = false;
					console.log('轮询已停止');
				}
			});
		},
		startPolling: function startPolling() {
			this.pollingInstance.start();
		}
	},
	mounted: function mounted() {
		this.startPolling();
	},
	beforeDestroy: function beforeDestroy() {
		if (this.pollingInstance) {
			this.pollingInstance.stop();
		}
	},

	watch: {
		$route: function $route(to, from) {
			this.getOnlineConnectsCounts();
		},

		languageCurrent: function languageCurrent(newVal, oldVal) {
			this.getOnlineConnectsCounts();
		},
		alarmNotifyNotice: function alarmNotifyNotice(newVal, oldVal) {
			var _this9 = this;

			if (newVal && newVal !== oldVal) {
				this.$notify({
					message: this.$gettext('You Have A New Alert Notification. Please Check It Promptly.'),
					type: 'warning',
					duration: 5 * 50 * 1000,
					offset: 50,
					onClick: function onClick() {
						_this9.$router.push({ name: 'alarmNotify', query: { notice_accounts: _this9.$store.getters.account.name } });
					},
					onClose: function onClose() {
						_this9.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.CLOSE_ALARM_NOTIFY);
					}
				});
			}
		}
	}
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(10);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'LeftNav',
	data: function data() {
		return {
			activeIndex: '',
			isCollapse: false,
			isUpdateAgent: false,
			newAgentVersion: ''
		};
	},
	mounted: function mounted() {
		window.addEventListener('resize', function () {
			var result = window.matchMedia('(max-width: 700px)');
			if (result.matches) {
				this.isCollapse = true;
			} else {
				this.isCollapse = false;
			}
			console.log(this.isCollapse);
		});
		this.initDefaultMenu(this.$route.path);
		if (this.currentAccount.is_admin) {
			this.getNewAgentVersion();
		}

		console.log(this.currentAccount.is_admin, 'this.currentAccount.is_admin🌹🌹🌹🌹');
	},

	computed: {
		currentAccount: function currentAccount() {
			return this.$store.getters.account;
		},
		openedsIndex: function openedsIndex() {
			if (!sessionStorage.getItem('activeIndex')) {
				return ['1'];
			} else {
				return sessionStorage.getItem('activeIndex').split('-').splice(0, 1);
			}
		}
	},
	methods: {
		initDefaultMenu: function initDefaultMenu(path) {
			var _this = this;

			var menus = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.el-menu-item');
			Object.forEach(menus, function (item, index) {
				if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(item).data('router')) {
					var routerConfig = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(item).data('router');
					for (var key in routerConfig) {
						if (path.split('/').length === 4) {
							var route = path.split('/').splice(0, 3);
							if (route.join('/').indexOf(key) >= 0) {
								_this.activeIndex = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(item).data('router')[key];
								sessionStorage.setItem('activeIndex', _this.activeIndex);
							}
						} else {
							if (path === key) {
								_this.activeIndex = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(item).data('router')[key];
								sessionStorage.setItem('activeIndex', _this.activeIndex);
							}
						}
					}
				}
			});
			if (!this.activeIndex) {
				this.activeIndex = sessionStorage.getItem('activeIndex') || '1-1';
			}
		},
		getNewAgentVersion: function getNewAgentVersion() {
			var _this2 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.CHECK_AGENT).then(function (res) {
				_this2.newAgentVersion = res.version;
				_this2.getClusterList();
			});
		},
		getClusterList: function getClusterList() {
			var _this3 = this;

			var params = {
				params: {
					page_size: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* Utils */].config.maxPageSize
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.GET_CLUSTER, params).then(function (res) {
				console.log(res);
				var agentList = [];
				res.objects.map(function (item) {
					if (item.agent_version) {
						agentList.push(item);
					}
				});
				console.log(agentList);
				agentList.forEach(function (item) {
					if (__WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.isNeedUpdate(item.agent_version, _this3.newAgentVersion) && !item.parent_id) {
						_this3.isUpdateAgent = true;
					}
				});
			});
		}
	},
	watch: {
		$route: function $route(to, from) {
			this.initDefaultMenu(this.$route.path);
		}
	}
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'login',
	data: function data() {
		return {
			compelChangePassword: false,
			loginForm: {
				domain: '',
				username: '',
				password: '',
				captcha: '',
				agree: false
			},
			ssoOption: {
				is_open_sso: false,
				mfa: false,
				is_account_password: false,
				sso_service: ''
			},
			showCaptcha: 0,
			currentAccount: this.$store.getters.current,
			captchaSrc: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].apiUrl + '/auth/captcha' + '?' + new Date().getTime(),
			loading: false,
			canSubmit: false,
			rules: {
				domain: [{
					required: true,
					trigger: 'blur'
				}],
				username: [{
					required: true,
					trigger: 'blur'
				}],
				password: [{
					required: true,
					trigger: 'blur'
				}],
				captcha: [{
					required: true,
					trigger: 'blur'
				}]
			}
		};
	},
	created: function created() {
		var _this = this;

		this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].ACCOUNT.CURRENT).then(function (res) {
			if (res.is_admin) {
				_this.$router.push('/dashboard');
				sessionStorage.setItem('activeIndex', '1-1');
			} else if (res.error_message) {
				console.log(res, 'res');
			} else {
				_this.$router.push('/operation/workgroup');
				sessionStorage.setItem('activeIndex', '1-2');
			}
		});
	},

	methods: {
		onKeyup: function onKeyup() {
			if (this.canSubmit) {
				this.login();
			}
		},
		checkCaptcha: function checkCaptcha() {
			var _this2 = this;

			console.log(this.$refs['loginForm'].validateField('username'));
			this.$refs['loginForm'].validateField('domain', function (res) {
				console.log('res', res);
				if (!res) {
					_this2.checkSSO();
					_this2.$refs['loginForm'].validateField('username', function (r) {
						if (!r) {
							var params = {
								domain: _this2.loginForm.domain,
								username: _this2.loginForm.username
							};
							_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].ACCOUNT.SHOW_CAPTCHA, params).then(function (res) {
								_this2.showCaptcha = res.captcha;
								if (_this2.showCaptcha) {
									_this2.refresh();
								}
							}, function () {
								_this2.showCaptcha = 0;
							});
						}
					});
				}
			});
		},
		checkSSO: function checkSSO() {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var params;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								params = {
									domain: _this3.loginForm.domain
								};

								_this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].ACCOUNT.CHECK_SSO, params).then(function (res) {
									console.log(res, 'res');
									_this3.ssoOption = {
										is_open_sso: res.is_open_sso,
										mfa: res.mfa,
										is_account_password: res.is_account_password,
										sso_service: res.sso_service
									};
									console.log(_this3.ssoOption, 'ssoOption');
								}, function () {
									_this3.$notify({
										type: 'error',
										message: _this3.$gettext('Check SSO Failed')
									});
								});

							case 2:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this3);
			}))();
		},
		login: function login(m) {
			var _this4 = this;

			this.loading = true;
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].ACCOUNT.LOGIN, {
				data: this.loginForm
			}).then(function (res) {
				_this4.loading = false;
				if (res.otp_enabled) {
					_this4.$router.push('/mfaComfirm');
				} else if (res.op == 'change_pwd') {
					_this4.$router.push('/compelChangePassword');
				} else if (res.company_mfa && !res.otp_enabled) {
					_this4.$router.push('/mfaOpen');
				} else {
					localStorage.setItem('isAdmin', res.is_admin);
					_this4.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].TEAM.CURRENT).then(function (team) {
						if (team.current_plan === null) {
							_this4.$router.push('/purchase');
						} else {
							if (res.is_admin) {
								_this4.$router.push('/dashboard');
								sessionStorage.setItem('activeIndex', '1-1');
							} else {
								_this4.$router.push('/operation/workgroup');
								sessionStorage.setItem('activeIndex', '1-2');
							}
						}
						_this4.$notify({
							message: _this4.$gettext('Login Successfully!'),
							type: 'success'
						});
					}).catch(function (err) {
						_this4.$notify({
							type: 'error',
							message: _this4.$gettext(err.code)
						});
					});
				}
			}, function (err) {
				console.log(err);

				if (err.code === 'CaptchaIncorrect') {
					_this4.showCaptcha = 1;
				}

				if (_this4.showCaptcha) {
					_this4.refresh();
				}
				_this4.loading = false;
			});
		},
		ssoLogin: function ssoLogin() {
			if (this.ssoOption.sso_service) {
				window.location.href = this.ssoOption.sso_service;
			}
		},
		isLogin: function isLogin() {
			if (!Object.isEmpty(this.$store.getters.account)) {
				this.$router.push('/dashboard');
			}
		},
		refresh: function refresh() {
			this.captchaSrc = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].apiUrl + '/auth/captcha' + '?' + new Date().getTime();
		}
	},
	watch: {
		loginForm: {
			handler: function handler(newVal, oldVal) {
				var that = this;
				if (this.$refs['loginForm']) {
					this.$refs['loginForm'].validate(function (valid) {
						that.canSubmit = valid;
					});
				}
			},
			deep: true
		}
	}
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      securityCode: '',
      isCansubmit: false,
      bindMfa: false
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTranslateText();
    }
  },
  methods: {
    getTranslateText: function getTranslateText() {
      return {
        'firstCode': this.$gettext('First column verification code'),
        'secondCode': this.$gettext('Second column verification code'),
        'enterCode': this.$gettext('Enter the 6-digit security code')
      };
    },
    onInputCode: function onInputCode(val) {
      if (/^\d{6}$/.test(val)) {
        this.isCansubmit = true;
      } else {
        this.isCansubmit = false;
      }
    },
    onSubmitVerify: function onSubmitVerify() {
      var _this = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.VERIFY_MFA_CODE, { code: this.securityCode }).then(function (res) {
        localStorage.setItem('isAdmin', res.is_admin);
        if (res.error_message) {
          _this.$notify({
            type: 'error',
            message: res.error_message
          });
          return;
        }
        if (res.is_admin) {
          _this.$router.push('/dashboard');
          sessionStorage.setItem('activeIndex', '1-1');
        } else {
          _this.$router.push('/operation/workgroup');
          sessionStorage.setItem('activeIndex', '1-2');
        }
      });
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      bindMfa: false,
      changeInfo: true,
      activeName: 'scanGet',
      securityNumForm: {
        mfaEwm: '',
        firstCode: '',
        secondCode: ''
      },
      secret: {},
      rules: {
        firstCode: [{
          required: true,
          pattern: /^\d{6}$/,
          message: this.$gettext('Enter the 6-digit security code'),
          trigger: 'blur'
        }],
        secondCode: [{
          required: true,
          pattern: /^\d{6}$/,
          message: this.$gettext('Enter the 6-digit security code'),
          trigger: 'blur'
        }]
      }
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTranslateText();
    }
  },
  methods: {
    getTranslateText: function getTranslateText() {
      return {
        'firstCode': this.$gettext('First column verification code'),
        'secondCode': this.$gettext('Second column verification code'),
        'enterCode': this.$gettext('Enter the 6-digit security code'),
        'mfaverify': this.$gettext('MFA Verification Instructions'),
        'scanCode': this.$gettext('Scan the two-dimensional code'),
        'manualInput': this.$gettext('Manual input'),
        'bingMfa': this.$gettext('Bind Mfa')
      };
    },
    onChangeInfo: function onChangeInfo() {
      this.changeInfo = false;
      this.securityNumForm.firstCode = '';
      this.securityNumForm.secondCode = '';
      this.activeName = 'scanGet';
      this.secret = '';
      this.securityNumForm.mfaEwm = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* baseUrl */].apiUrl + '/mfa/img' + '?' + Math.random();
    },
    onDialogClose: function onDialogClose() {
      this.bindMfa = false;
      this.changeInfo = true;
    },
    onCancelLogin: function onCancelLogin() {
      var _this = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.LOGOUT).then(function (res) {
        _this.$router.push('/login');
      });
    },
    onTabClick: function onTabClick(tab) {
      var _this2 = this;

      this.activeName = tab.name;
      if (this.activeName === 'handleGet' && !this.secret) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.GET_MFA_SECRET).then(function (res) {
          _this2.secret = res;
        });
      }
      this.resetForm('securityNum');
      this.securityNumForm.firstCode = '';
      this.securityNumForm.secondCode = '';
    },
    onConfirmOpen: function onConfirmOpen() {
      var _this3 = this;

      this.$refs['securityNum'].validate(function (valid) {
        if (valid) {
          var params = {
            data: {
              first_code: _this3.securityNumForm.firstCode,
              second_code: _this3.securityNumForm.secondCode,
              otp_enabled: 1
            }
          };
          _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.POST_MFA_CODE, params).then(function (res) {
            _this3.$router.push('/mfaComfirm');
            _this3.$notify({
              type: 'success',
              message: _this3.$gettext('Open success!')
            });
            _this3.bindMfa = false;
            _this3.changeInfo = true;
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_nvd3_pie_chart__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_nvd3_pie_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_nvd3_pie_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_nvd3_line_chart__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_nvd3_line_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_nvd3_line_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_base64__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utils__ = __webpack_require__(10);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard',
  data: function data() {
    return {
      xAxis: [],
      weekOperation: null,
      reTypeLoading: true,
      resourceType: null,
      statistic: {},
      topMembers: null,
      topResources: null,
      emptyData: true,
      currentConnectList: null,
      currentConnectPage: 1
    };
  },

  computed: {
    currentConnectCount: function currentConnectCount() {
      return this.$store.getters.dashboard.onlineMembersCount;
    },
    attrText: function attrText() {
      return this.getTranslateText();
    },
    languageCurrent: function languageCurrent() {
      return this.$language.current;
    }
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.account).length && this.$store.getters.account.is_admin) {
      this.$router.push('/dashboard');
      sessionStorage.setItem('activeIndex', '1-1');
      this.getStatistics();
      this.getWeekOperationStatistic();
      this.getResourceTypeStatistic();
      this.getTopMembers();
      this.getTopResources();
      this.getOnlineConnects();
    } else {
      this.$router.push('/operation/workgroup');
      sessionStorage.setItem('activeIndex', '1-2');
    }
  },
  mounted: function mounted() {},

  methods: {
    getTranslateText: function getTranslateText() {
      return {
        member: this.$gettext('Member'),
        cluster: this.$gettext('Cluster'),
        workgroup: this.$gettext('Workgroup'),
        duration: this.$gettext('Duration/minute'),
        number: this.$gettext('Number'),
        resource: this.$gettext('Resource'),
        action: this.$gettext('Action'),
        noSession: this.$gettext('no online sessions'),
        'unsafeMode': this.$gettext('Unsafe Mode')
      };
    },
    onLinkhref: function onLinkhref(url) {
      if (url) {
        window.open(url);
      }
    },
    createShadow: function createShadow(con) {
      var params = {
        master_connection_id: con.connection_id,
        readonly: false,
        expire_time: Math.floor(new Date().getTime() / 1000) + 30 * 60
      };
      var newWin = window.open('');
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.GET_CSOS_SHADOW, params).then(function (res) {
        var shadowUrl = 'http://' + res.agent_host + ':' + res.agent_webtty_port + '/?code=' + __WEBPACK_IMPORTED_MODULE_4_js_base64___default.a.Base64.encode(res.code) + '&user=' + res.user;
        newWin.location.href = shadowUrl;
      }, function () {
        newWin.close();
      });
    },
    getWeekOperationChartOptions: function getWeekOperationChartOptions(chartData) {
      var _this = this;

      var colors = ['#529AFC', '#A2F1AF'];
      var totalChartData = {
        options: {
          chart: {
            showLegend: true,
            showControls: false,
            showYAxis: false,
            showMinMaxPoints: false,
            height: 300,
            margin: {
              top: 20,
              right: 30,
              bottom: 40,
              left: 40
            },
            x: function x(d) {
              return d.x;
            },
            y: function y(d) {
              return d.y;
            },
            useInteractiveGuideline: true,
            xAxis: {
              showMaxMin: false,
              tickFormat: function tickFormat(d, index) {
                var date = new Date(_this.xAxis[d]);
                return date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
              }
            },
            yAxis: {
              showMaxMin: false,
              tickFormat: function tickFormat(d) {
                return d;
              }
            }
          }
        },
        data: []
      };
      chartData.forEach(function (item, index) {
        totalChartData.data.push({
          values: item,
          key: index === 0 ? _this.$gettext('Number of Connections/number') : _this.$gettext('Duration of Connections/hour'),
          color: colors[index],
          area: true
        });
      });
      return totalChartData;
    },
    getWeekOperationStatisticData: function getWeekOperationStatisticData(data) {
      var _this2 = this;

      var chartDataTotal = [];
      var chartDataTimeLen = [];

      data.forEach(function (item, index) {
        item._time = new Date(item.date.replace(/-/g, '/') + ' 00:00:00').getTime();
        _this2.xAxis.push(item._time);
        chartDataTotal.push({
          x: index,
          xLabel: item._time,
          y: item.conn_count
        });
        chartDataTimeLen.push({
          x: index,
          xLabel: item._time,
          y: (item.conn_time / 3600).toFixed(2)
        });
      });
      return [chartDataTotal, chartDataTimeLen];
    },
    getWeekOperationStatistic: function getWeekOperationStatistic() {
      var _this3 = this;

      var dataLen = 7;
      var currentDate = new Date();
      var year = currentDate.getFullYear();
      var month = currentDate.getMonth() + 1 < 10 ? '0' + (currentDate.getMonth() + 1) : '' + (currentDate.getMonth() + 1);
      var date = currentDate.getDate() < 10 ? '0' + currentDate.getDate() : currentDate.getDate();
      var endDate = new Date(year + '/' + month + '/' + date + ' 23:59:59');
      var startDate = new Date(endDate.getTime() - (dataLen * 24 * 60 * 60 * 1000 - 1000));
      var params = {
        time_from: Math.floor(startDate.getTime() / 1000),
        time_end: Math.floor(endDate.getTime() / 1000)
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].DASHBOARD.GET_OPERATION_WEEK, params).then(function (res) {
        console.log('一周运维统计：', _this3.getWeekOperationStatisticData(res));
        _this3.weekOperation = _this3.getWeekOperationChartOptions(_this3.getWeekOperationStatisticData(res));
      });
    },
    getResourceTypeChartOptions: function getResourceTypeChartOptions(data) {
      var chartData = {
        options: {
          chart: {
            showLegend: false,
            donut: true,
            x: function x(d) {
              return d.key;
            },
            y: function y(d) {
              return d.y;
            },
            showTooltipPercent: true,
            labelsOutside: true,
            valueFormat: function valueFormat(d) {
              return d;
            }
          }
        },
        data: data
      };
      return chartData;
    },
    getResourceTypeStatistic: function getResourceTypeStatistic() {
      var _this4 = this;

      this.reTypeLoading = true;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].DASHBOARD.GET_RESOURCE_TYPE_STATISTIC).then(function (res) {
        console.log('get resource type statistic: ', res);
        if (res) {
          var chartData = [];
          Object.forEach(res, function (val, key) {
            if (val > 0) {
              _this4.emptyData = false;
            }
            if (key === 'mssql') {
              chartData.push({
                key: 'SQL Server',
                y: val
              });
            }
            if (key === 'oracle') {
              chartData.push({
                key: 'Oracle',
                y: val
              });
            }
            if (key === 'mysql') {
              chartData.push({
                key: 'MySQL',
                y: val
              });
            }
            if (key === 'linux') {
              chartData.push({
                key: 'Linux',
                y: val
              });
            }
            if (key === 'win32') {
              chartData.push({
                key: 'Windows',
                y: val
              });
            }
          });
          if (!_this4.emptyData) {
            _this4.resourceType = _this4.getResourceTypeChartOptions(chartData);
          }
          _this4.reTypeLoading = false;
        }
      });
    },
    getStatistics: function getStatistics() {
      var _this5 = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].DASHBOARD.GET_STATISTICS).then(function (res) {
        console.log('dashboard Number', res);
        _this5.statistic = res;
      });
    },
    getTopMembers: function getTopMembers() {
      var _this6 = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].DASHBOARD.LIST_TOP_MEMBERS, this.getTopRequestParams()).then(function (res) {
        var topMembers = Object.clone(res);
        topMembers.forEach(function (item) {
          if (Math.round(item.conn_time / 60) === 0) {
            item.conn_time = (item.conn_time / 60).toFixed(2);
          } else {
            item.conn_time = Math.round(item.conn_time / 60);
          }
        });
        _this6.topMembers = topMembers.splice(0, 10);
      }, function () {
        _this6.topMembers = [];
      });
    },
    getTopResources: function getTopResources() {
      var _this7 = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].DASHBOARD.LIST_TOP_RESOURCES, this.getTopRequestParams()).then(function (res) {
        var topResources = Object.clone(res);
        _this7.topResources = topResources.splice(0, 10);
      }, function () {
        _this7.topResources = [];
      });
    },
    getTopRequestParams: function getTopRequestParams() {
      var currentDate = new Date();
      var beforeWeekDate = new Date(currentDate.getTime() - 7 * 24 * 3600 * 1000);
      return {
        time_from: parseInt(beforeWeekDate.getTime() / 1000),
        time_end: parseInt(currentDate.getTime() / 1000),
        period: 'day'
      };
    },
    onChangePage: function onChangePage(pageIndex) {
      this.currentConnectPage = pageIndex;
      this.getOnlineConnects(pageIndex);
    },
    getOnlineConnects: function getOnlineConnects(page) {
      var _this8 = this;

      this.currentConnectPage = page || 1;
      var params = {
        page: page || 1
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].DASHBOARD.GET_ONLINE_CONNECT, params).then(function (res) {
        if (res && res.length) {
          var _connectList = Object.clone(res);
          _connectList.forEach(function (item, index) {
            var linkHref = '';
            if (item.guacamole && item.guacamole === 1) {
              linkHref = 'http://' + item.host + ':' + item.webrdp_port + '/?code=' + __WEBPACK_IMPORTED_MODULE_4_js_base64___default.a.Base64.encode(item.tunnel_code) + '&ip=' + item.resource_ip_address + '&resourceName=' + item.resource_name;
            } else {
              linkHref += 'playlog.html';
              linkHref += '?link=' + __WEBPACK_IMPORTED_MODULE_5__config__["a" /* baseUrl */].apiUrl;
              linkHref += '&way=' + item.way;
              linkHref += '&code=' + item.tunnel_code;
              linkHref += '&lang=' + _this8.languageCurrent;
              linkHref += '&type=monitor';
            }
            if (item.connection_id) {
              linkHref += '&connection_id=' + item.connection_id;
            }
            item.linkHref = linkHref;
            var showRdp = false;
            if (item.agent_version) {
              item.noResourceDisabled = false;
              if (__WEBPACK_IMPORTED_MODULE_6__Utils__["a" /* default */].Utils.getAgentVersion(item.agent_version) >= '2.4.2') {
                showRdp = true;
              }
              item.agentVersion = __WEBPACK_IMPORTED_MODULE_6__Utils__["a" /* default */].Utils.getAgentVersion(item.agent_version);
            }
            item.showRdp = showRdp;
          });
          _this8.currentConnectList = _connectList;
          console.log('connects------->+', _this8.currentConnectList);
        } else {
          _this8.currentConnectList = [];
        }
      });
    },
    onCutOnline: function onCutOnline(item) {
      var _this9 = this;

      this.$confirm(this.$gettext('Are you sure to disconnect this connection?'), this.$gettext('Disconnect connection confirm'), {
        confirmButtonText: this.$gettext('Ok'),
        cancelButtonText: this.$gettext('Cancel'),
        type: 'warning'
      }).then(function () {
        _this9.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].DASHBOARD.CUT_ONLINE, item.id).then(function () {
          var copyCount = Object.clone(_this9.$store.getters.dashboard.onlineMembersCount);
          _this9.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT_COUNTS, copyCount - 1);
          _this9.getOnlineConnects();
          _this9.$notify({
            type: 'success',
            message: _this9.$gettext('Disconnect successfully!')
          });
        }).catch(function (err) {
          _this9.$notify.info({
            message: err
          });
        });
      });
    }
  },
  watch: {
    languageCurrent: function languageCurrent(newVal, oldVal) {
      this.getWeekOperationStatistic();
    }
  },
  components: {
    Nvd3PieChart: __WEBPACK_IMPORTED_MODULE_2__common_nvd3_pie_chart___default.a,
    Nvd3LineChart: __WEBPACK_IMPORTED_MODULE_3__common_nvd3_line_chart___default.a
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_vue_file_base64__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_vue_file_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__model_vue_file_base64__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false,
      document: {
        list: [],
        currentPage: 1,
        totalPage: 0,
        fileIds: [],
        uploadOption: {
          file_name: '',
          file_size: ''
        },
        downUrl: ''
      },
      show: false
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTransitionText();
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.account;
    }
  },
  created: function created() {
    this.getFileList();
    console.log('isAdmin', this.isAdmin, this.$store.getters.account);
  },

  methods: {
    onLoading: function onLoading(stadus) {
      this.loading = stadus;
    },
    getTransitionText: function getTransitionText() {
      return {
        fileName: this.$gettext('File Name'),
        size: this.$gettext('Size'),
        users: this.$gettext('Users'),
        date: this.$gettext('Date'),
        action: this.$gettext('Action')
      };
    },
    getFileList: function getFileList(page) {
      var _this = this;

      this.loading = true;
      var params = {
        params: {
          page: page || 1,
          q: {
            'order_by': [{ 'field': 'create_time', 'direction': 'desc' }]
          },
          r: Math.random()
        }
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].DOCUMENT.GET_LIST, params).then(function (res) {
        _this.document.list = _this.$store.getters.document;
        _this.document.totalPage = res.num_results;
        _this.loading = false;
      }, function () {
        _this.loading = true;
      });
    },
    uploadFiles: function uploadFiles(file) {
      var _this2 = this;

      var base = file.base64.split('base64,');
      var params = {
        file_name: file.name,
        file_size: file.size,
        content: base[1]
      };
      if (params.file_size > 10 * 1024 * 1024) {
        this.$notify({
          message: this.$gettext('The maximum supported file size is 10M.'),
          type: 'warning'
        });
        this.loading = false;
      } else {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].DOCUMENT.UPLOAD, params).then(function (res) {
          _this2.getFileList(_this2.document.currentPage);
          _this2.$notify({
            message: _this2.$gettext('Upload successfully!'),
            type: 'success'
          });
        });
      }
    },
    onDown: function onDown(id) {
      this.document.downUrl = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* baseUrl */] + '/file/manage?file_uuid=' + id;
    },
    batchDel: function batchDel(id) {
      var _this3 = this;

      var ids = this.document.fileIds.map(function (item) {
        return item.id;
      });
      this.$confirm(this.$gettext('Are you sure to delete the document?'), this.$gettext('Delete Confirm'), {
        confirmButtonText: this.$gettext('Comfirm'),
        cancelButtonText: this.$gettext('Cancel'),
        type: 'warning'
      }).then(function () {
        var param = {};
        if (id) {
          param = {
            ids: [id]
          };
        } else {
          param = {
            ids: ids
          };
        }
        _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].DOCUMENT.DEL, param).then(function (res) {
          _this3.$notify({
            type: 'success',
            message: _this3.$gettext('Delete successfully!')
          });
          _this3.getFileList(_this3.document.currentPage);
        });
      }).catch(function () {});
    },
    onChangePage: function onChangePage(page) {
      this.document.currentPage = page;
      this.getFileList(page);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.document.fileIds = val;
    },
    tableRowClassName: function tableRowClassName(row, index) {
      if (index % 2 === 0) {
        return 'info-row';
      }
      return '';
    }
  },
  components: {
    fileBase64: __WEBPACK_IMPORTED_MODULE_2__model_vue_file_base64___default.a
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_log_search__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_log_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__model_log_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_log_report__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_log_report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__model_log_report__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_moment_src_moment__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Utils__ = __webpack_require__(10);










/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			loading: false,
			freezeShow: false,
			freezeShowRow: '',
			log: {
				baseUrl: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* baseUrl */],
				tags: [],
				delTag: '',
				list: [],
				totalNum: 0,
				loadPage: 2,
				totalPage: 0,
				currentPage: 1
			},
			searchForm: {
				keywords: ''
			},
			importUrl: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* baseUrl */].apiUrl + '/search_tunnel' + '?' + 'export=true',
			scroll: false,
			busy: false,
			dataError: false,
			currentRightPanel: null,
			rightPanelData: null,
			pollingTimer: null,
			pollingLoading: false,
			pollingCode: '',

			viewLogShow: false,
			viewLogLoading: false,
			logContent: '',
			viewLogRow: '' };
	},

	computed: {
		attrText: function attrText() {
			return this.getTransitionText();
		},
		languageCurrent: function languageCurrent() {
			return this.$language.current;
		},
		currentCompany: function currentCompany() {
			console.log('currentCompany', this.$store.getters.team.setting);
			return this.$store.getters.team.setting;
		},
		tableMaxHeight: function tableMaxHeight() {
			return window.innerHeight - 300;
		}
	},
	created: function created() {
		this.onSearch({});
	},

	methods: {
		wayMap: function wayMap(way) {
			var way_map = {
				rdp: 'Windows（RDP）',
				terminal: 'Linux（SSH）',
				mysql: 'MySQL',
				mssql: 'MSSQL',
				postgresql: 'PostgreSQL',
				oracle: 'Oracle',
				transfer: this.attrText.fileTransfer
			};

			return way_map[way];
		},
		durTime: function durTime(data, startData) {
			var time = (data - startData) * 1000;
			var h = parseInt(__WEBPACK_IMPORTED_MODULE_6__node_modules_moment_src_moment__["a" /* default */].duration(time).asHours());
			var m = __WEBPACK_IMPORTED_MODULE_6__node_modules_moment_src_moment__["a" /* default */].duration(time).minutes();
			var s = __WEBPACK_IMPORTED_MODULE_6__node_modules_moment_src_moment__["a" /* default */].duration(time).seconds();
			if (h < 10) {
				h = '0' + h;
			}
			if (m < 10) {
				m = '0' + m;
			}
			if (s < 10) {
				s = '0' + s;
			}
			return h + ':' + m + ':' + s;
		},
		href: function href(link) {
			window.location.href = link;
		},
		showDetail: function showDetail(id) {
			if (this.log.detailRow !== id) {
				this.log.detailRow = id;
			} else {
				this.log.detailRow = '';
			}
			console.log(id);
		},
		getTranTest: function getTranTest(clusters) {
			var translated = this.$ngettext('%{ n } record', '%{ n } records', clusters);
			var interpolated = this.$gettextInterpolate(translated, { n: clusters });
			return interpolated;
		},
		getTransitionText: function getTransitionText() {
			return {
				command: this.$gettext('Input history command'),
				tagCommand: this.$gettext('Command'),
				now: this.$gettext('Now'),
				hour: this.$gettext('hour'),
				minute: this.$gettext('minute'),
				second: this.$gettext('second'),
				unsafeMode: this.$gettext('Unsafe Mode'),
				commissionTeam: this.$gettext('Commission Team'),
				download: this.$gettext('Download'),
				upload: this.$gettext('Upload'),
				from: this.$gettext('From'),
				to: this.$gettext('To'),
				ip: this.$gettext('IP'),
				operator: this.$gettext('Operator'),
				workgroup: this.$gettext('Workgroup'),
				operationObj: this.$gettext('Operation Obj'),
				operationTime: this.$gettext('Operation Time'),
				action: this.$gettext('Action'),
				fileTransfer: this.$gettext('File Transfer')
			};
		},
		copySuccess: function copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success'
			});
			e.clearSelection();
		},
		copyError: function copyError(e) {
			this.$notify({
				message: this.$gettext('Copy Failed!'),
				type: 'failed'
			});
		},
		loadMore: function loadMore() {
			console.log('loadmore');
			this.busy = true;
			this.scroll = true;
			if (this.log.list.length > 0 && this.log.list.length < this.log.totalNum && !this.dataError) {
				this.getLogList(this.log.loadPage);
				this.log.loadPage++;
			} else {
				this.busy = true;
			}
		},
		onChangePage: function onChangePage(page) {
			this.getLogList(page);
		},
		getLogList: function getLogList(page) {
			var _this = this;

			this.loading = true;
			this.dataError = false;
			this.importUrl = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* baseUrl */].apiUrl + '/search_tunnel' + '?' + 'export=true';
			var params = {
				page_index: page || 1,
				page_size: 10
			};
			this.log.tags.forEach(function (item) {
				if (item.key === 'timeRange') {
					var time = item.val.split(' - ');
					params['time_from'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__node_modules_moment_src_moment__["a" /* default */])(time[0]).format('x') / 1000;
					if (time[1] === _this.attrText.now) {
						var now = new Date();
						params['time_end'] = Math.ceil(now.getTime() / 1000);
					} else {
						params['time_end'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__node_modules_moment_src_moment__["a" /* default */])(time[1]).format('x') / 1000 + +24 * 3600;
					}
				} else {
					if (_this.$route.query.resourceName) {
						params['resource_id'] = _this.$route.query.resourceName.split(':')[0];
					} else {
						params[item.key] = item.val;
					}
				}
				if (item.key === 'way') {
					if (item.val === 'Linux') {
						params['way'] = 'terminal';
					} else if (item.val === 'Windows') {
						params['way'] = 'rdp';
					} else if (item.val === 'MySQL') {
						params['way'] = 'mysql';
					} else if (item.val === 'SQL Server') {
						params['way'] = 'mssql';
					}
				}
			});
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.ACTION, { params: params }).then(function (res) {
				console.log(res, 'res');

				Object.forEach(params, function (key, val) {
					if (val === 'page_size') {
						_this.importUrl += '&' + val + '=' + __WEBPACK_IMPORTED_MODULE_5__config__["g" /* Utils */].config.maxPageSize;
					} else {
						_this.importUrl += '&' + val + '=' + key;
					}
				});
				_this.importUrl += '&' + 'lang=' + _this.languageCurrent;
				_this.loading = false;
				_this.log.totalNum = res.total || 0;
				_this.log.totalPage = res.total;

				var data = [];
				if (res.data && res.data.length) {
					res.data.forEach(function (item, index) {
						var _playbackLink = 'playlog.html';
						var _downloadLink = _this.log.baseUrl.apiUrl + '/download_tunnel_log';
						_playbackLink += '#?link=' + _this.log.baseUrl.apiUrl;
						_playbackLink += '&way=' + item.way;
						_playbackLink += '&code=' + item.code;
						_playbackLink += '&resource_id=' + item.resource_id;
						_playbackLink += '&account_name=' + item.account_name;
						_playbackLink += '&avatar=' + item.avatar;
						_playbackLink += '&account_id=' + item.account_id;
						if (_this.searchForm.keywords) {
							_playbackLink += '&keywords=' + _this.searchForm.keywords;
						}
						if (item.agent_version) {
							_playbackLink += '&version=' + __WEBPACK_IMPORTED_MODULE_7__Utils__["a" /* default */].Utils.getAgentVersion(item.agent_version);
						}
						_playbackLink += '&start_time=' + item.start_date;
						_playbackLink += '&date=' + item.date;
						_downloadLink += '?way=' + item.way;
						_downloadLink += '&code=' + item.code;
						_downloadLink += '&start_time=' + item.start_date;
						if (item.connection_id) {
							_playbackLink += '&connection_id=' + item.connection_id;
							_downloadLink += '&connection_id=' + item.connection_id;
						}
						if (item.guacamole) {
							_playbackLink += '&guacamole=' + item.guacamole;
							if (item.rdp_width && item.rdp_height) {
								_playbackLink += '&rdp_width=' + item.rdp_width;
								_playbackLink += '&rdp_height=' + item.rdp_height;
							}
						}
						_playbackLink += '&lang=' + _this.languageCurrent;
						_playbackLink += '&type=playlog';
						item.playbackLink = _playbackLink;
						item.downloadLink = _downloadLink;
						data.push(item);
					});
				} else {
					_this.dataError = true;
				}
				_this.searchForm.keywords = '';
				if (!_this.scroll) {
					_this.log.list = data;
				} else {
					_this.log.list = _this.log.list.concat(data);
				}
				_this.busy = false;
			}, function () {
				_this.loading = true;
			});
		},
		onSearch: function onSearch(options) {
			this.log.tags = [];
			this.log.list = [];
			this.scroll = false;
			this.log.loadPage = 2;
			if (this.$route.query.resourceName) {
				console.log('this.$route.query.resourceName', this.$route.query.resourceName);
				this.log.tags.push({
					key: 'resource_name',
					val: this.$route.query.resourceName.split(':')[1],
					text: this.$gettext('Resource Name')
				});
			} else {
				for (var item in options) {
					if (item === 'keywords' && options[item] !== '') {
						this.log.tags.push({
							key: 'keywords',
							val: options[item],
							text: this.$gettext('Command')
						});
					}
					if (item === 'resourceType') {
						this.log.tags.push({
							key: 'way',
							val: options[item],
							text: this.$gettext('Resource Type')
						});
					}
					if (item === 'member') {
						this.log.tags.push({
							key: 'account_name',
							val: options[item],
							text: this.$gettext('Member')
						});
					}
					if (item === 'ip') {
						this.log.tags.push({
							key: 'ip',
							val: options[item],
							text: this.$gettext('ip')
						});
					}
					if (item === 'resourceName') {
						this.log.tags.push({
							key: 'resource_name',
							val: options[item],
							text: this.$gettext('Resource Name')
						});
					}
					if (item === 'unSafeMode') {
						this.log.tags.push({
							key: 'unsafe_mode',
							val: options[item],
							text: this.$gettext('unSafeMode')
						});
					}
					if (item === 'timeRange') {
						if (options[item][1] === '') {
							this.log.tags.push({
								key: 'timeRange',
								val: options[item][0] + ' - ' + this.attrText.now,
								text: this.$gettext('End Time')
							});
						} else {
							this.log.tags.push({
								key: 'timeRange',
								val: options[item][0] + ' - ' + options[item][1],
								text: this.$gettext('timeRange')
							});
						}
					}
				}
			}
			this.getLogList(1);
		},
		onCloseTag: function onCloseTag(tag) {
			this.log.tags.splice(this.log.tags.indexOf(tag), 1);
			if (this.$route.query.resourceName) {
				this.$router.push({ name: 'logs' });
			}
			this.scroll = false;
			this.getLogList(1);
		},
		onClosePanel: function onClosePanel() {
			this.currentRightPanel = null;
			this.rightPanelData = null;
		},
		videoReply: function videoReply() {
			var url = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* baseUrl */].apiUrl + '/video/rdp_replay';
			window.open(url, '_blank');
		},
		onShowLogSearch: function onShowLogSearch() {
			var _this2 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'LogSearch' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_3__model_log_search___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this2.rightPanelData = [];
				}, time);
			});
		},
		onShowLogReport: function onShowLogReport() {
			var _this3 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'LogReport' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_4__model_log_report___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this3.rightPanelData = [];
				}, time);
			});
		},
		tableRowClassName: function tableRowClassName(row, index) {
			if (index % 2 === 0) {
				return 'info-row';
			}
			return '';
		},
		viewLog: function viewLog(row, isDialog) {
			var params = {
				code: row.code,
				way: row.way,
				connection_id: row.connection_id,
				check: 1
			};
			if (isDialog) {
				params.check = 0;
				this.$notify({
					type: 'success',
					message: this.$gettext('正在解冻中!')
				});
			}
			clearTimeout(this.pollingTimer);

			this.polling(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params, { action: 'view' }), row);
		},
		loadLogContent: function loadLogContent(row) {
			var _this4 = this;

			this.viewLogLoading = true;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.VIEW_LOG, {
				params: {
					code: row.code,
					way: row.way,
					connection_id: row.connection_id,
					show: 1
				}
			}).then(function (res) {
				console.log(res, 'res');

				_this4.viewLogLoading = false;

				var cleanContent = __WEBPACK_IMPORTED_MODULE_7__Utils__["a" /* default */].Utils.filterAnsiEscapeCodes(res || '');
				_this4.logContent = cleanContent || '暂无日志内容';
				_this4.viewLogShow = true;
			}).catch(function () {
				_this4.viewLogLoading = false;
				_this4.$message.error('日志内容加载失败');
			});
		},
		closeViewLogDialog: function closeViewLogDialog() {
			this.viewLogShow = false;
			this.logContent = '';
			this.viewLogRow = '';
		},
		downLog: function downLog(row, isDialog) {
			var params = {
				code: row.code,
				way: row.way,
				connection_id: row.connection_id,
				check: 1
			};
			if (isDialog) {
				params.check = 0;
				this.$notify({
					type: 'success',
					message: this.$gettext('正在解冻中!')
				});
			}
			clearTimeout(this.pollingTimer);
			this.polling(params, row);
		},
		handleFreezeConfirm: function handleFreezeConfirm() {
			if (this.viewLogRow) {
				this.viewLog(this.viewLogRow, true);
				this.viewLogRow = '';
			} else {
				this.downLog(this.freezeShowRow, true);
			}
		},
		polling: function polling(params, row) {
			var _this5 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.UNFREEZE, { params: params }).then(function (res) {
				console.log(res, 'res轮询');
				if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res).length) {
					if (res.code == 'OSSFileArchived') {
						_this5.pollingCode = res.code;

						if (params.action === 'view') {
							_this5.viewLogRow = row;
						} else {
							_this5.freezeShowRow = row;
						}

						_this5.freezeShow = true;
					} else if (res.code == 'OSSFileRestoring') {
						_this5.pollingCode = res.code;
						params.check = 1;
						_this5.freezeShow = true;
						_this5.pollingLoading = true;
						_this5.pollingTimer = setTimeout(function () {
							_this5.polling(params, row);
						}, 3000);
					}
				} else {
					_this5.pollingCode = 'OSSFileAvailable';
					_this5.pollingLoading = false;
					_this5.freezeShow = false;

					if (params.action === 'view') {
						_this5.loadLogContent(row);
					} else {
						window.open(row.downloadLink, '__blank');
					}
				}
			});
		},
		closeDialog: function closeDialog() {
			this.freezeShow = false;
			this.pollingCode = '';
			this.viewLogRow = '';
			clearTimeout(this.pollingTimer);
		}
	},
	destroyed: function destroyed() {
		clearTimeout(this.pollingTimer);
	},

	watch: {
		languageCurrent: function languageCurrent(newVal, oldVal) {
			this.onSearch({});
		}
	},
	components: {
		LogSearch: __WEBPACK_IMPORTED_MODULE_3__model_log_search___default.a,
		LogReport: __WEBPACK_IMPORTED_MODULE_4__model_log_report___default.a
	}
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils__ = __webpack_require__(10);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Check',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			showPassword: false,
			domain: '',
			teamName: '',
			creator_id: '',
			connects: '',
			connectInfo: {
				username: '',
				password: '',
				type: ''
			},
			pageList: {
				totalPage: 1,
				pageSize: 10,
				currentPage: 1
			},
			reportTypeList: null,
			m: null,
			o: '',
			contact: { port: '', code: '', host: '' },
			canCreateStatus: false,
			currentAccountId: this.$store.getters.account.id,
			newTime: Math.ceil(new Date().getTime() / 1000),
			loading: false,
			tableLoading: false,
			btnLoading: false,

			pollingList: [],
			pollingTimer: null,
			pollingStep: 0
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	mounted: function mounted() {},
	created: function created() {
		console.log(this.$route.params.id, 'this.$route.params.id,');
	},

	methods: {
		getTranslateText: function getTranslateText() {
			return {
				reportname: this.$gettext('Report Name'),
				hostname: this.$gettext('Host Name'),
				checktime: this.$gettext('Check Time'),
				action: this.$gettext('Action')
			};
		},
		onClose: function onClose() {
			this.$emit('onClosePanel');
			this.$emit('reloadTunnelCode', [this.connects.project_resource_id]);

			this.connects = null;
		},
		changePage: function changePage(page) {
			this.getCsosReport(this.connects.project_resource_id, page);
		},
		getReportVersionType: function getReportVersionType(type) {
			var _this = this;

			console.log(type, 'type');
			var params = {
				type: type
			};
			if (type.includes('MySQL')) {
				params.type = 'mysql';
			} else if (type.includes('SQLServer')) {
				params.type = 'mssql';
			}
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_VERSION_BY_TYPE, params).then(function (res) {
				if (res.success) {
					_this.reportTypeList = res.content;
				}
			});
		},
		sendCheck: function sendCheck() {
			var _this2 = this;

			this.btnLoading = true;

			var params = {
				domain: this.domain,
				name: this.teamName,
				instance_name: this.connects.name,
				type: this.connects.type,
				version_id: this.connectInfo.type,
				resource_id: this.connects.project_resource_id,
				host: this.contact.host,
				databaseHost: this.connects.ip,
				port: this.contact.port,
				creator_id: this.creator_id,
				user: this.contact.code,
				databaseUser: this.connects.login_user[0],
				password: this.connectInfo.password,
				host_name: this.connects.db_name,
				project_id: this.$route.params.id,
				project_name: this.connects.project
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.CREATE_CSOS_REPORT, params).then(function (res) {
				_this2.btnLoading = false;
				if (res.success) {
					_this2.$notify({
						message: res.message,
						type: 'success'
					});
					_this2.getCsosReport(_this2.connects.project_resource_id);
				} else {
					_this2.$notify({
						message: res.message,
						type: 'error'
					});
				}
			}, function () {
				_this2.btnLoading = false;
			});
		},
		getCsosReport: function getCsosReport(id, pageIndex) {
			var _this3 = this;

			this.tableLoading = true;

			var params = {
				page: pageIndex || 1,
				domain: this.domain,
				resource_id: id
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_CSOS_REPORT, params).then(function (res) {
				console.log(res, 'csosReport');
				_this3.m = res.content.data;
				_this3.pageList.totalPage = res.content.pages;
				_this3.pageList.currentPage = res.content.page;

				_this3.tableLoading = false;

				_this3.pollingList = [];
				_this3.m.forEach(function (i) {
					if (i.tasks_status === 'working') {
						_this3.pollingList.push(i.id);
					}
				});
				if (_this3.pollingList.length) {
					clearTimeout(_this3.pollingTimer);
					_this3.polling(_this3.pollingList);
				}
			}, function () {
				_this3.tableLoading = false;
			});
		},
		getConnectLog: function getConnectLog(id) {
			var _this4 = this;

			var params = {
				project_resource_id: id
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_TUNNEL_INFO, params).then(function (res) {
				console.log(res, 'ooooooooo');
				_this4.o = res;
				_this4.contact.code = res.code;
				switch (res.os) {
					case 'mssql':
						_this4.contact.port = res.agent.mssql_port;
						break;
					case 'mysql':
						_this4.contact.port = res.agent.mysql_port;
						break;
					case 'linux':
						_this4.contact.port = res.agent.ssh_port;
						break;
					case 'windows':
						_this4.contact.port = res.agent.rdp_port;
						break;
					default:
						break;
				}
				_this4.contact.host = res.agent.host;
			});
			console.log(this.contact, 'contact');
		},
		view: function view(row) {
			if (row.version.code == 'mysql_detection') {
				window.open(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* baseUrl */].databaseReportUrl + '/mysql/' + row.id);
			} else if (row.version.code == 'mssql_detection') {
				window.open(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* baseUrl */].databaseReportUrl + '/sqlserver/' + row.id);
			}
		},
		copySuccess: function copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success'
			});
		},
		polling: function polling(report_ids) {
			var _this5 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_CSOS_REPORT_STATE, { report_ids: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(report_ids) }).then(function (res) {
				console.log(res, 'res轮询');
				var data = res.content.data;
				var reportIdArr = [];
				for (var k in data) {
					if (data[k] === 'working') {
						reportIdArr.push(k);
					}
				}
				if (_this5.pollingStep != reportIdArr.length) {
					_this5.getCsosReport(_this5.connects.project_resource_id);
					_this5.pollingStep = reportIdArr.length;
				}
				if (reportIdArr.length) {
					_this5.pollingTimer = setTimeout(function () {
						_this5.polling(reportIdArr);
					}, 3000);
				} else {
					_this5.getCsosReport(_this5.connects.project_resource_id);
					_this5.pollingList = [];
				}
			});
		},
		hideStr: function hideStr(str) {
			return __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* default */].Utils.hideStr(str);
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this6 = this;

				this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].TEAM.CURRENT).then(function (res) {
					if (res) {
						console.log(res, 'res');
						_this6.domain = res.domain;
						_this6.teamName = res.full_name;
					}
					if (_this6.connects) {
						_this6.connects = '';
						setTimeout(function () {
							_this6.connects = _this6.items;
							_this6.getCsosReport(_this6.connects.project_resource_id);
							_this6.getReportVersionType(_this6.connects.type);
							_this6.getConnectLog(_this6.connects.project_resource_id);
						}, 300);
					} else {
						_this6.connects = _this6.items;
						_this6.getReportVersionType(_this6.connects.type);
						_this6.getCsosReport(_this6.connects.project_resource_id);
						_this6.getConnectLog(_this6.connects.project_resource_id);
					}
				});
				this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].ACCOUNT.CURRENT).then(function (res) {
					_this6.creator_id = res.name;
				});
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default.a
	},
	destroyed: function destroyed() {
		clearTimeout(this.pollingTimer);
	}
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_codemirror_lib_codemirror_css__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_codemirror_lib_codemirror_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_codemirror_lib_codemirror_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_codemirror_addon_display_fullscreen_css__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_codemirror_addon_display_fullscreen_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_codemirror_addon_display_fullscreen_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_codemirror_addon_display_fullscreen_js__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_codemirror_addon_display_fullscreen_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_codemirror_addon_display_fullscreen_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_codemirror_theme_cobalt_css__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_codemirror_theme_cobalt_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_codemirror_theme_cobalt_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_codemirror_theme_eclipse_css__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_codemirror_theme_eclipse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_codemirror_theme_eclipse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_codemirror_theme_ayu_dark_css__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_codemirror_theme_ayu_dark_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_codemirror_theme_ayu_dark_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_codemirror_theme_idea_css__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_codemirror_theme_idea_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_codemirror_theme_idea_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_codemirror_theme_solarized_css__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_codemirror_theme_solarized_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_codemirror_theme_solarized_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_codemirror_addon_hint_show_hint_css__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_codemirror_addon_hint_show_hint_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_codemirror_addon_hint_show_hint_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_codemirror_addon_hint_show_hint_js__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_codemirror_addon_hint_show_hint_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_codemirror_addon_hint_show_hint_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_codemirror_addon_hint_sql_hint_js__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_codemirror_addon_hint_sql_hint_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_codemirror_addon_hint_sql_hint_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_codemirror_addon_selection_active_line_js__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_codemirror_addon_selection_active_line_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_codemirror_addon_selection_active_line_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_codemirror_addon_edit_matchbrackets_js__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_codemirror_addon_edit_matchbrackets_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_codemirror_addon_edit_matchbrackets_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_codemirror_mode_sql_sql__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_codemirror_mode_sql_sql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_codemirror_mode_sql_sql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_codemirror__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_codemirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_codemirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sql_formatter__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sql_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sql_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuex__ = __webpack_require__(175);






















/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		value: {
			type: String,
			default: ''
		},
		runLoading: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			sqlEditor: null,
			code: ''
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_vuex__["a" /* mapGetters */])(['options'])),
	mounted: function mounted() {
		this.init();
		this.setSize();
	},

	methods: {
		init: function init() {
			this.sqlEditor = __WEBPACK_IMPORTED_MODULE_16_codemirror___default.a.fromTextArea(this.$refs.codeMirror, {
				mode: 'text/x-sparksql',
				lineNumbers: true,
				styleActiveLine: true,
				theme: 'default',
				lineWrapping: true,
				matchBrackets: true,
				autoCloseBrackets: true,
				line: true,
				extraKeys: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'Ctrl', 'autocomplete'),
				hintOptions: {
					completeSingle: false,
					tables: {} }
			});
			this.setValue();
			this.editorEvents();
		},
		setValue: function setValue(sql) {
			this.sqlEditor.setValue(sql ? sql : this.value);
		},
		setSize: function setSize() {
			var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';
			var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '300px';

			this.sqlEditor.setSize(width, height);
		},
		setHintOptions: function setHintOptions(tables) {
			this.sqlEditor.options.hintOptions.tables = tables;
		},
		editorEvents: function editorEvents() {
			var _this = this;

			this.sqlEditor.on('keyup', function (cm, event) {
				if (event.keyCode >= 65 && event.keyCode <= 90) {
					cm.showHint();
				}

				if (!cm.state.completionActive && (event.keyCode >= 65 && event.keyCode <= 90 || event.keyCode == 52 || event.keyCode == 219 || event.keyCode == 190)) {
					__WEBPACK_IMPORTED_MODULE_16_codemirror___default.a.commands.autocomplete(cm, null, { completeSingle: false });
				}
			});

			this.sqlEditor.on('change', function (editor) {
				_this.code = editor.getValue();
				if (_this.$emit) {
					_this.$emit('input', _this.code);
				}
			});
		},
		onRunCode: function onRunCode() {
			this.$emit('run', this.sqlEditor.getValue());
		},
		onStopRun: function onStopRun() {
			this.$emit('stop');
		},
		onCommitOrder: function onCommitOrder() {
			this.$emit('commit', this.sqlEditor.getValue());
		},
		onFormatSQL: function onFormatSQL() {
			if (this.sqlEditor.getValue().trim() === '') {
				this.$message.warning('请先编辑 SQL 命令！');
				return;
			}
			var sqlCode = this.sqlEditor.getValue();
			this.sqlEditor.setValue(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_sql_formatter__["format"])(sqlCode));
		}
	}
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'linuxConfig',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null,
      m: null,
      defaultUser: '',
      submiting: false
    };
  },

  computed: {},
  mounted: function mounted() {},
  created: function created() {
    var _this = this;

    console.log('linux---config');
    setTimeout(function () {
      _this.getTunelInfo(_this.connects.project_resource_id);
    }, 300);
  },

  methods: {
    onClose: function onClose() {
      this.connects = null;
      this.$emit('onClosePanel');
    },
    getTunelInfo: function getTunelInfo(id) {
      var _this2 = this;

      var params = {
        project_resource_id: id
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.GET_TUNNEL_INFO, params).then(function (res) {
        console.log('res', res);
        _this2.m = res;
        var extension = JSON.parse(res.project_resource.extension);
        if (res.os === 'linux') {
          if (extension && extension.login_username.length > 0) {
            _this2.m.usernameList = extension.login_username;
          } else {
            _this2.m.usernameList = [];
          }
        } else if (res.os === 'win32') {
          if (extension && extension.login_username.length > 0) {
            _this2.m.usernameList = extension.login_username;
          } else {
            _this2.m.usernameList = [];
          }
        }
        if (res.project_resource.default_username) {
          _this2.defaultUser = res.project_resource.default_username;
        } else {
          _this2.defaultUser = _this2.m.usernameList[0];
        }
      });
    },
    setDefaultUsername: function setDefaultUsername() {
      var _this3 = this;

      var params = {
        project_resource_id: this.connects.project_resource_id,
        data: {
          default_username: this.defaultUser
        }
      };
      this.submiting = true;
      console.log('default', params);
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.SET_PROJECT_DEFAULT_NAME, params).then(function (res) {
        console.log('res', res);
        _this3.submiting = false;
        _this3.$notify({
          type: 'success',
          message: _this3.$gettext('Save successfully!')
        });
        _this3.onClose();
      });
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this4 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this4.connects = _this4.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
        console.log('connects', this.connects);
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_right_panel__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LogReport',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null
    };
  },

  computed: {
    attrText: function attrText() {
      return this.initTranslateText();
    }
  },
  methods: {
    initTranslateText: function initTranslateText() {
      return {
        'resourceName': this.$gettext('Resource Name'),
        'command': this.$gettext('Command'),
        'member': this.$gettext('Member'),
        'resourceType': this.$gettext('Resource Type'),
        'time': this.$gettext('The Range Of Time'),
        'unlimited': this.$gettext('Unlimited'),
        'oneDay': this.$gettext('Within one day'),
        'oneMouth': this.$gettext('Within one mouth'),
        'sevenDay': this.$gettext('Within seven days')
      };
    },
    onCloseReport: function onCloseReport() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this.connects = _this.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_0__common_right_panel___default.a
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_moment_src_moment__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(19);








__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('allMember', {
	functional: true,
	render: function render(h, ctx) {
		var item = ctx.props.item;
		return h('li', ctx.data, [h('img', { attrs: { class: 'avatar', src: item.avatar ? '' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* baseUrl */] + item.avatar : '../../../static/images/avatar.png' } }), h('span', { attrs: { class: 'name' } }, [item.name])]);
	},
	props: {
		item: { type: Object, required: true }
	}
});

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('allResourceName', {
	functional: true,
	render: function render(h, ctx) {
		var item = ctx.props.item;
		return h('li', ctx.data, [h('div', { attrs: { class: 'name' } }, [item])]);
	},
	props: {
		item: { type: String, required: true }
	}
});
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'LogSearch',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null,
			tag: [],
			advanceSearchForm: {
				resourceType: '',
				keywords: '',
				member: '',
				ip: '',
				resourceName: '',
				timeType: '1',
				timeRange: 'unlimit',
				startTime: '',
				endTime: '',
				unSafeMode: false,
				allMember: [],
				allResourceName: []
			}
		};
	},

	computed: {
		attrText: function attrText() {
			return this.initTranslateText();
		}
	},
	created: function created() {
		this.getMemberName();
		this.getAllResourceName();
	},

	methods: {
		initTranslateText: function initTranslateText() {
			return {
				resourceName: this.$gettext('Resource Name'),
				command: this.$gettext('Command'),
				member: this.$gettext('Member'),
				resourceType: this.$gettext('Resource Type'),
				time: this.$gettext('The Range Of Time'),
				unlimited: this.$gettext('Unlimited'),
				oneDay: this.$gettext('Within one day'),
				oneMouth: this.$gettext('Within one mouth'),
				sevenDay: this.$gettext('Within seven days'),
				pleaseinput: this.$gettext('Please input'),
				startTime: this.$gettext('Start Time'),
				endTime: this.$gettext('End Time'),
				select: this.$gettext('select'),
				ip: this.$gettext('Source IP'),
				fileTransfer: this.$gettext('File Transfer')
			};
		},
		getMemberName: function getMemberName() {
			var _this = this;

			var params = {
				page_size: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].LOG.GET_ACCOUNT_NAME, params).then(function (res) {
				_this.advanceSearchForm.allMember = res.objects;
			});
		},
		getAllResourceName: function getAllResourceName() {
			var _this2 = this;

			var params = {
				results_per_page: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].LOG.GET_RESOURCE_NAME, params).then(function (res) {
				_this2.advanceSearchForm.allResourceName = res.data;
			});
		},
		memberSearch: function memberSearch(queryString, cb) {
			var allMember = this.advanceSearchForm.allMember;
			var results = queryString ? allMember.filter(this.memberFilter(queryString)) : allMember;

			cb(results);
		},
		memberFilter: function memberFilter(queryString) {
			return function (restaurant) {
				return restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
			};
		},
		resourceNameSearch: function resourceNameSearch(queryString, cb) {
			var allResourceName = this.advanceSearchForm.allResourceName;
			var results = queryString ? allResourceName.filter(this.createFilter(queryString)) : allResourceName;

			cb(results);
		},
		createFilter: function createFilter(queryString) {
			return function (restaurant) {
				return restaurant.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
			};
		},
		onSubmitSearch: function onSubmitSearch(form) {
			console.log(form, 'form');
			var options = {};
			if (form.resourceType !== '') {
				options.resourceType = form.resourceType;
			}
			if (form.keywords !== '') {
				options.keywords = form.keywords;
			}
			if (form.member !== '') {
				options.member = form.member;
			}
			if (form.ip !== '') {
				options.ip = form.ip;
			}
			if (form.resourceName !== '') {
				options.resourceName = form.resourceName;
			}
			if (form.unSafeMode) {
				options.unSafeMode = form.unSafeMode;
			}
			if (form.timeType === '1' && form.timeRange !== 'unlimit' || form.timeType === '2') {
				var now = new Date();
				if (form.timeType === '1') {
					if (form.timeRange === 'oneDay') {
						var oneDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_moment_src_moment__["a" /* default */])(now.getTime() - 24 * 3600 * 1000).format('YYYY-MM-DD');
						options.timeRange = [oneDay, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_moment_src_moment__["a" /* default */])().format('YYYY-MM-DD')];
					} else if (form.timeRange === 'sevenDay') {
						var sevenDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_moment_src_moment__["a" /* default */])(now.getTime() - 7 * 24 * 3600 * 1000).format('YYYY-MM-DD');
						options.timeRange = [sevenDay, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_moment_src_moment__["a" /* default */])().format('YYYY-MM-DD')];
					} else if (form.timeRange === 'oneMouth') {
						var oneMouth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_moment_src_moment__["a" /* default */])(now.getTime() - 30 * 24 * 3600 * 1000).format('YYYY-MM-DD');
						options.timeRange = [oneMouth, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_moment_src_moment__["a" /* default */])().format('YYYY-MM-DD')];
					}
				} else if (form.timeType === '2') {
					if (form.startTime !== '') {
						var startTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_moment_src_moment__["a" /* default */])(form.startTime.getTime()).format('YYYY-MM-DD');
						if (form.endTime !== '') {
							var endTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_moment_src_moment__["a" /* default */])(form.endTime.getTime()).format('YYYY-MM-DD');
							options.timeRange = [startTime, endTime];
						} else {
							options.timeRange = [startTime, ''];
						}
					} else {
						if (form.endTime !== '') {
							form.timeRange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__node_modules_moment_src_moment__["a" /* default */])(form.endTime.getTime()).format('YYYY-MM-DD');
						}
					}
				}
			}
			this.$emit('callback', options);
			this.$refs.rightPanel.onClose();
		},
		memberSelect: function memberSelect(item) {
			this.advanceSearchForm.member = item.name;
		},
		resourceSelect: function resourceSelect(item) {
			this.advanceSearchForm.resourceName = item;
		},
		onClose: function onClose() {
			this.connects = null;
			this.$emit('onClosePanel');
		},
		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
			this.advanceSearchForm.endTime = '';
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this3 = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this3.connects = _this3.items;
					}, 300);
				} else {
					this.connects = this.items;
				}
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
	}
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(10);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ManageCode',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null,
			m: null,
			canCreateStatus: false,
			currentAccountId: this.$store.getters.account.id,
			newTime: Math.ceil(new Date().getTime() / 1000),
			loading: true
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	mounted: function mounted() {},
	created: function created() {},

	methods: {
		getAllowIPList: function getAllowIPList(allowIP) {
			if (!allowIP) {
				return [];
			}
			var legacyIPv4ListPattern = /^(\d{1,3}\.){3}\d{1,3}(:(\d{1,3}\.){3}\d{1,3})+$/;
			var result = [];
			allowIP.split(';').forEach(function (section) {
				section = section.trim();
				if (legacyIPv4ListPattern.test(section)) {
					result = result.concat(section.split(':'));
				} else if (section) {
					result.push(section);
				}
			});
			return result;
		},
		getTranslateText: function getTranslateText() {
			return {
				member: this.$gettext('Member'),
				action: this.$gettext('Action'),
				allowIP: this.$gettext('Allow IP'),
				startEndTime: this.$gettext('Create Time / Expire Time'),
				temporary: this.$gettext('Temporary Authorize')
			};
		},
		onClose: function onClose() {
			this.$emit('onClosePanel');
			this.$emit('reloadTunnelCode', [this.connects.project_resource_id]);

			this.connects = null;
		},
		showCreateModal: function showCreateModal() {
			this.$emit('onShowModal', { name: 'showCreateModal' });
		},
		showTempModal: function showTempModal() {
			this.$emit('onShowModal', { name: 'showTempModal' });
		},
		canCreate: function canCreate() {
			var _this = this;

			this.canCreateStatus = true;
			this.m.forEach(function (item) {
				if (item.account.id === _this.currentAccountId && item.type !== 'tmp_share') {
					_this.canCreateStatus = false;
				}
			});
		},
		getTunelInfo: function getTunelInfo(id) {
			var _this2 = this;

			var params = {
				results_per_page: __WEBPACK_IMPORTED_MODULE_0__config__["g" /* Utils */].config.maxPageSize,
				q: {
					filters: [{
						name: 'project_resource_id',
						op: 'eq',
						val: id
					}, {
						name: 'status',
						op: 'eq',
						val: 'enable'
					}],
					order_by: [{
						field: 'create_time',
						direction: 'desc'
					}]
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.GET_TUNNEL_CODE, params).then(function (res) {
				_this2.loading = false;
				var data = res.objects;
				var list = [];
				if (data.length > 0) {
					data.forEach(function (item) {
						if (item.allow_ip) {
							item.allowIPList = _this2.getAllowIPList(item.allow_ip);
						}
						list.push(item);
					});
				}
				_this2.m = list;
				_this2.canCreate();
			}, function () {
				_this2.loading = false;
			});
		},
		modifyCode: function modifyCode(row) {
			this.$emit('onShowModal', { name: 'modifyCreateModal', code: row.code });
		},
		deleteCode: function deleteCode(row) {
			var _this3 = this;

			row.saving = true;
			this.$confirm(this.$gettext('Are you sure to delete code ') + '  ' + this.hideStr(row.code) + '?', this.$gettext('Delete code confirm'), {
				confirmButtonText: this.$gettext('OK'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function (event) {
				_this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.DELETE_CODE, row.code).then(function (res) {
					_this3.m.remove(row);
					_this3.$notify({
						type: 'success',
						message: _this3.$gettext('Delete successfully')
					});
				});
			});
		},
		hideStr: function hideStr(str) {
			return __WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.hideStr(str);
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this4 = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this4.connects = _this4.items;
						_this4.getTunelInfo(_this4.connects.project_resource_id);
					}, 300);
				} else {
					this.connects = this.items;
					this.getTunelInfo(this.connects.project_resource_id);
				}
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
	}
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'mySqlView',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			isShow: false,
			mySqlDetailObj: null,
			type: '',
			sqlApplyStatusText: {
				approving: this.$gettext('approving'),
				approve_wait_result: this.$gettext('approved'),
				rejected: this.$gettext('rejected'),
				approved: this.$gettext('success'),
				failed: this.$gettext('failed')
			}
		};
	},

	methods: {
		onClose: function onClose() {
			this.mySqlDetailObj = null;
			this.$emit('onClosePanel');
		},
		previewSQL: function previewSQL() {
			this.$emit('onShowModal', { name: 'previewSQL', data: this.mySqlDetailObj });
		},
		copySuccess: function copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success'
			});
		},
		cancelSqlApply: function cancelSqlApply(id) {
			var _this = this;

			this.$confirm(this.$gettext('Are you sure to delete current application?'), this.$gettext('Delete SQL application confirm'), {
				confirmButtonText: this.$gettext('OK'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				_this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts_js__["a" /* default */].REVIEW.DELETE_SQL_APPLY, id).then(function (res) {
					_this.$notify({
						type: 'success',
						message: _this.$gettext('Cancel successfully!')
					});
					_this.$emit('viewCallback');
					_this.$emit('onClosePanel');
				});
			});
		},
		doExecute: function doExecute(id) {
			var _this2 = this;

			var params = {
				application_id: id
			};
			this.$confirm(this.$gettext('Are you sure to execute current SQL?'), this.$gettext('Execute SQL application confirm'), {
				confirmButtonText: this.$gettext('OK'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts_js__["a" /* default */].REVIEW.EXECUTE_SQL_APPLICATION, params).then(function (res) {
					_this2.$notify({
						type: 'success',
						message: _this2.$gettext('Submit success, you can check result later.')
					});
					_this2.$emit('viewCallback');
					_this2.$emit('onClosePanel');
				});
			});
		},
		doReject: function doReject(id) {
			var _this3 = this;

			console.log('doreject');
			this.$confirm(this.$gettext('Are you sure to reject current application?'), this.$gettext('Reject SQL application confirm'), {
				confirmButtonText: this.$gettext('OK'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				_this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts_js__["a" /* default */].REVIEW.REJECT_SQL_APPLICATION, id).then(function (res) {
					_this3.$emit('viewCallback');
					_this3.$emit('onClosePanel');
				});
			});
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this4 = this;

				console.log('newVal', newVal);
				if (this.mySqlDetailObj) {
					this.mySqlDetailObj = null;
					setTimeout(function () {
						console.log('items', _this4.items);
						_this4.mySqlDetailObj = _this4.items;
						_this4.isHideFooter = newVal.isHideFooter;
					}, 300);
				} else {
					this.mySqlDetailObj = this.items;
					this.isHideFooter = newVal.isHideFooter;
				}
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
	}
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'safeView',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      safeObj: null,
      type: '',
      isHideFooter: false,
      cancelLoading: false,
      passLoading: false,
      rejectLoading: false,
      safeApplyStatusText: {
        0: this.$gettext('approving'),
        1: this.$gettext('approved'),
        2: this.$gettext('rejected'),
        3: this.$gettext('failed')
      }
    };
  },

  methods: {
    onClose: function onClose() {
      this.safeObj = null;
      this.$emit('onClosePanel');
    },
    cancelSafeApply: function cancelSafeApply(id) {
      var _this = this;

      this.cancelLoading = true;
      this.$confirm(this.$gettext('Are you sure you want to cancel non-security mode application?'), this.$gettext('Please confirm?'), {
        confirmButtonText: this.$gettext('OK'),
        cancelButtonText: this.$gettext('Cancel'),
        type: 'warning'
      }).then(function () {
        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts_js__["a" /* default */].REVIEW.DELETE_SAFE_APPLY, id).then(function (res) {
          _this.cancelLoading = false;
          _this.$notify({
            type: 'success',
            message: _this.$gettext('Cancel successfully!')
          });
          _this.$emit('viewCallback');
          _this.$emit('onClosePanel');
        }, function () {
          _this.cancelLoading = false;
        });
      });
    },
    doExecute: function doExecute(id) {
      var _this2 = this;

      this.passLoading = true;
      this.$confirm(this.$gettext('Through current non-security mode application?'), this.$gettext('Through non-security mode application'), {
        confirmButtonText: this.$gettext('OK'),
        cancelButtonText: this.$gettext('Cancel'),
        type: 'warning'
      }).then(function () {
        _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts_js__["a" /* default */].REVIEW.DO_SAFE_EXCUTE, id).then(function (res) {
          _this2.passLoading = false;
          _this2.$notify({
            type: 'success',
            message: _this2.$gettext('Submit success, you can check result later.')
          });
          _this2.$emit('viewCallback');
          _this2.$emit('onClosePanel');
        }, function () {
          _this2.passLoading = false;
        });
      });
    },
    doReject: function doReject(id) {
      var _this3 = this;

      console.log('doreject');
      this.rejectLoading = true;
      this.$confirm(this.$gettext('Reject the current non-security mode application?'), this.$gettext('Reject non-safe mode application'), {
        confirmButtonText: this.$gettext('OK'),
        cancelButtonText: this.$gettext('Cancel'),
        type: 'warning'
      }).then(function () {
        _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts_js__["a" /* default */].REVIEW.DO_SAFE_REJECT, id).then(function (res) {
          _this3.rejectLoading = false;
          _this3.$emit('viewCallback');
          _this3.$emit('onClosePanel');
        }, function () {
          _this3.rejectLoading = false;
        });
      });
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this4 = this;

        console.log('newVal', newVal);
        if (this.safeObj) {
          this.safeObj = null;
          setTimeout(function () {
            console.log('items', _this4.items);
            _this4.safeObj = _this4.items;
            _this4.isHideFooter = newVal.isHideFooter;
          }, 300);
        } else {
          this.safeObj = this.items;
          this.isHideFooter = newVal.isHideFooter;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    done: {
      type: Function,
      default: function _default() {}
    },
    loading: {
      type: Function,
      default: function _default() {}
    }
  },
  methods: {
    onClick: function onClick() {
      document.getElementById('file').click();
    },
    onChange: function onChange(e) {
      var _this = this;

      var files = e.target.files;

      var allFiles = [];

      var _loop = function _loop(i) {
        var file = files[i];
        var reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = function () {
          var fileInfo = {
            name: file.name,
            type: file.type,
            size: Math.round(file.size),
            base64: reader.result,
            file: file
          };
          allFiles.push(fileInfo);

          if (allFiles.length === files.length) {
            if (_this.multiple) _this.done(allFiles);else _this.done(allFiles[0]);
          }
          e.target.value = '';
        };
        reader.onprogress = function (e) {
          if (e.lengthComputable) {
            var percentComplete = e.loaded / e.total;
            _this.loading(true);
            console.log('process', percentComplete);
          } else {
            console.log('total size is unknown');
          }
        };
      };

      for (var i = 0; i < files.length; i++) {
        _loop(i);
      }
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'WorkgroupApply',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			verifySuccess: false,
			verifyLoading: false,
			verifyLog: '',
			applyObj: {},
			applyForm: {
				sql: '',
				comment: '',
				reason: '',
				time: '',
				database: '',
				btnDisabled: false
			},
			applyRules: {
				sql: [{ required: true, message: this.$gettext('Please input sql'), trigger: 'blur' }],
				comment: [{ required: true, message: this.$gettext('Please input comment'), trigger: 'blur' }],
				reason: [{ required: true, message: this.$gettext('Please input applicate reason'), trigger: 'blur' }],
				time: [{ required: true, type: 'date', message: this.$gettext('Please select date'), trigger: 'blur' }],
				database: [{ required: true, message: this.$gettext('Please input target database'), trigger: 'blur' }]
			},
			safeOptions: {
				disabledDate: function disabledDate(time) {
					return time.getTime() < Date.now();
				}
			}
		};
	},

	computed: {
		attrText: function attrText() {
			return this.initAttrText();
		}
	},
	methods: {
		onClose: function onClose() {
			this.applyObj = null;
			this.$emit('onClosePanel');
			this.resetFrom();
		},
		resetFrom: function resetFrom() {
			if (this.$refs['applyForm'] !== undefined) {
				this.$refs['applyForm'].resetFields();
			}
		},
		sqlChange: function sqlChange() {
			this.verifySuccess = false;
			this.verifyLog = '';
		},
		onVerify: function onVerify() {
			var _this = this;

			if (this.applyObj.applyType === 'ecs') return;

			this.verifyLoading = true;
			var params = {
				sql: this.applyForm.sql,
				type: this.items.type
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.VERIFY_SQL, params).then(function (res) {
				console.log(res, 'res');
				if (res.success) {
					_this.verifySuccess = true;
					_this.$notify({
						message: _this.$gettext('Check success!'),
						type: 'success'
					});
				} else {
					_this.verifySuccess = false;
					_this.verifyLog = res.message;
					_this.$notify({
						message: _this.$gettext('Check failed!'),
						type: 'error'
					});
				}
				_this.verifyLoading = false;
			});
		},
		onSubmit: function onSubmit() {
			var _this2 = this;

			this.$refs['applyForm'].validate(function (valid) {
				if (valid) {
					var params = void 0;
					console.log(_this2.applyObj.applyType, 'this.applyObj.applyType');
					if (_this2.applyObj.applyType === 'ecs') {
						params = {
							project_id: +_this2.$route.params.id,
							project_resource_id: _this2.applyObj.project_resource_id,
							reason: _this2.applyForm.reason,
							expire_time: Date.parse(_this2.applyForm.time) / 1000
						};
						_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].REVIEW.CREATE_SAFE_APPLY, params).then(function (res) {
							_this2.applyForm.btnDisabled = true;
							_this2.$notify({
								type: 'success',
								message: _this2.$gettext('Create successfully!')
							});
							_this2.onClose();
						}, function () {
							_this2.applyForm.btnDisabled = false;
						});
					} else {
						params = {
							project_resource_id: _this2.applyObj.project_resource_id,
							sql: _this2.applyForm.sql,
							database: _this2.applyForm.database,
							comment: _this2.applyForm.comment
						};
						_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].REVIEW.CREATE_SQL_APPLICATION, params).then(function (res) {
							_this2.applyForm.btnDisabled = true;
							_this2.$notify({
								type: 'success',
								message: _this2.$gettext('Create successfully!')
							});
							_this2.onClose();
						}, function () {
							_this2.applyForm.btnDisabled = false;
						});
					}
					console.log('params', params);
				}
			});
		},
		initAttrText: function initAttrText() {
			return {
				sql: this.$gettext('SQL Application'),
				safeMode: this.$gettext('Security Mode'),
				project: this.$gettext('Workgroup'),
				resource: this.$gettext('Resource'),
				comment: this.$gettext('Comment'),
				resourceName: this.$gettext('Resource Name'),
				reason: this.$gettext('The Reasons For The Application'),
				validTime: this.$gettext('Valid Time'),
				startApplication: this.$gettext('Start Application'),
				select: this.$gettext('select'),
				myApplication: this.$gettext('My Application'),
				general: this.$gettext('General'),
				createTime: this.$gettext('Created Time'),
				applyer: this.$gettext('Applyer'),
				pendingApplication: this.$gettext('Pending Application'),
				myApproved: this.$gettext('My Approved'),
				status: this.$gettext('Status'),
				updateTime: this.$gettext('Update Time'),
				selectDate: this.$gettext('Please Select Date'),
				effectiveTime: this.$gettext('Valid Time'),
				targetDatabase: this.$gettext('Target Database')
			};
		},
		previewSQL: function previewSQL() {
			this.$emit('onShowModal', { name: 'previewSQL', data: this.applyForm });
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_0__common_right_panel___default.a
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this3 = this;

				if (this.applyObj) {
					this.applyObj = {};
					setTimeout(function () {
						console.log('items', _this3.items);
						_this3.applyObj = _this3.items;
						_this3.applyForm.database = _this3.items.db_name[0] === '*' ? '' : _this3.items.db_name[0];
						_this3.applyForm.sql = _this3.items.sql;
						_this3.isHideFooter = _this3.items.isHideFooter;
					}, 300);
				} else {
					console.log('items', this.items);
					this.applyObj = this.items;
					this.applyForm.database = this.items.db_name[0] === '*' ? '' : this.items.db_name[0];
					this.applyForm.sql = this.items.sql;
					this.isHideFooter = this.items.isHideFooter;
				}
			},
			deep: true
		}
	}
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_base64__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_base64__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkGroupAssist',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null,
      loading: true,
      isLoad: false,
      firstConnectInfo: {
        userName: '',
        code: '',
        agentVersion: ''
      },
      connectionInfo: {
        path: '/wetty/ssh',
        code: '',
        host: '',
        port: '',
        username: '',
        defaultName: 'root',
        linkUser: ''
      },
      shadowConnect: {
        agent_host: '',
        agent_webtty_port: '',
        code: ''
      },
      time: 0,
      assistInfo: null,
      initLoading: true
    };
  },
  created: function created() {},

  computed: {
    attrText: function attrText() {
      return this.initAttrText();
    },
    sshCommand: function sshCommand() {
      return 'ssh' + ' ' + this.connectionInfo.code + '_' + this.connectionInfo.defaultName + '@' + this.connectionInfo.host + ' -p ' + this.connectionInfo.port;
    },
    sshLink: function sshLink() {
      if (window.navigator.userAgent.indexOf('Macintosh') > -1) {
        return 'ssh://' + this.connectionInfo.code + '_' + this.connectionInfo.defaultName + '@' + this.connectionInfo.host + ':' + this.connectionInfo.port;
      } else {
        return 'ssh2://' + this.connectionInfo.code + '_' + this.connectionInfo.defaultName + '@' + this.connectionInfo.host + ':' + this.connectionInfo.port;
      }
    },
    assistLink: function assistLink() {
      var agentVersionFirst = parseInt(this.firstConnectInfo.agentVersion.split('.')[0]);
      console.log('agentVersionFirst', agentVersionFirst);

      if (!isNaN(agentVersionFirst) && agentVersionFirst > 1) {
        if (agentVersionFirst >= 3) {
          return 'http://' + this.shadowConnect.agent_host + ':' + this.shadowConnect.agent_webtty_port + '/?code=' + __WEBPACK_IMPORTED_MODULE_5_js_base64___default.a.Base64.encode(this.shadowConnect.code) + '&user=' + this.connectionInfo.defaultName;
        } else {
          return 'http://' + this.shadowConnect.agent_host + ':' + this.shadowConnect.agent_webtty_port + '/?code=' + this.shadowConnect.code + '&user=' + this.connectionInfo.defaultName;
        }
      } else {
        return 'http://' + this.shadowConnect.agent_host + ':' + this.shadowConnect.agent_webtty_port + this.connectionInfo.path + '/' + this.shadowConnect.code + '/' + this.connectionInfo.defaultName;
      }
    }
  },
  methods: {
    initAttrText: function initAttrText() {
      return {
        manualAssist: this.$gettext('Manual assistance'),
        operationAssist: this.$gettext('Operation assistant')
      };
    },
    copySuccess: function copySuccess(e) {
      this.$notify({
        message: this.$gettext('Copy successfully!'),
        type: 'success'
      });
    },
    getShadowConnect: function getShadowConnect(key, version) {
      var _this = this;

      var params = {
        master_connection_id: key,
        readonly: false,
        expire_time: Math.floor(new Date().getTime() / 1000) + 30 * 60
      };
      if (version && version >= '3.0.0') {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_CSOS_SHADOW, params).then(function (res) {
          _this.shadowConnect.agent_host = res.agent_host;
          _this.shadowConnect.agent_webtty_port = res.agent_webtty_port;
          _this.shadowConnect.code = res.code;
          _this.loading = false;
          _this.assistInfo = {
            url: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* baseUrl */].h5Url + '#/assistant/list?from=cloudcare&id=' + key + '&fromCsos=true&bgColor=white&code=' + __WEBPACK_IMPORTED_MODULE_5_js_base64___default.a.Base64.encode(res.code) + '&agent_host=' + res.agent_host + '&agent_port=' + res.agent_webtty_port
          };
        });
      } else {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_SHADOW_CONNECT, params).then(function (res) {
          _this.shadowConnect.agent_host = res.agent_host;
          _this.shadowConnect.agent_webtty_port = res.agent_webtty_port;
          _this.shadowConnect.code = res.code;
          _this.loading = false;
          _this.assistInfo = {
            url: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* baseUrl */].h5Url + '#/assistant/list?from=cloudcare&id=' + key + '&fromCsos=true&bgColor=white&code=' + __WEBPACK_IMPORTED_MODULE_5_js_base64___default.a.Base64.encode(res.code) + '&agent_host=' + res.agent_host + '&agent_port=' + res.agent_webtty_port
          };
        });
      }
    },
    getAssistInfo: function getAssistInfo(newCode, version) {
      var _this2 = this;

      this.loading = true;
      this.time++;
      var params = {
        code: newCode
      };
      if (version && version >= '3.0.0') {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.QUERY_CSOS_CONNECT, params).then(function (res) {
          if (res.connections.length < 1) {
            if (_this2.time < 60) {
              setTimeout(function () {
                _this2.getAssistInfo(newCode, version);
              }, 1000);
            } else {
              _this2.time = 0;
              _this2.loading = false;
            }
          } else {
            _this2.time = 0;
            var connectObj = res.connections[0];

            _this2.getShadowConnect(connectObj.connection_id, version);
          }
        });
      } else {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_ASSIST_INFO, params).then(function (res) {
          if (Object.isEmpty(res)) {
            if (_this2.time < 60) {
              setTimeout(function () {
                _this2.getAssistInfo(newCode);
              }, 1000);
            } else {
              _this2.time = 0;
              _this2.loading = false;
            }
          } else {
            _this2.time = 0;
            _this2.loading = false;
            var keys = [];
            for (var key in res) {
              keys.push(key);
            }
            _this2.getShadowConnect(keys[0]);
          }
        });
      }
    },
    getConnectLog: function getConnectLog(id, version) {
      var _this3 = this;

      var agentVersion = __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* default */].Utils.getAgentVersion(version);
      this.firstConnectInfo.agentVersion = agentVersion;
      console.log('agentVersion', agentVersion);
      if (agentVersion >= '3.0.0') {
        var params = {
          project_resource_id: id,
          tmpAssist: true
        };
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_TUNNEL_INFO, params).then(function (res) {
          _this3.initLoading = false;
          _this3.firstConnectInfo.code = res.code;
          _this3.getAssistInfo(_this3.firstConnectInfo.code, agentVersion);
          if (!_this3.isLoad) {
            var usernameList = JSON.parse(res.resource.extension).username;
            if (res.project_resource.default_username) {
              _this3.firstConnectInfo.username = res.project_resource.default_username;
            } else {
              _this3.firstConnectInfo.username = usernameList[0];
            }
            _this3.connectionInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this3.connectionInfo, {
              code: res.code,
              host: res.agent.host,
              port: res.agent.ssh_port,
              defaultName: _this3.firstConnectInfo.username,
              webPort: res.agent.web_port,
              username: res.code + '_' + _this3.firstConnectInfo.username
            });
            _this3.isLoad = true;
            _this3.assistLink = '';
          }
        }, function () {
          _this3.initLoading = false;
        });
      } else {
        var _params = {
          project_resource_id: id
        };

        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_TUNNEL_INFO, _params).then(function (res) {
          _this3.firstConnectInfo.agentVersion = res.agent.version;
          _this3.firstConnectInfo.code = res.code;
          var usernameList = JSON.parse(res.resource.extension).username;
          if (res.project_resource.default_username) {
            _this3.firstConnectInfo.username = res.project_resource.default_username;
          } else {
            _this3.firstConnectInfo.username = usernameList[0];
          }

          var params = {
            host: res.agent.host,
            ssh_port: res.agent.ssh_port,
            user: res.code + '_' + _this3.firstConnectInfo.username
          };
          _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_LITE_CONNECT_INFO, params).then(function (connect) {
            _this3.getAssistInfo(connect.code);
            if (!_this3.isLoad) {
              _this3.connectionInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this3.connectionInfo, {
                code: connect.code,
                host: connect.agent_host,
                port: connect.agent_ssh_port,
                defaultName: connect.user,
                webPort: connect.agent_webtty_port,
                username: connect.code + '_' + connect.user
              });
              _this3.isLoad = true;
            }
          });
        });
      }
    },
    connectHost: function connectHost() {
      var _link = 'http://' + this.connectionInfo.host + ':' + this.connectionInfo.webPort + this.connectionInfo.path + '/' + this.connectionInfo.code + '/' + this.connectionInfo.defaultName;
      var agentVersionFirst = parseInt(this.firstConnectInfo.agentVersion.split('.')[0]);

      if (!isNaN(agentVersionFirst) && agentVersionFirst > 1) {
        if (agentVersionFirst >= 3) {
          _link = 'http://' + this.connectionInfo.host + ':' + this.connectionInfo.webPort + '/?code=' + __WEBPACK_IMPORTED_MODULE_5_js_base64___default.a.Base64.encode(this.connectionInfo.code) + '&user=' + this.connectionInfo.defaultName;
        } else {
          _link = 'http://' + this.connectionInfo.host + ':' + this.connectionInfo.webPort + '/?code=' + this.connectionInfo.code + '&user=' + this.connectionInfo.defaultName;
        }
      }
      window.open(_link);
    },
    onClose: function onClose() {
      this.$emit('onClosePanel');
      this.connects = null;
      this.time = 60;
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this4 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this4.connects = _this4.items;
            _this4.getConnectLog(_this4.connects.projectResourceId, _this4.connects.agentVersion);
          }, 300);
        } else {
          this.connects = this.items;
          this.getConnectLog(this.connects.projectResourceId, this.connects.agentVersion);
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(10);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'WorkGroupConnectLogs',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null,
			logs: null,
			data: [],
			count: 0,
			busy: false,
			loading: true
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	mounted: function mounted() {},
	created: function created() {},

	methods: {
		getTranslateText: function getTranslateText() {
			return {
				unsafeMode: this.$gettext('Unsafe Mode')
			};
		},
		onShowAll: function onShowAll() {
			console.log('this.connects==>', this.connects);
			this.$router.push({ name: 'logs', query: { resourceName: this.connects.id + ':' + this.connects.name } });
		},
		onClose: function onClose() {
			this.connects = null;
			this.$emit('onClosePanel');
		},
		getConnectLog: function getConnectLog(page, id) {
			var _this = this;

			var params = {
				page_index: page || 1,
				page_size: 10,
				resource_id: id
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.GET_CONNECT_LOG, params).then(function (res) {
				console.log('connect-->log', res);
				console.log('language', _this.$language.current);
				res.data.forEach(function (item) {
					var _playbackLink = 'playlog.html';
					var _downloadLink = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* baseUrl */].apiUrl + '/download_tunnel_log';
					_playbackLink += '#?link=' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* baseUrl */].apiUrl;
					_playbackLink += '&way=' + item.way;
					_playbackLink += '&code=' + item.code;
					_playbackLink += '&resource_id=' + item.resource_id;
					_playbackLink += '&account_name=' + item.account_name;
					_playbackLink += '&avatar=' + item.avatar;
					_playbackLink += '&account_id=' + item.account_id;
					_playbackLink += '&start_time=' + item.start_date;
					_playbackLink += '&date=' + item.date;
					_downloadLink += '?way=' + item.way;
					_downloadLink += '&code=' + item.code;
					_downloadLink += '&start_time=' + item.start_date;
					if (item.guacamole) {
						_playbackLink += '&guacamole=' + item.guacamole;
						if (item.rdp_width && item.rdp_height) {
							_playbackLink += '&rdp_width=' + item.rdp_width;
							_playbackLink += '&rdp_height=' + item.rdp_height;
						}
					}
					if (item.connection_id) {
						_playbackLink += '&connection_id=' + item.connection_id;
						_downloadLink += '&connection_id=' + item.connection_id;
					}
					if (item.agent_version) {
						_playbackLink += '&version=' + __WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.getAgentVersion(item.agent_version);
					}
					_playbackLink += '&lang=' + _this.$language.current;
					_playbackLink += '&type=playlog';
					item.playbackLink = _playbackLink;
					item.downloadLink = _downloadLink;
					if (item.date - item.start_date > 0) {
						var ff = item.date - item.start_date;
						var h = Math.floor(ff / 3600);
						var m = Math.floor(ff % 3600 / 60);
						var s = ff % 60;
						if (h < 10) {
							h = '0' + h;
						}
						if (m < 10) {
							m = '0' + m;
						}
						if (s < 10) {
							s = '0' + s;
						}
						item.totalTime = h + ':' + m + ':' + s;
						console.log(item.totalTime);
					} else {
						item.totalTime = '00:00:00';
					}
				});
				_this.logs = res.data;
				console.log('logs', _this.logs, __WEBPACK_IMPORTED_MODULE_2__config__["a" /* baseUrl */]);
			}, function () {
				_this.logs = [];
			});
		},
		loadMore: function loadMore() {
			this.busy = true;
			console.log('load more');
			this.busy = false;
		},
		viewLog: function viewLog(row) {
			console.log('=== 子组件 viewLog 被调用 ===');
			console.log('row data:', row);

			this.$emit('onViewLog', row);
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this2 = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this2.connects = _this2.items;
						_this2.getConnectLog(1, _this2.connects.id);
					}, 300);
				} else {
					this.connects = this.items;
					this.getConnectLog(1, this.connects.id);
				}
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
	}
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_base64__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(10);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'WorkGroupConnection',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null,
			m: null,
			defaultUser: '',
			userName: '',
			codeStr: '',
			ssh_link: '',
			connectData: {},
			safeMode: null,
			safeConnect: 'safe_connect',
			unSafeConnect: 'unSafe_connect',
			loading: true,
			agentUpdateTip: false
		};
	},

	computed: {},
	mounted: function mounted() {},
	created: function created() {},

	methods: {
		getAllowIPList: function getAllowIPList(allowIP) {
			if (!allowIP) {
				return [];
			}
			var legacyIPv4ListPattern = /^(\d{1,3}\.){3}\d{1,3}(:(\d{1,3}\.){3}\d{1,3})+$/;
			var result = [];
			allowIP.split(';').forEach(function (section) {
				section = section.trim();
				if (legacyIPv4ListPattern.test(section)) {
					result = result.concat(section.split(':'));
				} else if (section) {
					result.push(section);
				}
			});
			return result;
		},
		modifyCode: function modifyCode() {
			this.$emit('onShowModal', { name: 'modifyCreateModal', code: this.m.code });
		},
		getTunelInfo: function getTunelInfo(id) {
			this.getConnectLog(id);
		},
		getNewAgentVersion: function getNewAgentVersion(projectResourceId) {
			var _this = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].CLUSTER.CHECK_AGENT).then(function (res) {
				_this.newAgentVersion = res.version;
				_this.loading = false;
				console.log('--version--', _this.m, _this.m.agent.version, '--newAgentVersion--', _this.newAgentVersion);
				if (_this.m && _this.m.agent && _this.m.agent.version && res.version) {
					if (__WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.isNeedUpdate(_this.m.agent.version, res.version)) {
						_this.agentUpdateTip = true;
					} else {
						_this.agentUpdateTip = false;
					}
				}
			}, function () {
				_this.loading = false;
			});
		},
		onClose: function onClose() {
			this.$emit('onClosePanel');

			this.$emit('reloadPojectResource');
			this.connects = null;
		},
		copySuccess: function copySuccess(e) {
			console.log('e', e);
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success'
			});
		},
		startApply: function startApply() {
			this.$emit('startApplyEvent', this.connects.row);
		},
		switchSafeMode: function switchSafeMode() {
			var _this2 = this;

			console.log('change safeMode', this.safeMode);
			var obj = {};
			if (this.safeMode) {
				obj = {
					code: this.m.code,
					safe_mode: 0
				};
			} else {
				obj = {
					code: this.m.code,
					safe_mode: 1
				};
			}
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.UPDATE_TUNNEL, obj).then(function (res) {
				_this2.safeMode = res.safe_mode;
				_this2.$set(_this2.m, 'safe_mode', res.safe_mode);
			});
		},
		changeUser: function changeUser() {
			var _this3 = this;

			if (this.m.os == 'linux') {
				this.m.selectUserData = this.m.usernameDataList.find(function (i) {
					return i.username == _this3.defaultUser;
				});
			}
			this.userName = this.m.code + '_' + this.defaultUser;
			this.codeStr = 'ssh' + ' ' + this.connectData.code + '_' + this.defaultUser + '@' + this.connectData.host + ' -p ' + this.connectData.sshPort;
			if (window.navigator.userAgent.indexOf('Macintosh') > -1) {
				this.ssh_link = 'ssh://' + this.connectData.code + '_' + this.defaultUser + '@' + this.connectData.host + ':' + this.connectData.sshPort;
			} else {
				this.ssh_link = 'ssh2://' + this.connectData.code + '_' + this.defaultUser + '@' + this.connectData.host + ':' + this.connectData.sshPort;
			}
		},
		getConnectLog: function getConnectLog(id) {
			var _this4 = this;

			var params = {
				project_resource_id: id
			};
			if (this.$store.getters.team.setting.code_ip_whitelist === false || this.$store.getters.team.setting.code_ip_whitelist === 0) {
				this.loadConnectInfo(params);
				return;
			}
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.GET_CLIENT_IP).then(function (data) {
				params.allow_ip = data.client_ip;
				_this4.loadConnectInfo(params);
			}, function () {
				_this4.loading = false;
			});
		},
		loadConnectInfo: function loadConnectInfo(params) {
			var _this5 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.GET_TUNNEL_INFO, params).then(function (res) {
				_this5.m = Object.clone(res);
				_this5.loading = false;
				_this5.getNewAgentVersion();
				_this5.connectData = {
					code: res.code,
					host: res.agent.host,
					version: __WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.getAgentVersion(res.agent.version),
					sshPort: res.agent.ssh_port
				};
				_this5.safeMode = res.safe_mode;
				_this5.m.winHost = res.agent.host;
				var extension = res.project_resource.extension ? JSON.parse(res.project_resource.extension) : { login_username: '' };
				var resourceExtension = res.resource.extension ? JSON.parse(res.resource.extension) : {};
				if (res.os === 'linux') {
					_this5.connectData.path = '/wetty/ssh';
					_this5.connectData.webPort = res.agent.web_port;
					if (extension && extension.login_username) {
						_this5.m.usernameList = extension.login_username;
					} else {
						_this5.m.usernameList = [];
					}
					if (extension && extension.data) {
						_this5.m.usernameDataList = extension.data;
						_this5.m.selectUserData = _this5.m.usernameDataList.find(function (i) {
							return i.username == _this5.m.usernameList[0];
						});
					} else {
						_this5.m.usernameDataList = [];
					}
				} else if (res.os === 'win32') {
					_this5.connectData.webrdp_port = res.agent.webrdp_port;
					_this5.connectData.allow_copy_paste = res.project_resource.extension ? JSON.parse(res.resource.extension).allow_copy_paste : false;
					if (extension && extension.login_username) {
						_this5.m.usernameList = extension.login_username;
					} else {
						_this5.m.usernameList = [];
					}
				} else if (res.os === 'mysql') {
					_this5.m.sqlHost = _this5.connectData.host;
					_this5.m.sqlport = res.agent.mysql_port;
				} else if (res.os === 'mssql') {
					_this5.m.sqlHost = _this5.connectData.host;
					_this5.m.sqlport = res.agent.mssql_port;
				} else if (res.os === 'postgresql') {
					_this5.m.sqlHost = _this5.connectData.host;
					_this5.m.sqlport = res.agent.postgresql_port;
				} else if (res.os === 'oracle') {
					_this5.m.sqlHost = _this5.connectData.host;
					_this5.m.sqlport = res.agent.oracle_port || 9521;
					_this5.m.serviceNameType = resourceExtension.service_name_type || 'service_name';
					_this5.m.serviceName = resourceExtension.service_name || '';
				}
				if (res.os === 'win32' || res.os === 'linux') {
					if (res.project_resource.default_username) {
						_this5.defaultUser = _this5.connectData.username = res.project_resource.default_username;
					} else {
						_this5.defaultUser = _this5.connectData.username = _this5.m.usernameList[0];
					}
					if (window.navigator.userAgent.indexOf('Macintosh') > -1) {
						_this5.ssh_link = 'ssh://' + _this5.connectData.code + '_' + _this5.connectData.username + '@' + _this5.connectData.host + ':' + _this5.connectData.sshPort;
					} else {
						_this5.ssh_link = 'ssh2://' + _this5.connectData.code + '_' + _this5.connectData.username + '@' + _this5.connectData.host + ':' + _this5.connectData.sshPort;
					}
					_this5.userName = _this5.m.code + '_' + _this5.defaultUser;
					_this5.codeStr = 'ssh' + ' ' + _this5.connectData.code + '_' + _this5.defaultUser + '@' + _this5.connectData.host + ' -p ' + _this5.connectData.sshPort;
				}
			}, function () {
				_this5.loading = false;
			});
		},
		connectHost: function connectHost() {
			console.log('this.connectData', this.connectData);
			console.log(this.$store.getters.team, 'this.$store.getters.team');
			console.log(this.$store.getters.account, 'this.$store.getters.team');

			var _link = 'http://' + this.connectData.host + ':' + this.connectData.webPort + this.connectData.path + '/' + __WEBPACK_IMPORTED_MODULE_2_js_base64___default.a.Base64.encode(this.connectData.code) + '/' + this.defaultUser;
			var agentVersionFirst = parseInt(this.connectData.version.split('.')[0]);
			console.log(agentVersionFirst, 'agentVersionFirst');

			if (!isNaN(agentVersionFirst) && agentVersionFirst > 1) {
				if (__WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.getAgentVersion(this.connectData.version) <= '3.1.25') {
					_link = 'http://' + this.connectData.host + ':' + this.connectData.webPort + '/?code=' + __WEBPACK_IMPORTED_MODULE_2_js_base64___default.a.Base64.encode(this.connectData.code) + '&user=' + this.defaultUser + '&team_name=' + this.$store.getters.team.setting.full_name + '&account_name=' + this.$store.getters.account.name;
				} else {
					_link = 'http://' + this.connectData.host + ':' + this.connectData.webPort + '/?user=' + this.defaultUser + '&conn_security=' + this.m.conn_security;
				}
			}
			console.log(_link);
			window.open(_link);
		},
		connectWinHost: function connectWinHost() {
			console.log(' this.connectData windows', this.connectData);
			var version = this.connectData.version;
			var _link = '';
			if (__WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.getAgentVersion(version) <= '3.1.25') {
				_link = 'http://' + this.connectData.host + ':' + this.connectData.webrdp_port + '/?allowCopyPaste=' + this.connectData.allow_copy_paste + '&code=' + __WEBPACK_IMPORTED_MODULE_2_js_base64___default.a.Base64.encode(this.connectData.code) + '&user=' + this.defaultUser + '&team_name=' + this.$store.getters.team.setting.full_name + '&account_name=' + this.$store.getters.account.name + '&ip=' + this.connects.row.ip + '&resourceName=' + this.connects.resourceName + '&resourceId=' + this.connects.row.id + '&redirect_url=' + window.location.href.split('#')[0];
			} else {
				_link = 'http://' + this.connectData.host + ':' + this.connectData.webrdp_port + '/?user=' + this.defaultUser + '&redirect_url=' + window.location.href.split('#')[0] + '&conn_security=' + this.m.conn_security;
			}
			console.log('_win link', _link);
			window.open(_link);
		},
		sqlConnect: function sqlConnect() {
			console.log(location, 'location');
			console.log(this.m, 'm');
			console.log(this.connects, 'connects');
			console.log('数据库连接');

			window.open(location.origin + '/webSQL/?conn_security=' + this.m.conn_security, '_blank');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this6 = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this6.connects = _this6.items;
						_this6.getConnectLog(_this6.connects.projectResourceId);
					}, 300);
				} else {
					this.connects = this.items;
					this.getConnectLog(this.connects.projectResourceId);
				}
				console.log('connects', this.connects);
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
	}
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_base64__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_base64__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkGroupOnlineConnection',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null,
      onlineConnection: null,
      resourceType: this.$route.query.type
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTranslateText();
    },
    languageCurrent: function languageCurrent() {
      return this.$language.current;
    },
    currentConnectList: function currentConnectList() {
      return this.$store.getters.dashboard.onlineMembers;
    }
  },
  mounted: function mounted() {},

  methods: {
    getTranslateText: function getTranslateText() {
      return {
        member: this.$gettext('Member'),
        createTime: this.$gettext('Create Time'),
        action: this.$gettext('Action'),
        'unsafeMode': this.$gettext('Unsafe Mode')
      };
    },
    onLinkhref: function onLinkhref(url) {
      window.open(url);
    },
    createShadow: function createShadow(con) {
      var params = {
        master_connection_id: con.connection_id,
        readonly: false,
        expire_time: Math.floor(new Date().getTime() / 1000) + 30 * 60
      };
      var newWin = window.open('');
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.GET_CSOS_SHADOW, params).then(function (res) {
        var shadowUrl = 'http://' + res.agent_host + ':' + res.agent_webtty_port + '/?code=' + __WEBPACK_IMPORTED_MODULE_4_js_base64___default.a.Base64.encode(res.code) + '&user=' + res.user;
        newWin.location.href = shadowUrl;
      }, function () {
        newWin.close();
      });
    },
    onClose: function onClose() {
      this.connects = null;
      this.$emit('onClosePanel');
      this.$emit('reloadOnlineConnects');
    },
    getResourceOnlineConnects: function getResourceOnlineConnects(id) {
      var _this = this;

      var params = {
        q_project: this.$route.params.id,
        q_resource: id
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.GET_WORKGROUP_RESOURCE_ONLINE_CONNECTS, params).then(function (res) {
        var _connectList = Object.clone(res.objects);
        _connectList.forEach(function (item, index) {
          var linkHref = '';
          if (item.guacamole && item.guacamole === 1) {
            linkHref = 'http://' + item.host + ':' + item.webrdp_port + '/?code=' + __WEBPACK_IMPORTED_MODULE_4_js_base64___default.a.Base64.encode(item.tunnel_code) + '&ip=' + item.resource_ip_address + '&resourceName=' + item.resource_name;
          } else {
            linkHref += 'playlog.html';
            linkHref += '?link=' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* baseUrl */].apiUrl;
            linkHref += '&way=' + item.way;
            linkHref += '&code=' + item.tunnel_code;
            linkHref += '&lang=' + _this.languageCurrent;
            linkHref += '&type=monitor';
          }
          if (item.connection_id) {
            linkHref += '&connection_id=' + item.connection_id;
          }
          item.linkHref = linkHref;
          var showRdp = false;
          if (__WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.getAgentVersion(item.agent_version) >= '2.4.2') {
            showRdp = true;
          }
          item.agentVersion = __WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.getAgentVersion(item.agent_version);
          item.showRdp = showRdp;
        });
        _this.onlineConnection = _connectList;
      });
    },
    cutOnline: function cutOnline(id) {
      var _this2 = this;

      this.$confirm(this.$gettext('Are you sure to disconnect this connection?'), this.$gettext('Disconnect connection confirm'), {
        confirmButtonText: this.$gettext('Ok'),
        cancelButtonText: this.$gettext('Cancel'),
        type: 'warning'
      }).then(function () {
        _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].DASHBOARD.CUT_ONLINE, id).then(function () {
          var copy = Object.clone(_this2.currentConnectList);
          var deleteItem = copy.find(function (item) {
            return item.id === id;
          });
          copy.remove(deleteItem);
          _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT, copy);
          var copyCount = Object.clone(_this2.$store.getters.dashboard.onlineMembersCount);
          _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT_COUNTS, copyCount - 1);
          _this2.$notify({
            type: 'success',
            message: _this2.$gettext('Disconnect successfully!')
          });
        }).catch(function (err) {
          _this2.$notify.info({
            message: err
          });
        });
      });
    }
  },
  created: function created() {},

  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this3 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this3.connects = _this3.items;
            _this3.getResourceOnlineConnects(_this3.connects.id);
          }, 300);
        } else {
          this.connects = this.items;
          this.getResourceOnlineConnects(this.connects.id);
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_0__common_right_panel___default.a
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_mySqlView__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_mySqlView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__model_mySqlView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_safeView__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_safeView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__model_safeView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_code_mirror_editor_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_code_mirror_editor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__model_code_mirror_editor_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			previewSQL: '',
			resourceType: 'rds',
			resourceList: [],
			projectList: [],
			networkList: null,
			initTabName: 'sql',
			projectResourceId: null,
			tabType: this.$route.query.type,
			initInfo: {
				init: true
			},
			initResource: false,
			sqlActiveName: 'sqlWaitApprove',
			safeActiveName: 'safeWaitApprove',
			account: this.$store.getters.account,
			m: {
				btnDisabled: false,
				project: '',
				resource: '',
				sql: '',
				comment: '',
				project_id: null,
				resource_id: null,
				resourceIndex: null
			},
			safe: {
				btnDisabled: false,
				project: '',
				resource: '',
				reason: '',
				time: '',
				resource_id: null,
				resourceIndex: null
			},
			mySqlApplication: {
				loading: true,
				list: [],
				totalPage: 0,
				pageSize: 10,
				currentPage: 1
			},
			waitSqlApplication: {
				loading: true,
				list: [],
				totalPage: 1,
				pageSize: 10,
				currentPage: 1
			},
			approvedSqlApplication: {
				loading: true,
				list: [],
				totalPage: 1,
				pageSize: 10,
				currentPage: 1
			},
			safeApplyList: {
				projectList: [],
				resourceList: []
			},
			mySafeApplyList: {
				loading: true,
				list: [],
				totalPage: 1,
				pageSize: 10,
				currentPage: 1
			},
			safeApprovingList: {
				loading: true,
				list: [],
				totalPage: 1,
				pageSize: 10,
				currentPage: 1
			},
			safeApprovedList: {
				loading: true,
				list: [],
				totalPage: 1,
				pageSize: 10,
				currentPage: 1
			},
			safeOptions: {
				disabledDate: function disabledDate(time) {
					return time.getTime() < Date.now();
				}
			},
			sqlApplyStatusText: {
				approving: this.$gettext('approving'),
				approve_wait_result: this.$gettext('approved'),
				rejected: this.$gettext('rejected'),
				approved: this.$gettext('success'),
				failed: this.$gettext('failed')
			},
			safeApplyStatusText: {
				0: this.$gettext('approving'),
				1: this.$gettext('approved'),
				2: this.$gettext('rejected'),
				3: this.$gettext('failed')
			},
			applyStatus: {
				approve_wait_result: 'approved',
				rejected: 'rejected',
				failed: 'failed',
				1: 'approved',
				2: 'rejected',
				3: 'failed'
			},
			sqlRules: {
				project_id: [{ required: true, type: 'number', message: this.$gettext('Please select workgroup'), trigger: 'blur' }],
				resourceIndex: [{ required: true, type: 'number', message: this.$gettext('Please select resource'), trigger: 'blur' }],
				sql: [{ required: true, message: this.$gettext('Please input sql'), trigger: 'blur' }],
				comment: [{ required: true, message: this.$gettext('Please input comment'), trigger: 'blur' }]
			},
			safeRules: {
				project: [{ required: true, message: this.$gettext('Please select workgroup'), trigger: 'blur' }],
				resourceIndex: [{ required: true, type: 'number', message: this.$gettext('Please select resource'), trigger: 'blur' }],
				reason: [{ required: true, message: this.$gettext('Please input applicate reason'), trigger: 'blur' }],
				time: [{ required: true, type: 'date', message: this.$gettext('Please select date'), trigger: 'blur' }]
			},
			currentRightPanel: null,
			rightPanelData: null,
			showModal: {
				previewSQL: false
			}
		};
	},

	computed: {
		attrText: function attrText() {
			return this.initAttrText();
		},
		getAccount: function getAccount() {
			return this.$store.getters.account;
		}
	},
	created: function created() {
		console.log('created');
		this.initTab();
	},

	methods: {
		initAttrText: function initAttrText() {
			return {
				sql: this.$gettext('SQL Application'),
				safeMode: this.$gettext('Security Mode'),
				project: this.$gettext('Workgroup'),
				resource: this.$gettext('Resource'),
				comment: this.$gettext('Comment'),
				resourceName: this.$gettext('Resource Name'),
				reason: this.$gettext('The Reasons For The Application'),
				validTime: this.$gettext('Valid Time'),
				startApplication: this.$gettext('Start Application'),
				select: this.$gettext('select'),
				myApplication: this.$gettext('My Application'),
				general: this.$gettext('General'),
				createTime: this.$gettext('Created Time'),
				applyer: this.$gettext('Applyer'),
				pendingApplication: this.$gettext('Pending Application'),
				myApproved: this.$gettext('My Approved'),
				status: this.$gettext('Status'),
				updateTime: this.$gettext('Update Time'),
				selectDate: this.$gettext('Please Select Date'),
				effectiveTime: this.$gettext('Valid Time'),
				targetDatabase: this.$gettext('Target Database'),
				previewSQL: this.$gettext('Preview SQL')
			};
		},
		onEditorInput: function onEditorInput(code) {
			this.previewSQL = code;
		},
		onShowModal: function onShowModal(params) {
			this.showModal[params.name] = true;
			if (params.name === 'previewSQL') {
				this.previewSQL = params.data.sql;
			}
		},
		initTab: function initTab() {
			if (this.$route.query.id) {
				this.projectResourceId = this.$route.query.id.toString();
			}
			if (this.projectResourceId && this.projectResourceId.indexOf('-')) {
				var index = this.projectResourceId.indexOf('-');
				this.initInfo.projectResourceId = this.projectResourceId.substring(0, index);
				this.initInfo.projectName = this.projectResourceId.substring(index + 1);
				console.log('initInfo', this.initInfo);
			}
			if (this.$route.query.type === 'sql') {
				this.initTabName = this.$route.query.type;

				this.sqlWaitApplication(1);
			} else if (this.$route.query.type === 'safe') {
				this.initTabName = this.$route.query.type;

				this.getSafeApprovingApplication(1);
			} else {
				this.initTabName = 'sql';
				this.onTabClick({ name: 'sql' });
			}
		},
		onClosePanel: function onClosePanel() {
			this.currentRightPanel = null;
			this.rightPanelData = null;
		},
		resetForm: function resetForm(formName) {
			if (this.$refs[formName]) {
				this.$refs[formName].resetFields();
			}
		},
		onTabClick: function onTabClick(tab) {
			this.initTabName = tab.name;
			if (tab.name === 'sql') {
				this.$router.replace({ name: 'operation.review', query: { type: 'sql' } });
			} else {
				this.$router.replace({ name: 'operation.review', query: { type: 'safe' } });
			}
		},
		sqlTabClick: function sqlTabClick(tab) {
			if (tab.name === 'sqlApply') {
				this.sqlActiveName = 'sqlApply';
				this.resetForm('sqlForm');
				this.getProjectList();
			} else if (tab.name === 'sqlWaitApprove') {
				this.sqlActiveName = 'sqlWaitApprove';
				this.sqlWaitApplication(1);
			} else if (tab.name === 'sqlApproved') {
				this.sqlActiveName = 'sqlApproved';
				this.sqlApprovedApplication(1);
			} else if (tab.name === 'sqlMyApply') {
				this.sqlActiveName = 'sqlMyApply';
				this._getMySqlApplication();
			}
		},
		safeTabClick: function safeTabClick(tab) {
			if (tab.name === 'safeApply') {
				this.safeActiveName = 'safeApply';
				this.resetForm('safeForm');
				this.getSafeModeApplication();
			} else if (tab.name === 'safeWaitApprove') {
				this.safeActiveName = 'safeWaitApprove';
				this.getSafeApprovingApplication(1);
			} else if (tab.name === 'safeApproved') {
				this.safeActiveName = 'safeApproved';
				this.getSafeApprovedApplication(1);
			} else if (tab.name === 'safeMyApply') {
				this.safeActiveName = 'safeMyApply';
				this.getMySafeModeApplication(1);
			}
		},
		sqlApplySubmit: function sqlApplySubmit(sqlForm) {
			var _this = this;

			this.m.btnDisabled = true;
			this.$refs[sqlForm].validate(function (valid) {
				if (valid && _this.m.resource && _this.m.resource.resource.status === 2) {
					var params = {
						project_resource_id: _this.m.resource.id,
						sql: _this.m.sql,
						comment: _this.m.comment
					};
					_this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].REVIEW.CREATE_SQL_APPLICATION, params).then(function (res) {
						_this.m.btnDisabled = true;
						_this.sqlActiveName = 'sqlMyApply';
						_this._getMySqlApplication(1);
						_this.$notify({
							type: 'success',
							message: _this.$gettext('Create successfully!')
						});
					});
				} else {
					_this.m.btnDisabled = false;
					return false;
				}
			});
		},
		safeApplySubmit: function safeApplySubmit(safeForm) {
			var _this2 = this;

			this.safe.btnDisabled = true;
			this.$refs[safeForm].validate(function (valid) {
				if (valid) {
					var params = {
						project_id: _this2.safe.resource.project_resource.project_id,
						project_resource_id: _this2.safe.resource.project_resource.id,
						reason: _this2.safe.reason,
						expire_time: Date.parse(_this2.safe.time) / 1000
					};
					_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].REVIEW.CREATE_SAFE_APPLY, params).then(function (res) {
						_this2.safe.btnDisabled = true;
						_this2.safeActiveName = 'safeMyApply';
						_this2.getMySafeModeApplication(1);
						_this2.$notify({
							type: 'success',
							message: _this2.$gettext('Create successfully!')
						});
					});
				} else {
					_this2.safe.btnDisabled = false;
					return false;
				}
			});
		},
		getProjectList: function getProjectList() {
			var _this3 = this;

			var ids = [];
			var networkIds = [];
			var params = {
				results_per_page: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].REVIEW.GET_PROJECT_LIST, params).then(function (res) {
				if (res.objects && res.objects.length) {
					_this3.projectList = res.objects;
					console.log('projectList', _this3.projectList);
					_this3.projectList.forEach(function (item) {
						ids.push(item.id);
						networkIds.push();
						if (_this3.initInfo.projectResourceId && _this3.initInfo.projectName) {
							if (+_this3.initInfo.projectName === item.id) {
								_this3.initInfo.projectRealName = item.project_name;
								_this3.m.project = item;
							}
						}
					});
					if (!_this3.initInfo.projectResourceId) {
						_this3.m.project = _this3.projectList[0];
					}
					_this3.m.project_id = _this3.m.project.id;
					_this3.getResourceList(ids);
				}
			});
		},
		getResourceList: function getResourceList(ids) {
			var _this4 = this;

			var params = {
				results_per_page: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* Utils */].config.maxPageSize,
				q: {
					filters: [{
						name: 'project_id',
						op: 'in',
						val: ids
					}, {
						name: 'resource__resource_type',
						op: 'has',
						val: this.resourceType
					}],
					order_by: [{
						field: 'create_time',
						direction: 'desc'
					}]
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].REVIEW.GET_RESOURCE_LIST, params).then(function (res) {
				if (res.objects && res.objects.length) {
					_this4.resourceList = res.objects.groupBy('project_id');
					console.log('resourceList', _this4.resourceList);
					_this4.initResource = true;

					if (_this4.initInfo.projectResourceId && _this4.initInfo.projectName) {
						_this4.resourceList[_this4.initInfo.projectName].forEach(function (item, index) {
							if (+_this4.initInfo.projectResourceId === item.id) {
								console.log('item ===> ', item);
								_this4.m.resource = item;
								_this4.m.resource_id = _this4.m.resource.id;
								_this4.m.resourceIndex = index;
							}
						});
						console.log('resourceList===>', _this4.m.resource, _this4.resourceList);
					} else {
						_this4.projectChanged(_this4.m.project.id);
					}
				}
			});
		},
		getNetworkList: function getNetworkList(page, cb) {
			var _this5 = this;

			var params = {
				params: {
					page: page || 1,
					results_per_page: 65535,
					q: { order_by: [{ field: 'create_time', direction: 'desc' }] }
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.GET, params).then(function (res) {
				if (res.objects.length) {
					_this5.networkList = res.objects.groupBy('id');
					if (cb) {
						cb(_this5.networkList);
					}
					console.log('this.networkList', _this5.networkList);
				}
			});
		},
		projectChanged: function projectChanged(id) {
			var _this6 = this;

			if (id && this.resourceList[id]) {
				this.m.resource = this.resourceList[id][0];
				this.m.project_id = id;
				console.log('this.m.resource-->', this.m.resource);
				this.m.resource_id = this.m.resource.id;
				this.m.resourceIndex = 0;

				if (this.networkList && this.resourceList[id].length) {
					this.resourceList[id].forEach(function (item, index) {
						if (item.resource && item.resource.network_id) {
							item.agentVersion = __WEBPACK_IMPORTED_MODULE_6__Utils__["a" /* default */].Utils.getAgentVersion(_this6.networkList[item.resource.network_id][0].agent.version);
						}
					});
					console.log('resource-changed->list', this.resourceList[id], this.resourceList);
				} else {
					this.getNetworkList(1, function (networkList) {
						_this6.resourceList[id].forEach(function (item, index) {
							if (item.resource && item.resource.network_id) {
								item.angentVersion = __WEBPACK_IMPORTED_MODULE_6__Utils__["a" /* default */].Utils.getAgentVersion(networkList[item.resource.network_id][0].agent.version);
							}
						});
						console.log('resource-changed->list', _this6.resourceList[id]);
					});
				}
			} else {
				this.m.resource = '';
				this.m.resource_id = null;
				this.m.resourceIndex = '';
			}
		},
		sqlResourceChanged: function sqlResourceChanged(index) {
			if (typeof index === 'number') {
				this.m.resource = this.resourceList[this.m.project_id][index];
				this.m.resource_id = this.m.resource.resource_id;
			}
			console.log('index', this.m.resource);
		},
		_getMySqlApplication: function _getMySqlApplication(page) {
			var _this7 = this;

			this.mySqlApplication.list = [];
			var params = {
				results_per_page: 10,
				page: page || 1,
				q: {
					order_by: [{
						field: 'create_time',
						direction: 'desc'
					}]
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].REVIEW.GET_MY_SQL_APPLICATION, params).then(function (res) {
				_this7.mySqlApplication.loading = false;
				_this7.mySqlApplication.list = res.objects;
				_this7.mySqlApplication.totalPage = res.total_pages;
				_this7.mySqlApplication.currentPage = res.page;
			}, function () {
				_this7.mySqlApplication.loading = false;
			});
		},
		onMySqlChangePage: function onMySqlChangePage(page) {
			this._getMySqlApplication(page);
		},
		sqlWaitApplication: function sqlWaitApplication(page) {
			var _this8 = this;

			var params = {
				results_per_page: 10,
				page: page || 1
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].REVIEW.GET_SQL_APPROVING_APPLICATION, params).then(function (res) {
				_this8.waitSqlApplication.loading = false;
				_this8.waitSqlApplication.list = res.objects;
				_this8.waitSqlApplication.totalPage = res.total_pages;
				_this8.waitSqlApplication.currentPage = res.page;
			}, function () {
				_this8.waitSqlApplication.loading = false;
			});
		},
		waitSqlApplicationChangePage: function waitSqlApplicationChangePage(page) {
			this.sqlWaitApplication(page);
		},
		sqlApprovedApplication: function sqlApprovedApplication(page) {
			var _this9 = this;

			var params = {
				results_per_page: 10,
				page: page || 1
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].REVIEW.GET_SQL_APPROVED_APPLICATION, params).then(function (res) {
				_this9.approvedSqlApplication.loading = false;
				_this9.approvedSqlApplication.list = res.objects;
				_this9.approvedSqlApplication.totalPage = res.total_pages;
				_this9.approvedSqlApplication.currentPage = res.page;
			}, function () {
				_this9.approvedSqlApplication.loading = false;
			});
		},
		approvedSqlApplicationChangePage: function approvedSqlApplicationChangePage(page) {
			this.sqlApprovedApplication(page);
		},
		getSafeModeApplication: function getSafeModeApplication() {
			var _this10 = this;

			var params = {
				results_per_page: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].REVIEW.GET_SAFE_APPLICATION, params).then(function (res) {
				console.log('safe_', res);
				if (!Object.isEmpty(res)) {
					_this10.safeApplyList.projectList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(res);
					_this10.safeApplyList.resourceList = res;
					console.log('safeApplyList', _this10.safeApplyList.projectList, _this10.safeApplyList.resourceList, _this10.initInfo);
					if (_this10.initInfo.projectResourceId && _this10.initInfo.projectName) {
						_this10.safeApplyList.projectList.forEach(function (item) {
							if (item === _this10.initInfo.projectName) {
								_this10.safe.project = _this10.initInfo.projectName;
								res[_this10.initInfo.projectName].forEach(function (_item, index) {
									if (_item.project_resource.id === parseInt(_this10.initInfo.projectResourceId)) {
										_this10.safe.resource = _item;
										_this10.safe.resource_id = _this10.safe.resource.resource.id;
										_this10.safe.resourceIndex = index;
									}
								});
								console.log('this sade', _this10.safe);
							}
						});
					} else {
						_this10.safe.project = _this10.safeApplyList.projectList[0];
						_this10.safe.resource = _this10.safeApplyList.resourceList[_this10.safe.project][0];
						_this10.safe.resource_id = _this10.safe.resource.resource.id;
					}
				}
			});
		},
		safeChanged: function safeChanged(_project) {
			if (this.initInfo.init) {
				this.initInfo.init = false;
			} else {
				if (_project) {
					this.safe.resource = this.safeApplyList.resourceList[_project][0];
					this.safe.resource_id = this.safe.resource.resource.id;
					this.safe.resourceIndex = 0;
					console.log(this.safe.resource, this.safe.resource_id);
				} else {
					this.safe.resource = '';
					this.safe.resource_id = null;
				}
			}
		},
		safeResourceChange: function safeResourceChange(index) {
			console.log('safe--->index', index, typeof index === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(index));
			if (typeof index === 'number') {
				this.safe.resource = this.safeApplyList.resourceList[this.safe.project][index];
				this.safe.resource_id = this.safe.resource.resource.id;
			}
			console.log('safechange-->', this.safe);
		},
		getMySafeModeApplication: function getMySafeModeApplication(page) {
			var _this11 = this;

			this.mySafeApplyList.list = [];
			var params = {
				results_per_page: 10,
				page: page || 1,
				q: {
					filters: [{
						name: 'applicant_id',
						op: 'in',
						val: [this.getAccount.id]
					}],
					order_by: [{
						field: 'create_time',
						direction: 'desc'
					}]
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].REVIEW.GET_MY_SAFE_APPLY, params).then(function (res) {
				_this11.mySafeApplyList.loading = false;
				_this11.mySafeApplyList.list = res.objects;
				_this11.mySafeApplyList.totalPage = res.total_pages;
				_this11.mySafeApplyList.currentPage = res.page;
			}, function () {
				_this11.mySafeApplyList.loading = false;
			});
		},
		onMySafeChangePage: function onMySafeChangePage(page) {
			this.getMySafeModeApplication(page);
		},
		getSafeApprovingApplication: function getSafeApprovingApplication(page) {
			var _this12 = this;

			var params = {
				results_per_page: 10,
				page: page || 1
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].REVIEW.GET_SAFE_APPROVING_APPLY, params).then(function (res) {
				_this12.safeApprovingList.loading = false;
				_this12.safeApprovingList.list = res.objects;
				_this12.safeApprovingList.totalPage = res.total_pages;
				_this12.safeApprovingList.currentPage = res.page;
			});
		},
		safeApprovingChangePage: function safeApprovingChangePage(page) {
			this.getSafeApprovingApplication(page);
		},
		getSafeApprovedApplication: function getSafeApprovedApplication(page) {
			var _this13 = this;

			var params = {
				results_per_page: 10,
				page: page || 1
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].REVIEW.GET_SAFE_APPROVED_APPLY, params).then(function (res) {
				_this13.safeApprovedList.loading = false;
				_this13.safeApprovedList.list = res.objects;
				_this13.safeApprovedList.totalPage = res.total_pages;
				_this13.safeApprovedList.currentPage = res.page;
			}, function () {
				console.log('err');
				_this13.safeApprovedList.loading = false;
			});
		},
		safeApprovedChangePage: function safeApprovedChangePage(page) {
			this.getSafeApprovedApplication(page);
		},
		viewCallback: function viewCallback() {
			if (this.currentRightPanel.name === 'mySqlView') {
				if (this.rightPanelData.pageType === 'mySqlApply') {
					this.sqlActiveName = 'sqlMyApply';
					this._getMySqlApplication(1);
				} else {
					this.sqlActiveName = 'sqlApproved';
					this.sqlApprovedApplication(1);
				}
			} else if (this.currentRightPanel.name === 'safeView') {
				if (this.rightPanelData.pageType === 'mySafeApply') {
					this.safeActiveName = 'safeMyApply';
					this.getMySafeModeApplication(1);
				} else {
					this.safeActiveName = 'safeApproved';
					this.getSafeApprovedApplication(1);
				}
			}
		},
		getSqlDetailInfo: function getSqlDetailInfo(id, cb) {
			var params = {
				application_id: id
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].REVIEW.GET_MY_APPLY_DETAIL, params).then(function (res) {
				cb(res);
			});
		},
		viewMySqlApply: function viewMySqlApply(row, event, column) {
			var _this14 = this;

			event.cancelBubble = true;
			this.getSqlDetailInfo(row.id, function (res) {
				var data = res.objects;
				data.viewType = 'my';
				data.pageType = 'mySqlApply';
				if (data.status !== 'approving') {
					data.isHideFooter = true;
				} else {
					data.isHideFooter = false;
				}
				var time = !_this14.currentRightPanel || _this14.currentRightPanel.name === 'mySqlView' ? 0 : 300;
				_this14.currentRightPanel = __WEBPACK_IMPORTED_MODULE_4__model_mySqlView___default.a;
				_this14.$nextTick(function () {
					setTimeout(function () {
						_this14.rightPanelData = Object.clone(data);
					}, time);
				});
			});
		},
		viewApprovingSqlApply: function viewApprovingSqlApply(row, event, column) {
			var _this15 = this;

			event.cancelBubble = true;
			this.getSqlDetailInfo(row.id, function (res) {
				var data = res.objects;
				data.viewType = 'approve';
				data.isHideFooter = false;
				data.pageType = 'mySqlApproving';
				var time = !_this15.currentRightPanel || _this15.currentRightPanel.name === 'mySqlView' ? 0 : 300;
				_this15.currentRightPanel = __WEBPACK_IMPORTED_MODULE_4__model_mySqlView___default.a;
				_this15.$nextTick(function () {
					setTimeout(function () {
						_this15.rightPanelData = Object.clone(data);
					}, time);
				});
			});
		},
		viewApprovedSql: function viewApprovedSql(row, event, column) {
			var _this16 = this;

			event.cancelBubble = true;
			this.getSqlDetailInfo(row.id, function (res) {
				var data = res.objects;
				data.viewType = 'approve';
				data.isHideFooter = true;
				data.pageType = 'mySqlApproved';
				var time = !_this16.currentRightPanel || _this16.currentRightPanel.name === 'mySqlView' ? 0 : 300;
				_this16.currentRightPanel = __WEBPACK_IMPORTED_MODULE_4__model_mySqlView___default.a;
				_this16.$nextTick(function () {
					setTimeout(function () {
						_this16.rightPanelData = Object.clone(data);
					}, time);
				});
			});
		},
		getSafeDetailInfo: function getSafeDetailInfo(id, cb) {
			var _this17 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].REVIEW.GET_SAFE_DETAIL, id).then(function (res) {
				cb(res);
			}).catch(function (err) {
				console.log('err--->', err);
				if (err && err.data.code === 'NeedPrivilege') {
					_this17.$notify.error({
						message: _this17.$gettext('The approval permission for the resource has been canceled')
					});
				}
			});
		},
		viewApprovingSafe: function viewApprovingSafe(row, event, column) {
			var _this18 = this;

			event.cancelBubble = true;
			this.getSafeDetailInfo(row.id, function (res) {
				var data = res;
				data.viewType = 'approve';
				data.isHideFooter = false;
				data.pageType = 'mySafeApproving';
				var time = !_this18.currentRightPanel || _this18.currentRightPanel.name === 'safeView' ? 0 : 300;
				_this18.currentRightPanel = __WEBPACK_IMPORTED_MODULE_5__model_safeView___default.a;
				_this18.$nextTick(function () {
					setTimeout(function () {
						_this18.rightPanelData = Object.clone(data);
					}, time);
				});
			});
		},
		viewApprovedSafe: function viewApprovedSafe(row, event, column) {
			var _this19 = this;

			event.cancelBubble = true;
			this.getSafeDetailInfo(row.id, function (res) {
				var data = res;
				data.viewType = 'approve';
				data.isHideFooter = true;
				data.pageType = 'mySafeApproved';
				var time = !_this19.currentRightPanel || _this19.currentRightPanel.name === 'safeView' ? 0 : 300;
				_this19.currentRightPanel = __WEBPACK_IMPORTED_MODULE_5__model_safeView___default.a;
				_this19.$nextTick(function () {
					setTimeout(function () {
						_this19.rightPanelData = Object.clone(data);
					}, time);
				});
			});
		},
		viewMySafeApply: function viewMySafeApply(row, event, column) {
			var _this20 = this;

			event.cancelBubble = true;
			this.getSafeDetailInfo(row.id, function (res) {
				var data = res;
				data.viewType = 'my';
				data.pageType = 'mySafeApply';
				if (data.app_status !== 0) {
					data.isHideFooter = true;
				} else {
					data.isHideFooter = false;
				}
				var time = !_this20.currentRightPanel || _this20.currentRightPanel.name === 'safeView' ? 0 : 300;
				_this20.currentRightPanel = __WEBPACK_IMPORTED_MODULE_5__model_safeView___default.a;
				_this20.$nextTick(function () {
					setTimeout(function () {
						_this20.rightPanelData = Object.clone(data);
					}, time);
				});
			});
		}
	},
	watch: {
		$route: function $route(to, from) {
			console.log('route--->change');
			this.initInfo = {};

			if (this.$route.query.type === 'sql') {
				this.initTabName = this.$route.query.type;

				this.sqlWaitApplication(1);
			} else if (this.$route.query.type === 'safe') {
				this.initTabName = this.$route.query.type;

				this.getSafeApprovingApplication(1);
			} else {
				this.initTabName = 'sql';
				this.onTabClick({ name: 'sql' });
			}
		}
	},
	components: {
		mySqlView: __WEBPACK_IMPORTED_MODULE_4__model_mySqlView___default.a,
		safeView: __WEBPACK_IMPORTED_MODULE_5__model_safeView___default.a,
		CodemirrorEditor: __WEBPACK_IMPORTED_MODULE_7__model_code_mirror_editor_vue___default.a
	}
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_workgroup_online_connection__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_workgroup_online_connection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__model_workgroup_online_connection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_workgroup_connection_logs__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_workgroup_connection_logs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__model_workgroup_connection_logs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_workgroup_connection__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_workgroup_connection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__model_workgroup_connection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_workgroup_apply__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_workgroup_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__model_workgroup_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_linux_config__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_linux_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__model_linux_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_manage_code__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_manage_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__model_manage_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_check_vue__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_check_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__model_check_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_workgroup_assist__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_workgroup_assist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__model_workgroup_assist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_code_mirror_editor_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_code_mirror_editor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__model_code_mirror_editor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_js_base64__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_js_base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__node_modules_moment_src_moment__ = __webpack_require__(157);



















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'WorkGroupDetail',
	data: function data() {
		var _this = this;

		var checkExpireTime = function checkExpireTime(rule, value, callback) {
			var maxTunnelExpireTime = 0;
			_this.clickRowInfo.m.max_tunnel_expire_time ? maxTunnelExpireTime = _this.clickRowInfo.m.max_tunnel_expire_time / 60 : 0;
			if (value < 1) {
				callback(new Error(_this.$gettext('In order to ensure the availability of the code, the maximum effective time cannot be less than 1 minutes')));
			} else if (maxTunnelExpireTime && value > maxTunnelExpireTime) {
				callback(new Error(_this.$gettext('the effective time has exceeded the maximum effective time of the code set by the administrator: ') + maxTunnelExpireTime + _this.$gettext('minutes')));
			} else {
				callback();
			}
		};
		return {
			verifyData: {},
			loading: true,
			downloadUrl: '',
			activeTabName: this.$route.query.type || 'ecs',
			workgroup: null,
			instances: [],
			instancesList: {
				totalPage: 1,
				pageSize: 10,
				currentPage: 1
			},
			databasesList: {
				totalPage: 1,
				pageSize: 10,
				currentPage: 1
			},
			databases: [],
			tunnelCode: null,
			searchForm: {
				type: 'q_name',
				key: ''
			},
			currentRightPanel: null,
			rightPanelData: null,
			showModal: {
				showCreateModal: false,
				modifyCreateModal: false,
				showTempModal: false,
				showTempModalSuccess: false,
				disCreateModal: true,
				previewSQL: false
			},
			formLabelWidth: '120px',
			rules: {
				username: [{ required: true, message: this.$gettext('Please input the username'), trigger: 'change' }],
				psw: [{ required: true, message: this.$gettext('Please input the password'), trigger: 'change' }],
				allow_ip: [{
					pattern: /^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}[:;])*(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})$/,
					message: this.$gettext('please input the right IP'),
					trigger: 'change'
				}],
				expire_time_customize: [{ required: true, type: 'number', message: this.$gettext('Please input the expire time'), trigger: 'change' }, { validator: checkExpireTime, trigger: 'change' }]
			},
			allowIPPattern: /^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}[:;])*(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})$/,
			clickRowInfo: {},
			m: {
				resource: {},
				network: {},
				safe: {},
				validTime: new Date(),
				expire: ''
			},
			codeObj: null,
			modifyTime: {
				type: 'day',
				time: '',
				isSelectTime: false
			},
			safeOptions: {
				disabledDate: function disabledDate(time) {
					return time.getTime() < Date.now();
				}
			},
			codeId: '',
			tempObj: {
				expire_time: '30',
				expire_time_customize: '',
				username: '',
				psw: '',
				allow_ip: '',
				saving: false
			},
			tempSuccessObj: null,
			tempWinObj: null,
			testcopy: false,

			tempTesting: false,
			tempTestPassed: false,

			viewLogShow: false,
			viewLogLoading: false,
			logContent: ''
		};
	},

	computed: {
		attrText: function attrText() {
			return this.initAttrText();
		},
		tempNeedTest: function tempNeedTest() {
			return this.tempObj.showNewTemp || !this.tempObj.showNewTemp && !this.tempObj.autologin;
		}
	},
	mounted: function mounted() {
		this.setSearchData();
		this.getProjectDetail();
		this.getProjectResource(1);
	},

	methods: {
		setSearchData: function setSearchData() {
			var _query = this.$route.query;
			if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_query).length) {
				for (var k in _query) {
					if (k == 'q_ip' || k == 'q_name') {
						this.searchForm.type = k;
						this.searchForm.key = _query[k];
					}
				}
			}
		},
		onEditorInput: function onEditorInput(code) {
			this.verifyData.sql = code;
		},
		initAttrText: function initAttrText() {
			return {
				validTime: this.$gettext('Valid Time'),
				serverUser: this.$gettext('Server User'),
				serverPsw: this.$gettext('Server Password'),
				allowIP: this.$gettext('Allow IP'),
				thirty: this.$gettext('Thirty minutes'),
				minutes: this.$gettext('minutes'),
				name: this.$gettext('Name'),
				userName: this.$gettext('Username'),
				select: this.$gettext('select'),
				selectDate: this.$gettext('Please Select Date'),
				dabaseName: this.$gettext('Database Name'),
				action: this.$gettext('Action'),
				instance: this.$gettext('Instance'),
				cluster: this.$gettext('Cluster'),
				avaliableCode: this.$gettext('Avaliable Code'),
				onlineSession: this.$gettext('Online Sessions'),
				connectLog: this.$gettext('Connection Log'),
				database: this.$gettext('Database'),
				createCode: this.$gettext('Create Code'),
				modifyCode: this.$gettext('Modify Code'),
				securityMode: this.$gettext('Security Mode'),
				temporaryAuthorize: this.$gettext('Temporary Authorize'),
				temporarypsw: this.$gettext('Temporary Password'),
				connectAddress: this.$gettext('Connection Address'),
				oneDay: this.$gettext('one day later'),
				oneMonth: this.$gettext('one month later'),
				customize: this.$gettext('customize'),
				tipallowIp: this.$gettext('Please input the allow IP'),
				unavailable: this.$gettext('Unavailable'),
				available: this.$gettext('Available'),
				notSupport: this.$gettext('The new version of the agent does not support the database connection, coming soon.'),
				previewSQL: this.$gettext('Preview SQL'),
				test: this.$gettext('Test'),
				testPassed: this.$gettext('Test passed')
			};
		},
		exportAnsible: function exportAnsible() {
			this.downloadUrl = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* baseUrl */].apiUrl + '/project/' + this.$route.params.id + '/hosts?type=ansible&export=true&t=' + new Date().getTime();
		},
		changeExpireTime: function changeExpireTime() {
			if (this.m.expire === 'day') {
				this.m.validTime = Date.now() + 24 * 60 * 60 * 1000;
			} else if (this.m.expire === 'month') {
				this.m.validTime = new Date().setMonth(new Date().getMonth() + 1);
			} else {
				this.m.validTime = new Date().getTime() + 30 * 60 * 1000;
			}
		},
		timeInput: function timeInput(e) {
			if (/\d/.test(e)) {
				this.showModal.disCreateModal = false;
				if (!this.m.client_ip || this.m.client_ip && this.allowIPPattern.test(this.m.client_ip)) {
					this.showModal.disCreateModal = false;
				} else {
					this.showModal.disCreateModal = true;
				}
			} else {
				this.showModal.disCreateModal = true;
			}
		},
		ipInput: function ipInput(e) {
			if (this.showModal.showCreateModal) {
				if (/\d/.test(this.m.validTime)) {
					if (this.m.client_ip) {
						if (!this.m.client_ip || this.m.client_ip && this.allowIPPattern.test(e)) {
							this.showModal.disCreateModal = false;
						} else {
							this.showModal.disCreateModal = true;
						}
					} else {
						this.showModal.disCreateModal = false;
					}
				}
			}
		},
		closeTempModal: function closeTempModal() {
			this.showModal.showTempModal = false;

			if (!this.showModal.showTempModalSuccess) {
				this.resetTempForm();
			}
		},
		resetTempForm: function resetTempForm() {
			var _this2 = this;

			this.tempObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.tempObj, {
				expire_time: '30',
				expire_time_customize: '',
				username: '',
				psw: '',
				allow_ip: '',
				saving: false
			});
			this.tempTesting = false;
			this.tempTestPassed = false;
			this.$nextTick(function () {
				if (_this2.$refs['tempObjForm']) {
					_this2.$refs['tempObjForm'].resetFields();
				}
			});
		},
		onTempCredentialChange: function onTempCredentialChange() {
			this.tempTestPassed = false;
		},
		testPasswordConnection: function testPasswordConnection() {
			var _this3 = this;

			if (!this.tempObj.username) {
				this.$notify({
					message: this.$gettext('Please input the username'),
					type: 'warning'
				});
				return false;
			}
			if (!this.tempObj.psw) {
				this.$notify({
					message: this.$gettext('Please input the password'),
					type: 'warning'
				});
				return false;
			}
			this.tempTesting = true;
			var params = {
				project_resource_id: this.clickRowInfo.m.project_resource_id,
				username: this.tempObj.username,
				passwd: this.tempObj.psw
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.TEST_PASSWORD_CONNECTION, params).then(function (res) {
				_this3.tempTesting = false;
				if (res && res.result === 'enable') {
					_this3.tempTestPassed = true;
					_this3.$notify({
						message: res && res.msg || _this3.$gettext('Test failed'),
						type: 'success'
					});
				} else {
					_this3.tempTestPassed = false;
					_this3.$notify({
						message: res && res.msg || _this3.$gettext('Test failed'),
						type: 'error'
					});
				}
			}, function (err) {
				_this3.tempTesting = false;
				_this3.tempTestPassed = false;
				_this3.$notify({
					message: err && err.err || _this3.$gettext('Test failed'),
					type: 'error'
				});
			});
		},
		copySuccess: function copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success'
			});
			e.clearSelection();
		},
		copyError: function copyError(e) {
			this.$notify({
				message: this.$gettext('Copy Failed!'),
				type: 'failed'
			});
		},
		onClosePanel: function onClosePanel() {
			this.currentRightPanel = null;
			this.rightPanelData = null;
		},
		startApplyEvent: function startApplyEvent(row) {
			console.log('row', row);
			this.onClosePanel();
			this.showModal.showCreateModal = false;
			this.showModal.modifyCreateModal = false;
			this.startApply(row, 'ecs');
		},
		onShowModal: function onShowModal(params) {
			var _this4 = this;

			this.showModal[params.name] = true;
			console.log('clickRowInfo', this.clickRowInfo);
			if (params.name === 'showCreateModal') {
				this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_PROJECT_RESOURCE_INFO, this.clickRowInfo.m.project_resource_id).then(function (res) {
					_this4.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_CLIENT_IP).then(function (data) {
						res.safeMode = true;
						res.client_ip = data.client_ip;
						res.extension = JSON.parse(res.resource.extension);
						_this4.m = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.m, res);
						console.log('mmmm->', _this4.m);
					});
				});
			} else if (params.name === 'modifyCreateModal') {
				this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_CODE_INFO, params.code).then(function (res) {
					res.safeMode = res.safe_mode;
					_this4.oldCodeObj = Object.clone(res);
					_this4.codeObj = Object.clone(res);
					_this4.modifyTime.time = res.expire_time * 1000;
				});
			} else if (params.name === 'showTempModal') {
				var showNewTemp = __WEBPACK_IMPORTED_MODULE_14__Utils__["a" /* default */].Utils.getAgentVersion(this.clickRowInfo.m.agent_version) >= '3.0.0';
				var autologin = this.clickRowInfo.m.autologin;

				var username = 'hhhhh';
				var defaultUserName = '';
				var userNameList = [];
				if (username) {
					userNameList = username.split(';');
					if (userNameList.length < 2) {
						defaultUserName = username;
					}
					defaultUserName = '';
				} else {
					userNameList = ['root'];
					defaultUserName = 'root';
				}
				this.tempObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.tempObj, {
					usernameList: userNameList,
					username: defaultUserName,
					autologin: autologin,
					showNewTemp: showNewTemp
				});

				this.tempTesting = false;
				this.tempTestPassed = false;
				this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_CLIENT_IP).then(function (data) {
					_this4.$set(_this4.tempObj, 'allow_ip', data.client_ip);
				});
			} else if (params.name === 'previewSQL') {
				this.verifyData = params.data;
			}
		},
		onShowConnectionLogs: function onShowConnectionLogs(row) {
			var _this5 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkGroupConnectLogs' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_5__model_workgroup_connection_logs___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this5.rightPanelData = row;
				}, time);
			});
		},
		onShowConnect: function onShowConnect(row) {
			var _this6 = this;

			this.codeId = row.project_resource_id;
			this.$set(this.clickRowInfo, 'm', row);
			var data = {
				agentVersion: __WEBPACK_IMPORTED_MODULE_14__Utils__["a" /* default */].Utils.getAgentVersion(row.agent_version),

				resourceName: row.name,

				projectResourceId: row.project_resource_id,
				row: row
			};
			var time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkGroupConnection' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_6__model_workgroup_connection___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this6.rightPanelData = data;
				}, time);
			});
		},
		onSelectAssistance: function onSelectAssistance(c) {
			this.onShowAssist(c);
		},
		onShowAssist: function onShowAssist(command) {
			var _this7 = this;

			console.log('--comand--', command);
			var data = {
				assistType: command.key,
				agentVersion: __WEBPACK_IMPORTED_MODULE_14__Utils__["a" /* default */].Utils.getAgentVersion(command.row.agent_version),
				projectName: command.row.project,
				resourceName: command.row.name,
				projectId: this.$route.params.id,
				projectResourceId: command.row.project_resource_id
			};
			var time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkGroupAssist' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_11__model_workgroup_assist___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this7.rightPanelData = data;
				}, time);
			});
		},
		onShowConnections: function onShowConnections(row) {
			var _this8 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkGroupOnlineConnection' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_4__model_workgroup_online_connection___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this8.rightPanelData = row;
				}, time);
			});
		},
		linuxConfig: function linuxConfig(row) {
			var _this9 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'LinuxConfig' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_8__model_linux_config___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this9.rightPanelData = row;
				}, time);
			});
		},
		manageCode: function manageCode(row) {
			var _this10 = this;

			this.codeId = row.project_resource_id;
			this.$set(this.clickRowInfo, 'm', row);
			row.resource_type = this.$route.query.type;
			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ManageCode' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_9__model_manage_code___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this10.rightPanelData = row;
				}, time);
			});
		},
		check: function check(row) {
			var _this11 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ManageReport' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_10__model_check_vue___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this11.rightPanelData = row;
				}, time);
			});
		},
		startApply: function startApply(row, type) {
			var _this12 = this;

			console.log('row', row, this.currentRightPanel);
			row.applyType = type;
			var time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupApply' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_7__model_workgroup_apply___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this12.rightPanelData = row;
				}, time);
			});
		},
		switchSafeMode: function switchSafeMode() {
			if (this.m.safeMode) {
				this.$set(this.m, 'safeMode', false);
			} else {
				this.$set(this.m, 'safeMode', true);
			}
		},
		switchModifySafeMode: function switchModifySafeMode() {
			if (this.codeObj.safeMode) {
				this.$set(this.codeObj, 'safeMode', false);
			} else {
				this.$set(this.codeObj, 'safeMode', true);
			}
		},
		createCode: function createCode() {
			var _this13 = this;

			console.log('current valid time:::', this.clickRowInfo.m.max_tunnel_expire_time);
			if (this.clickRowInfo.m.max_tunnel_expire_time && this.m.validTime > new Date().getTime() + this.clickRowInfo.m.max_tunnel_expire_time * 1000) {
				this.$notify({
					type: 'error',
					message: this.$gettext("Set failed.The admin has set the cluster's effective time to no more than ") + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__node_modules_moment_src_moment__["a" /* default */])(new Date().getTime() + this.clickRowInfo.m.max_tunnel_expire_time * 1000).format('YYYY-MM-DD HH:mm:ss')
				});
				return false;
			}
			this.m.saving = true;
			var params = {
				project_resource_id: this.m.id,
				allow_ip: this.m.client_ip,
				expire: parseFloat(((this.m.validTime - new Date().getTime()) / (60 * 60 * 1000)).toFixed(2))
			};
			if (this.m.safe.network_safe_mode && this.m.resource.resource_type === 'ecs' && this.m.extension.os === 'linux') {
				if (!this.m.safeMode) {
					params.safe_mode = 0;
				} else {
					params.safe_mode = 1;
				}
			}
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.CREATE_CODE, params).then(function (res) {
				_this13.m.saving = false;
				_this13.showModal.showCreateModal = false;
				_this13.$refs['rightPanel'].getTunelInfo(_this13.codeId);
				_this13.$notify({
					type: 'success',
					message: _this13.$gettext('Create code suceessfully!')
				});
			}, function () {
				_this13.m.saving = false;
			});
		},
		modifyCodeSelectChange: function modifyCodeSelectChange(name) {
			if (name === 'custom') {
				this.modifyTime.time = this.codeObj.expire_time * 1000;
			}
		},
		modifyCode: function modifyCode() {
			var _this14 = this;

			if (this.modifyTime.type === 'day') {
				this.modifyTime.time = (Date.now() + 24 * 60 * 60 * 1000) / 1000;
			} else if (this.modifyTime.type === 'month') {
				this.modifyTime.time = (Date.now() + 30 * 24 * 60 * 60 * 1000) / 1000;
			} else {
				console.log('this.modifyTime.time', !this.modifyTime.time);
				if (!this.modifyTime.time) {
					this.modifyTime.isSelectTime = true;
					return false;
				} else {
					this.modifyTime.isSelectTime = false;
					this.modifyTime.time = this.modifyTime.time / 1000;
				}
			}
			if (this.clickRowInfo.m.max_tunnel_expire_time && this.modifyTime.time > this.codeObj.create_time + this.clickRowInfo.m.max_tunnel_expire_time) {
				this.$notify({
					type: 'error',
					message: this.$gettext("Set failed.The admin has set the cluster's effective time to no more than ") + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__node_modules_moment_src_moment__["a" /* default */])((this.codeObj.create_time + this.clickRowInfo.m.max_tunnel_expire_time) * 1000).format('YYYY-MM-DD HH:mm:ss')
				});
				this.modifyCodeSelectChange('custom');
				return false;
			}
			var params = {
				expire_time: this.modifyTime.time
			};
			if (this.oldCodeObj.safeMode !== this.codeObj.safeMode) {
				if (this.codeObj.safeMode) {
					params.safe_mode = 1;
				} else {
					params.safe_mode = 0;
				}
			}
			if (this.oldCodeObj.allow_ip !== this.codeObj.allow_ip) {
				params.allow_ip = this.codeObj.allow_ip;
			}
			var obj = {
				code: this.codeObj.code,
				data: params
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.MODIFY_CODE, obj).then(function (res) {
				_this14.showModal.modifyCreateModal = false;
				_this14.modifyTime.type = 'day';
				_this14.$refs['rightPanel'].getTunelInfo(_this14.codeId);
				_this14.$notify({
					type: 'success',
					message: _this14.$gettext('Modify code successfully!')
				});
			});
		},
		closeTempModalSuccess: function closeTempModalSuccess() {
			var _this15 = this;

			this.tempWinObj = null;
			setTimeout(function () {
				_this15.resetTempForm();
			}, 300);
			this.$refs['rightPanel'].getTunelInfo(this.codeId);
		},
		tempAuth: function tempAuth() {
			var _this16 = this;

			this.$refs['tempObjForm'].validate(function (valid) {
				if (valid) {
					_this16.tempObj.saving = true;
					var params = {
						project_resource_id: _this16.clickRowInfo.m.project_resource_id,
						tmpShare: true,
						allow_ip: _this16.tempObj.allow_ip,
						expire: _this16.tempObj.expire_time === 'customize' ? Number(Number(_this16.tempObj.expire_time_customize) / 60) : Number(_this16.tempObj.expire_time / 60)
					};
					if (_this16.tempObj.psw) {
						params.passwd = _this16.tempObj.psw;
					}
					if (_this16.tempObj.expire_time !== 'customize' && _this16.clickRowInfo.m.max_tunnel_expire_time) {
						console.log('--this.', _this16.tempObj.expire_time, _this16.clickRowInfo.m.max_tunnel_expire_time / 60);
						if (_this16.tempObj.expire_time > _this16.clickRowInfo.m.max_tunnel_expire_time / 60) {
							_this16.$notify({
								message: _this16.$gettext('Creation failed, the effective time has exceeded the maximum effective time of the code set by the administrator'),
								type: 'error'
							});
							_this16.tempObj.saving = false;
							return false;
						}
					}
					_this16.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_TUNNEL_INFO, params).then(function (d) {
						_this16.tempObj.saving = false;
						_this16.showModal.showTempModal = false;
						console.log('tempsuccess:::', d);
						_this16.tempSuccessObj = d;
						var _connectData = {
							code: d.code,
							host: d.agent.host,
							agentVersion: __WEBPACK_IMPORTED_MODULE_14__Utils__["a" /* default */].Utils.getAgentVersion(d.agent.version),
							tmp_passwd: d.tmp_passwd
						};
						_this16.tempWinObj = {};
						_this16.tempWinObj.tmpPsw = _connectData.tmp_passwd;
						if (d.os === 'linux') {
							_connectData.type = 'linux';
							_connectData.webPort = d.agent.web_port;
							_connectData.path = '/wetty/ssh';
						} else if (d.os === 'win32') {
							_connectData.type = 'win32';
							_connectData.rdpPort = d.agent.rdp_port;
							_connectData.path = '/webrdp';
							_this16.tempWinObj.host = _connectData.host + ':' + _connectData.rdpPort;
							_this16.tempWinObj.tmpUsername = _connectData.code + '_' + _this16.tempObj.username;
						}
						var agentVersionFirst = parseInt(_connectData.agentVersion.split('.')[0]);
						if (d.os === 'linux') {
							_this16.tempWinObj.linkUrl = 'http://' + _connectData.host + ':' + _connectData.webPort + _connectData.path + '/' + __WEBPACK_IMPORTED_MODULE_13_js_base64___default.a.Base64.encode(d.code) + '/' + _this16.tempObj.username;
							if (!isNaN(agentVersionFirst) && agentVersionFirst > 1) {
								_this16.tempWinObj.linkUrl = 'http://' + _connectData.host + ':' + _connectData.webPort + '/?code=' + __WEBPACK_IMPORTED_MODULE_13_js_base64___default.a.Base64.encode(d.code) + '&user=' + _this16.tempObj.username;
							}
						} else if (d.os === 'win32') {
							_this16.tempWinObj.linkUrl = 'http://' + _connectData.host + ':' + _connectData.rdpPort + _connectData.path + '/' + __WEBPACK_IMPORTED_MODULE_13_js_base64___default.a.Base64.encode(d.code) + '/' + 'none' + '/' + _this16.tempObj.username;
						}
						_this16.tempWinObj.type = d.os;
						console.log('tempObj', _this16.tempWinObj, _this16.tempWinObj.linkUrl);
						_this16.showModal.showTempModalSuccess = true;
					}, function () {
						_this16.tempObj.saving = false;
					});
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		onSearch: function onSearch() {
			var params = {};
			if (this.searchForm.key !== '' && this.searchForm.type) {
				params[this.searchForm.type] = this.searchForm.key;
			}
			if (this.$route.query.type !== '' && this.$route.query.type) {
				params.type = this.$route.query.type;
			}

			this.$router.push({ path: this.$route.path, query: params });
		},
		onClickTab: function onClickTab(tab) {
			this.$router.push({ name: 'workgroupdetail', query: { type: tab.name } });
			this.searchForm = {
				type: 'q_name',
				key: ''
			};
			this.activeTabName = this.$route.query.type || 'ecs';
			this.getProjectResource();
		},
		getProjectDetail: function getProjectDetail() {
			var _this17 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_WORKGROUP_DETAIL, this.$route.params).then(function (res) {
				_this17.workgroup = res;
			});
		},
		changeProjectPage: function changeProjectPage(page) {
			this.getProjectResource(page);
		},
		getProjectResource: function getProjectResource(pageIndex) {
			var _this18 = this;

			this.loading = true;
			var params = {
				id: this.$route.params.id,
				params: {
					page: pageIndex || 1,
					type: this.activeTabName
				}
			};
			if (this.searchForm.key) {
				params.params[this.searchForm.type] = this.searchForm.key;
			}
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP_RESOURCE, params).then(function (res) {
				_this18.loading = false;
				_this18.instances = [];
				_this18.databases = [];
				if (_this18.activeTabName === 'ecs') {
					_this18.instances = res.objects;
					_this18.instancesList.totalPage = res.total_pages;
					_this18.instancesList.currentPage = res.page;
				} else if (_this18.activeTabName === 'rds') {
					_this18.databases = res.objects;
					_this18.databasesList.totalPage = res.total_pages;
					_this18.databasesList.currentPage = res.page;
				}
			}, function () {
				_this18.loading = false;
			});
		},
		getOnlineConnection: function getOnlineConnection() {
			var _this19 = this;

			var params = {
				page: 1,
				page_size: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].DASHBOARD.GET_ONLINE_CONNECT, params).then(function (res) {
				if (res && res.length) {
					var resourceObj = res.groupBy('project_resource_id');
					if (_this19.instances && _this19.instances.length) {
						_this19.instances.forEach(function (item) {
							_this19.$set(item, 'connects', resourceObj[item.id] || []);
						});
					}
					if (_this19.databases && _this19.databases.length) {
						_this19.databases.forEach(function (item) {
							_this19.$set(item, 'connects', resourceObj[item.id] || []);
						});
					}
					console.log('onlineConnec', _this19.instances);
				}
			});
		},
		getTunnelCode: function getTunnelCode(ids) {
			var _this20 = this;

			var params = {
				results_per_page: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* Utils */].config.maxPageSize,
				q: {
					filters: [{
						name: 'project_resource_id',
						op: 'in',
						val: ids
					}, {
						name: 'account_id',
						op: 'eq',
						val: this.$store.getters.account.id
					}, {
						name: 'type',
						op: 'eq',
						val: ''
					}, {
						name: 'status',
						op: 'eq',
						val: 'enable'
					}, {
						name: 'expire_time',
						op: '>',
						val: Math.floor(Date.now() / 1000)
					}]
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_TUNNEL_CODE, params).then(function (res) {
				var codeObj = res.objects.groupBy('project_resource_id');
				if (ids.length > 1) {
					_this20.tunnelCode = codeObj;
				} else {
					_this20.tunnelCode = _this20.tunnelCode || {};
					_this20.$set(_this20.tunnelCode, ids[0], res.objects);
				}
			});
		},
		reloadTunnelCode: function reloadTunnelCode(id) {
			this.getTunnelCode(id);
		},
		reloadOnlineConnects: function reloadOnlineConnects() {
			this.getOnlineConnection();
		},
		reloadPojectResource: function reloadPojectResource() {
			if (this.activeTabName === 'ecs') {
				this.getProjectResource(this.instancesList.currentPage);
			} else {
				this.getProjectResource(this.databasesList.currentPage);
			}
		},
		hideStr: function hideStr(str) {
			return __WEBPACK_IMPORTED_MODULE_14__Utils__["a" /* default */].Utils.hideStr(str);
		},
		handleViewLog: function handleViewLog(row) {
			console.log('父组件收到查看日志事件:', row);
			this.loadLogContent(row);
		},
		loadLogContent: function loadLogContent(row) {
			var _this21 = this;

			this.viewLogLoading = true;
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.VIEW_LOG, {
				params: {
					code: row.code,
					way: row.way,
					connection_id: row.connection_id,
					show: 1
				}
			}).then(function (res) {
				console.log('日志 API 返回:', res);
				_this21.viewLogLoading = false;

				var cleanContent = __WEBPACK_IMPORTED_MODULE_14__Utils__["a" /* default */].Utils.filterAnsiEscapeCodes(res || '');
				_this21.logContent = cleanContent || '暂无日志内容';
				_this21.viewLogShow = true;
				console.log('弹窗应该显示了, viewLogShow:', _this21.viewLogShow);
			}).catch(function (err) {
				console.error('日志加载失败:', err);
				_this21.viewLogLoading = false;
				_this21.$message.error('日志内容加载失败');
			});
		},
		closeViewLogDialog: function closeViewLogDialog() {
			this.viewLogShow = false;
			this.logContent = '';
		}
	},
	watch: {
		$route: function $route(to, from) {
			this.setSearchData();
			this.getProjectResource(1);
		}
	},
	components: {
		WorkgroupOnlineConnection: __WEBPACK_IMPORTED_MODULE_4__model_workgroup_online_connection___default.a,
		WorkgroupConnectLogs: __WEBPACK_IMPORTED_MODULE_5__model_workgroup_connection_logs___default.a,
		LinuxConfig: __WEBPACK_IMPORTED_MODULE_8__model_linux_config___default.a,
		ManageCode: __WEBPACK_IMPORTED_MODULE_9__model_manage_code___default.a,
		WorkGroupAssist: __WEBPACK_IMPORTED_MODULE_11__model_workgroup_assist___default.a,
		WorkgroupApply: __WEBPACK_IMPORTED_MODULE_7__model_workgroup_apply___default.a,
		CodemirrorEditor: __WEBPACK_IMPORTED_MODULE_12__model_code_mirror_editor_vue___default.a
	}
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'WorkGroup',
	data: function data() {
		return {
			searchData: this.$route.query,
			pageSize: __WEBPACK_IMPORTED_MODULE_4__config__["g" /* Utils */].config.pageSize,
			mode: 1,
			searchCondition: 'q_name',
			searchKey: '',
			favourites: [],
			workgroup: {},
			currentPage: 1,
			loading: true
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	mounted: function mounted() {
		this.getList(1, this.$route.query);
		this.getFavourites();
		this.setSearchData();
	},

	methods: {
		getTranTest: function getTranTest(clusters) {
			var translated = this.$ngettext('%{ n } resource', '%{ n } resources', clusters);
			var interpolated = this.$gettextInterpolate(translated, { n: clusters });
			return interpolated;
		},
		getTranslateText: function getTranslateText() {
			return {
				searchKey: this.$gettext('please input search key'),
				select: this.$gettext('select'),
				name: this.$gettext('Name')
			};
		},
		rowClick: function rowClick(row, event, column) {
			var searchData = {};
			if (this.searchKey !== '' && this.searchCondition) {
				searchData[this.searchCondition] = this.searchKey;
			}
			this.$router.push({ name: 'workgroupdetail', params: { id: row.id }, query: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ type: this.$route.type || 'ecs' }, this.$route.query) });
		},
		clearSearchInput: function clearSearchInput() {
			this.searchKey = '';
		},
		setSearchData: function setSearchData() {
			var _this = this;

			var _query = this.$route.query;
			if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_query).length) {
				var _loop = function _loop(k) {
					if (k == 'q_ip' || k == 'q_name') {
						_this.searchCondition = k;
						setTimeout(function () {
							_this.searchKey = _query[k];
						}, 200);
					}
				};

				for (var k in _query) {
					_loop(k);
				}
			} else {
				this.searchKey = '';
				this.searchCondition = 'q_name';
			}
		},
		onSearch: function onSearch(pageIndex) {
			var params = {};
			if (this.searchKey !== '' && this.searchCondition) {
				params[this.searchCondition] = this.searchKey;
			}

			this.$router.push({ path: this.$route.path, query: params });
		},
		onChangeMode: function onChangeMode(mode) {
			this.mode = mode;
		},
		onCurrentChange: function onCurrentChange(currentPage) {
			console.log('currentPage', currentPage);
			this.getList(currentPage, { total: this.workgroup.total });
		},
		getList: function getList(pageIndex, _params) {
			var _this2 = this;

			this.loading = true;
			var params = {
				page: pageIndex
			};
			if (_params) {
				params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, params, _params);
			}
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP, params).then(function (res) {
				_this2.loading = false;
				_this2.workgroup = res;
				_this2.loading = false;
			}, function () {
				_this2.loading = false;
			});
		},
		getFavourites: function getFavourites() {
			var _this3 = this;

			var params = {
				page_size: __WEBPACK_IMPORTED_MODULE_4__config__["g" /* Utils */].config.maxPageSize,
				q_favourite: true
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP, params).then(function (res) {
				_this3.favourites = res.objects;
			});
		},
		setFavourite: function setFavourite(row, isFavourite) {
			var _this4 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].WORKGROUP.SET_FAVOURITE, {
				id: row.id,
				favourite: isFavourite ? 1 : 0
			}).then(function (res) {
				var workGroup = null;
				if (isFavourite) {
					workGroup = row;
					_this4.favourites = [__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, row, { favourite: 1 })].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this4.favourites));
				} else {
					workGroup = _this4.workgroup.objects.find(function (item) {
						return item.id === row.id;
					});
					_this4.favourites.splice(_this4.favourites.indexOf(row), 1);
					if (!_this4.favourites || !_this4.favourites.length) {
						_this4.mode = 1;
					}
				}
				if (workGroup) {
					_this4.$set(_this4.workgroup.objects, _this4.workgroup.objects.indexOf(workGroup), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, workGroup, { favourite: isFavourite ? 1 : 0 }));
				}
			});
		},
		exportExcel: function exportExcel(row) {
			window.open(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].apiUrl + '/v1/project/resources/' + row.id + '/export', '__blank');
		}
	},
	watch: {
		$route: function $route(to, from) {
			this.setSearchData();
			this.getList(1, this.$route.query);
		}
	}
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_echarts_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_echarts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_echarts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_moment__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__node_modules_moment__);









var THEME_COLORS = {
	pie: ['#1890ff', '#722ed1', '#00c48c', '#fa8c16', '#f5222d'],

	line: '#4895ef',

	multiLine: ['#4895ef', '#fa8c16', '#00c48c', '#722ed1'],

	bar: '#1890ff'
};

/* harmony default export */ __webpack_exports__["default"] = ({
	components: { Echarts: __WEBPACK_IMPORTED_MODULE_2__components_common_echarts_vue___default.a },

	data: function data() {
		var _this = this;

		return {
			accountList: [],

			overviewData: {
				resources: 0,
				projects: 0,
				networks: 0,
				accounts: 0
			},

			statRowData: {
				conn_account_count: 0,
				resource_count: 0,
				conn_count: 0,
				notice_count: 0,
				avg_days_conn_count: 0,
				conn_time: '0',
				avg_days_conn_time: '0',
				avg_conn_time: '0'
			},

			connectCountPie: {
				title: { text: '连接次数/资源类型', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: { trigger: 'item', formatter: '{b}: {c} （{d}%）' },
				legend: {
					show: false,
					type: 'scroll',
					orient: 'vertical',
					right: 10,
					top: 20,
					formatter: function formatter(name) {
						var item = _this.connectCountPie.series[0].data.find(function (i) {
							return i.name === name;
						});
						return name + '\n' + item.value + ' (' + item.percent + '%)';
					}
				},
				series: [{
					name: '连接次数',
					radius: ['30%', '60%'],
					center: ['50%', '50%'],

					label: {
						show: true,
						position: 'outside',
						rich: {
							line1: {
								align: 'left',
								width: 80 },
							line2: {
								align: 'left'
							}
						},
						formatter: '{line1|{b}}\n{line2|{c} ({d}%)}',
						fontSize: 12
					},

					labelLine: {
						show: true,
						smooth: false,
						length: 10,
						length2: 30,
						lineStyle: {
							type: 'dashed',
							color: '#666',
							width: 1 },

						silent: true,
						showAbove: true },
					itemStyle: {
						color: function color(params) {
							return THEME_COLORS.pie[params.dataIndex % THEME_COLORS.pie.length];
						}
					},

					data: [{ name: 'MySQL', value: 13, percent: 6 }, { name: 'SQL server', value: 13, percent: 6 }, { name: 'PostgreSQL', value: 13, percent: 6 }, { name: 'Windows(RDP)', value: 13, percent: 6 }, { name: 'Linux(SSH)', value: 13, percent: 6 }]
				}]
			},

			connectCountLine: {
				title: { text: '连接次数', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: {
					trigger: 'axis',
					backgroundColor: '#000',
					textStyle: { color: '#fff', fontSize: 12 },
					padding: 10,
					borderRadius: 4,
					formatter: function formatter(params) {
						var html = '<div style="margin-bottom:8px;">' + params[0].axisValue + '</div>';

						params.forEach(function (item) {
							var dot = '<span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:' + item.color + '; margin-right:6px;"></span>';

							html += '<div style="line-height:1.8;">' + dot + item.seriesName + '\uFF1A' + item.value + '</div>';
						});
						return html;
					},
					axisPointer: { type: 'line', lineStyle: { color: '#999' } }
				},
				legend: { top: 'top', right: 'center', show: false },
				grid: { left: '5%', right: '5%', bottom: '10%', containLabel: true },
				xAxis: {
					data: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30']
				},
				yAxis: { type: 'value', min: 0 },
				series: [{
					name: '连接次数',
					symbol: 'circle',
					symbolSize: 6,
					smooth: false,
					lineStyle: { width: 2, color: THEME_COLORS.line },
					itemStyle: { color: THEME_COLORS.line },

					data: [15, 15, 0, 30, 15, 60, 30, 15, 15, -5, 0, 5]
				}]
			},

			connectTimePie: {
				title: { text: '连接时长（小时）/资源类型', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: { trigger: 'item', formatter: '{b}: {c}小时 ({d}%)' },
				legend: {
					show: false,
					type: 'scroll',
					orient: 'vertical',
					right: 10,
					top: 20,
					formatter: function formatter(name) {
						var item = _this.connectTimePie.series[0].data.find(function (i) {
							return i.name === name;
						});
						return name + '\n' + item.value + '\u5C0F\u65F6 (' + item.percent + '%)';
					}
				},
				series: [{
					name: '连接时长',
					radius: ['30%', '60%'],
					center: ['50%', '60%'],

					label: {
						show: true,
						position: 'outside',
						rich: {
							line1: {
								align: 'left',
								width: 80 },
							line2: {
								align: 'left'
							}
						},
						formatter: '{line1|{b}}\n{line2|{c} ({d}%)}',
						fontSize: 12
					},

					labelLine: {
						show: true,
						smooth: false,
						length: 10,
						length2: 30,
						lineStyle: {
							type: 'dashed',
							color: '#666',
							width: 1 },

						silent: true,
						showAbove: true },
					itemStyle: {
						color: function color(params) {
							return THEME_COLORS.pie[params.dataIndex % THEME_COLORS.pie.length];
						}
					},

					data: [{ name: 'MySQL', value: 13, percent: 6 }, { name: 'SQL server', value: 13, percent: 6 }, { name: 'PostgreSQL', value: 13, percent: 6 }, { name: 'Windows(RDP)', value: 13, percent: 6 }, { name: 'Linux(SSH)', value: 13, percent: 6 }]
				}]
			},

			connectTimeLine: {
				title: { text: '连接时长（小时）', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: {
					trigger: 'axis',
					backgroundColor: '#000',
					textStyle: { color: '#fff', fontSize: 12 },
					padding: 10,
					borderRadius: 4,
					formatter: function formatter(params) {
						var html = '<div style="margin-bottom:8px;">' + params[0].axisValue + '</div>';

						params.forEach(function (item) {
							var dot = '<span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:' + item.color + '; margin-right:6px;"></span>';

							html += '<div style="line-height:1.8;">' + dot + item.seriesName + '\uFF1A' + item.value + '</div>';
						});
						return html;
					},
					axisPointer: { type: 'line', lineStyle: { color: '#999' } }
				},
				legend: { top: 'top', right: 'center', show: false },
				grid: { left: '5%', right: '5%', bottom: '10%', containLabel: true },
				xAxis: {
					data: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30']
				},
				yAxis: { type: 'value', min: 0 },
				series: [{
					name: '连接时长',
					symbol: 'circle',
					symbolSize: 6,
					smooth: false,
					lineStyle: { width: 2, color: THEME_COLORS.line },
					itemStyle: { color: THEME_COLORS.line },

					data: [15, 15, 0, 30, 15, 60, 30, 15, 15, -5, 0, 5]
				}]
			},

			alertTopTable: [],

			alertMultiLine: {
				title: { text: '告警指令（类型/次数/日期）', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: {
					trigger: 'axis',
					backgroundColor: '#000',
					textStyle: { color: '#fff', fontSize: 12 },
					padding: 10,
					borderRadius: 4,
					formatter: function formatter(params) {
						var html = '<div style="margin-bottom:8px;">' + params[0].axisValue + '</div>';

						params.forEach(function (item) {
							var dot = '<span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:' + item.color + '; margin-right:6px;"></span>';

							html += '<div style="line-height:1.8;">' + dot + item.seriesName + '\uFF1A' + item.value + '</div>';
						});
						return html;
					},
					axisPointer: { type: 'line', lineStyle: { color: '#999' } }
				},
				legend: { top: 'top', right: 'center', show: false },
				grid: { left: '5%', right: '5%', bottom: '10%', containLabel: true },
				xAxis: {
					data: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30']
				},
				yAxis: { type: 'value' },
				series: []
			},

			memberConnectTop: [],

			memberTimeTop: [],

			alertMemberTop: [],

			resourceConnectTop: [],

			resourceTimeTop: [],

			resourceAlertTop: []
		};
	},

	methods: {
		getStatisticSummary: function getStatisticSummary(params) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								return _context.abrupt('return', _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].DASHBOARD.GET_STATISTIC_SUMMARY, params).then(function (res) {
									console.log(res, 'res');
									for (var k in _this2.overviewData) {
										_this2.overviewData[k] = res[k];
									}

									for (var _k in _this2.statRowData) {
										_this2.statRowData[_k] = res[_k];
										if (['conn_time', 'avg_days_conn_time', 'avg_conn_time'].includes(_k)) {
											_this2.statRowData[_k] = (res[_k] / 3600).toFixed(2);
										}
									}

									_this2.connectCountPie.series[0].data = res.resource_type_conn_count.map(function (item) {
										for (var _k2 in item) {
											return {
												name: _k2,
												value: item[_k2]
											};
										}
									});

									_this2.connectCountLine.xAxis.data = res.conversation.map(function (item) {
										return item.date;
									});
									_this2.connectCountLine.series[0].data = res.conversation.map(function (item) {
										return item.conn_count;
									});

									_this2.connectTimePie.series[0].data = res.resource_type_conn_time.map(function (item) {
										for (var _k3 in item) {
											return {
												name: _k3,
												value: item[_k3]
											};
										}
									});

									_this2.connectTimeLine.xAxis.data = res.conversation.map(function (item) {
										return item.date;
									});
									_this2.connectTimeLine.series[0].data = res.conversation.map(function (item) {
										return item.conn_time;
									});

									_this2.alertTopTable = res.match_command || [];

									_this2.alertMultiLine.xAxis.data = res.notice_command.map(function (item) {
										return item.day;
									});

									var resourceTypes = [{ name: 'MSSQL', color: '#f5222d' }, { name: 'MySQL', color: '#722ed1' }, { name: 'PostgreSQL', color: '#00c48c' }, { name: 'Windows（RDP）', color: '#fa8c16' }, { name: 'Linux（SSH）', color: '#4895ef' }];
									_this2.alertMultiLine.series = resourceTypes.map(function (type) {
										return {
											name: type.name,
											type: 'line',
											smooth: false,
											itemStyle: { color: type.color },
											lineStyle: { color: type.color },
											data: res.notice_command.map(function (item) {
												return item[type.name];
											})
										};
									});

									_this2.memberConnectTop = res.account_conn_count || [];

									_this2.memberTimeTop = res.account_conn_time || [];

									_this2.alertMemberTop = res.alarm_account_count || [];

									_this2.resourceConnectTop = res.resource_conn_count || [];

									_this2.resourceTimeTop = res.resource_conn_time || [];

									_this2.resourceAlertTop = res.alarm_resource_count || [];
								}));

							case 1:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}))();
		}
	},
	mounted: function mounted() {
		var _this3 = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							console.log(_this3.$route.query, 'query');

							_context2.next = 3;
							return _this3.getStatisticSummary(_this3.$route.query);

						case 3:
							document.title = 'CloudLinker \u8FD0\u7EF4\u5BA1\u8BA1\u62A5\u544A_' + __WEBPACK_IMPORTED_MODULE_4__node_modules_moment___default()(_this3.$route.query.time_from * 1000).format('YYYY-MM-DD') + '_' + __WEBPACK_IMPORTED_MODULE_4__node_modules_moment___default()(_this3.$route.query.time_end * 1000).format('YYYY-MM-DD') + ' ';
							setTimeout(function () {
								window.print();
							}, 1000);

						case 5:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, _this3);
		}))();
	}
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_account_edit_name_vue__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_account_edit_name_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__model_account_edit_name_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'accountInfo',
	data: function data() {
		return {
			loading: true,
			currentTeam: {},
			currentRightPanel: null,
			rightPanelData: null
		};
	},
	created: function created() {
		this.getCurrentTeam();
	},

	computed: {
		currentAccount: function currentAccount() {
			return this.$store.getters.account;
		}
	},
	methods: {
		getCurrentTeam: function getCurrentTeam() {
			var _this = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].TEAM.CURRENT).then(function (res) {
				_this.loading = false;
				_this.currentTeam = Object.clone(_this.$store.getters.team.setting);
			}, function () {
				_this.loading = false;
			});
		},
		fileClick: function fileClick() {
			document.getElementById('file').click();
		},
		onChange: function onChange(e) {
			var _this2 = this;

			var files = e.target.files;
			var allFiles = [];

			var _loop = function _loop(i) {
				var file = files[i];
				var reader = new FileReader();

				reader.readAsDataURL(file);
				reader.onload = function () {
					var fileInfo = {
						name: file.name,
						type: file.type,
						size: Math.round(file.size),
						base64: reader.result,
						file: file
					};
					allFiles.push(fileInfo);

					var flieType = fileInfo.type.split('/')[1];
					console.log('fileInfo,type', flieType);
					if (fileInfo.size > 1 * 1024 * 1024) {
						_this2.$notify({
							message: _this2.$gettext('The maximum supported file size is 1M.'),
							type: 'warning'
						});
					} else {
						if (flieType === 'png' || flieType === 'jpeg' || flieType === 'gif') {
							if (allFiles.length === files.length) {
								var params = {
									content: allFiles[0].base64.split('base64,')[1],
									extension: allFiles[0].name.split('.')[1],
									file_name: allFiles[0].name,
									file_size: allFiles[0].size
								};
								_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.CAANGE_AVATAR, params).then(function (res) {
									var params = {
										avatar: '/file/' + res.url
									};
									_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.UPDATE, { data: params }).then(function (res) {
										_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.CURRENT);
										_this2.$notify({
											message: _this2.$gettext('Change avatar successfully!'),
											type: 'success'
										});
									});
								});
							}
						} else {
							_this2.$notify({
								type: 'warning',
								message: _this2.$gettext('wrong file type')
							});
						}
					}
					e.target.value = '';
				};
			};

			for (var i = 0; i < files.length; i++) {
				_loop(i);
			}
		},
		trimSapce: function trimSapce(rule, value, callback) {
			console.log('rule', rule, value);
			if (value.match(/^\s+$/)) {
				if (this.currentRightPanel === __WEBPACK_IMPORTED_MODULE_1__model_account_edit_name_vue___default.a) {
					callback(new Error(this.$gettext('Please input the name')));
				}
			} else {
				value = value.trim();
				callback();
			}
		},
		showEditName: function showEditName() {
			var _this3 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'EditName' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_1__model_account_edit_name_vue___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this3.rightPanelData = {
						name: {
							label: _this3.$gettext('Display Nickname:'),
							labelWidth: 280,
							val: Object.clone(_this3.$store.getters.account.name),
							rule: [{
								required: true,
								message: _this3.$gettext('Please input the name'),
								trigger: 'blur'
							}, { max: 20, message: _this3.$gettext('length is within 20 characters'), trigger: 'change' }, { validator: _this3.trimSapce, trigger: 'blur' }]
						}
					};
				}, time);
			});
		},
		onClosePanel: function onClosePanel() {
			this.currentRightPanel = null;
			this.rightPanelData = null;
		}
	},
	components: {
		EditName: __WEBPACK_IMPORTED_MODULE_1__model_account_edit_name_vue___default.a
	}
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_account_change_mobile__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_account_change_mobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__model_account_change_mobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_account_change_password__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_account_change_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__model_account_change_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_account_open_mfa__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_account_open_mfa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__model_account_open_mfa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_account_close_mfa__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_account_close_mfa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__model_account_close_mfa__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      accountInfo: {},
      currentRightPanel: null,
      rightPanelData: null,
      showTipModal: false
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getAttrText();
    }
  },
  created: function created() {
    var _this = this;

    if (Object.isEmpty(this.$store.getters.account)) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].ACCOUNT.CURRENT).then(function (res) {
        _this.getAccountInfo(res.id);
      });
    } else {
      console.log('getters.account', this.$store.getters.account);
      this.accountInfo = this.$store.getters.account;
      this.getAccountInfo(this.$store.getters.account.id);
    }
  },

  methods: {
    getAttrText: function getAttrText() {
      return {
        change: this.$gettext('Change'),
        bindMobile: this.$gettext('Bind Mobile'),
        enabled: this.$gettext('Enabled'),
        unopened: this.$gettext('Unopened'),
        close: this.$gettext('Off'),
        open: this.$gettext('On')
      };
    },
    getAccountInfo: function getAccountInfo(id) {
      var _this2 = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].ACCOUNT.GET_SUCH_ACCOUNT, id).then(function (res) {
        _this2.loading = false;
        _this2.accountInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.accountInfo, res);
        console.log('accountInfo', _this2.accountInfo);
        if (_this2.$route.query.changePwd && _this2.$store.getters.team.setting.password_strength && _this2.$store.getters.account.password_strength.password_ok !== undefined && _this2.$store.getters.account.password_strength.password_ok === false) {
          _this2.$nextTick(function () {
            _this2.showTipModal = true;
            _this2.onChangePassword();
          });
        }
      }, function () {
        _this2.loading = false;
      });
    },
    onMfaOpen: function onMfaOpen() {
      this.accountInfo.otp_enabled ? this.onCloseMfa() : this.onOpenMfa();
    },
    onShowChangeMobile: function onShowChangeMobile() {
      var _this3 = this;

      var time = !this.currentRightPanel || this.currentRightPanel.name === 'AccountChangeMobile' ? 0 : 300;
      this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_3__model_account_change_mobile___default.a;
      this.$nextTick(function () {
        setTimeout(function () {
          _this3.rightPanelData = Object.clone(_this3.accountInfo);
        }, time);
      });
    },
    onOpenMfa: function onOpenMfa() {
      var _this4 = this;

      var time = !this.currentRightPanel || this.currentRightPanel.name === 'AccountMfaOpen' ? 0 : 300;
      this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_5__model_account_open_mfa___default.a;
      this.$nextTick(function () {
        setTimeout(function () {
          _this4.rightPanelData = Object.clone(_this4.accountInfo);
        }, time);
      });
    },
    onCloseMfa: function onCloseMfa() {
      var _this5 = this;

      var time = !this.currentRightPanel || this.currentRightPanel.name === 'AccountMfaClose' ? 0 : 300;
      this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_6__model_account_close_mfa___default.a;
      this.$nextTick(function () {
        setTimeout(function () {
          _this5.rightPanelData = {
            'first_code': {
              label: _this5.$gettext('Security Code'),
              val: '',
              rule: [{
                required: true, pattern: /^\d{6}$/, message: _this5.$gettext('Enter the 6-digit security code'), trigger: 'blur'
              }]
            }
          };
        }, time);
      });
    },
    onChangePassword: function onChangePassword() {
      var _this6 = this;

      var time = !this.currentRightPanel || this.currentRightPanel.name === 'AccountChangePassword' ? 0 : 300;
      this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_4__model_account_change_password___default.a;
      this.$nextTick(function () {
        setTimeout(function () {
          _this6.rightPanelData = [];
        }, time);
      });
    },
    onClosePanel: function onClosePanel() {
      var _this7 = this;

      console.log('--closed panel--');
      this.currentRightPanel = null;
      this.rightPanelData = null;
      var passwordOk = this.$store.getters.account.password_strength ? this.$store.getters.account.password_strength.password_ok !== undefined && this.$store.getters.account.password_strength.password_ok === false : false;
      if (this.currentRightPanel == null && this.$store.getters.team.setting.password_strength && passwordOk) {
        var h = this.$createElement;
        var level = this.$store.getters.team.setting.password_strength;
        this.showTipModal = false;
        this.$msgbox({
          title: this.$gettext('prompt'),
          center: true,
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false,
          confirmButtonText: this.$gettext('Change Password'),
          customClass: 'password_strength_modal',
          beforeClose: function beforeClose(action, instance, done) {
            _this7.onChangePassword();
            done();
            _this7.showTipModal = true;
          },
          message: h('p', null, [h('p', { style: 'margin-bottom: 20px;' }, this.$gettext('Your current login password complexity does not meet the password strength requirements set by the team administrator. Please change the password before continuing to use.')), h('p', null, this.$gettext(__WEBPACK_IMPORTED_MODULE_2__config__["e" /* PasswordStrengthMessage */][level]))])
        });
      }
    }
  },
  components: {
    AccountChangePassword: __WEBPACK_IMPORTED_MODULE_4__model_account_change_password___default.a,
    AccountChangeMobile: __WEBPACK_IMPORTED_MODULE_3__model_account_change_mobile___default.a,
    AccountMfaOpen: __WEBPACK_IMPORTED_MODULE_5__model_account_open_mfa___default.a,
    AccountMfaClose: __WEBPACK_IMPORTED_MODULE_6__model_account_close_mfa___default.a
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountChangeMobile',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      accountInfo: null,
      changePhoneNumForm: {
        mobile: '',
        code: '',
        time: 0,
        canWriteCode: true,
        disMobile: false,
        canSubmit: true,
        canClick: true
      }
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTransitionText();
    },
    text: function text() {
      return this.changePhoneNumForm.time > 0 ? this.changePhoneNumForm.time + 's' + this.$gettext('Retry After') : this.$gettext('Send Verify Code');
    }
  },
  methods: {
    getTransitionText: function getTransitionText() {
      return {
        'bindMobile': this.$gettext('Bind Mobile'),
        'changeMobile': this.$gettext('Change Mobile'),
        'mobileNum': this.$gettext('Mobile Number'),
        'verifyCode': this.$gettext('Verify Code'),
        'pleaseinputMobil': this.$gettext('Please input mobile number'),
        'pleaseinputverifyCode': this.$gettext('Please input verify code')
      };
    },
    onSubmitVerify: function onSubmitVerify() {
      var _this = this;

      var data = {
        data: {
          'mobile': this.changePhoneNumForm.mobile
        }
      };

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.UPDATE, data).then(function (res) {
        _this.$emit('callback', _this.$store.getters.account.id);
        _this.onClose();
        _this.$notify({
          message: _this.$gettext('Change successful'),
          type: 'success'
        });
      }).catch(function () {
        _this.$notify.error({
          message: _this.$gettext('Verification code error')
        });
        _this.$refs['rightPanel'].onSubmitErr();
      });
    },
    onClose: function onClose() {
      this.accountInfo = null;
      this.$emit('onClosePanel');
    },
    checkMobile: function checkMobile(val) {
      if (/^1[34578]\d{9}$/.test(val) && val !== this.accountInfo.mobile) {
        this.changePhoneNumForm.canSubmit = false;
      } else {
        this.changePhoneNumForm.canSubmit = true;
      }
    },
    checkCode: function checkCode(val) {
      if (/^\d{6}$/.test(val)) {
        this.changePhoneNumForm.canSubmit = false;
      } else {
        this.changePhoneNumForm.canSubmit = true;
      }
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        if (this.accountInfo) {
          this.accountInfo = null;
          setTimeout(function () {
            _this2.accountInfo = _this2.items;
          }, 300);
        } else {
          this.accountInfo = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountChangePassword',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    var _this = this;

    var pass = function pass(rule, value, callback) {
      var level = _this.company_password_strength;
      var uppercasePattern = __WEBPACK_IMPORTED_MODULE_2__config__["c" /* PasswordStrengthRegExp */].uppercasePattern;
      var lowercasePattern = __WEBPACK_IMPORTED_MODULE_2__config__["c" /* PasswordStrengthRegExp */].lowercasePattern;
      var sysbolPattern = __WEBPACK_IMPORTED_MODULE_2__config__["c" /* PasswordStrengthRegExp */].sysbolPattern;
      var uppercaseRes = uppercasePattern.test(value);
      var lowercaseRes = lowercasePattern.test(value);
      var sysbolRes = sysbolPattern.test(value);
      if (value.length) {
        if (level === 1) {
          if (value.length >= 6 && (lowercaseRes && uppercaseRes || lowercaseRes && sysbolRes || uppercaseRes && sysbolRes)) {
            callback();
          } else {
            _this.show_password_warning = false;
            callback(new Error(_this.$gettext(__WEBPACK_IMPORTED_MODULE_2__config__["d" /* PasswordStrengthRegExpCallback */].level1_msg)));
          }
        } else if (level === 2) {
          if (value.length >= 8 && lowercaseRes && uppercaseRes && sysbolRes) {
            callback();
          } else {
            _this.show_password_warning = false;
            callback(new Error(_this.$gettext(__WEBPACK_IMPORTED_MODULE_2__config__["d" /* PasswordStrengthRegExpCallback */].level2_msg)));
          }
        } else {
          callback();
        }
      } else {
        callback(new Error(_this.$gettext('Please enter your password!')));
      }
      if (_this.passWordForm.checkPass !== '') {
        _this.$refs.passForm.validateField('checkPass');
      }
    };
    var checkPass = function checkPass(rule, value, callback) {
      if (value === '') {
        callback(new Error(_this.$gettext('Please enter your password again!')));
      } else if (value !== _this.passWordForm.pass) {
        callback(new Error(_this.$gettext('Two passwords are not consistent!')));
      } else {
        callback();
      }
    };
    return {
      connects: null,
      passWordForm: {
        pass: '',
        checkPass: ''
      },
      rules: {
        pass: [{ validator: pass, trigger: 'change' }],
        checkPass: [{ validator: checkPass, trigger: 'change' }]
      },
      company_password_strength: this.$store.getters.team.setting.password_strength || 0,
      show_password_warning: this.$store.getters.team.setting.password_strength !== '0'
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTranslateText();
    }
  },
  methods: {
    getTranslateText: function getTranslateText() {
      return {
        password: this.$gettext('Password'),
        repeatpass: this.$gettext('repeat password')
      };
    },
    onSubmitForm: function onSubmitForm(formName) {
      var _this2 = this;

      var params = {
        data: {
          pwd: this.passWordForm.pass
        }
      };
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.UPDATE, params).then(function (res) {
            _this2.$refs.rightPanel.onClose();
            _this2.isShow = false;
            _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.LOGOUT).then(function (res) {
              _this2.$router.push('/login');
              _this2.$notify({
                message: _this2.$gettext('Modify password successfully,Please Re Login'),
                type: 'success'
              });
            });
          });
        } else {
          return false;
        }
      });
    },
    onCloseChange: function onCloseChange() {
      this.connects = null;
      this.$emit('onClosePanel');
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this3 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this3.connects = _this3.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountMfaClose',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null
    };
  },

  methods: {
    onSubmitForm: function onSubmitForm() {
      var _this = this;

      this.$refs['right-mfa-panel'].onClose();
      var params = {
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ otp_enabled: 0 }, this.$refs['right-mfa-panel'].profileModel)
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].ACCOUNT.POST_MFA_CODE, params).then(function () {
        _this.$notify({
          message: _this.$gettext('Close Successfully!'),
          type: 'success'
        });
        _this.$emit('callback', _this.$store.getters.account.id);
      });
    },
    onCloseForm: function onCloseForm() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this2.connects = _this2.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'EditName',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null
		};
	},

	methods: {
		onSubmitForm: function onSubmitForm() {
			var _this = this;

			var params = {
				name: this.$refs['right-panel'].profileModel.name
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.UPDATE, { data: params }).then(function () {
				_this.onCloseForm();
				_this.$notify({
					message: _this.$gettext('Change successful'),
					type: 'success'
				});
				_this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.CURRENT);
			}).catch(function (err) {
				console.log('err', err);
				_this.$refs['right-panel'].onSubmitErr();
			});
		},
		onCloseForm: function onCloseForm() {
			this.connects = null;
			this.$emit('onClosePanel');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this2 = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this2.connects = _this2.items;
					}, 300);
				} else {
					this.connects = this.items;
				}
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
	}
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountMfaOpen',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      accountInfo: null,
      mfa: {
        nextStep: false,
        activeTab: 'first',
        securityNumForm: {
          mfaEwm: '',
          firstCode: '',
          secondCode: ''
        },
        secret: {}
      },
      rules: {
        firstCode: [{ required: true, pattern: /^\d{6}$/, message: this.$gettext('Enter the 6-digit security code'), trigger: 'blur' }],
        secondCode: [{ required: true, pattern: /^\d{6}$/, message: this.$gettext('Enter the 6-digit security code'), trigger: 'blur' }]
      }
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTranslateText();
    }
  },
  methods: {
    getTranslateText: function getTranslateText() {
      return {
        'firstCode': this.$gettext('First column verification code'),
        'secondCode': this.$gettext('Second column verification code'),
        'enterCode': this.$gettext('Enter the 6-digit security code')
      };
    },
    onNextStep: function onNextStep() {
      this.resetForm('securityNumForm');

      this.mfa.secret = '';
      this.mfa.securityNumForm.mfaEwm = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* baseUrl */].apiUrl + '/mfa/img?t=' + new Date().getTime();
      console.log('mfaEwm==>', this.mfa.securityNumForm.mfaEwm);
      this.mfa.activeTab = 'first';
      this.mfa.nextStep = true;
    },
    onTabClick: function onTabClick(v) {
      var _this = this;

      this.mfa.activeTab = v.name;
      if (this.mfa.activeTab === 'second' && !this.mfa.secret) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.GET_MFA_SECRET).then(function (res) {
          _this.mfa.secret = res;
        });
      }
      this.resetForm('securityNumForm');
    },
    submitMfaString: function submitMfaString(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var params = {
            data: {
              first_code: _this2.mfa.securityNumForm.firstCode,
              second_code: _this2.mfa.securityNumForm.secondCode,
              otp_enabled: 1
            }
          };
          _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.POST_MFA_CODE, params).then(function (res) {
            _this2.$notify({
              type: 'success',
              message: _this2.$gettext('Open success!')
            });
            _this2.$emit('callback', _this2.$store.getters.account.id);
            _this2.$refs.rightPanel.onClose();
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onClose: function onClose() {
      this.accountInfo = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this3 = this;

        if (this.accountInfo) {
          this.accountInfo = null;
          setTimeout(function () {
            _this3.accountInfo = _this3.items;
          }, 300);
        } else {
          this.accountInfo = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddSshkey',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null
    };
  },

  methods: {
    onSubmitAddForm: function onSubmitAddForm() {
      var _this = this;

      var params = {
        data: this.$refs['right-panel-add'].profileModel
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].SSHKEY.ADD, params).then(function (res) {
        _this.$notify({
          message: _this.$gettext('Add Successfully!'),
          type: 'success'
        });
        _this.onCloseForm();
        _this.$emit('callback');
        _this.$refs['right-panel-add'].onSubmitErr();
      }).catch(function (err) {
        console.log('err', err);
        _this.$refs['right-panel-add'].onSubmitErr();
      });
    },
    onCloseForm: function onCloseForm() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this2.connects = _this2.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_add_sshkey__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_add_sshkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__model_add_sshkey__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false,
      sshKeyList: [],
      totalCount: 0,
      currentPage: 1,
      currentRightPanel: null,
      rightPanelData: null
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getAttrText();
    }
  },
  created: function created() {
    this.getSshKeys();
  },

  methods: {
    getAttrText: function getAttrText() {
      return {
        name: this.$gettext('Name'),
        latestVerifiTiem: this.$gettext('The Time Of Latest Verification'),
        addTime: this.$gettext('Add Time'),
        action: this.$gettext('Action')
      };
    },
    getSshKeys: function getSshKeys(page) {
      var _this = this;

      this.currentPage = page || 1;
      this.loading = true;
      var params = {
        page: page || 1,
        q: {
          order_by: [{ 'field': 'create_time', 'direction': 'desc' }]
        }
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].SSHKEY.GET, { params: params }).then(function (res) {
        _this.loading = false;
        _this.sshKeyList = _this.$store.getters.sshKey;
        _this.totalCount = res.num_results;
      });
    },
    onChangePage: function onChangePage(page) {
      this.getSshKeys(page);
    },
    delSshkey: function delSshkey(id) {
      var _this2 = this;

      this.$confirm(this.$gettext('Confirm to delete the SSH KEY?'), this.$gettext('prompt'), {
        confirmButtonText: this.$gettext('OK'),
        cancelButtonText: this.$gettext('Cancel'),
        type: 'warning'
      }).then(function () {
        _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].SSHKEY.DEL, id).then(function () {
          _this2.getSshKeys();
          _this2.$notify({
            type: 'success',
            message: _this2.$gettext('successfully deleted!')
          });
        });
      }).catch(function () {});
    },
    onShowAdd: function onShowAdd() {
      var _this3 = this;

      var time = !this.currentRightPanel || this.currentRightPanel.name === 'AddSshkey' ? 0 : 300;
      this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_1__model_add_sshkey___default.a;
      this.$nextTick(function () {
        setTimeout(function () {
          _this3.rightPanelData = {
            'title': {
              label: _this3.$gettext('Name'),
              val: '',
              rule: [{ required: true, message: _this3.$gettext('Please input the name'), trigger: 'blur' }, { max: 20, message: _this3.$gettext('length is within 20 characters'), trigger: 'change' }]
            },
            'pubkey': {
              label: 'Key',
              val: '',
              rule: { required: true, message: _this3.$gettext('Please input the sshkey'), trigger: 'change' },
              type: 'textarea',
              options: {
                autosize: true,
                resize: '300'
              }
            }
          };
        }, time);
      });
    },
    onClosePanel: function onClosePanel() {
      this.rightPanelData = null;
    },
    tableRowClassName: function tableRowClassName(row, index) {
      if (index % 2 === 0) {
        return 'info-row';
      }
      return '';
    }
  },
  components: {
    AddSshkey: __WEBPACK_IMPORTED_MODULE_1__model_add_sshkey___default.a
  }
});

/***/ }),
/* 259 */
/***/ (function(module, exports) {



/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'purchase',
  data: function data() {
    return {
      currentLan: localStorage.getItem('currentLanguage')
    };
  },
  created: function created() {
    var _this = this;

    console.log(this.currentLan);
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].ACCOUNT.CURRENT).then(function (res) {}).catch(function (err) {
      if (_this.$route.name !== 'login') {
        console.log('login path');
        _this.$notify({
          message: _this.$gettext(err.data.code),
          type: 'success'
        });
      } else {
        console.log('console', _this.$route.name);
      }
    });
  },

  methods: {},
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_account__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var _this = this;

		var checkcontact_address = function checkcontact_address(rule, value, callback) {
			if (value === '') {
				callback(new Error('请输入联系地址'));
			} else {
				callback();
			}
		};

		var checkName = function checkName(rule, value, callback) {
			if (value === '') {
				callback(new Error('请输入昵称'));
			} else {
				callback();
			}
		};

		var checkdomain = function checkdomain(rule, value, callback) {
			if (value === '') {
				callback(new Error('请输团队ID'));
			} else if (!_this.testDomain(value)) {
				callback(new Error('输入值需要2-32位英文或数字'));
			} else {
				callback();
			}
		};

		var checkfull_name = function checkfull_name(rule, value, callback) {
			if (value === '') {
				callback(new Error('请输入公司名称'));
			} else {
				callback();
			}
		};

		var checkSmscode = function checkSmscode(rule, value, callback) {
			if (value === '') {
				callback(new Error('请输入验证码'));
			} else {
				callback();
			}
		};

		var validateEmail = function validateEmail(rule, value, callback) {
			if (value === '') {
				callback(new Error('请输入邮箱'));
			} else if (!_this.checkEmail(value)) {
				callback(new Error('邮箱格式不正确'));
			} else {
				callback();
			}
		};
		return {
			captchaSrc: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* baseUrl */].apiUrl + '/auth/captcha' + '?' + new Date().getTime(),
			captcha: '',
			contact_phone: '16621678619',
			account: 'liuxing@jiagouyun.com',
			name: '',
			ruleForm2: {
				contact_address: '',
				smscode: '',
				name: '',
				domain: '',
				full_name: '',
				email: '',
				agree: false
			},
			rules2: {
				full_name: [{
					validator: checkfull_name,
					trigger: 'change'
				}],
				domain: [{
					validator: checkdomain,
					trigger: 'change'
				}],
				contact_address: [{
					validator: checkcontact_address,
					trigger: 'change'
				}],
				smscode: [{
					validator: checkSmscode,
					trigger: 'change'
				}],
				name1: [{
					validator: checkName,
					trigger: 'change'
				}],
				email: [{
					validator: validateEmail,
					trigger: 'change'
				}]
			},
			buttonText: '获取验证码',
			flag: true
		};
	},

	methods: {
		submitForm: function submitForm(formName) {
			var _this2 = this;

			var content = {
				captcha: this.ruleForm2.smscode,
				company: {
					domain: this.ruleForm2.domain,
					email: this.ruleForm2.email,
					full_name: this.ruleForm2.full_name,
					contact_name: this.ruleForm2.name,
					contact_address: this.ruleForm2.contact_address,
					contact_phone: this.ruleForm2.tel
				},
				account: {
					account: this.ruleForm2.email,
					name: this.ruleForm2.name
				}
			};
			__WEBPACK_IMPORTED_MODULE_0__api_account__["a" /* default */].register(content).then(function (res) {
				_this2.$notify({
					message: _this2.$gettext('Register Successfully!'),
					type: 'success'
				});
				_this2.$router.push('/login');
				_this2.ruleForm2 = _this2.$options.data().ruleForm2;
			}).catch(function (err) {
				_this2.$notify({
					message: _this2.$gettext('Register failed!'),
					type: 'error'
				});
			});
			this.refresh();
		},
		gotoLogin: function gotoLogin() {
			this.$router.push({
				path: '/login'
			});
		},
		checkEmail: function checkEmail(str) {
			var re = /^[A-Za-z0-9\u4e00-\u9fa5]+([._\\-]*[A-Za-z0-9\u4e00-\u9fa5])*@[A-Za-z0-9_-\u4e00-\u9fa5]+(\.[A-Za-z0-9_-\u4e00-\u9fa5]+)+$/;
			if (re.test(str)) {
				return true;
			} else {
				return false;
			}
		},
		testDomain: function testDomain(str) {
			var re = /^[0-9A-Za-z]{2,32}$/;
			if (re.test(str)) {
				return true;
			} else {
				return false;
			}
		},
		refresh: function refresh() {
			this.captchaSrc = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* baseUrl */].apiUrl + '/auth/captcha' + '?' + new Date().getTime();
		}
	}
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_element_ui_packages_button_src_button__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_element_ui_packages_button_src_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_element_ui_packages_button_src_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_element_ui_packages_input_src_input__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_element_ui_packages_input_src_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_element_ui_packages_input_src_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		ElInput: __WEBPACK_IMPORTED_MODULE_2__node_modules_element_ui_packages_input_src_input___default.a,
		ElButton: __WEBPACK_IMPORTED_MODULE_1__node_modules_element_ui_packages_button_src_button___default.a
	},
	name: 'resetPsw',
	data: function data() {
		var _this = this;

		var pass = function pass(rule, value, callback) {
			var level = _this.resetPsw.company_password_strength;
			var uppercasePattern = __WEBPACK_IMPORTED_MODULE_3__config__["c" /* PasswordStrengthRegExp */].uppercasePattern;
			var lowercasePattern = __WEBPACK_IMPORTED_MODULE_3__config__["c" /* PasswordStrengthRegExp */].lowercasePattern;
			var sysbolPattern = __WEBPACK_IMPORTED_MODULE_3__config__["c" /* PasswordStrengthRegExp */].sysbolPattern;
			var uppercaseRes = uppercasePattern.test(value);
			var lowercaseRes = lowercasePattern.test(value);
			var sysbolRes = sysbolPattern.test(value);
			if (value.length) {
				_this.resetPsw.show_password_warning = false;
				if (level === '1') {
					if (value.length >= 6 && (lowercaseRes && uppercaseRes || lowercaseRes && sysbolRes || uppercaseRes && sysbolRes)) {
						callback();
					} else {
						callback(new Error('密码长度最少6位，必须包含大写字母、小写字母、特殊字符中的两项'));
					}
				} else if (level === '2') {
					if (value.length >= 8 && lowercaseRes && uppercaseRes && sysbolRes) {
						callback();
					} else {
						callback('密码长度最少8位，必须包含大写字母、小写字母、特殊字符');
					}
				} else {
					callback();
				}
			} else {
				callback(new Error('请输入密码'));
			}
			if (_this.resetPsw.repeat_pwd !== '') {
				_this.$refs.resetPsw.validateField('repeat_pwd');
			}
		};
		var checkPass = function checkPass(rule, value, callback) {
			if (value === '' && _this.resetPsw.password !== '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== _this.resetPsw.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			resetPsw: {
				account: this.$route.query.account || 'test@me.com',
				password: '',
				repeat_pwd: '',
				company_password_strength: this.$route.query.password_strength || 0,
				show_password_warning: this.$route.query.password_strength !== '0'
			},
			pass: {
				tipOne: '',
				tipReset: ''
			},
			loading: false,
			canSubmit: false,
			rules: {
				password: [{ validator: pass, trigger: 'blur' }],
				repeat_pwd: [{ validator: checkPass, trigger: 'blur' }]
			}
		};
	},

	methods: {
		onResetPsw: function onResetPsw() {
			var _this2 = this;

			this.loading = true;
			var params = {
				code: this.$route.query.code,
				account: this.$route.query.account,
				pwd: this.resetPsw.password
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.RSET_PSWD, params).then(function (res) {
				_this2.loading = false;
				_this2.$notify({
					message: '重置密码成功, 请登录。',
					type: 'success'
				});
				_this2.$router.push('/login');
			}).catch(function () {
				_this2.loading = false;
			});
		},
		resetFields: function resetFields() {
			this.$refs['forgetPswForm'].resetFields();
		}
	},
	watch: {
		resetPsw: {
			handler: function handler(newVal, oldVal) {
				var that = this;
				if (this.$refs['resetPsw']) {
					this.$refs['resetPsw'].validate(function (valid) {
						that.canSubmit = valid;
					});
				}
			},
			deep: true
		}
	}
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_cluster_safe_mode__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_cluster_safe_mode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__model_cluster_safe_mode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_cluster_change_name_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_cluster_change_name_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__model_cluster_change_name_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_cluster_add_instance__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_cluster_add_instance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__model_cluster_add_instance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_cluster_batch_instances__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_cluster_batch_instances___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__model_cluster_batch_instances__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_cluster_scan_import__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_cluster_scan_import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__model_cluster_scan_import__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_cluster_ak_import__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_cluster_ak_import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__model_cluster_ak_import__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_cluster_instance_setting__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_cluster_instance_setting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__model_cluster_instance_setting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_cluster_add_database__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_cluster_add_database___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__model_cluster_add_database__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__model_cluster_database_setting__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__model_cluster_database_setting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__model_cluster_database_setting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__model_cluster_add_share__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__model_cluster_add_share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__model_cluster_add_share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__model_cluster_log_filter__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__model_cluster_log_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__model_cluster_log_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__model_cluster_check_support__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__model_cluster_check_support___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__model_cluster_check_support__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__model_cluster_cloud_ak__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__model_cluster_cloud_ak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__model_cluster_cloud_ak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__model_cluster_config_file_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__model_cluster_config_file_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__model_cluster_config_file_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__model_cluster_set__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__model_cluster_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__model_cluster_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__node_modules_element_ui_packages_button_src_button__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__node_modules_element_ui_packages_button_src_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__node_modules_element_ui_packages_button_src_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Utils__ = __webpack_require__(10);
























/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			loading: false,
			currentRightPanel: null,
			rightPanelData: null,
			newAgentVersion: '',
			refresh: [],
			supportMutipleDatabase: false,
			detail: {
				updateTip: false,
				currentTab: 'ecs',
				info: {},
				list: [],
				totalPage: 0,
				currentPage: 1,
				taskId: '',
				isTest: [],
				agentUpdate: true,
				backAgent: false
			},
			tableHeader: {
				scanDis: false,
				deleteIds: '',
				searchForm: {
					type: '',
					condition: '',
					text: ''
				},
				filters: []
			},
			setting: {
				activeTab: '',
				settingActivetab: 'shareCluster',
				shareList: [],
				logList: [],
				logBatchIds: '',
				available: {
					code: ''
				},
				backAgentCode: '',
				unavailable: {
					check: false,
					disCheck: false,
					code: '',
					regionList: __WEBPACK_IMPORTED_MODULE_4__config__["h" /* ClusterRegionConfig */]
				},
				isUpdateCode: false,
				agent_sha: ''
			},
			unavailableForm: {
				name: 'aliy',
				keyId: '',
				keySecret: '',
				region: '',
				isCanSubmit: false
			},
			upload: {
				isUpload: false,
				resourceId: '',
				username: '',
				password: '',
				status: ''
			},
			cloud: {
				show: false,
				basicInfo: {},
				regions: null,
				zones: null,
				Memory: null,
				RegionName: '',
				ZoneName: '',
				systemDisk: '',
				dataDisk: ''
			},
			cluodDialog: {
				stopInstance: false,
				reStart: false,
				start: false,
				Instances: {},
				resourceId: '',
				stopWay: '1',
				isForceShop: false,
				reStartWay: '1',
				isForcereStart: false
			},
			Instances: null,
			rules: {
				name: [{ required: true, message: this.$gettext('Please select the name'), trigger: 'change' }],
				keyId: [{ required: true, message: this.$gettext('Please input the key ID'), trigger: 'change' }],
				keySecret: [{ required: true, message: this.$gettext('Please input the key secret'), trigger: 'change' }],
				region: [{ required: true, message: this.$gettext('Please select the region'), trigger: 'change' }]
			},
			intervalId: null,
			onlineConnectTooltip: false,
			currentConnectList: []
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getAttrText();
		},
		currentAccount: function currentAccount() {
			return this.$store.getters.account;
		}
	},
	created: function created() {
		this.getNewAgentVersion();

		this.detail.currentTab = this.$route.query.type;
	},

	methods: {
		getAttrText: function getAttrText() {
			return {
				unavailable: this.$gettext('Unavailable'),
				available: this.$gettext('Available'),
				on: this.$gettext('On'),
				off: this.$gettext('Off'),
				yes: this.$gettext('yes'),
				no: this.$gettext('no'),
				servers: this.$gettext('Servers'),
				dataBase: this.$gettext('Databases'),
				setting: this.$gettext('Setting'),
				shareCluster: this.$gettext('Share Cluster'),
				logFilter: this.$gettext('Log Filter'),
				name: this.$gettext('Name'),
				accountName: this.$gettext('Account Name'),
				dataBaseName: this.$gettext('Database Name'),
				os: this.$gettext('OS'),
				specification: this.$gettext('Specification'),
				type: this.$gettext('Type'),
				Connectivity: this.$gettext('Connectivity'),
				action: this.$gettext('Action'),
				opSystem: this.$gettext('Operating System'),
				region: this.$gettext('region'),
				select: this.$gettext('select'),
				cloudName: this.$gettext('Cloud Name'),
				teamId: this.$gettext('Team Id'),
				teamName: this.$gettext('Team Full Name'),
				shareTime: this.$gettext('Sharing Time'),
				filtersOperation: this.$gettext('Filters Operation'),
				condition: this.$gettext('Condition'),
				createTime: this.$gettext('Create Time'),
				upload: this.$gettext('Upload'),
				password: this.$gettext('Password'),
				targetKey: this.$gettext('ssh key verification'),
				passwordFree: this.$gettext('Password Free Authentication'),
				cos: this.$gettext('CloudLinker Authority Authentication'),
				aliyun: this.$gettext('aliyun'),
				stopInstanceText: this.$gettext('Stop The Instance'),
				reStartText: this.$gettext('Reboot Instance'),
				needPsw: this.$gettext('Need to re input database password'),
				turnInstance: this.$gettext('Turn On Instance'),
				notSupport: this.$gettext('Not available now,coming soon.'),
				updateTip: this.$gettext('Update Tip'),
				innerIp: this.$gettext('IP/Connection Address'),
				desDocument: this.$gettext('Control Node Function Description Document')
			};
		},
		initSelect: function initSelect(val) {
			if (!val) {
				this.tableHeader.searchForm.text = '';
			}
		},
		getNewAgentVersion: function getNewAgentVersion() {
			var _this = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.CHECK_AGENT).then(function (res) {
				_this.newAgentVersion = res.version;
				_this.refresh = res.refresh;
				_this.setting.agent_sha = res.agent_sha;
				_this.getDetailInfo();
			});
		},
		onShowConfigFile: function onShowConfigFile() {
			var _this2 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterConfigFile' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_18__model_cluster_config_file_vue___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this2.rightPanelData = {
						info: _this2.detail.info,
						callback: _this2.updateDetailInfo
					};
				}, time);
			});
		},
		onShowChangeName: function onShowChangeName() {
			var _this3 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'SetCluster' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_19__model_cluster_set___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this3.rightPanelData = {
						info: _this3.detail.info
					};
				}, time);
			});
		},
		getDetailInfo: function getDetailInfo() {
			var _this4 = this;

			var params = Number(this.$route.params.id);
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.GET_DETAIL, params).then(function (res) {
				console.log('%c集群详情', 'color:red', res);
				if (res.agent) {
					var features;

					(function () {
						if (res.agent.features) {
							features = JSON.parse(res.agent.features);

							_this4.supportMutipleDatabase = features.indexOf('support-multiple-databases') > 0;
						}
						res.version = __WEBPACK_IMPORTED_MODULE_21__Utils__["a" /* default */].Utils.getAgentVersion(res.agent.version);
						console.log(new Date(new Date().setHours(0, 0, 0, 0) + 86400000), new Date().getTime());

						var expiresTime = new Date().setHours(0, 0, 0, 0) + 86400000;
						var agentUpdateTip = localStorage.getItem('agentUpdateTip');
						var oldVersion = __WEBPACK_IMPORTED_MODULE_21__Utils__["a" /* default */].Utils.getAgentVersion(res.agent.version);
						var newVersion = __WEBPACK_IMPORTED_MODULE_21__Utils__["a" /* default */].Utils.getAgentVersion(_this4.newAgentVersion);
						var isNeedUndateVersion = __WEBPACK_IMPORTED_MODULE_21__Utils__["a" /* default */].Utils.isNeedUpdate(res.agent.version, _this4.newAgentVersion);
						if (isNeedUndateVersion && !res.parent_id) {
							if (!agentUpdateTip) {
								_this4.detail.updateTip = true;

								var clusterArr = [];
								clusterArr.push({
									accountId: _this4.currentAccount.id,
									resource: [{ id: params, expiresTime: expiresTime }]
								});
								localStorage.setItem('agentUpdateTip', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(clusterArr));
							} else {
								(function () {
									console.log(JSON.parse(agentUpdateTip));
									var tipList = JSON.parse(agentUpdateTip);
									var accountIDs = tipList.map(function (item) {
										return item.accountId;
									});

									if (accountIDs.indexOf(_this4.currentAccount.id) > -1) {
										for (var i = 0; i < tipList.length; i++) {
											console.log(tipList[i].accountId, _this4.currentAccount.id);
											if (tipList[i].accountId === _this4.currentAccount.id) {
												var ids = tipList[i].resource.map(function (item) {
													return item.id;
												});

												if (ids.indexOf(params) > -1) {
													tipList[i].resource.forEach(function (item) {
														if (item.id === params) {
															if (item.expiresTime < new Date().getTime()) {
																_this4.detail.updateTip = true;
																item.expiresTime = expiresTime;
																localStorage.setItem('agentUpdateTip', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(tipList));
															}
														}
													});
												} else {
													_this4.detail.updateTip = true;
													tipList[i].resource.push({ id: params, expiresTime: expiresTime });
													localStorage.setItem('agentUpdateTip', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(tipList));
												}
												break;
											}
										}
									} else {
										_this4.detail.updateTip = true;
										tipList.push({
											accountId: _this4.currentAccount.id,
											resource: [{ id: params, expiresTime: expiresTime }]
										});
										localStorage.setItem('agentUpdateTip', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(tipList));
									}
								})();
							}
						}
					})();
				}
				_this4.detail.info = res;
				_this4.detail.info.agent ? _this4.detail.info.agent.status === 1 ? _this4.tableHeader.scanDis = false : _this4.tableHeader.scanDis = true : _this4.tableHeader.scanDis = true;

				_this4.setting.logList = res.log_filters;
				if (res.parent_id) {
					_this4.setting.settingActivetab = 'logFilter';
				}
				if (!_this4.setting.isUpdateCode) {
					_this4.setting.unavailable.code = 'bash -c "$(curl -fsSL ' + __WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].agentInstallUrl + ')" - --key ' + _this4.detail.info.key + ' --sshproxyport 9998 --websshport 8889 --mysqlproxyport 9696 --mssqlproxyport 9433 --postgresqlproxyport 9432 --oracleproxyport 9521 --rdpagentport 9389 --webrdpagentport 8389 --guacdport 4822 --self-host default';

					_this4.setting.available.code = 'bash -c "$(curl -fsSL ' + __WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].agentInstallUrl + ')" - --upgrade 1 --csos-host ' + __WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].csosHost;
				}
				_this4.changeCurrentTab(_this4.$route.query.type, res.default_project_id);
			});
		},
		updateDetailInfo: function updateDetailInfo() {
			var _this5 = this;

			var params = Number(this.$route.params.id);
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.GET_DETAIL, params).then(function (res) {
				console.log('%c集群详情', 'color:red', res);
				_this5.detail.info = res;
			});
		},
		getDetailList: function getDetailList(page, defaultProjectId) {
			var _this6 = this;

			this.loading = true;
			this.detail.currentPage = page || 1;
			var params = {
				id: defaultProjectId || this.detail.info.default_project_id,
				params: {
					page: page || 1,
					type: this.$route.query.type
				}
			};
			if (this.tableHeader.searchForm.type !== '') {
				params.params.q_os = this.tableHeader.searchForm.type;
			}
			if (this.tableHeader.searchForm.text !== '') {
				params.params[this.tableHeader.searchForm.condition] = this.tableHeader.searchForm.text;
			}
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP_RESOURCE, params).then(function (res) {
				console.log(res, 'res');
				_this6.loading = false;
				_this6.detail.list = res.objects;
				_this6.detail.totalPage = res.total;
			});
		},
		deleteCluster: function deleteCluster() {
			var _this7 = this;

			this.$confirm(this.$gettext('Are you sure to delete this Cluster?'), this.$gettext('Delete Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				_this7.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.DELETE, _this7.$route.params.id).then(function () {
					_this7.$notify({
						type: 'success',
						message: _this7.$gettext('Delete successfully!')
					});
					_this7.$router.push('/settings/cluster');
				});
			});
		},
		returnCluster: function returnCluster() {
			var _this8 = this;

			this.$confirm(this.$gettext('Return the current cluster?'), this.$gettext('Please Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				_this8.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.DELETE, _this8.$route.params.id).then(function () {
					_this8.$notify({
						type: 'success',
						message: _this8.$gettext('Return successfully!')
					});
					_this8.$router.push('/settings/cluster');
				});
			});
		},
		batchDel: function batchDel(row, ids) {
			var _this9 = this;

			this.$confirm(this.$gettext('Are you sure to delete this resouce?'), this.$gettext('Delete Resource Comfirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				row && _this9.$set(row, 'deleting', true);
				!row && (_this9.loading = true);
				var params = {
					projectId: _this9.detail.info.default_project_id,
					data: {
						resources: ids
					}
				};
				_this9.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].WORKGROUP.DEL_WORKGROUP_RESOURCE, params).then(function () {
					_this9.$notify({
						type: 'success',
						message: _this9.$gettext('Delete successfully!')
					});
					_this9.getDetailList(_this9.detail.currentPage, _this9.detail.info.default_project_id);
				}).finally(function () {
					row && _this9.$set(row, 'deleting', false);
					!row && (_this9.loading = true);
				});
			}).catch(function () {
				row && _this9.$set(row, 'deleting', false);
				!row && (_this9.loading = true);
			});
		},
		onSelectionChange: function onSelectionChange(val) {
			if (val.length === 0) {
				this.tableHeader.deleteDisabled = true;
				this.tableHeader.deleteIds = '';
			} else {
				this.tableHeader.deleteDisabled = false;
				var idArr = [];
				idArr = val.map('id');
				this.tableHeader.deleteIds = idArr;
			}
		},
		onSettingTabClick: function onSettingTabClick(tab) {
			this.setting.settingActivetab = tab.name;
		},
		getCodeVersion: function getCodeVersion(codes, cb, errCb) {
			var params = {
				results_per_page: __WEBPACK_IMPORTED_MODULE_4__config__["g" /* Utils */].config.maxPageSize,
				q: {
					filters: [{
						name: 'code',
						op: 'in',
						val: codes
					}]
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].WORKGROUP.GET_CODE_VERSION, params).then(function (res) {
				cb(res.objects);
			}, function () {
				errCb();
			});
		},
		getNetworkConnects: function getNetworkConnects() {
			var _this10 = this;

			this.loading = true;
			var params = {
				page_size: __WEBPACK_IMPORTED_MODULE_4__config__["g" /* Utils */].config.maxPageSize,
				q_network_id: this.$route.params.id
			};
			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				_this10.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT, params).then(function (res) {
					if (res) {
						_this10.currentConnectList = Object.clone(res);
						resolve(res);
					}
				});
			});
		},
		updateAgent: function updateAgent() {
			var _this11 = this;

			var version = __WEBPACK_IMPORTED_MODULE_21__Utils__["a" /* default */].Utils.getAgentVersion(this.newAgentVersion);
			if (version === __WEBPACK_IMPORTED_MODULE_21__Utils__["a" /* default */].Utils.getAgentVersion(this.detail.info.agent.version) && !__WEBPACK_IMPORTED_MODULE_21__Utils__["a" /* default */].Utils.isNeedUpdate(this.detail.info.agent.version, this.newAgentVersion)) {
				this.$notify({
					message: this.$gettext('Already latest version.'),
					type: 'success'
				});
			} else {
				this.getNetworkConnects().then(function (conns) {
					if (conns.length) {
						var codes = _this11.currentConnectList.map('tunnel_code');
						console.log('codes', codes);
						_this11.getCodeVersion(codes, function (res) {
							console.log('res', res);
							if (res.length) {
								var networkExist = false;
								var clusterCode = [];
								res.forEach(function (item, index) {
									console.log('id', _this11.$route.params.id);
									if (item.resource && item.resource.network_id === parseInt(_this11.$route.params.id)) {
										networkExist = true;
										clusterCode.push(item.code);
									}
								});
								if (networkExist) {
									var cloneList = Object.clone(_this11.currentConnectList);
									var cutIds = [];
									_this11.currentConnectList.forEach(function (item) {
										if (clusterCode.indexOf(item.tunnel_code) > -1) {
											cutIds.push(item.id);
											cloneList.remove(item);
											console.log('copy-----', cutIds);
										}
									});
									_this11.$confirm(_this11.getTrannum(cutIds.length), _this11.$gettext('Please confirm'), {
										confirmButtonText: _this11.$gettext('Disconnect all connections '),
										cancelButtonText: _this11.$gettext('Upgrade later')
									}).then(function () {
										_this11.batchDeleteOnlineUser(cutIds, function () {
											console.log('集群=====');

											_this11.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT, cloneList);
											var copyCount = Object.clone(_this11.$store.getters.dashboard.onlineMembersCount);
											_this11.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT_COUNTS, copyCount - cutIds.length);
											_this11.onlineConnectTooltip = false;
											if (__WEBPACK_IMPORTED_MODULE_21__Utils__["a" /* default */].Utils.getAgentVersion(_this11.detail.info.agent.version) > '3.0.0') {
												_this11.detail.agentUpdate = false;
											}
										});
										_this11.noOnlineUserTip('isLowerVersion');
									});
									_this11.detail.updateTip = false;
									_this11.onlineConnectTooltip = true;
								} else {
									console.log('newwork false');
									_this11.noOnlineUserTip();
									_this11.detail.updateTip = false;
									_this11.onlineConnectTooltip = false;
								}
							} else {
								_this11.noOnlineUserTip();
								_this11.detail.updateTip = false;
								_this11.onlineConnectTooltip = false;
							}
						}, function () {
							_this11.detail.agentUpdate = false;
						});
					} else {
						_this11.noOnlineUserTip();
						_this11.detail.updateTip = false;
					}
				});
			}
			this.detail.backAgent = false;
		},
		backAgent: function backAgent() {
			var _this12 = this;

			var nextIndex = 0;
			this.refresh.forEach(function (item, index) {
				if (_this12.newAgentVersion == item.version) {
					nextIndex = index + 1;
				}
			});
			var backAgentVersion = this.refresh[nextIndex].version;
			var version = __WEBPACK_IMPORTED_MODULE_21__Utils__["a" /* default */].Utils.getBackAgentVersion(backAgentVersion);
			var backAgentSha = this.refresh[nextIndex].agent_sha || '';

			this.setting.backAgentCode = 'bash -c "$(curl -fsSL ' + __WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].backAgentUrl + '/install-' + version + '.sh)" - --upgrade 1 --csos-host ' + __WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].csosHost;
			this.detail.backAgent = true;
			this.detail.agentUpdate = true;
		},
		noOnlineUserTip: function noOnlineUserTip(isLowerVersion) {
			console.log('isLowerVersion', isLowerVersion);
			var version = __WEBPACK_IMPORTED_MODULE_21__Utils__["a" /* default */].Utils.getAgentVersion(this.newAgentVersion);
			if (__WEBPACK_IMPORTED_MODULE_21__Utils__["a" /* default */].Utils.getAgentVersion(this.detail.info.agent.version) < '3.0.0') {
				if (!isLowerVersion) {
					this.$notify({
						message: this.$gettext('Please Uninstall Agent Before!'),
						type: 'warning'
					});
				}
			} else if (__WEBPACK_IMPORTED_MODULE_21__Utils__["a" /* default */].Utils.isNeedUpdate(this.detail.info.agent.version, this.newAgentVersion)) {
				this.$notify({
					message: this.$gettext('Not Latest version, you can run script below again to update.'),
					type: 'warning'
				});
				this.detail.agentUpdate = false;
			}
		},
		batchDeleteOnlineUser: function batchDeleteOnlineUser(ids, cd) {
			var _this13 = this;

			var params = {
				connection_ids: ids
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.BAECH_DELETE_ONLINE_USER, params).then(function (res) {
				cd();
				if (__WEBPACK_IMPORTED_MODULE_21__Utils__["a" /* default */].Utils.getAgentVersion(_this13.detail.info.agent.version) < '3.0.0') {
					_this13.$notify({
						message: _this13.$gettext('Disconnect successfully! Please Uninstall Agent Before!'),
						type: 'warning'
					});
				} else {
					_this13.$notify({
						type: 'success',
						message: _this13.$gettext('Disconnect successfully! you can run script below again to update.')
					});
				}
			});
		},
		getTrannum: function getTrannum(num) {
			var translated = this.$ngettext('The current control node has %{ n } online connection. Please disconnect all connections and update it', 'The current control node has %{ n } online connections. Please disconnect all connections and update it', num);
			var interpolated = this.$gettextInterpolate(translated, { n: num });
			return interpolated;
		},
		unBindAgent: function unBindAgent() {
			var _this14 = this;

			this.getNetworkConnects().then(function (conns) {
				if (conns.length) {
					var codes = _this14.currentConnectList.map('tunnel_code');
					_this14.getCodeVersion(codes, function (res) {
						console.log('res:::', res);
						if (res.length) {
							var networkExist = false;
							res.forEach(function (item, index) {
								console.log('id', _this14.$route.params.id);
								if (item.resource && item.resource.network_id === parseInt(_this14.$route.params.id)) {
									networkExist = true;
								}
							});
							if (networkExist) {
								_this14.onlineConnectTooltip = true;
							} else {
								_this14.onlineConnectTooltip = false;
								_this14.unBindAgentApi();
							}
						}
					}, function () {});
				} else {
					_this14.unBindAgentApi();
				}
			});
		},
		unBindAgentApi: function unBindAgentApi() {
			var _this15 = this;

			this.$confirm(this.$gettext('Are you sure to uninstall this agent?'), this.$gettext('Uninstall Agent Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				var params = {
					id: _this15.$route.params.id,
					data: {
						agent_id: null
					}
				};
				_this15.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.CHANGE, params).then(function (res) {
					_this15.$notify({
						type: 'success',
						message: _this15.$gettext('unBind successfully!')
					});
					_this15.getDetailInfo();
				});
			});
		},
		copySuccess: function copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success'
			});
		},
		getSharingList: function getSharingList() {
			var _this16 = this;

			this.loading = true;
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.GET_SHARING, this.$route.params.id).then(function (res) {
				_this16.loading = false;
				_this16.setting.shareList = _this16.$store.getters.cluster.detail.settings.shares;
			}, function () {
				_this16.loading = true;
			});
		},
		delShareCluster: function delShareCluster(id) {
			var _this17 = this;

			this.$confirm(this.$gettext('Are you sure to cancel this sharing?'), this.$gettext('Cancel Share Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				_this17.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.CANCEL_SHARE, id).then(function (res) {
					_this17.getSharingList();
					_this17.$notify({
						type: 'success',
						message: _this17.$gettext('Cancel Share successfully!')
					});
				});
			}).catch(function () {});
		},
		delLogFilter: function delLogFilter(id) {
			var _this18 = this;

			this.$confirm(this.$gettext('Are you sure to delete this Filters Operation ?'), this.$gettext('Delete Prompt'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				_this18.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.DEL_LOG_FILTER, id).then(function (res) {
					_this18.getDetailInfo();
					_this18.$notify({
						type: 'success',
						message: _this18.$gettext('Delete successfully!')
					});
				});
			}).catch(function () {});
		},
		batchDelLogFilter: function batchDelLogFilter() {
			var _this19 = this;

			this.$confirm(this.$gettext('Are you sure to delete selected resource?'), this.$gettext('Delete Resource Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				var ids = _this19.setting.logBatchIds;
				_this19.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.DEL_BARCH_LOG_FILTER, ids).then(function (res) {
					_this19.getDetailInfo();
					_this19.$notify({
						type: 'success',
						message: _this19.$gettext('Delete successfully!')
					});
				});
			}).catch(function () {});
		},
		onSelectLog: function onSelectLog(v) {
			if (v.length !== 0) {
				this.setting.logBatchIds = v.map(function (item) {
					return item.id;
				}).join(',');
			} else {
				this.setting.logBatchIds = '';
			}
			console.log('log', this.setting.logBatchIds);
		},
		onAdd: function onAdd() {
			if (this.$route.query.type === 'ecs') {
				this.onShowClusterAddInstance();
				console.log('ecs');
			} else if (this.$route.query.type === 'rds') {
				console.log('rds');
				this.onShowClusterAddDatabase();
			}
		},
		onSettingAdd: function onSettingAdd() {
			if (this.setting.activeTab === 'shareCluster') {
				this.onShowClusterAddShare();
			} else if (this.setting.activeTab === 'logFilter') {
				this.onShowClusterLogFilter();
			}
		},
		onSetting: function onSetting(id) {
			if (this.$route.query.type === 'ecs') {
				console.log('ecs');
				this.onShowClusterInstanceSetting(id);
			} else if (this.$route.query.type === 'rds') {
				console.log('rds');
				this.onShowClusterDatabaseSetting(id);
			}
		},
		onTestConnection: function onTestConnection(resource) {
			var _this20 = this;

			var params = {
				resource_id: resource.id
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.TEST_CONNECTION, params).then(function (res) {
				_this20.detail.taskId = res.task_id;
				resource.taskId = res.task_id;
				console.log('resource--->测试', resource);
				_this20.queryTest(resource);
			});
		},
		queryTest: function queryTest(resource) {
			var _this21 = this;

			var params = {
				task_id: resource.taskId
			};
			console.log('query------>轮询', resource);
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.QUERY_TEST, params).then(function (res) {
				if (res.result == null || !res.result) {
					_this21.$set(_this21.detail.list, _this21.detail.list.indexOf(resource), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(resource, {
						test_result: 'disable'
					}));
				} else {
					_this21.$set(_this21.detail.list, _this21.detail.list.indexOf(resource), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(resource, {
						test_result: res.result
					}));
					if (res.result === 'pending') {
						setTimeout(function () {
							_this21.queryTest(resource);
						}, 3000);
					} else {}
				}
			});
		},
		onSearch: function onSearch() {
			this.tableHeader.filters = [];
			if (this.tableHeader.searchForm.type !== '') {
				this.tableHeader.filters.push({
					name: 'extension',
					op: 'like',
					val: '%' + this.tableHeader.searchForm.type + '%'
				});
			}
			if (this.tableHeader.searchForm.text !== '') {
				this.tableHeader.filters.push({
					name: this.tableHeader.searchForm.condition,
					op: 'like',
					val: '%' + this.tableHeader.searchForm.text + '%'
				});
			}
			this.getDetailList(1, this.detail.info.default_project_id);
		},
		onChangePage: function onChangePage(page) {
			this.getDetailList(page, this.detail.info.default_project_id);
		},
		onTabClick: function onTabClick(tab) {
			this.$router.push({ name: 'clusterDetail', query: { type: tab.name } });
			this.tableHeader.filters = [];
			this.tableHeader.searchForm = {
				type: '',
				condition: '',
				text: ''
			};
		},
		changeCurrentTab: function changeCurrentTab(tab, defaultProjectId) {
			this.detail.currentTab = this.$route.query.type || 'ecs';
			if (tab === 'settings') {
				this.detail.info.parent_id ? this.setting.activeTab = 'logFilter' : this.setting.activeTab = 'shareCluster';
				this.getSharingList();
			} else {
				if (defaultProjectId) {
					this.getDetailList(1, defaultProjectId);
				}
			}
		},
		tableRowClassName: function tableRowClassName(row, index) {
			if (index % 2 === 0) {
				return 'info-row';
			}
			return '';
		},
		onUpload: function onUpload(option) {
			this.upload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.upload, {
				isUpload: option.isUpload,
				username: option.username,
				resourceId: option.resourceId,
				password: ''
			});
			console.log('username', this.upload.resourceId, this.upload.isUpload);
		},
		onComfirmUpload: function onComfirmUpload() {
			var _this22 = this;

			var params = {
				resourceId: this.upload.resourceId,
				data: {
					password: this.upload.password,
					username: this.upload.username
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.UOLOAD_SSHKEY, params).then(function (res) {
				var id = res.task_id;
				_this22.queryUpload(id);
			});
		},
		queryUpload: function queryUpload(id) {
			var _this23 = this;

			var queryParams = {
				resourceId: this.upload.resourceId,
				params: {
					task_id: id
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.QUERY_SSHKEY, queryParams).then(function (res) {
				_this23.upload.status = res.result;
				_this23.upload.password = '';
				if (res.result !== 'pending') {
					if (res.result === 'failed') {
						_this23.$notify({
							type: 'error',
							message: _this23.$gettext('Upload failed')
						});
					} else {
						_this23.$notify({
							type: 'success',
							message: _this23.$gettext('Upload success')
						});
						_this23.upload.isUpload = false;
					}
				} else {
					setTimeout(function () {
						_this23.queryUpload(id);
					}, 1000);
				}
			});
		},
		onClosePanel: function onClosePanel() {
			var _this24 = this;

			console.log('this.currentRightPanel.name', this.currentRightPanel.name);
			if (this.currentRightPanel.name === 'ClusterSafeMode') {
				setTimeout(function () {
					_this24.getDetailInfo();
				}, 300);
			}
			this.currentRightPanel = null;
			this.rightPanelData = null;
		},
		callback: function callback() {
			console.log('callback===', this.currentRightPanel.name);
			if (this.currentRightPanel.name === 'ClusterSafeMode' || this.currentRightPanel.name === 'ClusterLogFilter' || this.currentRightPanel.name === 'ChangeClusterName' || this.currentRightPanel.name === 'SetCluster') {
				return this.getDetailInfo();
			} else if (this.currentRightPanel.name === 'ClusterAddShare') {
				return this.getSharingList();
			} else {
				return this.getDetailList(this.detail.currentPage, this.detail.info.default_project_id);
			}
		},
		onShowClusterSafeMode: function onShowClusterSafeMode() {
			var _this25 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterSafeMode' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_5__model_cluster_safe_mode___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					console.log('click', _this25.detail.info);
					_this25.rightPanelData = Object.clone(_this25.detail.info);
				}, time);
			});
		},
		onShowClusterAddInstance: function onShowClusterAddInstance() {
			var _this26 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterAddInstance' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_7__model_cluster_add_instance___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this26.rightPanelData = [];
				}, time);
			});
		},
		onShowClusterBatchInstance: function onShowClusterBatchInstance() {
			var _this27 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterBatchInstance' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_8__model_cluster_batch_instances___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this27.rightPanelData = [];
				}, time);
			});
		},
		onShowClusterScanImport: function onShowClusterScanImport() {
			var _this28 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterScanImport' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_9__model_cluster_scan_import___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this28.rightPanelData = Object.clone(_this28.detail.info);
				}, time);
			});
		},
		onShowClusterAkImport: function onShowClusterAkImport() {
			var _this29 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterAkImport' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_10__model_cluster_ak_import___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this29.rightPanelData = Object.clone(_this29.detail.info);
				}, time);
			});
		},
		onShowClusterInstanceSetting: function onShowClusterInstanceSetting(id) {
			var _this30 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterInstanceSetting' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_11__model_cluster_instance_setting___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this30.rightPanelData = id;
				}, time);
			});
		},
		onShowClusterAddDatabase: function onShowClusterAddDatabase() {
			var _this31 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterAddDatabase' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_12__model_cluster_add_database___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this31.rightPanelData = {
						supportMutipleDatabase: _this31.supportMutipleDatabase
					};
				}, time);
			});
		},
		onShowClusterDatabaseSetting: function onShowClusterDatabaseSetting(id) {
			var _this32 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterDatabaseSetting' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_13__model_cluster_database_setting___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this32.rightPanelData = id;
				}, time);
			});
		},
		onShowClusterAddShare: function onShowClusterAddShare() {
			var _this33 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterAddShare' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_14__model_cluster_add_share___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this33.rightPanelData = {
						domain: {
							label: _this33.$gettext('Team code'),
							val: '',
							rule: [{ required: true, message: _this33.$gettext('Please input the team code'), trigger: 'blur' }, { validator: _this33.trimSapce, trigger: 'blur' }]
						}
					};
				}, time);
			});
		},
		trimSapce: function trimSapce(rule, value, callback) {
			console.log('rule', rule, value);
			if (value.match(/^\s+$/)) {
				if (this.currentRightPanel === __WEBPACK_IMPORTED_MODULE_15__model_cluster_log_filter___default.a) {
					callback(new Error(this.$gettext('Please input the condition')));
				} else if (this.currentRightPanel === __WEBPACK_IMPORTED_MODULE_14__model_cluster_add_share___default.a) {
					callback(new Error(this.$gettext('Please input the team code')));
				}
			} else {
				value = value.trim();
				callback();
			}
		},
		onShowClusterLogFilter: function onShowClusterLogFilter() {
			var _this34 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterLogFilter' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_15__model_cluster_log_filter___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this34.rightPanelData = {
						filterOperator: {
							label: _this34.$gettext('Fileter Operator'),
							val: 'contains',
							disabled: 'disabled',
							rule: [{ message: _this34.$gettext('Please input the condition'), trigger: 'blur' }]
						},
						condition: {
							label: _this34.$gettext('Condition'),
							val: '',
							rule: [{ required: true, message: _this34.$gettext('Please input the condition'), trigger: 'blur' }, { validator: _this34.trimSapce, trigger: 'blur' }]
						}
					};
				}, time);
			});
		},
		onShowClusterCheckSupport: function onShowClusterCheckSupport() {
			var _this35 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterCheckSupport' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_16__model_cluster_check_support___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this35.rightPanelData = [];
				}, time);
			});
		},
		onCloudShow: function onCloudShow(option) {
			var _this36 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'ClusterCloudAk' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_17__model_cluster_cloud_ak___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this36.rightPanelData = option;
				}, time);
			});
		},
		onShowCloudDialog: function onShowCloudDialog(option) {
			this.cluodDialog.Instances = option.Instances;
			this.cluodDialog.resourceId = option.resourceId;
			if (option.type === 1) {
				if (option.Instances && option.Instances.InstanceId) {
					if (option.Instances.Status === 'Stopped') {
						this.cluodDialog.start = true;
					}
				}
			} else if (option.type === 2) {
				this.cluodDialog.reStart = true;
			} else if (option.type === 3) {
				this.cluodDialog.stopInstance = true;
			}
		},
		onOpenStop: function onOpenStop() {
			this.cluodDialog.stopWay = '1';
			this.cluodDialog.isForceShop = false;
		},
		onOpenRestart: function onOpenRestart() {
			this.cluodDialog.reStartWay = '1';
			this.cluodDialog.isForcereStart = false;
		},
		onStart: function onStart() {
			var _this37 = this;

			this.cluodDialog.start = false;
			var params = {
				id: this.cluodDialog.resourceId,
				params: {
					Action: 'StartInstance'
				}
			};
			this.$refs['rightComponent'].changeStatus('Starting');
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.GET_ALIYUN_ECS, params).then(function (d) {
				_this37.$refs['rightComponent'].loadInstanceStatus();
			});
		},
		onStop: function onStop() {
			var _this38 = this;

			var params = {
				id: this.cluodDialog.resourceId,
				params: {
					Action: 'StopInstance',
					ForceStop: this.cluodDialog.isForceShop
				}
			};
			this.$refs['rightComponent'].changeStatus('Stopping');
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.GET_ALIYUN_ECS, params).then(function (d) {
				_this38.$refs['rightComponent'].loadInstanceStatus();
				_this38.cluodDialog.isForceShop = false;
				_this38.cluodDialog.stopInstance = false;
			});
		},
		onRestart: function onRestart() {
			var _this39 = this;

			this.$refs['rightComponent'].changeStatus('Stopping');
			var params = {
				id: this.cluodDialog.resourceId,
				params: {
					Action: 'RebootInstance',
					ForceStop: this.cluodDialog.isForcereStart
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.GET_ALIYUN_ECS, params).then(function (d) {
				_this39.$refs['rightComponent'].loadInstanceStatus();
				_this39.cluodDialog.reStart = false;
			});
		},
		closeUpdateTip: function closeUpdateTip() {
			this.detail.updateTip = false;
			console.log('close=====>');
		}
	},
	beforeRouteLeave: function beforeRouteLeave(to, from, next) {
		console.log('leave route');
		clearInterval(this.intervalId);
		next();
	},

	watch: {
		unavailableForm: {
			handler: function handler(newVal, oldVal) {
				var _this40 = this;

				this.$refs['unavailableForm'].validate(function (valid) {
					_this40.unavailableForm.isCanSubmit = valid;
				});
			},
			deep: true
		},
		$route: function $route(to, from) {
			this.detail.currentTab = this.$route.query.type;
			this.changeCurrentTab(this.detail.currentTab, this.detail.info.default_project_id);
		}
	},
	components: {
		ElButton: __WEBPACK_IMPORTED_MODULE_20__node_modules_element_ui_packages_button_src_button___default.a,
		ClusterSafeMode: __WEBPACK_IMPORTED_MODULE_5__model_cluster_safe_mode___default.a,
		ClusterAddInstance: __WEBPACK_IMPORTED_MODULE_7__model_cluster_add_instance___default.a,
		ClusterBatchInstance: __WEBPACK_IMPORTED_MODULE_8__model_cluster_batch_instances___default.a,
		ClusterScanImport: __WEBPACK_IMPORTED_MODULE_9__model_cluster_scan_import___default.a,
		ClusterAkImport: __WEBPACK_IMPORTED_MODULE_10__model_cluster_ak_import___default.a,
		ClusterInstanceSetting: __WEBPACK_IMPORTED_MODULE_11__model_cluster_instance_setting___default.a,
		ClusterAddDatabase: __WEBPACK_IMPORTED_MODULE_12__model_cluster_add_database___default.a,
		ClusterDatabaseSetting: __WEBPACK_IMPORTED_MODULE_13__model_cluster_database_setting___default.a,
		ClusterAddShare: __WEBPACK_IMPORTED_MODULE_14__model_cluster_add_share___default.a,
		ClusterLogFilter: __WEBPACK_IMPORTED_MODULE_15__model_cluster_log_filter___default.a,
		ClusterCheckSupport: __WEBPACK_IMPORTED_MODULE_16__model_cluster_check_support___default.a,
		ClusterCloudAk: __WEBPACK_IMPORTED_MODULE_17__model_cluster_cloud_ak___default.a,
		ChangeCluster: __WEBPACK_IMPORTED_MODULE_6__model_cluster_change_name_vue___default.a,
		SetCluster: __WEBPACK_IMPORTED_MODULE_19__model_cluster_set___default.a,
		ClusterConfigFile: __WEBPACK_IMPORTED_MODULE_18__model_cluster_config_file_vue___default.a
	}
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_cluster_add__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_cluster_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__model_cluster_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			loading: false,
			cluster: {
				count: 0,
				list: [],
				detail: {},
				isDetail: false,
				totalPage: 0,
				currentPage: 1
			},
			search: {
				condition: 'q_name',
				name: '',
				params: []
			},
			currentRightPanel: null,
			rightPanelData: null,
			intervalId: ''
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getAttrText();
		},
		newAgentversion: function newAgentversion() {
			return this.$store.getters.cluster.newAgentVersion;
		}
	},
	created: function created() {
		this.getClusterList();
	},

	methods: {
		getTranTest: function getTranTest(number) {
			var translated = this.$ngettext('%{ n } resource', '%{ n } resources', number);
			var interpolated = this.$gettextInterpolate(translated, { n: number });
			return interpolated;
		},
		getAttrText: function getAttrText() {
			return {
				unavailable: this.$gettext('Unavailable'),
				available: this.$gettext('Available'),
				shareCluster: this.$gettext('shared cluster'),

				inputName: this.$gettext('Please input WokGroup Name'),
				defaultWorkgroup: this.$gettext('default workgroup'),
				select: this.$gettext('select'),
				name: this.$gettext('Name')
			};
		},
		isNewVersion: function isNewVersion(version) {
			return !__WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* default */].Utils.isNeedUpdate(version, this.newAgentversion);
		},
		getClusterList: function getClusterList(page, total) {
			var _this = this;

			if (!this.cluster.list.length) {
				this.loading = true;
			}
			var params = {
				params: {
					page: page || 1
				}
			};
			if (this.search.name !== '' && this.search.condition) {
				params.params[this.search.condition] = this.search.name;
			}
			if (total) {
				params.params.total = total;
			}
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].CLUSTER.GET_CLUSTER, params).then(function (res) {
				_this.loading = false;
				_this.cluster.list = res.objects;
				_this.cluster.totalPage = res.total;
			});
		},
		exportCluster: function exportCluster(id) {
			window.open(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* baseUrl */].apiUrl + '/v1/project/resources/export/' + id, '__blank');
		},
		returnCluster: function returnCluster(id) {
			var _this2 = this;

			this.$confirm(this.$gettext('Return the current network?'), this.$gettext('Please Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].CLUSTER.DELETE, id).then(function () {
					_this2.$notify({
						type: 'success',
						message: _this2.$gettext('Return successfully!')
					});
					_this2.getClusterList(_this2.cluster.currentPage);
				}).catch(function (err) {
					_this2.$notify.info({
						message: err
					});
				});
			});
		},
		onSearch: function onSearch() {
			this.getClusterList();
		},
		clearSearchInput: function clearSearchInput() {
			this.search.name = '';
		},
		deleteCluster: function deleteCluster(row) {
			var _this3 = this;

			this.$confirm(this.$gettext('Are you sure to delete the cluster?'), this.$gettext('Delete Prompt'), {
				confirmButtonText: this.$gettext('Comfirm'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				_this3.$set(row, 'deleting', true);

				_this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].CLUSTER.DELETE, row.id).then(function () {
					_this3.getClusterList(_this3.cluster.currentPage);
					_this3.$notify({
						type: 'success',
						message: _this3.$gettext('Delete successfully!')
					});
				}).finally(function () {
					_this3.$set(row, 'deleting', false);
				});
			}).catch(function () {
				_this3.$set(row, 'deleting', false);
			});
		},
		onChangePage: function onChangePage(page) {
			this.getClusterList(page, this.cluster.totalPage);
		},
		tableRowClassName: function tableRowClassName(row, index) {
			if (index % 2 === 0) {
				return 'info-row';
			}
			return '';
		},
		onClosePanel: function onClosePanel() {
			this.currentRightPanel = null;
			this.rightPanelData = null;
		},
		onShowCreateCluster: function onShowCreateCluster() {
			var _this4 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'CreateCluster' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_1__model_cluster_add___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this4.rightPanelData = {
						name: {
							label: _this4.$gettext('Cluster Name'),
							labelWidth: 280,
							val: '',
							rule: [{
								required: true,
								message: _this4.$gettext('Please input the cluster name'),
								trigger: 'blur'
							}, { max: 50, message: _this4.$gettext('length is within 50 characters'), trigger: 'change' }]
						},
						tips: {
							type: 'tips',
							text: _this4.$gettext('Note: A cluster can add up to 1000 resources')
						}
					};
				}, time);
			});
		}
	},
	beforeRouteLeave: function beforeRouteLeave(to, from, next) {
		window.clearInterval(this.intervalId);
		next();
	},

	components: {
		CreateCluster: __WEBPACK_IMPORTED_MODULE_1__model_cluster_add___default.a
	}
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(19);







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('allMember', {
	functional: true,
	render: function render(h, ctx) {
		var item = ctx.props.item;
		return h('li', ctx.data, [h('div', { attrs: { class: 'name' } }, [item.name]), h('div', {}, [item.account])]);
	},
	props: {
		item: { type: Object, required: true }
	}
});
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'WorkgroupAddMember',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null,
			loading: false,
			workgroupForm: {
				list: [],
				type: '0',
				project_ids: [],
				memberDis: false
			},
			memberName: false,
			rules: {
				value: [{ required: true, message: this.$gettext('Please input workgroup name'), trigger: 'change' }]
			}
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	created: function created() {
		this.getAllWorkgroup();
	},

	methods: {
		getTranslateText: function getTranslateText() {
			return {
				member: this.$gettext('Member'),
				type: this.$gettext('Type'),
				administrator: this.$gettext('administrator'),
				ordinary: this.$gettext('Ordinary Member'),
				inputName: this.$gettext('Please input workgroup name search'),
				inputSearch: this.$gettext('Search')
			};
		},
		getAllWorkgroup: function getAllWorkgroup() {
			var _this = this;

			var params = {
				account_id: this.$route.params.id,
				page_size: __WEBPACK_IMPORTED_MODULE_1__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP, params).then(function (res) {
				_this.workgroupForm.list = res.objects;
			});
		},
		onChangeSelect: function onChangeSelect(val) {
			console.log('select-val', val);
			this.$refs.workgroups.query = '';
		},
		onSubmit: function onSubmit() {
			var _this2 = this;

			this.$refs['workgroupForm'].validate(function (valid) {
				if (valid) {
					var params = {
						account_id: _this2.$route.params.id,
						project_ids: _this2.workgroupForm.project_ids,
						role: 0
					};
					if (!_this2.workgroupForm.project_ids) {
						_this2.$notify({
							type: 'error',
							message: _this2.$gettext('Workgroup is found')
						});
					} else {
						_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.ADD_ACCOUNT_WORKGROUP, params).then(function (res) {
							_this2.$notify({
								type: 'success',
								message: _this2.$gettext('Add success')
							});
							_this2.$emit('callback');
							_this2.$refs['right-panel'].onClose();
						}).catch(function (err) {
							_this2.$emit('callback');
							_this2.$refs['right-panel'].onClose();
						});
					}
				} else {
					return false;
				}
			});
		},
		onClose: function onClose() {
			this.connects = null;
			this.$emit('onClosePanel');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this3 = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this3.connects = _this3.items;
					}, 300);
				} else {
					this.connects = this.items;
				}
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
	}
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClusterAddDatabase',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null,
      btnDisabled: false,
      supportMutipleDatabase: false,
      addForm: {
        name: '',
        instanceId: '',
        ipAddress: '',
        os: 'mysql',
        username: '',
        port: '3306',
        databaseName: '',
        serviceName: '',
        serviceNameType: 'service_name',
        password: ''
      },
      rules: {
        name: [{ required: true, message: this.$gettext('Please input the resource name'), trigger: 'change' }],
        ipAddress: [{ required: true, message: this.$gettext('Please input the ip/link address'), trigger: 'change' }],
        os: [{ required: true, message: this.$gettext('Please input the userName'), trigger: 'change' }],
        username: [{ required: true, message: this.$gettext('Please input the username'), trigger: 'change' }],
        databaseName: [{ validator: this.checkDatabase, trigger: 'change, blur' }],
        serviceNameType: [{ required: true, message: this.$gettext('Please select the connection identifier type'), trigger: 'change' }],
        serviceName: [{ required: true, message: this.$gettext('Please input the Service Name / SID'), trigger: 'change' }],
        port: [{ required: true, message: this.$gettext('Please input the port'), trigger: 'change' }],
        password: [{ required: true, message: this.$gettext('Please input the password'), trigger: 'change' }]
      }
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTransitionText();
    }
  },
  methods: {
    getTransitionText: function getTransitionText() {
      return {
        resourceName: this.$gettext('Resource name'),
        ipAddress: this.$gettext('IP/Connection Address'),
        defaultIpText: this.$gettext('IP or connection string'),
        type: this.$gettext('Type'),
        username: this.$gettext('Username'),
        port: this.$gettext('Port'),
        password: this.$gettext('Password'),
        databaseName: this.$gettext('Database Name'),
        connectIdentifier: this.$gettext('Service Name / SID'),
        connectIdentifierType: this.$gettext('Connection identifier type')
      };
    },
    checkDatabase: function checkDatabase(rule, value, callback) {
      var val = value.trim();
      if (val) {
        if (this.supportMutipleDatabase) {
          callback();
        } else {
          if (val.indexOf('*') >= 0 || val.indexOf(';') >= 0) {
            callback(new Error(this.$gettext('Database name format is incorrect')));
          } else {
            callback();
          }
        }
      } else {
        callback(new Error(this.$gettext('Please input the databaseName')));
      }
    },
    selectDefault: function selectDefault(val) {
      if (val === 'mysql') {
        this.addForm.port = '3306';
      } else if (val === 'postgresql') {
        this.addForm.port = '5432';
      } else if (val === 'oracle') {
        this.addForm.port = '1521';
        this.addForm.serviceNameType = 'service_name';
      } else {
        this.addForm.port = '1433';
      }
    },
    onSubmitAddForm: function onSubmitAddForm() {
      var _this = this;

      this.$refs['addForm'].validate(function (valid) {
        if (valid) {
          var options = _this.addForm;
          var params = {
            data: {
              network_id: Number(_this.$route.params.id),
              resources: [{
                name: options.name,
                ip_address: options.ipAddress,
                os: options.os,
                username: [options.username],
                password: options.password,
                port: Number(options.port),
                databases: [],
                service_name: options.os === 'oracle' ? options.serviceName : null,
                service_name_type: options.os === 'oracle' ? options.serviceNameType : null
              }]
            }
          };
          options.databaseName.split(';').forEach(function (el) {
            if (el && el.trim()) {
              params.data.resources[0].databases.push(el.trim());
            }
          });
          _this.btnDisabled = true;
          _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].CLUSTER.ADD_RESOURCE, params).then(function (res) {
            _this.$notify({
              message: _this.$gettext('Add Successfully!'),
              type: 'success'
            });
            _this.$refs['right-panel-add'].onClose();
            _this.btnDisabled = false;
            _this.$emit('callback');
            _this.onCloseForm();
          }).catch(function (err) {
            _this.btnDisabled = false;
            if (err.code === 'ResourceExceeded') {
              _this.$notify({
                type: 'error',
                message: _this.$gettext('ResourceExceeded.')
              });
            }
          });
        }
      });
    },
    onCloseForm: function onCloseForm() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this2.connects = _this2.items;
            _this2.supportMutipleDatabase = _this2.items.supportMutipleDatabase;
          }, 300);
        } else {
          this.connects = this.items;
          this.supportMutipleDatabase = this.items.supportMutipleDatabase;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClusterAddInstance',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    var _this = this;

    var validEmpty = function validEmpty(rule, value, callback) {
      if (value.trim() === '') {
        callback(new Error(_this.$gettext('Please input the username')));
      } else {
        callback();
      }
    };
    return {
      connects: null,
      loading: false,
      addForm: {
        name: '',
        instanceId: '',
        ipAddress: '',
        os: 'linux',
        username: 'root',
        port: '22',
        flavor: '',
        clipboard: true
      },
      btnDisabled: false,
      rules: {
        name: [{ required: true, message: this.$gettext('Please input the resource name'), trigger: 'change' }],
        instanceId: [{ message: this.$gettext('Please input the instance_id'), trigger: 'change' }],
        ipAddress: [{ required: true, message: this.$gettext('Please input the Inner IP'), trigger: 'change' }, {
          pattern: /^(\d{1,3}|\*)(\.(\d{1,3}|\*)){3}$/,
          message: this.$gettext('please input the right Inner IP'),
          trigger: 'change'
        }],
        os: [{ required: true, message: this.$gettext('Please input the userName'), trigger: 'change' }],
        username: [{ required: true, message: this.$gettext('Please input the username'), trigger: 'change' }, { validator: validEmpty, trigger: 'change' }],
        port: [{ required: true, message: this.$gettext('Please input the port'), trigger: 'change' }, {
          pattern: /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
          message: this.$gettext('please input the right port'),
          trigger: 'change'
        }],
        flavor: [{
          message: this.$gettext('Please input the flavor descroption'),
          trigger: 'change'
        }]
      }
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTransitionText();
    }
  },
  methods: {
    getTransitionText: function getTransitionText() {
      return {
        resourceName: this.$gettext('Resource name'),
        instanceId: this.$gettext('Instance ID'),
        defaultIdText: this.$gettext('Confirm that agent has integrated AK'),
        ipAddress: this.$gettext('Inner IP'),
        os: this.$gettext('OS'),
        username: this.$gettext('Username'),
        port: this.$gettext('Port'),
        flavor: this.$gettext('Flavor Descroption'),
        defaultFlavorText: this.$gettext('1 core 1G etc.'),
        clipboard: this.$gettext('Clipboard')
      };
    },
    selectDefault: function selectDefault(val) {
      console.log(val);
      if (val === 'win32') {
        this.addForm.username = 'administrator';
        this.addForm.port = '3389';
      } else {
        this.addForm.username = 'root';
        this.addForm.port = '22';
      }
    },
    onSubmitAddForm: function onSubmitAddForm() {
      var _this2 = this;

      this.$refs['addForm'].validate(function (valid) {
        if (valid) {
          _this2.loading = false;
          var options = _this2.addForm;
          var params = {
            data: {
              network_id: Number(_this2.$route.params.id),
              resources: [{
                name: options.name,
                ip_address: options.ipAddress,
                os: options.os,
                username: [],
                port: Number(options.port),
                flavor: options.flavor,
                allow_copy_paste: _this2.addForm.clipboard
              }]
            }
          };
          options.username.split(';').forEach(function (el) {
            if (el && el.trim()) {
              params.data.resources[0].username.push(el.trim());
            }
          });
          _this2.btnDisabled = true;
          _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].CLUSTER.ADD_RESOURCE, params).then(function (res) {
            _this2.btnDisabled = false;
            _this2.loading = false;
            _this2.$notify({
              message: _this2.$gettext('Add Successfully!'),
              type: 'success'
            });
            _this2.$emit('callback');
            _this2.$refs['right-panel-add'].onClose();
          }).catch(function (err) {
            _this2.btnDisabled = false;
            _this2.loading = false;
            if (err.code === 'ResourceExceeded') {
              _this2.$notify({
                type: 'error',
                message: _this2.$gettext('ResourceExceeded.')
              });
            }
          });
        }
      });
    },
    onCloseForm: function onCloseForm() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this3 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this3.connects = _this3.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClusterAddShare',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      itemForm: null
    };
  },

  methods: {
    onSubmitAddForm: function onSubmitAddForm() {
      var _this = this;

      var params = {
        id: this.$route.params.id,
        data: this.$refs['right-panel-add'].profileModel
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].CLUSTER.ADD_SHARING, params).then(function () {
        _this.$notify({
          message: _this.$gettext('Add Successfully!'),
          type: 'success'
        });
        _this.$emit('callback');
      });
      setTimeout(function () {
        _this.onCloseForm();
      }, 300);
    },
    onCloseForm: function onCloseForm() {
      this.itemForm = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        if (this.itemForm) {
          this.itemForm = null;
          setTimeout(function () {
            _this2.itemForm = _this2.items;
          }, 300);
        } else {
          this.itemForm = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateCluster',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null
    };
  },

  methods: {
    onSubmitForm: function onSubmitForm() {
      var _this = this;

      var params = {
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$refs['right-panel'].profileModel)
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.ADD, params).then(function () {
        _this.$notify({
          type: 'success',
          message: _this.$gettext('Create cluster successfully!')
        });
        _this.$emit('callback');
        _this.$refs['right-panel'].onClose();
      }).catch(function (err) {
        console.log('err', err);
        _this.$refs['right-panel'].onSubmitErr();
      });
    },
    onCloseForm: function onCloseForm() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this2.connects = _this2.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(10);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ClusterScanImport',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null,
			formData: {
				source: '',
				ak: '',
				sk: '',
				region: '',
				is_shield: 0
			},
			regions: [],
			instanceList: [],
			searchForm: {
				condition: 'instance_name',
				text: ''
			},
			selectedInstances: [],
			importLoading: false,
			isCanImport: false,
			nameOsObj: {
				win32: 'administrator',
				linux: 'root'
			},
			queryTimeout: null,
			scanLoading: false,
			rules: {
				source: [{ required: true, message: this.$gettext('Please select the cloud platform'), trigger: 'change' }],
				ak: [{ required: true, message: this.$gettext('Please input the AK'), trigger: 'blur' }],
				sk: [{ required: true, message: this.$gettext('Please input the SK'), trigger: 'blur' }],
				os: [{ required: true, message: this.$gettext('Please select the os'), trigger: 'change' }],
				port: [{ required: true, message: this.$gettext('Please input the port'), trigger: 'change' }, {
					pattern: /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
					message: this.$gettext('please input the right port'),
					trigger: 'change'
				}],
				userName: [{ required: true, message: this.$gettext('Please input the userName'), trigger: 'change' }],
				password: [{ required: true, message: this.$gettext('Please input the password'), trigger: 'change' }]
			}
		};
	},
	created: function created() {
		console.log(this.currentAccount, 'currentAccount');
	},

	computed: {
		attrText: function attrText() {
			return this.getTransitionText();
		},
		isCanScan: function isCanScan() {
			return this.formData.source && this.formData.ak && this.formData.sk && this.formData.region;
		},
		currentAccount: function currentAccount() {
			return this.$store.getters.account;
		}
	},
	methods: {
		getTransitionText: function getTransitionText() {
			return {
				os: this.$gettext('OS'),
				port: this.$gettext('Port'),
				userName: this.$gettext('userName'),
				password: this.$gettext('Password'),
				moreUser: this.$gettext('Multiple users with semicolons ‘;’'),
				ak: this.$gettext('Please input the AK'),
				sk: this.$gettext('Please input the SK'),
				type: this.$gettext('Type'),
				cloudPlatform: this.$gettext('Cloud Platform'),
				area: this.$gettext('Area'),
				instanceName: this.$gettext('Instance Name'),
				instanceId: this.$gettext('Instance ID'),
				dataBase: this.$gettext('Database'),
				connectIdentifier: this.$gettext('Service Name / SID'),
				connectIdentifierType: this.$gettext('Connection identifier type'),
				usernameholder: this.$gettext('Available; Split multiple usernames'),
				instanceIdAndName: this.$gettext('Instance Name / Instance ID'),
				IPAndAddress: this.$gettext('IP / Connection Address'),
				aliyun_zh: this.$gettext('Alibaba Cloud(China)'),
				aliyun_cn: this.$gettext('Alibaba Cloud(International)'),
				huawei_zh: this.$gettext('Huawei Cloud(China)'),
				huawei_cn: this.$gettext('Huawei Cloud(International)'),
				aws_zh: this.$gettext('AWS(China)'),
				aws_cn: this.$gettext('AWS(International)'),
				volcengine: this.$gettext('Volcengine'),
				scanType: this.$gettext('Scan Type')
			};
		},
		getRegions: function getRegions() {
			var _this = this;

			var params = {
				source: this.formData.source,
				language: this.$language.current
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.CLOUD_GET_REGIONS, params).then(function (res) {
				console.log(res, 'res');
				_this.regions = res;
			}).catch(function (err) {
				console.log(err);
			});
		},
		scan: function scan() {
			var _this2 = this;

			if (this.searchForm.condition && this.searchForm.text) {
				this.formData.filter = { key: this.searchForm.condition, value: this.searchForm.text };
			} else {
				delete this.formData.filter;
			}
			var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.formData, { type: this.$route.query.type, project_id: this.connects.default_project_id });
			params.sk = this.encrypt(params.sk, this.currentAccount.id, this.currentAccount.company_id);
			this.scanLoading = true;
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.SCAN_INSTANCE, params).then(function (res) {
				console.log(res, 'res');
				_this2.instanceList = res;

				_this2.scanLoading = false;
				if (res && res.length) {
					_this2.$notify({
						type: 'success',
						message: _this2.$gettext('Scan success')
					});
				} else {
					_this2.$notify({
						type: 'warning',
						message: _this2.$gettext('No available instance found')
					});
				}
			}).catch(function (err) {
				console.log(err, 'err');

				_this2.scanLoading = false;
			});
		},
		onStartImport: function onStartImport() {
			var _this3 = this;

			var params = {
				network_id: this.connects.id,
				source: this.formData.source,
				type: this.$route.query.type,
				instances: this.selectedInstances
			};
			this.importLoading = true;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.LOAD_INSTANCE, params).then(function (res) {
				_this3.$emit('callback');
				_this3.$notify({
					type: 'success',
					message: _this3.$gettext('Import success')
				});
				_this3.importLoading = false;
			}).catch(function (err) {
				_this3.importLoading = false;
			});
		},
		onCloseForm: function onCloseForm() {
			this.connects = null;
			this.$emit('onClosePanel');
		},
		changeCloudPlarform: function changeCloudPlarform(val) {
			if (!val) return;
			this.formData.region = '';
			this.getRegions();
		},
		initSelect: function initSelect() {
			this.searchForm.text = '';
		},
		handleSelectionChange: function handleSelectionChange(val) {
			console.log(val, 'val');
			this.selectedInstances = val;
			if (this.selectedInstances && this.selectedInstances.length) {
				this.isCanImport = true;
			} else {
				this.isCanImport = false;
			}
		},
		encrypt: function encrypt(string, key, iv) {
			return __WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* default */].Utils.encryptAesCbc(string, key, iv);
		}
	},
	watch: {
		formData: {
			handler: function handler(newVal, oldVal) {
				var _this4 = this;

				this.$refs['formData'].validate(function (valid) {
					_this4.isCanScan = valid;
				});
			},
			deep: true
		},
		items: {
			handler: function handler(newVal) {
				var _this5 = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this5.connects = _this5.items;
					}, 300);
				} else {
					this.connects = this.items;
				}
				console.log(this.connects, 'connects');
				console.log(this.$route.query.type, 'route query type');
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
	}
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_upload_file__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_upload_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__vue_upload_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClusterBatchInstance',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null,
      fileInfo: null,
      progress: 0,
      downUrl: '',
      errMsg: ''
    };
  },

  methods: {
    uploadFiles: function uploadFiles(file) {
      this.fileInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, file);
    },
    onUpload: function onUpload() {
      var _this = this;

      var params = {
        network_id: Number(this.$route.params.id),
        resource_type: this.$route.query.type,
        content: [{
          data: this.fileInfo.base64.split('base64,')[1],
          file_name: this.fileInfo.name,
          extension: this.fileInfo.name.split('.')[1]
        }]
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.XLSX_BATCH_IMPORT, params).then(function (res) {
        _this.$emit('callback');
        _this.onClose();
        _this.$notify({
          message: _this.$gettext('Upload successfully!'),
          type: 'success'
        });
      }).catch(function (err) {
        console.log('err ==>', err);
        var totalLength = err.error_message.length;
        if (err.code === 'FileEmptyError') {
          _this.errMsg = _this.$gettext('The resource list is empty. Please check again!');
        } else if (err.code === 'ResourceExceeded') {
          _this.errMsg = _this.$gettext('Exceeding the maximum number of resources');
        } else if (err.code === 'FileDataError') {
          var firstIndex = err.error_message.lastIndexOf(':');
          var secondIndex = err.error_message.lastIndexOf('-');
          var row = err.error_message.substring(firstIndex + 1, secondIndex);
          var col = err.error_message.substring(secondIndex + 1, totalLength);
          _this.errMsg = '第' + row + '行,第' + col + '列出现错误!';
        } else if (err.code === 'FileTypeError') {
          _this.errMsg = _this.$gettext('Please upload the correct form!');
        } else if (err.code === 'ResourceExist') {
          var _firstIndex = err.error_message.indexOf('[');
          var lastIndex = err.error_message.lastIndexOf(']');
          var errIpStr = err.error_message.substring(_firstIndex + 1, lastIndex);
          _this.errMsg = _this.$gettext('Intranet IP:') + errIpStr + _this.$gettext('exist!');
        } else if (err.code === 'FileResourceExist') {
          var _firstIndex2 = err.error_message.indexOf('[');
          var _lastIndex = err.error_message.lastIndexOf(']');
          var _errIpStr = err.error_message.substring(_firstIndex2 + 1, _lastIndex);
          _this.errMsg = _this.$gettext('Intranet IP:') + _errIpStr + _this.$gettext('exist!');
        }
      });
    },
    onProgress: function onProgress(progress) {
      this.progress = progress;
    },
    onDownUrl: function onDownUrl() {
      if (this.$language.current === 'zh_CN') {
        if (this.$route.query.type === 'ecs') {
          this.downUrl = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].apiUrl + '/download/local_file/ecs.xlsx';
        } else {
          this.downUrl = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].apiUrl + '/download/local_file/database.xlsx';
        }
      } else {
        if (this.$route.query.type === 'ecs') {
          this.downUrl = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].apiUrl + '/download/local_file/ecs_english.xlsx';
        } else {
          this.downUrl = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].apiUrl + '/download/local_file/database_english.xlsx';
        }
      }
    },
    onCloseFile: function onCloseFile() {
      this.fileInfo = null;
      this.progress = 0;
      this.errMsg = '';
    },
    onClose: function onClose() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this2.connects = _this2.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a,
    fileBase64: __WEBPACK_IMPORTED_MODULE_3__vue_upload_file___default.a
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChangeClusterName',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null
    };
  },

  methods: {
    onSubmitForm: function onSubmitForm() {
      var _this = this;

      console.log('id----', this.$route.params);
      var params = {
        id: this.$route.params.id,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$refs['right-panel'].profileModel)
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.CHANGE, params).then(function () {
        _this.$notify({
          type: 'success',
          message: _this.$gettext('Change successfully!')
        });
        _this.$emit('callback');
        _this.$refs['right-panel'].onClose();
      }).catch(function (err) {
        console.log('err', err);
        _this.$refs['right-panel'].onSubmitErr();
      });
    },
    onCloseForm: function onCloseForm() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this2.connects = _this2.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClusterCheckSupport',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null,
      checkList: __WEBPACK_IMPORTED_MODULE_1__config__["i" /* ClusterAliyunSupport */]
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTranslateText();
    }
  },
  methods: {
    getTranslateText: function getTranslateText() {
      return {
        os: this.$gettext('OS'),
        version: this.$gettext('Version'),
        comment: this.$gettext('Comment')
      };
    },
    onCloseForm: function onCloseForm() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this.connects = _this.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_0__common_right_panel___default.a
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_nvd3_line_chart__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_nvd3_line_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_nvd3_line_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_d3__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClusterCloudAk',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      options: null,
      activeName: 'baseInfo',
      basicInfo: {
        Instances: {},
        regions: [],
        zones: [],
        systemDisk: {},
        dataDisk: [],
        show: false,
        err: false,
        ZoneName: '',
        RegionName: ''
      },
      monitorInfo: {
        selectTime: 'oneHour',
        netLoadCount: 0,
        options: {
          StartTime: new Date(new Date().getTime() - 1 * 60 * 60 * 1000),
          EndTime: new Date(new Date().getTime() - 7 * 1000),
          Period: 60
        },
        instanceStatusInterval: null,
        show: false,
        cpuData: null,
        netData: null,
        diskData: null,
        err: false
      },
      diskCategory: {
        cloud: this.$gettext('cloud'),
        cloud_efficiency: this.$gettext('cloud_efficiency'),
        cloud_ssd: this.$gettext('cloud_ssd'),
        ephemeral_ssd: this.$gettext('ephemeral_ssd'),
        ephemeral: this.$gettext('ephemeral')
      },
      xAxis: []
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTransitionText();
    }
  },
  created: function created() {
    var _this = this;

    setTimeout(function () {
      _this.getRegions();
    }, 300);
  },

  methods: {
    getTransitionText: function getTransitionText() {
      return {
        baseInfo: this.$gettext('Basic Information'),
        monitorInfo: this.$gettext('Monitoring Information'),
        onehour: this.$gettext('One Hour'),
        sixhour: this.$gettext('Six Hours'),
        oneday: this.$gettext('One Day'),
        sevenday: this.$gettext('Seven Days')
      };
    },
    tabClick: function tabClick(v) {
      if (v.name === 'monitorInfo' && !this.monitorInfo.netData) {
        this.getEcsMonitorData();
      }
    },
    getRegions: function getRegions() {
      var _this2 = this;

      this.basicInfo.show = false;
      var params = {
        id: this.options.resourceId,
        params: {
          Action: 'DescribeRegions'
        }
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.GET_ALIYUN_ECS, params).then(function (res) {
        _this2.basicInfo.regions = res.Regions.Region;
        _this2.getZones();
      }).catch(function () {
        _this2.basicInfo.show = true;
        _this2.basicInfo.err = true;
      });
    },
    getZones: function getZones() {
      var _this3 = this;

      var params = {
        id: this.options.resourceId,
        params: {
          Action: 'DescribeZones'
        }
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.GET_ALIYUN_ECS, params).then(function (res) {
        _this3.basicInfo.zones = res.Zones.Zone;
        _this3.getInstanceAttr();
      });
    },
    getInstanceAttr: function getInstanceAttr() {
      var _this4 = this;

      var params = {
        id: this.options.resourceId,
        params: {
          Action: 'DescribeInstances',
          InstanceIds: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([this.options.instanceId])
        }
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.GET_ALIYUN_ECS, params).then(function (res) {
        _this4.basicInfo.Instances = Object.clone(res.Instances.Instance[0]);
        if (_this4.basicInfo.Instances) {
          if (_this4.basicInfo.Instances.Status !== 'Running' && _this4.basicInfo.Instances.Status !== 'Stopped') {
            _this4.loadInstanceStatus();
          }
          if (parseInt(_this4.basicInfo.Instances.Memory) > 712) {
            _this4.basicInfo.Memory = parseInt(_this4.basicInfo.Instances.Memory) / 1024 + 'GB';
          } else {
            _this4.basicInfo.Memory += 'MB';
          }
          _this4.basicInfo.regions.forEach(function (region) {
            if (region.RegionId === _this4.basicInfo.Instances.RegionId) {
              _this4.basicInfo.RegionName = region.LocalName;
            }
          });
          _this4.basicInfo.zones.forEach(function (zone) {
            if (zone.ZoneId === _this4.basicInfo.Instances.ZoneId) {
              _this4.basicInfo.ZoneName = zone.LocalName;
            }
          });
          _this4.basicInfo.show = true;
        }
      });
      this.getEcsDiskData();
    },
    getEcsDiskData: function getEcsDiskData() {
      var _this5 = this;

      var params = {
        id: this.options.resourceId,
        params: {
          Action: 'DescribeDisks'
        }
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.GET_ALIYUN_ECS, params).then(function (res) {
        if (res.Disks.Disk) {
          var diskArr = res.Disks.Disk;
          diskArr.forEach(function (disk) {
            if (disk.Type === 'system') {
              _this5.basicInfo.systemDisk = disk;
            } else {
              console.log('this.basicInfo.dataDisk', _this5.basicInfo.dataDisk);
              var dataDiskIndex = _this5.basicInfo.dataDisk.findIndex(function (item) {
                return item.category === disk.Category;
              });
              if (dataDiskIndex < 0) {
                _this5.basicInfo.dataDisk.push({ 'category': disk.Category, 'size': disk.Size });
              } else {
                _this5.basicInfo.dataDisk[dataDiskIndex].size = parseInt(_this5.basicInfo.dataDisk[dataDiskIndex].size) + parseInt(disk.Size);
              }
            }
          });
        }
        console.log('this.basicInfo.systemDisk', _this5.basicInfo.systemDisk, _this5.basicInfo.dataDisk);
      });
    },
    getEcsMonitorData: function getEcsMonitorData() {
      var _this6 = this;

      this.monitorInfo.show = false;
      var params = {
        id: this.options.resourceId,
        params: {
          Action: 'DescribeInstanceMonitorData'
        }
      };
      params.params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, params.params, {
        StartTime: this.monitorInfo.options.StartTime.iso().replace(/\.\d{3}Z/, 'Z'),
        EndTime: this.monitorInfo.options.EndTime.iso().replace(/\.\d{3}Z/, 'Z'),
        Period: this.monitorInfo.options.Period
      });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.GET_ALIYUN_ECS, params).then(function (res) {
        console.log('sevenDay', _this6.monitorInfo.selectTime);
        if (_this6.monitorInfo.selectTime === 'sevenDay') {
          _this6.monitorInfo.netLoadCount += 1;
          var _data = [];
          if (res.MonitorData && res.MonitorData.InstanceMonitorData) {
            _data = _data.concat(res.MonitorData.InstanceMonitorData);
          }
          if (_this6.monitorInfo.netLoadCount === 7) {
            if (_data.length > 0) {
              _this6.monitorInfo.cpuData = _this6.getCpuOptions(_this6.getCpuData(res.MonitorData.InstanceMonitorData));
              _this6.monitorInfo.netData = _this6.getNetOptions(_this6.getNetData(res.MonitorData.InstanceMonitorData));
              _this6.monitorInfo.diskData = _this6.getdiskOptions(_this6.getdiskData(res.MonitorData.InstanceMonitorData));
            }
          }
        } else {
          if (res.MonitorData && res.MonitorData.InstanceMonitorData && res.MonitorData.InstanceMonitorData.length > 0) {
            _this6.monitorInfo.cpuData = _this6.getCpuOptions(_this6.getCpuData(res.MonitorData.InstanceMonitorData));
            _this6.monitorInfo.netData = _this6.getNetOptions(_this6.getNetData(res.MonitorData.InstanceMonitorData));
            _this6.monitorInfo.diskData = _this6.getdiskOptions(_this6.getdiskData(res.MonitorData.InstanceMonitorData));
          }
        }
        _this6.monitorInfo.show = true;
      }).catch(function () {
        _this6.monitorInfo.show = true;
        _this6.monitorInfo.err = true;
      });
    },
    getCpuData: function getCpuData(data) {
      var totalOutFlow = [];
      data.sort(function (a, b) {
        return new Date(a.TimeStamp).getTime() - new Date(b.TimeStamp).getTime();
      });
      data.forEach(function (item, index) {
        item._time = new Date(item.TimeStamp).getTime();
        totalOutFlow.push({
          x: item._time,
          xLabel: item._time,
          y: item.CPU || 0
        });
      });
      return [totalOutFlow];
    },
    getCpuOptions: function getCpuOptions(chartData) {
      var _this7 = this;

      var colors = ['#729AFC'];
      var _maxValue = __WEBPACK_IMPORTED_MODULE_5_d3___default.a.max(chartData[0], function (vItem) {
        return vItem.y;
      });
      var totalChartData = {
        options: {
          chart: {
            showLegend: true,
            showControls: false,
            showMinMaxPoints: false,
            height: 200,
            margin: {
              top: 20,
              right: 20,
              bottom: 40,
              left: 60
            },
            x: function x(d) {
              return d.x;
            },
            y: function y(d) {
              return d.y;
            },
            useInteractiveGuideline: true,
            xAxis: {
              showMaxMin: false,
              tickFormat: function tickFormat(d, x, y) {
                var t = new Date(d);
                if (x === undefined && x) {
                  var _H = t.getHours() > 9 ? t.getHours() : '0' + t.getHours();
                  var _M = t.getMinutes() > 9 ? t.getMinutes() : '0' + t.getMinutes();
                  return t.getMonth() + 1 + '/' + t.getDate() + ' ' + _H + ':' + _M;
                } else {
                  if (t.getHours() === 0 && t.getMinutes() === 0) {
                    return t.getMonth() + 1 + '/' + t.getDate();
                  } else {
                    var _H2 = t.getHours() > 9 ? t.getHours() : '0' + t.getHours();
                    var _M2 = t.getMinutes() > 9 ? t.getMinutes() : '0' + t.getMinutes();
                    return _H2 + ':' + _M2;
                  }
                }
              }
            },
            yDomain: _maxValue > 10 ? [0, _maxValue + Math.floor(_maxValue / 7)] : [0, 10],
            yAxis: {
              showMaxMin: false,
              tickFormat: function tickFormat(d) {
                return d;
              }
            }
          }
        },
        data: []
      };
      chartData.forEach(function (item, index) {
        totalChartData.data.push({
          values: item,
          key: _this7.$gettext('Cpu usage (%)'),
          color: colors[index],
          area: true
        });
      });
      console.log('totalcputData', totalChartData);
      return totalChartData;
    },
    getNetData: function getNetData(data) {
      var _this8 = this;

      var totalOutFlow = [];
      var totalInFlow = [];
      data.sort(function (a, b) {
        return new Date(a.TimeStamp).getTime() - new Date(b.TimeStamp).getTime();
      });
      data.forEach(function (item, index) {
        item._time = new Date(item.TimeStamp).getTime();
        _this8.xAxis.push(item._time);
        totalOutFlow.push({
          x: index,
          xLabel: item._time,
          y: item.IntranetTX || 0
        });
        totalInFlow.push({
          x: index,
          xLabel: item._time,
          y: item.IntranetRX || 0
        });
      });
      return [totalOutFlow, totalInFlow];
    },
    getNetOptions: function getNetOptions(chartData) {
      var _this9 = this;

      var colors = ['#729AFC', '#A2F1AF'];
      var totalChartData = {
        options: {
          chart: {
            showLegend: true,
            showControls: false,
            showMinMaxPoints: false,
            height: 200,
            margin: {
              top: 20,
              right: 20,
              bottom: 40,
              left: 60
            },
            x: function x(d) {
              return d.x;
            },
            y: function y(d) {
              return d.y;
            },
            useInteractiveGuideline: true,
            xAxis: {
              showMaxMin: false,
              tickFormat: function tickFormat(d, x, y) {
                var t = new Date(_this9.xAxis[d]);
                if (x === 0 && x) {
                  var _H = t.getHours() > 9 ? t.getHours() : '0' + t.getHours();
                  var _M = t.getMinutes() > 9 ? t.getMinutes() : '0' + t.getMinutes();
                  return t.getMonth() + 1 + '/' + t.getDate() + ' ' + _H + ':' + _M;
                } else {
                  if (t.getHours() === 0 && t.getMinutes() === 0) {
                    return t.getMonth() + 1 + '/' + t.getDate();
                  } else {
                    var _H3 = t.getHours() > 9 ? t.getHours() : '0' + t.getHours();
                    var _M3 = t.getMinutes() > 9 ? t.getMinutes() : '0' + t.getMinutes();
                    return _H3 + ':' + _M3;
                  }
                }
              }
            },
            yAxis: {
              showMaxMin: false,
              tickFormat: function tickFormat(d) {
                var t = Math.floor(d);
                return t;
              }
            }
          }
        },
        data: []
      };
      chartData.forEach(function (item, index) {
        totalChartData.data.push({
          values: item,
          key: index === 0 ? _this9.$gettext('Total Out Flow (kbytes)') : _this9.$gettext('Total In Flow (kbytes)'),
          color: colors[index],
          area: true
        });
      });
      console.log('totalChartData', totalChartData);
      return totalChartData;
    },
    getdiskData: function getdiskData(data) {
      var BPSRead = [];
      var BPSWrite = [];
      data.sort(function (a, b) {
        return new Date(a.TimeStamp).getTime() - new Date(b.TimeStamp).getTime();
      });
      data.forEach(function (item, index) {
        item._time = new Date(item.TimeStamp).getTime();
        BPSRead.push({
          x: item._time,
          xLabel: item._time,
          y: item.BPSRead
        });
        BPSWrite.push({
          x: item._time,
          xLabel: item._time,
          y: item.BPSWrite || 0
        });
      });
      return [BPSRead, BPSWrite];
    },
    getdiskOptions: function getdiskOptions(chartData) {
      var _this10 = this;

      var colors = ['#729AFC', '#A2F1AF'];
      var totalChartData = {
        options: {
          chart: {
            showLegend: true,
            showControls: false,
            showMinMaxPoints: false,
            height: 200,
            margin: {
              top: 20,
              right: 20,
              bottom: 40,
              left: 60
            },
            x: function x(d) {
              return d.x;
            },
            y: function y(d) {
              return d.y;
            },
            useInteractiveGuideline: true,
            xAxis: {
              showMaxMin: false,
              tickFormat: function tickFormat(d, x, y) {
                var t = new Date(d);
                if (x === 0 && x) {
                  var _H = t.getHours() > 9 ? t.getHours() : '0' + t.getHours();
                  var _M = t.getMinutes() > 9 ? t.getMinutes() : '0' + t.getMinutes();
                  return t.getMonth() + 1 + '/' + t.getDate() + ' ' + _H + ':' + _M;
                } else {
                  if (t.getHours() === 0 && t.getMinutes() === 0) {
                    return t.getMonth() + 1 + '/' + t.getDate();
                  } else {
                    var _H4 = t.getHours() > 9 ? t.getHours() : '0' + t.getHours();
                    var _M4 = t.getMinutes() > 9 ? t.getMinutes() : '0' + t.getMinutes();
                    return _H4 + ':' + _M4;
                  }
                }
              }
            },
            yAxis: {
              showMaxMin: false,
              tickFormat: function tickFormat(d) {
                return parseFloat((d / 1024).toFixed(2));
              }
            }
          }
        },
        data: []
      };
      chartData.forEach(function (item, index) {
        totalChartData.data.push({
          values: item,
          key: index === 0 ? _this10.$gettext('Disk Read Bandwidth (KByte/s)') : _this10.$gettext('Disk write bandwidth (KByte/s)'),
          color: colors[index],
          area: true
        });
      });
      return totalChartData;
    },
    onSelectTime: function onSelectTime(v) {
      var _this11 = this;

      console.log('v', v);
      if (v === 'oneHour') {
        this.monitorInfo.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.monitorInfo.options, {
          StartTime: new Date(new Date().getTime() - 1 * 60 * 60 * 1000),
          EndTime: new Date(new Date().getTime() - 7 * 1000),
          Period: 60
        });
      } else if (v === 'sixHour') {
        this.monitorInfo.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.monitorInfo.options, {
          StartTime: new Date(new Date().getTime() - 6 * 60 * 60 * 1000),
          EndTime: new Date(new Date().getTime() - 7 * 1000),
          Period: 600
        });
      } else if (v === 'oneDay') {
        this.monitorInfo.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.monitorInfo.options, {
          StartTime: new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
          EndTime: new Date(new Date().getTime() - 7 * 1000),
          Period: 3600
        });
      } else if (v === 'sevenDay') {
        [1, 2, 3, 4, 7, 6, 7].forEach(function (_item, _index) {
          var _start = new Date(new Date().getTime() - _item * 24 * 60 * 60 * 1000);
          var _end = new Date(new Date().getTime() - (_item - 1) * 24 * 60 * 60 * 1000);
          if (_index === 0) {
            _end = new Date(new Date().getTime() - 7 * 1000);
          }
          _this11.monitorInfo.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this11.monitorInfo.options, {
            StartTime: _start,
            EndTime: _end,
            Period: 3600
          });
        });
      }
      this.getEcsMonitorData();
      console.log('time', v);
    },
    loadInstanceStatus: function loadInstanceStatus() {
      var _this12 = this;

      var params = {
        id: this.options.resourceId,
        params: {
          Action: 'DescribeInstances',
          InstanceIds: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([this.options.instanceId])
        }
      };
      this.monitorInfo.instanceStatusInterval = setInterval(function () {
        _this12.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.GET_ALIYUN_ECS, params).then(function (d) {
          if (d.Instances.Instance) {
            _this12.basicInfo.Instances = Object.clone(d.Instances.Instance[0]);
            if (_this12.basicInfo.Instances.Status === 'Running' || _this12.basicInfo.Instances.Status === 'Stopped') {
              clearInterval(_this12.monitorInfo.instanceStatusInterval);
            }
          }
        });
      }, 3000);
    },
    changeStatus: function changeStatus(status) {
      this.basicInfo.Instances.Status = status;
    },
    onShowDialog: function onShowDialog(type) {
      var option = {
        type: type,
        Instances: this.basicInfo.Instances,
        resourceId: this.options.resourceId
      };
      this.$emit('onShowCloudDialog', option);
    },
    onStart: function onStart() {
      if (this.basicInfo.Instances && this.options.instanceId) {
        if (this.basicInfo.Instances.Status === 'Stopped') {}
      }
    },
    onCloseForm: function onCloseForm() {
      this.options = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this13 = this;

        if (this.options) {
          this.options = null;
          setTimeout(function () {
            _this13.options = _this13.items;
          }, 300);
        } else {
          this.options = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default.a,
    Nvd3LineChart: __WEBPACK_IMPORTED_MODULE_4__common_nvd3_line_chart___default.a
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_polling__ = __webpack_require__(108);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ClusterConfigFile',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null,
			addForm: {
				ipAddress: ''
			},
			isPolling: false,
			isPaused: false,
			fileList: []
		};
	},

	computed: {
		attrText: function attrText() {
			return this.translateText();
		},
		baseUrl: function baseUrl() {
			return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */];
		},
		pollingInstance: function pollingInstance() {
			return this.$store.state.cluster.configPollingInstance;
		}
	},
	created: function created() {
		if (this.pollingInstance) {
			this.isPolling = true;
		}
	},

	methods: {
		translateText: function translateText() {
			return {
				configurationFile: this.$gettext('Configuration File'),
				updateTime: this.$gettext('Update Time')
			};
		},
		pollingClusterConfig: function pollingClusterConfig(params) {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								return _context.abrupt('return', _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.POLLING_CLUSTER_CONFIG, { task_id: params.task_id }).then(function (res) {
									return res;
								}));

							case 1:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		toExport: function toExport() {
			var _this2 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.EXPORT_CLUSTER_CONFIG, {
				network_id: this.connects.info.id
			}).then(function (res) {
				if (_this2.pollingInstance) {
					_this2.pollingInstance.stop();
				}
				var newPolling = new __WEBPACK_IMPORTED_MODULE_5__plugins_polling__["a" /* default */]({
					interval: 1000 * 3,
					maxRetry: 3,
					requestFn: _this2.pollingClusterConfig,
					requestFnParams: {
						task_id: res.task_id
					},

					onSuccess: function onSuccess(result) {
						_this2.isPolling = true;
						_this2.isPaused = false;
						console.log('轮询获取状态：', result);
						if (result.result) {
							window.open(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* baseUrl */].apiUrl + '/agent/config/query?task_id=' + res.task_id + '&download=1', '_blank');

							newPolling.stop();
							_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE);
							_this2.isPolling = false;
						}
					},

					onError: function onError(error) {
						console.error('轮询请求失败：', error);

						_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE);
						_this2.isPolling = false;
					},

					onComplete: function onComplete() {
						_this2.isPolling = false;
						_this2.isPaused = false;
						console.log('轮询已停止');

						_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE);
					}
				});

				newPolling.start();
				_this2.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.SET_CONFIG_POLLING_INSTANCE, newPolling);
				_this2.isPolling = true;
			});
		},
		importAndRestart: function importAndRestart(response, file) {
			var _this3 = this;

			console.log(response, 'response');

			if (this.pollingInstance) {
				this.pollingInstance.stop();
			}
			var newPolling = new __WEBPACK_IMPORTED_MODULE_5__plugins_polling__["a" /* default */]({
				interval: 1000 * 3,
				maxRetry: 3,
				requestFn: this.pollingClusterConfig,
				requestFnParams: {
					task_id: response.task_id
				},

				onSuccess: function onSuccess(result) {
					_this3.isPolling = true;
					_this3.isPaused = false;
					console.log('轮询获取状态：', result);
					if (result.result) {
						newPolling.stop();
						_this3.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE);
						_this3.$notify({
							message: _this3.$gettext('Update successfully!'),
							type: 'success'
						});
						_this3.$emit('onClosePanel');
						_this3.connects.callback();
					}
				},

				onError: function onError(error) {
					console.error('轮询请求失败：', error);
					_this3.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE);
					_this3.isPolling = false;
				},

				onComplete: function onComplete() {
					_this3.isPolling = false;
					_this3.isPaused = false;
					console.log('轮询已停止');

					_this3.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE);
				}
			});

			newPolling.start();
			this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.SET_CONFIG_POLLING_INSTANCE, newPolling);
			this.isPolling = true;
		},
		importError: function importError(err) {
			console.log(err.message, 'err');
			if (err.message.includes('FileTypeError')) {
				this.$notify({
					message: this.$gettext('File Format Error'),
					type: 'error'
				});
			}
			if (err.message.includes('NetworkNotFound')) {
				this.$notify({
					message: this.$gettext('Cluster Does Not Exist'),
					type: 'error'
				});
			}
			if (err.message.includes('AgentNotFound')) {
				this.$notify({
					message: this.$gettext('Node Not Bound Or Does Not Exist'),
					type: 'error'
				});
			}
		},
		onSubmitForm: function onSubmitForm() {},
		onCloseForm: function onCloseForm() {
			this.connects = null;
			this.$emit('onClosePanel');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				this.connects = this.items;
				this.addForm.update_time = this.items.info.agent.update_time;
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default.a
	}
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ClusterDatabaseSetting',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			resourceId: null,
			parentId: null,
			databaseObj: null,
			addForm: {
				name: '',
				database: '',
				ipAddress: '',
				os: '',
				username: '',
				port: '',
				password: '',
				serviceName: '',
				serviceNameType: 'service_name'
			},
			disEditUsername: true,
			disEditPassword: true,
			moreForm: {
				interceptsCommand: [],
				moreSet: false,
				sqlInterception: '',
				action: '',
				cellName: '',
				interception: [],
				sqlApprover: '',
				approver: [],
				name: '',
				nameList: [],
				sqlAlarmIntruct: '',
				alarmAction: '',
				alarmCellName: '',
				alarmInterception: [],
				notifier: '',
				notifierList: []
			},
			isHave: {
				action: [],
				cellName: false
			},
			isHave_alarm: {
				action: [],
				cellName: false
			},
			rules: {
				name: [{ required: true, message: this.$gettext('Please input the resource name'), trigger: 'change' }],
				database: [{ required: true, message: this.$gettext('Please input the databaseName'), trigger: 'change' }],
				serviceNameType: [{ required: true, message: this.$gettext('Please select the connection identifier type'), trigger: 'change' }],
				serviceName: [{ required: true, message: this.$gettext('Please input the Service Name / SID'), trigger: 'change' }]
			}
		};
	},

	computed: {
		attrText: function attrText() {
			return this.translateText();
		},
		addTable: function addTable() {
			var _this = this;

			var command = this.moreForm.interceptsCommand.find(function (action) {
				return action[0] === _this.moreForm.action;
			});
			if (command) {
				return !command[1];
			} else {
				return true;
			}
		},
		alarmAddTable: function alarmAddTable() {
			var _this2 = this;

			var command = this.moreForm.interceptsCommand.find(function (action) {
				return action[0] === _this2.moreForm.alarmAction;
			});
			if (command) {
				return !command[1];
			} else {
				return true;
			}
		}
	},
	created: function created() {
		var _this3 = this;

		setTimeout(function () {
			_this3.onSetDatabase();
		}, 301);
	},

	methods: {
		translateText: function translateText() {
			return {
				resourceName: this.$gettext('Resource name'),
				database: this.$gettext('Database'),
				connectIdentifier: this.$gettext('Service Name / SID'),
				connectIdentifierType: this.$gettext('Connection identifier type'),
				innerIp: this.$gettext('IP/Connection Address'),
				os: this.$gettext('Type'),
				userName: this.$gettext('Username'),
				tableName: this.$gettext('Table Name'),
				port: this.$gettext('Port'),
				password: this.$gettext('Password'),
				sqlInterception: this.$gettext('SQL Interception'),
				interceptionCommand: this.$gettext('Interception Command'),
				command: this.$gettext('Command'),
				action: this.$gettext('Action'),
				sqlApprover: this.$gettext('SQL Approver'),
				approver: this.$gettext('Approver'),
				select: this.$gettext('select'),
				noApprover: this.$gettext('Not set approver'),
				notCommand: this.$gettext('Not add block command'),
				sqlAlarmIntruct: this.$gettext('SQL Alarm instruction'),
				alarmInstruction: this.$gettext('Alarm instruction'),
				notifier: this.$gettext('Notifier'),
				noNotifier: this.$gettext('Not set notifier'),
				notAlarmCommand: this.$gettext('Not set up alarm command')
			};
		},
		getInterceptsCommand: function getInterceptsCommand() {
			var _this4 = this;

			var params = {
				type: this.addForm.os
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.GET_INTERCEPTS_COMMADN, params).then(function (res) {
				_this4.moreForm.interceptsCommand = res.result;
			});
		},
		onSetDatabase: function onSetDatabase() {
			var _this5 = this;

			this.getSafeApprover();
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.GET_RESOURCE_DETAIL, this.resourceId).then(function (res) {
				console.log(res, '获取数据库资源详情');
				_this5.databaseObj = res;
				_this5.parentId = res.parent_id;
				_this5.addForm = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this5.addForm, {
					name: res.name,
					ipAddress: res.ip_address,
					database: res.databases.join(';'),
					serviceName: res.service_name || '',
					serviceNameType: res.service_name_type || 'service_name',
					username: res.username,
					os: res.os,
					port: res.port
				});
				_this5.moreForm = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this5.moreForm, {
					interception: res.block_pattern ? JSON.parse(res.block_pattern) : [],
					alarmInterception: res.notice_pattern ? JSON.parse(res.notice_pattern) : [],
					sqlApprover: res.status !== 2 ? '0' : '1',
					sqlAlarmIntruct: res.notice_status ? '1' : '0',
					sqlInterception: res.status === 2 ? '1' : '0',
					approver: res.approve_accounts ? res.approve_accounts : [],
					notifierList: res.notice_accounts ? res.notice_accounts : []
				});
				_this5.getInterceptsCommand();
			});
		},
		getSafeApprover: function getSafeApprover() {
			var _this6 = this;

			var params = {
				results_per_page: __WEBPACK_IMPORTED_MODULE_4__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.GET_SAFE_APPROVER, params).then(function (res) {
				_this6.moreForm.nameList = res.objects;
			});
		},
		addCommand: function addCommand() {
			var _this7 = this;

			if (this.moreForm.action !== '') {
				this.isHave.action = [];
				this.isHave.cellName = false;
				if (this.moreForm.interception.length === 0) {
					if (this.moreForm.cellName === '') {
						this.moreForm.interception.push({ op: this.moreForm.action });
					} else {
						this.moreForm.interception.push({ op: this.moreForm.action, table: this.moreForm.cellName });
					}
				} else {
					this.moreForm.interception.forEach(function (item) {
						if (item.op === _this7.moreForm.action) {
							_this7.isHave.action.push(item);
						}
					});
					if (this.isHave.action.isEmpty()) {
						if (this.moreForm.cellName === '') {
							this.moreForm.interception.push({ op: this.moreForm.action });
						} else {
							this.moreForm.interception.push({ op: this.moreForm.action, table: this.moreForm.cellName });
						}
					} else {
						if (this.moreForm.cellName === '') {
							this.isHave.action.forEach(function (item) {
								if (!item.table) {
									_this7.isHave.cellName = true;
								}
							});
							if (!this.isHave.cellName) {
								this.moreForm.interception.push({ op: this.moreForm.action });
							}
						} else {
							this.isHave.action.forEach(function (item) {
								if (item.table === _this7.moreForm.cellName) {
									_this7.isHave.cellName = true;
								}
							});
							if (!this.isHave.cellName) {
								this.moreForm.interception.push({ op: this.moreForm.action, table: this.moreForm.cellName });
							}
						}
					}
				}

				this.moreForm.cellName = '';
			}
		},
		removeCommand: function removeCommand(val) {
			this.moreForm.interception.splice(val, 1);
		},
		addAlarmCommand: function addAlarmCommand() {
			var _this8 = this;

			if (this.moreForm.alarmAction !== '') {
				this.isHave_alarm.action = [];
				this.isHave_alarm.cellName = false;
				if (this.moreForm.alarmInterception.length === 0) {
					if (this.moreForm.alarmCellName === '') {
						this.moreForm.alarmInterception.push({ op: this.moreForm.alarmAction });
					} else {
						this.moreForm.alarmInterception.push({ op: this.moreForm.alarmAction, table: this.moreForm.alarmCellName });
					}
				} else {
					this.moreForm.alarmInterception.forEach(function (item) {
						if (item.op === _this8.moreForm.alarmAction) {
							_this8.isHave_alarm.action.push(item);
						}
					});
					if (this.isHave_alarm.action.isEmpty()) {
						if (this.moreForm.alarmCellName === '') {
							this.moreForm.alarmInterception.push({ op: this.moreForm.alarmAction });
						} else {
							this.moreForm.alarmInterception.push({ op: this.moreForm.alarmAction, table: this.moreForm.alarmCellName });
						}
					} else {
						if (this.moreForm.alarmCellName === '') {
							this.isHave_alarm.action.forEach(function (item) {
								if (!item.table) {
									_this8.isHave_alarm.cellName = true;
								}
							});
							if (!this.isHave_alarm.cellName) {
								this.moreForm.alarmInterception.push({ op: this.moreForm.alarmAction });
							}
						} else {
							this.isHave_alarm.action.forEach(function (item) {
								if (item.table === _this8.moreForm.alarmCellName) {
									_this8.isHave_alarm.cellName = true;
								}
							});
							if (!this.isHave_alarm.cellName) {
								this.moreForm.alarmInterception.push({ op: this.moreForm.alarmAction, table: this.moreForm.alarmCellName });
							}
						}
					}
				}

				this.moreForm.alarmCellName = '';
			}
		},
		removeAlarmCommand: function removeAlarmCommand(val) {
			this.moreForm.alarmInterception.splice(val, 1);
		},
		addApprover: function addApprover() {
			var _this9 = this;

			if (this.moreForm.name !== '') {
				var have = false;
				this.moreForm.approver.forEach(function (item) {
					if (item.name === _this9.moreForm.name) {
						have = true;
					}
				});
				if (!have) {
					this.moreForm.nameList.forEach(function (item) {
						if (item.name === _this9.moreForm.name) {
							_this9.moreForm.approver.push(item);
						}
					});
				}
			}
		},
		removeApprover: function removeApprover(val) {
			this.moreForm.approver.splice(val, 1);
			this.$notify({
				type: 'success',
				message: this.$gettext('Remove successfully!')
			});
		},
		addNotifier: function addNotifier() {
			var _this10 = this;

			if (this.moreForm.notifier !== '') {
				var have = false;
				this.moreForm.notifierList.forEach(function (item) {
					if (item.name === _this10.moreForm.notifier) {
						have = true;
					}
				});
				if (!have) {
					this.moreForm.nameList.forEach(function (item) {
						if (item.name === _this10.moreForm.notifier) {
							_this10.moreForm.notifierList.push(item);
						}
					});
				}
			}
		},
		removeNotifier: function removeNotifier(val) {
			this.moreForm.notifierList.splice(val, 1);
			this.$notify({
				type: 'success',
				message: this.$gettext('Remove successfully!')
			});
		},
		onSubmitForm: function onSubmitForm() {
			var _this11 = this;

			console.log('moreForm', this.moreForm);
			var addApprover = this.moreForm.approver.map(function (item) {
				return item.id;
			}).join(',');
			var addNotifier = this.moreForm.notifierList.map(function (item) {
				return item.id;
			}).join(',');
			var params = {
				id: this.resourceId,
				data: {
					data: {
						name: this.addForm.name,
						ip_address: this.addForm.ipAddress,
						os: this.addForm.os,
						port: Number(this.addForm.port),
						databases: [],
						service_name: this.addForm.os === 'oracle' ? this.addForm.serviceName : null,
						service_name_type: this.addForm.os === 'oracle' ? this.addForm.serviceNameType : null,
						username: this.addForm.username || null,
						password: this.addForm.password || null,
						status: this.moreForm.sqlApprover === '1' ? 2 : 1,
						notice_status: this.moreForm.sqlAlarmIntruct === '1' ? 1 : 0,
						block_pattern: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.moreForm.interception),
						notice_pattern: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.moreForm.alarmInterception)
					}
				}
			};

			this.addForm.database.split(';').forEach(function (el) {
				if (el && el.trim()) {
					params.data.data.databases.push(el.trim());
				}
			});
			if (this.moreForm.sqlApprover === '1') {
				params.data.data.approver_accounts = addApprover;
			}
			if (this.moreForm.sqlAlarmIntruct === '1') {
				params.data.data.notice_accounts = addNotifier;
			}
			if (!this.moreForm.moreSet) {
				this.$refs['addForm'].validate(function (valid) {
					if (valid) {
						_this11.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.PATCH_RESOURCE, params).then(function (res) {
							_this11.$notify({
								type: 'success',
								message: _this11.$gettext('Change successfully!')
							});
							_this11.$emit('callback');
							_this11.onCloseForm();
						});
					} else {
						return false;
					}
				});
			} else {
				this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.PATCH_RESOURCE, params).then(function (res) {
					_this11.$notify({
						type: 'success',
						message: _this11.$gettext('Change successfully!')
					});
					_this11.$emit('callback');
					_this11.onCloseForm();
				});
			}
		},
		onCloseForm: function onCloseForm() {
			this.connects = null;
			this.$emit('onClosePanel');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this12 = this;

				if (this.resourceId) {
					this.resourceId = null;
					setTimeout(function () {
						_this12.resourceId = _this12.items;
					}, 300);
				} else {
					this.resourceId = this.items;
				}
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default.a
	}
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ClusterInstanceSetting',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			resourceId: null,
			parentId: null,
			addForm: {
				name: '',
				instanceId: '',
				ipAddress: '',
				os: '',
				username: '',
				port: '',
				flavor: '',
				clipboard: true
			},
			moreForm: {
				moreSet: false,
				cos: '',
				keyVerify: '',
				availability: []
			},
			isCansubmit: true,
			rules: {
				name: [{ required: true, message: this.$gettext('Please input the resource name'), trigger: 'change' }]
			}
		};
	},

	computed: {
		attrText: function attrText() {
			return this.translateText();
		}
	},
	created: function created() {
		var _this = this;

		setTimeout(function () {
			_this.onGetResource();
		}, 301);
	},

	methods: {
		translateText: function translateText() {
			return {
				resourceName: this.$gettext('Resource name'),
				instanceId: this.$gettext('Instance ID'),
				innerIp: this.$gettext('Inner IP'),
				os: this.$gettext('OS'),
				userName: this.$gettext('Username'),
				port: this.$gettext('Port'),
				flavor: this.$gettext('Flavor Descroption'),
				cos: this.$gettext('CloudLinker Authority Authentication'),
				key: this.$gettext('Target machine key verification'),
				keyAbled: this.$gettext('The availability of key'),
				accountName: this.$gettext('Account Name'),
				availability: this.$gettext('Availability'),
				unavailable: this.$gettext('Unavailable'),
				available: this.$gettext('Available'),
				action: this.$gettext('Action'),
				clipboard: this.$gettext('Clipboard'),
				authenticationMode: this.$gettext('Authentication Mode'),
				emptyText: this.$gettext('Function update, click Save to synchronize authentication data')
			};
		},
		onUsername: function onUsername(val) {
			if (val.trim()) {
				if (/^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/.test(this.addForm.port)) {
					this.isCansubmit = true;
				} else {
					this.isCansubmit = false;
				}
			} else {
				this.isCansubmit = false;
			}
		},
		onPort: function onPort(val) {
			if (/^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/.test(val)) {
				if (this.addForm.username.trim()) {
					this.isCansubmit = true;
				} else {
					this.isCansubmit = false;
				}
			} else {
				this.isCansubmit = false;
			}
		},
		onGetResource: function onGetResource() {
			var _this2 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.GET_RESOURCE_DETAIL, this.resourceId).then(function (res) {
				console.log(res, 'res');

				_this2.parentId = res.parent_id;
				_this2.addForm = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.addForm, {
					name: res.name,
					instanceId: res.instance_id,
					ipAddress: res.ip_address,
					clipboard: res.allow_copy_paste,
					os: res.os,
					username: res.username.join(';'),
					port: res.port,
					flavor: res.flavor
				});
				_this2.moreForm = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.moreForm, {
					cos: res.csos_check,
					keyVerify: res.autologin === 0 ? '0' : '1',
					availability: res.data
				});
				console.log(_this2.addForm, 'addForm');
				console.log(_this2.moreForm, 'moreForm');
			});
		},
		onSubmitForm: function onSubmitForm() {
			var _this3 = this;

			var params = {
				id: this.resourceId,
				data: {
					data: {
						os: this.addForm.os,
						username: [],
						data: this.moreForm.availability.map(function (item) {
							return {
								auth_type: item.auth_type,
								username: item.username
							};
						}),
						port: Number(this.addForm.port),
						name: this.addForm.name,
						flavor: this.addForm.flavor,
						instance_id: this.addForm.instanceId,
						ip_address: this.addForm.ipAddress,
						allow_copy_paste: this.addForm.clipboard,
						autologin: this.moreForm.keyVerify === '0' ? 0 : 1,
						csos_check: this.moreForm.cos
					}
				}
			};
			this.addForm.username.split(';').forEach(function (el) {
				if (el && el.trim()) {
					params.data.data.username.push(el.trim());
				}
			});
			if (!this.moreForm.moreSet) {
				this.$refs['addForm'].validate(function (valid) {
					if (valid) {
						_this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.PATCH_RESOURCE, params).then(function (res) {
							_this3.$notify({
								type: 'success',
								message: _this3.$gettext('Change successfully!')
							});
							_this3.$emit('callback');
							_this3.onCloseForm();
						});
					} else {
						return false;
					}
				});
			} else {
				this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.PATCH_RESOURCE, params).then(function (res) {
					_this3.$notify({
						type: 'success',
						message: _this3.$gettext('Change successfully!')
					});
					_this3.$emit('callback');
					_this3.onCloseForm();
				});
			}
		},
		onTestKeyAvaliable: function onTestKeyAvaliable(list) {
			var _this4 = this;

			var params = {
				id: this.resourceId,
				params: {
					username: list.username
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.TEST_KEY_AVALIABLE, params).then(function (res) {
				var id = res.task_id;
				_this4.onQueryTest(list, id);
			});
		},
		onQueryTest: function onQueryTest(list, id) {
			var _this5 = this;

			var params = {
				id: this.resourceId,
				params: {
					task_id: id
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.QUERY_KEY_AVALIABLE, params).then(function (res) {
				_this5.$set(_this5.moreForm.availability, _this5.moreForm.availability.indexOf(list), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(list, {
					test_result: res.result
				}));
				if (res.result === 'pending') {
					setTimeout(function () {
						_this5.onQueryTest(list, id);
					}, 1000);
				} else {
					console.log('test_result', list.test_result);
				}
			});
		},
		onUpload: function onUpload(option) {
			console.log('option', option);
			this.$emit('upload', option);
		},
		onCloseForm: function onCloseForm() {
			this.connects = null;
			this.$emit('onClosePanel');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this6 = this;

				if (this.resourceId) {
					this.resourceId = null;
					setTimeout(function () {
						_this6.resourceId = _this6.items;
					}, 300);
				} else {
					this.resourceId = this.items;
				}
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
	}
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClusterLogFilter',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      itemForm: null
    };
  },

  methods: {
    onSubmitAddForm: function onSubmitAddForm() {
      var _this = this;

      var params = {
        data: {
          network_id: Number(this.$route.params.id),
          operator: 'contains',
          condition: this.$refs['right-panel-add'].profileModel.condition.trim()
        }
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].CLUSTER.ADD_LOG_FILTER, params).then(function () {
        _this.$notify({
          message: _this.$gettext('Add Successfully!'),
          type: 'success'
        });
        _this.$emit('callback');
      });
      setTimeout(function () {
        _this.onCloseForm();
      }, 300);
    },
    onCloseForm: function onCloseForm() {
      this.itemForm = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        if (this.itemForm) {
          this.itemForm = null;
          setTimeout(function () {
            _this2.itemForm = _this2.items;
          }, 300);
        } else {
          this.itemForm = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_element_ui_packages_form_src_form__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_element_ui_packages_form_src_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_element_ui_packages_form_src_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_element_ui_packages_button_src_button__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_element_ui_packages_button_src_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__node_modules_element_ui_packages_button_src_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ClusterSafeMode',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null,
			loading: false,
			safeMode: {
				setRadio: '1',
				safeRadio: '1',
				command: '',
				name: '',
				nameList: [],
				blockCommand: [],
				addCommand: [],
				delCommand: [],
				approver: []
			},
			alarmMode: {
				alarmRadio: '1',
				command: '',
				name: '',
				nameList: [],
				blockCommand: [],
				addCommand: [],
				delCommand: [],
				notifier: []
			},

			detailInfo: this.$store.getters.cluster.detail.info
		};
	},

	computed: {
		attrText: function attrText() {
			return this.initTranslateText();
		}
	},
	created: function created() {
		var _this = this;

		this.getSafeApprover();
		setTimeout(function () {
			_this.safeMode = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.safeMode, {
				setRadio: _this.items.safe_mode ? '1' : '0',
				safeRadio: _this.items.safe_mode_approver ? '1' : '0',
				blockCommand: [].concat(_this.items.need_intercept_commands || []),
				approver: [].concat(_this.items.approver_accounts || [])
			});

			_this.alarmMode = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.alarmMode, {
				alarmRadio: _this.items.safe_mode_notice ? '1' : '0',
				blockCommand: [].concat(_this.items.need_notice_commands || []),
				notifier: [].concat(_this.items.notice_accounts || [])
			});
		}, 300);
	},

	methods: {
		initTranslateText: function initTranslateText() {
			return {
				selected: this.$gettext('Please select'),
				approver: this.$gettext('Approver'),
				notifier: this.$gettext('Notifier'),
				action: this.$gettext('Action'),
				setstatus: this.$gettext('Set Status'),
				systemCommandAlarm: this.$gettext('System command alarm'),
				alarmInstruction: this.$gettext('Alarm instruction'),
				blockCommand: this.$gettext('Block Command'),
				Command: this.$gettext('Command'),
				safemode: this.$gettext('Security Mode Application'),
				noApprover: this.$gettext('Not set approver'),
				noNotifier: this.$gettext('Not set notifier'),
				notCommand: this.$gettext('Not set up block command'),
				notAlarmCommand: this.$gettext('Not set up alarm command')
			};
		},
		addCommand: function addCommand() {
			if (this.safeMode.command !== '') {
				var stringArr = this.safeMode.command.split(',');
				var that = this;
				var cammandArr = this.safeMode.blockCommand.map(function (item) {
					return item.command;
				});
				stringArr.forEach(function (item) {
					if (cammandArr.indexOf(item) < 0) {
						that.safeMode.blockCommand.push({ command: item, network_id: that.detailInfo.id });
						that.safeMode.addCommand.push({ command: item, network_id: that.detailInfo.id });
					}
				});
			}
			this.safeMode.command = '';
		},
		removeCommand: function removeCommand(val) {
			var _this2 = this;

			this.safeMode.blockCommand.forEach(function (item) {
				if (item.command === val) {
					var key = _this2.safeMode.blockCommand.indexOf(item);
					_this2.safeMode.blockCommand.splice(key, 1);
					_this2.safeMode.delCommand.push(item);
				}
			});
		},
		addAlarmCommand: function addAlarmCommand() {
			if (this.alarmMode.command !== '') {
				var stringArr = this.alarmMode.command.split(',');
				var that = this;
				var cammandArr = this.alarmMode.blockCommand.map(function (item) {
					return item.command;
				});
				stringArr.forEach(function (item) {
					if (cammandArr.indexOf(item) < 0) {
						that.alarmMode.blockCommand.push({ command: item, network_id: that.detailInfo.id });
						that.alarmMode.addCommand.push({ command: item, network_id: that.detailInfo.id });
					}
				});
			}
			this.alarmMode.command = '';
		},
		removeAlarmCommand: function removeAlarmCommand(val) {
			var _this3 = this;

			this.alarmMode.blockCommand.forEach(function (item) {
				if (item.command === val) {
					var key = _this3.alarmMode.blockCommand.indexOf(item);
					_this3.alarmMode.blockCommand.splice(key, 1);
					_this3.alarmMode.delCommand.push(item);
				}
			});
		},
		getSafeApprover: function getSafeApprover() {
			var _this4 = this;

			var params = {
				results_per_page: __WEBPACK_IMPORTED_MODULE_5__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.GET_SAFE_APPROVER, params).then(function (res) {
				_this4.safeMode.nameList = res.objects;
				_this4.alarmMode.nameList = res.objects;
			});
		},
		addApprover: function addApprover() {
			var _this5 = this;

			console.log('this.safeMode.name ', this.safeMode, this.safeMode.name);
			if (this.safeMode.name !== '') {
				var have = false;
				console.log(this.safeMode.approver, this.safeMode.name);
				this.safeMode.approver.forEach(function (item) {
					if (item.name === _this5.safeMode.name) {
						have = true;
					}
				});
				if (!have) {
					this.safeMode.nameList.forEach(function (item) {
						if (item.name === _this5.safeMode.name) {
							_this5.safeMode.approver.push(item);
						}
					});
				}
				console.log(have);
			}
		},
		removeApprover: function removeApprover(val) {
			var _this6 = this;

			this.safeMode.approver.forEach(function (item) {
				if (item.name === val) {
					var key = _this6.safeMode.approver.indexOf(item);
					_this6.safeMode.approver.splice(key, 1);
					_this6.$notify({
						type: 'success',
						message: _this6.$gettext('Remove successfully!')
					});
				}
			});
		},
		addNotifier: function addNotifier() {
			var _this7 = this;

			console.log('this.alarmMode.name ', this.alarmMode, this.alarmMode.name);
			if (this.alarmMode.name !== '') {
				var have = false;
				console.log(this.alarmMode.notifier, this.alarmMode.name);
				this.alarmMode.notifier.forEach(function (item) {
					if (item.name === _this7.alarmMode.name) {
						have = true;
					}
				});
				if (!have) {
					this.alarmMode.nameList.forEach(function (item) {
						if (item.name === _this7.alarmMode.name) {
							_this7.alarmMode.notifier.push(item);
						}
					});
				}
				console.log(have);
			}
		},
		removeNotifier: function removeNotifier(val) {
			var _this8 = this;

			this.alarmMode.notifier.forEach(function (item) {
				if (item.name === val) {
					var key = _this8.alarmMode.notifier.indexOf(item);
					_this8.alarmMode.notifier.splice(key, 1);
					_this8.$notify({
						type: 'success',
						message: _this8.$gettext('Remove successfully!')
					});
				}
			});
		},
		onSubmitSafeMode: function onSubmitSafeMode() {
			var _this9 = this;

			console.log(this.safeMode, 'safeMode');
			console.log(this.alarmMode, 'alarmMode');
			this.loading = true;

			if (this.safeMode.delCommand.length !== 0 || this.alarmMode.delCommand.length !== 0) {
				if (this.safeMode.delCommand.length !== 0) {
					var safeIds = this.safeMode.delCommand.map(function (item) {
						return item.id;
					}).join(',');
					this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.DEL_INTERCEPT, safeIds).then(function (res) {
						if (_this9.safeMode.addCommand.length !== 0) {
							_this9.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.ADD_INTERCEPT, { data: { intercept: _this9.safeMode.addCommand } }).then(function (res) {});
						}
					});
				}
				if (this.alarmMode.delCommand.length !== 0) {
					var alarmIds = this.alarmMode.delCommand.map(function (item) {
						return item.id;
					}).join(',');
					this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.DEL_ALARM_INTERCEPT, alarmIds).then(function (res) {
						if (_this9.safeMode.addCommand.length !== 0) {
							_this9.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.ADD_INTERCEPT, { data: { notice: _this9.alarmMode.addCommand } }).then(function (res) {});
						}
					});
				}
			} else {
				if (this.safeMode.addCommand.length !== 0 || this.alarmMode.addCommand.length !== 0) {
					this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.ADD_INTERCEPT, { data: { intercept: this.safeMode.addCommand, notice: this.alarmMode.addCommand } }).then(function (res) {});
				}
			}
			var account = this.safeMode.approver.map(function (item) {
				return item.id;
			}).join(',');
			var notifier = this.alarmMode.notifier.map(function (item) {
				return item.id;
			}).join(',');
			var params = {
				id: this.$route.params.id,
				data: {
					approver_accounts: account,
					notice_accounts: notifier,
					safe_mode: Number(this.safeMode.setRadio),
					safe_mode_approver: Number(this.safeMode.safeRadio),
					safe_mode_notice: Number(this.alarmMode.alarmRadio)
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.CHANGE, params).then(function (res) {
				_this9.loading = false;
				_this9.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].CLUSTER.UPDATE_DETAIL, res);
			}, function () {
				_this9.loading = false;
			});
			this.$refs.rightPanelSet.onClose();
		},
		onClose: function onClose() {
			this.connects = null;
			this.$emit('onClosePanel');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this10 = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this10.connects = _this10.items;
					}, 300);
				} else {
					this.connects = this.items;
				}
				console.log('watch--->items', this.items);
			},
			deep: true
		}
	},
	components: {
		ElButton: __WEBPACK_IMPORTED_MODULE_4__node_modules_element_ui_packages_button_src_button___default.a,
		ElForm: __WEBPACK_IMPORTED_MODULE_3__node_modules_element_ui_packages_form_src_form___default.a,
		RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
	}
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils__ = __webpack_require__(10);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClusterScanImport',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null,
      agentVersion: null,
      scanForm: {
        cidr: '',
        os: 'linux',
        port: '22',
        userName: 'root'
      },
      queryScan: {
        taskId: '',
        process: 0,
        list: null,
        total: 1,
        selectList: [],
        isCanImport: false,
        isCanScan: false,
        isCanRestart: false,
        importLoading: false,
        hide_duplicate_ip: false
      },
      nameOsObj: {
        'win32': 'administrator',
        'linux': 'root'
      },
      queryTimeout: null,
      newQueryShow: false,
      scanLoading: false,
      rules: {
        cidr: [{ required: true, message: this.$gettext('Please input the Cidr Block'), trigger: 'blur' }, {
          pattern: /^((\d|([1-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))\.)(([0-9]|([1-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))\.){2}([0-9]|([1-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))\/(2[4-9]|3[0-2])$/,
          message: this.$gettext('e.g. 10.0.0.0/24, and only supports 24-32'),
          trigger: 'change,blur'
        }],
        os: [{ required: true, message: this.$gettext('Please select the os'), trigger: 'change' }],
        port: [{ required: true, message: this.$gettext('Please input the port'), trigger: 'change' }, {
          pattern: /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
          message: this.$gettext('please input the right port'),
          trigger: 'change'
        }],
        userName: [{ required: true, message: this.$gettext('Please input the userName'), trigger: 'change' }]
      }
    };
  },
  created: function created() {},

  computed: {
    attrText: function attrText() {
      return this.getTransitionText();
    },
    processPercent: function processPercent() {
      return Math.floor(this.queryScan.process / this.queryScan.total * 100);
    }
  },
  methods: {
    getTransitionText: function getTransitionText() {
      return {
        cidrBlock: this.$gettext('Cidr Block'),
        os: this.$gettext('OS'),
        port: this.$gettext('Port'),
        network: this.$gettext('Network, e.g. 10.0.0.0/24'),
        userName: this.$gettext('userName'),
        moreUser: this.$gettext('Multiple users with semicolons ‘;’')
      };
    },
    changeOs: function changeOs(val) {
      if (val === 'linux') {
        this.scanForm.port = '22';
      } else {
        this.scanForm.port = '3389';
      }
      this.scanForm.userName = this.nameOsObj[val];
    },
    onStartScan: function onStartScan() {
      var _this = this;

      console.log('this.scanForm.userName', this.scanForm.userName);
      this.scanLoading = true;
      var params = {
        cidr: this.scanForm.cidr,
        network_id: this.$route.params.id,
        ports: this.scanForm.port,
        username: '',
        r: Math.random()
      };
      var arr = [];
      this.scanForm.userName.split(';').forEach(function (el) {
        if (el && el.trim()) {
          arr.push(el.trim());
        }
      });
      params.username = arr.join(';');
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.SCAN_SATRT, params).then(function (res) {
        _this.newQueryShow = true;
        _this.scanLoading = false;
        _this.queryScan.taskId = res.task_id;
        _this.onScanQuery();
      });
    },
    onScanQuery: function onScanQuery() {
      var _this2 = this;

      var params = {
        task_id: this.queryScan.taskId,
        network_id: this.$route.params.id,
        hide_duplicate: this.queryScan.hide_duplicate_ip ? '1' : '0'
      };
      if (__WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* default */].Utils.getAgentVersion(this.connects.agent.version) >= '3.0.0') {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.SCAN_NEW_QUERY, params).then(function (res) {
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(res).length > 0) {
            _this2.queryScan.isCanRestart = true;
            _this2.queryScan.list = res.result;
            clearTimeout(_this2.queryTimeout);
          } else {}
        }, function (err) {
          _this2.queryScan.isCanRestart = true;
          _this2.queryScan.list = [];
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(err).length > 0) {
            _this2.$notify({
              type: 'warning',
              message: _this2.$gettext(err.error_message)
            });
          }
          clearTimeout(_this2.queryTimeout);
        });
        this.queryTimeout = setTimeout(this.onScanQuery, 3000);
      } else {
        if (this.queryScan.process < 0 || this.queryScan.process > this.queryScan.total) {
          this.queryScan.isCanRestart = true;
          clearTimeout(this.queryTimeout);
        } else {
          this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.SCAN_QUERY, params).then(function (res) {
            _this2.queryScan.isCanRestart = true;
            _this2.queryScan.process = res.process;
            _this2.queryScan.list = res.result;
            _this2.queryScan.total = res.total;
          }, function () {
            _this2.queryScan.isCanRestart = true;
            clearTimeout(_this2.queryTimeout);
          });
          this.queryTimeout = setTimeout(this.onScanQuery, 3000);
        }
      }
    },
    onScanAgain: function onScanAgain() {
      this.queryScan.process = 0;
      this.queryScan.total = 2;
      this.queryScan.list = null;
      this.queryScan.isCanRestart = false;
      this.onStartScan();
    },
    changeHideDuplicateIp: function changeHideDuplicateIp(val) {
      this.queryScan.hide_duplicate_ip = val;
      this.onScanAgain();
    },
    onSelectImport: function onSelectImport(v) {
      console.log('v', v);
      this.queryScan.selectList = v;
      if (v.length === 0) {
        this.queryScan.isCanImport = false;
      } else {
        this.queryScan.isCanImport = true;
      }
    },
    onStartImport: function onStartImport() {
      var _this3 = this;

      var params = [];
      this.queryScan.importLoading = true;
      this.queryScan.selectList.forEach(function (item) {
        var extension = {
          'os': _this3.scanForm.os,
          'username': ''
        };
        var arr = [];
        _this3.scanForm.userName.split(';').forEach(function (el) {
          if (el && el.trim()) {
            arr.push(el.trim());
          }
        });
        extension.username = arr;
        if (_this3.scanForm.os === 'linux') {
          extension.ssh_port = item.port;
        } else {
          extension.rdp_port = item.port;
        }
        params.push({
          extension: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(extension),
          ip_address: item.ip,
          network_id: _this3.$route.params.id,
          name: item.ip,
          resource_type: _this3.$route.query.type
        });
      });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].CLUSTER.POST_BATCH_RESOURCE, params).then(function (res) {
        _this3.queryScan.importLoading = false;
        _this3.$emit('callback');
        _this3.$notify({
          type: 'success',
          message: _this3.$gettext('Import success')
        });
        _this3.onCloseForm();
      }).catch(function (err) {
        _this3.queryScan.importLoading = false;
        if (err.code === 'ResourceExceeded') {
          _this3.$notify({
            type: 'error',
            message: _this3.$gettext('ResourceExceeded.')
          });
        }
      });
    },
    onCloseForm: function onCloseForm() {
      clearTimeout(this.queryTimeout);
      this.connects = null;
      this.$emit('onClosePanel');
    },
    tableRowClassName: function tableRowClassName(row, index) {
      if (index % 2 === 0) {
        return 'info-row';
      }
      return '';
    }
  },
  watch: {
    scanForm: {
      handler: function handler(newVal, oldVal) {
        var _this4 = this;

        this.$refs['scanForm'].validate(function (valid) {
          _this4.queryScan.isCanScan = valid;
        });
      },
      deep: true
    },
    'items': {
      handler: function handler(newVal) {
        var _this5 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this5.connects = _this5.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
        this.agentVersion = __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* default */].Utils.getAgentVersion(this.connects.agent.version);
        console.log('agent', __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* default */].Utils.getAgentVersion(this.connects.agent.version));
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default.a
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_right_panel__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'SetCluster',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		var _this = this;

		var checkTime = function checkTime(rule, value, callback) {
			if (value) {
				var maxTunnelExpireTime = void 0;
				if (_this.clusterSetForm.timeType === 'minute') {
					maxTunnelExpireTime = _this.clusterSetForm.time * 60;
				} else if (_this.clusterSetForm.timeType === 'hour') {
					maxTunnelExpireTime = _this.clusterSetForm.time * 60 * 60;
				} else if (_this.clusterSetForm.timeType === 'day') {
					maxTunnelExpireTime = _this.clusterSetForm.time * 60 * 60 * 24;
				}
				if (maxTunnelExpireTime > 60 * 60 * 24 * 365) {
					callback(new Error(_this.$gettext('Effective time cannot exceed 1 year')));
				} else if (maxTunnelExpireTime < 60 * 30) {
					callback(new Error(_this.$gettext('In order to ensure the availability of the code, the maximum effective time cannot be less than 30 minutes')));
				} else {
					_this.clusterSetForm.max_tunnel_expire_time = maxTunnelExpireTime;
					callback();
				}
			} else {
				callback(new Error(_this.$gettext('In order to ensure the availability of the code, the maximum effective time cannot be less than 30 minutes')));
			}
		};
		return {
			connects: null,
			timeArr: [{
				value: 'minute',
				label: this.$gettext('minute')
			}, {
				value: 'hour',
				label: this.$gettext('hour')
			}, {
				value: 'day',
				label: this.$gettext('day')
			}],
			clusterSetForm: {
				name: '',
				agent_host_alias: '',
				codeSet: '1',
				timeType: 'minute',
				time: 0,
				is_open_map: false,
				port_map_info: []
			},
			rules: {
				name: [{
					required: true,
					message: this.$gettext('Please input the cluster name'),
					trigger: 'blur'
				}, { max: 50, message: this.$gettext('length is within 50 characters'), trigger: 'change' }],
				time: [{ required: true, type: 'number', message: this.$gettext('Please enter the numeric type'), trigger: 'blur' }, { validator: checkTime, trigger: 'blur' }]
			},
			port_map_info: []
		};
	},

	computed: {
		attrText: function attrText() {
			return this.initAttrText();
		}
	},
	methods: {
		initAttrText: function initAttrText() {
			return {
				name: this.$gettext('Cluster Name :'),
				ip: this.$gettext('Cluster IP :'),
				code: this.$gettext('The maximum effective time of code :'),
				ipName: this.$gettext('IP Name'),
				originPort: this.$gettext('Origin Port'),
				mapPort: this.$gettext('Map Port'),
				ConnectMap: this.$gettext('Service Port Mapping')
			};
		},
		timeLongChange: function timeLongChange(time) {
			var _time = void 0;
			if (time <= 3600) {
				this.clusterSetForm.timeType = 'minute';
				_time = time / 60;
			} else if (time > 3600 && time <= 3600 * 24) {
				this.clusterSetForm.timeType = 'hour';
				_time = (Math.floor(time / 3600) + time % 3600 / 3600).toFixed(2);
			} else if (time > 3600 * 24) {
				this.clusterSetForm.timeType = 'day';
				_time = (Math.floor(time / 86400) + time % 86400 / 86400).toFixed(2);
			}
			this.clusterSetForm.time = parseFloat(_time);
			console.log(this.clusterSetForm.time, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.clusterSetForm.time));
		},
		changeMapPort: function changeMapPort(row) {
			if (row.map_port.toString().includes('.')) {
				row.map_port = parseInt(row.map_port);
			}
			if (row.map_port < 1) {
				row.map_port = 1;
			} else if (row.map_port > 65535) {
				row.map_port = 65535;
			}
		},
		hasPorts: function hasPorts(arr) {
			var seenPorts = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					if (seenPorts.has(item.map_port)) {
						return false;
					}
					seenPorts.add(item.map_port);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return true;
		},
		onCloseForm: function onCloseForm() {
			this.clusterSetForm = {
				name: '',
				agent_host_alias: '',
				codeSet: '1',
				timeType: 'minute',
				time: 0
			};
			this.connects = null;
			this.$emit('onClosePanel');
		},
		onSubmit: function onSubmit() {
			var _this2 = this;

			this.$refs['setClusterForm'].validate(function (valid) {
				if (valid) {
					if (!_this2.hasPorts(_this2.clusterSetForm.port_map_info)) {
						_this2.$notify({
							type: 'error',
							message: _this2.$gettext('The port mapping rules cannot have duplicate ports')
						});
						return;
					}
					var data = {
						is_open_map: _this2.clusterSetForm.is_open_map,
						port_map_info: _this2.clusterSetForm.port_map_info
					};
					if (_this2.clusterSetForm.name !== _this2.connects.info.name) {
						data.name = _this2.clusterSetForm.name;
					}
					if (_this2.clusterSetForm.agent_host_alias !== _this2.connects.info.agent.host) {
						data.agent_host_alias = _this2.clusterSetForm.agent_host_alias;
					}
					if (_this2.clusterSetForm.codeSet === '1') {
						data.max_tunnel_expire_time = 0;
					}
					if (_this2.clusterSetForm.codeSet === '2') {
						data.max_tunnel_expire_time = _this2.clusterSetForm.max_tunnel_expire_time;
					}
					var params = {
						id: _this2.connects.info.id,
						data: data
					};
					_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_consts__["a" /* default */].CLUSTER.CHANGE, params).then(function () {
						_this2.$notify({
							type: 'success',
							message: _this2.$gettext('Change successful')
						});
						_this2.$emit('callback');
						_this2.onCloseForm();
					});
				}
			});
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this3 = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this3.connects = _this3.items;
					}, 300);
				} else {
					this.connects = this.items;
				}
				this.clusterSetForm.name = this.connects.info.name;
				this.clusterSetForm.agent_host_alias = this.connects.info.agent.host;
				this.clusterSetForm.is_open_map = this.connects.info.is_open_map;
				this.connects.info.port_map_info.forEach(function (item) {
					var addItem = {
						ip_name: item.ip_name,
						origin_port: item.origin_port,
						map_port: item.map_port
					};
					_this3.clusterSetForm.port_map_info.push(addItem);
				});
				if (this.connects.info.max_tunnel_expire_time > 0) {
					this.clusterSetForm.codeSet = '2';
					this.timeLongChange(this.connects.info.max_tunnel_expire_time);
				}
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_4__common_right_panel___default.a
	}
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(19);







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('allMember', {
	functional: true,
	render: function render(h, ctx) {
		var item = ctx.props.item;
		return h('li', ctx.data, [h('div', { attrs: { class: 'name' } }, [item.name]), h('div', {}, [item.account])]);
	},
	props: {
		item: { type: Object, required: true }
	}
});
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'GroupAddWorkgroup',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null,
			loading: false,
			workgroupForm: {
				list: [],
				type: '0',
				project_ids: [],
				memberDis: false
			},
			memberName: false,
			rules: {
				value: [{ required: true, message: this.$gettext('Please input workgroup name'), trigger: 'change' }]
			}
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	created: function created() {
		this.getAllWorkgroup();
	},

	methods: {
		getTranslateText: function getTranslateText() {
			return {
				member: this.$gettext('Member'),
				type: this.$gettext('Type'),
				administrator: this.$gettext('administrator'),
				ordinary: this.$gettext('Ordinary Member'),
				inputName: this.$gettext('Please input workgroup name search'),
				inputSearch: this.$gettext('Search')
			};
		},
		getAllWorkgroup: function getAllWorkgroup() {
			var _this = this;

			var params = {
				group_id: this.$route.params.id,
				page_size: __WEBPACK_IMPORTED_MODULE_1__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP, params).then(function (res) {
				_this.workgroupForm.list = res.objects;
			});
		},
		onChangeSelect: function onChangeSelect(val) {
			console.log('select-val', val);
			this.$refs.workgroups.query = '';
		},
		onSubmit: function onSubmit() {
			var _this2 = this;

			this.$refs['workgroupForm'].validate(function (valid) {
				if (valid) {
					var params = {
						id: _this2.$route.params.id,
						project_id: _this2.workgroupForm.project_ids
					};
					if (!_this2.workgroupForm.project_ids) {
						_this2.$notify({
							type: 'error',
							message: _this2.$gettext('Workgroup is found')
						});
					} else {
						_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.ADD_GROUP_WORKGROUP, params).then(function (res) {
							_this2.$notify({
								type: 'success',
								message: _this2.$gettext('Add success')
							});
							_this2.$emit('callback');
							_this2.$refs['right-panel'].onClose();
						}).catch(function (err) {
							_this2.$emit('callback');
							_this2.$refs['right-panel'].onClose();
						});
					}
				} else {
					return false;
				}
			});
		},
		onClose: function onClose() {
			this.connects = null;
			this.$emit('onClosePanel');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this3 = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this3.connects = _this3.items;
					}, 300);
				} else {
					this.connects = this.items;
				}
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
	}
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TeamAddGroup',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null
    };
  },

  methods: {
    onSubmitForm: function onSubmitForm() {
      var _this = this;

      var params = {
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$refs['right-panel'].profileModel)
      };
      console.log('par', params);
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].TEAM.ADD_GROUP, params).then(function () {
        _this.$notify({
          type: 'success',
          message: _this.$gettext('Create group successfully!')
        });
        _this.$emit('callback');
        _this.$refs['right-panel'].onClose();
      }).catch(function (err) {
        console.log('err', err);
        _this.$refs['right-panel'].onSubmitErr();
      });
    },
    onCloseForm: function onCloseForm() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this2.connects = _this2.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'TeamAddMember',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null
		};
	},

	methods: {
		onSubmitAddForm: function onSubmitAddForm() {
			var _this = this;

			var params = {
				data: {
					account: this.$refs['right-panel-add'].profileModel.account,
					name: this.$refs['right-panel-add'].profileModel.name
				}
			};

			switch (this.$refs['right-panel-add'].profileModel.is_admin) {
				case 'ordinary':
					params.data.is_admin = 0;
					break;
				case 'admin':
					params.data.is_admin = 1;
					break;
				case 'auditAdmin':
					params.data.is_admin = 2;
					break;
				case 'optAdmin':
					params.data.is_admin = 3;
					break;
				case 'safeAdmin':
					params.data.is_admin = 4;
					break;
			}
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].TEAM.ADD, params).then(function () {
				_this.$notify({
					message: _this.$gettext('Add Successfully!'),
					type: 'success'
				});
				_this.$refs['right-panel-add'].onClose();
				_this.$emit('callback');
			}).catch(function () {
				console.log('this.profileModel', _this.$refs['right-panel-add'].profileModel);
				_this.$refs['right-panel-add'].onSubmitErr();
			});
		},
		onCloseForm: function onCloseForm() {
			this.connects = null;
			this.$emit('onClosePanel');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this2 = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this2.connects = _this2.items;
					}, 300);
				} else {
					this.connects = this.items;
				}
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
	}
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(19);








__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('allMember', {
	functional: true,
	render: function render(h, ctx) {
		var item = ctx.props.item;
		return h('li', ctx.data, [h('div', { attrs: { class: 'name' } }, [item.name]), h('div', {}, [item.account])]);
	},
	props: {
		item: { type: Object, required: true }
	}
});
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'TeamGroupAddMember',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null,
			loading: false,
			enableSubmitting: true,
			filteredOptions: [],
			memberForm: {
				list: [],
				value: '',
				accountId: null
			},
			rules: {
				value: [{ required: true, message: this.$gettext('Please input members name'), trigger: 'change' }]
			}
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	created: function created() {
		this.getAllMember();
	},

	methods: {
		getTranslateText: function getTranslateText() {
			return {
				member: this.$gettext('Member'),
				inputName: this.$gettext('Please input members name or account search'),
				inputSearch: this.$gettext('Search')
			};
		},
		getAllMember: function getAllMember() {
			var _this = this;

			var params = {
				page_size: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].LOG.GET_ACCOUNT_NAME, params).then(function (res) {
				var filterParams = {
					id: _this.$route.params.id,
					data: {
						page_size: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* Utils */].config.maxPageSize
					}
				};

				_this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].TEAM.GET_GROUP_MEMBERS, filterParams).then(function (exits) {
					var exitIds = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(exits.objects.map(function (e) {
						return e.id;
					}));
					_this.memberForm.list = res.objects.filter(function (item) {
						return !exitIds.has(item.id);
					});
				});
			});
		},
		onChangeSelect: function onChangeSelect(val) {
			console.log('select-val', val);
			this.$refs.members.query = '';
		},
		selectFocus: function selectFocus(event, a, b) {
			if (this.$refs.members) {
				this.$refs.members.$el.children[0].children[1].focus();
			}
		},
		remoteMethod: function remoteMethod(query) {
			var _this2 = this;

			if (query !== '') {
				this.loading = true;
				setTimeout(function () {
					_this2.loading = false;
					_this2.filteredOptions = _this2.memberForm.list.filter(function (item) {
						if (item.name && item.account) {
							return item.name.indexOf(query) > -1 || item.account.indexOf(query) > -1;
						}
					});
				}, 200);
			} else {
				this.filteredOptions = [];
			}
		},
		onSubmit: function onSubmit() {
			var _this3 = this;

			this.$refs['memberForm'].validate(function (valid) {
				if (valid) {
					var params = {
						group_id: _this3.$route.params.id,
						data: {
							members: _this3.memberForm.accountId
						}
					};
					if (!_this3.memberForm.accountId) {
						_this3.$notify({
							type: 'error',
							message: _this3.$gettext('Member is found')
						});
					} else {
						_this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].TEAM.GROUP_ADD_MEMBER, params).then(function (res) {
							_this3.$notify({
								type: 'success',
								message: _this3.$gettext('Add success')
							});
							_this3.$emit('callback');
							_this3.$refs['right-panel'].onClose();
						});
					}
				} else {
					return false;
				}
			});
		},
		onClose: function onClose() {
			this.connects = null;
			this.$emit('onClosePanel');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this4 = this;

				console.log('--this.items(team group add member)--', this.items);
				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this4.connects = _this4.items;
					}, 300);
				} else {
					this.connects = this.items;
				}
			},
			deep: true
		},
		'memberForm.accountId': {
			handler: function handler() {
				if (this.memberForm.accountId.length) {
					this.enableSubmitting = false;
					if (this.$refs.members) {
						this.$refs.members.$el.children[0].children[1].focus();
						this.$refs.members.$el.children[0].children[1].placeholder = this.attrText.inputSearch;
					}
				} else {
					this.enableSubmitting = true;
					this.$refs.members.$el.children[0].children[1].placeholder = '';
				}
			}
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default.a
	}
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TeamGroupSetting',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null,
      setting: {
        name: '',
        note: '',
        isCanSubmit: false
      },
      rules: {
        name: [{ required: true, message: this.$gettext('Please input the group name'), trigger: 'blur, change' }, { max: 20, message: this.$gettext('length is within 20 characters'), trigger: 'change' }],
        note: [{ max: 140, message: this.$gettext('length is within 140 characters'), trigger: 'change' }]
      }
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTranslateText();
    }
  },
  created: function created() {},

  methods: {
    setVal: function setVal(connects) {
      this.setting.name = connects.name;
      this.setting.note = connects.note;
    },
    getTranslateText: function getTranslateText() {
      return {
        name: this.$gettext('Group Name'),
        note: this.$gettext('Comment')
      };
    },
    onSubmitForm: function onSubmitForm() {
      var _this = this;

      this.$refs['groupForm'].validate(function (valid) {
        if (valid) {
          var params = {
            group_id: _this.connects.id,
            data: {
              data: {}
            }
          };
          if (_this.setting.name !== _this.connects.name) {
            params.data.data.name = _this.setting.name;
          }
          if (_this.setting.note !== _this.connects.note) {
            params.data.data.note = _this.setting.note;
          }
          _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].TEAM.EDIT_GROUP, params).then(function () {
            _this.$notify({
              type: 'success',
              message: _this.$gettext('Change successfully!')
            });
            _this.$emit('callback');
          });
          _this.$refs['right-panel'].onClose();
        } else {
          return false;
        }
      });
    },
    onClose: function onClose() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        console.log('---this.items---', this.items);
        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this2.connects = _this2.items;
            _this2.setVal(_this2.connects);
          }, 300);
        } else {
          this.connects = this.items;
          this.setVal(this.connects);
        }
      },
      deep: true
    },
    'setting': {
      handler: function handler(val) {
        if (this.connects && (this.setting.name !== this.connects.name || this.setting.note !== this.connects.note)) {
          this.setting.isCanSubmit = true;
        } else {
          this.setting.isCanSubmit = false;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'TeamMemberSetting',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		var _this = this;

		var validatePass = function validatePass(rule, value, callback) {
			var level = _this.company_password_strength;
			var uppercasePattern = __WEBPACK_IMPORTED_MODULE_2__config__["c" /* PasswordStrengthRegExp */].uppercasePattern;
			var lowercasePattern = __WEBPACK_IMPORTED_MODULE_2__config__["c" /* PasswordStrengthRegExp */].lowercasePattern;
			var sysbolPattern = __WEBPACK_IMPORTED_MODULE_2__config__["c" /* PasswordStrengthRegExp */].sysbolPattern;
			var uppercaseRes = uppercasePattern.test(value);
			var lowercaseRes = lowercasePattern.test(value);
			var sysbolRes = sysbolPattern.test(value);
			if (value.length) {
				if (level === 1) {
					if (value.length >= 6 && (lowercaseRes && uppercaseRes || lowercaseRes && sysbolRes || uppercaseRes && sysbolRes)) {
						callback();
					} else {
						_this.show_password_warning = false;
						callback(new Error(_this.$gettext(__WEBPACK_IMPORTED_MODULE_2__config__["d" /* PasswordStrengthRegExpCallback */].level1_msg)));
					}
				} else if (level === 2) {
					if (value.length >= 8 && lowercaseRes && uppercaseRes && sysbolRes) {
						callback();
					} else {
						_this.show_password_warning = false;
						callback(new Error(_this.$gettext(__WEBPACK_IMPORTED_MODULE_2__config__["d" /* PasswordStrengthRegExpCallback */].level2_msg)));
					}
				} else {
					callback();
				}
			} else {
				callback();
				setTimeout(function () {
					_this.show_password_warning = true;
				}, 300);
			}

			if (_this.$refs.setMemberForm) {
				_this.$refs.setMemberForm.validateField('checkPass');
			}
		};
		var validateCheckPass = function validateCheckPass(rule, value, callback) {
			if (_this.setMember.password && !value) {
				callback(new Error(_this.$gettext('Please confirm your password')));
			} else if (value && value !== _this.setMember.password) {
				callback(new Error(_this.$gettext('Two passwords are not consistent!')));
			} else {
				callback();
			}
		};
		return {
			memberInfo: null,
			company_password_strength: this.$store.getters.team.setting.password_strength || 0,
			show_password_warning: this.$store.getters.team.setting.password_strength !== '0',
			setMember: {
				name: '',
				password: '',
				checkPass: '',
				is_admin: ''
			},
			rules: {
				password: [{ validator: validatePass, trigger: 'blur,change' }],
				checkPass: [{ validator: validateCheckPass, trigger: 'change' }]
			}
		};
	},

	computed: {
		attrText: function attrText() {
			return this.initAttrText();
		}
	},
	created: function created() {
		var _this2 = this;

		setTimeout(function () {
			console.log('this.memberInfo', _this2.items);
			_this2.setMember.is_admin = _this2.items.is_admin.toString();
			_this2.setMember.name = _this2.memberInfo.name;
		}, 300);
	},

	methods: {
		initAttrText: function initAttrText() {
			return {
				optAdmin: this.$gettext('Opt Admin'),
				auditAdmin: this.$gettext('Audit Admin'),
				safeAdmin: this.$gettext('Safe Admin'),
				admin: this.$gettext('Administrator'),
				ordinary: this.$gettext('Ordinary User'),
				name: this.$gettext('Full Name'),
				displayNickname: this.$gettext('Display Nickname'),
				email: this.$gettext('Email'),
				pwd: this.$gettext('Password'),
				repwd: this.$gettext('Repeat Password'),
				role: this.$gettext('Role'),
				selectRole: this.$gettext('Select Role'),
				account: this.$gettext('Account')
			};
		},
		onChangeMember: function onChangeMember(id, formName) {
			var _this3 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var params = {
						data: {
							id: id,
							data: {
								name: _this3.setMember.name,
								is_admin: _this3.setMember.is_admin
							}
						}
					};
					if (_this3.setMember.password !== '') {
						params.data.data.pwd = _this3.setMember.password;
					}
					_this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].TEAM.EDIT_MEMBER, params).then(function () {
						if (id === _this3.$store.getters.account.id) {
							_this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].ACCOUNT.CURRENT);
						}
						_this3.$refs.rightPanelSet.onClose();
						_this3.$emit('callback');
						_this3.$notify({
							type: 'success',
							message: _this3.$gettext('update account success')
						});
					}, function () {
						_this3.$refs.rightPanelSet.onClose();
					});
				} else {
					return false;
				}
			});
		},
		onCloseForm: function onCloseForm() {
			this.memberInfo = null;
			this.$emit('onClosePanel');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this4 = this;

				if (this.memberInfo) {
					this.memberInfo = null;
					setTimeout(function () {
						_this4.memberInfo = _this4.items;
					}, 300);
				} else {
					this.memberInfo = this.items;
				}
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
	}
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    progress: {
      require: true
    },
    done: {
      type: Function,
      default: function _default() {}
    },
    fileInfo: {
      require: true
    }
  },
  methods: {
    onClick: function onClick() {
      document.getElementById('file').click();
    },
    onChange: function onChange(e) {
      var _this = this;

      var files = e.target.files;
      var allFiles = [];

      var _loop = function _loop(i) {
        var file = files[i];
        var reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onprogress = function (e) {
          if (e.lengthComputable) {
            var percentComplete = e.loaded / e.total * 100;
            _this.progress(percentComplete);
          } else {
            console.log('total size is unknown');
          }
        };
        reader.onload = function () {
          var fileInfo = {
            name: file.name,
            type: file.type,
            size: Math.round(file.size),
            base64: reader.result,
            file: file
          };
          allFiles.push(fileInfo);

          if (allFiles.length === files.length) {
            if (_this.multiple) _this.done(allFiles);else _this.done(allFiles[0]);
          }
          e.target.value = '';
        };
      };

      for (var i = 0; i < files.length; i++) {
        _loop(i);
      }
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(19);








__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('allMember', {
	functional: true,
	render: function render(h, ctx) {
		var item = ctx.props.item;
		return h('li', ctx.data, [h('div', { attrs: { class: 'name' } }, [item.name]), h('div', {}, [item.account])]);
	},
	props: {
		item: { type: Object, required: true }
	}
});
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'WorkgroupAddGroup',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null,
			enableSubmitting: true,
			groupForm: {
				list: [],
				value: '',
				groupId: null
			}
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	created: function created() {
		this.getAllMember();
	},

	methods: {
		getTranslateText: function getTranslateText() {
			return {
				group: this.$gettext('Group'),
				inputName: this.$gettext('Please input group name search'),
				inputSearch: this.$gettext('Search')
			};
		},
		getAllMember: function getAllMember() {
			var _this = this;

			var params = {
				params: {
					page_size: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* Utils */].config.maxPageSize
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].TEAM.GROUP_LIST, params).then(function (res) {
				var filterParams = {
					id: _this.$route.params.id,
					data: {
						page_size: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* Utils */].config.maxPageSize
					}
				};
				_this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.GET_GROUP_LIST, filterParams).then(function (exits) {
					var exitIds = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(exits.objects.map(function (e) {
						return e.id;
					}));
					_this.groupForm.list = res.objects.filter(function (item) {
						return !exitIds.has(item.id);
					});
				});
			});
		},
		memberSearch: function memberSearch(queryString, cb) {
			var allResourceName = this.groupForm.list;
			var results = queryString ? allResourceName.filter(this.createFilter(queryString)) : allResourceName;

			cb(results);
		},
		createFilter: function createFilter(queryString) {
			return function (restaurant) {
				if (restaurant.name) {
					return restaurant.name.indexOf(queryString) > -1;
				}
			};
		},
		memberSelect: function memberSelect(item) {
			this.groupForm.value = item.name;
			this.groupForm.groupId = item.id;
		},
		onChangeSelect: function onChangeSelect(val) {
			console.log('select-val', val);
			this.$refs.groups.query = '';
		},
		onSubmit: function onSubmit() {
			var _this2 = this;

			this.$refs['groupForm'].validate(function (valid) {
				if (valid) {
					var params = {
						projectId: _this2.$route.params.id,
						data: {
							group_id: _this2.groupForm.groupId
						}
					};
					if (!_this2.groupForm.groupId) {
						_this2.$notify({
							type: 'error',
							message: _this2.$gettext('Group is not found')
						});
					} else {
						_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.ADD_GROUP, params).then(function (res) {
							_this2.$notify({
								type: 'success',
								message: _this2.$gettext('Add success')
							});
							_this2.$emit('callback');
							_this2.$refs['right-panel'].onClose();
						});
					}
				} else {
					return false;
				}
			});
		},
		onClose: function onClose() {
			this.connects = null;
			this.$emit('onClosePanel');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this3 = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this3.connects = _this3.items;
					}, 300);
				} else {
					this.connects = this.items;
				}
			},
			deep: true
		},
		'groupForm.groupId': {
			handler: function handler() {
				if (this.groupForm.groupId.length) {
					this.enableSubmitting = false;
					if (this.$refs.groups) {
						this.$refs.groups.$el.children[0].children[1].focus();
						this.$refs.groups.$el.children[0].children[1].placeholder = this.attrText.inputSearch;
					}
				} else {
					this.enableSubmitting = true;
					this.$refs.groups.$el.children[0].children[1].placeholder = '';
				}
			}
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_3__common_right_panel___default.a
	}
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_right_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(19);









__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('allMember', {
	functional: true,
	render: function render(h, ctx) {
		var item = ctx.props.item;
		return h('li', ctx.data, [h('div', { attrs: { class: 'name' } }, [item.name]), h('div', {}, [item.account])]);
	},
	props: {
		item: { type: Object, required: true }
	}
});
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'WorkgroupAddMember',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null,
			loading: false,
			enableSubmitting: true,
			filteredOptions: [],
			memberForm: {
				list: [],
				value: '',
				type: '0',
				accountId: null,
				memberDis: false
			},
			memberName: false,
			rules: {
				value: [{ required: true, message: this.$gettext('Please input members name'), trigger: 'change' }]
			}
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	created: function created() {
		var _this = this;

		setTimeout(function () {
			if (_this.connects.account) {
				_this.memberForm = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this.memberForm, {
					memberDis: true,
					value: _this.connects.name,
					type: _this.connects.isAdmin ? '1' : '0',
					accountId: _this.connects.id
				});
			}
		}, 300);
		this.getAllMember();
	},

	methods: {
		getTranslateText: function getTranslateText() {
			return {
				member: this.$gettext('Member'),
				type: this.$gettext('Type'),
				administrator: this.$gettext('administrator'),
				ordinary: this.$gettext('Ordinary Member'),
				inputName: this.$gettext('Please input members name or account search'),
				inputSearch: this.$gettext('Search')
			};
		},
		getAllMember: function getAllMember() {
			var _this2 = this;

			var params = {
				page_size: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.GET_ACCOUNT_NAME, params).then(function (res) {
				var filterParams = {
					id: _this2.$route.params.id,
					data: {
						page_size: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* Utils */].config.maxPageSize
					}
				};
				_this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.GET_MEMBER_LIST, filterParams).then(function (exits) {
					var exitIds = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(exits.objects.map(function (e) {
						return e.id;
					}));
					_this2.memberForm.list = res.objects.filter(function (item) {
						return !exitIds.has(item.id);
					});
				});
			});
		},
		memberSearch: function memberSearch(queryString, cb) {
			var allResourceName = this.memberForm.list;
			var results = queryString ? allResourceName.filter(this.createFilter(queryString)) : allResourceName;

			cb(results);
		},
		createFilter: function createFilter(queryString) {
			return function (restaurant) {
				return restaurant.name.indexOf(queryString) === 0 || restaurant.account.indexOf(queryString) === 0;
			};
		},
		memberSelect: function memberSelect(item) {
			this.memberForm.value = item.name;
			this.memberForm.accountId = item.id;
		},
		onChangeSelect: function onChangeSelect(val) {
			console.log('select-val', val);
			this.$refs.members.query = '';
		},
		selectFocus: function selectFocus(event, a, b) {
			if (this.$refs.members) {
				this.$refs.members.$el.children[0].children[1].focus();
			}
		},
		remoteMethod: function remoteMethod(query) {
			var _this3 = this;

			if (query !== '') {
				this.loading = true;
				setTimeout(function () {
					_this3.loading = false;
					_this3.filteredOptions = _this3.memberForm.list.filter(function (item) {
						if (item.name && item.account) {
							return item.name.indexOf(query) > -1 || item.account.indexOf(query) > -1;
						}
					});
				}, 200);
			} else {
				this.filteredOptions = [];
			}
		},
		onSubmit: function onSubmit() {
			var _this4 = this;

			this.$refs['memberForm'].validate(function (valid) {
				if (valid) {
					var params = {
						projectId: _this4.$route.params.id,
						data: {
							account_id: _this4.memberForm.accountId,
							role: 0
						}
					};
					if (!_this4.memberForm.accountId) {
						_this4.$notify({
							type: 'error',
							message: _this4.$gettext('Member is found')
						});
					} else {
						if (_this4.connects.account) {
							_this4.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.PATCH_MEMBER, params).then(function (res) {
								if (_this4.memberForm.memberDis) {
									_this4.$notify({
										type: 'success',
										message: _this4.$gettext('Change success')
									});
								} else {
									_this4.$notify({
										type: 'success',
										message: _this4.$gettext('Add success')
									});
								}
								_this4.$emit('callback');
								_this4.$refs['right-panel'].onClose();
							});
						} else {
							_this4.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].WORKGROUP.ADD_MEMBER, params).then(function (res) {
								_this4.$notify({
									type: 'success',
									message: _this4.$gettext('Add success')
								});
								_this4.$emit('callback');
								_this4.$refs['right-panel'].onClose();
							});
						}
					}
				} else {
					return false;
				}
			});
		},
		onClose: function onClose() {
			this.connects = null;
			this.$emit('onClosePanel');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this5 = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this5.connects = _this5.items;
					}, 300);
				} else {
					this.connects = this.items;
				}
			},
			deep: true
		},
		'memberForm.accountId': {
			handler: function handler() {
				if (this.memberForm.accountId.length) {
					this.enableSubmitting = false;
					if (this.$refs.members) {
						this.$refs.members.$el.children[0].children[1].focus();
						this.$refs.members.$el.children[0].children[1].placeholder = this.attrText.inputSearch;
					}
				} else {
					this.enableSubmitting = true;
					this.$refs.members.$el.children[0].children[1].placeholder = '';
				}
			}
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_4__common_right_panel___default.a
	}
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkgroupAdd',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null
    };
  },

  methods: {
    onSubmitForm: function onSubmitForm() {
      var _this = this;

      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$refs['right-panel'].profileModel);
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.CREATED_WORKGROUP, params).then(function () {
        _this.$notify({
          type: 'success',
          message: _this.$gettext('Create workgroup success')
        });
        _this.$emit('callback');
        _this.$refs['right-panel'].onClose();
      }).catch(function (err) {
        _this.$refs['right-panel'].onSubmitErr();
        console.log(err, err);
      });
    },
    onClose: function onClose() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this2.connects = _this2.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'WorkgroupChangeHost',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null,
			hostForm: {
				loginUsername: []
			}
		};
	},

	methods: {
		getTranslateText: function getTranslateText() {
			return {
				loginUsername: this.$gettext('Login Username')
			};
		},
		onSubmit: function onSubmit() {
			var _this = this;

			console.log(1, '1');
			console.log(this.$ref, 'ref');
			this.$refs['hostForm'].validate(function (valid) {
				if (valid) {
					var params = {
						id: _this.items.project_resource_id,
						data: {
							login_username: _this.hostForm.loginUsername
						}
					};
					_this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.CHANGE_LOGIN_USER, params).then(function (res) {
						_this.$notify({
							type: 'success',
							message: _this.$gettext('Change success')
						});
						_this.$emit('callback');
						_this.$refs['right-panel'].onClose();
					});
				} else {
					return false;
				}
			});
		},
		onClose: function onClose() {
			this.connects = null;
			this.$emit('onClosePanel');
		}
	},
	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this2 = this;

				console.log('---items', this.items.project_resource_login_username);
				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this2.connects = _this2.items.login_user;
					}, 300);
				} else {
					this.connects = this.items.login_user;
					this.hostForm.loginUsername = this.items.project_resource_login_username ? JSON.parse(this.items.project_resource_login_username).login_username : [];
				}
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
	}
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkgroupDistributeInstance',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null,
      clusterList: [],
      selectedClusterId: '',
      selectedCluster: {},
      page: {
        current: 1,
        total: 0
      },
      loadingMore: false,
      resourceList: [],
      resourceLoading: false,
      selectedResourceAll: false,
      selectedResourceIds: [],
      selectedResourceList: [],
      filter: {
        key: 'q_name',
        value: ''
      }
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTranslateText();
    }
  },
  created: function created() {
    this.getClusterList();
  },

  methods: {
    getTranslateText: function getTranslateText() {
      return {
        'selectCluster': this.$gettext('Select Cluster'),
        'selectInstance': this.$gettext('Select Resource'),
        'selectedInstance': this.$gettext('Selected Instance'),
        'selectedDatabase': this.$gettext('Selected Database'),
        'hostName': this.$gettext('Host name / IP'),
        'databaseName': this.$gettext('Database name/ IP'),
        'name': this.$gettext('Name'),
        'input': this.$gettext('please input search key'),
        'noData': this.$gettext('No Data')
      };
    },
    onChangeCluster: function onChangeCluster(index) {
      this.selectedCluster = this.clusterList.find(function (cluster) {
        return cluster.project_id === index;
      });

      this.selectedResourceIds = [];
      this.resourceList = [];
      this.filter.value = '';
    },
    loadMoreCluster: function loadMoreCluster() {
      this.loadingMore = true;
      this.getClusterList(++this.page.current);
    },
    getClusterList: function getClusterList(page) {
      var _this = this;

      var params = {
        params: {
          page: page || 1,
          page_size: 20
        }
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].CLUSTER.GET_CLUSTER, params).then(function (res) {
        _this.loadingMore = false;
        _this.page.total = res.total;
        var clusterArr = res.objects.map(function (item) {
          return {
            id: item.id,
            project_id: item.project_id,
            name: item.name
          };
        });
        if (!clusterArr.length) return;
        _this.selectedCluster = clusterArr[0];
        if (_this.clusterList.length) {
          _this.clusterList = _this.clusterList.concat(clusterArr);
        } else {
          _this.clusterList = clusterArr;
          _this.selectedClusterId = clusterArr[0].project_id;
        }
      });
    },
    getClusterResources: function getClusterResources() {
      var _this2 = this;

      this.resourceLoading = true;
      var projectId = this.selectedCluster.project_id;
      var params = {
        id: projectId,
        params: {
          type: this.$route.query.type,
          exclude_pid: this.$route.params.id,
          page_size: 50
        }
      };
      if (this.filter.key && this.filter.value) {
        params.params[this.filter.key] = this.filter.value;
      }
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP_RESOURCE, params).then(function (res) {
        _this2.resourceLoading = false;
        _this2.resourceList = res.objects;
        var idArr = [];
        _this2.resourceList.forEach(function (item) {
          var findItem = _this2.selectedResourceList.find(function (_) {
            return _.id === item.id;
          });
          if (findItem) {
            idArr.push(findItem.id);
          }
        });
        _this2.selectedResourceIds = idArr;
        if (_this2.selectedResourceIds.length === _this2.resourceList.length) {
          _this2.selectedResourceAll = true;
        } else {
          _this2.selectedResourceAll = false;
        }
      });
    },
    onFilter: function onFilter() {
      if (!this.filter.key || !this.filter.value) return;
      this.getClusterResources();
    },
    handleCheckAllChange: function handleCheckAllChange(value) {
      var _this3 = this;

      if (this.selectedResourceAll) {
        this.resourceList.forEach(function (item) {
          var findItem = _this3.selectedResourceList.find(function (_) {
            return _.id === item.id;
          });
          var findId = _this3.selectedResourceIds.find(function (id) {
            return id === item.id;
          });
          if (!findItem) {
            _this3.selectedResourceList = _this3.selectedResourceList.concat([item]);
          }
          if (!findId) {
            _this3.selectedResourceIds = _this3.selectedResourceIds.concat([item.id]);
          }
        });
      } else {
        this.resourceList.forEach(function (item) {
          var findIndex = _this3.selectedResourceList.findIndex(function (_) {
            return _.id === item.id;
          });
          var findIdIndex = _this3.selectedResourceIds.findIndex(function (id) {
            return id === item.id;
          });
          if (findIndex >= 0) {
            _this3.selectedResourceList.splice(findIndex, 1);
          }
          if (findIdIndex >= 0) {
            _this3.selectedResourceIds.splice(findIdIndex, 1);
          }
        });
      }
    },
    handleCheckedChange: function handleCheckedChange(values) {
      var _this4 = this;

      if (values.length === this.resourceList.length) {
        this.selectedResourceAll = true;
      } else {
        this.selectedResourceAll = false;
      }
      this.resourceList.forEach(function (item) {
        var findIndex1 = values.findIndex(function (id) {
          return id === item.id;
        });
        var findIndex2 = _this4.selectedResourceList.findIndex(function (_) {
          return _.id === item.id;
        });
        if (findIndex1 < 0 && findIndex2 >= 0) {
          _this4.selectedResourceList.splice(findIndex2, 1);
        } else if (findIndex1 >= 0 && findIndex2 < 0) {
          _this4.selectedResourceList = _this4.selectedResourceList.concat([item]);
        }
      });
    },
    onCloseTag: function onCloseTag(resource) {
      var findIndex = this.selectedResourceList.findIndex(function (item) {
        return item.id === resource.id;
      });
      var findIdIndex = this.selectedResourceIds.findIndex(function (id) {
        return id === resource.id;
      });
      if (findIndex >= 0) {
        this.selectedResourceList.splice(findIndex, 1);
      }
      if (findIdIndex >= 0) {
        this.selectedResourceIds.splice(findIdIndex, 1);
      }
      if (this.selectedResourceIds.length === this.resourceList.length) {
        this.selectedResourceAll = true;
      } else {
        this.selectedResourceAll = false;
      }
    },
    onSubmit: function onSubmit() {
      var _this5 = this;

      var params = {
        projectId: this.$route.params.id,
        data: {
          resources: []
        }
      };
      this.selectedResourceList.forEach(function (item) {
        params.data.resources.push(item.id);
      });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.ADD_WORKGTOUP_RESOURCE, params).then(function (res) {
        _this5.$emit('callback');
        _this5.$refs['right-panel'].onClose();
        _this5.$notify({
          message: _this5.$gettext('Add Successfully!'),
          type: 'success'
        });
      }).catch(function (err) {
        if (err.code === 'ResourceExceeded') {
          _this5.$notify({
            type: 'error',
            message: _this5.$gettext('ResourceExceeded.')
          });
        }
      });
    },
    onClose: function onClose() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this6 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this6.connects = _this6.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_right_panel__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkgroupSetting',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null,
      setting: {
        name: '',
        desc: '',
        isCanSubmit: false
      },
      rules: {
        name: [{ required: true, message: this.$gettext('Please input the workgroup name'), trigger: 'blur' }, { min: 2, message: this.$gettext('2-255 characters'), trigger: 'change' }, { max: 255, message: this.$gettext('2-255 characters'), trigger: 'change' }],
        desc: [{ max: 140, message: this.$gettext('length is within 140 characters'), trigger: 'change' }]
      }
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTranslateText();
    }
  },
  created: function created() {},

  methods: {
    setVal: function setVal(connects) {
      this.setting.name = connects.name;
      this.setting.desc = connects.desc;
    },
    getTranslateText: function getTranslateText() {
      return {
        name: this.$gettext('Workgoup Name'),
        desc: this.$gettext('Describe')
      };
    },
    onSubmitForm: function onSubmitForm() {
      var _this = this;

      this.$refs['workgropForm'].validate(function (valid) {
        if (valid) {
          var params = {
            id: _this.connects.id,
            data: {}
          };
          if (_this.setting.name !== _this.connects.name) {
            params.data.name = _this.setting.name;
          }
          if (_this.setting.desc !== _this.connects.desc) {
            params.data.desc = _this.setting.desc;
          }
          _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.PATCH_WORKGROUP, params).then(function () {
            _this.$notify({
              type: 'success',
              message: _this.$gettext('Change successfully!')
            });
            _this.$emit('callback');
          });
          _this.$refs['right-panel'].onClose();
        } else {
          return false;
        }
      });
    },
    onClose: function onClose() {
      this.connects = null;
      this.$emit('onClosePanel');
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this2.connects = _this2.items;
            _this2.setVal(_this2.connects);
          }, 300);
        } else {
          this.connects = this.items;
          this.setVal(this.connects);
        }
      },
      deep: true
    },
    'setting': {
      handler: function handler(val) {
        if (this.connects && (this.setting.name !== this.connects.name || this.setting.desc !== this.connects.desc)) {
          this.setting.isCanSubmit = true;
        } else {
          this.setting.isCanSubmit = false;
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_1__common_right_panel___default.a
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkgroupAddGroup',
  props: {
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      connects: null,
      detail: {
        groupId: '',
        list: [],
        totalCount: 0,
        currentPage: 1
      }
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTranslateText();
    }
  },
  created: function created() {},

  methods: {
    getTranslateText: function getTranslateText() {
      return {
        'userName': this.$gettext('User Name'),
        'account': this.$gettext('Account')
      };
    },
    getTeamGroupMembers: function getTeamGroupMembers(page, total) {
      var _this = this;

      this.detail.currentPage = page || 1;
      var params = {
        id: this.connects.id,
        data: {
          page: page || 1
        }
      };
      if (total) {
        params.data.total = total;
      }
      this.loading = true;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].TEAM.GET_GROUP_MEMBERS, params).then(function (res) {
        _this.loading = false;
        _this.detail = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
          list: res.objects,
          totalCount: res.total,
          currentPage: page || res.page
        });
      }, function () {
        _this.loading = false;
      });
    },
    onClose: function onClose() {
      this.connects = null;
      this.$emit('onClosePanel');
    },
    handlePageChange: function handlePageChange(page) {
      this.detail.currentPage = page;
      this.getTeamGroupMembers(page, this.detail.totalCount);
    }
  },
  watch: {
    'items': {
      handler: function handler(newVal) {
        var _this2 = this;

        console.log('---items', this.items);
        if (this.connects) {
          this.connects = null;
          setTimeout(function () {
            _this2.connects = _this2.items;
          }, 300);
        } else {
          this.connects = this.items;
        }
        this.getTeamGroupMembers();
      },
      deep: true
    }
  },
  components: {
    RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_account_add_workgroup__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_account_add_workgroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__model_account_add_workgroup__);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			loading: false,
			m: {
				currentTab: this.$route.query.type || 'workgroup',
				totalPage: 1,
				currentPage: 1,
				accountWorkgroupList: [],
				workgroupList: [],
				batchDel: '',
				members: [],
				isHaveNet: false,
				groups: []
			},
			clusterIds: [],
			clusterList: {},
			currentRightPanel: null,
			rightPanelData: null
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	created: function created() {
		this.getAccountWorkGroupList();
	},

	methods: {
		getTranslateText: function getTranslateText() {
			return {
				servers: this.$gettext('Servers'),
				dataBase: this.$gettext('DataBases'),
				members: this.$gettext('Member'),
				workgroup: this.$gettext('Workgroup'),
				group: this.$gettext('Group'),
				name: this.$gettext('Name'),
				cluster: this.$gettext('Cluster'),
				loginUsername: this.$gettext('Login Username'),
				os: this.$gettext('OS'),
				action: this.$gettext('Action'),
				Specification: this.$gettext('Specification'),
				dataBaseName: this.$gettext('Database Name'),
				ipConnect: this.$gettext('IP/Connection String'),
				type: this.$gettext('Type'),
				email: this.$gettext('Email'),
				administrator: this.$gettext('administrator'),
				ordinary: this.$gettext('Ordinary Member'),
				defaultWorkgroup: this.$gettext('default workgroup'),
				selectCluster: this.$gettext('Select Cluster'),
				selectInstance: this.$gettext('Select Resource'),
				selectedInstance: this.$gettext('Selected Instance'),
				selectedDatabase: this.$gettext('Selected Database'),
				hostName: this.$gettext('Host name / IP'),
				account: this.$gettext('Account'),
				desc: this.$gettext('Desc')
			};
		},
		getAccountWorkGroupList: function getAccountWorkGroupList() {
			var _this = this;

			this.loading = true;
			var params = {
				id: this.$route.params.id
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.GET_ACCOUNT_WORKGROUP_LIST, params).then(function (res) {
				console.log(res, 'res');
				_this.m.accountWorkgroupList = res;
				_this.loading = false;
			});
		},
		getWorkGroupList: function getWorkGroupList(page) {
			var _this2 = this;

			this.m.currentPage = page || 1;
			this.loading = true;
			var params = {
				page: page || 1
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP, params).then(function (res) {
				_this2.m.totalPage = res.total;
				_this2.m.workgroupList = res.objects;
				_this2.loading = false;
			});
		},
		batchDel: function batchDel(id) {
			var _this3 = this;

			this.$confirm(this.$gettext('Are You Sure To Exit The Selected Working Group?'), this.$gettext('Exit Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				if (_this3.$route.query.type === 'workgroup') {
					var params = {
						account_id: _this3.$route.params.id,
						project_ids: id.toString()
					};
					_this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.DEL_ACCOUNT_WORKGROUP, params).then(function () {
						_this3.$notify({
							type: 'success',
							message: _this3.$gettext('Exit successfully!')
						});
						_this3.getAccountWorkGroupList();
					});
				}
			});
		},
		onSelectionChange: function onSelectionChange(select) {
			if (select.length !== 0) {
				this.m.batchDel = select.map(function (item) {
					return item.id;
				}).join(',');
			} else {
				this.m.batchDel = '';
			}
			console.log('del', this.m.batchDel);
		},
		onChangePage: function onChangePage(page) {
			this.getWorkGroupList(page);
		},
		onClosePanel: function onClosePanel() {
			this.currentRightPanel = null;
			this.rightPanelData = null;
		},
		callback: function callback() {
			return this.getAccountWorkGroupList();
		},
		onShowAccountAddWorkgroup: function onShowAccountAddWorkgroup(row) {
			var _this4 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'AccountAddWorkgroup' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_1__model_account_add_workgroup___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this4.rightPanelData = row || [];
				}, time);
			});
		},
		tableRowClassName: function tableRowClassName(row, index) {
			if (index % 2 === 0) {
				return 'info-row';
			}
			return '';
		}
	},
	watch: {
		$route: function $route(to, from) {
			this.m.currentTab = this.$route.query.type;
		}
	},
	components: {
		AccountAddWorkgroup: __WEBPACK_IMPORTED_MODULE_1__model_account_add_workgroup___default.a
	}
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_team_group_add_member__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_team_group_add_member___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__model_team_group_add_member__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false,
      detail: {
        totalPage: 1,
        currentPage: 1,
        batchDel: '',
        list: []
      },
      search: {
        user: '',
        val: ''
      },
      currentRightPanel: null,
      rightPanelData: null
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTranslateText();
    }
  },
  created: function created() {
    this.getTeamGroupMembers();
  },

  methods: {
    getTranslateText: function getTranslateText() {
      return {
        'name': this.$gettext('Name'),
        'email': this.$gettext('Email'),
        'type': this.$gettext('Type'),
        'role': this.$gettext('Role'),
        'action': this.$gettext('Action'),
        'administrator': this.$gettext('administrator'),
        'ordinary': this.$gettext('Ordinary Member'),
        'account': this.$gettext('Account')
      };
    },
    getTeamGroupMembers: function getTeamGroupMembers(page, total) {
      var _this = this;

      this.detail.currentPage = page || 1;
      var params = {
        id: this.$route.params.id,
        data: {
          page: page || 1
        }
      };
      if (total) {
        params.data.total = total;
      }
      if (this.search.val !== '') {
        params.data[this.search.user] = this.search.val;
      }
      this.loading = true;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].TEAM.GET_GROUP_MEMBERS, params).then(function (res) {
        _this.loading = false;
        _this.detail = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
          list: res.objects,
          totalPage: res.total,
          currentPage: page || res.page,
          batchDel: ''
        });
      }, function () {
        _this.loading = false;
      });
    },
    batchDel: function batchDel(id) {
      var _this2 = this;

      this.$confirm(this.$gettext('Are you sure to remove selected?'), this.$gettext('Remove Confirm'), {
        confirmButtonText: this.$gettext('Ok'),
        cancelButtonText: this.$gettext('Cancel'),
        type: 'warning'
      }).then(function () {
        var params = {
          group_id: _this2.$route.params.id,
          data: {
            members: id
          }
        };
        _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].TEAM.DEL_GROUP_MEMBER, params).then(function () {
          _this2.$notify({
            type: 'success',
            message: _this2.$gettext('Remove successfully!')
          });
          _this2.clearSearchText();
          _this2.getTeamGroupMembers();
        });
      });
    },
    onSelectionChange: function onSelectionChange(select) {
      if (select.length !== 0) {
        this.detail.batchDel = select.map(function (item) {
          return item.id;
        });
      } else {
        this.detail.batchDel = '';
      }
      console.log('del', this.detail.batchDel);
    },
    clearSearchText: function clearSearchText() {
      this.search.val = '';
    },
    onSearch: function onSearch() {
      this.getTeamGroupMembers();
    },
    onChangePage: function onChangePage(page) {
      this.detail.currentPage = page;
      this.getTeamGroupMembers(page, this.detail.totalPage);
    },
    onClosePanel: function onClosePanel() {
      this.currentRightPanel = null;
      this.rightPanelData = null;
    },
    callback: function callback() {
      this.clearSearchText();
      return this.getTeamGroupMembers();
    },
    onShowTeamGroupAddMember: function onShowTeamGroupAddMember(row) {
      var _this3 = this;

      var time = !this.currentRightPanel || this.currentRightPanel.name === 'TeamGroupAddMember' ? 0 : 300;
      this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_2__model_team_group_add_member___default.a;
      this.$nextTick(function () {
        setTimeout(function () {
          _this3.rightPanelData = row || [];
        }, time);
      });
    },
    tableRowClassName: function tableRowClassName(row, index) {
      if (index % 2 === 0) {
        return 'info-row';
      }
      return '';
    }
  },
  components: {
    TeamGroupAddMember: __WEBPACK_IMPORTED_MODULE_2__model_team_group_add_member___default.a
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_group_add_workgroup_vue__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_group_add_workgroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__model_group_add_workgroup_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			loading: false,
			m: {
				currentTab: this.$route.query.type || 'workgroup',
				totalPage: 1,
				currentPage: 1,
				groupWorkgroupList: [],
				workgroupList: [],
				batchDel: '',
				members: [],
				isHaveNet: false,
				groups: []
			},
			clusterIds: [],
			clusterList: {},
			currentRightPanel: null,
			rightPanelData: null
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	created: function created() {
		this.getWorkGroupListByGroup();
	},

	methods: {
		getTranslateText: function getTranslateText() {
			return {
				servers: this.$gettext('Servers'),
				dataBase: this.$gettext('DataBases'),
				members: this.$gettext('Member'),
				workgroup: this.$gettext('Workgroup'),
				group: this.$gettext('Group'),
				name: this.$gettext('Name'),
				cluster: this.$gettext('Cluster'),
				loginUsername: this.$gettext('Login Username'),
				os: this.$gettext('OS'),
				action: this.$gettext('Action'),
				Specification: this.$gettext('Specification'),
				dataBaseName: this.$gettext('Database Name'),
				ipConnect: this.$gettext('IP/Connection String'),
				type: this.$gettext('Type'),
				email: this.$gettext('Email'),
				administrator: this.$gettext('administrator'),
				ordinary: this.$gettext('Ordinary Member'),
				defaultWorkgroup: this.$gettext('default workgroup'),
				selectCluster: this.$gettext('Select Cluster'),
				selectInstance: this.$gettext('Select Resource'),
				selectedInstance: this.$gettext('Selected Instance'),
				selectedDatabase: this.$gettext('Selected Database'),
				hostName: this.$gettext('Host name / IP'),
				account: this.$gettext('Account'),
				desc: this.$gettext('Desc')
			};
		},
		getWorkGroupListByGroup: function getWorkGroupListByGroup() {
			var _this = this;

			this.loading = true;
			var params = {
				id: this.$route.params.id
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.GET_WORKGROUP_LIST_BY_GROUP, params).then(function (res) {
				console.log(res, 'res');
				_this.m.groupWorkgroupList = res;
				_this.loading = false;
			});
		},
		getWorkGroupList: function getWorkGroupList(page) {
			var _this2 = this;

			this.m.currentPage = page || 1;
			this.loading = true;
			var params = {
				page: page || 1
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP, params).then(function (res) {
				_this2.m.totalPage = res.total;
				_this2.m.workgroupList = res.objects;
				_this2.loading = false;
			});
		},
		batchDel: function batchDel(id) {
			var _this3 = this;

			this.$confirm(this.$gettext('Are You Sure To Exit The Selected Working Group?'), this.$gettext('Exit Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				if (_this3.$route.query.type === 'workgroup') {
					var params = {
						id: _this3.$route.params.id,
						project_id: id.toString()
					};
					_this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_consts__["a" /* default */].WORKGROUP.DEL_GROUP_WORKGROUP, params).then(function () {
						_this3.$notify({
							type: 'success',
							message: _this3.$gettext('Exit successfully!')
						});
						_this3.getWorkGroupListByGroup();
					});
				}
			});
		},
		onSelectionChange: function onSelectionChange(select) {
			if (select.length !== 0) {
				this.m.batchDel = select.map(function (item) {
					return item.id;
				}).join(',');
			} else {
				this.m.batchDel = '';
			}
			console.log('del', this.m.batchDel);
		},
		onChangePage: function onChangePage(page) {
			this.getWorkGroupList(page);
		},
		onClosePanel: function onClosePanel() {
			this.currentRightPanel = null;
			this.rightPanelData = null;
		},
		callback: function callback() {
			return this.getWorkGroupListByGroup();
		},
		onShowAccountAddWorkgroup: function onShowAccountAddWorkgroup(row) {
			var _this4 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'GroupAddWorkgroup' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_1__model_group_add_workgroup_vue___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this4.rightPanelData = row || [];
				}, time);
			});
		},
		tableRowClassName: function tableRowClassName(row, index) {
			if (index % 2 === 0) {
				return 'info-row';
			}
			return '';
		}
	},
	watch: {
		$route: function $route(to, from) {
			this.m.currentTab = this.$route.query.type;
		}
	},
	components: {
		GroupAddWorkgroup: __WEBPACK_IMPORTED_MODULE_1__model_group_add_workgroup_vue___default.a
	}
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_team_add_member__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_team_add_member___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__model_team_add_member__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_team_member_setting__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_team_member_setting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__model_team_member_setting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_team_add_group__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_team_add_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__model_team_add_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_team_group_setting__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_team_group_setting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__model_team_group_setting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(3);













/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var _this = this;

		return {
			loading: true,
			settingLoading: true,
			activeTab: this.$route.query.type || 'members',
			settingForm: {
				isLoaded: false,
				isCanSubmit: false,
				domain: '',
				fullName: '',
				contactName: '',
				contactPhone: '',
				contactAddress: '',
				ipWhitelist: '',
				adminWhitelist: '',
				codeIpWhitelist: true,
				session_expire_time: 30,
				teamToken: '',
				bindedWorkSpaceName: '',
				bindedWorkSpaceId: '',
				iscompanyMfaOpen: false,
				loginLockout: true,
				passwordStrength: 0,
				adminUser: ''
			},
			uploadAction: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* baseUrl */].apiUrl + '/sso/parse_metadata',
			ssoForm: {
				is_open: false,
				is_account_password: true,
				sso_type: 'SAML2.0',
				id_vendor: '',
				login_url: '',
				assertion_url: '',
				access_white_list: '',
				isCanSubmit: false,
				fileList: []
			},

			ntpForm: {
				ntpServer: 'ntp.aliyun.com',
				currentTime: '',
				syncCycle: '5分钟',
				syncCountdown: 300,
				isSyncing: false },
			countdownInterval: null,
			adminUserList: [],
			team: {
				isLoaded: false,
				totalPage: 0,
				currentPage: 1,
				list: []
			},
			group: {
				isLoaded: false,
				totalPage: 0,
				currentPage: 1,
				list: []
			},
			search: {
				isSearch: false,
				user: 'q_name',
				val: ''
			},
			searchGroup: {
				isSearch: false,
				val: ''
			},
			version: {
				versionName: '',
				time: '',
				resource: '',
				cluster: '',
				user: '',
				haveResource: '',
				haveCluster: '',
				haveUser: '',
				shareResource: '',
				shareCluster: ''
			},
			colorName: '',
			versionText: {
				企业版: this.$gettext('Enterprise'),
				旗舰版: this.$gettext('Ultimate'),
				至尊版: this.$gettext('Ultimate'),
				基础版: this.$gettext('Basic'),
				高级版: this.$gettext('Premium'),
				普通版: this.$gettext('Trial'),
				试用版: this.$gettext('Trial')
			},
			versionColor: {
				企业版: 'test',
				旗舰版: 'ulit',
				至尊版: 'ulit',
				基础版: 'base',
				高级版: '',
				普通版: 'test',
				试用版: 'test'
			},
			rules: {
				fullName: [{ required: true, message: this.$gettext('please input the team name'), trigger: 'change' }],
				contactName: [{ required: true, message: this.$gettext('please input the contact name'), trigger: 'change' }],
				contactPhone: [{ required: true, message: this.$gettext('please input the contact phone'), trigger: 'change' }, {
					pattern: /^1[34578]\d{9}$/,
					message: this.$gettext('please input the right contact phone'),
					trigger: 'change'
				}],
				contactAddress: [{ required: true, message: this.$gettext('please input the contact address'), trigger: 'change' }],
				ipWhitelist: [{
					pattern: /^(\d{1,3}|\*)(\.(\d{1,3}|\*)){3}(,(\d{1,3}|\*)(\.(\d{1,3}|\*)){3})*$/,
					message: this.$gettext('please input the ip whitelist, CIDR address is not allowed'),
					trigger: 'change'
				}],
				adminWhitelist: [{
					pattern: /^(\d{1,3}|\*)(\.(\d{1,3}|\*)){3}(,(\d{1,3}|\*)(\.(\d{1,3}|\*)){3})*$/,
					message: this.$gettext('please input the ip whitelist'),
					trigger: 'change'
				}],
				session_expire_time: [{
					pattern: /^(3[0-9]|[4-9][0-9]|[1-3][0-9]{2}|4[0-7][0-9]|480)$/,
					message: this.$gettext('Min. 30 min. 480 min'),
					trigger: 'change'
				}]
			},
			ssoRules: {
				fileList: [{
					validator: function validator(rule, value, callback) {
						if (_this.ssoForm.is_open && _this.ssoForm.fileList.length === 0) {
							callback(new Error(_this.$gettext('Please upload the metadata document.')));
						} else {
							callback();
						}
					},
					trigger: 'change'
				}],
				sso_type: [{ required: true, message: this.$gettext('Please Select Tthe Type'), trigger: 'change' }],
				id_vendor: [{ required: true, message: this.$gettext('please input the ID Vendor'), trigger: 'change' }, { max: 64, message: this.$gettext('The maximum length can be up to 64 characters.'), trigger: 'change' }],
				access_white_list: [{ required: true, message: this.$gettext('Support inputting multiple email domain addresses, for example: cloudcare.cn. Multiple domains should be separated by commas.'), trigger: 'change' }]
			},
			currentRightPanel: null,
			rightPanelData: null
		};
	},

	computed: {
		attrText: function attrText() {
			return this.initAttrText();
		},
		account: function account() {
			var currentAccount = this.$store.getters.account;
			console.log(currentAccount, 'currentAccount');

			return currentAccount;
		}
	},
	created: function created() {
		this.routeChange(this.$route.query.type);
	},

	methods: {
		getTranTest: function getTranTest(number) {
			console.log('number', number);
			if (number >= 0) {
				var translated = this.$ngettext('%{ n } day', '%{ n } days', number);
				var interpolated = this.$gettextInterpolate(translated, { n: number });
				return interpolated;
			} else {
				return this.$gettext('expired');
			}
		},
		initInput: function initInput(val) {
			if (!val) {
				this.search.val = '';
			}
		},
		initAttrText: function initAttrText() {
			var _ref;

			return _ref = {
				member: this.$gettext('Member'),
				group: this.$gettext('Group'),
				groupInputName: this.$gettext('Please input Group Name to Search'),
				optAdmin: this.$gettext('Opt Admin'),
				safeAdmin: this.$gettext('Safe Admin'),
				auditAdmin: this.$gettext('Audit Admin'),
				admin: this.$gettext('Administrator'),
				ordinary: this.$gettext('Ordinary User'),
				accountType: this.$gettext('Account Type'),
				select: this.$gettext('Select'),
				name: this.$gettext('Full Name'),
				displayNickname: this.$gettext('Display Nickname'),
				email: this.$gettext('Email'),
				account: this.$gettext('Account'),
				type: this.$gettext('Type'),
				status: this.$gettext('Status'),
				comment: this.$gettext('Comment'),
				membersNumber: this.$gettext('Members Number'),
				action: this.$gettext('Action'),
				code: this.$gettext('Team ID'),
				teamName: this.$gettext('Team Full Name'),
				person: this.$gettext('Contact Name'),
				phone: this.$gettext('Contact Phone'),
				address: this.$gettext('Contact Address'),
				ip: this.$gettext('IP Whitelist'),
				adminIP: this.$gettext('Admin IP Whitelist'),
				codeIPWhitelist: this.$gettext('Code IP Whitelist'),
				loginHoldTime: this.$gettext('Login Hold Time'),
				takesLoginAgain: this.$gettext('It takes effect after you log in again'),
				teamToken: this.$gettext('Team Token'),
				bindedWorkSpace: this.$gettext('Binded Workspace'),
				mfa: this.$gettext('Team MFA Certification'),
				compelChangePassword: this.$gettext('Compel Change Password'),
				loginLockout: this.$gettext('Login Lockout'),
				pwd: this.$gettext('Password'),
				repwd: this.$gettext('Repeat Password'),
				empty: this.$gettext('Leave blank'),
				mutip: this.$gettext('Multiple IP to separate'),
				Setting: this.$gettext('Setting'),
				version: this.$gettext('Version'),
				nowVersion: this.$gettext('Current Version:'),
				resource: this.$gettext('Resources:'),
				user: this.$gettext('users:'),
				cluster: this.$gettext('Clusters:'),
				shareCluster: this.$gettext('Shared Clusters:'),
				shareResource: this.$gettext('Shared Resources:'),
				remainTime: this.$gettext('remaining time:'),
				motify: this.$gettext('Motify'),
				maxResource: this.$gettext('The maximum amount of resources for a single network in the current version is'),
				passwordStrength: this.$gettext('Password Strength'),
				adminUser: this.$gettext('Master Account Binding Administrator'),
				sso: this.$gettext('SSO'),
				WriterMetadataDocument: this.$gettext('Writer Metadata Document'),
				is_account_password: this.$gettext('Enable Password Login')
			}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'type', this.$gettext('Type')), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'id_vendor', this.$gettext('ID Vendor')), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'login_url', this.$gettext('Login URL')), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'assertion_url', this.$gettext('Assertion URL')), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'access_white_list', this.$gettext('Access Restrictions')), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'ntp', this.$gettext('Clock')), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'ntpServer', this.$gettext('NTP Server')), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'currentTime', this.$gettext('Current Time')), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'syncCycle', this.$gettext('Sync Cycle')), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'syncCountdown', this.$gettext('Sync Countdown')), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'syncSuccess', this.$gettext('NTP sync success')), _ref;
		},
		clearSearchInput: function clearSearchInput() {
			this.search.val = '';
			this.searchGroup.val = '';
		},
		callback: function callback() {
			if (this.activeTab === 'members') {
				this.getTeamMemberList(this.team.currentPage);
			} else if (this.activeTab === 'group') {
				this.getTeamGroupList(this.group.currentPage);
			}
		},
		getTeamMemberList: function getTeamMemberList(page, total) {
			var _this2 = this;

			this.loading = true;
			var params = {
				page: page || 1
			};
			if (total) {
				params.total = total;
			}
			if (this.search.val !== '') {
				params[this.search.user] = this.search.val;
			}
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.GET_MEMBER_LIST, { params: params }).then(function (res) {
				_this2.loading = false;
				_this2.team = {
					isLoaded: true,
					totalPage: res.total,
					list: res.objects,
					currentPage: res.page
				};
			}, function () {
				_this2.loading = false;
			});
		},
		getGroupAdminMembers: function getGroupAdminMembers() {
			var _this3 = this;

			var params = {
				page: 1,
				page_size: __WEBPACK_IMPORTED_MODULE_9__config__["g" /* Utils */].config.maxPageSize,
				q_is_admin: true
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.GET_MEMBER_LIST, { params: params }).then(function (res) {
				_this3.adminUserList = Object.clone(res.objects);
			});
		},
		getTeamGroupList: function getTeamGroupList(page, total) {
			var _this4 = this;

			this.loading = true;
			var params = {
				page: page || 1
			};
			if (total) {
				params.total = total;
			}
			if (this.searchGroup.val !== '') {
				params.q_name = this.searchGroup.val;
			}
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.GROUP_LIST, { params: params }).then(function (res) {
				_this4.loading = false;
				_this4.group = {
					isLoaded: true,
					totalPage: res.total,
					list: res.objects,
					currentPage: res.page
				};
			}, function () {
				_this4.loading = false;
			});
		},
		getSettingFormData: function getSettingFormData() {
			var _this5 = this;

			this.loading = true;
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.CURRENT).then(function (res) {
				console.log(res, 'resres');
				_this5.settingForm = {
					isLoaded: true,
					domain: res.domain,
					fullName: res.full_name,
					contactName: res.contact_name,
					contactPhone: res.contact_phone,
					contactAddress: res.contact_address,
					ipWhitelist: res.ip_whitelist,
					adminWhitelist: res.admin_whitelist,
					codeIpWhitelist: res.code_ip_whitelist === undefined ? true : Boolean(res.code_ip_whitelist),
					session_expire_time: res.session_expire_time,
					domain_token: res.domain_token,
					bindedWorkSpaceName: res.ee_work_space_name,
					bindedWorkSpaceId: res.ee_work_space_id,
					iscompanyMfaOpen: res.company_mfa,
					iscompanyPassword: res.reset_password,
					loginLockout: true,
					passwordStrength: res.password_strength,
					adminUser: res.email
				};
				var userDay = res.current_plan_expire_time - new Date().getTime() / 1000;
				_this5.version.time = Math.ceil(userDay / 60 / 60 / 24);
				_this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.GET_PLAN).then(function (res) {
					_this5.colorName = _this5.versionColor[res.plan];
					_this5.version = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this5.version, {
						versionName: _this5.versionText[res.plan],
						shareResource: res.shared_resources,
						shareCluster: res.shared_networks,
						haveResource: res.resources,
						haveCluster: res.networks,
						haveUser: res.accounts
					});
					console.log('colorName', _this5.colorName);
					_this5.loading = false;
				}, function () {
					_this5.loading = false;
				});
			}, function () {
				_this5.loading = false;
			});
		},
		updateTeamToken: function updateTeamToken() {
			var _this6 = this;

			this.$confirm(this.$gettext('After the team token is updated, the original team token will become invalid and the CloudCare workspace bound to it will also be unbound. Exercise caution when performing this operation.'), this.$gettext('Please Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				_this6.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.UPDATE_TEAM_TOKEN).then(function () {
					_this6.$notify({
						type: 'success',
						message: _this6.$gettext('Update successfully!')
					});
					_this6.getSettingFormData();
				});
			});
		},
		resetMFA: function resetMFA(row, index) {
			var _this7 = this;

			this.$confirm(this.$gettext('Confirm Whether To Reset The Member Mfa Account?'), this.$gettext('Please Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				var data = {
					id: row.id
				};
				_this7.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.RESET_MFA, data).then(function (res) {
					_this7.$notify({
						type: 'success',
						message: _this7.$gettext('Reset successfully!')
					});
					_this7.getSettingFormData();
				});
			});
		},
		unbindWorkSpace: function unbindWorkSpace() {
			var _this8 = this;

			this.$confirm(this.$gettext('After the CloudCare workspace is unbound, historical diagnosis reports cannot be viewed. Exercise caution when performing this operation.'), this.$gettext('Please Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				var data = {
					work_space_id: _this8.settingForm.bindedWorkSpaceId,
					domain: _this8.settingForm.domain
				};
				_this8.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.UNBIND_WORKSPACE, { data: data }).then(function (res) {
					_this8.$notify({
						type: 'success',
						message: _this8.$gettext('Unbind successfully!')
					});
					_this8.getSettingFormData();
				});
			});
		},
		onSubmitSet: function onSubmitSet() {
			var _this9 = this;

			var data = {
				full_name: this.settingForm.fullName,
				contact_name: this.settingForm.contactName,
				contact_phone: this.settingForm.contactPhone,
				contact_address: this.settingForm.contactAddress,
				ip_whitelist: this.settingForm.ipWhitelist,
				admin_whitelist: this.settingForm.adminWhitelist,
				code_ip_whitelist: this.settingForm.codeIpWhitelist ? 1 : 0,
				session_expire_time: this.settingForm.session_expire_time,
				company_mfa: this.settingForm.iscompanyMfaOpen ? 1 : 0,
				reset_password: this.settingForm.iscompanyPassword,
				password_strength: this.settingForm.passwordStrength,
				email: this.settingForm.adminUser
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.SET, { data: data }).then(function (res) {
				_this9.$notify({
					message: _this9.$gettext('Modify team info successfully!'),
					type: 'success'
				});
				_this9.getSettingFormData();
			});
		},
		deleteMember: function deleteMember(row) {
			var _this10 = this;

			this.$confirm(this.$gettext('Are you sure to delete this account!'), this.$gettext('Delete Prompt'), {
				confirmButtonText: this.$gettext('Comfirm'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				_this10.$set(row, 'deleting', true);
				_this10.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.DELETE, row.id).then(function (res) {
					_this10.clearSearchInput();
					_this10.getTeamMemberList(1);
					_this10.$notify({
						type: 'success',
						message: _this10.$gettext('Delete successfully!')
					});
				}).finally(function () {
					_this10.$set(row, 'deleting', false);
				});
			}).catch(function () {
				_this10.$set(row, 'deleting', false);
			});
		},
		deleteGroup: function deleteGroup(row, memberCount) {
			var _this11 = this;

			if (memberCount) {
				this.$alert(this.$gettext('There are members in the group, please delete all members before delete the group!'), this.$gettext('Delete Prompt'), {
					confirmButtonText: this.$gettext('Comfirm'),
					type: 'warning'
				});
			} else {
				this.$confirm(this.$gettext('Are you sure to delete this group!'), this.$gettext('Delete Prompt'), {
					confirmButtonText: this.$gettext('Comfirm'),
					cancelButtonText: this.$gettext('Cancel'),
					type: 'warning'
				}).then(function () {
					_this11.$set(row, 'deleting', true);
					_this11.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.DELETE_GROUP, row.id).then(function (res) {
						_this11.clearSearchInput();
						_this11.getTeamGroupList(1);
						_this11.$notify({
							type: 'success',
							message: _this11.$gettext('Delete successfully!')
						});
					}).finally(function () {
						_this11.$set(row, 'deleting', false);
					});
				}).catch(function () {
					_this11.$set(row, 'deleting', false);
				});
			}
		},
		onTabClick: function onTabClick(tab, event) {
			this.$router.push({ name: 'team', query: { type: tab.name } });
			this.activeTab = this.$route.query.type || 'members';
			this.clearSearchInput();
		},
		onChangePage: function onChangePage(page) {
			this.getTeamMemberList(page, this.team.totalPage);
		},
		onChangeGroupPage: function onChangeGroupPage(page) {
			this.getTeamGroupList(page, this.group.totalPage);
		},
		onSearchMemberClick: function onSearchMemberClick() {
			this.getTeamMemberList();
		},
		onSearchGroupClick: function onSearchGroupClick() {
			this.getTeamGroupList();
		},
		tableRowClassName: function tableRowClassName(row, index) {
			if (index % 2 === 0) {
				return 'info-row';
			}
			return '';
		},
		routeChange: function routeChange(tab) {
			console.log('--team-current-tab--', tab);
			if (tab === 'settings' || tab === 'version') {
				if (tab === 'settings') {
					this.getGroupAdminMembers();
				}
				this.getSettingFormData();
			} else if (tab === 'members') {
				this.getTeamMemberList();
			} else if (tab === 'group') {
				this.getTeamGroupList();
			} else if (tab === 'sso') {
				this.getSSOConfig();
			} else if (tab === 'ntp') {
				this.getNTPConfig();
			}
		},
		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		onClosePanel: function onClosePanel() {
			this.currentRightPanel = null;
			this.rightPanelData = null;
		},
		trimSapce: function trimSapce(rule, value, callback) {
			if (value.match(/^\s+$/)) {
				if (this.currentRightPanel === __WEBPACK_IMPORTED_MODULE_5__model_team_add_member___default.a) {
					callback(new Error(this.$gettext('Please input the name')));
				}
			} else {
				value = value.trim();
				callback();
			}
		},
		onShowTeamAddGroup: function onShowTeamAddGroup() {
			var _this12 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'TeamAddGroup' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_7__model_team_add_group___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this12.rightPanelData = {
						name: {
							label: _this12.$gettext('Group Name'),
							val: '',
							rule: [{ required: true, message: _this12.$gettext('Please input the group name'), trigger: 'blur' }, { min: 2, message: _this12.$gettext('2-20 characters'), trigger: 'change' }, { max: 20, message: _this12.$gettext('2-20 characters'), trigger: 'change' }]
						},
						note: {
							label: _this12.$gettext('Comment'),
							val: '',
							rule: [{ max: 140, message: _this12.$gettext('length is within 140 characters'), trigger: 'change' }],
							type: 'textarea',
							options: {
								autosize: true,
								resize: '300'
							}
						}
					};
				}, time);
			});
		},
		onShowTeamGroupSetting: function onShowTeamGroupSetting(row, index) {
			var _this13 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'TeamGroupSetting' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_8__model_team_group_setting___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this13.rightPanelData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, row, { index: index });
					console.log(_this13.rightPanelData);
				}, time);
			});
		},
		onShowTeamAddMember: function onShowTeamAddMember() {
			var _this14 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'TeamAddMember' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_5__model_team_add_member___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this14.rightPanelData = {
						account: {
							label: _this14.$gettext('Email'),
							val: '',
							rule: [{ required: true, message: _this14.$gettext('Please input the email'), trigger: 'blur' }, { required: true, pattern: /^\S+@\S+(\.\S{2,})+$/, message: _this14.$gettext('Please input the right email'), trigger: 'blur,change' }]
						},
						name: {
							label: _this14.$gettext('Full Name'),
							val: '',
							rule: [{ required: true, message: _this14.$gettext('Please input the name'), trigger: 'change' }, { min: 2, message: _this14.$gettext('2-16 characters'), trigger: 'change' }, { max: 16, message: _this14.$gettext('2-16 characters'), trigger: 'change' }, { validator: _this14.trimSapce, trigger: 'blur' }]
						},
						is_admin: {
							label: _this14.$gettext('Role'),
							val: 'ordinary',
							rule: { required: true, message: _this14.$gettext('Please select the role'), trigger: 'change' },
							type: 'select',
							options: [{ text: _this14.$gettext('ordinary user'), key: 'ordinary' }, { text: _this14.$gettext('adminstrator'), key: 'admin' }, { text: _this14.$gettext('Opt Admin'), key: 'optAdmin' }, { text: _this14.$gettext('Audit Admin'), key: 'auditAdmin' }]
						}
					};
				}, time);
			});
		},
		onShowTeamMemberSetting: function onShowTeamMemberSetting(row, index) {
			var _this15 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'TeamMemberSetting' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_6__model_team_member_setting___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this15.rightPanelData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, row, { index: index });
					console.log('setting-info', _this15.rightPanelData);
				}, time);
			});
		},
		changeStatus: function changeStatus(row) {
			var _this16 = this;

			console.log(row, 'row');
			console.log(this.$store.getters.account, 'account');
			var message = '\u662F\u5426' + (row.status ? '启用' : '禁用') + '\u6210\u5458' + row.name + '\uFF1F';

			this.$confirm(message, {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				var params = {
					data: {
						id: row.id,
						data: {
							status: !row.status
						}
					}
				};
				_this16.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.EDIT_MEMBER, params).then(function () {
					_this16.$notify({
						type: 'success',
						message: _this16.$gettext('update account success')
					});
					_this16.getTeamMemberList(1);
				});
			});
		},
		uploadSuccess: function uploadSuccess(response, file, fileList) {
			console.log('uploadSuccess', response, file, fileList);
			if (response) {
				console.log(fileList, 'fileList');
				this.ssoForm.fileList = fileList.slice(-1);
				console.log(this.ssoForm, 'ssoForm');

				this.$notify({
					type: 'success',
					message: this.$gettext('Upload successfully!')
				});
			} else {
				this.$notify({
					type: 'error',
					message: response.message || this.$gettext('Upload failed!')
				});
			}
		},
		removeFile: function removeFile(file, fileList) {
			console.log(file, fileList, 'file');
			this.ssoForm.fileList = fileList;
		},
		getSSOConfig: function getSSOConfig() {
			var _this17 = this;

			this.loading = true;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.GET_SSO_CONFIG).then(function (res) {
				console.log(res, 'res');
				_this17.loading = false;

				_this17.ssoForm = {
					is_open: res.is_open,
					is_account_password: res.is_account_password,
					sso_type: res.sso_type,
					id_vendor: res.id_vendor,
					login_url: res.login_url,
					assertion_url: res.assertion_url,
					access_white_list: res.access_white_list,
					fileList: res.fileList
				};
				console.log(_this17.ssoForm, 'ssoForm');
			}, function () {
				_this17.loading = false;
			});
		},
		onSubmitSetSSO: function onSubmitSetSSO() {
			var _this18 = this;

			var data = {
				is_open: this.ssoForm.is_open,
				is_account_password: this.ssoForm.is_account_password,
				sso_type: this.ssoForm.sso_type,
				id_vendor: this.ssoForm.id_vendor,
				access_white_list: this.ssoForm.access_white_list
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.UPDATE_SSO_CONFIG, data).then(function (res) {
				_this18.$notify({
					type: 'success',
					message: _this18.$gettext('Update SSO config successfully!')
				});
				_this18.getSSOConfig();
			});
		},
		copySuccess: function copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success'
			});
			e.clearSelection();
		},
		getNTPConfig: function getNTPConfig() {
			var _this19 = this;

			this.loading = true;
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.GET_NTP_CONFIG).then(function (res) {
				console.log(res, 'NTP配置');
				_this19.ntpForm = {
					ntpServer: res.host,
					currentTime: res.time,
					syncCycle: '5分钟',
					syncCountdown: _this19.ntpForm.syncCountdown
				};
				_this19.loading = false;
				_this19.startCountdown();
			}, function () {
				_this19.loading = false;
			});
		},
		startCountdown: function startCountdown() {
			var _this20 = this;

			if (this.countdownInterval) clearInterval(this.countdownInterval);
			this.countdownInterval = setInterval(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_this20.ntpForm.currentTime++;

								if (_this20.ntpForm.syncCountdown <= 0) {
									_this20.onManualSyncNtp();
								} else {
									_this20.ntpForm.syncCountdown--;
								}

							case 2:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this20);
			})), 1000);
		},
		onManualSyncNtp: function onManualSyncNtp() {
			var _this21 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var res;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_this21.ntpForm.isSyncing = true;
								_this21.ntpForm.syncCountdown = 300;

								_context2.prev = 2;
								_context2.next = 5;
								return _this21.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.UPDATE_NTP_CONFIG, {
									host: _this21.ntpForm.ntpServer
								});

							case 5:
								res = _context2.sent;

								_this21.getNTPConfig();

								_this21.$notify({ type: 'success', message: _this21.$gettext('NTP sync success!') });
								_context2.next = 13;
								break;

							case 10:
								_context2.prev = 10;
								_context2.t0 = _context2['catch'](2);

								_this21.$notify({ type: 'error', message: _this21.$gettext('NTP sync failed!') });

							case 13:
								_context2.prev = 13;

								_this21.ntpForm.isSyncing = false;
								return _context2.finish(13);

							case 16:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this21, [[2, 10, 13, 16]]);
			}))();
		}
	},
	destroyed: function destroyed() {
		clearInterval(this.countdownInterval);
	},

	watch: {
		settingForm: {
			handler: function handler(newVal) {
				var _this22 = this;

				if (this.$refs['teamSetForm']) {
					this.$refs['teamSetForm'].validate(function (valid) {
						_this22.settingForm.isCanSubmit = valid;
					});
				}
			},
			deep: true
		},
		ssoForm: {
			handler: function handler(newVal) {
				var _this23 = this;

				if (this.$refs['ssoSetForm']) {
					this.$refs['ssoSetForm'].validate(function (valid) {
						_this23.ssoForm.isCanSubmit = valid;
					});
				}
			},
			deep: true
		},
		$route: function $route(to, from) {
			this.activeTab = this.$route.query.type;
			this.routeChange(this.activeTab);
		}
	},
	components: {
		TeamAddMember: __WEBPACK_IMPORTED_MODULE_5__model_team_add_member___default.a,
		TeamMemberSetting: __WEBPACK_IMPORTED_MODULE_6__model_team_member_setting___default.a,
		TeamAddGroup: __WEBPACK_IMPORTED_MODULE_7__model_team_add_group___default.a,
		TeamGroupSetting: __WEBPACK_IMPORTED_MODULE_8__model_team_group_setting___default.a
	}
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_workgroup_distribute_instance__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_workgroup_distribute_instance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__model_workgroup_distribute_instance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_workgroup_add_member__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_workgroup_add_member___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__model_workgroup_add_member__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_workgroup_view_group__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_workgroup_view_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__model_workgroup_view_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_workgroup_add_group__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_workgroup_add_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__model_workgroup_add_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_workgroup_change_host_vue__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_workgroup_change_host_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__model_workgroup_change_host_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			loading: false,
			detail: {
				currentTab: this.$route.query.type || 'ecs',
				totalPage: 1,
				currentPage: 1,
				info: {},
				list: [],
				batchDel: '',
				members: [],
				isHaveNet: false,
				groups: []
			},
			clusterIds: [],
			clusterList: {},
			currentRightPanel: null,
			rightPanelData: null
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	created: function created() {
		this.getWorkGroupDetail();
		this.onRouteChange();
	},

	methods: {
		getTranslateText: function getTranslateText() {
			return {
				servers: this.$gettext('Servers'),
				dataBase: this.$gettext('DataBases'),
				members: this.$gettext('Member'),
				group: this.$gettext('Group'),
				name: this.$gettext('Name'),
				cluster: this.$gettext('Cluster'),
				loginUsername: this.$gettext('Login Username'),
				os: this.$gettext('OS'),
				action: this.$gettext('Action'),
				Specification: this.$gettext('Specification'),
				dataBaseName: this.$gettext('Database Name'),
				ipConnect: this.$gettext('IP/Connection String'),
				type: this.$gettext('Type'),
				email: this.$gettext('Email'),
				administrator: this.$gettext('administrator'),
				ordinary: this.$gettext('Ordinary Member'),
				defaultWorkgroup: this.$gettext('default workgroup'),
				selectCluster: this.$gettext('Select Cluster'),
				selectInstance: this.$gettext('Select Resource'),
				selectedInstance: this.$gettext('Selected Instance'),
				selectedDatabase: this.$gettext('Selected Database'),
				hostName: this.$gettext('Host name / IP'),
				account: this.$gettext('Account')
			};
		},
		getWorkGroupDetail: function getWorkGroupDetail() {
			var _this = this;

			var params = {
				id: this.$route.params.id
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.GET_WORKGROUP_DETAIL, params).then(function (res) {
				console.log(res, 'res');
				_this.detail.info = res;
				if (!_this.detail.info.network_id) {
					_this.detail.isHaveNet = true;
				}
			});
		},
		getWorkGroupList: function getWorkGroupList(page) {
			var _this2 = this;

			this.detail.currentPage = page || 1;
			this.loading = true;
			var params = {
				id: this.$route.params.id,
				params: {
					page: page || 1,
					type: this.$route.query.type
				}
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP_RESOURCE, params).then(function (res) {
				_this2.detail.totalPage = res.total;
				_this2.detail.list = res.objects;
				_this2.loading = false;
			});
		},
		getMemberList: function getMemberList(page, total) {
			var _this3 = this;

			var params = {
				id: this.$route.params.id,
				data: {
					page: page || 1
				}
			};
			if (total) {
				params.data.total = total;
			}
			this.loading = true;
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.GET_MEMBER_LIST, params).then(function (res) {
				_this3.detail.members = res.objects;
				_this3.detail.totalPage = res.total;
				_this3.detail.currentPage = res.page;
				_this3.loading = false;
			}, function () {
				_this3.loading = false;
			});
		},
		getGroupList: function getGroupList(page, total) {
			var _this4 = this;

			var params = {
				id: this.$route.params.id,
				data: {
					page: page || 1
				}
			};
			if (total) {
				params.data.total = total;
			}
			this.loading = true;
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.GET_GROUP_LIST, params).then(function (res) {
				_this4.detail.groups = res.objects;
				_this4.detail.totalPage = res.total;
				_this4.detail.currentPage = res.page;
				_this4.loading = false;
			}, function () {
				_this4.loading = false;
			});
		},
		batchDel: function batchDel(row, id) {
			var _this5 = this;

			this.$confirm(this.$gettext('Are you sure to delete selected?'), this.$gettext('Delete Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning'
			}).then(function () {
				row && _this5.$set(row, 'loading', true);
				!row && (_this5.loading = true);
				if (_this5.$route.query.type === 'member') {
					var params = {
						projectId: _this5.$route.params.id,
						data: {
							account_ids: id
						}
					};
					_this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.DEL_MEMBER, params).then(function () {
						_this5.$notify({
							type: 'success',
							message: _this5.$gettext('Delete successfully!')
						});
						_this5.getMemberList();
					}).finally(function () {
						row && _this5.$set(row, 'loading', false);
						!row && (_this5.loading = false);
					});
				} else if (_this5.$route.query.type === 'group') {
					var _params = {
						projectId: _this5.$route.params.id,
						data: {
							group_ids: id
						}
					};
					_this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.DEL_GROUP, _params).then(function () {
						_this5.$notify({
							type: 'success',
							message: _this5.$gettext('Delete successfully!')
						});
						_this5.getGroupList();
					}).finally(function () {
						row && _this5.$set(row, 'loading', false);
						!row && (_this5.loading = false);
					});
				} else {
					if (typeof id === 'string') {
						id = id.split(',');
					} else {
						id = [id];
					}
					var _params2 = {
						projectId: _this5.$route.params.id,
						data: {
							resources: id
						}
					};
					_this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.DEL_WORKGROUP_RESOURCE, _params2).then(function () {
						_this5.$notify({
							type: 'success',
							message: _this5.$gettext('Delete successfully!')
						});
						_this5.getWorkGroupList();
					}).finally(function () {
						row && _this5.$set(row, 'loading', false);
						!row && (_this5.loading = false);
					});
				}
			}).catch(function () {
				row && _this5.$set(row, 'loading', false);
				!row && (_this5.loading = false);
			});
		},
		onSelectionChange: function onSelectionChange(select) {
			if (select.length !== 0) {
				this.detail.batchDel = select.map(function (item) {
					return item.id;
				}).join(',');
			} else {
				this.detail.batchDel = '';
			}
			console.log('del', this.detail.batchDel);
		},
		onTabClick: function onTabClick(tab) {
			this.$router.push({ name: 'settingWorkgroupDetail', query: { type: tab.name } });
			this.detail = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.detail, {
				currentTab: this.$route.query.type || 'ecs',
				batchDel: '',
				currentPage: 1
			});
			this.$refs.memberTable.clearSelection();
			this.$refs.groupTable.clearSelection();
			console.log('this.detail.batchDel---', this.detail.batchDel);
		},
		onRouteChange: function onRouteChange() {
			if (this.$route.query.type === 'member') {
				this.getMemberList();
			} else if (this.$route.query.type === 'group') {
				this.getGroupList();
			} else {
				this.getWorkGroupList();
			}
		},
		onChangePage: function onChangePage(page) {
			if (this.$route.query.type === 'group') {
				this.getGroupList(page, this.detail.totalPage);
			} else if (this.$route.query.type === 'member') {
				this.getMemberList(page, this.detail.totalPage);
			} else {
				this.getWorkGroupList(page);
			}
		},
		onClosePanel: function onClosePanel() {
			this.currentRightPanel = null;
			this.rightPanelData = null;
		},
		callback: function callback() {
			if (this.currentRightPanel === __WEBPACK_IMPORTED_MODULE_2__model_workgroup_distribute_instance___default.a || this.currentRightPanel === __WEBPACK_IMPORTED_MODULE_6__model_workgroup_change_host_vue___default.a) {
				return this.getWorkGroupList();
			} else if (this.currentRightPanel === __WEBPACK_IMPORTED_MODULE_5__model_workgroup_add_group___default.a) {
				return this.getGroupList();
			} else {
				return this.getMemberList();
			}
		},
		batchChange: function batchChange(row) {
			var _this6 = this;

			console.log('修改主机');
			var time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupChangeHost' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_6__model_workgroup_change_host_vue___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this6.rightPanelData = row || [];
				}, time);
			});
		},
		onShowWorkgroupViewGroup: function onShowWorkgroupViewGroup(row) {
			var _this7 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupViewGroup' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_4__model_workgroup_view_group___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this7.rightPanelData = row || [];
				}, time);
			});
		},
		onShowWorkgroupAddGroup: function onShowWorkgroupAddGroup(row) {
			var _this8 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupAddGroup' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_5__model_workgroup_add_group___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this8.rightPanelData = row || [];
				}, time);
			});
		},
		onShowWorkgroupDistributeInstance: function onShowWorkgroupDistributeInstance() {
			var _this9 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupDistributeInstance' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_2__model_workgroup_distribute_instance___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this9.rightPanelData = [];
				}, time);
			});
		},
		onShowWorkgroupAddMember: function onShowWorkgroupAddMember(row) {
			var _this10 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupAddMember' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_3__model_workgroup_add_member___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this10.rightPanelData = row || [];
				}, time);
			});
		},
		tableRowClassName: function tableRowClassName(row, index) {
			if (index % 2 === 0) {
				return 'info-row';
			}
			return '';
		}
	},
	watch: {
		$route: function $route(to, from) {
			this.detail.currentTab = this.$route.query.type;
			this.onRouteChange();
		}
	},
	components: {
		WorkgroupDistributeInstance: __WEBPACK_IMPORTED_MODULE_2__model_workgroup_distribute_instance___default.a,
		WorkgroupAddMember: __WEBPACK_IMPORTED_MODULE_3__model_workgroup_add_member___default.a,
		WorkgroupViewGroup: __WEBPACK_IMPORTED_MODULE_4__model_workgroup_view_group___default.a,
		WorkgroupAddGroup: __WEBPACK_IMPORTED_MODULE_5__model_workgroup_add_group___default.a,
		WorkgroupChangeHost: __WEBPACK_IMPORTED_MODULE_6__model_workgroup_change_host_vue___default.a
	}
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_workgroup_add__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_workgroup_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__model_workgroup_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_workgroup_setting__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_workgroup_setting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__model_workgroup_setting__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      search: {
        condition: 'q_name',
        name: '',
        params: []
      },
      workGroup: {
        list: [],
        totalPage: 0,
        currentPage: 1
      },
      currentRightPanel: null,
      rightPanelData: null
    };
  },

  computed: {
    attrText: function attrText() {
      return this.getTranslateText();
    }
  },
  created: function created() {
    this.getWorkGroupList();
  },

  methods: {
    getTranTest: function getTranTest(clusters) {
      var translated = this.$ngettext('%{ n } resource', '%{ n } resources', clusters);
      var interpolated = this.$gettextInterpolate(translated, { n: clusters });
      return interpolated;
    },
    getTranMember: function getTranMember(clusters) {
      var translated = this.$ngettext('%{ n } member', '%{ n } members', clusters);
      var interpolated = this.$gettextInterpolate(translated, { n: clusters });
      return interpolated;
    },
    getTranslateText: function getTranslateText() {
      return {
        inputName: this.$gettext('Please input WokGroup Name'),
        defaultWorkgroup: this.$gettext('default workgroup'),
        select: this.$gettext('select'),
        name: this.$gettext('Name')
      };
    },
    getWorkGroupList: function getWorkGroupList(page, total) {
      var _this = this;

      var params = {
        page: page || 1
      };
      if (this.search.name !== '' && this.search.condition) {
        params[this.search.condition] = this.search.name;
      }
      if (total) {
        params.total = total;
      }
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP, params).then(function (res) {
        _this.loading = false;
        _this.workGroup = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
          list: res.objects,
          totalPage: res.total,
          currentPage: res.page
        });
      }, function () {
        _this.loading = false;
      });
    },
    onSearch: function onSearch() {
      this.getWorkGroupList();
    },
    clearSearchInput: function clearSearchInput() {
      this.search.name = '';
    },
    deleteResource: function deleteResource(id) {
      var _this2 = this;

      this.$confirm(this.$gettext('Are you sure to delete this project?'), this.$gettext('Delete Confirm'), {
        confirmButtonText: this.$gettext('Comfirm'),
        cancelButtonText: this.$gettext('Cancel'),
        type: 'warning'
      }).then(function () {
        _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].WORKGROUP.DELETE_WORKGROUP, id).then(function () {
          _this2.clearSearchInput();
          _this2.getWorkGroupList(_this2.workGroup.currentPage);
          _this2.$notify({
            type: 'success',
            message: _this2.$gettext('Delete successfully!')
          });
        });
      });
    },
    onChangePage: function onChangePage(page) {
      this.getWorkGroupList(page, this.workGroup.totalPage);
    },
    tableRowClassName: function tableRowClassName(row, index) {
      if (index % 2 === 0) {
        return 'info-row';
      }
      return '';
    },
    onClosePanel: function onClosePanel() {
      this.currentRightPanel = null;
      this.rightPanelData = null;
    },
    onShowCreateWorkgroupAdd: function onShowCreateWorkgroupAdd() {
      var _this3 = this;

      var time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupAdd' ? 0 : 300;
      this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_2__model_workgroup_add___default.a;
      this.$nextTick(function () {
        setTimeout(function () {
          _this3.rightPanelData = {
            'name': {
              label: _this3.$gettext('Workgroup Name'),
              val: '',
              rule: [{
                required: true, message: _this3.$gettext('Please input the workgroup name'), trigger: 'blur'
              }, { min: 2, message: _this3.$gettext('2-255 characters'), trigger: 'change' }, { max: 255, message: _this3.$gettext('2-255 characters'), trigger: 'change' }]
            },
            'tips': {
              type: 'tips',
              text: _this3.$gettext('Note: A workgroup can allocate up to 1000 resources')
            },
            'desc': {
              label: _this3.$gettext('Describe'),
              val: '',
              rule: [{ max: 140, message: _this3.$gettext('length is within 140 characters'), trigger: 'change' }],
              type: 'textarea',
              options: {
                autosize: true,
                resize: '300'
              }
            }
          };
        }, time);
      });
    },
    onShowCreateWorkgroupSetting: function onShowCreateWorkgroupSetting(row) {
      var _this4 = this;

      console.log('row', row);
      var time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupSetting' ? 0 : 300;
      this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_3__model_workgroup_setting___default.a;
      this.$nextTick(function () {
        setTimeout(function () {
          _this4.rightPanelData = row;
        }, time);
      });
    }
  },
  components: {
    WorkgroupAdd: __WEBPACK_IMPORTED_MODULE_2__model_workgroup_add___default.a,
    WorkgroupSetting: __WEBPACK_IMPORTED_MODULE_3__model_workgroup_setting___default.a
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_alarm_log_detail_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_alarm_log_detail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__model_alarm_log_detail_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			selectOptions: __WEBPACK_IMPORTED_MODULE_2__config__["f" /* SelectOptionsConfig */].alarmLogs.role,
			loading: true,
			log: {
				list: [],
				totalPage: 0,
				currentPage: 1
			},
			search: {
				options: [],
				isAdmin: '',
				account: '',
				startTime: '',
				endTime: '',
				eventType: '',
				role: '',
				is_read: true,
				isDisabled: true
			},
			eventShow: false,
			currentRightPanel: null,
			rightPanelData: null,
			teamList: []
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getAttrText();
		}
	},
	created: function created() {
		this.search.options.push({
			key: 'is_read',
			val: this.search.is_read ? 0 : 1
		});
		if (this.$route.query.notice_accounts) {
			for (var k in this.$route.query) {
				this.search.options.push({
					key: k,
					val: this.$route.query[k]
				});
				this.search.role = k;
				this.search.account = this.$route.query[k];
			}
		}
		this.getAlarmLog(1);
		this.getTeamList();
	},

	methods: {
		getAttrText: function getAttrText() {
			return {
				event: this.$gettext('Event'),
				safeAdmin: this.$gettext('Safe Admin'),
				optAdmin: this.$gettext('Opt Admin'),
				auditAdmin: this.$gettext('Audit Admin'),
				admin: this.$gettext('Administrator'),
				select: this.$gettext('Select'),
				startTime: this.$gettext('Start Time'),
				endTime: this.$gettext('End Time'),
				input: this.$gettext('Please input'),
				time: this.$gettext('Time'),
				account: this.$gettext('Account'),
				eventType: this.$gettext('Event Type'),
				action: this.$gettext('Action'),
				operationTime: this.$gettext('Operation Time'),
				sourceIp: this.$gettext('Source IP'),
				operationObj: this.$gettext('Operation Obj'),
				workGroup: this.$gettext('In Work Group'),
				connectType: this.$gettext('Connect Type'),
				eventDesc: this.$gettext('Event Desc'),
				norifyObj: this.$gettext('Notify Obj'),
				users: this.$gettext('Users'),
				triggerStrategy: this.$gettext('Trigger Strategy'),
				status: this.$gettext('Status')
			};
		},
		getAlarmLog: function getAlarmLog(page) {
			var _this = this;

			this.loading = true;
			var params = {
				page_index: page || 1
			};
			this.search.options.forEach(function (item) {
				params[item.key] = item.val;
			});

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].LOG.ALARM, { params: params }).then(function (res) {
				console.log(res, '告警日志');
				if (res.objects && res.objects.length) {
					_this.log.list = _this.$store.getters.logs.alarmLogs.objects;
					_this.log.totalPage = _this.$store.getters.logs.alarmLogs.num_results;
					_this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].LOG.UNREAD_COUNTS, 0);
					setTimeout(function () {
						_this.eventShow = true;
					}, 10);
				} else {
					_this.log.list = res.objects;
					_this.log.totalPage = res.num_results;
				}
				_this.loading = false;
				console.log(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* SelectOptionsConfig */].alarmLogs, 'SelectOptionsConfig.alarmLogs');
			}, function () {
				_this.loading = false;
			});
		},
		onSelectIsRead: function onSelectIsRead() {
			this.log.currentPage = 1;
			this.search.options = this.search.options.filter(function (item) {
				return item.key !== 'is_read';
			});
			this.search.options.push({
				key: 'is_read',
				val: this.search.is_read ? 0 : 1
			});
			this.getAlarmLog(1);
		},
		toShowAlarmDetail: function toShowAlarmDetail(row) {
			var _this2 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'alarmLogDetail' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_3__model_alarm_log_detail_vue___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this2.rightPanelData = row;
				}, time);
			});
		},
		getTeamList: function getTeamList() {
			var _this3 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].TEAM.GET_MEMBER_LIST).then(function (res) {
				console.log(res, 'res');
				if (res && res.objects && res.objects.length) {
					_this3.teamList = res.objects;
				}
			});
		},
		onSearch: function onSearch() {
			this.log.currentPage = 1;
			this.search.options = [];
			if (this.search.startTime !== '') {
				this.search.options.push({
					key: 'start_time',
					val: this.search.startTime.getTime() / 1000
				});
			}
			if (this.search.endTime !== '') {
				this.search.options.push({
					key: 'end_time',
					val: this.search.endTime.getTime() / 1000 + 24 * 3600
				});
			}
			if (this.search.isAdmin !== '') {
				this.search.options.push({
					key: 'admin',
					val: this.search.isAdmin
				});
			}
			if (this.search.account !== '') {
				if (this.search.role === '') {
					this.search.options.push({
						key: 'account',
						val: this.search.account
					});
				} else {
					this.search.options.push({
						key: this.search.role,
						val: this.search.account
					});
				}
			}
			if (this.search.eventType !== '') {
				this.search.options.push({
					key: 'event',
					val: this.search.eventType
				});
			}
			this.getAlarmLog(1);
		},
		onChangePage: function onChangePage(page) {
			this.getAlarmLog(page);
		},
		onSelectRole: function onSelectRole() {
			if (this.search.role !== '') {
				this.search.isDisabled = false;
			}
		},
		resetSearchValue: function resetSearchValue() {
			this.search = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.search, {
				isAdmin: '',
				account: '',
				startTime: '',
				endTime: '',
				eventType: '',
				role: '',
				isDisabled: true
			});
		},
		onClosePanel: function onClosePanel() {
			this.currentRightPanel = null;
			this.rightPanelData = null;
		},
		exportLog: function exportLog() {
			if (this.search.role === '') {
				window.open(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* baseUrl */].apiUrl + '/event/sys_log_export?log_type=alarmLogs&admin=' + this.search.isAdmin + '&start_time=' + (this.search.startTime ? this.search.startTime.getTime() / 1000 : '') + '&end_time=' + (this.search.endTime ? this.search.endTime.getTime() / 1000 + 24 * 3600 : '') + '&event=' + this.search.eventType + '&account=' + this.search.account, '_blank');
			} else {
				window.open(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* baseUrl */].apiUrl + '/event/sys_log_export?log_type=alarmLogs&admin=' + this.search.isAdmin + '&start_time=' + (this.search.startTime ? this.search.startTime.getTime() / 1000 : '') + '&end_time=' + (this.search.endTime ? this.search.endTime.getTime() / 1000 + 24 * 3600 : '') + '&event=' + this.search.eventType + '&' + this.search.role + '=' + this.search.account, '_blank');
			}
		}
	},

	components: {
		alarmLogDetail: __WEBPACK_IMPORTED_MODULE_3__model_alarm_log_detail_vue___default.a
	}
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_right_panel__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'CreateEventNotice',
	props: {
		items: {
			required: true
		}
	},
	data: function data() {
		return {
			connects: null
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		}
	},
	created: function created() {},

	methods: {
		getTranslateText: function getTranslateText() {
			return {
				eventType: this.$gettext('Event Type'),
				notifyObj: this.$gettext('Notify Obj')
			};
		},
		copySuccess: function copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success'
			});
		},
		onCloseChange: function onCloseChange() {
			this.connects = null;
			this.$emit('onClosePanel');
		}
	},
	watch: {
		items: {
			handler: function handler(newVal) {
				var _this = this;

				if (this.connects) {
					this.connects = null;
					setTimeout(function () {
						_this.connects = _this.items;
					}, 300);
				} else {
					this.connects = this.items;
				}
				console.log(this.connects, 'this.connects');
			},
			deep: true
		}
	},
	components: {
		RightPanel: __WEBPACK_IMPORTED_MODULE_2__common_right_panel___default.a
	}
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_echarts_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_echarts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_echarts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_consts__ = __webpack_require__(2);






var THEME_COLORS = {
	pie: ['#1890ff', '#722ed1', '#00c48c', '#fa8c16', '#f5222d'],

	line: '#4895ef',

	multiLine: ['#4895ef', '#fa8c16', '#00c48c', '#722ed1'],

	bar: '#1890ff'
};

var legendColorMap = {
	'Windows（RDP）': '#1890ff',
	'Linux（SSH）': '#722ed1',
	'SQL Server': '#00c48c',
	MySQL: '#fa8c16',
	PostgreSQL: '#f5222d'
};

/* harmony default export */ __webpack_exports__["default"] = ({
	components: { Echarts: __WEBPACK_IMPORTED_MODULE_0__common_echarts_vue___default.a },
	props: {
		filterParams: {
			type: Object,
			required: true
		}
	},
	data: function data() {
		var _this = this;

		return {
			accountList: [],

			overviewData: {
				resources: 0,
				projects: 0,
				networks: 0,
				accounts: 0
			},

			statRowData: {
				conn_account_count: 0,
				resource_count: 0,
				conn_count: 0,
				notice_count: 0,
				avg_days_conn_count: 0,
				conn_time: '0',
				avg_days_conn_time: '0',
				avg_conn_time: '0'
			},

			connectCountPie: {
				title: { text: '连接次数/资源类型', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
				legend: {
					show: false,
					type: 'scroll',
					orient: 'vertical',
					right: 10,
					top: 20,
					formatter: function formatter(name) {
						var item = _this.connectCountPie.series[0].data.find(function (i) {
							return i.name === name;
						});
						return name + '\n' + item.value + ' (' + item.percent + '%)';
					}
				},
				series: [{
					name: '连接次数',
					radius: ['30%', '60%'],
					center: ['50%', '60%'],

					label: {
						show: true,
						position: 'outside',
						rich: {
							line1: {
								align: 'left',
								width: 80 },
							line2: {
								align: 'left'
							}
						},
						formatter: '{line1|{b}}\n{line2|{c} ({d}%)}',
						fontSize: 12
					},

					labelLine: {
						show: true,
						smooth: false,
						length: 10,
						length2: 30,
						lineStyle: {
							type: 'dashed',
							color: '#666',
							width: 1 },

						silent: true,
						showAbove: true },

					data: [{ name: 'MySQL', value: 13, percent: 6 }, { name: 'SQL server', value: 13, percent: 6 }, { name: 'PostgreSQL', value: 13, percent: 6 }, { name: 'Windows(RDP)', value: 13, percent: 6 }, { name: 'Linux(SSH)', value: 13, percent: 6 }]
				}]
			},

			connectCountLine: {
				title: { text: '连接次数', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: {
					trigger: 'axis',
					backgroundColor: '#000',
					textStyle: { color: '#fff', fontSize: 12 },
					padding: 10,
					borderRadius: 4,
					formatter: function formatter(params) {
						var html = '<div style="margin-bottom:8px;">' + params[0].axisValue + '</div>';

						params.forEach(function (item) {
							var dot = '<span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:' + item.color + '; margin-right:6px;"></span>';

							html += '<div style="line-height:1.8;">' + dot + item.seriesName + '\uFF1A' + item.value + '</div>';
						});
						return html;
					},
					axisPointer: { type: 'line', lineStyle: { color: '#999' } }
				},
				legend: { top: 'top', right: 'center', show: false },
				grid: { left: '5%', right: '5%', bottom: '10%' },
				xAxis: {
					data: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30']
				},
				yAxis: { type: 'value', min: 0 },
				series: [{
					name: '连接次数',
					symbol: 'circle',
					symbolSize: 6,
					smooth: false,
					lineStyle: { width: 2, color: THEME_COLORS.line },
					itemStyle: { color: THEME_COLORS.line },

					data: [15, 15, 0, 30, 15, 60, 30, 15, 15, -5, 0, 5]
				}]
			},

			connectTimePie: {
				title: { text: '连接时长（小时）/资源类型', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: { trigger: 'item', formatter: '{b}: {c}小时 ({d}%)' },
				legend: {
					show: false,
					type: 'scroll',
					orient: 'vertical',
					right: 10,
					top: 20,
					formatter: function formatter(name) {
						var item = _this.connectTimePie.series[0].data.find(function (i) {
							return i.name === name;
						});
						return name + '\n' + item.value + '\u5C0F\u65F6 (' + item.percent + '%)';
					}
				},
				series: [{
					name: '连接时长',
					radius: ['30%', '60%'],
					center: ['50%', '60%'],

					label: {
						show: true,
						position: 'outside',
						rich: {
							line1: {
								align: 'left',
								width: 80 },
							line2: {
								align: 'left'
							}
						},
						formatter: '{line1|{b}}\n{line2|{c} ({d}%)}',
						fontSize: 12
					},

					labelLine: {
						show: true,
						smooth: false,
						length: 10,
						length2: 30,
						lineStyle: {
							type: 'dashed',
							color: '#666',
							width: 1 },

						silent: true,
						showAbove: true },

					data: [{ name: 'MySQL', value: 13, percent: 6 }, { name: 'SQL server', value: 13, percent: 6 }, { name: 'PostgreSQL', value: 13, percent: 6 }, { name: 'Windows(RDP)', value: 13, percent: 6 }, { name: 'Linux(SSH)', value: 13, percent: 6 }]
				}]
			},

			connectTimeLine: {
				title: { text: '连接时长（小时）', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: {
					trigger: 'axis',
					backgroundColor: '#000',
					textStyle: { color: '#fff', fontSize: 12 },
					padding: 10,
					borderRadius: 4,
					formatter: function formatter(params) {
						var html = '<div style="margin-bottom:8px;">' + params[0].axisValue + '</div>';

						params.forEach(function (item) {
							var dot = '<span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:' + item.color + '; margin-right:6px;"></span>';

							html += '<div style="line-height:1.8;">' + dot + item.seriesName + '\uFF1A' + item.value + '</div>';
						});
						return html;
					},
					axisPointer: { type: 'line', lineStyle: { color: '#999' } }
				},
				legend: { top: 'top', right: 'center', show: false },
				grid: { left: '5%', right: '5%', bottom: '10%' },
				xAxis: {
					data: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30']
				},
				yAxis: { type: 'value', min: 0 },
				series: [{
					name: '连接时长',
					symbol: 'circle',
					symbolSize: 6,
					smooth: false,
					lineStyle: { width: 2, color: THEME_COLORS.line },
					itemStyle: { color: THEME_COLORS.line },

					data: [15, 15, 0, 30, 15, 60, 30, 15, 15, -5, 0, 5]
				}]
			},

			alertTopTable: [],

			alertMultiLine: {
				title: { text: '告警指令（类型/次数/日期）', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: {
					trigger: 'axis',
					backgroundColor: '#000',
					textStyle: { color: '#fff', fontSize: 12 },
					padding: 10,
					borderRadius: 4,
					formatter: function formatter(params) {
						var html = '<div style="margin-bottom:8px;">' + params[0].axisValue + '</div>';

						params.forEach(function (item) {
							var dot = '<span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:' + item.color + '; margin-right:6px;"></span>';

							html += '<div style="line-height:1.8;">' + dot + item.seriesName + '\uFF1A' + item.value + '</div>';
						});
						return html;
					},
					axisPointer: { type: 'line', lineStyle: { color: '#999' } }
				},
				legend: { top: 'top', right: 'center', show: false },
				grid: { left: '5%', right: '5%', bottom: '10%' },
				xAxis: {
					data: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30']
				},
				yAxis: { type: 'value' },
				series: []
			},

			memberConnectTop: [],

			memberTimeTop: [],

			alertMemberTop: [],

			resourceConnectTop: [],

			resourceTimeTop: [],

			resourceAlertTop: []
		};
	},

	methods: {
		getStatisticSummary: function getStatisticSummary(params) {
			var _this2 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_consts__["a" /* default */].DASHBOARD.GET_STATISTIC_SUMMARY, params).then(function (res) {
				console.log(res, 'res');
				for (var k in _this2.overviewData) {
					_this2.overviewData[k] = res[k];
				}

				for (var _k in _this2.statRowData) {
					_this2.statRowData[_k] = res[_k];
					if (['conn_time', 'avg_days_conn_time', 'avg_conn_time'].includes(_k)) {
						_this2.statRowData[_k] = (res[_k] / 3600).toFixed(2);
					}
				}

				_this2.connectCountPie.series[0].data = res.resource_type_conn_count.map(function (item) {
					for (var _k2 in item) {
						return {
							name: _k2,
							value: item[_k2],
							itemStyle: {
								color: legendColorMap[_k2]
							}
						};
					}
				});

				_this2.connectCountLine.xAxis.data = res.conversation.map(function (item) {
					return item.date;
				});
				_this2.connectCountLine.series[0].data = res.conversation.map(function (item) {
					return item.conn_count;
				});

				_this2.connectTimePie.series[0].data = res.resource_type_conn_time.map(function (item) {
					for (var _k3 in item) {
						return {
							name: _k3,
							value: item[_k3],
							itemStyle: {
								color: legendColorMap[_k3]
							}
						};
					}
				});

				_this2.connectTimeLine.xAxis.data = res.conversation.map(function (item) {
					return item.date;
				});
				_this2.connectTimeLine.series[0].data = res.conversation.map(function (item) {
					return item.conn_time;
				});

				_this2.alertTopTable = res.match_command || [];

				_this2.alertMultiLine.xAxis.data = res.notice_command.map(function (item) {
					return item.day;
				});

				var resourceTypes = [{ name: 'MSSQL', color: '#f5222d' }, { name: 'MySQL', color: '#722ed1' }, { name: 'PostgreSQL', color: '#00c48c' }, { name: 'Windows（RDP）', color: '#fa8c16' }, { name: 'Linux（SSH）', color: '#4895ef' }];
				_this2.alertMultiLine.series = resourceTypes.map(function (type) {
					return {
						name: type.name,
						type: 'line',
						smooth: false,
						itemStyle: { color: type.color },
						lineStyle: { color: type.color },
						data: res.notice_command.map(function (item) {
							return item[type.name];
						})
					};
				});

				_this2.memberConnectTop = res.account_conn_count || [];

				_this2.memberTimeTop = res.account_conn_time || [];

				_this2.alertMemberTop = res.alarm_account_count || [];

				_this2.resourceConnectTop = res.resource_conn_count || [];

				_this2.resourceTimeTop = res.resource_conn_time || [];

				_this2.resourceAlertTop = res.alarm_resource_count || [];
			});
		}
	},
	mounted: function mounted() {},

	watch: {
		filterParams: {
			deep: true,
			immediate: true, handler: function handler(newFilter, oldFilter) {
				console.log(newFilter, 'newFilter');

				this.getStatisticSummary(newFilter);
			}
		}
	}
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_statistics_overview_vue__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_statistics_overview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__model_statistics_overview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_nvd3_pie_chart__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_nvd3_pie_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_nvd3_pie_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_nvd3_line_chart__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_nvd3_line_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_nvd3_line_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_nvd3_bar_chart__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_nvd3_bar_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_nvd3_bar_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_echarts_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_echarts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_echarts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_packages_col_src_col__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__node_modules_moment__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__node_modules_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__node_modules_moment__);
















/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			activeTabName: this.$route.query.type || 'overview',
			loading: true,
			filterList: {
				memberList: [],
				workGroupList: [],
				clusterList: [],
				resourceList: []
			},
			xAxis: [],
			statisticData: {
				company: {
					data: null,
					totalChartData: null,
					peopleChartData: null
				},
				resource: {
					networkProject: null,
					networkOrProject: null
				}
			},
			statistic: {
				type: 'overview',
				chart: 'connect',
				start: null,
				end: null,
				dataLen: 7
			},
			filterTimes: [new Date(new Date().getTime() - 7 * 24 * 3600 * 1000), new Date()],
			summaryFilter: {
				time_from: Math.floor(new Date().getTime() / 1000) - 7 * 24 * 3600,
				time_end: Math.floor(new Date().getTime() / 1000),
				account_id: '',
				resource_type: '',
				network_id: '',
				project_id: '',
				resource_id: ''
			},
			pickerOptions: {
				shortcuts: [{
					text: '近一天',
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '近7天',
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '近30天',
					onClick: function onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}]
			}
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getTranslateText();
		},
		languageCurrent: function languageCurrent() {
			return this.$language.current;
		},
		pieSeriesData: function pieSeriesData() {
			var value = 13;
			var percent = 6;
			return [{ name: 'MySQL', value: value, percent: percent }, { name: 'SQL server', value: value, percent: percent }, { name: 'PostgreSQL', value: value, percent: percent }, { name: 'Windows(RDP)', value: value, percent: percent }, { name: 'Linux(SSH)', value: value, percent: percent }];
		}
	},
	mounted: function mounted() {
		this.routeChange(this.$route.query.type);
		this.getMemberList();
		this.getWorkGroupList();
		this.getClusterList();
		this.getResourceList();

		console.log(location, 'location');
	},

	methods: {
		getTranslateText: function getTranslateText() {
			return {
				within7Day: this.$gettext('Within 7 Days'),
				within30Day: this.$gettext('Within 30 Days'),
				within90Day: this.$gettext('Within 90 Days'),
				team: this.$gettext('Team'),
				overview: this.$gettext('Overview'),
				resource: this.$gettext('Resource'),
				connectNum: this.$gettext('Number of Connections'),
				connectDur: this.$gettext('Duration of Connections')
			};
		},
		getCompanyPeopleChartOptions: function getCompanyPeopleChartOptions(chartData) {
			var _this = this;

			var peopleChartData = [];
			var chartOptions = {
				options: {
					chart: {
						showLegend: false,
						showControls: false,
						height: 250,
						showMinMaxPoints: false,
						margin: {
							top: 20,
							right: 30,
							bottom: 40,
							left: this.statistic.chart === 'connect' ? 40 : 80
						},
						padding: {
							top: 20,
							right: 30,
							bottom: 30,
							left: 30
						},
						x: function x(d) {
							return d.x;
						},
						y: function y(d) {
							return d.y;
						},
						useInteractiveGuideline: true,
						xAxis: {
							showMaxMin: false,
							tickFormat: function tickFormat(d, index) {
								var date = new Date(_this.xAxis[d]);
								return date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
							}
						},
						yDomain: [0, 10],
						yAxis: {
							showMaxMin: false,
							tickFormat: function tickFormat(d) {
								if (_this.statistic.chart === 'connect' || d === 0) {
									return d;
								} else {
									var timeStr = '';
									var hour = Math.floor(d / 3600);
									var minute = Math.floor((d - hour * 3600) / 60);
									var second = Math.floor(d % 60);
									timeStr += (hour < 10 ? '0' + hour : hour) + ':';
									timeStr += (minute < 10 ? '0' + minute : minute) + ':';
									timeStr += second < 10 ? '0' + second : second;
									return timeStr;
								}
							}
						}
					}
				},
				data: []
			};
			chartData.forEach(function (item, index) {
				var _maxValue = __WEBPACK_IMPORTED_MODULE_9_d3___default.a.max(item.results, function (vItem) {
					return vItem.y;
				});
				var itemOptions = Object.clone(chartOptions);
				if (_maxValue > 10) {
					itemOptions.options.chart.yDomain = [0, _maxValue + Math.floor(_maxValue / 5)];
				}
				peopleChartData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, item, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, itemOptions, {
					data: [{
						values: item.results,
						key: _this.statistic.chart === 'connect' ? _this.$gettext('The total number of connections') : _this.$gettext('The total length of connections'),
						color: '#A2F1AF',
						area: true
					}]
				})));
			});
			return peopleChartData;
		},
		getCompanyTotalChartOptions: function getCompanyTotalChartOptions(chartData) {
			var _this2 = this;

			var colors = ['#529AFC'];
			var _maxValue = __WEBPACK_IMPORTED_MODULE_9_d3___default.a.max(chartData[0], function (vItem) {
				return vItem.y;
			});
			var totalChartData = {
				options: {
					chart: {
						showLegend: false,
						showControls: false,
						showMinMaxPoints: false,
						height: 250,
						margin: {
							top: 20,
							right: 30,
							bottom: 40,
							left: this.statistic.chart === 'connect' ? 40 : 80
						},
						x: function x(d) {
							return d.x;
						},
						y: function y(d) {
							return d.y;
						},
						useInteractiveGuideline: true,
						xAxis: {
							showMaxMin: false,
							tickFormat: function tickFormat(d, index) {
								var date = new Date(_this2.xAxis[d]);
								return date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
							}
						},
						yDomain: _maxValue > 10 ? [0, _maxValue + Math.floor(_maxValue / 5)] : [0, 10],
						yAxis: {
							showMaxMin: false,
							tickFormat: function tickFormat(d) {
								if (_this2.statistic.chart === 'connect' || d === 0) {
									return d;
								} else {
									var timeStr = '';
									var hour = Math.floor(d / 3600);
									var minute = Math.floor((d - hour * 3600) / 60);
									var second = Math.floor(d % 60);
									timeStr += (hour < 10 ? '0' + hour : hour) + ':';
									timeStr += (minute < 10 ? '0' + minute : minute) + ':';
									timeStr += second < 10 ? '0' + second : second;
									return timeStr;
								}
							}
						}
					}
				},
				data: []
			};
			chartData.forEach(function (item, index) {
				totalChartData.data.push({
					values: item,
					key: _this2.statistic.chart === 'connect' ? _this2.$gettext('The total number of connections') : _this2.$gettext('The total length of connections'),
					color: colors[index],
					area: true
				});
			});
			return totalChartData;
		},
		getNetworkProjectChartOptions: function getNetworkProjectChartOptions(chartData) {
			var _this3 = this;

			var networkProjectChartData = {
				options: {
					chart: {
						showLegend: false,
						showControls: false,
						showValues: true,
						showYAxis: false,
						tooltip: {
							headerFormatter: function headerFormatter(d) {
								return d.replace(/-&#@#&-[0-9]*/g, '');
							}
						},
						valueFormat: function valueFormat(d) {
							return __WEBPACK_IMPORTED_MODULE_9_d3___default.a.format(',f')(d);
						},
						barColor: function barColor(d) {
							if (d.label === 'others') {
								return '#FFD036';
							}
							return '#FF6472';
						},
						duration: 500,
						height: chartData.length * 40 < 200 ? 200 : chartData.length * 40,
						groupSpacing: 0.5,
						margin: {
							top: 20,
							right: 20,
							bottom: 40,
							left: 200
						},
						x: function x(d) {
							return d.label !== 'others' ? d.label : _this3.$gettext('others');
						},
						y: function y(d) {
							return d.value;
						},
						yAxis: {
							showMaxMin: false,
							tickFormat: function tickFormat(d) {
								return __WEBPACK_IMPORTED_MODULE_9_d3___default.a.format(',f')(d);
							}
						},
						xAxis: {
							showMaxMin: false,
							tickFormat: function tickFormat(d, x, y) {
								if (x === undefined && y === undefined) {
									return d;
								}
								var totalLen = 0;
								if (d) {
									d = d.replace(/-&#@#&-[0-9]*/g, '');
									totalLen = d.length;
								}
								var doubleByteChart = d.match(/[^\x00-\xff]/g);
								if (doubleByteChart) {
									totalLen = totalLen + doubleByteChart.length;
								}
								var len = 0;
								var str = '';
								var _iteratorNormalCompletion = true;
								var _didIteratorError = false;
								var _iteratorError = undefined;

								try {
									for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(d), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
										var chart = _step.value;

										var _chart = chart.match(/[^\x00-\xff]/g);
										if (_chart && _chart.length > 0) {
											len += 2;
										} else {
											len += 1;
										}
										if (len <= 30) {
											str += chart;
										} else {
											break;
										}
									}
								} catch (err) {
									_didIteratorError = true;
									_iteratorError = err;
								} finally {
									try {
										if (!_iteratorNormalCompletion && _iterator.return) {
											_iterator.return();
										}
									} finally {
										if (_didIteratorError) {
											throw _iteratorError;
										}
									}
								}

								if (len < totalLen) {
									str += '...';
								}
								return str;
							}
						}
					}
				},
				data: [{
					key: this.$gettext('Number of Connections'),
					color: '#FF6472',
					values: chartData
				}]
			};
			return networkProjectChartData;
		},
		getNetworkOrProjectChartOptions: function getNetworkOrProjectChartOptions(chartData) {
			var _this4 = this;

			var networkOrProjectChartData = [];
			chartData.forEach(function (chartItem, index) {
				var data = Object.clone(chartItem.data);
				chartItem.data = [];
				chartItem.data.push({
					key: _this4.$gettext('Number of Connections'),
					color: '#FF6472',
					values: data
				});
				chartItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, chartItem, {
					options: {
						chart: {
							showLegend: false,
							showControls: false,
							showValues: true,
							showYAxis: false,
							tooltip: {
								headerFormatter: function headerFormatter(d) {
									return d.replace(/-&#@#&-[0-9]*/g, '');
								}
							},
							valueFormat: function valueFormat(d) {
								return __WEBPACK_IMPORTED_MODULE_9_d3___default.a.format(',f')(d);
							},
							barColor: function barColor(d) {
								if (d.label === 'others') {
									return '#FFD036';
								}
								return '#FF6472';
							},
							duration: 500,
							height: chartItem.dataLen * 50 <= 100 ? 150 : chartItem.dataLen * 50,
							groupSpacing: 0.5,
							margin: {
								top: 20,
								right: 20,
								bottom: 40,
								left: 100
							},
							x: function x(d) {
								return d.label !== 'others' ? d.label : _this4.$gettext('others');
							},
							y: function y(d) {
								return d.value;
							},
							yAxis: {
								showMaxMin: false,
								tickFormat: function tickFormat(d) {
									return __WEBPACK_IMPORTED_MODULE_9_d3___default.a.format(',f')(d);
								}
							},
							xAxis: {
								showMaxMin: false,
								tickFormat: function tickFormat(d, x, y) {
									if (x === undefined && y === undefined) {
										return d;
									}
									var totalLen = 0;
									if (d) {
										d = d.replace(/-&#@#&-[0-9]*/g, '');
										totalLen = d.length;
									}
									var doubleByteChart = d.match(/[^\x00-\xff]/g);
									if (doubleByteChart) {
										totalLen = totalLen + doubleByteChart.length;
									}
									var len = 0;
									var str = '';
									var _iteratorNormalCompletion2 = true;
									var _didIteratorError2 = false;
									var _iteratorError2 = undefined;

									try {
										for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(d), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
											var chart = _step2.value;

											var _chart = chart.match(/[^\x00-\xff]/g);
											if (_chart && _chart.length > 0) {
												len += 2;
											} else {
												len += 1;
											}
											if (len <= 10) {
												str += chart;
											} else {
												break;
											}
										}
									} catch (err) {
										_didIteratorError2 = true;
										_iteratorError2 = err;
									} finally {
										try {
											if (!_iteratorNormalCompletion2 && _iterator2.return) {
												_iterator2.return();
											}
										} finally {
											if (_didIteratorError2) {
												throw _iteratorError2;
											}
										}
									}

									if (len < totalLen) {
										str += '...';
									}
									return str;
								}
							}
						}
					}
				});
				networkOrProjectChartData.push(chartItem);
			});
			return networkOrProjectChartData;
		},
		drawResourceChartData: function drawResourceChartData(data, type) {
			var chartData = [];
			if (type === 'networkproject') {
				var _loop = function _loop(key) {
					data[key].forEach(function (item, index) {
						chartData.push({
							label: key + '(' + item.name + '-&#@#&-' + item.id + ')',
							value: item.conn_count
						});
					});
				};

				for (var key in data) {
					_loop(key);
				}
				chartData.sort(function (a, b) {
					return b.value - a.value;
				});
			} else {
				var _loop2 = function _loop2(key) {
					var hasData = data[key].length > 0;
					var monitor = {
						name: key,
						hasData: hasData,
						dataLen: data[key].length,
						data: []
					};
					data[key].forEach(function (item, index) {
						monitor.data.push({
							label: item.name + '-&#@#&-' + item.id,
							value: item.conn_count
						});
					});
					chartData.push(monitor);
				};

				for (var key in data) {
					_loop2(key);
				}
			}
			return chartData;
		},
		drawCompanyChartData: function drawCompanyChartData(data, type) {
			var _this5 = this;

			var chartData = [];
			if (type === 'total') {
				if (data) {
					var totalData = data.result;
					totalData.forEach(function (item, index) {
						item._time = new Date(item.date.replace(/-/g, '/') + ' 00:00:00').getTime();
						_this5.xAxis.push(item._time);
						chartData.push({
							x: index,
							xLabel: item._time,
							y: item.conn_count
						});
					});
				}
			} else {
				if (data) {
					var peopleData = data.result;

					var _loop3 = function _loop3(key) {
						var _item = {
							account: peopleData[key]['account'],
							avatar: peopleData[key]['avatar'],
							name: key,
							results: []
						};
						peopleData[key].days.forEach(function (resultItem, _index) {
							_item.results.push({
								x: _index,
								xLabel: new Date(resultItem.date.replace(/-/g, '/') + ' 00:00:00').getTime(),
								y: _this5.statistic.chart === 'connect' ? resultItem.conn_count : resultItem.conn_time
							});
						});
						chartData.push(_item);
					};

					for (var key in peopleData) {
						_loop3(key);
					}
				}
			}
			return chartData;
		},
		getCompanyStatistic: function getCompanyStatistic(_start, _end) {
			var _this6 = this;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				if (!_this6.statisticData.company.data) {
					var params = {
						time_from: _start,
						time_end: _end
					};
					_this6.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.GET_STATISTIC_TEAM, params).then(function (res) {
						_this6.statisticData.company.data = res;
						resolve({ data: res });
					});
				} else {
					resolve(_this6.statisticData.company.data);
				}
			});
		},
		getCompanyTotalStatistic: function getCompanyTotalStatistic(_start, _end) {
			var _this7 = this;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				if (!_this7.statisticData.company.totalData) {
					var params = {
						time_from: _start,
						time_end: _end
					};
					_this7.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.GET_RESOURCE_STATISTIC_TEAM, params).then(function (res) {
						_this7.statisticData.company.totalData = res;
						resolve({ data: res });
					});
				} else {
					resolve(_this7.statisticData.company.totalData);
				}
			});
		},
		getClusterResourceStatistic: function getClusterResourceStatistic(_start, _end) {
			var _this8 = this;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var params = {
					time_from: _start,
					time_end: _end
				};
				_this8.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].CLUSTER.GET_CLUSTER_RESOURCE_STATISTIC, params).then(function (res) {
					_this8.statisticData.resource.networkProject = res.result;
					resolve({ data: res });
				}, function () {
					_this8.statisticData.resource.networkProject = null;
					resolve({ err: 1 });
				});
			});
		},
		getClusterStatistic: function getClusterStatistic(_start, _end) {
			var _this9 = this;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var params = {
					time_from: _start,
					time_end: _end
				};
				_this9.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].CLUSTER.GET_CLUSTER_STATISTIC, params).then(function (res) {
					_this9.statisticData.resource.networkOrProject = res.result;
					resolve({ data: res });
				}, function () {
					_this9.statisticData.resource.networkOrProject = null;
					resolve({ err: 1 });
				});
			});
		},
		getResourceStatistic: function getResourceStatistic(_start, _end) {
			var _this10 = this;

			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				var params = {
					time_from: _start,
					time_end: _end
				};
				_this10.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].CLUSTER.GET_RESOURCE_STATISTIC, params).then(function (res) {
					_this10.statisticData.resource.networkOrProject = res.result;
					resolve({ data: res });
				}, function () {
					_this10.statisticData.resource.networkOrProject = null;
					resolve({ err: 1 });
				});
			});
		},
		getStatisticInitTime: function getStatisticInitTime() {
			var dataLen = this.statistic.dataLen;
			var currentDate = new Date();
			var year = currentDate.getFullYear();
			var month = currentDate.getMonth() + 1 < 10 ? '0' + (currentDate.getMonth() + 1) : '' + (currentDate.getMonth() + 1);
			var date = currentDate.getDate() < 10 ? '0' + currentDate.getDate() : currentDate.getDate();
			var endDate = new Date(year + '/' + month + '/' + date + ' 23:59:59');
			var startDate = new Date(endDate.getTime() - (dataLen * 24 * 60 * 60 * 1000 - 1000));
			this.statistic.start = Math.floor(startDate.getTime() / 1000);
			this.statistic.end = Math.floor(endDate.getTime() / 1000);
		},
		onChangeTab: function onChangeTab(_tab) {
			this.$router.push({ name: 'statistics', query: { type: _tab.name } });
			this.activeTabName = this.$route.query.type || 'overview';
			this.loading = true;
			this.statistic.type = _tab.name || 'overview';
		},
		routeChange: function routeChange(type) {
			var _this11 = this;

			this.statistic.dataLen = 7;
			this.statistic.type = this.activeTabName;
			this.getStatisticInitTime();
			if (type === 'company') {
				this.statistic.chart = 'connect';
				this.getCompanyStatistic(this.statistic.start, this.statistic.end).then(function (data) {
					if (!data.err) {
						var peopleChartData = _this11.drawCompanyChartData(_this11.statisticData.company.data, 'people');

						_this11.statisticData.company.peopleChartData = _this11.getCompanyPeopleChartOptions(peopleChartData);
					}
					_this11.loading = false;
				});
				this.getCompanyTotalStatistic(this.statistic.start, this.statistic.end).then(function (data) {
					if (!data.err) {
						var totalChartData = _this11.drawCompanyChartData(_this11.statisticData.company.totalData, 'total');
						_this11.statisticData.company.totalChartData = _this11.getCompanyTotalChartOptions([totalChartData]);
					}
					_this11.loading = false;
				});
			} else {
				this.statistic.chart = 'networkproject';
				this.getClusterResourceStatistic(this.statistic.start, this.statistic.end).then(function (data) {
					if (!data.err) {
						var networkProjectData = _this11.drawResourceChartData(_this11.statisticData.resource.networkProject, 'networkproject');
						_this11.statisticData.resource.networkProject = _this11.getNetworkProjectChartOptions(networkProjectData);
					}
					_this11.loading = false;
				});
			}
		},
		onChangeChart: function onChangeChart(_chart) {
			var _this12 = this;

			this.statistic.chart = _chart;
			if (this.statistic.type === 'company') {
				this.getCompanyStatistic(this.statistic.start, this.statistic.end).then(function (data) {
					if (!data.err) {
						var peopleChartData = _this12.drawCompanyChartData(_this12.statisticData.company.data, 'people');

						_this12.statisticData.company.peopleChartData = _this12.getCompanyPeopleChartOptions(peopleChartData);
					}
					_this12.loading = false;
				});
				this.getCompanyTotalStatistic(this.statistic.start, this.statistic.end).then(function (data) {
					if (!data.err) {
						var totalChartData = _this12.drawCompanyChartData(_this12.statisticData.company.totalData, 'total');
						_this12.statisticData.company.totalChartData = _this12.getCompanyTotalChartOptions([totalChartData]);
					}
					_this12.loading = false;
				});
			} else {
				this.loading = true;
				if (this.statistic.chart === 'networkproject') {
					this.getClusterResourceStatistic(this.statistic.start, this.statistic.end).then(function (data) {
						if (!data.err) {
							var networkProjectData = _this12.drawResourceChartData(_this12.statisticData.resource.networkProject, 'networkproject');
							_this12.statisticData.resource.networkProject = _this12.getNetworkProjectChartOptions(networkProjectData);
						}
						_this12.loading = false;
					});
				} else if (this.statistic.chart === 'network') {
					this.getClusterStatistic(this.statistic.start, this.statistic.end).then(function (data) {
						if (!data.err) {
							var networkData = _this12.drawResourceChartData(_this12.statisticData.resource.networkOrProject, 'network');
							_this12.statisticData.resource.networkOrProject = _this12.getNetworkOrProjectChartOptions(networkData);
						}
						_this12.loading = false;
					});
				} else if (this.statistic.chart === 'project') {
					this.getResourceStatistic(this.statistic.start, this.statistic.end).then(function (data) {
						if (!data.err) {
							var projectData = _this12.drawResourceChartData(_this12.statisticData.resource.networkOrProject, 'project');
							_this12.statisticData.resource.networkOrProject = _this12.getNetworkOrProjectChartOptions(projectData);
						}
						_this12.loading = false;
					});
				}
			}
		},
		onChangeDateLen: function onChangeDateLen() {
			var _this13 = this;

			this.loading = true;
			this.getStatisticInitTime();
			this.xAxis = [];
			if (this.statistic.type === 'company') {
				this.statisticData.company.data = null;
				this.statisticData.company.totalData = null;
				this.getCompanyStatistic(this.statistic.start, this.statistic.end).then(function (data) {
					if (!data.err) {
						var peopleChartData = _this13.drawCompanyChartData(_this13.statisticData.company.data, 'people');

						_this13.statisticData.company.peopleChartData = _this13.getCompanyPeopleChartOptions(peopleChartData);
					}
					_this13.loading = false;
				});
				this.getCompanyTotalStatistic(this.statistic.start, this.statistic.end).then(function (data) {
					if (!data.err) {
						var totalChartData = _this13.drawCompanyChartData(_this13.statisticData.company.totalData, 'total');
						_this13.statisticData.company.totalChartData = _this13.getCompanyTotalChartOptions([totalChartData]);
					}
				});
			} else {
				if (this.statistic.chart === 'networkproject') {
					this.getClusterResourceStatistic(this.statistic.start, this.statistic.end).then(function (data) {
						if (!data.err) {
							var networkProjectData = _this13.drawResourceChartData(_this13.statisticData.resource.networkProject, 'networkproject');
							_this13.statisticData.resource.networkProject = _this13.getNetworkProjectChartOptions(networkProjectData);
						}
						_this13.loading = false;
					});
				} else if (this.statistic.chart === 'network') {
					this.getClusterStatistic(this.statistic.start, this.statistic.end).then(function (data) {
						if (!data.err) {
							var networkData = _this13.drawResourceChartData(_this13.statisticData.resource.networkOrProject, 'network');
							_this13.statisticData.resource.networkOrProject = _this13.getNetworkOrProjectChartOptions(networkData);
						}
						_this13.loading = false;
					});
				} else if (this.statistic.chart === 'project') {
					this.getResourceStatistic(this.statistic.start, this.statistic.end).then(function (data) {
						if (!data.err) {
							var projectData = _this13.drawResourceChartData(_this13.statisticData.resource.networkOrProject, 'project');
							_this13.statisticData.resource.networkOrProject = _this13.getNetworkOrProjectChartOptions(projectData);
						}
						_this13.loading = false;
					});
				}
			}
		},
		changeTimes: function changeTimes() {
			this.summaryFilter.time_from = __WEBPACK_IMPORTED_MODULE_12__node_modules_moment___default()(this.filterTimes[0]).unix();
			this.summaryFilter.time_end = __WEBPACK_IMPORTED_MODULE_12__node_modules_moment___default()(this.filterTimes[1]).endOf('day').unix();
			console.log(__WEBPACK_IMPORTED_MODULE_12__node_modules_moment___default()(this.filterTimes[0]).format('YYYY-MM-DD HH:mm:ss'), __WEBPACK_IMPORTED_MODULE_12__node_modules_moment___default()(this.filterTimes[1]).format('YYYY-MM-DD HH:mm:ss'));
			console.log(__WEBPACK_IMPORTED_MODULE_12__node_modules_moment___default()(this.summaryFilter.time_from * 1000).format('YYYY-MM-DD HH:mm:ss'), __WEBPACK_IMPORTED_MODULE_12__node_modules_moment___default()(this.summaryFilter.time_end * 1000).format('YYYY-MM-DD HH:mm:ss'));
		},
		handleExport: function handleExport() {
			var paramsStr = '';
			for (var k in this.summaryFilter) {
				paramsStr += k + '=' + this.summaryFilter[k] + '&';
			}
			window.open('' + location.origin + location.pathname + '#exportOverview/?' + paramsStr, '_blank');
		},
		getMemberList: function getMemberList() {
			var _this14 = this;

			var params = {
				page: 1,
				page_size: __WEBPACK_IMPORTED_MODULE_11__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].TEAM.GET_MEMBER_LIST, { params: params }).then(function (res) {
				_this14.filterList.memberList = res.objects;
			});
		},
		getWorkGroupList: function getWorkGroupList() {
			var _this15 = this;

			var params = {
				page: 1,
				page_size: __WEBPACK_IMPORTED_MODULE_11__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP, params).then(function (res) {
				_this15.filterList.workGroupList = res.objects;
			});
		},
		getClusterList: function getClusterList() {
			var _this16 = this;

			var params = {
				page: 1,
				page_size: __WEBPACK_IMPORTED_MODULE_11__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].CLUSTER.GET_CLUSTER, params).then(function (res) {
				_this16.filterList.clusterList = res.objects;
			});
		},
		getResourceList: function getResourceList() {
			var _this17 = this;

			var params = {
				page: 1,
				page_size: __WEBPACK_IMPORTED_MODULE_11__config__["g" /* Utils */].config.maxPageSize
			};
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_consts__["a" /* default */].CLUSTER.GET_RESOURCE_LISTS, params).then(function (res) {
				_this17.filterList.resourceList = res.objects;
			});
		}
	},
	watch: {
		$route: function $route(to, from) {
			this.activeTabName = this.$route.query.type;
			this.routeChange(this.$route.query.type);
		},

		languageCurrent: function languageCurrent(newVal, oldVal) {
			this.routeChange(this.$route.query.type);
		}
	},
	components: {
		ElCol: __WEBPACK_IMPORTED_MODULE_10_element_ui_packages_col_src_col__["a" /* default */],
		Nvd3PieChart: __WEBPACK_IMPORTED_MODULE_5__common_nvd3_pie_chart___default.a,
		Nvd3LineChart: __WEBPACK_IMPORTED_MODULE_6__common_nvd3_line_chart___default.a,
		Nvd3BarChart: __WEBPACK_IMPORTED_MODULE_7__common_nvd3_bar_chart___default.a,
		Echarts: __WEBPACK_IMPORTED_MODULE_8__common_echarts_vue___default.a,
		statisticsOverview: __WEBPACK_IMPORTED_MODULE_3__model_statistics_overview_vue___default.a
	}
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_alarm_log_detail_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_alarm_log_detail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__model_alarm_log_detail_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			selectOptions: {},
			loading: true,
			log: {
				list: [],
				totalPage: 0,
				currentPage: 1,
				currentTab: this.$route.query.type || 'loginLogs'
			},
			search: {
				options: [],
				isAdmin: '',
				account: '',
				startTime: '',
				endTime: '',
				eventType: '',
				role: '',
				isDisabled: true
			},
			eventShow: false,
			currentRightPanel: null,
			rightPanelData: null,
			teamList: []
		};
	},

	computed: {
		attrText: function attrText() {
			return this.getAttrText();
		}
	},
	created: function created() {
		var params = this.$route.query.type;
		this.changeCurrentTab(1, params);
		this.getTeamList();
	},

	methods: {
		getAttrText: function getAttrText() {
			var _ref;

			return _ref = {
				loginLog: this.$gettext('Login Log'),
				teamLog: this.$gettext('Team Log'),
				clusterLog: this.$gettext('Cluster Log'),
				workgroupLog: this.$gettext('Workgroup Logs'),
				alarmLog: this.$gettext('Alarm Log'),
				userType: this.$gettext('Account Type'),
				eventType: this.$gettext('Event Type'),
				event: this.$gettext('Event'),
				safeAdmin: this.$gettext('Safe Admin'),
				optAdmin: this.$gettext('Opt Admin'),
				auditAdmin: this.$gettext('Audit Admin'),
				admin: this.$gettext('Administrator'),
				ordinary: this.$gettext('Ordinary User'),
				select: this.$gettext('Select'),
				startTime: this.$gettext('Start Time'),
				endTime: this.$gettext('End Time'),
				inputAccount: this.$gettext('Please input account'),
				input: this.$gettext('Please input'),
				time: this.$gettext('Time'),
				account: this.$gettext('Account'),
				accountType: this.$gettext('Account Type'),
				loginIp: this.$gettext('Login Ip'),
				clusterName: this.$gettext('Cluster Name'),
				resourceName: this.$gettext('Resource Name'),
				teamName: this.$gettext('Team Name'),
				accountEdited: this.$gettext('Account Edited'),
				workgroupName: this.$gettext('Workgroup Name'),
				groupEdited: this.$gettext('Group Edited'),
				ruleId: this.$gettext('Rule Id')
			}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'eventType', this.$gettext('Event Type')), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'createTime', this.$gettext('Create Time')), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'action', this.$gettext('Action')), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loginStatus', this.$gettext('Login Status')), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'comment', this.$gettext('Comment')), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'operationTime', this.$gettext('Operation Time')), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'sourceIp', this.$gettext('Source IP')), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'operationObj', this.$gettext('Operation Obj')), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'workGroup', this.$gettext('In Work Group')), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'connectType', this.$gettext('Connect Type')), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'eventDesc', this.$gettext('Event Desc')), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'norifyObj', this.$gettext('Notify Obj')), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'users', this.$gettext('Users')), _ref;
		},
		getLoginLog: function getLoginLog(page) {
			var _this = this;

			this.loading = true;
			var params = {
				page_index: page || 1
			};
			this.search.options.forEach(function (item) {
				params[item.key] = item.val;
			});
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.LOGIN, { params: params }).then(function (res) {
				if (res && res.objects.length) {
					_this.selectOptions = {};
					_this.log.list = res.objects;
					_this.log.totalPage = res.num_results;
				} else {
					_this.log.list = res.objects;
					_this.log.totalPage = res.num_results;
				}
				_this.loading = false;
			}, function () {
				_this.loading = false;
			});
		},
		getTeamLog: function getTeamLog(page) {
			var _this2 = this;

			this.loading = true;
			var params = {
				page_index: page || 1
			};
			this.search.options.forEach(function (item) {
				params[item.key] = item.val;
			});
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.TEAM, { params: params }).then(function (res) {
				if (res && res.objects.length) {
					_this2.selectOptions = __WEBPACK_IMPORTED_MODULE_3__config__["f" /* SelectOptionsConfig */].teamLogs;
					_this2.log.list = _this2.$store.getters.logs.teamLogs.objects;
					_this2.log.totalPage = _this2.$store.getters.logs.teamLogs.num_results;
					setTimeout(function () {
						_this2.eventShow = true;
					}, 10);
				} else {
					_this2.log.list = res.objects;
					_this2.log.totalPage = res.num_results;
				}
				_this2.loading = false;
			}, function () {
				_this2.loading = false;
			});
		},
		getClusterLog: function getClusterLog(page) {
			var _this3 = this;

			this.loading = true;
			var params = {
				page_index: page || 1
			};
			this.search.options.forEach(function (item) {
				params[item.key] = item.val;
			});
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.CLUSTER, { params: params }).then(function (res) {
				if (res && res.objects.length) {
					_this3.selectOptions = __WEBPACK_IMPORTED_MODULE_3__config__["f" /* SelectOptionsConfig */].clusterLogs;
					_this3.log.list = _this3.$store.getters.logs.clusterLogs.objects;
					_this3.log.totalPage = _this3.$store.getters.logs.clusterLogs.num_results;
					setTimeout(function () {
						_this3.eventShow = true;
					}, 10);
				} else {
					_this3.log.list = res.objects;
					_this3.log.totalPage = res.num_results;
				}
				_this3.loading = false;
			}, function () {
				_this3.loading = false;
			});
		},
		getResourceLog: function getResourceLog(page) {
			var _this4 = this;

			this.loading = true;
			var params = {
				page_index: page || 1
			};
			this.search.options.forEach(function (item) {
				params[item.key] = item.val;
			});
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.RESOURCE, { params: params }).then(function (res) {
				if (res && res.objects.length) {
					_this4.selectOptions = __WEBPACK_IMPORTED_MODULE_3__config__["f" /* SelectOptionsConfig */].resourceLogs;
					_this4.log.list = _this4.$store.getters.logs.resourceLogs.objects;
					_this4.log.totalPage = _this4.$store.getters.logs.resourceLogs.num_results;
					setTimeout(function () {
						_this4.eventShow = true;
					}, 10);
				} else {
					_this4.log.list = res.objects;
					_this4.log.totalPage = res.num_results;
				}
				_this4.loading = false;
			}, function () {
				_this4.loading = false;
			});
		},
		getAlarmLog: function getAlarmLog(page) {
			var _this5 = this;

			this.loading = true;
			var params = {
				page_index: page || 1
			};
			this.search.options.forEach(function (item) {
				params[item.key] = item.val;
			});
			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].LOG.ALARM, { params: params }).then(function (res) {
				console.log(res, '告警日志');
				if (res && res.objects.length) {
					_this5.selectOptions = __WEBPACK_IMPORTED_MODULE_3__config__["f" /* SelectOptionsConfig */].alarmLogs;
					_this5.log.list = _this5.$store.getters.logs.alarmLogs.objects;
					_this5.log.totalPage = _this5.$store.getters.logs.alarmLogs.num_results;
					setTimeout(function () {
						_this5.eventShow = true;
					}, 10);
				} else {
					_this5.log.list = res.objects;
					_this5.log.totalPage = res.num_results;
				}
				_this5.loading = false;
				console.log(__WEBPACK_IMPORTED_MODULE_3__config__["f" /* SelectOptionsConfig */].alarmLogs, 'SelectOptionsConfig.alarmLogs');
			}, function () {
				_this5.loading = false;
			});
		},
		toShowAlarmDetail: function toShowAlarmDetail(row) {
			var _this6 = this;

			var time = !this.currentRightPanel || this.currentRightPanel.name === 'alarmLogDetail' ? 0 : 300;
			this.currentRightPanel = __WEBPACK_IMPORTED_MODULE_4__model_alarm_log_detail_vue___default.a;
			this.$nextTick(function () {
				setTimeout(function () {
					_this6.rightPanelData = row;
				}, time);
			});
		},
		getTeamList: function getTeamList() {
			var _this7 = this;

			this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_consts__["a" /* default */].TEAM.GET_MEMBER_LIST).then(function (res) {
				console.log(res, 'res');
				if (res && res.objects && res.objects.length) {
					_this7.teamList = res.objects;
				}
			});
		},
		onTabClick: function onTabClick(v) {
			this.$router.push({ name: 'log', query: { type: v.name } });
			this.log.currentTab = this.$route.query.type || 'loginLogs';
			this.log.currentPage = 1;
			this.search.options = [];
			this.eventShow = false;
			this.resetSearchValue();
		},
		onSearch: function onSearch() {
			this.log.currentPage = 1;
			this.search.options = [];
			if (this.search.startTime !== '') {
				this.search.options.push({
					key: 'start_time',
					val: this.search.startTime.getTime() / 1000
				});
			}
			if (this.search.endTime !== '') {
				this.search.options.push({
					key: 'end_time',
					val: this.search.endTime.getTime() / 1000 + 24 * 3600
				});
			}
			if (this.search.isAdmin !== '') {
				this.search.options.push({
					key: 'admin',
					val: this.search.isAdmin
				});
			}
			if (this.search.account !== '') {
				if (this.search.role === '') {
					this.search.options.push({
						key: 'account',
						val: this.search.account
					});
				} else {
					this.search.options.push({
						key: this.search.role,
						val: this.search.account
					});
				}
			}
			if (this.search.eventType !== '') {
				this.search.options.push({
					key: 'event',
					val: this.search.eventType
				});
			}
			this.changeCurrentTab(1, this.log.currentTab);
		},
		onChangePage: function onChangePage(page) {
			this.changeCurrentTab(page, this.log.currentTab);
		},
		onSelectRole: function onSelectRole() {
			if (this.search.role !== '') {
				this.search.isDisabled = false;
			}
		},
		changeCurrentTab: function changeCurrentTab(page, tab) {
			this.log.currentTab = tab;
			if (tab === 'loginLogs') {
				this.getLoginLog(page);
			} else if (tab === 'teamLogs') {
				this.getTeamLog(page);
			} else if (tab === 'clusterLogs') {
				this.getClusterLog(page);
			} else if (tab === 'resourceLogs') {
				this.getResourceLog(page);
			} else if (tab === 'alarmLogs') {
				this.getAlarmLog(page);
			}
		},
		resetSearchValue: function resetSearchValue() {
			this.search = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.search, {
				isAdmin: '',
				account: '',
				startTime: '',
				endTime: '',
				eventType: '',
				role: '',
				isDisabled: true
			});
		},
		onClosePanel: function onClosePanel() {
			this.currentRightPanel = null;
			this.rightPanelData = null;
		},
		exportLog: function exportLog() {
			if (this.search.role === '') {
				window.open(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* baseUrl */].apiUrl + '/event/sys_log_export?log_type=' + this.log.currentTab + '&admin=' + this.search.isAdmin + '&start_time=' + (this.search.startTime ? this.search.startTime.getTime() / 1000 : '') + '&end_time=' + (this.search.endTime ? this.search.endTime.getTime() / 1000 + 24 * 3600 : '') + '&event=' + this.search.eventType + '&account=' + this.search.account, '_blank');
			} else {
				window.open(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* baseUrl */].apiUrl + '/event/sys_log_export?log_type=' + this.log.currentTab + '&admin=' + this.search.isAdmin + '&start_time=' + (this.search.startTime ? this.search.startTime.getTime() / 1000 : '') + '&end_time=' + (this.search.endTime ? this.search.endTime.getTime() / 1000 + 24 * 3600 : '') + '&event=' + this.search.eventType + '&' + this.search.role + '=' + this.search.account, '_blank');
			}
		}
	},
	watch: {
		$route: function $route(to, from) {
			this.log.currentTab = this.$route.query.type;
			this.changeCurrentTab(1, this.log.currentTab);
		}
	},
	components: {
		alarmLogDetail: __WEBPACK_IMPORTED_MODULE_4__model_alarm_log_detail_vue___default.a
	}
});

/***/ }),
/* 307 */
/***/ (function(module, exports) {



/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);

window.rootVue = window.rootVue ? window.rootVue : {
	$gettext: function $gettext(t) {
		return t;
	}
};
var errorMsg = {
	RequestTimeout: {
		code: 'RequestTimeout',
		message: window.rootVue.$gettext('RequestTimeout')
	},
	UnknowError: {
		code: 'UnknowError',
		message: window.rootVue.$gettext('unknow error')
	},
	NeedLogin: {
		code: 'NeedLogin',
		message: window.rootVue.$gettext('Need login.')
	},
	NeedPrivilege: {
		code: 'NeedPrivilege',
		message: window.rootVue.$gettext('Need privilege.')
	},
	DomainInUse: {
		code: 'DomainInUse',
		message: window.rootVue.$gettext('Domain in use.')
	},
	LoginFailed: {
		code: 'LoginFailed',
		message: window.rootVue.$gettext('Login failed.')
	},
	VerifyFailed: {
		code: 'VerifyFailed',
		message: window.rootVue.$gettext('Verify failed.')
	},
	AlreadySendSMS: {
		code: 'AlreadySendSMS',
		message: window.rootVue.$gettext('Already send SMS.')
	},
	FileNotFound: {
		code: 'FileNotFound',
		message: window.rootVue.$gettext('File is not found.')
	},
	QuickLinksNotFound: {
		code: 'QuickLinksNotFound',
		message: window.rootVue.$gettext('Quick links is not found.')
	},
	ProjectResourceNotFound: {
		code: 'ProjectResourceNotFound',
		message: window.rootVue.$gettext('Workgroup Resource is not found.')
	},
	LogFilterNotFound: {
		code: 'LogFilterNotFound',
		message: window.rootVue.$gettext('Log Filter is not found.')
	},
	ProjectNotFound: {
		code: 'ProjectNotFound',
		message: window.rootVue.$gettext('Workgroup is not found.')
	},
	NetworkNotFound: {
		code: 'NetworkNotFound',
		message: window.rootVue.$gettext('Cluster is not found.')
	},
	PlanNotFound: {
		code: 'PlanNotFound',
		message: window.rootVue.$gettext('Plan is not found.')
	},
	SkuNotFound: {
		code: 'SkuNotFound',
		message: window.rootVue.$gettext('Sku is not found.')
	},
	BillNotFound: {
		code: 'BillNotFound',
		message: window.rootVue.$gettext('Bill is not found.')
	},
	NoteNotFound: {
		code: 'NoteNotFound',
		message: window.rootVue.$gettext('Note is not found.')
	},
	EndpointRequire: {
		code: 'EndpointRequire',
		message: window.rootVue.$gettext('You should have at least one endpoint in your resource pool.')
	},
	InvalidParameter: {
		code: 'InvalidParameter',
		message: window.rootVue.$gettext('Parameter name is invalid.')
	},
	BatchCreateFailed: {
		code: 'BatchCreateFailed',
		message: window.rootVue.$gettext('One or more parameters invalid in batch create.')
	},
	BatchDeleteFailed: {
		code: 'BatchDeleteFailed',
		message: window.rootVue.$gettext('Error occured when batch delete.')
	},
	LDAPError: {
		code: 'LDAPError',
		message: window.rootVue.$gettext('LDAP error, please contact your system administrator.')
	},
	CompanyNotFound: {
		code: 'CompanyNotFound',
		message: window.rootVue.$gettext('Company is not found.')
	},
	AccountNotFound: {
		code: 'AccountNotFound',
		message: window.rootVue.$gettext('Account is not found.')
	},
	AccountExist: {
		code: 'AccountExist',
		message: window.rootVue.$gettext('Account is exist.')
	},
	DeleteSelf: {
		code: 'DeleteSelf',
		message: window.rootVue.$gettext('You cannot delete yourself.')
	},
	Locked: {
		code: 'Locked',
		message: window.rootVue.$gettext('Your account has been locked.')
	},
	ResourceNotFound: {
		code: 'ResourceNotFound',
		message: window.rootVue.$gettext('Resource is not found.')
	},
	TunnelIsOnline: {
		code: 'TunnelIsOnline',
		message: window.rootVue.$gettext('Tunnel is online.')
	},
	TunnelNotFound: {
		code: 'TunnelNotFound',
		message: window.rootVue.$gettext('Tunnel is not found.')
	},
	TunnelExpire: {
		code: 'TunnelExpire',
		message: window.rootVue.$gettext('Tunnel is expired.')
	},
	NetworkExceeded: {
		code: 'NetworkExceeded',
		message: window.rootVue.$gettext('Cluster Exceeded.')
	},
	NetworkHasResources: {
		code: 'NetworkHasResources',
		message: window.rootVue.$gettext('Cluster still has resources.')
	},
	NetworkHasBeenShared: {
		code: 'NetworkHasBeenShared',
		message: window.rootVue.$gettext('Cluster has been shared.')
	},
	AccountExceeded: {
		code: 'AccountExceeded',
		message: window.rootVue.$gettext('Account Exceeded.')
	},
	ResourceExceeded: {
		code: 'ResourceExceeded',
		message: window.rootVue.$gettext('ResourceExceeded.')
	},
	SubscriptionNotfound: {
		code: 'SubscriptionNotfound',
		message: window.rootVue.$gettext('Subscription is not found.')
	},
	NetmaskTooSmall: {
		code: 'NetmaskTooSmall',
		message: window.rootVue.$gettext('NetmaskTooSmall')
	},
	ResetLinkExpire: {
		code: 'ResetLinkExpire',
		message: window.rootVue.$gettext('Reset Link Has Expire')
	},
	CaptchaIncorrect: {
		code: 'CaptchaIncorrect',
		message: window.rootVue.$gettext('Captcha Incorrect')
	},
	VerificationCodeIncorrect: {
		code: 'VerificationCodeIncorrect',
		message: window.rootVue.$gettext('Verification Code Incorrect.')
	},
	SubscribeForbidden: {
		code: 'SubscribeForbidden',
		message: window.rootVue.$gettext('Subscribe Forbidden')
	},
	EmailSendFail: {
		code: 'EmailSendFail',
		message: window.rootVue.$gettext('Email send fail.')
	},
	SMSSendFail: {
		code: 'SMSSendFail',
		message: window.rootVue.$gettext('SMS send fail.')
	},
	ProjectNameExist: {
		code: 'ProjectNameExist',
		message: window.rootVue.$gettext('Workgroup Name is exist.')
	},
	NetworkNameExist: {
		code: 'NetworkNameExist',
		message: window.rootVue.$gettext('Cluster Name is exist.')
	},
	NetworkUnavailable: {
		code: 'NetworkUnavailable',
		message: window.rootVue.$gettext('Cluster unavailable.')
	},
	ExpireTimeTooBig: {
		code: 'ExpireTimeTooBig',
		message: window.rootVue.$gettext('Expire Time Too Big.')
	},
	SqlApplicationNotFound: {
		code: 'SqlApplicationNotFound',
		message: window.rootVue.$gettext('sql application not found.')
	},
	RemovingSelf: {
		code: 'RemovingSelf',
		message: window.rootVue.$gettext('You cannot remove your self.')
	},
	AgentAlreadyInstall: {
		code: 'AgentAlreadyInstall',
		message: window.rootVue.$gettext('there is already one have installed, please unbund the exist one on cloudlinker.')
	},
	SharedNetworkCannotChangeLogFilter: {
		code: 'SharedNetworkCannotChangeLogFilter',
		message: window.rootVue.$gettext('Shared cluster cannot change log filter rules.')
	},
	NetworkCannotShare: {
		code: 'NetworkCannotShare',
		message: window.rootVue.$gettext('Shared cluster cannot share to other company.')
	},
	NetworkAlreadyShared: {
		code: 'NetworkAlreadyShared',
		message: window.rootVue.$gettext('Cluster already shared to the company or own is yourself.')
	},
	MustBeLinuxServer: {
		code: 'MustBeLinuxServer',
		message: window.rootVue.$gettext('Must be Linux Server.')
	},
	SetAutologinFailed: {
		code: 'SetAutologinFailed',
		message: window.rootVue.$gettext('Set auto login failed.')
	},
	UpgradeSubscriptionFailed: {
		code: 'UpgradeSubscriptionFailed',
		message: window.rootVue.$gettext('Upgrade subscription failed.')
	},
	CannotUpgradeSubscription: {
		code: 'CannotUpgradeSubscription',
		message: window.rootVue.$gettext('Cannot upgrade subscription.')
	},
	SubscribeOvertime: {
		code: 'SubscribeOvertime',
		message: window.rootVue.$gettext('Subscribe overtime. The maximum length of subscription is 12.')
	},
	SubscriptionFailed: {
		code: 'SubscriptionFailed',
		message: window.rootVue.$gettext('Subscription failed.')
	},
	Timeout: {
		code: 'Timeout',
		message: window.rootVue.$gettext('Timeout.')
	},
	TimeNotValid: {
		code: 'TimeNotValid',
		message: window.rootVue.$gettext('Need future time')
	},
	HostsTypeError: {
		code: 'HostsTypeError',
		message: window.rootVue.$gettext('Hosts type error')
	},
	NeedRenewOrUpdate: {
		code: 'NeedRenewOrUpdate',
		message: window.rootVue.$gettext('Need to renew or update')
	},
	InvoiceTitleNeedCheck: {
		code: 'InvoiceTitleNeedCheck',
		message: window.rootVue.$gettext('Need to check invoice title')
	},
	NeedInvoiceTitleAndAddress: {
		code: 'NeedInvoiceTitleAndAddress',
		message: window.rootVue.$gettext('Need invoice title and address')
	},
	NeedInvoiceSubscriptions: {
		code: 'NeedInvoiceSubscriptions',
		message: window.rootVue.$gettext('Need invoice subscriptions')
	},
	XiaoshouyiException: {
		code: 'XiaoshouyiException',
		message: window.rootVue.$gettext('Xiaoshouyi Error')
	},
	CommandExist: {
		code: 'CommandExist',
		message: window.rootVue.$gettext('Command exist')
	},
	NetworkSafeModeNotOpen: {
		code: 'NetworkSafeModeNotOpen',
		message: window.rootVue.$gettext('cluster safe_mode is not open')
	},
	ApplicationExist: {
		code: 'ApplicationExist',
		message: window.rootVue.$gettext('cluster safe_mode application exist')
	},
	NeedApplicationSafeMode: {
		code: 'NeedApplicationSafeMode',
		message: window.rootVue.$gettext('need apply safe mode')
	},
	MfaCodeError: {
		code: 'MfaCodeError',
		message: window.rootVue.$gettext('need right mfa code')
	},
	MfaKeyError: {
		code: 'MfaKeyError',
		message: window.rootVue.$gettext('need right mfa key')
	},
	NeedMfaLogin: {
		code: 'NeedMfaLogin',
		message: window.rootVue.$gettext('need mfa login')
	},
	AccountPubKeyNotFound: {
		code: 'AccountPubKeyNotFound',
		message: window.rootVue.$gettext('account pubkey not found')
	},
	AccountPubKeyError: {
		code: 'AccountPubKeyError',
		message: window.rootVue.$gettext('account pubkey error')
	},
	AccountPubKeyExist: {
		code: 'AccountPubKeyExist',
		message: window.rootVue.$gettext('account pubkey is exist')
	},
	TunnelConnectionNotFound: {
		code: 'TunnelConnectionNotFound',
		message: window.rootVue.$gettext('Tunnel connection is not found.')
	},
	RefreshTokenNotExists: {
		code: 'RefreshTokenNotExists',
		message: window.rootVue.$gettext('Refresh token is not exists.')
	},
	InvalidToken: {
		code: 'InvalidToken',
		message: window.rootVue.$gettext('InvalidToken')
	},
	AccountNotAllowDelete: {
		code: 'AccountNotAllowDelete',
		message: window.rootVue.$gettext("The account is bound to the primary account. Please change the bound administrator account in the team's Settings then delete it.")
	},
	ProjectAccountExist: {
		code: 'ProjectAccountExist',
		message: window.rootVue.$gettext('Workgroup Account Exist')
	},
	AgentError: {
		code: 'AgentError',
		message: window.rootVue.$gettext('Agent is not online.')
	},
	IncorrectInstanceStatus: {
		code: 'IncorrectInstanceStatus',
		message: window.rootVue.$gettext('The current status of the resource does not support this operation.')
	},
	TooManyShadows: {
		code: 'TooManyShadows',
		message: window.rootVue.$gettext('Can not create more than 5 shadows')
	},
	'InvalidInstanceId.NotFound': {
		code: 'InvalidInstanceId.NotFound',
		message: window.rootVue.$gettext('The specified InstanceId does not exist.')
	},
	ConnectionIDNotFound: {
		code: 'ConnectionIDNotFound',
		message: window.rootVue.$gettext('Connection ID not found')
	},
	TaskExpired: {
		code: 'TaskExpired',
		message: window.rootVue.$gettext('Task expired')
	},
	AccountLocked: {
		code: 'AccountLocked',
		message: window.rootVue.$gettext('You have entered the wrong password 10 times. Please try again in 1 hour or change the password by find the password feature.')
	},
	GroupExist: {
		code: 'GroupExist',
		message: window.rootVue.$gettext('Group Exist')
	},
	GroupNameExist: {
		code: 'GroupNameExist',
		message: window.rootVue.$gettext('Group Name is exist')
	},
	GroupNotFound: {
		code: 'GroupNotFound',
		message: window.rootVue.$gettext('Group not found')
	},
	ProjectGroupExist: {
		code: 'ProjectGroupExist',
		message: window.rootVue.$gettext('Project Group Exist')
	},
	ProjectGroupNotFound: {
		code: 'ProjectGroupNotFound',
		message: window.rootVue.$gettext('Project Group not found')
	},
	GroupAccountExist: {
		code: 'GroupAccountExist',
		message: window.rootVue.$gettext('Group Account Exist')
	},
	GroupAccountNotFound: {
		code: 'GroupAccountNotFound',
		message: window.rootVue.$gettext('Group Account not found')
	},
	ResourceNameExist: {
		code: 'ResourceNameExist',
		message: window.rootVue.$gettext('Resource Name is exist')
	},
	InvalidPassword: {
		code: 'InvalidPassword',
		message: window.rootVue.$gettext('Password complexity does not meet the requirements')
	},
	PasswordError: {
		code: 'PasswordError',
		message: window.rootVue.$gettext('Password error')
	},
	ProjectExist: {
		code: 'ProjectExist',
		message: window.rootVue.$gettext('Project Name is exist')
	},
	InvalidResource: {
		code: 'InvalidResource',
		message: window.rootVue.$gettext('Invalid Resource Info')
	},
	IPNotInWhiteList: {
		code: 'IPNotInWhiteList',
		message: window.rootVue.$gettext('IP is not in white list')
	},
	AccountDisabled: {
		code: 'AccountDisabled',
		message: window.rootVue.$gettext('User disabled')
	},
	AkError: {
		code: 'AkError',
		message: window.rootVue.$gettext('Please Confirm Whether Ak And Sk Are Correct')
	},
	PermissionError: {
		code: 'PermissionError',
		message: window.rootVue.$gettext('Insufficient Data Access Rights. Please Grant IAM.ECS.ReadOnlyAccess')
	},
	ParamError: {
		code: 'ParamError',
		message: window.rootVue.$gettext('Failed to obtain interface data. Please check if the parameters are correct!')
	},
	InvalidStatisticTimeScope: {
		code: 'InvalidStatisticTimeScope',
		message: window.rootVue.$gettext('The Time Frame Cannot Exceed One Year. Please Adjust It And Try Again.')
	}
};

var showErrorMsg = function showErrorMsg(code, msg, type, options) {
	var error = errorMsg[code] || errorMsg[msg];
	var message = null;
	if (error) {
		message = window.rootVue.$gettext(error.message);
		var keys = message.match(/#{[a-zA-Z0-9]+}/g);
		if (keys && keys.length && options) {
			keys.forEach(function (key) {
				var _key = key.substring(2, key.length - 1);
				message = message.replace(new RegExp('#{' + _key + '}'), options[_key]);
			});
		}
	}
	__WEBPACK_IMPORTED_MODULE_0_element_ui___default.a.Notification({
		message: code && errorMsg[code] || errorMsg[msg] ? message : window.rootVue.$gettext ? window.rootVue.$gettext(msg) : msg,
		type: type || 'error'
	});
};

/* harmony default export */ __webpack_exports__["a"] = ({
	showErrorMsg: showErrorMsg
});

/***/ }),
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ewm.8a8c159.png";

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo5.690e5f9.png";

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(556),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(563),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(411)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(603),
  /* scopeId */
  "data-v-9b0b3a30",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(424)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(616),
  /* scopeId */
  "data-v-cabe2dca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(361)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(552),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(407)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(599),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(398)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(590),
  /* scopeId */
  "data-v-76113ddb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(584),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(399)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(591),
  /* scopeId */
  "data-v-7802c282",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(410)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(602),
  /* scopeId */
  "data-v-8bde6e5e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(402)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(594),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(352)
__webpack_require__(351)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(543),
  /* scopeId */
  "data-v-2938854b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(375)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(568),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(415)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(607),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(426)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(618),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(359)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(550),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(403)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(595),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(345)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(537),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(577),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(409)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(601),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(430)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(623),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(367)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(559),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(353)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(544),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(613),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(408)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(600),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(572),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(420)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(612),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(376)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(569),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(573),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(425)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(617),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(391)
__webpack_require__(390)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(583),
  /* scopeId */
  "data-v-6914310a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(350)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(542),
  /* scopeId */
  "data-v-26ecad13",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(348)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(540),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(349)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(404)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(596),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(431)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(624),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(343)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(362)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(553),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(571),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(406)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(598),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(358)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(549),
  /* scopeId */
  "data-v-3507429e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(574),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(370)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(562),
  /* scopeId */
  "data-v-4c86e486",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(427)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(619),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(356)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(547),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(419)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(611),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(369)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(561),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(371)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(564),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(395)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(587),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(340)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(531),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(339)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(530),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(344)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(535),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(365)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(557),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(570),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(357)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(548),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(341)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(532),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(364)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(555),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(418)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(610),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(387)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(580),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(347)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(539),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(429)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(622),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(397)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(589),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(393)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(585),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(354)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(545),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(360)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(551),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(405)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(597),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(368)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(560),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(575),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(412)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(604),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(414)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(606),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(428)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(621),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(338)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(355)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(546),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(620),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(366)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(558),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(432)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(625),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(346)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(538),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(396)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(588),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(400)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(592),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(342)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(533),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(578),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(372)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(565),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(576),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(386)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(579),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(581),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(422)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(614),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(389)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(582),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(374)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(567),
  /* scopeId */
  "data-v-5550f9a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [(!_vm.memberForm.memberDis) ? _c('translate', [_vm._v("Add Members")]) : _vm._e(), _vm._v(" "), (_vm.memberForm.memberDis) ? _c('translate', [_vm._v("Change Members")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    staticStyle: {
      "height": "100%"
    },
    on: {
      "click": function($event) {
        _vm.selectFocus()
      }
    },
    slot: "content"
  }, [_c('el-form', {
    ref: "memberForm",
    staticClass: "memberForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.memberForm
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "label": _vm.attrText.type
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.memberForm.type),
      callback: function($$v) {
        _vm.memberForm.type = $$v
      },
      expression: "memberForm.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.administrator,
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.ordinary,
      "value": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "accountId"
    }
  }, [_c('el-select', {
    ref: "members",
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": _vm.attrText.inputName,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.onChangeSelect
    },
    model: {
      value: (_vm.memberForm.accountId),
      callback: function($$v) {
        _vm.memberForm.accountId = $$v
      },
      expression: "memberForm.accountId"
    }
  }, _vm._l((_vm.memberForm.list), function(item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "select-item",
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }, [_vm._v(" " + _vm._s(item.name)), _c('br'), _vm._v(_vm._s(item.account) + " ")])
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.enableSubmitting
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects,
      "items": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Create Cluster")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel-add",
    attrs: {
      "datas": _vm.itemForm,
      "items": _vm.itemForm
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitAddForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Sharing Cluster")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel-add",
    attrs: {
      "datas": _vm.options
    },
    on: {
      "onClose": _vm.onCloseForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Instance Detail")])], 1), _vm._v(" "), _c('div', {
    staticClass: "cloud-wrapper",
    slot: "content"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.baseInfo,
      "name": "baseInfo"
    }
  }, [(!_vm.basicInfo.show) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.basicInfo.show),
      expression: "!basicInfo.show"
    }],
    staticStyle: {
      "height": "300px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.basicInfo.show) ? _c('div', [_c('div', {
    staticClass: "info-content"
  }, [_c('h4', {
    staticClass: "info-title"
  }, [_c('translate', [_vm._v("Information")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Instance ID")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.options.instanceId))]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Instance Name")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Instances.InstanceName))]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Zone")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.ZoneName))]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Region")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.RegionName))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('h4', {
    staticClass: "info-title"
  }, [_c('translate', [_vm._v("Configuration Information")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("CPU")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Instances.Cpu) + "  core")]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("RAM")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Memory))]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Public Network IP")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err && _vm.basicInfo.Instances.InstanceNetworkType == 'vpc') ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Instances.EipAddress.IpAddress))]) : _vm._e(), _vm._v(" "), (!_vm.basicInfo.err && _vm.basicInfo.Instances.InstanceNetworkType != 'vpc') ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Instances.PublicIpAddress.IpAddress.join(',')))]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Intranet IP")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err && _vm.basicInfo.Instances.InstanceNetworkType == 'vpc') ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Instances.VpcAttributes.PrivateIpAddress.IpAddress[0]))]) : _vm._e(), _vm._v(" "), (!_vm.basicInfo.err && _vm.basicInfo.Instances.InstanceNetworkType != 'vpc') ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Instances.InnerIpAddress.IpAddress.join(',')))]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("System Disk")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(((_vm.diskCategory[_vm.basicInfo.systemDisk.Category]) + " " + (_vm.basicInfo.systemDisk.Size) + "GB")) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Data Disk")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    staticClass: "ak-defined",
    attrs: {
      "span": 17
    }
  }, [(_vm.basicInfo.systemDisk.DiskId && (!_vm.basicInfo.dataDisk || _vm.basicInfo.dataDisk.length == 0)) ? _c('div', [_vm._v(" - ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.basicInfo.dataDisk), function(disk, index) {
    return _c('div', {
      key: index
    }, [_vm._v(_vm._s(disk.category ? ((_vm.diskCategory[disk.category]) + " " + (disk.size) + "GB") : '-'))])
  })], 2) : _vm._e()], 1)])])]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.monitorInfo,
      "name": "monitorInfo"
    }
  }, [_c('div', {
    staticClass: "select-time"
  }, [_c('el-select', {
    on: {
      "change": _vm.onSelectTime
    },
    model: {
      value: (_vm.monitorInfo.selectTime),
      callback: function($$v) {
        _vm.monitorInfo.selectTime = $$v
      },
      expression: "monitorInfo.selectTime"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.onehour,
      "value": "oneHour"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.sixhour,
      "value": "sixHour"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.oneday,
      "value": "oneDay"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.sevenday,
      "value": "sevenDay"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.monitorInfo.show) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.monitorInfo.show),
      expression: "!monitorInfo.show"
    }],
    staticStyle: {
      "height": "300px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.monitorInfo.show && _vm.monitorInfo.err) ? _c('div', {
    staticStyle: {
      "line-height": "100px",
      "text-align": "center"
    }
  }, [_c('translate', [_vm._v("No Monitoring Information Is Available")])], 1) : _vm._e(), _vm._v(" "), (_vm.monitorInfo.show && !_vm.monitorInfo.err) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.monitorInfo.show),
      expression: "!monitorInfo.show"
    }],
    staticClass: "show-chart"
  }, [_c('div', {
    staticClass: "chart-item"
  }, [_c('h3', {
    staticClass: "chart-title"
  }, [_c('translate', [_vm._v("CPU Monitoring")])], 1), _vm._v(" "), (_vm.monitorInfo.cpuData) ? _c('nvd3-line-chart', {
    attrs: {
      "options": _vm.monitorInfo.cpuData.options,
      "data": _vm.monitorInfo.cpuData.data
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-item"
  }, [_c('h3', {
    staticClass: "chart-title"
  }, [_c('translate', [_vm._v("Network Monitoring")])], 1), _vm._v(" "), (_vm.monitorInfo.netData) ? _c('nvd3-line-chart', {
    attrs: {
      "options": _vm.monitorInfo.netData.options,
      "data": _vm.monitorInfo.netData.data
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-item"
  }, [_c('h3', {
    staticClass: "chart-title"
  }, [_c('translate', [_vm._v("Disk Monitoring")])], 1), _vm._v(" "), (_vm.monitorInfo.diskData) ? _c('nvd3-line-chart', {
    attrs: {
      "options": _vm.monitorInfo.diskData.options,
      "data": _vm.monitorInfo.diskData.data
    }
  }) : _vm._e()], 1)]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.basicInfo.err || _vm.basicInfo.Instances.Status === 'Running' || _vm.basicInfo.Instances.Status === 'Stopping' || _vm.basicInfo.Instances.Status === 'Starting'
    },
    on: {
      "click": function($event) {
        _vm.onShowDialog(1)
      }
    }
  }, [_c('translate', [_vm._v("Start")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "disabled": _vm.basicInfo.err || _vm.basicInfo.Instances.Status === 'Stopped' || _vm.basicInfo.Instances.Status === 'Stopping' || _vm.basicInfo.Instances.Status === 'Starting'
    },
    on: {
      "click": function($event) {
        _vm.onShowDialog(2)
      }
    }
  }, [_c('translate', [_vm._v("Reboot")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.basicInfo.err || _vm.basicInfo.Instances.Status !== 'Running' || _vm.basicInfo.Instances.Status === 'Starting' || _vm.basicInfo.Instances.Status === 'Stopping'
    },
    on: {
      "click": function($event) {
        _vm.onShowDialog(3)
      }
    }
  }, [_c('translate', [_vm._v("Stop")])], 1), _vm._v(" "), (_vm.basicInfo.Instances.Status !== 'Running' && _vm.basicInfo.Instances.Status !== 'Stopped') ? _c('span', {
    staticStyle: {
      "margin-left": "10px",
      "color": "red"
    }
  }, [(_vm.basicInfo.Instances.Status === 'Stopping') ? _c('translate', [_vm._v("The Instance Is Stopping")]) : _vm._e(), _vm._v(" "), (_vm.basicInfo.Instances.Status === 'Starting') ? _c('translate', [_vm._v("The Instance Is Starting Up")]) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "view-title"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.$route.query.groupName || _vm.attrText.group) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "workgroup-wrapper"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card",
      "active-name": _vm.m.currentTab
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.workgroup,
      "name": "workgroup"
    }
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowAccountAddWorkgroup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Distribute")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.m.batchDel === ''
    },
    on: {
      "click": function($event) {
        _vm.batchDel(_vm.m.batchDel)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Exit")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "memberTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.m.groupWorkgroupList,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.project_name))]), _vm._v(" "), (scope.row.network_id !== -1) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.defaultWorkgroup,
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-globe",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.desc
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.desc) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.batchDel(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Exit")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.m.totalPage > 10 && _vm.m.currentTab === 'workgroup') ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.m.totalPage,
      "current-page": _vm.m.currentPage,
      "page-size": 10
    },
    on: {
      "update:currentPage": function($event) {
        _vm.m.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.callback
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects,
      "items": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Change Nickname")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Cloud Account Import")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "select-role",
    attrs: {
      "label": _vm.attrText.cloudPlatform,
      "prop": "source"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.changeCloudPlarform
    },
    model: {
      value: (_vm.formData.source),
      callback: function($$v) {
        _vm.formData.source = $$v
      },
      expression: "formData.source"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.aliyun_zh,
      "value": "aliyun"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.aliyun_cn,
      "value": "aliyun_overseas"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.huawei_zh,
      "value": "huaweiyun"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.huawei_cn,
      "value": "huaweiyun_overseas"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.aws_zh,
      "value": "aws"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.aws_cn,
      "value": "aws_overseas"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.volcengine,
      "value": "huoshanyun"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fixed-text",
    attrs: {
      "label": "Access Key",
      "prop": "ak"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.ak
    },
    model: {
      value: (_vm.formData.ak),
      callback: function($$v) {
        _vm.formData.ak = $$v
      },
      expression: "formData.ak"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fixed-text",
    attrs: {
      "label": "Access Secret",
      "prop": "sk"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.sk,
      "type": "password",
      "name": "newPassword",
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.formData.sk),
      callback: function($$v) {
        _vm.formData.sk = $$v
      },
      expression: "formData.sk"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.area,
      "prop": "region"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "disabled": !_vm.formData.source
    },
    model: {
      value: (_vm.formData.region),
      callback: function($$v) {
        _vm.formData.region = $$v
      },
      expression: "formData.region"
    }
  }, _vm._l((_vm.regions), function(region) {
    return _c('el-option', {
      key: region.RegionId,
      attrs: {
        "label": _vm.$language.current === 'zh_CN' ? region.LocalName : region.LocalNameEn,
        "value": region.RegionId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.scanType,
      "prop": "region"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.is_shield),
      callback: function($$v) {
        _vm.formData.is_shield = $$v
      },
      expression: "formData.is_shield"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_c('translate', [_vm._v("Full Scan")])], 1), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_c('translate', [_vm._v("Block Imported IP")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.scanLoading),
      expression: "scanLoading"
    }],
    staticClass: "scan-btn",
    attrs: {
      "type": "primary",
      "disabled": !_vm.isCanScan
    },
    on: {
      "click": function($event) {
        _vm.scan()
      }
    }
  }, [_c('translate', [_vm._v("Scan")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-header"
  }, [(_vm.$route.query.type == 'ecs') ? _c('span', [_c('translate', [_vm._v("Select The Host")])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.query.type == 'rds') ? _c('span', [_c('translate', [_vm._v("Select The Database")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-select', {
    staticClass: "account-search",
    attrs: {
      "placeholder": "userType"
    },
    on: {
      "change": _vm.initSelect
    },
    model: {
      value: (_vm.searchForm.condition),
      callback: function($$v) {
        _vm.searchForm.condition = $$v
      },
      expression: "searchForm.condition"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.instanceName,
      "value": "instance_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.instanceId,
      "value": "instance_id"
    }
  }), _vm._v(" "), (_vm.$route.query.type == 'ecs') ? _c('el-option', {
    attrs: {
      "label": _vm.attrText.os,
      "value": "os_type"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.query.type == 'ecs') ? _c('el-option', {
    attrs: {
      "label": "VPC ID",
      "value": "vpc_id"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.query.type == 'rds') ? _c('el-option', {
    attrs: {
      "label": _vm.attrText.type,
      "value": "engine"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.IPAndAddress,
      "value": "ip_address"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "icon": "search",
      "on-icon-click": _vm.scan
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.scan()
      }
    },
    model: {
      value: (_vm.searchForm.text),
      callback: function($$v) {
        _vm.searchForm.text = $$v
      },
      expression: "searchForm.text"
    }
  })], 1)]), _vm._v(" "), (_vm.$route.query.type == 'ecs') ? _c('el-table', {
    staticClass: "instance-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.instanceList,
      "max-height": "400"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45",
      "fixed": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.instanceIdAndName,
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.instance_name
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.instance_name))])]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.instance_id
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.instance_id))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.os,
      "prop": "os_type",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "VPC ID",
      "prop": "vpc_id",
      "width": "220"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.IPAndAddress,
      "prop": "ip_address",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.port,
      "prop": "port",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.port),
            callback: function($$v) {
              scope.row.port = $$v
            },
            expression: "scope.row.port"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.userName,
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": _vm.attrText.usernameholder
          },
          model: {
            value: (scope.row.username),
            callback: function($$v) {
              scope.row.username = $$v
            },
            expression: "scope.row.username"
          }
        })]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$route.query.type == 'rds') ? _c('el-table', {
    staticClass: "instance-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.instanceList,
      "max-height": "400"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45",
      "fixed": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.instanceIdAndName,
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.instance_name
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.instance_name))])]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.instance_id
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.instance_id))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.type,
      "prop": "engine",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.IPAndAddress,
      "prop": "ip_address",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.ip_address
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.ip_address))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.port,
      "prop": "port",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.port),
            callback: function($$v) {
              scope.row.port = $$v
            },
            expression: "scope.row.port"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.dataBase,
      "prop": "database",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.database),
            callback: function($$v) {
              scope.row.database = $$v
            },
            expression: "scope.row.database"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.connectIdentifier,
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.engine === 'Oracle') ? _c('el-input', {
          model: {
            value: (scope.row.service_name),
            callback: function($$v) {
              scope.row.service_name = $$v
            },
            expression: "scope.row.service_name"
          }
        }) : _c('span', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.connectIdentifierType,
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.engine === 'Oracle') ? _c('el-select', {
          model: {
            value: (scope.row.service_name_type),
            callback: function($$v) {
              scope.row.service_name_type = $$v
            },
            expression: "scope.row.service_name_type"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "Service Name",
            "value": "service_name"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "SID",
            "value": "sid"
          }
        })], 1) : _c('span', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.userName,
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.username),
            callback: function($$v) {
              scope.row.username = $$v
            },
            expression: "scope.row.username"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.password,
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "password"
          },
          model: {
            value: (scope.row.password),
            callback: function($$v) {
              scope.row.password = $$v
            },
            expression: "scope.row.password"
          }
        })]
      }
    }])
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.importLoading),
      expression: "importLoading"
    }],
    attrs: {
      "type": "primary",
      "disabled": !_vm.isCanImport
    },
    on: {
      "click": function($event) {
        _vm.onStartImport()
      }
    }
  }, [_c('translate', [_vm._v("Import")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "el-button",
    class: [
      _vm.type ? 'el-button--' + _vm.type : '',
      _vm.size ? 'el-button--' + _vm.size : '',
      {
        'is-disabled': _vm.disabled,
        'is-loading': _vm.loading,
        'is-plain': _vm.plain
      }
    ],
    attrs: {
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus,
      "type": _vm.nativeType
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e(), _vm._v(" "), (_vm.icon && !_vm.loading) ? _c('i', {
    class: 'el-icon-' + _vm.icon
  }) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('span', [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Advanced Search")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "advanceSearchForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.advanceSearchForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.resourceType,
      "prop": "resourceType"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.advanceSearchForm.resourceType),
      callback: function($$v) {
        _vm.advanceSearchForm.resourceType = $$v
      },
      expression: "advanceSearchForm.resourceType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.select,
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Linux（SSH）",
      "value": "Linux"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Windows（RDP）",
      "value": "Windows"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "MySQL",
      "value": "MySQL"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SQL Server",
      "value": "SQL Server"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "PostgreSQL",
      "value": "postgresql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Oracle",
      "value": "oracle"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.fileTransfer,
      "value": "transfer"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.command,
      "prop": "keywords"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.advanceSearchForm.keywords),
      callback: function($$v) {
        _vm.advanceSearchForm.keywords = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "advanceSearchForm.keywords"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.member,
      "prop": "member"
    }
  }, [_c('div', {
    staticClass: "auto-search"
  }, [_c('el-autocomplete', {
    attrs: {
      "popper-class": "my-autocomplete",
      "fetch-suggestions": _vm.memberSearch,
      "custom-item": "allMember",
      "trigger-on-focus": false,
      "placeholder": _vm.attrText.pleaseinput
    },
    on: {
      "select": _vm.memberSelect
    },
    model: {
      value: (_vm.advanceSearchForm.member),
      callback: function($$v) {
        _vm.advanceSearchForm.member = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "advanceSearchForm.member"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.ip,
      "prop": "ip"
    }
  }, [_c('div', {
    staticClass: "auto-search"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "例：192.168.1.1"
    },
    model: {
      value: (_vm.advanceSearchForm.ip),
      callback: function($$v) {
        _vm.advanceSearchForm.ip = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "advanceSearchForm.ip"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.resourceName,
      "prop": "resourceName"
    }
  }, [_c('div', {
    staticClass: "auto-search"
  }, [_c('el-autocomplete', {
    attrs: {
      "popper-class": "my-autocomplete",
      "custom-item": "allResourceName",
      "fetch-suggestions": _vm.resourceNameSearch,
      "placeholder": _vm.attrText.pleaseinput,
      "trigger-on-focus": false
    },
    on: {
      "select": _vm.resourceSelect
    },
    model: {
      value: (_vm.advanceSearchForm.resourceName),
      callback: function($$v) {
        _vm.advanceSearchForm.resourceName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "advanceSearchForm.resourceName"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.time,
      "prop": "timeType"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.advanceSearchForm.timeType),
      callback: function($$v) {
        _vm.advanceSearchForm.timeType = $$v
      },
      expression: "advanceSearchForm.timeType"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "timeRange"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.advanceSearchForm.timeType !== '1'
    },
    model: {
      value: (_vm.advanceSearchForm.timeRange),
      callback: function($$v) {
        _vm.advanceSearchForm.timeRange = $$v
      },
      expression: "advanceSearchForm.timeRange"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.unlimited,
      "value": "unlimit"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.oneDay,
      "value": "oneDay"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.sevenDay,
      "value": "sevenDay"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.oneMouth,
      "value": "oneMouth"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('div', {
    staticClass: "radio-search"
  }, [_c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.attrText.startTime,
      "disabled": _vm.advanceSearchForm.timeType !== '2',
      "prop": "startTime"
    },
    model: {
      value: (_vm.advanceSearchForm.startTime),
      callback: function($$v) {
        _vm.advanceSearchForm.startTime = $$v
      },
      expression: "advanceSearchForm.startTime"
    }
  }), _vm._v(" "), _c('span', [_c('translate', [_vm._v("To")])], 1), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.attrText.endTime,
      "disabled": _vm.advanceSearchForm.timeType !== '2',
      "prop": "endTime"
    },
    model: {
      value: (_vm.advanceSearchForm.endTime),
      callback: function($$v) {
        _vm.advanceSearchForm.endTime = $$v
      },
      expression: "advanceSearchForm.endTime"
    }
  })], 1)], 1)])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "unSafeMode"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "prop": "unSafeMode"
    },
    model: {
      value: (_vm.advanceSearchForm.unSafeMode),
      callback: function($$v) {
        _vm.advanceSearchForm.unSafeMode = $$v
      },
      expression: "advanceSearchForm.unSafeMode"
    }
  }, [_c('translate', [_vm._v("Non-Security Mode Connection")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmitSearch(_vm.advanceSearchForm)
      }
    }
  }, [_c('translate', [_vm._v("Search")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetForm('advanceSearchForm')
      }
    }
  }, [_c('translate', [_vm._v("Reset")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("View Members")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%"
    },
    slot: "content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.detail.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.attrText.userName
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": _vm.attrText.account
    }
  })], 1), _vm._v(" "), (_vm.detail.totalCount > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.detail.totalCount,
      "page-size": 10,
      "current-page": _vm.detail.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.detail.currentPage = $event
      },
      "current-change": _vm.handlePageChange
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel-add",
    attrs: {
      "datas": _vm.itemForm,
      "items": _vm.itemForm
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitAddForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Add Log Filter")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-security"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTipModal),
      expression: "showTipModal"
    }],
    staticClass: "confirm-tip-modal"
  }), _vm._v(" "), _c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Account Security")])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "m-h-200"
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "security-item"
  }, [_c('div', {
    staticClass: "account-ip item-deteil"
  }, [_c('p', [_c('span', {
    staticClass: "item-name"
  }, [_c('translate', [_vm._v("Last Login Time:")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.accountInfo.last_login_time * 1000, 'YYYY-MM-DD HH:mm:ss')))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "item-name"
  }, [_c('translate', [_vm._v("Last Login IP:")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.accountInfo.last_login_ip))])]), _vm._v(" "), _c('el-button', {
    staticClass: "change-password",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onChangePassword()
      }
    }
  }, [_c('translate', [_vm._v("Change Password")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "item-deteil"
  }, [_c('p', [_c('span', {
    staticClass: "item-name"
  }, [_c('translate', [_vm._v("Bind Mobile")])], 1), _vm._v(" "), (_vm.accountInfo.mobile) ? _c('span', {
    staticClass: "item-msg"
  }, [_c('translate', [_vm._v("You have bound")]), _vm._v(" " + _vm._s(_vm._f("telNumberFormat")(_vm.accountInfo.mobile)) + "\n          ")], 1) : _vm._e(), _vm._v(" "), (!_vm.accountInfo.mobile) ? _c('span', {
    staticClass: "item-msg"
  }, [_c('translate', [_vm._v("Unbound phone number")])], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn-text",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowChangeMobile()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.accountInfo.mobile ? _vm.attrText.change : _vm.attrText.bindMobile) + "\n          ")])], 1), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "item-name"
  }, [_c('translate', [_vm._v("Virtual MFA")])], 1), _vm._v(" "), _c('span', {
    staticClass: "item-msg"
  }, [_vm._v(_vm._s(_vm.accountInfo.otp_enabled ? _vm.attrText.enabled : _vm.attrText.unopened))]), _vm._v(" "), _c('el-button', {
    staticClass: "btn-text",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onMfaOpen()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.accountInfo.otp_enabled ? _vm.attrText.close : _vm.attrText.open) + "\n          ")])], 1)])])]) : _vm._e(), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.getAccountInfo
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.accountInfo
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [(_vm.accountInfo) ? _c('div', {
    slot: "header"
  }, [_vm._v("\n    " + _vm._s(!_vm.accountInfo.mobile ? _vm.attrText.bindMobile : _vm.attrText.changeMobile) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "mobileForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.mobileNum
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.changePhoneNumForm.disMobile,
      "placeholder": _vm.attrText.pleaseinputMobil
    },
    on: {
      "change": _vm.checkMobile
    },
    model: {
      value: (_vm.changePhoneNumForm.mobile),
      callback: function($$v) {
        _vm.changePhoneNumForm.mobile = $$v
      },
      expression: "changePhoneNumForm.mobile"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('div', {
    staticClass: "btn-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.changePhoneNumForm.canSubmit
    },
    on: {
      "click": function($event) {
        _vm.onSubmitVerify()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs.rightPanel.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-information"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Account Information")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "m-h-200"
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "account-avatar"
  }, [_c('img', {
    staticClass: "avatar-img",
    attrs: {
      "src": _vm._f("resetURL")(_vm.currentAccount.avatar)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "avatar-desc"
  }, [_c('translate', [_vm._v("avatar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "upload-avatar",
    on: {
      "click": function($event) {
        _vm.fileClick()
      }
    }
  }, [_c('input', {
    staticClass: "upload-file",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/png,image/gif,image/jpeg"
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('translate', [_vm._v("Change")])], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "team-info break-line"
  }, [_c('p', {
    staticClass: "info-name"
  }, [_c('span', {
    staticClass: "name-space"
  }, [_c('translate', [_vm._v("Team Name:")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentTeam.full_name))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "name-space"
  }, [_c('translate', [_vm._v("Team code:")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentTeam.domain))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "team-info"
  }, [_c('p', {
    staticClass: "info-name"
  }, [_c('span', {
    staticClass: "name-space"
  }, [_c('translate', [_vm._v("Display Nickname:")])], 1), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "limit-text"
  }, [_vm._v(_vm._s(_vm.currentAccount.name))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-edit edit-name",
    on: {
      "click": function($event) {
        _vm.showEditName()
      }
    }
  })])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "name-space"
  }, [_c('translate', [_vm._v("login account:")])], 1), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "limit-text"
  }, [_vm._v(_vm._s(_vm.currentAccount.account))])])])])])], 1) : _vm._e()], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "statistic-panel"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "statistic-item text-center",
    attrs: {
      "xs": 12,
      "sm": 6
    }
  }, [_c('div', [_c('div', [_c('i', {
    staticClass: "material-icons assess-color"
  }, [_vm._v("assessment")])]), _vm._v(" "), _c('div', [_c('translate', [_vm._v("Resource")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "count assess-color"
  }, [_vm._v(_vm._s(_vm.statistic.resources + _vm.statistic.shared_resources || 0))])], 1)])]), _vm._v(" "), _c('el-col', {
    staticClass: "statistic-item text-center",
    attrs: {
      "xs": 12,
      "sm": 6
    }
  }, [_c('div', [_c('div', [_c('i', {
    staticClass: "material-icons work-color"
  }, [_vm._v("dvr")])]), _vm._v(" "), _c('div', [_c('translate', [_vm._v("WorkGroup")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "count work-color"
  }, [_vm._v(_vm._s(_vm.statistic.projects || 0))])], 1)])]), _vm._v(" "), _c('el-col', {
    staticClass: "statistic-item text-center",
    attrs: {
      "xs": 12,
      "sm": 6
    }
  }, [_c('div', [_c('div', [_c('i', {
    staticClass: "material-icons cluster-color"
  }, [_vm._v("view_list")])]), _vm._v(" "), _c('div', [_c('translate', [_vm._v("Cluster")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "count cluster-color"
  }, [_vm._v(_vm._s(_vm.statistic.networks || 0))])], 1)])]), _vm._v(" "), _c('el-col', {
    staticClass: "statistic-item text-center",
    attrs: {
      "xs": 12,
      "sm": 6
    }
  }, [_c('div', [_c('div', [_c('i', {
    staticClass: "material-icons member-color"
  }, [_vm._v("group")])]), _vm._v(" "), _c('div', [_c('translate', [_vm._v("Member")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "count member-color"
  }, [_vm._v(_vm._s(_vm.statistic.accounts || 0))])], 1)])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-panel"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 10,
      "lg": 10
    }
  }, [_c('div', {
    staticClass: "graph-item"
  }, [_c('div', {
    staticClass: "graph-item-header"
  }, [_c('translate', [_vm._v("Resource Type")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.reTypeLoading),
      expression: "reTypeLoading"
    }],
    staticClass: "graph-item-content chart"
  }, [(!_vm.resourceType && !_vm.reTypeLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "110px"
    }
  }, [_c('translate', [_vm._v("No Resource Type")])], 1) : _vm._e(), _vm._v(" "), (_vm.resourceType && !_vm.reTypeLoading) ? _c('nvd3-pie-chart', {
    attrs: {
      "options": _vm.resourceType.options,
      "data": _vm.resourceType.data
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 14,
      "lg": 14
    }
  }, [_c('div', {
    staticClass: "graph-item"
  }, [_c('div', {
    staticClass: "graph-item-header"
  }, [_c('translate', [_vm._v("A Week Operation Statistic")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.weekOperation),
      expression: "!weekOperation"
    }],
    staticClass: "graph-item-content chart"
  }, [(_vm.weekOperation) ? _c('nvd3-line-chart', {
    attrs: {
      "options": _vm.weekOperation.options,
      "data": _vm.weekOperation.data
    }
  }) : _vm._e()], 1)])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-panel"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "graph-item",
    class: _vm.currentConnectCount > 10 ? 'graph-item-210' : ''
  }, [_c('div', {
    staticClass: "graph-item-header"
  }, [_c('translate', [_vm._v("Online Sessions")])], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-item-content"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.currentConnectList),
      expression: "!currentConnectList"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.currentConnectList,
      "empty-text": _vm.attrText.noSession
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "account.name",
      "label": _vm.attrText.member,
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(!scope.row.account ? '' : scope.row.account.name) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50",
      "label": " "
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.safe_mode) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.unsafeMode,
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-exclamation-circle warn"
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "project_name",
      "label": _vm.attrText.workgroup
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resource_name",
      "label": _vm.attrText.resource
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.agentVersion < '3.0.0') ? _c('el-button', {
          attrs: {
            "disabled": !scope.row.linkHref || !(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp)),
            "type": "text",
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              _vm.onLinkhref(scope.row.linkHref)
            }
          }
        }, [_c('translate', [_vm._v("Monitor")])], 1) : _vm._e(), _vm._v(" "), (scope.row.agentVersion >= '3.0.0') ? _c('el-button', {
          attrs: {
            "disabled": !(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp)),
            "type": "text",
            "target": "_blank"
          }
        }, [(scope.row.way === 'terminal' || scope.row.way === 'wetty') ? _c('span', {
          on: {
            "click": function($event) {
              _vm.createShadow(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("assistance")])], 1) : _vm._e(), _vm._v(" "), ((scope.row.way === 'rdp' && scope.row.showRdp)) ? _c('span', {
          on: {
            "click": function($event) {
              _vm.onLinkhref(scope.row.linkHref)
            }
          }
        }, [_c('translate', [_vm._v("monitor")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.onCutOnline(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Disconnect")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.currentConnectCount > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.currentConnectCount,
      "page-size": 10,
      "current-page": _vm.currentConnectPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentConnectPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('div', {
    staticClass: "graph-item"
  }, [_c('div', {
    staticClass: "graph-item-header"
  }, [_c('translate', [_vm._v("A Week TOP Member")])], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-item-content"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.topMembers),
      expression: "!topMembers"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.topMembers
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.member
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "photo clearfix"
        }, [_c('img', {
          attrs: {
            "src": _vm._f("resetURL")(props.row.avatar),
            "border": "0"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.row.name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.duration,
      "width": "110",
      "class-name": "text-right",
      "label-class-name": "text-right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.conn_time) + "\n                ")]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('div', {
    staticClass: "graph-item"
  }, [_c('div', {
    staticClass: "graph-item-header"
  }, [_c('translate', [_vm._v("A Week TOP Resource")])], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-item-content"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.topResources),
      expression: "!topResources"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.topResources
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.attrText.resource,
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "conn_count",
      "label": _vm.attrText.number,
      "class-name": "text-right",
      "label-class-name": "text-right"
    }
  })], 1)], 1)])])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    attrs: {
      "datas": _vm.applyObj
    },
    on: {
      "onClose": function($event) {
        _vm.onClose()
      }
    }
  }, [(_vm.applyObj) ? _c('div', {
    slot: "header"
  }, [_c('div', [_c('translate', [_vm._v("Start Application")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.applyObj) ? _c('div', {
    staticClass: "apply-content",
    slot: "content"
  }, [_c('el-form', {
    ref: "applyForm",
    attrs: {
      "model": _vm.applyForm,
      "label-width": "90px",
      "rules": _vm.applyRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.project
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.applyObj.project))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.resourceName
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.applyObj.name))])]), _vm._v(" "), (_vm.applyObj.applyType === 'rds') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.targetDatabase,
      "prop": "database"
    }
  }, [(_vm.applyObj.db_name && _vm.applyObj.db_name[0] !== '*') ? _c('el-select', {
    model: {
      value: (_vm.applyForm.database),
      callback: function($$v) {
        _vm.applyForm.database = $$v
      },
      expression: "applyForm.database"
    }
  }, _vm._l((_vm.applyObj.db_name), function(db, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": db,
        "value": db
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.applyObj.db_name && _vm.applyObj.db_name[0] === '*') ? _c('el-input', {
    model: {
      value: (_vm.applyForm.database),
      callback: function($$v) {
        _vm.applyForm.database = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "applyForm.database"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.applyObj.applyType === 'rds') ? _c('el-form-item', {
    attrs: {
      "label": "SQL",
      "prop": "sql"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 8,
        maxRows: 15
      }
    },
    on: {
      "change": function($event) {
        _vm.sqlChange()
      }
    },
    model: {
      value: (_vm.applyForm.sql),
      callback: function($$v) {
        _vm.applyForm.sql = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "applyForm.sql"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "preview-sql-img",
    attrs: {
      "src": __webpack_require__(167),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.previewSQL()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.applyObj.applyType === 'rds') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.comment,
      "prop": "comment"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "width": "360px"
    },
    model: {
      value: (_vm.applyForm.comment),
      callback: function($$v) {
        _vm.applyForm.comment = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "applyForm.comment"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.applyObj.applyType === 'ecs') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.reason,
      "prop": "reason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.applyForm.reason),
      callback: function($$v) {
        _vm.applyForm.reason = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "applyForm.reason"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.applyObj.applyType === 'ecs') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.validTime,
      "prop": "time"
    }
  }, [_c('el-date-picker', {
    staticClass: "safe-datetime-picker",
    attrs: {
      "type": "datetime",
      "picker-options": _vm.safeOptions,
      "placeholder": _vm.attrText.selectDate
    },
    model: {
      value: (_vm.applyForm.time),
      callback: function($$v) {
        _vm.applyForm.time = $$v
      },
      expression: "applyForm.time"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.verifySuccess) ? _c('p', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto",
      "color": "red",
      "margin-left": "50px"
    }
  }, [_vm._v(_vm._s(_vm.verifyLog))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [(_vm.applyObj.applyType === 'rds') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.verifyLoading,
      "disabled": _vm.verifyLoading
    },
    on: {
      "click": function($event) {
        _vm.onVerify()
      }
    }
  }, [(_vm.verifyLoading) ? _c('span') : _c('span', [_c('translate', [_vm._v("Verify")])], 1)]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.applyObj.applyType === 'rds' && !_vm.verifySuccess
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Join WorkGroup")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    staticStyle: {
      "height": "100%"
    },
    slot: "content"
  }, [_c('el-form', {
    ref: "workgroupForm",
    staticClass: "workgroupForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.workgroupForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "project_ids"
    }
  }, [_c('el-select', {
    ref: "workgroups",
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": _vm.attrText.inputName,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.onChangeSelect
    },
    model: {
      value: (_vm.workgroupForm.project_ids),
      callback: function($$v) {
        _vm.workgroupForm.project_ids = $$v
      },
      expression: "workgroupForm.project_ids"
    }
  }, _vm._l((_vm.workgroupForm.list), function(item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "select-item",
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }, [_vm._v(" " + _vm._s(item.name)), _c('br'), _vm._v(_vm._s(item.account) + " ")])
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.workgroupForm.project_ids.length
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects,
      "items": _vm.connects
    },
    on: {
      "onClose": _vm.onClose,
      "onSubmit": _vm.onSubmitForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Create WorkGroup")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cluster-detail"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('div', {
    staticClass: "view-title-container"
  }, [_c('div', {
    staticClass: "title-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.detail.info.name))]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    class: _vm.detail.info.agent ? (_vm.detail.info.agent.status === 1 ? 'available' : 'unavailable') : 'unavailable'
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.detail.info.agent ? (_vm.detail.info.agent.status === 1 ? _vm.attrText.available : _vm.attrText.unavailable) : _vm.attrText.unavailable) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "del-btn"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.onShowConfigFile()
      }
    }
  }, [_c('translate', [_vm._v("Configuration File")])], 1), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onShowChangeName()
      }
    }
  }, [_c('translate', [_vm._v("Set Cluster")])], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteCluster()
      }
    }
  }, [_c('translate', [_vm._v("Delete Cluster")])], 1) : _vm._e(), _vm._v(" "), (_vm.detail.info.parent_id) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.returnCluster()
      }
    }
  }, [_c('translate', [_vm._v("Return The Cluster")])], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ssk-wrapper"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card",
      "active-name": _vm.detail.currentTab
    },
    on: {
      "tab-click": _vm.onTabClick
    }
  }, [(_vm.$route.query.type !== 'settings') ? _c('div', {
    staticClass: "add-ssk"
  }, [(_vm.detail.currentTab === 'ecs') ? _c('span', [_c('translate', [_vm._v("Set The Security Mode:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#58d99f"
    }
  }, [_vm._v(_vm._s(_vm.$store.getters.cluster.detail.info.safe_mode ? _vm.attrText.on : _vm.attrText.off))])], 1) : _vm._e(), _vm._v(" "), (_vm.detail.currentTab === 'ecs') ? _c('el-button', {
    staticClass: "change-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowClusterSafeMode()
      }
    }
  }, [_c('translate', [_vm._v("Change")])], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.tableHeader.scanDis
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onAdd()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Add")])], 1) : _vm._e(), _vm._v(" "), (_vm.detail.currentTab === 'ecs' && !_vm.detail.info.parent_id) ? _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.tableHeader.scanDis
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowClusterScanImport()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-television fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Scan Import")])], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.tableHeader.scanDis
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowClusterBatchInstance()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Mass import")])], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.tableHeader.scanDis
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowClusterAkImport()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Cloud Account Import")])], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.tableHeader.deleteIds === '' || _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.batchDel(null, _vm.tableHeader.deleteIds)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Delete")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [(_vm.detail.currentTab === 'ecs') ? _c('el-select', {
    staticClass: "account-search",
    attrs: {
      "placeholder": "Operating System"
    },
    model: {
      value: (_vm.tableHeader.searchForm.type),
      callback: function($$v) {
        _vm.tableHeader.searchForm.type = $$v
      },
      expression: "tableHeader.searchForm.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.os,
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Linux",
      "value": "%linux%"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Windows",
      "value": "%win32%"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.detail.currentTab === 'rds') ? _c('el-select', {
    staticClass: "account-search",
    attrs: {
      "placeholder": "Type"
    },
    model: {
      value: (_vm.tableHeader.searchForm.type),
      callback: function($$v) {
        _vm.tableHeader.searchForm.type = $$v
      },
      expression: "tableHeader.searchForm.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.type,
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "MySQL",
      "value": "mysql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SQL Server",
      "value": "mssql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "PostgreSQL",
      "value": "postgresql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Oracle",
      "value": "oracle"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-select', {
    staticClass: "account-search",
    attrs: {
      "placeholder": "userType"
    },
    on: {
      "change": _vm.initSelect
    },
    model: {
      value: (_vm.tableHeader.searchForm.condition),
      callback: function($$v) {
        _vm.tableHeader.searchForm.condition = $$v
      },
      expression: "tableHeader.searchForm.condition"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.select,
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.name,
      "value": "q_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IP",
      "value": "q_ip"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "icon": "search",
      "on-icon-click": _vm.onSearch,
      "disabled": _vm.tableHeader.searchForm.condition == ''
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearch()
      }
    },
    model: {
      value: (_vm.tableHeader.searchForm.text),
      callback: function($$v) {
        _vm.tableHeader.searchForm.text = $$v
      },
      expression: "tableHeader.searchForm.text"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.servers,
      "name": "ecs"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.dataBase,
      "name": "rds"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.setting,
      "name": "settings"
    }
  }, [(_vm.detail.info.agent && !_vm.detail.info.parent_id) ? _c('div', {
    staticClass: "setting-wrapper"
  }, [(_vm.onlineConnectTooltip) ? _c('div', [_c('translate', {
    staticClass: "font-danger",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v(" The agent has alive users,please disconnect them to continue. ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.agentUpdate) ? _c('div', [_c('translate', {
    attrs: {
      "tag": "p"
    }
  }, [_vm._v(" Please perform the following script on the control node to update the control node to the latest version ")]), _vm._v(" "), _c('div', {
    ref: "text",
    staticClass: "copy-text"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.setting.available.code) + "\n\t\t\t\t\t\t\t\t"), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.setting.available.code),
      expression: "setting.available.code",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "type": "text"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.detail.agentUpdate && !_vm.detail.backAgent) ? _c('translate', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "tag": "p"
    }
  }, [_vm._v(" The network has successfully installed the agent. If you need to change, please click \"Uninstall Agent\". ")]) : _vm._e(), _vm._v(" "), (_vm.detail.backAgent) ? _c('div', [_c('translate', {
    attrs: {
      "tag": "p"
    }
  }, [_vm._v(" Please perform the following script on the control node to roll back the management node ")]), _vm._v(" "), _c('div', {
    ref: "text",
    staticClass: "copy-text"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.setting.backAgentCode) + "\n\t\t\t\t\t\t\t\t"), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.setting.backAgentCode),
      expression: "setting.backAgentCode",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "type": "text"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "general"
  }, [_c('translate', {
    staticClass: "m-space bold"
  }, [_vm._v("General Situation")]), _vm._v(" "), _c('span', {
    staticClass: "m-space"
  }, [_c('translate', {
    staticClass: "m-space"
  }, [_vm._v("Control node IP:")]), _vm._v(" " + _vm._s(_vm.detail.info.agent.host))], 1), _vm._v(" "), _c('span', {
    staticClass: "m-space"
  }, [_c('translate', {
    staticClass: "m-space"
  }, [_vm._v("Control node version:")]), _vm._v(" " + _vm._s(_vm.detail.info.agent ? _vm.detail.info.agent.version : ''))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "agent-wrapper"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.updateAgent()
      }
    }
  }, [_c('translate', [_vm._v("Agent Update")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.backAgent()
      }
    }
  }, [_c('translate', [_vm._v("Back Agent")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.unBindAgent()
      }
    }
  }, [_c('translate', [_vm._v("Uninstall Agent")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.detail.info.agent && !_vm.detail.info.parent_id) ? _c('div', {
    staticClass: "setting-unavailable"
  }, [(_vm.setting.unavailable.code !== '') ? _c('div', {
    staticClass: "setting-wrapper"
  }, [_c('p', [_c('translate', [_vm._v(" Please execute the following script on a server in the current cluster (recommended using CentOS 7.9, 64 Bit) to configure the machine as a managed node.")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "copy-text"
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('p', {
    staticClass: "code"
  }, [_vm._v(_vm._s(_vm.setting.unavailable.code))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.setting.unavailable.code),
      expression: "setting.unavailable.code",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "type": "text"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('p', [_c('translate', [_vm._v("Notes for Attention:")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v(" 1) Network recommends configuration 2 cores 4G,40GB disk,10Mbps network bandwidth.(Recommended configuration:4 cores,4G,40GB disk,20Mbps or higher network bandwidth)")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v(" 2) To ensure the normal operation of the control node functions, the remaining disk space must be greater than 5GB.")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v(" 3) After executing the installation script, CloudLinker will use the public IP of your host as the control node IP. If there are any special requirements, please replace \"default\" with the IP or domain name you want to specify. If you need to modify the connection port of the control node, replace the default port number with the new one.")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v(" 4) In consideration of the system performance, it is recommended that the server of agent don’t be used for other purposes. ")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("5) Make sure that wget and curl are installed on your server.")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("6) Other:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://mrdoc.cloudcare.cn/doc/278/",
      "target": "_blank"
    }
  }, [_c('translate', [_vm._v("Control Node Function Description Document")])], 1)], 1)]), _vm._v(" "), _c('p', {
    staticClass: "general"
  }, [_c('translate', {
    staticClass: "m-space bold"
  }, [_vm._v("General Situation")]), _vm._v(" "), _c('span', {
    staticClass: "m-space"
  }, [_c('translate', {
    staticClass: "m-space"
  }, [_vm._v("Control node IP:")]), _vm._v(" "), _c('translate', [_vm._v("No time")])], 1), _vm._v(" "), _c('span', {
    staticClass: "m-space"
  }, [_c('translate', {
    staticClass: "m-space"
  }, [_vm._v("Control node version:")]), _vm._v(" "), _c('translate', [_vm._v("No time")])], 1)], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-tabs', {
    staticClass: "setting-tab",
    attrs: {
      "active-name": _vm.setting.settingActivetab
    },
    on: {
      "tab-click": _vm.onSettingTabClick
    },
    model: {
      value: (_vm.setting.activeTab),
      callback: function($$v) {
        _vm.setting.activeTab = $$v
      },
      expression: "setting.activeTab"
    }
  }, [(!_vm.detail.info.parent_id) ? _c('div', {
    staticClass: "setting-header"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSettingAdd($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Add")])], 1), _vm._v(" "), (_vm.setting.activeTab === 'logFilter') ? _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": this.setting.logBatchIds === ''
    },
    on: {
      "click": function($event) {
        _vm.batchDelLogFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Delete")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.shareCluster,
      "name": "shareCluster"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.setting.shareList,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.teamId
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.company.domain) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.teamName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.company.full_name) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.shareTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delShareCluster(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Cancel Share")])], 1)]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.logFilter,
      "name": "logFilter"
    }
  }, [(_vm.detail.info && _vm.setting.settingActivetab === 'logFilter') ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.setting.logList,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectLog
    }
  }, [(!_vm.detail.info.parent_id) ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.filtersOperation
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.operator) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.condition
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.condition) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.createTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delLogFilter(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Delete")])], 1)]
      }
    }])
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)])], 1), _vm._v(" "), (_vm.detail.info && _vm.$route.query.type !== 'settings') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "table-wrapper"
  }, [(_vm.detail.list && _vm.detail.currentTab !== 'settings') ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detail.list,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name,
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.name
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.name))])]), _vm._v(" "), (scope.row.resource_status === 2) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.needPsw,
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-warning text-warning"
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.accountName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.login_type), function(item) {
          return _c('p', [_c('span', [_vm._v(_vm._s(item.username))]), _vm._v(" "), (item.csos_check === 'open') ? _c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": _vm.attrText.cos,
              "placement": "top"
            }
          }, [_c('i', {
            staticClass: "fa fa-expeditedssl"
          })]) : _vm._e(), _vm._v(" "), (item.autologin) ? _c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": scope.row.type == 'WinServer' ? _vm.attrText.passwordFree : _vm.attrText.targetKey,
              "placement": "top"
            }
          }, [_c('i', {
            staticClass: "fa fa-unlock-alt"
          })]) : _vm._e()], 1)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.detail.currentTab === 'ecs' ? 'IP' : _vm.attrText.dataBaseName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.detail.currentTab === 'ecs') ? _c('p', [_vm._v(_vm._s(scope.row.ip))]) : _c('div', _vm._l((scope.row.db_name), function(item) {
          return _c('p', [_vm._v(_vm._s(item))])
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.detail.currentTab === 'ecs' ? _vm.attrText.os : _vm.attrText.innerIp,
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.detail.currentTab === 'ecs') ? _c('div', [_vm._v(_vm._s(scope.row.type === 'WinServer' ? 'Windows' : 'Linux'))]) : _c('div', [_c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.ip
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.ip))])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.detail.currentTab === 'ecs' ? _vm.attrText.specification : _vm.attrText.type
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.detail.currentTab === 'ecs') ? _c('span', [_vm._v(_vm._s(scope.row.flavor ? scope.row.flavor : '-'))]) : _c('div', [(scope.row.type === 'SQLServerDatabase') ? _c('span', [_vm._v("SQL Server")]) : (scope.row.type === 'PostgreSQLDatabase') ? _c('span', [_vm._v("PostgreSQL")]) : (scope.row.type === 'OracleDatabase') ? _c('span', [_vm._v("Oracle")]) : _c('span', [_vm._v("MySQL")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.Connectivity
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.test_result === 'pending' || (_vm.detail.info.agent ? _vm.detail.info.agent.status !== 1 : !_vm.detail.info.agent)
          },
          on: {
            "click": function($event) {
              _vm.onTestConnection(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Test")])], 1), _vm._v(" "), (scope.row.test_result === 'pending') ? _c('i', {
          staticClass: "el-icon-loading"
        }) : _vm._e(), _vm._v(" "), (scope.row.test_result === 'disable' || scope.row.test_result === 'enable') ? _c('span', {
          staticClass: "badge",
          class: scope.row.test_result && scope.row.test_result === 'disable' ? 'unavailable' : 'available'
        }, [_vm._v(_vm._s(scope.row.test_result && scope.row.test_result === 'disable' ? _vm.attrText.no : _vm.attrText.yes))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onSetting(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Setting")])], 1), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
          attrs: {
            "type": "text",
            "loading": scope.row.deleting
          },
          on: {
            "click": function($event) {
              _vm.batchDel(scope.row, [scope.row.id])
            }
          }
        }, [(!scope.row.deleting) ? _c('translate', [_vm._v("Delete")]) : _vm._e()], 1) : _vm._e()]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.detail.totalPage > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.detail.totalPage,
      "current-page": _vm.detail.currentPage,
      "page-size": 10
    },
    on: {
      "update:currentPage": function($event) {
        _vm.detail.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": _vm.attrText.upload,
      "visible": _vm.upload.isUpload
    },
    on: {
      "update:visible": function($event) {
        _vm.upload.isUpload = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.password
    }
  }, [_vm._v(":\n\t\t\t\t\t\t"), _c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.upload.password),
      callback: function($$v) {
        _vm.upload.password = $$v
      },
      expression: "upload.password"
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("(The password of %{upload.username} for the destination host)")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.upload.password === ''
    },
    on: {
      "click": function($event) {
        _vm.onComfirmUpload()
      }
    }
  }, [(_vm.upload.status !== 'pending') ? _c('span', [_c('translate', [_vm._v("Upload")])], 1) : _vm._e(), _vm._v(" "), (_vm.upload.status === 'pending') ? _c('span', [_c('translate', [_vm._v("Uploading")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.upload.isUpload = false
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.turnInstance,
      "visible": _vm.cluodDialog.start,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.cluodDialog.start = $event
      }
    }
  }, [_c('translate', [_vm._v("Are you sure to Turn On Instance?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onStart
    }
  }, [_c('translate', [_vm._v("Ok")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.cluodDialog.start = false
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "instance-dialog",
    attrs: {
      "title": _vm.attrText.reStartText,
      "visible": _vm.cluodDialog.reStart
    },
    on: {
      "update:visible": function($event) {
        _vm.cluodDialog.reStart = $event
      },
      "open": _vm.onOpenRestart,
      "click": function($event) {
        $event.stopPropagation();
        _vm.testOpen()
      }
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('translate', {
    staticClass: "tip",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Are you sure to start 1 instances?")]), _vm._v(" "), _c('p', {
    staticClass: "instance-id"
  }, [_vm._v(_vm._s(_vm.cluodDialog.Instances.InstanceId))]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('translate', [_vm._v("The Way Of Start:")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.cluodDialog.reStartWay),
      callback: function($$v) {
        _vm.cluodDialog.reStartWay = $$v
      },
      expression: "cluodDialog.reStartWay"
    }
  }, [_c('translate', [_vm._v("Reboot")])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.cluodDialog.reStartWay),
      callback: function($$v) {
        _vm.cluodDialog.reStartWay = $$v
      },
      expression: "cluodDialog.reStartWay"
    }
  }, [_c('translate', [_vm._v("Forced Restart")])], 1)], 1)], 1), _vm._v(" "), (_vm.cluodDialog.reStartWay === '2') ? _c('div', {
    staticClass: "force-stop"
  }, [_c('translate', {
    staticClass: "tip",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v(" The forced restart server will causes the virtual host to lose data that is not currently saved. ")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.cluodDialog.isForcereStart),
      callback: function($$v) {
        _vm.cluodDialog.isForcereStart = $$v
      },
      expression: "cluodDialog.isForcereStart"
    }
  }, [_c('translate', [_vm._v("Make Sure To Restart")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "disabled": _vm.cluodDialog.reStartWay === '2' && !_vm.cluodDialog.isForcereStart
    },
    on: {
      "click": _vm.onRestart
    }
  }, [_c('translate', [_vm._v("Ok")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.cluodDialog.reStart = false
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "instance-dialog",
    attrs: {
      "title": _vm.attrText.stopInstanceText,
      "visible": _vm.cluodDialog.stopInstance
    },
    on: {
      "update:visible": function($event) {
        _vm.cluodDialog.stopInstance = $event
      },
      "open": _vm.onOpenStop,
      "click": function($event) {
        $event.stopPropagation();
        _vm.testOpen()
      }
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('translate', {
    staticClass: "tip",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Are you sure to stop 1 instances?")]), _vm._v(" "), _c('p', {
    staticClass: "instance-id"
  }, [_vm._v(_vm._s(_vm.cluodDialog.Instances.InstanceId))]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('translate', [_vm._v("The Way Of Stop:")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.cluodDialog.stopWay),
      callback: function($$v) {
        _vm.cluodDialog.stopWay = $$v
      },
      expression: "cluodDialog.stopWay"
    }
  }, [_c('translate', [_vm._v("Stop")])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.cluodDialog.stopWay),
      callback: function($$v) {
        _vm.cluodDialog.stopWay = $$v
      },
      expression: "cluodDialog.stopWay"
    }
  }, [_c('translate', [_vm._v("Forced To Stop")])], 1)], 1)], 1), _vm._v(" "), (_vm.cluodDialog.stopWay === '2') ? _c('div', {
    staticClass: "force-stop"
  }, [_c('translate', {
    staticClass: "tip",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v(" The forced stop server will causes the virtual host to lose data that is not currently saved. ")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.cluodDialog.isForceShop),
      callback: function($$v) {
        _vm.cluodDialog.isForceShop = $$v
      },
      expression: "cluodDialog.isForceShop"
    }
  }, [_c('translate', [_vm._v("Make Sure To Stop")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "disabled": _vm.cluodDialog.stopWay === '2' && !_vm.cluodDialog.isForceShop
    },
    on: {
      "click": _vm.onStop
    }
  }, [_c('translate', [_vm._v("Ok")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.cluodDialog.stopInstance = false
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "instance-dialog",
    attrs: {
      "title": _vm.attrText.updateTip,
      "visible": _vm.detail.updateTip
    },
    on: {
      "update:visible": function($event) {
        _vm.detail.updateTip = $event
      },
      "close": function($event) {
        _vm.closeUpdateTip()
      }
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('translate', {
    attrs: {
      "tag": "span"
    }
  }, [_vm._v("The control node agent has released a new version, please update,")]), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "span"
    }
  }, [_vm._v("can click")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://mrdoc.cloudcare.cn/doc/318/"
    }
  }, [_c('translate', {
    attrs: {
      "tag": "span"
    }
  }, [_vm._v("update log")])], 1), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "span"
    }
  }, [_vm._v("for detail.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "agent-compile"
  }, [_c('p', {
    staticClass: "agent-version"
  }, [_c('translate', {
    staticClass: "sub-title"
  }, [_vm._v("Current Version:")]), _vm._v(" "), _c('span', {
    staticClass: "version"
  }, [_vm._v(_vm._s(_vm.detail.info.agent ? _vm.detail.info.agent.version : ''))])], 1), _vm._v(" "), _c('p', {
    staticClass: "agent-version"
  }, [_c('translate', {
    staticClass: "sub-title"
  }, [_vm._v("New Version:")]), _vm._v(" "), _c('span', {
    staticClass: "version"
  }, [_vm._v(_vm._s(_vm.newAgentVersion))])], 1)]), _vm._v(" "), (_vm.detail.info.agent && _vm.detail.info.agent.version && _vm.detail.info.agent.version.split('-')[0].split('.')[0] === '2') ? _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#fda541",
      "margin-top": "30px"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#fda541",
      "font-size": "14px",
      "top": "2px"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("Version 2.0 upgrade to Version 3.0 will disable the old connection code, please be prepared")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.updateAgent
    }
  }, [_c('translate', [_vm._v("Update Now")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeUpdateTip()
      }
    }
  }, [_c('translate', [_vm._v("Remind Me Later")])], 1)], 1)]), _vm._v(" "), _c(_vm.currentRightPanel, {
    ref: "rightComponent",
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.callback,
      "upload": _vm.onUpload,
      "onShowCloudDialog": _vm.onShowCloudDialog
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("The Aliyun Official Image Which We Support")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.checkList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "os",
      "label": _vm.attrText.os,
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": _vm.attrText.version
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.comment
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.comment, _vm.$gettext)) + "\n        ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "doc"
  }, [_c('h1', [_vm._v("《隐私协议》")]), _vm._v(" "), _c('div', {
    staticClass: "doc-contnet",
    staticStyle: {
      "padding": "5px 20px 20px",
      "font-size": "1rem"
    }
  }, [_c('hr'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("更新日期：")]), _vm._v(" 2025 年 01 月 01 日"), _c('br'), _c('strong', [_vm._v("生效日期：")]), _vm._v(" 2025 年 01 月 01 日")]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("提示条款")])]), _vm._v(" "), _c('p', [_vm._v("欢迎您使用 CloudLinker 安全运维管理平台（以下简称 “本平台” 或 “我们”）的服务。我们深知企业数据与个人信息安全对您的重要性，并将恪守 “零信任” 与 “最小必要” 原则，致力于通过技术与管理手段保障您的信息与隐私安全。CloudLinker 是由上海驻云信息科技有限公司自主研发和运营的、基于云计算的企业安全运维管理 SaaS 平台。")]), _vm._v(" "), _c('p', [_vm._v("在您开始使用本平台前，"), _c('strong', [_vm._v("请您务必仔细阅读、充分理解本《隐私协议》（以下简称 “本协议”）的全部内容，特别是以加粗或下划线形式提示您注意的条款。")]), _vm._v(" 本协议旨在帮助您了解：当您的企业组织（以下简称 “企业用户”）注册、使用本平台服务时，我们作为 “数据处理者” 如何收集、使用、存储、保护以及处理相关的信息；以及您作为企业用户的授权管理员或运维人员（以下简称 “最终用户”），您的个人信息将如何被处理。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("您的同意与确认：")]), _vm._v("当企业用户的管理员代表组织同意本协议，或您作为最终用户首次登录并使用本平台时，即表示您及您所代表的企业用户已阅读、理解并同意接受本协议的全部约束。如您不同意本协议的任何内容，您及您的企业用户应立即停止访问或使用本平台服务。")]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("一、 适用范围")])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t1.1 本协议适用于 CloudLinker 平台（包括其网站、客户端应用程序及相关的技术服务）向您提供的各项产品和服务。"), _c('br'), _vm._v("1.2 本协议不适用于其他第三方通过本平台向您提供的服务。例如，您通过本平台访问或管理的第三方云资源、数据库、应用软件等，其个人信息处理行为受该等第三方的隐私政策约束。"), _c('br'), _vm._v("1.3 作为企业级 SaaS 服务平台，本平台存在两类主要角色："), _c('br'), _vm._v("\n\t\t\t* "), _c('strong', [_vm._v("企业用户（客户）：")]), _vm._v(" 指购买并管理本平台服务的法人组织。企业用户的管理员有权配置平台策略、管理下属成员（最终用户）账号及权限。"), _c('br'), _vm._v("\n\t\t\t* "), _c('strong', [_vm._v("最终用户：")]), _vm._v(" 指经企业用户授权，使用本平台执行日常运维操作的个人成员。企业用户与其最终用户之间的权利义务关系（包括个人信息的内部管理）由双方自行约定，我们仅根据企业用户的明确指令处理最终用户的信息。"), _c('br'), _vm._v("1.4 本协议中涉及的专业术语，如 “个人信息”、“个人敏感信息”、“匿名化”、“去标识化” 等，均以《中华人民共和国个人信息保护法》及相关法律法规中的定义为准。\n\t\t")]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("二、 我们如何收集和使用信息")])]), _vm._v(" "), _c('p', [_vm._v("我们收集和使用信息遵循 “合法、正当、必要和诚信” 原则，并基于明确、合理的业务与安全目的。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("2.1 为实现平台核心功能所必需的信息")]), _c('br'), _vm._v("为向您提供安全运维审计、访问控制等核心服务，我们需收集和使用以下信息。若您拒绝提供，可能无法正常使用本平台。")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("企业用户账户信息：")]), _vm._v(" 当企业用户注册时，需提供企业名称、社会统一信用代码、管理员联系人的姓名、手机号、电子邮箱，用于创建账户、签订合同、身份验证及服务沟通。")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("最终用户账户信息：")]), _vm._v(" 企业管理员为团队成员创建账号时，需提供其"), _c('strong', [_vm._v("姓名、手机号、电子邮箱、部门、职位")]), _vm._v("等信息，用于身份标识、权限分配、登录验证及操作审计。")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("身份验证信息：")]), _vm._v(" 包括登录用户名、加密存储的密码哈希值、动态令牌（如 MFA）绑定信息。为增强安全性，我们可能支持生物特征验证（如指纹、面部识别），该等"), _c('strong', [_vm._v("生物识别信息")]), _vm._v("仅用于本地验证，"), _c('strong', [_vm._v("不会上传至我们的服务器")]), _vm._v("。")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("设备与日志信息：")]), _vm._v(" 当您访问本平台时，我们会自动收集您的 "), _c('strong', [_vm._v("IP 地址、浏览器类型、操作系统版本、登录时间、操作记录、设备标识符（如设备型号）")]), _vm._v(" 等信息。这些信息用于保障账号安全（如异常登录检测）、满足网络安全审计法律法规要求、排查故障及改善服务。")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("运维审计信息（核心数据）：")]), _vm._v(" 这是本平台提供安全审计服务的核心。当最终用户通过本平台访问目标资源（如服务器、数据库）时，我们会记录并存储"), _c('strong', [_vm._v("会话发起时间、操作的命令、文件传输行为、会话时长")]), _vm._v("等全链路运维日志。这些日志可能包含通过目标资源访问的第三方数据，我们对这些数据的处理严格限于为企业用户提供安全审计之目的。")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("2.2 为优化与保障服务所需的信息")]), _c('br'), _vm._v("为提升您的服务体验及平台安全性，我们可能会收集以下信息：")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("产品使用统计信息：")]), _vm._v(" 我们可能收集经"), _c('strong', [_vm._v("去标识化或匿名化")]), _vm._v("处理的平台功能使用频率、模块点击量等统计数据，用于分析产品使用情况，优化功能设计。")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("客服与支持信息：")]), _vm._v(" 当您联系我们的客服或提交工单时，我们会保存您的通信记录、问题描述及相关截图，以便为您提供支持并改进服务质量。")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("2.3 无需征得授权同意的情形")]), _c('br'), _vm._v("根据相关法律法规，在以下情形中，我们可能在合理的必要范围内处理您的信息而无需征得您的同意：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("为订立、履行本协议所必需；")]), _vm._v(" "), _c('li', [_vm._v("为履行法定的网络安全保护义务所必需；")]), _vm._v(" "), _c('li', [_vm._v("为应对突发公共卫生事件，或者紧急情况下为保护您或他人的生命健康和财产安全所必需；")]), _vm._v(" "), _c('li', [_vm._v("为公共利益实施新闻报道、舆论监督，在合理的范围内处理已公开的信息；")]), _vm._v(" "), _c('li', [_vm._v("法律法规规定的其他情形。")])]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("三、 我们如何存储与保护信息")])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t3.1 "), _c('strong', [_vm._v("存储期限：")]), _vm._v(" 我们仅在本协议所述目的所需的最短期限内保留您的信息。"), _c('strong', [_vm._v("运维审计日志")]), _vm._v("等用于安全追溯的信息，将根据《网络安全法》等法律法规的要求及企业用户的配置，保留不少于"), _c('strong', [_vm._v("六个月")]), _vm._v("。超出保留期限后，我们将对信息进行删除或匿名化处理。"), _c('br'), _vm._v("3.2 "), _c('strong', [_vm._v("存储位置：")]), _vm._v(" 我们承诺，在中华人民共和国境内运营中收集和产生的个人信息和重要数据，将"), _c('strong', [_vm._v("存储在中华人民共和国境内")]), _vm._v("。如需跨境传输，我们将单独征得您的同意，并严格遵守《数据出境安全评估办法》等国家规定，履行合规义务。"), _c('br'), _vm._v("3.3 "), _c('strong', [_vm._v("安全技术措施（平台核心架构优势）：")]), _c('br'), _vm._v("\n\t\t\t* "), _c('strong', [_vm._v("权限分离架构：")]), _vm._v(" CloudLinker 采用 "), _c('strong', [_vm._v("Master-Agent 分离架构")]), _vm._v("。Master 节点存储经过严格脱敏的日志、策略等元数据；Agent 部署于您的目标资源侧，负责建立加密的运维隧道。"), _c('strong', [_vm._v("我们绝不存储您的服务器、数据库等目标资源的账号密码或私钥")]), _vm._v("。此设计确保即使平台管理端出现风险，攻击者也无法直接获取您的核心资产凭证。"), _c('br'), _vm._v("\n\t\t\t* "), _c('strong', [_vm._v("加密与防篡改：")]), _vm._v(" 我们对数据传输进行全程加密（TLS/SSL），对敏感配置信息进行加密存储。运维会话录像、操作日志采用防篡改技术存储，确保审计追溯的真实性与有效性。"), _c('br'), _vm._v("3.4 "), _c('strong', [_vm._v("安全管理措施：")]), _vm._v(" 我们建立严格的内部数据访问权限审批与监控机制，对员工进行信息安全与隐私保护培训，并签署保密协议。我们定期进行安全审计与风险评估。"), _c('br'), _vm._v("3.5 "), _c('strong', [_vm._v("安全事件处置：")]), _vm._v(" 若发生个人信息安全事件，我们将按照法律法规要求，及时启动应急预案，采取补救措施，并依法向主管部门报告及向受影响的用户告知。\n\t\t")]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("四、 我们如何使用 Cookie 和同类技术")])]), _vm._v(" "), _c('p', [_vm._v("Cookie 和同类技术是互联网中的通用常用技术。当您或终端用户使用我们的相关服务时，我们可能会使用相关技术向您的设备发送一个或多个 Cookie 或匿名标识符，以收集和存储您访问、使用我们网站或系统时的信息。例如，您的浏览器名称和版本、设备型号、IP 地址、地理位置、表单填写时长和提交时间、微信 OpenID 等。我们使用 Cookie 和同类技术主要为了保障产品与服务的安全、高效运转，改善产品服务及用户体验。")]), _vm._v(" "), _c('p', [_vm._v("如果您或终端用户的浏览器或浏览器附加服务允许，您或终端用户可修改对 Cookie 的接受程度或拒绝我们的 Cookie 或不填写、提交表单。大多数浏览器均为终端用户提供了清除浏览器缓存数据的功能，您或终端用户可以在浏览器设置功能中进行相应的数据清除操作。但请注意，如果停用 Cookie，您或终端用户可能无法享受相对更佳的服务体验。")]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("五、 我们如何委托处理、共享、转让与公开披露信息")])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t5.1 "), _c('strong', [_vm._v("委托处理：")]), _vm._v(" 我们可能委托受信赖的第三方服务提供商（如云基础设施提供商、客服系统供应商）处理信息，以协助我们提供服务。我们将通过合同约束其保护信息的安全与保密，且不得用于其他任何目的。"), _c('br'), _vm._v("5.2 "), _c('strong', [_vm._v("信息共享：")]), _vm._v(" 我们"), _c('strong', [_vm._v("不会")]), _vm._v("与任何第三方共享您的业务数据（如运维日志）或个人敏感信息，除非存在以下情形之一："), _c('br'), _vm._v("\n\t\t\t* "), _c('strong', [_vm._v("获得您的明确授权或同意；")]), _c('br'), _vm._v("\n\t\t\t* "), _c('strong', [_vm._v("根据法律法规、司法程序或政府主管部门的强制性要求；")]), _c('br'), _vm._v("\n\t\t\t* "), _c('strong', [_vm._v("为保护 CloudLinker、我们的用户或公众的财产与安全免遭损害而有必要提供；")]), _c('br'), _vm._v("\n\t\t\t* "), _c('strong', [_vm._v("在法律要求或允许的范围内，就企业用户的合规性审计需求，向其提供相关的审计日志（该等日志可能包含最终用户的操作信息）。")]), _c('br'), _vm._v("5.3 "), _c('strong', [_vm._v("企业用户内部的共享：")]), _vm._v(" 最终用户使用本平台产生的所有操作日志、审计记录等信息，将根据企业管理员设定的权限，向该企业内部的指定管理员、审计员等角色开放，以满足其内部安全管理与合规审查的需要。"), _c('br'), _vm._v("5.4 "), _c('strong', [_vm._v("转让与公开披露：")]), _vm._v(" 我们"), _c('strong', [_vm._v("不会")]), _vm._v("将您的个人信息转让给任何公司、组织或个人，也不会进行公开披露，除非在涉及合并、收购或破产清算时，且新的持有方承诺继续受本协议约束，或获得您的单独同意。"), _c('br'), _vm._v("5.5 "), _c('strong', [_vm._v(" SDK 的使用：")]), _vm._v(" 我们的客户端应用程序可能会集成第三方 SDK（如用于消息推送）。我们会审慎评估其合规性。\n\t\t")]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("六、 您（最终用户）的权利")])]), _vm._v(" "), _c('p', [_vm._v("根据中国法律法规，您对自己的个人信息享有以下权利。您可以通过本协议第九条的联系方式，或通过您所在企业的管理员向我们提出请求：")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t6.1 "), _c('strong', [_vm._v("访问与复制权：")]), _vm._v(" 您有权访问、复制我们持有的您的个人信息。"), _c('br'), _vm._v("6.2 "), _c('strong', [_vm._v("更正与删除权：")]), _vm._v(" 您有权更正不准确或不完整的个人信息。在以下情形下，您可以请求删除个人信息："), _c('br'), _vm._v("\n\t\t\t* 处理目的已实现或不再必要；"), _c('br'), _vm._v("\n\t\t\t* 我们停止提供服务，或保存期限已届满；"), _c('br'), _vm._v("\n\t\t\t* 您撤回同意。"), _c('br'), _vm._v("\n\t\t\t* "), _c('strong', [_vm._v("请注意，基于《网络安全法》等法律法规的强制记录要求，运维审计日志在法定的保存期限内可能无法删除。")]), _vm._v(" 我们将在期限届满后立即删除或匿名化处理。"), _c('br'), _vm._v("6.3 "), _c('strong', [_vm._v("改变授权与注销账户：")]), _vm._v(" 您可以通过系统设置改变部分授权范围。账户注销需"), _c('strong', [_vm._v("通过您所在企业的管理员发起")]), _vm._v("。注销后，我们将停止处理您的个人信息并删除账号，但依法需留存的审计信息除外。"), _c('br'), _vm._v("6.4 "), _c('strong', [_vm._v("响应与反馈：")]), _vm._v(" 我们将在收到您清晰、可执行的请求后 "), _c('strong', [_vm._v("15 个工作日内")]), _vm._v("作出答复。为保障安全，我们可能需要先验证您的身份。对于合理的请求，原则上不收取费用。\n\t\t")]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("七、 未成年人信息保护")])]), _vm._v(" "), _c('p', [_vm._v("本平台是面向企业提供的专业工具，"), _c('strong', [_vm._v("不直接向未成年人提供产品或服务")]), _vm._v("。如果企业用户为培训等目的授权了未成年人使用，请企业用户确保已事先获得其监护人的同意。如果我们发现自己在未获得监护人同意的情况下收集了未成年人的个人信息，会设法尽快删除相关数据。")]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("八、 本协议的更新")])]), _vm._v(" "), _c('p', [_vm._v("我们可能根据业务发展、法律法规变化适时修订本协议。更新后，我们将通过平台公告、站内通知或邮件等方式进行发布。"), _c('strong', [_vm._v("若变更内容会实质性减损您的权利或增加您的义务，我们将再次征求您的同意。")]), _vm._v(" 您可以在本平台帮助中心查阅历史版本。")]), _vm._v(" "), _c('h3', [_c('strong', [_vm._v("九、 联系我们")])]), _vm._v(" "), _c('p', [_vm._v("如果您对本协议有任何疑问、意见、建议，或需要行使您的个人权利，请通过以下方式与我们联系：")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("客服邮箱：")]), _vm._v(" support@jiagouyun.com")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(" 客服热线：")]), _vm._v(" 021-50653160")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(" 在线客服：")]), _vm._v(" "), _c('a', {
    staticClass: "external",
    attrs: {
      "title": "点击链接",
      "href": "https://work.weixin.qq.com/kfid/kfc63de878415ef9ba5",
      "target": "_blank"
    }
  }, [_vm._v("点击前往")])])])])])
}]}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Config")])], 1), _vm._v(" "), (_vm.m) ? _c('div', {
    staticClass: "linux-config project-connect",
    slot: "content"
  }, [_c('div', {
    staticClass: "vertify-content"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Default Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.defaultUser),
      callback: function($$v) {
        _vm.defaultUser = $$v
      },
      expression: "defaultUser"
    }
  }, _vm._l((_vm.m.usernameList), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option,
        "value": option
      }
    })
  }))], 1)], 1), _vm._v(" "), (_vm.m.os === 'linux') ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Security Mode")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(_vm.m.safe.network_safe_mode) ? _c('div', [_c('translate', [_vm._v("Opening")])], 1) : _vm._e(), _vm._v(" "), (!_vm.m.safe.network_safe_mode) ? _c('div', [_c('translate', [_vm._v("Closed")])], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.m.os === 'linux') ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("CloudLinker Authentication")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [(_vm.m.resource.csos_check === 'open') ? _c('div', [_c('translate', [_vm._v("Opening")])], 1) : _vm._e(), _vm._v(" "), (_vm.m.resource.csos_check !== 'open') ? _c('div', [_c('translate', [_vm._v("Closed")])], 1) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("("), _c('translate', [_vm._v("When permissions is enabled, webssh does not support KEY authentication.")]), _vm._v(")")], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.m.os === 'linux') ? _c('el-row', {
    staticClass: "l-h-16"
  }, [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Destination Host Authentication")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(_vm.m.resource.autologin === 1) ? _c('div', [_c('translate', [_vm._v("Opening")])], 1) : _vm._e(), _vm._v(" "), (_vm.m.resource.autologin !== 1) ? _c('div', [_c('translate', [_vm._v("Closed")])], 1) : _vm._e()])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submiting
    },
    on: {
      "click": _vm.setDefaultUsername
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects,
      "items": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Create Group")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showRoute) ? _c('div', [_c('left-nav', {
    staticClass: "left-nav"
  }), _vm._v(" "), _c('app-header', {
    staticClass: "header",
    attrs: {
      "packageInfo": this.packageInfo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-content"
  }, [_c('router-view')], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.accountInfo
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Bind MFA")])], 1), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mfa.nextStep),
      expression: "!mfa.nextStep"
    }],
    staticClass: "detail-wrapper"
  }, [_c('div', {
    staticClass: "detail-desc"
  }, [_c('translate', [_vm._v("1. You must install the MFA application on your smart device to continue.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-desc"
  }, [_c('translate', [_vm._v("2. Common applications that support MFA on smart devices are ")]), _c('a', {
    staticStyle: {
      "color": "#20a0ff"
    },
    attrs: {
      "href": "https://promotion.aliyun.com/ntms/mobile.html",
      "target": "view_window"
    }
  }, [_c('translate', [_vm._v("Identity")])], 1), _vm._v(", Microsoft Authenticator，Google Authenticator.\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-desc"
  }, [_c('translate', [_vm._v("3. If your account has been shared by multiple people, then when you successfully bind MFA, other unbound MFA people will not be able to log in. The solution is to let other people also install the MFA application and scan the 2D code for this page, or save the 2D code picture for others to follow the sweep. But from the security best practice, we recommend that you cancel the multiplayer account.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-desc"
  }, [_c('translate', [_vm._v("4. If you can not verify for some reason, such as missing or mistakenly deleted MFA applications, you can manually unmarshal MFA binding by dialing 021-50653160.")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mfa.nextStep && _vm.mfa.securityNumForm.mfaEwm !== ''),
      expression: "mfa.nextStep && mfa.securityNumForm.mfaEwm !== ''"
    }],
    staticClass: "detail-wrapper"
  }, [_c('el-tabs', {
    attrs: {
      "active-name": _vm.mfa.activeTab
    },
    on: {
      "tab-click": _vm.onTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "first"
    }
  }, [_c('span', {
    slot: "label"
  }, [_c('translate', [_vm._v("Scan the two-dimensional code")])], 1), _vm._v(" "), _c('div', {
    staticClass: "scan-ewm"
  }, [_c('img', {
    attrs: {
      "src": _vm.mfa.securityNumForm.mfaEwm,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_c('translate', [_vm._v("Please use the MFA application on your smartphone to scan")])], 1)])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "second"
    }
  }, [_c('span', {
    slot: "label"
  }, [_c('translate', [_vm._v("Manual input")])], 1), _vm._v(" "), _c('div', {
    staticClass: "hand-get"
  }, [_c('p', [_c('translate', [_vm._v("Authentication information")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("user name")]), _vm._v(": " + _vm._s(_vm.mfa.secret.account))], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("Key")]), _vm._v(": " + _vm._s(_vm.mfa.secret.secret))], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("Please enter the above information manually in the MFA application to obtain the security code")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "securityNum"
  }, [_c('p', {
    staticClass: "tip-text"
  }, [_c('translate', [_vm._v("Please enter the two consecutive security codes you have obtained from the MFA application")]), _vm._v(":")], 1), _vm._v(" "), _c('el-form', {
    ref: "securityNumForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.mfa.securityNumForm,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.firstCode,
      "prop": "firstCode"
    }
  }, [_c('el-input', {
    staticClass: "input-class",
    attrs: {
      "placeholder": _vm.attrText.enterCode
    },
    model: {
      value: (_vm.mfa.securityNumForm.firstCode),
      callback: function($$v) {
        _vm.mfa.securityNumForm.firstCode = $$v
      },
      expression: "mfa.securityNumForm.firstCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.secondCode,
      "prop": "secondCode"
    }
  }, [_c('el-input', {
    staticClass: "input-class",
    attrs: {
      "placeholder": _vm.attrText.enterCode
    },
    model: {
      value: (_vm.mfa.securityNumForm.secondCode),
      callback: function($$v) {
        _vm.mfa.securityNumForm.secondCode = $$v
      },
      expression: "mfa.securityNumForm.secondCode"
    }
  })], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [(!_vm.mfa.nextStep) ? _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onNextStep()
      }
    }
  }, [_c('translate', [_vm._v("Next")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs.rightPanel.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.mfa.nextStep) ? _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitMfaString('securityNumForm')
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs.rightPanel.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    ref: "chart"
  })])
},staticRenderFns: []}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Configuration File")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px",
      "label-suffix": "："
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.configurationFile
    }
  }, [_vm._v(" agent_config.yaml ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.updateTime
    }
  }, [(_vm.connects) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((_vm.addForm.update_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn flex items-center",
    staticStyle: {
      "justify-content": "space-around"
    },
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isPolling),
      expression: "isPolling"
    }],
    attrs: {
      "disabled": _vm.isPolling,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.toExport()
      }
    }
  }, [_c('translate', [_vm._v("Export")])], 1), _vm._v(" "), (_vm.connects) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "disabled": _vm.isPolling,
      "action": ((_vm.baseUrl.apiUrl) + "/agent/config/import"),
      "data": {
        network_id: _vm.connects.info.id
      },
      "show-file-list": false,
      "on-success": _vm.importAndRestart,
      "on-error": _vm.importError,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isPolling),
      expression: "isPolling"
    }],
    attrs: {
      "size": "primary",
      "type": "primary"
    }
  }, [_c('translate', [_vm._v("Import And Restart")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "el-form",
    class: [
      _vm.labelPosition ? 'el-form--label-' + _vm.labelPosition : '',
      {
        'el-form--inline': _vm.inline
      }
    ]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "addInstance",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [(this.$route.query.type === 'ecs') ? _c('translate', [_vm._v("Add The Host In Bulk")]) : _vm._e(), _vm._v(" "), (this.$route.query.type === 'rds') ? _c('translate', [_vm._v("Add The Database In Bulk")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-row', {
    staticClass: "step"
  }, [_c('el-col', {
    staticClass: "step-title",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("First Step")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "step-text",
    attrs: {
      "span": 18
    }
  }, [(this.$route.query.type === 'ecs') ? _c('translate', [_vm._v("Download The Host List, Fill In The Host Information")]) : _vm._e(), _vm._v(" "), (this.$route.query.type === 'rds') ? _c('translate', [_vm._v("Download The Database List, Fill In The Database Information")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "down-load",
    attrs: {
      "href": _vm.downUrl
    },
    on: {
      "click": _vm.onDownUrl
    }
  }, [_c('translate', [_vm._v("Download")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "step"
  }, [_c('el-col', {
    staticClass: "step-title secont-title",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Second Step")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "step-text",
    attrs: {
      "span": 18
    }
  }, [(this.$route.query.type === 'ecs') ? _c('translate', [_vm._v("Upload The Host List")]) : _vm._e(), _vm._v(" "), (this.$route.query.type === 'rds') ? _c('translate', [_vm._v("Upload The Database List")]) : _vm._e(), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.$refs['upload-file'].onClick()
      }
    }
  }, [_c('file-base64', {
    ref: "upload-file",
    attrs: {
      "fileInfo": _vm.fileInfo,
      "progress": _vm.onProgress,
      "done": _vm.uploadFiles
    }
  })], 1), _vm._v(" "), (_vm.fileInfo) ? _c('ul', {
    staticClass: "upload-list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('el-row', {
    staticStyle: {
      "height": "20px"
    }
  }, [_c('el-col', {
    staticClass: "word-wrap",
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.fileInfo.name))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_vm._v(_vm._s(((_vm.fileInfo.size / 1000) + "kB")))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('a', {
    staticClass: "close-file",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onCloseFile
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-times-circle-o"
  })])])], 1), _vm._v(" "), _c('el-progress', {
    attrs: {
      "percentage": _vm.progress,
      "show-text": false,
      "stroke-width": 3
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "err-code"
  }, [_vm._v("\n              " + _vm._s(_vm.errMsg) + "\n            ")])], 1)]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.fileInfo && _vm.progress !== 100
    },
    on: {
      "click": function($event) {
        _vm.onUpload()
      }
    }
  }, [_c('translate', [_vm._v("Upload")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs.addInstance.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [(_vm.$route.query.type === 'ecs') ? _c('translate', [_vm._v("Add Host")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.type === 'rds') ? _c('translate', [_vm._v("Add Database")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.selectCluster
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "380px",
      "min-width": "100%"
    },
    attrs: {
      "value-key": "",
      "filterable": ""
    },
    on: {
      "change": _vm.onChangeCluster
    },
    model: {
      value: (_vm.selectedClusterId),
      callback: function($$v) {
        _vm.selectedClusterId = $$v
      },
      expression: "selectedClusterId"
    }
  }, [_vm._l((_vm.clusterList), function(item, index) {
    return _c('el-option', {
      key: index,
      staticStyle: {
        "width": "380px",
        "min-width": "100%"
      },
      attrs: {
        "label": item.name,
        "value": item.project_id
      }
    })
  }), _vm._v(" "), (_vm.clusterList.length < _vm.page.total) ? _c('p', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingMore),
      expression: "loadingMore"
    }],
    staticClass: "loadMore",
    on: {
      "click": _vm.loadMoreCluster
    }
  }, [_c('translate', [_vm._v("Load More")])], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.selectInstance
    }
  }, [_c('div', {
    staticClass: "filter-content"
  }, [_c('el-select', {
    staticClass: "fitler-key",
    model: {
      value: (_vm.filter.key),
      callback: function($$v) {
        _vm.filter.key = $$v
      },
      expression: "filter.key"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.name,
      "value": "q_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IP",
      "value": "q_ip"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "filter-value",
    attrs: {
      "placeholder": _vm.attrText.input
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onFilter($event)
      }
    },
    model: {
      value: (_vm.filter.value),
      callback: function($$v) {
        _vm.filter.value = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "filter.value"
    }
  }, [_c('el-button', {
    staticClass: "filter-btn",
    on: {
      "click": _vm.onFilter
    },
    slot: "append"
  }, [_c('i', {
    staticClass: "el-icon-search"
  })])], 1)], 1), _vm._v(" "), (_vm.resourceLoading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.resourceLoading),
      expression: "resourceLoading"
    }],
    staticStyle: {
      "height": "100px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.resourceList && _vm.resourceList.length) ? _c('div', {
    staticClass: "select-instance"
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.selectedResourceAll),
      callback: function($$v) {
        _vm.selectedResourceAll = $$v
      },
      expression: "selectedResourceAll"
    }
  }, [_c('translate', [_vm._v("All")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.selectedResourceIds),
      callback: function($$v) {
        _vm.selectedResourceIds = $$v
      },
      expression: "selectedResourceIds"
    }
  }, _vm._l((_vm.resourceList), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "label": item.id
      }
    }, [_vm._v("\n              " + _vm._s(((item.name) + "(" + (item.ip) + ")")) + "\n            ")])
  }))], 1) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$route.query.type === 'ecs' ? _vm.attrText.selectedInstance : _vm.attrText.selectedDatabase
    }
  }, [_c('div', {
    staticClass: "resource-selected"
  }, [(_vm.selectedResourceList.length === 0) ? _c('div', {
    staticClass: "no-select"
  }, [_c('translate', [_vm._v("No resource selected")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedResourceList), function(tag) {
    return _c('el-tag', {
      key: tag.name,
      attrs: {
        "closable": true
      },
      on: {
        "close": function($event) {
          _vm.onCloseTag(tag)
        }
      }
    }, [_vm._v("\n            " + _vm._s(((tag.name) + "/(" + (tag.ip) + ")")) + "\n          ")])
  })], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedResourceList.length === 0
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "a-upload",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-square fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Upload")])], 1)
},staticRenderFns: []}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Add Members")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    staticStyle: {
      "height": "100%"
    },
    slot: "content"
  }, [_c('el-form', {
    ref: "memberForm",
    staticClass: "memberForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.memberForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "accountId"
    }
  }, [_c('el-select', {
    ref: "members",
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": _vm.attrText.inputName,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.onChangeSelect
    },
    model: {
      value: (_vm.memberForm.accountId),
      callback: function($$v) {
        _vm.memberForm.accountId = $$v
      },
      expression: "memberForm.accountId"
    }
  }, _vm._l((_vm.memberForm.list), function(item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "select-item",
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }, [_vm._v(" " + _vm._s(item.name)), _c('br'), _vm._v(_vm._s(item.account) + " ")])
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.enableSubmitting
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Join WorkGroup")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    staticStyle: {
      "height": "100%"
    },
    slot: "content"
  }, [_c('el-form', {
    ref: "workgroupForm",
    staticClass: "workgroupForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.workgroupForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "project_ids"
    }
  }, [_c('el-select', {
    ref: "workgroups",
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": _vm.attrText.inputName,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.onChangeSelect
    },
    model: {
      value: (_vm.workgroupForm.project_ids),
      callback: function($$v) {
        _vm.workgroupForm.project_ids = $$v
      },
      expression: "workgroupForm.project_ids"
    }
  }, _vm._l((_vm.workgroupForm.list), function(item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "select-item",
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }, [_vm._v(" " + _vm._s(item.name)), _c('br'), _vm._v(_vm._s(item.account) + " ")])
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.workgroupForm.project_ids.length
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "register-wrapper"
  }, [_c('div', {
    attrs: {
      "id": "register"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("会员注册")]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm2,
      "status-icon": "",
      "rules": _vm.rules2,
      "label-width": "0"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.ruleForm2.email),
      callback: function($$v) {
        _vm.ruleForm2.email = $$v
      },
      expression: "ruleForm2.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入昵称"
    },
    model: {
      value: (_vm.ruleForm2.name),
      callback: function($$v) {
        _vm.ruleForm2.name = $$v
      },
      expression: "ruleForm2.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "contact_address "
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入联系地址"
    },
    model: {
      value: (_vm.ruleForm2.contact_address),
      callback: function($$v) {
        _vm.ruleForm2.contact_address = $$v
      },
      expression: "ruleForm2.contact_address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "tel"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.ruleForm2.tel),
      callback: function($$v) {
        _vm.ruleForm2.tel = $$v
      },
      expression: "ruleForm2.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "domain"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "团队ID，2-32位英文或数字"
    },
    model: {
      value: (_vm.ruleForm2.domain),
      callback: function($$v) {
        _vm.ruleForm2.domain = $$v
      },
      expression: "ruleForm2.domain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "full_name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "公司名称"
    },
    model: {
      value: (_vm.ruleForm2.full_name),
      callback: function($$v) {
        _vm.ruleForm2.full_name = $$v
      },
      expression: "ruleForm2.full_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "code",
    attrs: {
      "prop": "smscode"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "57%",
      "position": "relative",
      "right": "60px"
    },
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.ruleForm2.smscode),
      callback: function($$v) {
        _vm.ruleForm2.smscode = $$v
      },
      expression: "ruleForm2.smscode"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "35%",
      "height": "35px"
    },
    attrs: {
      "src": _vm.captchaSrc,
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.refresh()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "agree"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.ruleForm2.agree),
      callback: function($$v) {
        _vm.ruleForm2.agree = $$v
      },
      expression: "ruleForm2.agree"
    }
  }), _vm._v("\n\t\t\t\t\t我已阅读并同意\n\t\t\t\t\t"), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "/console.html#/user-agreement",
      "target": "_blank"
    }
  }, [_vm._v("用户协议")]), _vm._v("、\n\t\t\t\t\t"), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "/console.html#/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("隐私政策")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.ruleForm2.agree
    },
    on: {
      "click": function($event) {
        _vm.submitForm('ruleForm2')
      }
    }
  }, [_vm._v("注册")])], 1), _vm._v(" "), _c('el-form-item', [_c('p', {
    staticClass: "login",
    on: {
      "click": _vm.gotoLogin
    }
  }, [_vm._v("已有账号？立即登录")])])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      _vm.type === 'textarea' ? 'el-textarea' : 'el-input',
      _vm.size ? 'el-input--' + _vm.size : '',
      {
        'is-disabled': _vm.disabled,
        'el-input-group': _vm.$slots.prepend || _vm.$slots.append,
        'el-input-group--append': _vm.$slots.append,
        'el-input-group--prepend': _vm.$slots.prepend
      }
    ]
  }, [(_vm.type !== 'textarea') ? [(_vm.$slots.prepend) ? _c('div', {
    staticClass: "el-input-group__prepend"
  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), _vm._t("icon", [(_vm.icon) ? _c('i', {
    staticClass: "el-input__icon",
    class: [
      'el-icon-' + _vm.icon,
      _vm.onIconClick ? 'is-clickable' : ''
    ],
    on: {
      "click": _vm.handleIconClick
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.type !== 'textarea') ? _c('input', _vm._b({
    ref: "input",
    staticClass: "el-input__inner",
    attrs: {
      "autocomplete": _vm.autoComplete
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    }
  }, 'input', _vm.$props, false)) : _vm._e(), _vm._v(" "), (_vm.validating) ? _c('i', {
    staticClass: "el-input__icon el-icon-loading"
  }) : _vm._e(), _vm._v(" "), (_vm.$slots.append) ? _c('div', {
    staticClass: "el-input-group__append"
  }, [_vm._t("append")], 2) : _vm._e()] : _c('textarea', _vm._b({
    ref: "textarea",
    staticClass: "el-textarea__inner",
    style: (_vm.textareaStyle),
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    }
  }, 'textarea', _vm.$props, false))], 2)
},staticRenderFns: []}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel-add",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Add Database")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "add-form",
    attrs: {
      "model": _vm.addForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.resourceName,
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.resourceName
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.addForm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.type,
      "prop": "os"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.selectDefault
    },
    model: {
      value: (_vm.addForm.os),
      callback: function($$v) {
        _vm.addForm.os = $$v
      },
      expression: "addForm.os"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "MySQL",
      "value": "mysql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SQL Server",
      "value": "mssql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "PostgreSQL",
      "value": "postgresql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Oracle",
      "value": "oracle"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.ipAddress,
      "prop": "ipAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.defaultIpText
    },
    model: {
      value: (_vm.addForm.ipAddress),
      callback: function($$v) {
        _vm.addForm.ipAddress = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.ipAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.port,
      "prop": "port"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.port),
      callback: function($$v) {
        _vm.addForm.port = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.port"
    }
  })], 1), _vm._v(" "), (_vm.addForm.os === 'oracle') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.connectIdentifierType,
      "prop": "serviceNameType"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.serviceNameType),
      callback: function($$v) {
        _vm.addForm.serviceNameType = $$v
      },
      expression: "addForm.serviceNameType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Service Name",
      "value": "service_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SID",
      "value": "sid"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.os === 'oracle') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.connectIdentifier,
      "prop": "serviceName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.connectIdentifier
    },
    model: {
      value: (_vm.addForm.serviceName),
      callback: function($$v) {
        _vm.addForm.serviceName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.serviceName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.databaseName,
      "prop": "databaseName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.databaseName
    },
    model: {
      value: (_vm.addForm.databaseName),
      callback: function($$v) {
        _vm.addForm.databaseName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.databaseName"
    }
  }), _vm._v(" "), (_vm.supportMutipleDatabase) ? _c('p', [_c('translate', [_vm._v("Multiple database with semicolons ‘;’ ‘")]), _c('translate', {
    staticStyle: {
      "font-size": "24px",
      "vertical-align": "-webkit-baseline-middle"
    }
  }, [_vm._v("*")]), _c('translate', [_vm._v("’ indicates authorization all the database")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.username,
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.username
    },
    model: {
      value: (_vm.addForm.username),
      callback: function($$v) {
        _vm.addForm.username = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.password,
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.password,
      "type": "password"
    },
    model: {
      value: (_vm.addForm.password),
      callback: function($$v) {
        _vm.addForm.password = $$v
      },
      expression: "addForm.password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.btnDisabled
    },
    on: {
      "click": function($event) {
        _vm.onSubmitAddForm()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "view-title"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.detail.info.project_name) + "\n\t\t"), (_vm.detail.info.network_id) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.attrText.defaultWorkgroup,
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1), _vm._v(" "), (_vm.detail.info) ? _c('div', {
    staticClass: "workgroup-wrapper"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card",
      "active-name": _vm.detail.currentTab
    },
    on: {
      "tab-click": _vm.onTabClick
    }
  }, [(!_vm.detail.info.network_id && _vm.$route.query.type !== 'member' && _vm.$route.query.type !== 'group') ? _c('div', {
    staticClass: "add-ssk"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowWorkgroupDistributeInstance()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Add")])], 1), _vm._v(" "), (!_vm.detail.info.network_id) ? _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.detail.batchDel === ''
    },
    on: {
      "click": function($event) {
        _vm.batchDel(null, _vm.detail.batchDel)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Delete")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.servers,
      "name": "ecs"
    }
  }, [(_vm.detail.info && _vm.detail.list && _vm.detail.currentTab === 'ecs' && !_vm.loading) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detail.list,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectionChange
    }
  }, [(_vm.detail.isHaveNet) ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.ip) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.loginUsername
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.project_resource_login_username ? JSON.parse(scope.row.project_resource_login_username).login_username.join(';') : '-') + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.cluster
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(!_vm.detail.info.network_id ? scope.row.network_name : scope.row.project) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.os
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.type === 'LinuxServer' ? 'Linux' : 'Windows') + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.Specification,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.flavor ? scope.row.flavor : '-') + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.batchChange(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Change")])], 1), _vm._v(" "), (_vm.detail.isHaveNet) ? _c('el-button', {
          attrs: {
            "type": "text",
            "loading": scope.row.loading
          },
          on: {
            "click": function($event) {
              _vm.batchDel(scope.row, scope.row.id)
            }
          }
        }, [(!scope.row.loading) ? _c('translate', [_vm._v("Delete")]) : _vm._e()], 1) : _vm._e()]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.detail.totalPage > 10 && _vm.detail.currentTab === 'ecs') ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.detail.totalPage,
      "current-page": _vm.detail.currentPage,
      "page-size": 10
    },
    on: {
      "update:currentPage": function($event) {
        _vm.detail.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.dataBase,
      "name": "rds"
    }
  }, [(_vm.detail.info && _vm.detail.list && _vm.detail.currentTab === 'rds' && !_vm.loading) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detail.list,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectionChange
    }
  }, [(_vm.detail.isHaveNet) ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.dataBaseName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.db_name ? scope.row.db_name.join('; ') : '') + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.ipConnect
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.ip) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.cluster
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.isHaveNet ? scope.row.network_name : scope.row.project) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.type,
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 'PostgreSQLDatabase') ? _c('span', [_vm._v("PostgreSQL")]) : (scope.row.type == 'MySQLDatabase') ? _c('span', [_vm._v("MySQL")]) : (scope.row.type == 'OracleDatabase') ? _c('span', [_vm._v("Oracle")]) : _c('span', [_vm._v("SQL Server")])]
      }
    }])
  }), _vm._v(" "), (_vm.detail.isHaveNet) ? _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "loading": scope.row.loading
          },
          on: {
            "click": function($event) {
              _vm.batchDel(scope.row, scope.row.id)
            }
          }
        }, [(!scope.row.loading) ? _c('translate', [_vm._v("Delete")]) : _vm._e()], 1)]
      }
    }])
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.detail.totalPage > 10 && _vm.detail.currentTab === 'rds') ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.detail.totalPage,
      "current-page": _vm.detail.currentPage,
      "page-size": 10
    },
    on: {
      "update:currentPage": function($event) {
        _vm.detail.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.members,
      "name": "member"
    }
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowWorkgroupAddMember(_vm.detail.members)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Distribute")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.detail.batchDel === '' || _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.batchDel(null, _vm.detail.batchDel)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Delete")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "memberTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detail.members,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.account
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.account) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.type
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.is_admin ? _vm.attrText.administrator : _vm.attrText.ordinary) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "loading": scope.row.loading
          },
          on: {
            "click": function($event) {
              _vm.batchDel(scope.row, scope.row.id)
            }
          }
        }, [(!scope.row.loading) ? _c('translate', [_vm._v("Delete")]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.detail.totalPage > 10 && _vm.detail.currentTab === 'member') ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.detail.totalPage,
      "current-page": _vm.detail.currentPage,
      "page-size": 10
    },
    on: {
      "update:currentPage": function($event) {
        _vm.detail.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.group,
      "name": "group"
    }
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowWorkgroupAddGroup(_vm.detail.groups)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Distribute")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.detail.batchDel === '' || _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.batchDel(null, _vm.detail.batchDel)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Delete")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "groupTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detail.groups,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.onShowWorkgroupViewGroup(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("View")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "loading": scope.row.loading
          },
          on: {
            "click": function($event) {
              _vm.batchDel(scope.row, scope.row.id)
            }
          }
        }, [(!scope.row.loading) ? _c('translate', [_vm._v("Delete")]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.detail.totalPage > 10 && _vm.detail.currentTab === 'group') ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.detail.totalPage,
      "current-page": _vm.detail.currentPage,
      "page-size": 10
    },
    on: {
      "update:currentPage": function($event) {
        _vm.detail.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.callback
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "chartRef",
    staticClass: "echarts-container",
    style: ({
      width: _vm.width,
      height: _vm.height
    })
  })
},staticRenderFns: []}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "doc"
  }, [_c('h1', [_vm._v("《用户协议》")]), _vm._v(" "), _c('div', {
    staticClass: "doc-contnet",
    staticStyle: {
      "padding": "5px 20px 20px",
      "font-size": "1rem"
    }
  }, [_c('hr'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("更新日期：")]), _vm._v(" 2025 年 01 月 01 日"), _c('br'), _c('strong', [_vm._v("生效日期：")]), _vm._v(" 2025 年 01 月 01 日")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("前言")])]), _vm._v(" "), _c('p', [_vm._v("欢迎您使用上海驻云信息科技有限公司（以下简称 “本公司” 或 “我们”）提供的 CloudLinker 安全运维管理平台（以下简称 “本平台” 或 “CloudLinker”）。")]), _vm._v(" "), _c('p', [_vm._v("在完成注册程序或以任何方式使用本平台服务前，请您务必仔细阅读并透彻理解本《用户协议》（以下简称 “本协议”）。一旦您完成 “同意条款并注册” 或开始以其他方式使用本平台服务，即表明您已阅读、理解并同意接受本协议的全部约束。如您不同意本协议的任何内容，您应立即停止注册或使用行为。")]), _vm._v(" "), _c('p', [_vm._v("我们再次提示您审慎阅读、充分理解各条款内容，特别是"), _c('strong', [_vm._v("免除或限制责任、法律适用与争议解决")]), _vm._v("的条款，该类条款可能以加粗等形式提示您注意。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("一、 签约主体与协议范围")])]), _vm._v(" "), _c('p', [_vm._v("1.1 本协议是您（“用户” 或 “您”）与上海驻云信息科技有限公司之间就使用 CloudLinker 平台服务（包括但不限于账户注册、平台登录、运维审计、访问控制、安全合规管理等，以下简称 “本服务”）所订立的有效合约。"), _c('br'), _vm._v("1.2 本平台是一个基于云计算的企业级安全运维管理（SaaS）平台，采用 Master-Agent 分离架构。用户通过 CloudLinker Master 节点进行统一管理与审计，通过部署在目标资源侧的 Agent 建立安全运维通道。"), _c('strong', [_vm._v("我们申明，本平台不存储您目标服务器、数据库等资产的账户密码或私钥")]), _vm._v("。"), _c('br'), _vm._v("1.3 您理解并同意，我们可能不时发布针对特定功能或服务的附加条款或操作规范。该等附加条款或规范构成本协议不可分割的一部分，若其与本协议存在冲突，则以该附加条款或规范为准。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("二、 账户注册、使用与安全")])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t2.1 "), _c('strong', [_vm._v("注册资格")]), _c('br'), _vm._v("\n\t\t\t您确认，在您完成注册或以其他我们允许的方式使用本服务时，您应当是具备完全民事权利能力和行为能力的自然人、法人或非法人组织。若您代表法人或非法人组织注册，您应确保已获得该实体的充分授权。"), _c('br'), _vm._v("2.2 "), _c('strong', [_vm._v("账户注册与实名认证")]), _c('br'), _vm._v("\n\t\t\t2.2.1 您需按照注册页面提示提供准确、最新及完整的资料，包括但不限于企业名称、统一社会信用代码、管理员姓名、手机号及邮箱等。我们可能根据法律法规要求或业务需要，要求您完成进一步的身份认证（如企业资质审核）。"), _c('br'), _vm._v("\n\t\t\t2.2.2 "), _c('strong', [_vm._v("您知悉并同意，企业用户的账户将作为该组织管理其下所有成员（最终用户）及资源的唯一凭证。")]), _vm._v(" 企业管理员有权创建、管理及禁用其组织内的最终用户账户。"), _c('br'), _vm._v("\n\t\t\t2.2.3 您应妥善保管您的账户名、密码及任何动态验证码。所有通过您账户（包括企业账户及其下的最终用户账户）进行的操作，均视为您本人或您授权代表的行为，您应对此承担全部法律责任。"), _c('br'), _vm._v("2.3 "), _c('strong', [_vm._v("账户安全责任")]), _c('br'), _vm._v("\n\t\t\t2.3.1 您是自身账户安全的第一责任人。您应自行负责对最终用户的权限分配与监督，并对任何通过您账户进行的操作负责。"), _c('br'), _vm._v("\n\t\t\t2.3.2 如发现任何未经授权的账户使用行为，应立即通知我们。我们可协助您采取冻结账户、重置密码等措施，但对于采取措施前已发生的损失，我们不承担责任。"), _c('br'), _vm._v("\n\t\t\t2.3.3 您不得以任何方式出借、出租、转让或分享账户给任何第三方使用。\n\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("三、 服务内容与使用规范")])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t3.1 "), _c('strong', [_vm._v("服务提供")]), _c('br'), _vm._v("\n\t\t\t我们有权根据业务发展、技术升级或法律法规变化，不时调整、增减、暂停或终止某项服务功能，并将通过平台公告、站内信等方式通知您。"), _c('br'), _vm._v("3.2 "), _c('strong', [_vm._v("使用规范")]), _c('br'), _vm._v("\n\t\t\t您承诺使用本服务时，将遵守所有适用的中国法律法规，并保证："), _c('br'), _vm._v("\n\t\t\t3.2.1 不会利用本服务进行任何破坏网络安全、干扰网络正常服务、非法侵入他人网络或系统的行为，包括但不限于：扫描、漏洞探测、权限提升、拒绝服务攻击等。"), _c('br'), _vm._v("\n\t\t\t3.2.2 不会利用本服务存储、发布、传播任何违法违规信息，或侵犯他人知识产权、商业秘密、隐私权等合法权益的内容。"), _c('br'), _vm._v("\n\t\t\t3.2.3 不会对本服务涉及的软件、系统进行反向工程、反编译、破解或试图绕过任何安全限制。"), _c('br'), _vm._v("\n\t\t\t3.2.4 应仅为内部运维管理之目的使用本服务，不得将其用于任何形式的对外服务租赁、代理或转售（除非获得我们明确书面授权）。"), _c('br'), _vm._v("\n\t\t\t3.2.5 应遵守我们发布的全部运营规则、安全策略及技术规范。"), _c('br'), _vm._v("3.3 "), _c('strong', [_vm._v("违规处理")]), _c('br'), _vm._v("\n\t\t\t如我们根据自身判断认为您存在违反上述使用规范的行为，我们有权在不事先通知的情况下，采取包括但不限于"), _c('strong', [_vm._v("中断服务、限制功能、冻结或注销账户、删除数据")]), _vm._v("等措施。因您违规行为导致我们或第三方遭受损失的，您应承担全部赔偿责任。\n\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("四、 隐私与数据保护")])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t4.1 "), _c('strong', [_vm._v("隐私保护")]), _c('br'), _vm._v("\n\t\t\t我们高度重视您的隐私和个人信息保护。关于我们如何收集、使用、存储和保护您的个人信息，请详细阅读并遵守我们另行发布的《隐私协议》。"), _c('br'), _vm._v("4.2 "), _c('strong', [_vm._v("业务数据")]), _c('br'), _vm._v("\n\t\t\t4.2.1 您通过本平台上传、存储、处理的运维日志、配置信息、资产清单等数据（“业务数据”），其所有权和控制权归属于您。我们仅根据您的指令和为实现服务目的的必要范围进行处理。"), _c('br'), _vm._v("\n\t\t\t4.2.2 "), _c('strong', [_vm._v("我们承诺：")]), _vm._v(" (a) 不对您的业务数据进行任何非授权的访问、使用或披露；(b) 采用符合业界标准的技术和管理措施保障业务数据安全；(c) 除为履行本协议或法律强制要求外，不向任何第三方提供您的业务数据。"), _c('br'), _vm._v("\n\t\t\t4.2.3 "), _c('strong', [_vm._v("您承诺：")]), _vm._v(" (a) 对业务数据的来源及内容承担全部法律责任，确保其合法合规；(b) 自行负责对业务数据的备份，我们不对业务数据的丢失或损坏承担责任。\n\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("五、 知识产权")])]), _vm._v(" "), _c('p', [_vm._v("5.1 本平台提供的所有内容，包括但不限于软件、代码、界面设计、图形、商标、技术文档等，其知识产权及相关权利均归我们或我们的授权方所有。"), _c('br'), _vm._v("5.2 本协议并未授予您任何使用我们或第三方知识产权（包括商标、品牌）的权利。未经我们事先书面许可，您不得使用、复制、修改、创建衍生作品或公开发表前述任何内容。"), _c('br'), _vm._v("5.3 您在使用本服务过程中产生的运维日志等业务数据，其知识产权仍归您所有。您授予我们一项全球性、免费的许可，允许我们为向您提供及改进服务之目的而使用这些数据（在聚合、匿名化处理后）。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("六、 免责与责任限制")])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t6.1 "), _c('strong', [_vm._v("免责情形")]), _c('br'), _vm._v("\n\t\t\t发生下列情况导致服务中断、延迟或数据丢失的，我们将尽力减少影响，但"), _c('strong', [_vm._v("不承担任何责任")]), _vm._v("："), _c('br'), _vm._v("\n\t\t\t(a) 不可抗力，包括但不限于自然灾害、战争、动乱、政府行为等；"), _c('br'), _vm._v("\n\t\t\t(b) 基础电信运营商网络故障、电力供应中断等公共服务因素；"), _c('br'), _vm._v("\n\t\t\t(c) 您或您的最终用户的设备、软件或网络故障；"), _c('br'), _vm._v("\n\t\t\t(d) 您未遵循本协议或操作指南使用服务；"), _c('br'), _vm._v("\n\t\t\t(e) 经事先公告的例行系统维护、升级、迁移。"), _c('br'), _vm._v("6.2 "), _c('strong', [_vm._v("责任限制")]), _c('br'), _vm._v("\n\t\t\t6.2.1 在法律允许的最大范围内，"), _c('strong', [_vm._v("我们对因本协议引起或与之相关的任何间接、附带、惩罚性、特殊或后果性的损失（包括利润损失、数据丢失、商誉损害等）不承担责任")]), _vm._v("。"), _c('br'), _vm._v("\n\t\t\t6.2.2 我们基于现有技术和条件提供服务，尽最大努力保障服务的连续性和安全性，但"), _c('strong', [_vm._v("无法对所有技术风险和法律风险做出担保")]), _vm._v("。"), _c('br'), _vm._v("\n\t\t\t6.2.3 "), _c('strong', [_vm._v("特别提示：本平台作为运维安全管理工具，其作用在于规范流程、记录行为、防范风险，但不能替代您自身应建立的安全体系。")]), _vm._v(" 您应自行评估并承担使用本服务可能带来的操作及业务风险。"), _c('br'), _vm._v("\n\t\t\t6.2.4 在任何情况下，我们对您所承担的累计赔偿责任总额，"), _c('strong', [_vm._v("不应超过您就导致该索赔的服务已向我们支付的费用总额")]), _vm._v("。\n\t\t")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("七、 协议变更、中止与终止")])]), _vm._v(" "), _c('p', [_vm._v("7.1 我们有权根据国家法律法规变化及服务运营需要，适时修改本协议。修改内容将通过平台公告等方式公布。如您不同意修改后的协议，您有权停止使用服务；如您继续使用，则视为接受修改。"), _c('br'), _vm._v("7.2 您有权通过企业管理员账户申请注销服务。服务终止后，我们将根据《隐私协议》的规定处理您的数据。"), _c('br'), _vm._v("7.3 我们有权在发现您存在严重违法违规行为、长期欠费或其他我们认为有必要的情况下，单方中止或终止向您提供服务，并保留追究法律责任的权利。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("八、 法律适用与争议解决")])]), _vm._v(" "), _c('p', [_vm._v("8.1 本协议的订立、执行、解释及争议解决均适用中华人民共和国大陆地区法律。"), _c('br'), _vm._v("8.2 因本协议引起的或与本协议有关的任何争议，双方应首先友好协商解决；协商不成的，任何一方均有权将争议提交至"), _c('strong', [_vm._v("上海驻云信息科技有限公司住所地有管辖权的人民法院")]), _vm._v("诉讼解决。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("九、 其他")])]), _vm._v(" "), _c('p', [_vm._v("9.1 本协议的任何条款被认定为无效或不可执行，不影响其他条款的效力与执行。"), _c('br'), _vm._v("9.2 我们可通过网页公告、站内信、电子邮件、短信或电话等方式向您送达通知。该等通知于发送之日视为已送达。"), _c('br'), _vm._v("9.3 本协议构成您与我们之间就本服务所达成的完整协议，并取代任何先前的口头或书面约定。"), _c('br'), _vm._v("9.4 我们有权将本协议项下的权利义务全部或部分转移给我们的关联公司，但我们将确保您的权利不因此受到减损。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("感谢您选择 CloudLinker！")])])])])
}]}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Document")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ssk-wrapper"
  }, [(_vm.isAdmin.is_admin) ? _c('div', {
    staticClass: "add-ssk"
  }, [(_vm.isAdmin) ? _c('div', {
    staticClass: "file-wrapper",
    on: {
      "click": function($event) {
        _vm.$refs['file-upload'].onClick()
      }
    }
  }, [_c('file-base64', {
    ref: "file-upload",
    attrs: {
      "done": _vm.uploadFiles,
      "loading": _vm.onLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": this.document.fileIds.length === 0
    },
    on: {
      "click": function($event) {
        _vm.batchDel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Delete")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.document.list,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [(_vm.isAdmin.is_admin) ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.fileName,
      "prop": "file_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.size
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "log-list-name"
        }, [_c('p', [_vm._v(_vm._s(scope.row.file_size))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.users
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.account.account) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.date
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("moment")(scope.row.create_time * 1000, 'YYYY-MM-DD HH:mm:ss')) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('a', {
          staticClass: "down-load",
          attrs: {
            "href": _vm.document.downUrl
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onDown(scope.row.file_uuid)
            }
          }
        }, [_c('translate', [_vm._v("Download")])], 1)]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isAdmin.is_admin),
            expression: "isAdmin.is_admin"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.batchDel(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Delete")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.document.totalPage > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.document.totalPage,
      "page-size": 10,
      "current-page": _vm.document.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.document.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Application")])], 1), _vm._v(" "), _c('el-tabs', {
    staticClass: "teamTab",
    attrs: {
      "type": "card",
      "active-name": _vm.initTabName
    },
    on: {
      "tab-click": _vm.onTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "sql",
      "label": _vm.attrText.sql
    }
  }, [_c('el-tabs', {
    staticClass: "reviewTab",
    attrs: {
      "active-name": _vm.sqlActiveName
    },
    on: {
      "tab-click": _vm.sqlTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.pendingApplication,
      "name": "sqlWaitApprove"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.waitSqlApplication.loading),
      expression: "waitSqlApplication.loading"
    }],
    staticClass: "apply-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.waitSqlApplication.list,
      "stripe": ""
    },
    on: {
      "row-click": _vm.viewApprovingSqlApply
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.applyer
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.account) ? _c('img', {
          staticClass: "apply-avatar",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.account.avatar),
            "border": "0"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.account) ? _c('div', {
          staticClass: "apply-avatar-name"
        }, [_vm._v(_vm._s(scope.row.account.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resource
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.resource ? scope.row.resource.name : '-'))]), _vm._v(" "), (scope.row.project) ? _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.project.project_name ? scope.row.project.project_name : '-'))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.targetDatabase
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.database ? scope.row.database : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.general
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.comment))]), _vm._v(" "), _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.sql))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.createTime,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  })], 1), _vm._v(" "), (_vm.waitSqlApplication.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.waitSqlApplication.totalPage,
      "page-size": 10,
      "current-page": _vm.waitSqlApplication.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.waitSqlApplication.currentPage = $event
      },
      "current-change": _vm.waitSqlApplicationChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.myApproved,
      "name": "sqlApproved"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.approvedSqlApplication.loading),
      expression: "approvedSqlApplication.loading"
    }],
    staticClass: "apply-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.approvedSqlApplication.list,
      "stripe": ""
    },
    on: {
      "row-click": _vm.viewApprovedSql
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.applyer
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.account) ? _c('img', {
          staticClass: "apply-avatar",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.account.avatar),
            "border": "0"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.account) ? _c('div', {
          staticClass: "apply-avatar-name"
        }, [_vm._v(_vm._s(scope.row.account.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resource
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.resource ? scope.row.resource.name : '-'))]), _vm._v(" "), (scope.row.project) ? _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.project.project_name ? scope.row.project.project_name : '-'))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.targetDatabase
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.database ? scope.row.database : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.general
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.comment))]), _vm._v(" "), _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.sql))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.createTime,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.status,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.applyStatus[scope.row.status]
        }, [_vm._v(_vm._s(_vm.sqlApplyStatusText[scope.row.status]))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.approvedSqlApplication.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.approvedSqlApplication.totalPage,
      "page-size": 10,
      "current-page": _vm.approvedSqlApplication.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.approvedSqlApplication.currentPage = $event
      },
      "current-change": _vm.approvedSqlApplicationChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.myApplication,
      "name": "sqlMyApply"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.mySqlApplication.loading),
      expression: "mySqlApplication.loading"
    }],
    staticClass: "apply-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mySqlApplication.list,
      "stripe": ""
    },
    on: {
      "row-click": _vm.viewMySqlApply
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resourceName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.resource ? scope.row.resource.name : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.targetDatabase
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.database ? scope.row.database : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.general
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.comment))]), _vm._v(" "), _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.sql))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.createTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.updateTime,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.update_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.status,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.applyStatus[scope.row.status]
        }, [_vm._v(_vm._s(_vm.sqlApplyStatusText[scope.row.status]))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.mySqlApplication.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.mySqlApplication.totalPage,
      "page-size": 10,
      "current-page": _vm.mySqlApplication.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.mySqlApplication.currentPage = $event
      },
      "current-change": _vm.onMySqlChangePage
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "safe",
      "label": _vm.attrText.safeMode
    }
  }, [_c('el-tabs', {
    staticClass: "reviewTab",
    attrs: {
      "active-name": _vm.safeActiveName
    },
    on: {
      "tab-click": _vm.safeTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.pendingApplication,
      "name": "safeWaitApprove"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.safeApprovingList.loading),
      expression: "safeApprovingList.loading"
    }],
    staticClass: "apply-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.safeApprovingList.list,
      "stripe": ""
    },
    on: {
      "row-click": _vm.viewApprovingSafe
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.applyer
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.account) ? _c('img', {
          staticClass: "apply-avatar",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.account.avatar),
            "border": "0"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.account) ? _c('div', {
          staticClass: "apply-avatar-name"
        }, [_vm._v(_vm._s(scope.row.account.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resourceName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.resource ? scope.row.resource.name : '-'))]), _vm._v(" "), (scope.row.project) ? _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.project.project_name ? scope.row.project.project_name : '-'))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.general
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.reason) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.updateTime,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.status,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.applyStatus[scope.row.app_status]
        }, [_vm._v(_vm._s(_vm.safeApplyStatusText[scope.row.app_status]))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.safeApprovingList.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.safeApprovingList.totalPage,
      "page-size": 10,
      "current-page": _vm.safeApprovingList.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.safeApprovingList.currentPage = $event
      },
      "current-change": _vm.safeApprovingChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.myApproved,
      "name": "safeApproved"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.safeApprovedList.loading),
      expression: "safeApprovedList.loading"
    }],
    staticClass: "apply-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.safeApprovedList.list,
      "stripe": ""
    },
    on: {
      "row-click": _vm.viewApprovedSafe
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.applyer
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.account) ? _c('img', {
          staticClass: "apply-avatar",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.account.avatar),
            "border": "0"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.account) ? _c('div', {
          staticClass: "apply-avatar-name"
        }, [_vm._v(_vm._s(scope.row.account.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resourceName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.resource ? scope.row.resource.name : '-'))]), _vm._v(" "), (scope.row.project) ? _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.project.project_name ? scope.row.project.project_name : '-'))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.general
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.reason) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.updateTime,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.status,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.applyStatus[scope.row.app_status]
        }, [_vm._v(_vm._s(_vm.safeApplyStatusText[scope.row.app_status]))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.safeApprovedList.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.safeApprovedList.totalPage,
      "page-size": 10,
      "current-page": _vm.safeApprovedList.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.safeApprovedList.currentPage = $event
      },
      "current-change": _vm.safeApprovedChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.myApplication,
      "name": "safeMyApply"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.mySafeApplyList.loading),
      expression: "mySafeApplyList.loading"
    }],
    staticClass: "apply-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mySafeApplyList.list,
      "stripe": ""
    },
    on: {
      "row-click": _vm.viewMySafeApply
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resource,
      "prop": "resource.name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.resource ? scope.row.resource.name : '-'))]), _vm._v(" "), (scope.row.project) ? _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.project.project_name ? scope.row.project.project_name : '-'))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.effectiveTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.expire_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.createTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.updateTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.update_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.status,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.applyStatus[scope.row.app_status]
        }, [_vm._v(_vm._s(_vm.safeApplyStatusText[scope.row.app_status]))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.mySafeApplyList.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.mySafeApplyList.totalPage,
      "page-size": 10,
      "current-page": _vm.mySafeApplyList.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.mySafeApplyList.currentPage = $event
      },
      "current-change": _vm.onMySafeChangePage
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "onShowModal": _vm.onShowModal,
      "viewCallback": _vm.viewCallback
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.previewSQL,
      "visible": _vm.showModal.previewSQL
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal.previewSQL = $event
      }
    }
  }, [(_vm.showModal.previewSQL) ? _c('CodemirrorEditor', {
    ref: "codemirrorEditor",
    attrs: {
      "value": _vm.previewSQL
    },
    on: {
      "input": _vm.onEditorInput
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModal.previewSQL = false
      }
    }
  }, [_c('translate', [_vm._v("Confirm")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects,
      "items": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Change ClusterName")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel-add",
    attrs: {
      "datas": _vm.connects,
      "items": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitAddForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Add SSH KEY")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects,
      "hideFooter": true
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "project-header",
    slot: "header"
  }, [(_vm.connects) ? _c('span', {
    staticClass: "limit-text"
  }, [_c('translate', [_vm._v("Connect")]), _vm._v(_vm._s((" ( " + (_vm.connects.resourceName) + " )")))], 1) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading",
    slot: "content"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(89)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.m && _vm.m.os === 'linux') ? _c('div', {
    staticClass: "project-connect",
    slot: "content"
  }, [_c('div', {
    staticClass: "b-b"
  }, [_c('translate', [_vm._v("Verify Security")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [(_vm.m.selectUserData) ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("The Way Of Verification")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), (_vm.m.selectUserData.auth_type === 0) ? _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('translate', [_vm._v("Host Password")])], 1) : _vm._e(), _vm._v(" "), (_vm.m.selectUserData.auth_type === 1) ? _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v("SSH KEY")]) : _vm._e(), _vm._v(" "), (_vm.m.selectUserData.auth_type === 2) ? _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('translate', [_vm._v("CloudLinker team account password")])], 1) : _vm._e()], 1) : _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("The Way Of Verification")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), (_vm.m.resource.csos_check === 'open') ? _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('translate', [_vm._v("CloudLinker team account password")])], 1) : _vm._e(), _vm._v(" "), (_vm.m.resource.csos_check === 'close' && _vm.m.resource.autologin === 1) ? _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v("SSH KEY")]) : _vm._e(), _vm._v(" "), (_vm.m.resource.csos_check === 'close' && _vm.m.resource.autologin === 0) ? _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('translate', [_vm._v("Host Password")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.m.safe.network_safe_mode) ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Security mode")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.m.safe.safe_mode_approver && _vm.safeMode),
      expression: "!m.safe.safe_mode_approver && safeMode"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('translate', [_vm._v("Block")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.m.safe.safe_mode_approver && !_vm.safeMode),
      expression: "!m.safe.safe_mode_approver && !safeMode"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('translate', [_vm._v("Green Light")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.safeMode && (_vm.m.safe.safe_mode_application == 3 || _vm.m.safe.safe_mode_application == 4)),
      expression: "m.safe.safe_mode_approver && safeMode && (m.safe.safe_mode_application == 3 || m.safe.safe_mode_application == 4)"
    }],
    attrs: {
      "span": 2
    }
  }, [_c('translate', [_vm._v("Block")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.safeMode && _vm.m.safe.safe_mode_application == 0),
      expression: "m.safe.safe_mode_approver && safeMode && m.safe.safe_mode_application == 0"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("block/pending audit")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.safeMode && _vm.m.safe.safe_mode_application == 1),
      expression: "m.safe.safe_mode_approver && safeMode && m.safe.safe_mode_application == 1"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("block/passed")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.safeMode && _vm.m.safe.safe_mode_application == 2),
      expression: "m.safe.safe_mode_approver && safeMode && m.safe.safe_mode_application == 2"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("block/not passed")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && !_vm.safeMode && _vm.m.safe.safe_mode_application == 1),
      expression: "m.safe.safe_mode_approver && !safeMode && m.safe.safe_mode_application == 1"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("green light/passed")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.safeMode && (_vm.m.safe.safe_mode_application == 3 || _vm.m.safe.safe_mode_application == 4)),
      expression: "m.safe.safe_mode_approver && safeMode && (m.safe.safe_mode_application == 3 || m.safe.safe_mode_application == 4)"
    }],
    staticClass: "apply-safe",
    attrs: {
      "span": 6
    },
    on: {
      "click": _vm.startApply
    }
  }, [_c('translate', [_vm._v("Apply Non-security mode")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.m.safe.safe_mode_approver || (_vm.m.safe.safe_mode_approver && _vm.m.safe.safe_mode_application == 1)),
      expression: "!m.safe.safe_mode_approver || (m.safe.safe_mode_approver && m.safe.safe_mode_application == 1)"
    }],
    attrs: {
      "span": 3
    },
    on: {
      "click": _vm.switchSafeMode
    }
  }, [_c('translate', [_vm._v("Switch")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.safeMode && _vm.m.safe.safe_mode_application == 2),
      expression: "m.safe.safe_mode_approver && safeMode && m.safe.safe_mode_application == 2"
    }],
    staticClass: "apply-safe",
    attrs: {
      "span": 3
    },
    on: {
      "click": _vm.startApply
    }
  }, [_c('translate', [_vm._v("Reapply")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Default Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    on: {
      "change": function($event) {
        _vm.changeUser()
      }
    },
    model: {
      value: (_vm.defaultUser),
      callback: function($$v) {
        _vm.defaultUser = $$v
      },
      expression: "defaultUser"
    }
  }, _vm._l((_vm.m.usernameList), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option,
        "value": option
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "b-b b-t"
  }, [_c('translate', [_vm._v("Connection Information")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [(_vm.agentUpdateTip) ? _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#fda541",
      "font-size": "14px",
      "top": "2px"
    }
  }), _vm._v(" "), _c('translate', {
    staticStyle: {
      "color": "#fda541"
    }
  }, [_vm._v("The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible")])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Host")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.m.agent.host))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.m.agent.host),
      expression: "m.agent.host",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Port")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.m.agent.ssh_port))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (String(_vm.m.agent.ssh_port)),
      expression: "String(m.agent.ssh_port)",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.userName),
      expression: "userName",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("IP Whitelist")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "ip-whitelist",
    attrs: {
      "span": 13
    }
  }, [_vm._l((_vm.getAllowIPList(_vm.m.allow_ip)), function(ip, ipIndex) {
    return _c('div', {
      key: ipIndex
    }, [_vm._v(_vm._s(ip))])
  }), _vm._v(" "), (!_vm.m.allow_ip) ? _c('span', [_vm._v("-")]) : _vm._e()], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    on: {
      "click": _vm.modifyCode
    }
  }, [_c('translate', [_vm._v("Change")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("SSH Command")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.ssh_link
    }
  }, [_vm._v(_vm._s(_vm.codeStr))])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.codeStr),
      expression: "codeStr",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Connect Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    staticClass: "linux-username",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.defaultUser),
      callback: function($$v) {
        _vm.defaultUser = $$v
      },
      expression: "defaultUser"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    class: {
      safeConnect: !_vm.safeMode
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.connectHost($event)
      }
    }
  }, [_c('translate', [_vm._v("Connect")])], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.m && _vm.m.os === 'win32' && _vm.connects.agentVersion >= '2.4.0') ? _c('div', {
    staticClass: "project-connect",
    slot: "content"
  }, [_c('div', {
    staticClass: "b-b"
  }, [_c('translate', [_vm._v("Verify Security")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("The Way Of Verification")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('translate', [_vm._v("Login to the host using the local password")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Default Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    on: {
      "change": function($event) {
        _vm.changeUser()
      }
    },
    model: {
      value: (_vm.defaultUser),
      callback: function($$v) {
        _vm.defaultUser = $$v
      },
      expression: "defaultUser"
    }
  }, _vm._l((_vm.m.usernameList), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option,
        "value": option
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "b-b b-t"
  }, [_c('translate', [_vm._v("Connection Information")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [(_vm.agentUpdateTip) ? _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#fda541",
      "font-size": "14px",
      "top": "2px"
    }
  }), _vm._v(" "), _c('translate', {
    staticStyle: {
      "color": "#fda541"
    }
  }, [_vm._v("The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible")])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Host")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.winHost))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.m.winHost),
      expression: "m.winHost",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Port")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.agent.rdp_port))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (String(_vm.m.agent.rdp_port)),
      expression: "String(m.agent.rdp_port)",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.userName),
      expression: "userName",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("IP Whitelist")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15 ip-whitelist",
    attrs: {
      "span": 12
    }
  }, [_vm._l((_vm.getAllowIPList(_vm.m.allow_ip)), function(ip, ipIndex) {
    return _c('div', {
      key: ipIndex
    }, [_vm._v(_vm._s(ip))])
  }), _vm._v(" "), (!_vm.m.allow_ip) ? _c('span', [_vm._v("-")]) : _vm._e()], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    on: {
      "click": _vm.modifyCode
    }
  }, [_c('translate', [_vm._v("Change")])], 1)])], 1), _vm._v(" "), (_vm.m.agent.webrdp_port) ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Connect Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    staticClass: "linux-username",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.defaultUser),
      callback: function($$v) {
        _vm.defaultUser = $$v
      },
      expression: "defaultUser"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    class: {
      safeConnect: !_vm.safeMode
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.connectWinHost($event)
      }
    }
  }, [_c('translate', [_vm._v("Connect")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.m && _vm.m.os === 'win32' && _vm.connects.agentVersion < '2.4.0') ? _c('div', {
    staticClass: "project-connect",
    slot: "content"
  }, [_c('div', {
    staticClass: "b-b"
  }, [_c('translate', [_vm._v("Connection Information")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [(_vm.agentUpdateTip) ? _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#fda541",
      "font-size": "14px",
      "top": "2px"
    }
  }), _vm._v(" "), _c('translate', {
    staticStyle: {
      "color": "#fda541"
    }
  }, [_vm._v("The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible")])], 1) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "l-h-36 text-center"
  }, [_c('translate', [_vm._v("Use the RDP client to connect to the current host")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center l-h-36"
  }, [_c('span', [_c('translate', [_vm._v("Please confirm")])], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://files.cloudcare.cn/rdpclient.exe"
    }
  }, [_c('translate', [_vm._v("download")])], 1), _vm._v(" "), _c('span', [_c('translate', [_vm._v("and installed the RDP client (Windows only support)")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-center l-h-36"
  }, [_c('translate', [_vm._v("Fill in the client with Code and connect to your Windows server.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-h-36 text-center"
  }, [_c('span', [_vm._v("Code")]), _vm._v(" "), _c('span', [_vm._v(":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.m.code))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("IP Whitelist")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15 ip-whitelist",
    attrs: {
      "span": 12
    }
  }, [_vm._l((_vm.getAllowIPList(_vm.m.allow_ip)), function(ip, ipIndex) {
    return _c('div', {
      key: ipIndex
    }, [_vm._v(_vm._s(ip))])
  }), _vm._v(" "), (!_vm.m.allow_ip) ? _c('span', [_vm._v("-")]) : _vm._e()], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    on: {
      "click": _vm.modifyCode
    }
  }, [_c('translate', [_vm._v("Change")])], 1)])], 1), _vm._v(" "), _c('img', {
    staticClass: "win-image",
    attrs: {
      "src": "/static/images/screen_windows.png",
      "alt": "demo"
    }
  })], 1), _vm._v(" "), _c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.m && (_vm.m.os === 'mysql' || _vm.m.os === 'mssql' || _vm.m.os === 'postgresql' || _vm.m.os === 'oracle')) ? _c('div', {
    staticClass: "project-connect",
    slot: "content"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(89)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "b-b"
  }, [_c('translate', [_vm._v("Connection Information")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [(_vm.agentUpdateTip) ? _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#fda541",
      "font-size": "14px",
      "top": "2px"
    }
  }), _vm._v(" "), _c('translate', {
    staticStyle: {
      "color": "#fda541"
    }
  }, [_vm._v("The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible")])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Host")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.sqlHost))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.m.sqlHost),
      expression: "m.sqlHost",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Port")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.sqlport))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.m.sqlport),
      expression: "m.sqlport",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), (_vm.m.os === 'oracle') ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Connection identifier type")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.serviceNameType === 'sid' ? 'SID' : 'Service Name'))])], 1) : _vm._e(), _vm._v(" "), (_vm.m.os === 'oracle') ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Service Name / SID")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.serviceName))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.m.serviceName),
      expression: "m.serviceName",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.code))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.m.code),
      expression: "m.code",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("IP Whitelist")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15 ip-whitelist",
    attrs: {
      "span": 12
    }
  }, [_vm._l((_vm.getAllowIPList(_vm.m.allow_ip)), function(ip, ipIndex) {
    return _c('div', {
      key: ipIndex
    }, [_vm._v(_vm._s(ip))])
  }), _vm._v(" "), (!_vm.m.allow_ip) ? _c('span', [_vm._v("-")]) : _vm._e()], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    on: {
      "click": _vm.modifyCode
    }
  }, [_c('translate', [_vm._v("Change")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Note:")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [(_vm.m.os === 'mysql') ? _c('translate', [_vm._v("Use MySQL client to connect to the current database")]) : _vm._e(), _vm._v(" "), (_vm.m.os === 'mssql') ? _c('translate', [_vm._v("Use SQL Server client to connect to the current database")]) : _vm._e(), _vm._v(" "), (_vm.m.os === 'postgresql') ? _c('translate', [_vm._v("Use PostgreSQL client to connect to the current database")]) : _vm._e(), _vm._v(" "), (_vm.m.os === 'oracle') ? _c('translate', [_vm._v("Oracle only supports web connections")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    on: {
      "click": _vm.sqlConnect
    }
  }, [_c('translate', [_vm._v("Connect")])], 1)])], 1)], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-group-detail"
  }, [_c('div', {
    staticClass: "view-title"
  }, [(_vm.workgroup && _vm.workgroup.project_name) ? _c('span', [_vm._v(_vm._s(_vm.workgroup.project_name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "view-content"
  }, [_c('div', {
    staticClass: "csos-tabs"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card",
      "active-name": _vm.activeTabName
    },
    on: {
      "tab-click": _vm.onClickTab
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "clearfix panel-search"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.attrText.select
    },
    model: {
      value: (_vm.searchForm.type),
      callback: function($$v) {
        _vm.searchForm.type = $$v
      },
      expression: "searchForm.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.name,
      "value": "q_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IP",
      "value": "q_ip"
    }
  })], 1)], 1), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "icon": "search",
      "disabled": !_vm.searchForm.type,
      "on-icon-click": _vm.onSearch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearch($event)
      }
    },
    model: {
      value: (_vm.searchForm.key),
      callback: function($$v) {
        _vm.searchForm.key = $$v
      },
      expression: "searchForm.key"
    }
  })], 1), _vm._v(" "), (_vm.activeTabName == 'ecs') ? _c('a', {
    attrs: {
      "href": _vm.downloadUrl
    },
    on: {
      "click": _vm.exportAnsible
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("Export Ansible")])], 1) : _vm._e()])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.instance,
      "name": "ecs"
    }
  }, [_c('div', [(_vm.instances !== '') ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.instances
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": " ",
      "width": "30"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": scope.row.type === 'LinuxServer' ? 'Linux' : 'Windows',
            "placement": "top"
          }
        }, [_c('img', {
          attrs: {
            "src": ("../../../static/images/" + (scope.row.type === 'LinuxServer' ? 'linux' : 'win32') + ".png"),
            "alt": ""
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ip",
      "label": "IP"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.cluster
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.agent_status === 1 && scope.row.network_name) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.available,
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "tip-point available"
        })]) : _vm._e(), _vm._v(" "), (scope.row.agent_status !== 1 && scope.row.network_name) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.unavailable,
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "tip-point unavailable"
        })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.network_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.avaliableCode
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.hideStr(scope.row.code)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": _vm.attrText.onlineSession
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.online_connections < 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowConnections(scope.row)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.online_connections) + "\n\t\t\t\t\t\t\t\t\t\t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": _vm.attrText.connectLog
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.logs < 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowConnectionLogs(scope.row)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.logs) + "\n\t\t\t\t\t\t\t\t\t\t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "360",
      "label": _vm.attrText.action
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.agent_status !== 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowConnect(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Connect")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.agent_status !== 1
          },
          on: {
            "click": function($event) {
              _vm.linuxConfig(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Config")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.agent_status !== 1
          },
          on: {
            "click": function($event) {
              _vm.manageCode(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Manage Code")])], 1)]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.instancesList.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.instancesList.totalPage,
      "page-size": 10,
      "current-page": _vm.instancesList.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.instancesList.currentPage = $event
      },
      "current-change": _vm.changeProjectPage
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.database,
      "name": "rds"
    }
  }, [(_vm.databases !== '') ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.databases
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": " ",
      "width": "35"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 'PostgreSQLDatabase') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "PostgreSQL",
            "placement": "top"
          }
        }, [_c('img', {
          attrs: {
            "src": "../../../static/images/postgresql.png",
            "width": "16",
            "height": "16",
            "alt": ""
          }
        })]) : (scope.row.type == 'OracleDatabase') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Oracle",
            "placement": "top"
          }
        }, [_c('img', {
          attrs: {
            "src": "../../../static/images/oracle.png",
            "width": "16",
            "height": "12",
            "alt": ""
          }
        })]) : (scope.row.type == 'MySQLDatabase') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MySQL",
            "placement": "top"
          }
        }, [_c('img', {
          attrs: {
            "src": "../../../static/images/mysql.png",
            "alt": "",
            "width": "16",
            "height": "16"
          }
        })]) : _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "SQL Server",
            "placement": "top"
          }
        }, [_c('img', {
          attrs: {
            "src": "../../../static/images/mssql.png",
            "width": "16",
            "height": "14",
            "alt": ""
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.dabaseName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.db_name), function(dbName, dbIndex) {
          return _c('div', {
            key: dbIndex,
            staticClass: "database-name-item"
          }, [_vm._v(_vm._s(dbName))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ip",
      "label": "IP"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.cluster
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.agent_status === 1 && scope.row.network_name) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.available,
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "tip-point available"
        })]) : _vm._e(), _vm._v(" "), (scope.row.agent_status !== 1 && scope.row.network_name) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.unavailable,
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "tip-point unavailable"
        })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.network_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.avaliableCode
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.hideStr(scope.row.code)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": _vm.attrText.connectLog
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.logs < 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowConnectionLogs(scope.row)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.logs) + "\n\t\t\t\t\t\t\t\t\t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "300",
      "label": _vm.attrText.action
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.agent_status !== 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowConnect(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Connect")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.agent_status !== 1
          },
          on: {
            "click": function($event) {
              _vm.manageCode(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Manage Code")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.agent_status !== 1
          },
          on: {
            "click": function($event) {
              _vm.check(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Check")])], 1), _vm._v(" "), (scope.row.status === 2) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.startApply(scope.row, 'rds')
            }
          }
        }, [_c('translate', [_vm._v("Start Application")])], 1) : _vm._e()]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.databasesList.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.databasesList.totalPage,
      "page-size": 10,
      "current-page": _vm.databasesList.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.databasesList.currentPage = $event
      },
      "current-change": _vm.changeProjectPage
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    ref: "rightPanel",
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "reloadTunnelCode": _vm.reloadTunnelCode,
      "reloadOnlineConnects": _vm.reloadOnlineConnects,
      "reloadPojectResource": _vm.reloadPojectResource,
      "onShowModal": _vm.onShowModal,
      "startApplyEvent": _vm.startApplyEvent,
      "onViewLog": _vm.handleViewLog
    }
  })], 1), _vm._v(" "), (_vm.m) ? _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.createCode,
      "visible": _vm.showModal.showCreateModal,
      "custom-class": "create-code-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal.showCreateModal = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": _vm.formLabelWidth
    }
  }, [(_vm.m && _vm.m.safe.network_safe_mode && _vm.m.resource.resource_type === 'ecs' && _vm.m.extension.os === 'linux') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.securityMode
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.m.safe.safe_mode_approver && _vm.m.safeMode),
      expression: "!m.safe.safe_mode_approver && m.safeMode"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Block")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.m.safe.safe_mode_approver && !_vm.m.safeMode),
      expression: "!m.safe.safe_mode_approver && !m.safeMode"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Green Light")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.m.safeMode && (_vm.m.safe.safe_mode_application == 3 || _vm.m.safe.safe_mode_application == 4)),
      expression: "m.safe.safe_mode_approver && m.safeMode && (m.safe.safe_mode_application == 3 || m.safe.safe_mode_application == 4)"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(" : Block")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.m.safeMode && _vm.m.safe.safe_mode_application == 0),
      expression: "m.safe.safe_mode_approver && m.safeMode && m.safe.safe_mode_application == 0"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": block/pending audit")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.m.safeMode && _vm.m.safe.safe_mode_application == 1),
      expression: "m.safe.safe_mode_approver && m.safeMode && m.safe.safe_mode_application == 1"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": block/passed")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.m.safeMode && _vm.m.safe.safe_mode_application == 2),
      expression: "m.safe.safe_mode_approver && m.safeMode && m.safe.safe_mode_application == 2"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": block/not passed")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && !_vm.m.safeMode && _vm.m.safe.safe_mode_application == 1),
      expression: "m.safe.safe_mode_approver && !m.safeMode && m.safe.safe_mode_application == 1"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": green light/passed")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.m.safeMode && (_vm.m.safe.safe_mode_application == 3 || _vm.m.safe.safe_mode_application == 4)),
      expression: "m.safe.safe_mode_approver && m.safeMode && (m.safe.safe_mode_application == 3 || m.safe.safe_mode_application == 4)"
    }],
    staticClass: "apply-safe",
    attrs: {
      "span": 6
    },
    on: {
      "click": function($event) {
        _vm.startApplyEvent(_vm.clickRowInfo.m, 'ecs')
      }
    }
  }, [_c('translate', [_vm._v("Apply Non-security mode")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.m.safe.safe_mode_approver || (_vm.m.safe.safe_mode_approver && _vm.m.safe.safe_mode_application == 1)),
      expression: "!m.safe.safe_mode_approver || (m.safe.safe_mode_approver && m.safe.safe_mode_application == 1)"
    }],
    attrs: {
      "span": 3
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.switchSafeMode($event)
      }
    }
  }, [_c('translate', [_vm._v("Switch")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.m.safeMode && _vm.m.safe.safe_mode_application == 2),
      expression: "m.safe.safe_mode_approver && m.safeMode && m.safe.safe_mode_application == 2"
    }],
    staticClass: "apply-safe",
    attrs: {
      "span": 3
    },
    on: {
      "click": function($event) {
        _vm.startApplyEvent(_vm.clickRowInfo.m, 'ecs')
      }
    }
  }, [_c('translate', [_vm._v("Reapply")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.validTime
    }
  }, [_c('el-select', {
    staticClass: "code-input",
    on: {
      "change": _vm.changeExpireTime
    },
    model: {
      value: (_vm.m.expire),
      callback: function($$v) {
        _vm.m.expire = $$v
      },
      expression: "m.expire"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "day",
      "label": _vm.attrText.oneDay
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "month",
      "label": _vm.attrText.oneMonth
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "custom",
      "label": _vm.attrText.customize
    }
  })], 1), _vm._v(" "), (_vm.m.expire === 'custom') ? _c('el-date-picker', {
    staticClass: "code-input",
    attrs: {
      "type": "datetime",
      "picker-options": _vm.safeOptions,
      "placeholder": _vm.attrText.selectDate
    },
    model: {
      value: (_vm.m.validTime),
      callback: function($$v) {
        _vm.m.validTime = $$v
      },
      expression: "m.validTime"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.m) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.allowIP
    }
  }, [_c('el-input', {
    staticClass: "code-input",
    attrs: {
      "placeholder": _vm.attrText.tipallowIp
    },
    on: {
      "change": _vm.ipInput
    },
    model: {
      value: (_vm.m.client_ip),
      callback: function($$v) {
        _vm.m.client_ip = $$v
      },
      expression: "m.client_ip"
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "div"
    }
  }, [_vm._v("IPs are separated by semicolons \";\", and there is no limit if left blank")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showModal.showCreateModal = false
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.m.saving,
      "disabled": _vm.m.validTime < new Date().getTime()
    },
    on: {
      "click": _vm.createCode
    }
  }, [_c('translate', [_vm._v("Confirm")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.modifyCode,
      "visible": _vm.showModal.modifyCreateModal,
      "custom-class": "modify-code-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal.modifyCreateModal = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": _vm.formLabelWidth
    }
  }, [(_vm.codeObj && _vm.codeObj.safe.network_safe_mode && _vm.codeObj && _vm.codeObj.resource.resource_type === 'ecs' && _vm.codeObj.os === 'linux') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.securityMode,
      "prop": "safeMode"
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode),
      expression: "!codeObj.safe.safe_mode_approver && codeObj.safeMode"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Block")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeObj.safe.safe_mode_approver && !_vm.codeObj.safeMode),
      expression: "!codeObj.safe.safe_mode_approver && !codeObj.safeMode"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Green Light")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode && (_vm.codeObj.safe.safe_mode_application == 3 || _vm.codeObj.safe.safe_mode_application == 4)),
      expression: "codeObj.safe.safe_mode_approver && codeObj.safeMode && (codeObj.safe.safe_mode_application == 3 || codeObj.safe.safe_mode_application == 4)"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(" : Block")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode && _vm.codeObj.safe.safe_mode_application == 0),
      expression: "codeObj.safe.safe_mode_approver && codeObj.safeMode && codeObj.safe.safe_mode_application == 0"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": block/pending audit")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode && _vm.codeObj.safe.safe_mode_application == 1),
      expression: "codeObj.safe.safe_mode_approver && codeObj.safeMode && codeObj.safe.safe_mode_application == 1"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": block/passed")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode && _vm.codeObj.safe.safe_mode_application == 2),
      expression: "codeObj.safe.safe_mode_approver && codeObj.safeMode && codeObj.safe.safe_mode_application == 2"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v(": block/not passed")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && !_vm.codeObj.safeMode && _vm.codeObj.safe.safe_mode_application == 1),
      expression: "codeObj.safe.safe_mode_approver && !codeObj.safeMode && codeObj.safe.safe_mode_application == 1"
    }],
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v(": green light/passed")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode && (_vm.codeObj.safe.safe_mode_application == 3 || _vm.codeObj.safe.safe_mode_application == 4)),
      expression: "codeObj.safe.safe_mode_approver && codeObj.safeMode && (codeObj.safe.safe_mode_application == 3 || codeObj.safe.safe_mode_application == 4)"
    }],
    staticClass: "apply-safe",
    attrs: {
      "span": 6
    },
    on: {
      "click": function($event) {
        _vm.startApplyEvent(_vm.clickRowInfo.m, 'ecs')
      }
    }
  }, [_c('translate', [_vm._v("Apply Non-security mode")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeObj.safe.safe_mode_approver || (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safe.safe_mode_application == 1)),
      expression: "!codeObj.safe.safe_mode_approver || (codeObj.safe.safe_mode_approver && codeObj.safe.safe_mode_application == 1)"
    }],
    attrs: {
      "span": 3
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.switchModifySafeMode($event)
      }
    }
  }, [_c('translate', [_vm._v("Switch")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeObj.safe.safe_mode_approver && _vm.codeObj.safeMode && _vm.codeObj.safe.safe_mode_application == 2),
      expression: "codeObj.safe.safe_mode_approver && codeObj.safeMode && codeObj.safe.safe_mode_application == 2"
    }],
    staticClass: "apply-safe",
    attrs: {
      "span": 3
    },
    on: {
      "click": function($event) {
        _vm.startApplyEvent(_vm.clickRowInfo.m, 'ecs')
      }
    }
  }, [_c('translate', [_vm._v("Reapply")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.validTime,
      "prop": "validTime"
    }
  }, [_c('el-select', {
    staticClass: "code-input",
    on: {
      "change": _vm.modifyCodeSelectChange
    },
    model: {
      value: (_vm.modifyTime.type),
      callback: function($$v) {
        _vm.modifyTime.type = $$v
      },
      expression: "modifyTime.type"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "day",
      "label": _vm.attrText.oneDay
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "month",
      "label": _vm.attrText.oneMonth
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "custom",
      "label": _vm.attrText.customize
    }
  })], 1), _vm._v(" "), (_vm.modifyTime.type === 'custom') ? _c('el-date-picker', {
    staticClass: "code-input",
    attrs: {
      "type": "datetime",
      "picker-options": _vm.safeOptions,
      "placeholder": _vm.attrText.selectDate
    },
    on: {
      "change": function($event) {
        _vm.modifyTime.isSelectTime = false
      }
    },
    model: {
      value: (_vm.modifyTime.time),
      callback: function($$v) {
        _vm.modifyTime.time = $$v
      },
      expression: "modifyTime.time"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modifyTime.isSelectTime) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.attrText.selectDate))]) : _vm._e()], 1), _vm._v(" "), (_vm.codeObj) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.allowIP
    }
  }, [_c('el-input', {
    staticClass: "code-input",
    attrs: {
      "placeholder": _vm.attrText.tipallowIp
    },
    model: {
      value: (_vm.codeObj.allow_ip),
      callback: function($$v) {
        _vm.codeObj.allow_ip = $$v
      },
      expression: "codeObj.allow_ip"
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "div"
    }
  }, [_vm._v("IPs are separated by semicolons \";\", and there is no limit if left blank")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showModal.modifyCreateModal = false
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modifyCode
    }
  }, [_c('translate', [_vm._v("Confirm")])], 1)], 1)], 1), _vm._v(" "), (_vm.tempObj) ? _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.temporaryAuthorize,
      "visible": _vm.showModal.showTempModal
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal.showTempModal = $event
      },
      "close": function($event) {
        _vm.closeTempModal()
      }
    }
  }, [_c('el-form', {
    ref: "tempObjForm",
    attrs: {
      "label-width": "200px",
      "model": _vm.tempObj,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    staticClass: "m-b-none",
    attrs: {
      "label": _vm.attrText.validTime,
      "prop": "expire_time"
    }
  }, [_c('el-select', {
    staticClass: "code-input",
    model: {
      value: (_vm.tempObj.expire_time),
      callback: function($$v) {
        _vm.tempObj.expire_time = $$v
      },
      expression: "tempObj.expire_time"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "30",
      "label": ("30 " + (_vm.attrText.minutes))
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "60",
      "label": ("60 " + (_vm.attrText.minutes))
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "120",
      "label": ("120 " + (_vm.attrText.minutes))
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "customize",
      "label": _vm.attrText.customize
    }
  })], 1)], 1), _vm._v(" "), (_vm.tempObj.expire_time == 'customize') ? _c('el-form-item', {
    staticClass: "p-l-200",
    attrs: {
      "prop": "expire_time_customize"
    }
  }, [_c('el-input', {
    staticClass: "code-input-time",
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.tempObj.expire_time_customize),
      callback: function($$v) {
        _vm.tempObj.expire_time_customize = _vm._n($$v)
      },
      expression: "tempObj.expire_time_customize"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("minutes")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "p-l-200"
  }, [_c('translate', [_vm._v("This expiration time is not limited by the SSH or RDP timeout set on the host.")])], 1), _vm._v(" "), (!_vm.tempObj.showNewTemp && _vm.tempObj.autologin) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.userName,
      "prop": "username"
    }
  }, [_c('el-select', {
    staticClass: "code-input",
    model: {
      value: (_vm.tempObj.username),
      callback: function($$v) {
        _vm.tempObj.username = $$v
      },
      expression: "tempObj.username"
    }
  }, [_c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tempObj.usernameList.length > 1),
      expression: "tempObj.usernameList.length > 1"
    }],
    attrs: {
      "value": "",
      "label": _vm.attrText.select
    }
  }), _vm._v(" "), _vm._l((_vm.tempObj.usernameList), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "value": user
      }
    })
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.tempObj.showNewTemp || (!_vm.tempObj.showNewTemp && !_vm.tempObj.autologin)) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.serverUser,
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "code-input",
    attrs: {
      "auto-complete": "new-password"
    },
    on: {
      "input": _vm.onTempCredentialChange
    },
    model: {
      value: (_vm.tempObj.username),
      callback: function($$v) {
        _vm.tempObj.username = $$v
      },
      expression: "tempObj.username"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tempObj.showNewTemp || (!_vm.tempObj.showNewTemp && !_vm.tempObj.autologin)) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.serverPsw,
      "prop": "psw"
    }
  }, [_c('div', {
    staticClass: "psw-test-wrap"
  }, [_c('el-input', {
    staticClass: "code-input-psw",
    attrs: {
      "auto-complete": "new-password",
      "type": "password"
    },
    on: {
      "input": _vm.onTempCredentialChange
    },
    model: {
      value: (_vm.tempObj.psw),
      callback: function($$v) {
        _vm.tempObj.psw = $$v
      },
      expression: "tempObj.psw"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "test-btn",
    attrs: {
      "loading": _vm.tempTesting
    },
    on: {
      "click": _vm.testPasswordConnection
    }
  }, [(_vm.tempTesting) ? _c('span') : _c('translate', [_vm._v("Test")])], 1), _vm._v(" "), (_vm.tempTestPassed) ? _c('span', {
    staticClass: "test-status test-status-success"
  }, [_c('i', {
    staticClass: "el-icon-circle-check"
  }), _vm._v(" "), _c('translate', [_vm._v("Test passed")])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.allowIP,
      "prop": "allow_ip"
    }
  }, [_c('el-input', {
    staticClass: "code-input",
    attrs: {
      "pattern": _vm.allowIPPattern,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.tempObj.allow_ip),
      callback: function($$v) {
        _vm.tempObj.allow_ip = $$v
      },
      expression: "tempObj.allow_ip"
    }
  }), _vm._v(" "), _c('translate', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(" IPs are separated by semicolons \";\", and there is no limit if left blank ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeTempModal()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.tempObj.saving,
      "disabled": _vm.tempNeedTest && !_vm.tempTestPassed
    },
    on: {
      "click": _vm.tempAuth
    }
  }, [_c('translate', [_vm._v("Confirm")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.temporaryAuthorize,
      "visible": _vm.showModal.showTempModalSuccess
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal.showTempModalSuccess = $event
      },
      "close": _vm.closeTempModalSuccess
    }
  }, [(_vm.tempWinObj) ? _c('el-form', {
    attrs: {
      "label-width": _vm.formLabelWidth
    }
  }, [(_vm.tempWinObj.type === 'linux') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.connectAddress
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tempWinObj.linkUrl))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.tempWinObj.linkUrl),
      expression: "tempWinObj.linkUrl",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }]
  }, [_c('translate', [_vm._v("Copy")])], 1)]), _vm._v(" "), (_vm.tempWinObj.tmpPsw) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.temporarypsw
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tempWinObj.tmpPsw))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.tempWinObj.tmpPsw),
      expression: "tempWinObj.tmpPsw",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }]
  }, [_c('translate', [_vm._v("Copy")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-l-note"
  }, [_c('translate', [_vm._v("Note: The link is only available once (Valid time:")]), _vm._v(_vm._s(_vm.tempObj.expire_time === 'customize' ? Math.round(_vm.tempObj.expire_time_customize) : _vm.tempObj.expire_time) + " "), _c('translate', [_vm._v("minutes)")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tempWinObj.type === 'win32') ? _c('div', {
    staticClass: "temp-win"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Host")]), _vm._v(" "), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 8
    }
  }, [_vm._v(_vm._s(_vm.tempWinObj.host))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.tempWinObj.host),
      expression: "tempWinObj.host",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }]
  }, [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Temporary user")]), _vm._v(" "), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 8
    }
  }, [_vm._v(_vm._s(_vm.tempWinObj.tmpUsername))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.tempWinObj.tmpUsername),
      expression: "tempWinObj.tmpUsername",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }]
  }, [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Temporary password")]), _vm._v(" "), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 8
    }
  }, [_vm._v(_vm._s(_vm.tempWinObj.tmpPsw))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.tempWinObj.tmpPsw),
      expression: "tempWinObj.tmpPsw",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }]
  }, [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('translate', [_vm._v("Note: The user and password are only available once (Valid time:")]), _vm._v(_vm._s(_vm.tempObj.expire_time === 'customize' ? Math.round(_vm.tempObj.expire_time_customize) : _vm.tempObj.expire_time) + " "), _c('translate', [_vm._v("minutes)")])], 1)], 1) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.previewSQL,
      "visible": _vm.showModal.previewSQL
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal.previewSQL = $event
      }
    }
  }, [(_vm.showModal.previewSQL) ? _c('CodemirrorEditor', {
    ref: "codemirrorEditor",
    attrs: {
      "value": _vm.verifyData.sql
    },
    on: {
      "input": _vm.onEditorInput
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModal.previewSQL = false
      }
    }
  }, [_c('translate', [_vm._v("Confirm")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "日志内容查看",
      "visible": _vm.viewLogShow,
      "width": "90%",
      "top": "20px"
    },
    on: {
      "update:visible": function($event) {
        _vm.viewLogShow = $event
      },
      "close": _vm.closeViewLogDialog
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.viewLogLoading),
      expression: "viewLogLoading"
    }],
    staticClass: "log-view-content",
    attrs: {
      "element-loading-text": "加载日志内容中..."
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.logContent))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.logContent),
      expression: "logContent",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.viewLogShow = false
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    staticClass: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "purchase-content"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentLan === 'zh_CN' ? '../../static/images/purchase.png' : '../../static/images/purchase_en.png',
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Setting Team Group")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "groupForm",
    attrs: {
      "model": _vm.setting,
      "rules": _vm.rules,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.name,
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.setting.name),
      callback: function($$v) {
        _vm.setting.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "setting.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.note,
      "prop": "note"
    }
  }, [_c('el-input', {
    staticClass: "right-panel-textarea",
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.setting.note),
      callback: function($$v) {
        _vm.setting.note = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "setting.note"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.setting.isCanSubmit
    },
    on: {
      "click": function($event) {
        _vm.onSubmitForm()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workgroup"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Work Group List")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "search-header"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowCreateWorkgroupAdd()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Created New Workgrounp")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-select', {
    staticClass: "searchSelect",
    attrs: {
      "placeholder": _vm.attrText.select
    },
    on: {
      "change": _vm.clearSearchInput
    },
    model: {
      value: (_vm.search.condition),
      callback: function($$v) {
        _vm.search.condition = $$v
      },
      expression: "search.condition"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.name,
      "value": "q_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IP",
      "value": "q_ip"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "disabled": !_vm.search.condition
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearch()
      }
    },
    model: {
      value: (_vm.search.name),
      callback: function($$v) {
        _vm.search.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "search.name"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    on: {
      "click": _vm.onSearch
    }
  }, [_c('translate', [_vm._v("Search")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.workGroup.list,
      "show-header": false,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'settingWorkgroupDetail',
              params: {
                id: scope.row.id
              },
              query: {
                type: 'ecs'
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('span', {
          staticClass: "project-name"
        }, [_vm._v(_vm._s(scope.row.name))])]), _vm._v(" "), (scope.row.network_id !== -1) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.defaultWorkgroup,
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-globe",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "desc"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.desc ? scope.row.desc : '-') + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.getTranTest(scope.row.resource_count)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.getTranMember(scope.row.account_count)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "text-right",
    attrs: {
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'settingWorkgroupDetail',
              params: {
                id: scope.row.id
              },
              query: {
                type: 'ecs'
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('translate', [_vm._v("Details")])], 1)], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowCreateWorkgroupSetting(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Setting")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.network_id !== -1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteResource(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Delete")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.workGroup.totalPage > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.workGroup.totalPage,
      "page-size": 10,
      "current-page": _vm.workGroup.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.workGroup.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": function($event) {
        _vm.getWorkGroupList(_vm.workGroup.currentPage)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Manage Code")])], 1), _vm._v(" "), _c('div', {
    staticClass: "manage-code",
    slot: "content"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.m
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.member
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "account-photo",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.account.avatar)
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.account.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Code"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type === 'tmp_share') ? _c('span', [_vm._v(_vm._s(_vm.attrText.temporary))]) : (_vm.$store.getters.account.id == scope.row.account.id) ? _c('span', [_vm._v(_vm._s(scope.row.code))]) : _c('span', [_vm._v(_vm._s(_vm.hideStr(scope.row.code)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.allowIP
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((_vm.getAllowIPList(scope.row.allow_ip)), function(ip, ipIndex) {
          return _c('div', {
            key: ipIndex,
            staticClass: "ip-space"
          }, [_vm._v(_vm._s(ip))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": _vm.attrText.startEndTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "white-space": "normal"
          }
        }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
          class: scope.row.expire_time < _vm.newTime ? 'over-time' : '',
          staticStyle: {
            "white-space": "normal"
          }
        }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.expire_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.type !== 'tmp_share') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.modifyCode(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Change")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "loading": scope.row.saving
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteCode(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Delete")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.connects) ? _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.canCreateStatus || _vm.connects.agent_status !== 1
    },
    on: {
      "click": _vm.showCreateModal
    }
  }, [_c('translate', [_vm._v("Create")])], 1), _vm._v(" "), (_vm.connects.resource_type === 'ecs') ? _c('el-button', {
    attrs: {
      "disabled": _vm.connects.agent_status !== 1,
      "type": "primary"
    },
    on: {
      "click": _vm.showTempModal
    }
  }, [_c('translate', [_vm._v("Temporary Authorize")])], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Team")])], 1), _vm._v(" "), _c('el-tabs', {
    staticClass: "teamTab",
    attrs: {
      "type": "card",
      "active-name": _vm.activeTab
    },
    on: {
      "tab-click": _vm.onTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "members",
      "label": _vm.attrText.member
    }
  }, [_c('div', {
    staticClass: "ssk-wrapper"
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowTeamAddMember()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('translate', [_vm._v("Add Member")])], 1), _vm._v(" "), _c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Batch Import")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-select', {
    staticClass: "condition-search",
    attrs: {
      "placeholder": _vm.attrText.select
    },
    on: {
      "change": _vm.initInput
    },
    model: {
      value: (_vm.search.user),
      callback: function($$v) {
        _vm.search.user = $$v
      },
      expression: "search.user"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.name,
      "value": "q_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.account,
      "value": "q_account"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "icon": "search",
      "disabled": _vm.search.user === '',
      "on-icon-click": _vm.onSearchMemberClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearchMemberClick($event)
      }
    },
    model: {
      value: (_vm.search.val),
      callback: function($$v) {
        _vm.search.val = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "search.val"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.team.list,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.displayNickname,
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.account,
      "prop": "account"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.type,
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "log-list-name"
        }, [(scope.row.is_admin == 0) ? _c('p', [_vm._v(_vm._s(_vm.attrText.ordinary))]) : _vm._e(), _vm._v(" "), (scope.row.is_admin == 1) ? _c('p', [_vm._v(_vm._s(_vm.attrText.admin))]) : _vm._e(), _vm._v(" "), (scope.row.is_admin == 2) ? _c('p', [_vm._v(_vm._s(_vm.attrText.auditAdmin))]) : _vm._e(), _vm._v(" "), (scope.row.is_admin == 3) ? _c('p', [_vm._v(_vm._s(_vm.attrText.optAdmin))]) : _vm._e(), _vm._v(" "), (scope.row.is_admin == 4) ? _c('p', [_vm._v(_vm._s(_vm.attrText.safeAdmin))]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.status
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status) ? _c('p', {
          style: ({
            color: '#F56C6C'
          })
        }, [_vm._v("禁用")]) : _c('p', {
          style: ({
            color: '#67C23A'
          })
        }, [_vm._v("启用")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'settingTeamAccountWorkgroup',
              params: {
                id: scope.row.id
              },
              query: {
                type: 'workgroup',
                accountName: scope.row.name
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('translate', [_vm._v("Project")])], 1)], 1), _vm._v(" "), (_vm.account.is_admin == 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.resetMFA(scope.row, scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Reset MFA")])], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowTeamMemberSetting(scope.row, scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Setting")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.id === _vm.$store.getters.account.id || scope.row.is_admin === 1 || _vm.$store.getters.account.is_admin != 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.changeStatus(scope.row, scope.$index)
            }
          }
        }, [(scope.row.status) ? _c('translate', [_vm._v("Enable")]) : _c('translate', [_vm._v("Disable")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "loading": scope.row.deleting,
            "disabled": scope.row.id === _vm.$store.getters.account.id || scope.row.is_admin === 1 || _vm.$store.getters.account.is_admin != 1
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.deleteMember(scope.row)
            }
          }
        }, [(!scope.row.deleting) ? _c('translate', [_vm._v("Delete")]) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.team.totalPage > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.team.totalPage,
      "page-size": 10,
      "current-page": _vm.team.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.team.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "group",
      "label": _vm.attrText.group
    }
  }, [_c('div', {
    staticClass: "ssk-wrapper"
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowTeamAddGroup()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('translate', [_vm._v("Create Group")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": _vm.attrText.groupInputName
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearchGroupClick()
      }
    },
    model: {
      value: (_vm.searchGroup.val),
      callback: function($$v) {
        _vm.searchGroup.val = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "searchGroup.val"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    on: {
      "click": _vm.onSearchGroupClick
    }
  }, [_c('translate', [_vm._v("Search")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.group.list,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name,
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'settingTeamGroupDetail',
              params: {
                id: scope.row.id
              },
              query: {
                name: scope.row.name
              }
            }
          }
        }, [_c('a', {
          staticClass: "el-button--text"
        }, [_vm._v(_vm._s(scope.row.name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.comment,
      "prop": "note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.note ? scope.row.note : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.membersNumber,
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "log-list-name"
        }, [_c('p', [_vm._v(_vm._s(scope.row.member_count || 0))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'settingTeamGroupWorkgroup',
              params: {
                id: scope.row.id
              },
              query: {
                type: 'workgroup',
                groupName: scope.row.name
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('translate', [_vm._v("Project")])], 1)], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onShowTeamGroupSetting(scope.row, scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Setting")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "loading": scope.row.deleting
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.deleteGroup(scope.row, scope.row.member_count)
            }
          }
        }, [(!scope.row.deleting) ? _c('translate', [_vm._v("Delete")]) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.group.totalPage > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.group.totalPage,
      "page-size": 10,
      "current-page": _vm.group.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.group.currentPage = $event
      },
      "current-change": _vm.onChangeGroupPage
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    staticClass: "team-set",
    attrs: {
      "name": "settings",
      "label": _vm.attrText.Setting
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "teamSetForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.settingForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    staticClass: "fixed-text",
    attrs: {
      "label": _vm.attrText.code
    }
  }, [_vm._v(_vm._s(_vm.settingForm.domain))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.teamName,
      "prop": "fullName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.settingForm.fullName),
      callback: function($$v) {
        _vm.settingForm.fullName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "settingForm.fullName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.person,
      "prop": "contactName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.settingForm.contactName),
      callback: function($$v) {
        _vm.settingForm.contactName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "settingForm.contactName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.phone,
      "prop": "contactPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel"
    },
    model: {
      value: (_vm.settingForm.contactPhone),
      callback: function($$v) {
        _vm.settingForm.contactPhone = $$v
      },
      expression: "settingForm.contactPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.address,
      "prop": "contactAddress"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.settingForm.contactAddress),
      callback: function($$v) {
        _vm.settingForm.contactAddress = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "settingForm.contactAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.ip,
      "prop": "ipWhitelist"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.mutip
    },
    model: {
      value: (_vm.settingForm.ipWhitelist),
      callback: function($$v) {
        _vm.settingForm.ipWhitelist = $$v
      },
      expression: "settingForm.ipWhitelist"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.adminIP,
      "prop": "adminWhitelist"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.mutip
    },
    model: {
      value: (_vm.settingForm.adminWhitelist),
      callback: function($$v) {
        _vm.settingForm.adminWhitelist = $$v
      },
      expression: "settingForm.adminWhitelist"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.codeIPWhitelist
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-switch', {
    staticStyle: {
      "margin-right": "16px"
    },
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.settingForm.codeIpWhitelist),
      callback: function($$v) {
        _vm.settingForm.codeIpWhitelist = $$v
      },
      expression: "settingForm.codeIpWhitelist"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("The creator's IP is added automatically; only whitelisted IPs can connect")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.loginHoldTime,
      "prop": "session_expire_time"
    }
  }, [_c('div', {
    staticClass: "loginHoldTime"
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "max": 480,
      "min": 30,
      "placeholder": _vm.attrText.takesLoginAgain
    },
    model: {
      value: (_vm.settingForm.session_expire_time),
      callback: function($$v) {
        _vm.settingForm.session_expire_time = $$v
      },
      expression: "settingForm.session_expire_time"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("minutes")])], 1)]), _vm._v(" "), (_vm.$store.getters.account.unique_id) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.adminUser
    }
  }, [_c('el-select', {
    staticClass: "settingSelect",
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.settingForm.adminUser),
      callback: function($$v) {
        _vm.settingForm.adminUser = $$v
      },
      expression: "settingForm.adminUser"
    }
  }, _vm._l((_vm.adminUserList), function(user, index) {
    return _c('el-option', {
      key: index,
      staticStyle: {
        "height": "50px"
      },
      attrs: {
        "value": user.account,
        "label": user.account
      }
    }, [_c('p', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.account))])])
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.teamToken
    }
  }, [_c('div', {
    staticClass: "teamToken"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.teamToken,
      "readonly": ""
    },
    model: {
      value: (_vm.settingForm.domain_token),
      callback: function($$v) {
        _vm.settingForm.domain_token = $$v
      },
      expression: "settingForm.domain_token"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.updateTeamToken
    }
  }, [_c('translate', [_vm._v("Update")])], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.bindedWorkSpace
    }
  }, [_c('div', {
    staticClass: "bindedWorkSpace"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请先绑定工作空间",
      "readonly": ""
    },
    model: {
      value: (_vm.settingForm.bindedWorkSpaceName),
      callback: function($$v) {
        _vm.settingForm.bindedWorkSpaceName = $$v
      },
      expression: "settingForm.bindedWorkSpaceName"
    }
  }), _vm._v(" "), (_vm.settingForm.bindedWorkSpaceId) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.unbindWorkSpace
    }
  }, [_c('translate', [_vm._v("Unbind")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.mfa
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.settingForm.iscompanyMfaOpen),
      callback: function($$v) {
        _vm.settingForm.iscompanyMfaOpen = $$v
      },
      expression: "settingForm.iscompanyMfaOpen"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.compelChangePassword
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-switch', {
    staticStyle: {
      "margin-right": "16px"
    },
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.settingForm.iscompanyPassword),
      callback: function($$v) {
        _vm.settingForm.iscompanyPassword = $$v
      },
      expression: "settingForm.iscompanyPassword"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("Team members request password changes every 90 days")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.loginLockout
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-switch', {
    staticStyle: {
      "margin-right": "16px"
    },
    attrs: {
      "on-text": "",
      "off-text": "",
      "disabled": ""
    },
    model: {
      value: (_vm.settingForm.loginLockout),
      callback: function($$v) {
        _vm.settingForm.loginLockout = $$v
      },
      expression: "settingForm.loginLockout"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("If you enter the password incorrectly 10 times in a row, your account will be locked for 1 hour")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.passwordStrength
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.settingForm.passwordStrength),
      callback: function($$v) {
        _vm.settingForm.passwordStrength = $$v
      },
      expression: "settingForm.passwordStrength"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_c('translate', [_vm._v("weak")])], 1), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_c('translate', [_vm._v("medium")])], 1), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 2
    }
  }, [_c('translate', [_vm._v("strong")])], 1)], 1), _vm._v(" "), _c('translate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settingForm.passwordStrength === 0),
      expression: "settingForm.passwordStrength === 0"
    }],
    staticStyle: {
      "margin-top": "15px",
      "max-width": "350px"
    },
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Team member password complexity is not required")]), _vm._v(" "), _c('translate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settingForm.passwordStrength === 1),
      expression: "settingForm.passwordStrength === 1"
    }],
    staticStyle: {
      "margin-top": "15px",
      "max-width": "350px"
    },
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("The password must be at least 6 characters long and must contain two types of three:uppercase letters, lowercase letters, and special characters. (the existing member will be forced to change the password when logging in. Please notify the relevant member to change the password. )")]), _vm._v(" "), _c('translate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settingForm.passwordStrength === 2),
      expression: "settingForm.passwordStrength === 2"
    }],
    staticStyle: {
      "margin-top": "15px",
      "max-width": "350px"
    },
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters. (the existing member will be forced to change the password when logging in. Please notify the relevant member to change the password. )")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "set-btn",
    attrs: {
      "type": "primary",
      "disabled": !_vm.settingForm.isCanSubmit
    },
    on: {
      "click": function($event) {
        _vm.onSubmitSet()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    staticClass: "sso",
    attrs: {
      "name": "sso",
      "label": "SSO"
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "ssoSetForm",
    staticClass: "sso-form",
    attrs: {
      "model": _vm.ssoForm,
      "rules": _vm.ssoRules,
      "label-width": "180px",
      "show-message": false
    }
  }, [_c('el-form-item', {
    staticClass: "fixed-text",
    attrs: {
      "label": _vm.attrText.sso
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.ssoForm.is_open),
      callback: function($$v) {
        _vm.ssoForm.is_open = $$v
      },
      expression: "ssoForm.is_open"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fixed-text",
    attrs: {
      "label": _vm.attrText.is_account_password
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "disabled": !_vm.ssoForm.is_open
    },
    model: {
      value: (_vm.ssoForm.is_account_password),
      callback: function($$v) {
        _vm.ssoForm.is_account_password = $$v
      },
      expression: "ssoForm.is_account_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.type,
      "prop": "sso_type"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": !_vm.ssoForm.is_open
    },
    model: {
      value: (_vm.ssoForm.sso_type),
      callback: function($$v) {
        _vm.ssoForm.sso_type = $$v
      },
      expression: "ssoForm.sso_type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "SAML2.0",
      "value": "SAML"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.id_vendor,
      "prop": "id_vendor"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.id_vendor,
      "maxlength": 64,
      "show-word-limit": "",
      "clearable": "",
      "disabled": !_vm.ssoForm.is_open
    },
    model: {
      value: (_vm.ssoForm.id_vendor),
      callback: function($$v) {
        _vm.ssoForm.id_vendor = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "ssoForm.id_vendor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.WriterMetadataDocument,
      "prop": "fileList"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.uploadAction,
      "drag": "",
      "accept": "text/xml",
      "limit": 1,
      "on-success": _vm.uploadSuccess,
      "on-remove": _vm.removeFile,
      "file-list": _vm.ssoForm.fileList,
      "disabled": !_vm.ssoForm.is_open
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('p', [_c('translate', [_vm._v(" Only the xml file format is supported. The file size should not exceed 5MB and a maximum of 1 file can be uploaded. ")])], 1)])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.login_url,
      "prop": "login_url"
    }
  }, [_c('div', {
    staticClass: "copy-text"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.login_url,
      "disabled": ""
    },
    model: {
      value: (_vm.ssoForm.login_url),
      callback: function($$v) {
        _vm.ssoForm.login_url = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "ssoForm.login_url"
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.ssoForm.login_url),
      expression: "ssoForm.login_url",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "type": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-clone fa-sm"
  })])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.assertion_url,
      "prop": "assertion_url"
    }
  }, [_c('div', {
    staticClass: "copy-text"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.assertion_url,
      "disabled": ""
    },
    model: {
      value: (_vm.ssoForm.assertion_url),
      callback: function($$v) {
        _vm.ssoForm.assertion_url = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "ssoForm.assertion_url"
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.ssoForm.assertion_url),
      expression: "ssoForm.assertion_url",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "type": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-clone fa-sm"
  })])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.access_white_list,
      "prop": "access_white_list"
    }
  }, [_c('div', {
    staticClass: "copy-text"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 10
      },
      "resize": "none",
      "placeholder": "支持输入多个邮箱域名地址，例如：cloudcare.cn，多个域名用逗号分隔。",
      "disabled": !_vm.ssoForm.is_open
    },
    model: {
      value: (_vm.ssoForm.access_white_list),
      callback: function($$v) {
        _vm.ssoForm.access_white_list = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "ssoForm.access_white_list"
    }
  }), _vm._v(" "), _c('el-tooltip', [_c('div', {
    slot: "content"
  }, [_c('translate', [_vm._v("Emails with the same domain suffix have the permission to obtain the single sign-on access link for this identity provider. When users log in for the first time, the system will dynamically create a CloudLinker member account, eliminating the need to create it in the system in advance.")]), _c('br'), _c('translate', [_vm._v("The default account permission is: Ordinary Member")])], 1), _vm._v(" "), _c('i', {
    staticClass: "fa fa-question-circle fa-lg"
  })])], 1)]), _vm._v(" "), _c('el-button', {
    staticClass: "set-btn",
    attrs: {
      "type": "primary",
      "disabled": !_vm.ssoForm.isCanSubmit
    },
    on: {
      "click": function($event) {
        _vm.onSubmitSetSSO()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.callback
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alarm-notify"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Alarm Notify")])], 1), _vm._v(" "), _c('div', {
    staticClass: "alarm-notify-container"
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.onSelectIsRead
    },
    model: {
      value: (_vm.search.is_read),
      callback: function($$v) {
        _vm.search.is_read = $$v
      },
      expression: "search.is_read"
    }
  }), _vm._v(" "), _c('translate', {
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("Unread")]), _vm._v(" "), _c('el-select', {
    staticClass: "account-search",
    attrs: {
      "placeholder": _vm.attrText.select
    },
    on: {
      "change": _vm.onSelectRole
    },
    model: {
      value: (_vm.search.role),
      callback: function($$v) {
        _vm.search.role = $$v
      },
      expression: "search.role"
    }
  }, _vm._l((_vm.selectOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm._f("translate")(item.text, _vm.$gettext),
        "value": item.val
      }
    })
  })), _vm._v(" "), _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "icon": "search",
      "placeholder": _vm.attrText.input,
      "disabled": _vm.search.isDisabled
    },
    model: {
      value: (_vm.search.account),
      callback: function($$v) {
        _vm.search.account = $$v
      },
      expression: "search.account"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "date-picker",
    attrs: {
      "type": "date",
      "placeholder": _vm.attrText.startTime,
      "align": "right"
    },
    model: {
      value: (_vm.search.startTime),
      callback: function($$v) {
        _vm.search.startTime = $$v
      },
      expression: "search.startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "date-picker",
    attrs: {
      "type": "date",
      "placeholder": _vm.attrText.endTime,
      "align": "right"
    },
    model: {
      value: (_vm.search.endTime),
      callback: function($$v) {
        _vm.search.endTime = $$v
      },
      expression: "search.endTime"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "btn-class",
    on: {
      "click": _vm.onSearch
    }
  }, [_c('translate', [_vm._v("Search")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "btn-class",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportLog
    }
  }, [_c('translate', [_vm._v("Export")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.log.list,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.operationTime,
      "prop": "operation_time",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.users,
      "prop": "account_name",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.sourceIp,
      "prop": "con_ip"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.operationObj,
      "prop": "resource_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.workGroup,
      "prop": "project_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.connectType,
      "prop": "way"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.eventDesc
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "effect": "light",
            "placement": "top",
            "popper-class": "alarm-trigger-tooltip",
            "open-delay": 200
          }
        }, [_c('div', {
          staticClass: "alarm-trigger-tooltip-content",
          slot: "content"
        }, [_vm._v(_vm._s(scope.row.command || '-'))]), _vm._v(" "), _c('p', {
          staticClass: "ellipsis-mult"
        }, [_vm._v(_vm._s(scope.row.command || '-'))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.triggerStrategy
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "effect": "light",
            "placement": "top",
            "popper-class": "alarm-trigger-tooltip",
            "open-delay": 200
          }
        }, [_c('div', {
          staticClass: "alarm-trigger-tooltip-content",
          slot: "content"
        }, [_vm._v(_vm._s(scope.row.match_command || '-'))]), _vm._v(" "), _c('p', {
          staticClass: "trigger-strategy-text"
        }, [_vm._v(_vm._s(scope.row.match_command || '-'))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.norifyObj
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.notice_accounts) ? _c('div', _vm._l((JSON.parse(scope.row.notice_accounts)), function(i) {
          return _c('p', {
            key: i
          }, [_vm._v(_vm._s(i))])
        })) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.status
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_read) ? _c('span', [_c('translate', [_vm._v("Read")])], 1) : _c('span', {
          staticStyle: {
            "color": "#fda541"
          }
        }, [_c('translate', [_vm._v("Unread")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.toShowAlarmDetail(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [(_vm.log.totalPage > 10) ? _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.log.totalPage,
      "current-page": _vm.log.currentPage,
      "page-size": 10
    },
    on: {
      "update:currentPage": function($event) {
        _vm.log.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.getAlarmLog
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "instance-setting"
  }, [_c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.resourceId
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitForm
    }
  }, [_c('div', {
    slot: "header"
  }, [(!_vm.moreForm.moreSet) ? _c('translate', [_vm._v("Basic information")]) : _vm._e(), _vm._v(" "), (_vm.moreForm.moreSet) ? _c('translate', [_vm._v("Authentication settings")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [(!_vm.moreForm.moreSet) ? _c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.resourceName,
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.parentId
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.addForm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.innerIp
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.addForm.ipAddress) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.os
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.addForm.os === 'win32' ? 'Windows' : 'Linux') + "\n\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.userName
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.parentId
    },
    on: {
      "change": _vm.onUsername
    },
    model: {
      value: (_vm.addForm.username),
      callback: function($$v) {
        _vm.addForm.username = $$v
      },
      expression: "addForm.username"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("Multiple users with semicolons ‘;’")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.port
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.parentId
    },
    on: {
      "change": _vm.onPort
    },
    model: {
      value: (_vm.addForm.port),
      callback: function($$v) {
        _vm.addForm.port = $$v
      },
      expression: "addForm.port"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.flavor
    }
  }, [_c('div', {
    staticClass: "add-textarea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": _vm.parentId
    },
    model: {
      value: (_vm.addForm.flavor),
      callback: function($$v) {
        _vm.addForm.flavor = $$v
      },
      expression: "addForm.flavor"
    }
  })], 1)]), _vm._v(" "), (_vm.addForm.os === 'win32') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.clipboard
    }
  }, [_c('el-switch', {
    staticStyle: {
      "margin-right": "16px"
    },
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.addForm.clipboard),
      callback: function($$v) {
        _vm.addForm.clipboard = $$v
      },
      expression: "addForm.clipboard"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.parentId) ? _c('a', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.moreForm.moreSet = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("More")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.moreForm.moreSet) ? _c('el-form', {
    ref: "moreForm",
    attrs: {
      "model": _vm.moreForm,
      "label-width": "120px",
      "show-message": false
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "10px",
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_c('translate', [_vm._v("Host Authentication Mode")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.moreForm.availability,
      "empty-text": _vm.attrText.emptyText
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.accountName,
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(scope.row.username) + "\n\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.onUpload({
                isUpload: true,
                username: scope.row.username,
                resourceId: _vm.resourceId
              })
            }
          }
        }, [_c('translate', [_vm._v("Upload")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.availability
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.$store.getters.cluster.detail.info.agent && _vm.$store.getters.cluster.detail.info.agent.status !== 1
          },
          on: {
            "click": function($event) {
              _vm.onTestKeyAvaliable(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Test")])], 1), _vm._v(" "), (scope.row.test_result === 'pending') ? _c('i', {
          staticClass: "el-icon-loading"
        }) : _vm._e(), _vm._v(" "), (scope.row.test_result === 'disable' || scope.row.test_result === 'enable') ? _c('span', {
          staticClass: "badge",
          class: scope.row.test_result ? (scope.row.test_result !== 'disable' ? 'available' : 'unavailable') : 'unavailable'
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.test_result ? (scope.row.test_result !== 'disable' ? _vm.attrText.available : _vm.attrText.unavailable) : _vm.attrText.unavailable) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.authenticationMode
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-radio-group', {
          model: {
            value: (scope.row.auth_type),
            callback: function($$v) {
              scope.row.auth_type = $$v
            },
            expression: "scope.row.auth_type"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 0
          }
        }, [_c('translate', [_vm._v("Host Password")])], 1), _vm._v(" "), (_vm.addForm.os == 'linux') ? _c('el-radio', {
          attrs: {
            "label": 1,
            "disabled": !scope.row.test_result || ['disable', 'pending'].includes(scope.row.test_result)
          }
        }, [_vm._v("SSH KEY")]) : _vm._e(), _vm._v(" "), (_vm.addForm.os == 'win32') ? _c('el-radio', {
          attrs: {
            "label": 1,
            "disabled": !scope.row.test_result || ['disable', 'pending'].includes(scope.row.test_result)
          }
        }, [_c('translate', [_vm._v("Password-Free Login")])], 1) : _vm._e(), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 2,
            "disabled": !scope.row.test_result || ['disable', 'pending'].includes(scope.row.test_result)
          }
        }, [_c('translate', [_vm._v("Team Account")])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('translate', [_vm._v("Node:")])], 1), _vm._v(" "), _c('p', [(_vm.addForm.os == 'linux') ? _c('translate', [_vm._v(" For SSH KEY authentication or team account authentication on the target host, ensure that the host user password has been verified. ")]) : _vm._e(), _vm._v(" "), (_vm.addForm.os == 'win32') ? _c('translate', [_vm._v(" For password free login or team account authentication on the target host, ensure that the host user password has been verified. ")]) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isCansubmit || _vm.parentId
    },
    on: {
      "click": function($event) {
        _vm.onSubmitForm()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cloudlinker-stat-page"
  }, [_c('div', {
    staticClass: "overview-cards"
  }, [_c('div', {
    staticClass: "overview-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("资源")]), _vm._v(" "), _c('div', {
    staticClass: "card-value assess-color"
  }, [_vm._v(_vm._s(_vm.overviewData.resources))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("工作组")]), _vm._v(" "), _c('div', {
    staticClass: "card-value work-color"
  }, [_vm._v(_vm._s(_vm.overviewData.projects))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("集群")]), _vm._v(" "), _c('div', {
    staticClass: "card-value cluster-color"
  }, [_vm._v(_vm._s(_vm.overviewData.networks))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("成员")]), _vm._v(" "), _c('div', {
    staticClass: "card-value member-color"
  }, [_vm._v(_vm._s(_vm.overviewData.accounts))])])]), _vm._v(" "), _c('div', {
    staticClass: "stat-row"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("活跃用户数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.conn_account_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("被访问资源数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.resource_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("总连接次数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.conn_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("指令告警次数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.notice_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("日均连接次数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.avg_days_conn_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("总连接时长")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.conn_time) + "小时")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("日均连接时长")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.avg_days_conn_time) + "小时")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("平均连接时长")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.avg_conn_time) + "小时")])])]), _vm._v(" "), _c('div', {
    staticClass: "chart-group"
  }, [_c('Echarts', {
    attrs: {
      "type": "pie",
      "options": _vm.connectCountPie,
      "width": "40%",
      "height": "300px"
    }
  }), _vm._v(" "), _c('Echarts', {
    attrs: {
      "type": "line",
      "options": _vm.connectCountLine,
      "width": "60%",
      "height": "300px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-group"
  }, [_c('Echarts', {
    attrs: {
      "type": "pie",
      "options": _vm.connectTimePie,
      "width": "40%",
      "height": "300px"
    }
  }), _vm._v(" "), _c('Echarts', {
    attrs: {
      "type": "line",
      "options": _vm.connectTimeLine,
      "width": "60%",
      "height": "300px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-group"
  }, [_c('div', {
    staticStyle: {
      "width": "40%"
    }
  }, [_c('p', [_vm._v("告警指令TOP5")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.alertTopTable,
      "height": "300"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "指令",
      "prop": "match_command"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('Echarts', {
    attrs: {
      "type": "line",
      "options": _vm.alertMultiLine,
      "width": "60%",
      "height": "300px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "top-list-group"
  }, [_c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('p', [_vm._v("成员连接次数TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.memberConnectTop,
      "height": "300",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "成员",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [_c('img', {
          staticClass: "avatar-img",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.avatar)
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "conn_count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('p', [_vm._v("资源连接次数TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.resourceConnectTop,
      "height": "300",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源",
      "prop": "resource_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [(scope.row.os === 'linux') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Linux",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/linux.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os === 'win32') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Windows",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/win32.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'postgresql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "PostgreSQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/postgresql.png",
            "width": "16",
            "height": "16",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mysql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MySQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/mysql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mssql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "SQL Server",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/mssql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.resource_name))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "集群",
      "prop": "network_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP地址",
      "prop": "ip_address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "conn_count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "top-list-group"
  }, [_c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('p', [_vm._v("成员连接时长TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.memberTimeTop,
      "height": "300",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "成员",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [_c('img', {
          staticClass: "avatar-img",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.avatar)
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时长",
      "prop": "conn_time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.conn_time / 3600).toFixed(2)) + "小时")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('p', [_vm._v("资源连接时长TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.resourceTimeTop,
      "height": "300",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源",
      "prop": "resource_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [(scope.row.os === 'linux') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Linux",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/linux.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os === 'win32') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Windows",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/win32.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'postgresql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "PostgreSQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/postgresql.png",
            "width": "16",
            "height": "16",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mysql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MySQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/mysql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mssql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "SQL Server",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/mssql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.resource_name))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "集群",
      "prop": "network_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP地址",
      "prop": "ip_address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时长",
      "prop": "conn_time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.conn_time / 3600).toFixed(2)) + "小时")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "top-list-group"
  }, [_c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('p', [_vm._v("指令告警次数/成员TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.alertMemberTop,
      "height": "300",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "成员",
      "prop": "account_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [_c('img', {
          staticClass: "avatar-img",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.avatar)
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.account_name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('p', [_vm._v("指令告警次数/资源TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.resourceAlertTop,
      "height": "300",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源",
      "prop": "resource_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [(scope.row.os === 'linux') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Linux",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/linux.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os === 'win32') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Windows",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/win32.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'postgresql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "PostgreSQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/postgresql.png",
            "width": "16",
            "height": "16",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mysql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MySQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/mysql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mssql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "SQL Server",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../../../static/images/mssql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.resource_name))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "集群",
      "prop": "network_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP地址",
      "prop": "resource_ip_address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons assess-color"
  }, [_vm._v("assessment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons work-color"
  }, [_vm._v("dvr")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons cluster-color"
  }, [_vm._v("view_list")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons member-color"
  }, [_vm._v("group")])])
}]}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-dairy"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("System Logs")])], 1), _vm._v(" "), _c('el-tabs', {
    staticClass: "tableTab",
    attrs: {
      "type": "card",
      "active-name": _vm.log.currentTab
    },
    on: {
      "tab-click": _vm.onTabClick
    }
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [(['teamLogs', 'clusterLogs', 'resourceLogs'].includes(_vm.log.currentTab)) ? _c('el-select', {
    staticClass: "event-search",
    attrs: {
      "placeholder": _vm.attrText.eventType
    },
    model: {
      value: (_vm.search.eventType),
      callback: function($$v) {
        _vm.search.eventType = $$v
      },
      expression: "search.eventType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$gettext('Event Type'),
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.selectOptions.event), function(val, key, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm._f("translate")(val.text, _vm.$gettext),
        "value": val.code
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.log.currentTab === 'loginLogs') ? _c('el-select', {
    staticClass: "account-search",
    attrs: {
      "placeholder": _vm.attrText.userType
    },
    model: {
      value: (_vm.search.isAdmin),
      callback: function($$v) {
        _vm.search.isAdmin = $$v
      },
      expression: "search.isAdmin"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.userType,
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.admin,
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.optAdmin,
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.auditAdmin,
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.safeAdmin,
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.ordinary,
      "value": "0"
    }
  })], 1) : _vm._e(), _vm._v(" "), (['teamLogs', 'clusterLogs', 'resourceLogs', 'alarmLogs'].includes(_vm.log.currentTab)) ? _c('el-select', {
    staticClass: "account-search",
    attrs: {
      "placeholder": _vm.attrText.select
    },
    on: {
      "change": _vm.onSelectRole
    },
    model: {
      value: (_vm.search.role),
      callback: function($$v) {
        _vm.search.role = $$v
      },
      expression: "search.role"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.select,
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.selectOptions.role), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm._f("translate")(item.text, _vm.$gettext),
        "value": item.val
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (['teamLogs', 'clusterLogs', 'resourceLogs', 'alarmLogs'].includes(_vm.log.currentTab)) ? _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "icon": "search",
      "placeholder": _vm.log.currentTab === 'loginLogs' ? _vm.attrText.inputAccount : _vm.attrText.input,
      "disabled": _vm.log.currentTab === 'loginLogs' ? !_vm.search.isDisabled : _vm.search.isDisabled
    },
    model: {
      value: (_vm.search.account),
      callback: function($$v) {
        _vm.search.account = $$v
      },
      expression: "search.account"
    }
  }) : _vm._e(), _vm._v(" "), (['loginLogs', 'teamLogs', 'clusterLogs', 'resourceLogs', 'alarmLogs'].includes(_vm.log.currentTab)) ? _c('el-date-picker', {
    staticClass: "date-picker",
    attrs: {
      "type": "date",
      "placeholder": _vm.attrText.startTime,
      "align": "right"
    },
    model: {
      value: (_vm.search.startTime),
      callback: function($$v) {
        _vm.search.startTime = $$v
      },
      expression: "search.startTime"
    }
  }) : _vm._e(), _vm._v(" "), (['loginLogs', 'teamLogs', 'clusterLogs', 'resourceLogs', 'alarmLogs'].includes(_vm.log.currentTab)) ? _c('el-date-picker', {
    staticClass: "date-picker",
    attrs: {
      "type": "date",
      "placeholder": _vm.attrText.endTime,
      "align": "right"
    },
    model: {
      value: (_vm.search.endTime),
      callback: function($$v) {
        _vm.search.endTime = $$v
      },
      expression: "search.endTime"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn-class",
    on: {
      "click": _vm.onSearch
    }
  }, [_c('translate', [_vm._v("Search")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "btn-class",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportLog
    }
  }, [_c('translate', [_vm._v("Export")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.loginLog,
      "name": "loginLogs",
      "disabled": _vm.loading
    }
  }, [(_vm.log.currentTab === 'loginLogs') ? _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.log.list,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.time
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm._f("moment")((scope.row.time * 1000), 'YYYY-MM-DD HH:mm:ss')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.account,
      "prop": "account"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.accountType
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.admin == 0) ? _c('p', [_vm._v(_vm._s(_vm.attrText.ordinary))]) : _vm._e(), _vm._v(" "), (scope.row.admin == 1) ? _c('p', [_vm._v(_vm._s(_vm.attrText.admin))]) : _vm._e(), _vm._v(" "), (scope.row.admin == 2) ? _c('p', [_vm._v(_vm._s(_vm.attrText.auditAdmin))]) : _vm._e(), _vm._v(" "), (scope.row.admin == 3) ? _c('p', [_vm._v(_vm._s(_vm.attrText.optAdmin))]) : _vm._e(), _vm._v(" "), (scope.row.admin == 4) ? _c('p', [_vm._v(_vm._s(_vm.attrText.safeAdmin))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.loginIp,
      "prop": "ip",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.loginStatus,
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.success) ? _c('p', {
          staticStyle: {
            "color": "#88d8a5"
          }
        }, [_vm._v("成功")]) : _c('p', {
          staticStyle: {
            "color": "#e47470"
          }
        }, [_vm._v("失败")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.comment,
      "prop": "reason",
      "width": "200"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.teamLog,
      "name": "teamLogs",
      "disabled": _vm.loading
    }
  }, [(_vm.log.currentTab === 'teamLogs') ? _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.log.list,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.time
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm._f("moment")((scope.row.time * 1000), 'YYYY-MM-DD HH:mm:ss')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.account,
      "prop": "account"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.event,
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.eventShow) ? _c('p', [_vm._v(_vm._s(_vm._f("translate")(_vm.selectOptions.event[scope.row.event].text, _vm.$gettext)))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.accountEdited
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.user ? scope.row.user : '-') + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.groupEdited
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.group ? scope.row.group : '-') + "\n\t\t\t\t\t\t")]
      }
    }])
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.clusterLog,
      "name": "clusterLogs",
      "disabled": _vm.loading
    }
  }, [(_vm.log.currentTab === 'clusterLogs') ? _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.log.list,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.time
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm._f("moment")((scope.row.time * 1000), 'YYYY-MM-DD HH:mm:ss')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.account,
      "prop": "account"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.event
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.eventShow && _vm.selectOptions.event[scope.row.event]) ? _c('p', [_vm._v(_vm._s(_vm._f("translate")(_vm.selectOptions.event[scope.row.event].text, _vm.$gettext)))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.clusterName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.net_name ? scope.row.net_name : '-') + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resourceName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.resource_name ? scope.row.resource_name : '-') + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.teamName,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.shared_company_name ? scope.row.shared_company_name : '-') + "\n\t\t\t\t\t\t")]
      }
    }])
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.workgroupLog,
      "name": "resourceLogs",
      "disabled": _vm.loading
    }
  }, [(_vm.log.currentTab === 'resourceLogs') ? _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.log.list,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.time
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm._f("moment")((scope.row.time * 1000), 'YYYY-MM-DD HH:mm:ss')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.account,
      "prop": "account"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.event
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.eventShow && _vm.selectOptions.event[scope.row.event]) ? _c('p', [_vm._v(_vm._s(_vm._f("translate")(_vm.selectOptions.event[scope.row.event].text, _vm.$gettext)))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.workgroupName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.project_name ? scope.row.project_name : '-') + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resourceName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.resource_name ? scope.row.resource_name : '-') + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.accountEdited
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.project_account ? scope.row.project_account : '-') + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.groupEdited
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.group ? scope.row.group : '-') + "\n\t\t\t\t\t\t")]
      }
    }])
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [(_vm.log.totalPage > 10) ? _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.log.totalPage,
      "current-page": _vm.log.currentPage,
      "page-size": 10
    },
    on: {
      "update:currentPage": function($event) {
        _vm.log.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.getAlarmLog
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cloudlinker-stat-page"
  }, [_c('div', {
    staticClass: "overview-banner"
  }, [_c('h2', [_vm._v("CloudLinker 运维审计报告")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("moment")((_vm.$route.query.time_from * 1000), 'YYYY-MM-DD HH:mm:ss')) + " ~ " + _vm._s(_vm._f("moment")((_vm.$route.query.time_end * 1000), 'YYYY-MM-DD HH:mm:ss')))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-cards"
  }, [_c('div', {
    staticClass: "overview-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("资源")]), _vm._v(" "), _c('div', {
    staticClass: "card-value assess-color"
  }, [_vm._v(_vm._s(_vm.overviewData.resources))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("工作组")]), _vm._v(" "), _c('div', {
    staticClass: "card-value work-color"
  }, [_vm._v(_vm._s(_vm.overviewData.projects))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("集群")]), _vm._v(" "), _c('div', {
    staticClass: "card-value cluster-color"
  }, [_vm._v(_vm._s(_vm.overviewData.networks))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("成员")]), _vm._v(" "), _c('div', {
    staticClass: "card-value member-color"
  }, [_vm._v(_vm._s(_vm.overviewData.accounts))])])]), _vm._v(" "), _c('div', {
    staticClass: "stat-row"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("活跃用户数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.conn_account_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("被访问资源数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.resource_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("总连接次数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.conn_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("指令告警次数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.notice_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("日均连接次数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.avg_days_conn_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("总连接时长")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.conn_time) + "小时")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("日均连接时长")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.avg_days_conn_time) + "小时")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("平均连接时长")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.avg_conn_time) + "小时")])])]), _vm._v(" "), _c('div', {
    staticClass: "chart-group"
  }, [_c('Echarts', {
    attrs: {
      "type": "pie",
      "options": _vm.connectCountPie,
      "width": "40%",
      "height": "300px"
    }
  }), _vm._v(" "), _c('Echarts', {
    attrs: {
      "type": "line",
      "options": _vm.connectCountLine,
      "width": "60%",
      "height": "300px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-group"
  }, [_c('Echarts', {
    attrs: {
      "type": "pie",
      "options": _vm.connectTimePie,
      "width": "40%",
      "height": "300px"
    }
  }), _vm._v(" "), _c('Echarts', {
    attrs: {
      "type": "line",
      "options": _vm.connectTimeLine,
      "width": "60%",
      "height": "300px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-group"
  }, [_c('div', {
    staticStyle: {
      "width": "40%"
    }
  }, [_c('p', [_vm._v("告警指令TOP5")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.alertTopTable,
      "height": "400"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "指令",
      "prop": "match_command"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('Echarts', {
    attrs: {
      "type": "line",
      "options": _vm.alertMultiLine,
      "width": "60%",
      "height": "400px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "top-list-group"
  }, [_c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('p', [_vm._v("成员连接次数TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.memberConnectTop,
      "height": "400",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "成员",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [_c('img', {
          staticClass: "avatar-img",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.avatar)
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "conn_count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('p', [_vm._v("资源连接次数TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.resourceConnectTop,
      "height": "400",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源",
      "prop": "resource_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [(scope.row.os === 'linux') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Linux",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/linux.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os === 'win32') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Windows",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/win32.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'postgresql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "PostgreSQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/postgresql.png",
            "width": "16",
            "height": "16",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mysql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MySQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/mysql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mssql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "SQL Server",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/mssql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.resource_name))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "集群",
      "prop": "network_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP地址",
      "prop": "ip_address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "conn_count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "top-list-group"
  }, [_c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('p', [_vm._v("成员连接时长TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.memberTimeTop,
      "height": "400",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "成员",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [_c('img', {
          staticClass: "avatar-img",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.avatar)
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时长",
      "prop": "conn_time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.conn_time / 3600).toFixed(2)) + "小时")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('p', [_vm._v("资源连接时长TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.resourceTimeTop,
      "height": "400",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源",
      "prop": "resource_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [(scope.row.os === 'linux') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Linux",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/linux.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os === 'win32') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Windows",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/win32.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'postgresql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "PostgreSQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/postgresql.png",
            "width": "16",
            "height": "16",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mysql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MySQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/mysql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mssql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "SQL Server",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/mssql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.resource_name))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "集群",
      "prop": "network_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP地址",
      "prop": "ip_address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时长",
      "prop": "conn_time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.conn_time / 3600).toFixed(2)) + "小时")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "top-list-group"
  }, [_c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('p', [_vm._v("指令告警次数/成员TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.alertMemberTop,
      "height": "400",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "成员",
      "prop": "account_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [_c('img', {
          staticClass: "avatar-img",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.avatar)
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.account_name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('p', [_vm._v("指令告警次数/资源TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.resourceAlertTop,
      "height": "400",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源",
      "prop": "resource_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [(scope.row.os === 'linux') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Linux",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/linux.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os === 'win32') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Windows",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/win32.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'postgresql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "PostgreSQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/postgresql.png",
            "width": "16",
            "height": "16",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mysql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MySQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/mysql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mssql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "SQL Server",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/mssql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.resource_name))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "集群",
      "prop": "network_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP地址",
      "prop": "resource_ip_address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons assess-color"
  }, [_vm._v("assessment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons work-color"
  }, [_vm._v("dvr")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons cluster-color"
  }, [_vm._v("view_list")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons member-color"
  }, [_vm._v("group")])])
}]}

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', [_c('div', {
    staticClass: "csos-logo"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(440)
    }
  })]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-vertical-demo default-active",
    attrs: {
      "default-active": _vm.activeIndex,
      "default-openeds": _vm.openedsIndex
    }
  }, [_c('el-submenu', {
    staticClass: "default-active",
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    slot: "title"
  }, [_c('translate', [_vm._v("Operation")])], 1)]), _vm._v(" "), _c('el-menu-item-group', [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([1, 2, 3, 4].includes(_vm.currentAccount.is_admin)),
      expression: "[1, 2, 3, 4].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "to": "/operation/dashboard"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1-1",
      "data-router": "{\"/operation/dashboard\": \"1-1\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("apps")]), _vm._v(" "), _c('translate', [_vm._v("Dashboard")])], 1)], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([0, 1].includes(_vm.currentAccount.is_admin)),
      expression: "[0, 1].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "to": "/operation/workgroup"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1-2",
      "data-router": "{\"/operation/workgroup\": \"1-2\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("tune")]), _vm._v(" "), _c('translate', [_vm._v("WorkGroup")])], 1)], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([0, 1, 2, 4].includes(_vm.currentAccount.is_admin)),
      expression: "[0, 1, 2, 4].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "to": "/operation/log"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1-3",
      "data-router": "{\"/operation/log\": \"1-3\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("event_note")]), _vm._v(" "), _c('translate', [_vm._v("Log")])], 1)], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([0, 1].includes(_vm.currentAccount.is_admin)),
      expression: "[0, 1].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "to": {
        name: 'operation.review',
        query: {
          type: 'sql'
        }
      }
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1-4",
      "data-router": "{\"/operation/review\":\"1-4\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_balance")]), _vm._v(" "), _c('translate', [_vm._v("Application")])], 1)], 1)], 1)], 2), _vm._v(" "), _c('el-submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([1, 3].includes(_vm.currentAccount.is_admin)),
      expression: "[1, 3].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('translate', [_vm._v("Configuration")])], 1), _vm._v(" "), _c('el-menu-item-group', [_c('router-link', {
    attrs: {
      "to": "/settings/workgroup"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "2-1",
      "data-router": "{\"/settings/workgroup\": \"2-1\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dvr")]), _vm._v(" "), _c('translate', [_vm._v("WorkGroup Manage")])], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/settings/cluster"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "2-2",
      "data-router": "{\"/settings/cluster\": \"2-2\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_list")]), _vm._v(" "), _c('translate', [_vm._v("Cluster Manage")]), _vm._v(" "), (_vm.isUpdateAgent) ? _c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#fda541",
      "font-size": "14px",
      "top": "2px"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([1].includes(_vm.currentAccount.is_admin)),
      expression: "[1].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "to": {
        name: 'team',
        query: {
          type: 'members'
        }
      }
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "2-3",
      "data-router": "{\"/settings/team\": \"2-3\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("group")]), _vm._v(" "), _c('translate', [_vm._v("Team Manage")])], 1)], 1)], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('translate', [_vm._v("System")])], 1), _vm._v(" "), _c('el-menu-item-group', [_c('router-link', {
    attrs: {
      "to": {
        name: 'statistics',
        query: {
          type: 'overview'
        }
      }
    }
  }, [_c('el-menu-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([1, 2, 4].includes(_vm.currentAccount.is_admin)),
      expression: "[1, 2, 4].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "index": "3-1",
      "data-router": "{\"/system/statistics\": \"3-1\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("timeline")]), _vm._v(" "), _c('translate', [_vm._v("Statistic")])], 1)], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([1, 2, 4].includes(_vm.currentAccount.is_admin)),
      expression: "[1, 2, 4].includes(currentAccount.is_admin)"
    }],
    attrs: {
      "to": {
        name: 'log',
        query: {
          type: 'loginLogs'
        }
      }
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "3-2",
      "data-router": "{\"/system/log\": \"3-2\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chrome_reader_mode")]), _vm._v(" "), _c('translate', [_vm._v("System Log")])], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'alarmNotify'
      }
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "3-3",
      "data-router": "{\"/system/alarmNotify\": \"3-3\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("announcement")]), _vm._v(" "), _c('translate', [_vm._v("Alarm Notify")])], 1)], 1)], 1)], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('translate', [_vm._v("Personal")])], 1), _vm._v(" "), _c('el-menu-item-group', [_c('router-link', {
    attrs: {
      "to": "/personal/info"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "4-1",
      "data-router": "{\"/personal/info\": \"4-1\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")]), _vm._v(" "), _c('translate', [_vm._v("Account Info")])], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/personal/security"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "4-2",
      "data-router": "{\"/personal/security\": \"4-2\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("security")]), _vm._v(" "), _c('translate', [_vm._v("Account Security")])], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/personal/sshkey"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "4-3",
      "data-router": "{\"/personal/sshkey\": \"4-3\"}"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock")]), _vm._v(" "), _c('span', [_vm._v("SSH KEY")])])], 1)], 1)], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Set Cluster")])], 1), _vm._v(" "), _c('div', {
    staticClass: "set-cluster-content",
    slot: "content"
  }, [_c('el-form', {
    ref: "setClusterForm",
    attrs: {
      "model": _vm.clusterSetForm,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.name,
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.clusterSetForm.name),
      callback: function($$v) {
        _vm.clusterSetForm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "clusterSetForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.ip,
      "prop": "agent_host_alias"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.clusterSetForm.agent_host_alias),
      callback: function($$v) {
        _vm.clusterSetForm.agent_host_alias = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "clusterSetForm.agent_host_alias"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.code
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.clusterSetForm.codeSet),
      callback: function($$v) {
        _vm.clusterSetForm.codeSet = $$v
      },
      expression: "clusterSetForm.codeSet"
    }
  }, [_c('translate', [_vm._v("Default")])], 1), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.clusterSetForm.codeSet),
      callback: function($$v) {
        _vm.clusterSetForm.codeSet = $$v
      },
      expression: "clusterSetForm.codeSet"
    }
  }, [_c('translate', [_vm._v("Customize")])], 1)], 1), _vm._v(" "), (_vm.clusterSetForm.codeSet === '2') ? _c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "time"
    }
  }, [_c('el-input', {
    staticClass: "set-input",
    model: {
      value: (_vm.clusterSetForm.time),
      callback: function($$v) {
        _vm.clusterSetForm.time = _vm._n($$v)
      },
      expression: "clusterSetForm.time"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "set-select",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.clusterSetForm.timeType),
      callback: function($$v) {
        _vm.clusterSetForm.timeType = $$v
      },
      expression: "clusterSetForm.timeType"
    }
  }, _vm._l((_vm.timeArr), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "set-note"
  }, [_c('translate', [_vm._v("Log in resource need to generate a code, every code has a effective period,This term set the maximum effective period that user can set.")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "0"
    },
    attrs: {
      "label": _vm.attrText.ConnectMap,
      "prop": ""
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.clusterSetForm.is_open_map),
      callback: function($$v) {
        _vm.clusterSetForm.is_open_map = $$v
      },
      expression: "clusterSetForm.is_open_map"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "set-note"
  }, [_c('translate', [_vm._v("Note: After enabling the service connection mapping function, the IP and port displayed during actual connection will be subject to the current mapping rules.")])], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.clusterSetForm.port_map_info
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ip_name",
      "label": _vm.attrText.ipName
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_port",
      "label": _vm.attrText.originPort
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "map_port",
      "label": _vm.attrText.mapPort
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number"
          },
          on: {
            "change": function($event) {
              _vm.changeMapPort(scope.row)
            }
          },
          model: {
            value: (scope.row.map_port),
            callback: function($$v) {
              scope.row.map_port = _vm._n($$v)
            },
            expression: "scope.row.map_port"
          }
        })]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    ref: "chart"
  })])
},staticRenderFns: []}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel-add",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Add Instance")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "add-form",
    attrs: {
      "model": _vm.addForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.resourceName,
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.resourceName
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.addForm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.ipAddress,
      "prop": "ipAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "IP"
    },
    model: {
      value: (_vm.addForm.ipAddress),
      callback: function($$v) {
        _vm.addForm.ipAddress = $$v
      },
      expression: "addForm.ipAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.os,
      "prop": "os"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.selectDefault
    },
    model: {
      value: (_vm.addForm.os),
      callback: function($$v) {
        _vm.addForm.os = $$v
      },
      expression: "addForm.os"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Windows",
      "value": "win32"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Linux",
      "value": "linux"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.username,
      "prop": "username"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.username),
      callback: function($$v) {
        _vm.addForm.username = $$v
      },
      expression: "addForm.username"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("Multiple users with semicolons ‘;’")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.port,
      "prop": "port"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.port),
      callback: function($$v) {
        _vm.addForm.port = $$v
      },
      expression: "addForm.port"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.flavor,
      "prop": "flavor"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": _vm.attrText.defaultFlavorText
    },
    model: {
      value: (_vm.addForm.flavor),
      callback: function($$v) {
        _vm.addForm.flavor = $$v
      },
      expression: "addForm.flavor"
    }
  })], 1), _vm._v(" "), (_vm.addForm.os === 'win32') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.clipboard
    }
  }, [_c('el-switch', {
    staticStyle: {
      "margin-right": "16px"
    },
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.addForm.clipboard),
      callback: function($$v) {
        _vm.addForm.clipboard = $$v
      },
      expression: "addForm.clipboard"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.btnDisabled,
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.onSubmitAddForm()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "view-title"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.$route.query.accountName || _vm.attrText.members) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "workgroup-wrapper"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card",
      "active-name": _vm.m.currentTab
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.workgroup,
      "name": "workgroup"
    }
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowAccountAddWorkgroup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Distribute")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.m.batchDel === ''
    },
    on: {
      "click": function($event) {
        _vm.batchDel(_vm.m.batchDel)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Exit")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "memberTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.m.accountWorkgroupList,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.project_name))]), _vm._v(" "), (scope.row.network_id !== -1) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.defaultWorkgroup,
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-globe",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.desc
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.desc) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.batchDel(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Exit")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.m.totalPage > 10 && _vm.m.currentTab === 'workgroup') ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.m.totalPage,
      "current-page": _vm.m.currentPage,
      "page-size": 10
    },
    on: {
      "update:currentPage": function($event) {
        _vm.m.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.callback
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Scan Import")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newQueryShow),
      expression: "!newQueryShow"
    }],
    ref: "scanForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.scanForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "fixed-text",
    attrs: {
      "label": _vm.attrText.cidrBlock,
      "prop": "cidr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.network
    },
    model: {
      value: (_vm.scanForm.cidr),
      callback: function($$v) {
        _vm.scanForm.cidr = $$v
      },
      expression: "scanForm.cidr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select-role",
    attrs: {
      "label": _vm.attrText.os,
      "prop": "os"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.changeOs
    },
    model: {
      value: (_vm.scanForm.os),
      callback: function($$v) {
        _vm.scanForm.os = $$v
      },
      expression: "scanForm.os"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Windows",
      "value": "win32"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Linux",
      "value": "linux"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.port,
      "prop": "port"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.scanForm.port),
      callback: function($$v) {
        _vm.scanForm.port = $$v
      },
      expression: "scanForm.port"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.userName,
      "prop": "userName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.scanForm.userName),
      callback: function($$v) {
        _vm.scanForm.userName = $$v
      },
      expression: "scanForm.userName"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("Multiple users with semicolons ‘;’")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newQueryShow),
      expression: "newQueryShow"
    }],
    staticClass: "scan-import"
  }, [_c('div', {
    staticClass: "scan-process"
  }, [(_vm.agentVersion && _vm.agentVersion < '3.0.0') ? _c('div', {
    staticClass: "process"
  }, [_c('el-progress', {
    attrs: {
      "percentage": _vm.processPercent,
      "stroke-width": 20,
      "show-text": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "scan-btn"
  }, [_c('div', {
    staticClass: "hide_duplicate_switch"
  }, [_c('translate', [_vm._v("Hide the same resources as the IP in the cluster")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "disabled": !_vm.queryScan.isCanRestart
    },
    on: {
      "change": _vm.changeHideDuplicateIp
    },
    model: {
      value: (_vm.queryScan.hide_duplicate_ip),
      callback: function($$v) {
        _vm.queryScan.hide_duplicate_ip = $$v
      },
      expression: "queryScan.hide_duplicate_ip"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "scan_again",
    attrs: {
      "disabled": !_vm.queryScan.isCanRestart
    },
    on: {
      "click": function($event) {
        _vm.onScanAgain()
      }
    }
  }, [_c('translate', [_vm._v("Scan again")])], 1)], 1)]), _vm._v(" "), (_vm.agentVersion && _vm.agentVersion < '3.0.0') ? _c('div', {
    staticClass: "scan-table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.queryScan.list,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectImport
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP",
      "prop": "ip"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.port,
      "prop": "port"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.agentVersion && _vm.agentVersion >= '3.0.0') ? _c('div', {
    staticClass: "scan-table"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.queryScan.list),
      expression: "!queryScan.list"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.queryScan.list,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectImport
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP",
      "prop": "ip"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.port,
      "prop": "port"
    }
  })], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [(_vm.queryScan.total === 1) ? _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.scanLoading),
      expression: "scanLoading"
    }],
    attrs: {
      "type": "primary",
      "disabled": !_vm.queryScan.isCanScan
    },
    on: {
      "click": function($event) {
        _vm.onStartScan()
      }
    }
  }, [_c('translate', [_vm._v("Scan")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.newQueryShow) ? _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.queryScan.importLoading),
      expression: "queryScan.importLoading"
    }],
    attrs: {
      "type": "primary",
      "disabled": !_vm.queryScan.isCanImport || _vm.queryScan.importLoading
    },
    on: {
      "click": function($event) {
        _vm.onStartImport()
      }
    }
  }, [_c('translate', [_vm._v("Import")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('h4', {
    staticClass: "content-titel"
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('el-form', {
    ref: "forgetPswForm",
    attrs: {
      "model": _vm.forgetPswForm,
      "rules": _vm.rules,
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('el-form-item', {
    staticClass: "list-group-item",
    attrs: {
      "prop": "domain"
    }
  }, [_c('el-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "required",
      "placeholder": "团队代码"
    },
    model: {
      value: (_vm.forgetPswForm.domain),
      callback: function($$v) {
        _vm.forgetPswForm.domain = $$v
      },
      expression: "forgetPswForm.domain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "list-group-item",
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "required": "required",
      "placeholder": "邮箱"
    },
    model: {
      value: (_vm.forgetPswForm.account),
      callback: function($$v) {
        _vm.forgetPswForm.account = $$v
      },
      expression: "forgetPswForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "captcha"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-input', {
    staticClass: "form-control",
    attrs: {
      "required": "required",
      "placeholder": "验证码"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onKeyup()
      }
    },
    model: {
      value: (_vm.forgetPswForm.captcha),
      callback: function($$v) {
        _vm.forgetPswForm.captcha = $$v
      },
      expression: "forgetPswForm.captcha"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "send-code",
    attrs: {
      "span": 8
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "32px",
      "margin-top": "2px"
    },
    attrs: {
      "src": _vm.captchaSrc,
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.refresh()
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "submit-btn",
    attrs: {
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.resetPasswordMail()
      }
    }
  }, [(!_vm.loading) ? _c('span', [_c('translate', [_vm._v("Submit")])], 1) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('span', [_c('translate', [_vm._v("Submiting")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: " capitalize clearfix"
  }, [_c('router-link', {
    staticClass: "pull-left login-link",
    attrs: {
      "to": "login"
    }
  }, [_c('translate', [_vm._v("Login")])], 1)], 1)], 1)], 1)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(59)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright clearfix"
  }, [_c('div', [_vm._v("Copyright 2013-2022 上海驻云信息科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("Powered by\n      "), _c('a', {
    staticClass: "text-primary new-block",
    attrs: {
      "href": "https://cloudcare.cn/",
      "target": "_blank"
    }
  }, [_vm._v("cloudcare.cn")])])])
}]}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("欢迎使用")]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("CloudLinker 账号登录")]), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules,
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('el-form-item', {
    staticClass: "list-group-item",
    attrs: {
      "prop": "domain"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "团队ID"
    },
    on: {
      "blur": _vm.checkCaptcha
    },
    model: {
      value: (_vm.loginForm.domain),
      callback: function($$v) {
        _vm.loginForm.domain = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "loginForm.domain"
    }
  })], 1), _vm._v(" "), (!_vm.ssoOption.is_open_sso || (_vm.ssoOption.is_open_sso && _vm.ssoOption.is_account_password)) ? _c('el-form-item', {
    staticClass: "list-group-item",
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "placeholder": "账号/邮箱"
    },
    on: {
      "blur": _vm.checkCaptcha
    },
    model: {
      value: (_vm.loginForm.username),
      callback: function($$v) {
        _vm.loginForm.username = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "loginForm.username"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.ssoOption.is_open_sso || (_vm.ssoOption.is_open_sso && _vm.ssoOption.is_account_password)) ? _c('el-form-item', {
    staticClass: "list-group-item",
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onKeyup()
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.loginForm.password = $$v
      },
      expression: "loginForm.password"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showCaptcha) ? _c('el-form-item', {
    attrs: {
      "prop": "captcha"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-input', {
    staticClass: "form-control",
    attrs: {
      "required": "required",
      "placeholder": "验证码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onKeyup()
      }
    },
    model: {
      value: (_vm.loginForm.captcha),
      callback: function($$v) {
        _vm.loginForm.captcha = $$v
      },
      expression: "loginForm.captcha"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "send-code",
    attrs: {
      "span": 8
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "32px",
      "margin-top": "2px"
    },
    attrs: {
      "src": _vm.captchaSrc,
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.refresh()
      }
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "agree"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.loginForm.agree),
      callback: function($$v) {
        _vm.loginForm.agree = $$v
      },
      expression: "loginForm.agree"
    }
  }), _vm._v("\n\t\t\t\t\t我已阅读并同意\n\t\t\t\t\t"), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "/console.html#/user-agreement",
      "target": "_blank"
    }
  }, [_vm._v("用户协议")]), _vm._v("、\n\t\t\t\t\t"), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "/console.html#/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("隐私政策")])], 1), _vm._v(" "), (!_vm.ssoOption.is_open_sso || (_vm.ssoOption.is_open_sso && _vm.ssoOption.is_account_password)) ? _c('el-form-item', [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary",
      "disabled": _vm.loginForm.domain != '' && _vm.loginForm.username != '' && _vm.loginForm.password != '' && _vm.loginForm.agree ? false : true
    },
    on: {
      "click": function($event) {
        _vm.login(_vm.loginForm)
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("登录")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('span', [_c('span', [_vm._v("登录中")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.ssoOption.is_open_sso) ? _c('el-form-item', [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "disabled": !_vm.loginForm.agree
    },
    on: {
      "click": function($event) {
        _vm.ssoLogin()
      }
    }
  }, [_c('span', [_vm._v("使用SSO登录")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "capitalize clearfix"
  }, [_c('div', {
    staticClass: "but"
  }, [_c('router-link', {
    staticClass: "pull-right login-link",
    attrs: {
      "to": "forgetpsw"
    }
  }, [_vm._v("忘记密码?")]), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right login-link",
    attrs: {
      "to": "register"
    }
  }, [_vm._v("立即注册")])], 1)])], 1)], 1)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(59)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright clearfix small"
  }, [_c('div', [_vm._v("Copyright 上海驻云信息科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\tPowered by\n\t\t\t"), _c('a', {
    staticClass: "text-primary new-block",
    attrs: {
      "href": "https://www.cloudcare.cn",
      "target": "_blank"
    }
  }, [_vm._v("cloudcare.cn")])])])
}]}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team-group-detail"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('span', [_vm._v(_vm._s(this.$route.query.name))])]), _vm._v(" "), _c('div', {
    staticClass: "team-group-detail-wrapper"
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('router-link', {
    staticStyle: {
      "margin-right": "6px"
    },
    attrs: {
      "to": {
        name: 'team',
        query: {
          type: 'group'
        }
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Back")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowTeamGroupAddMember(_vm.detail.list)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Add Member")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.detail.batchDel === ''
    },
    on: {
      "click": function($event) {
        _vm.batchDel(_vm.detail.batchDel)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Remove")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-select', {
    staticClass: "condition-search",
    model: {
      value: (_vm.search.user),
      callback: function($$v) {
        _vm.search.user = $$v
      },
      expression: "search.user"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.name,
      "value": "q_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.account,
      "value": "q_account"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "icon": "search",
      "disabled": _vm.search.user === '',
      "on-icon-click": _vm.onSearch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearch()
      }
    },
    model: {
      value: (_vm.search.val),
      callback: function($$v) {
        _vm.search.val = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "search.val"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detail.list,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "32"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name,
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.account,
      "prop": "account"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.role
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "log-list-name"
        }, [_c('p', [_vm._v(_vm._s(scope.row.is_admin ? _vm.attrText.administrator : _vm.attrText.ordinary))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.batchDel([scope.row.id])
            }
          }
        }, [_c('translate', [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.detail.totalPage > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.detail.totalPage,
      "current-page": _vm.detail.currentPage,
      "page-size": 10
    },
    on: {
      "update:currentPage": function($event) {
        _vm.detail.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.callback
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isShow) ? _c('div', {
    staticClass: "right-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "right-header"
  }, [_vm._t("header", [_vm._v("\n        title\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.onClose()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "translate": ""
    }
  }, [_vm._v("clear")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("content", [_c('el-form', {
    ref: "profileForm",
    staticClass: "profile-form",
    attrs: {
      "model": _vm.profileModel,
      "rules": _vm.rules
    }
  }, _vm._l((_vm.formItems), function(val, key) {
    return _c('el-form-item', {
      key: key,
      attrs: {
        "label": val.label,
        "labelWidth": val.labelWidth
      }
    }, _vm._l((val.childs), function(item, key) {
      return _c('el-col', {
        key: key,
        class: item.class,
        attrs: {
          "span": item.col
        }
      }, [_c('el-form-item', {
        attrs: {
          "prop": item.key
        }
      }, [(item.type === 'uploader') ? _c('el-upload', {
        staticClass: "uploader-wrapper",
        attrs: {
          "action": item.option.action,
          "show-file-list": false,
          "data": item.option.data,
          "before-upload": item.option.onBeforeUpload,
          "on-success": item.option.onSuccess,
          "on-error": item.option.onFail,
          "on-progress": item.option.onProgress,
          "on-change": item.option.onChange,
          "multiple": false
        }
      }, [(_vm.profileModel[item.key]) ? _c('img', {
        staticClass: "avatar",
        attrs: {
          "src": _vm.profileModel[item.key]
        }
      }) : _c('i', {
        staticClass: "el-icon-upload avatar-uploader-icon"
      }), _vm._v(" "), _c('div', [_vm._v("上传新头像")])]) : (item.type === 'select') ? _c('el-select', {
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, $$v)
          },
          expression: "profileModel[item.key]"
        }
      }, _vm._l((item.options), function(item, index) {
        return _c('el-option', {
          key: index,
          staticClass: "sns-item",
          attrs: {
            "label": item.text,
            "value": item.key
          }
        }, [(item.icon) ? _c('span', {
          staticClass: "pull-left"
        }, [_c('i', {
          class: item.icon
        })]) : _vm._e(), _vm._v(" "), (item.logo) ? _c('span', {
          staticClass: "pull-left"
        }, [_c('img', {
          staticClass: "sns-logo",
          attrs: {
            "src": item.logo,
            "border": "0"
          }
        })]) : _vm._e(), _vm._v(" "), (item.icon) ? _c('span', [_c('i', {
          staticClass: "material-icons pull-left"
        }, [_vm._v(_vm._s(item.icon))])]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])])
      })) : (item.type === 'level') ? _c('el-select', {
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, $$v)
          },
          expression: "profileModel[item.key]"
        }
      }, _vm._l((item.options), function(perItem, index) {
        return _c('el-option', {
          key: index,
          attrs: {
            "label": perItem.label,
            "value": perItem.key
          }
        }, [_c('el-rate', {
          attrs: {
            "disabled": "",
            "text-template": perItem.label,
            "show-text": true
          },
          model: {
            value: (perItem.val),
            callback: function($$v) {
              perItem.val = $$v
            },
            expression: "perItem.val"
          }
        })], 1)
      })) : (item.type === 'radio') ? _c('el-radio-group', {
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, $$v)
          },
          expression: "profileModel[item.key]"
        }
      }, _vm._l((item.options), function(option, key) {
        return _c('el-radio', {
          key: key,
          attrs: {
            "label": option.label
          }
        }, [_vm._v(_vm._s(option.text))])
      })) : (item.type === 'datePicker') ? _c('el-date-picker', {
        attrs: {
          "type": item.pickerType,
          "placeholder": item.placeholder
        },
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, $$v)
          },
          expression: "profileModel[item.key]"
        }
      }) : (item.type === 'separation') ? _c('span', {
        staticClass: "line"
      }, [_vm._v(" " + _vm._s(item.text) + " ")]) : (item.type === 'tips') ? _c('span', {
        staticClass: "line",
        staticStyle: {
          "display": "block",
          "margin-left": "130px",
          "margin-top": "-12px",
          "color": "#999",
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item.text))]) : (item.type === 'check') ? _c('el-checkbox', {
        on: {
          "change": function($event) {
            item.checkFun(_vm.profileModel[item.key])
          }
        },
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, $$v)
          },
          expression: "profileModel[item.key]"
        }
      }, [_vm._v(_vm._s(item.label))]) : (item.type === 'textarea') ? _c('el-input', {
        staticClass: "right-panel-textarea",
        attrs: {
          "type": "textarea",
          "autosize": item.options.autosize,
          "resize": item.options.resize
        },
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, $$v)
          },
          expression: "profileModel[item.key]"
        }
      }) : _c('el-input', {
        attrs: {
          "disabled": item.disabled
        },
        model: {
          value: (_vm.profileModel[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.profileModel, item.key, (typeof $$v === 'string' ? $$v.trim() : $$v))
          },
          expression: "profileModel[item.key]"
        }
      })], 1)], 1)
    }))
  }))])], 2), _vm._v(" "), (!_vm.hideFooter) ? _c('div', {
    staticClass: "footer"
  }, [_vm._t("footer", [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.onSubmit('profileForm')
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)])], 2) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-titel"
  }, [_c('translate', [_vm._v("MFA Verification Instructions")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "30px 0 20px",
      "padding": "0 20px"
    }
  }, [_c('translate', [_vm._v("If the administrator has opened the team MFA certification, you must bind MFA to log in normally!")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('el-button', {
    staticClass: "mfa-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.bindMfa = true
      }
    }
  }, [_c('translate', [_vm._v("Bind Immediately")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "mfa-btn",
    on: {
      "click": _vm.onCancelLogin
    }
  }, [_c('translate', [_vm._v("Unregister")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "copyright clearfix small"
  }, [_c('div', [_vm._v("Copyright 2013-2017 "), _c('translate', [_vm._v("Shanghai Zhuyun Information Technology Co.,Ltd")])], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": _vm.changeInfo ? _vm.attrText.mfaverify : _vm.attrText.bingMfa,
      "visible": _vm.bindMfa
    },
    on: {
      "update:visible": function($event) {
        _vm.bindMfa = $event
      },
      "close": function($event) {
        _vm.onDialogClose()
      }
    }
  }, [(_vm.changeInfo) ? _c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("1.You must install the MFA application on your smart device to continue")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("2. Common applications that support MFA on smart devices are ")]), _c('a', {
    staticStyle: {
      "color": "#20a0ff"
    },
    attrs: {
      "href": "https://promotion.aliyun.com/ntms/mobile.html",
      "target": "view_window"
    }
  }, [_c('translate', [_vm._v("Identity")])], 1), _c('translate', [_vm._v(", Microsoft Authenticator, Google Authenticator.")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("3.If your account has been shared by multiple people, when you successfully bind MFA, other unbound MFA people will not be able to log in. Other people must also install the MFA application and scan the 2D code for this page, or save the 2D code picture for others to scan. In consideration of account security, we recommend that you cancel the multiplayer account.")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("4. If you can not verify for some reason, such as missing or mistakenly deleted MFA applications, you can manually unmarshal MFA binding by dialing 021-50653160.")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.changeInfo) ? _c('div', {
    staticClass: "change-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.onTabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.scanCode,
      "name": "scanGet"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.manualInput,
      "name": "handleGet"
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "securityNum",
    attrs: {
      "span": 13
    }
  }, [_c('p', {
    staticClass: "tip-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('translate', [_vm._v("Please use the MFA application on your smartphone to scan")])], 1), _vm._v(" "), _c('el-form', {
    ref: "securityNum",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.securityNumForm,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "label": _vm.attrText.firstCode,
      "prop": "firstCode"
    }
  }, [_c('el-input', {
    staticClass: "input-class",
    attrs: {
      "placeholder": _vm.attrText.enterCode
    },
    model: {
      value: (_vm.securityNumForm.firstCode),
      callback: function($$v) {
        _vm.securityNumForm.firstCode = $$v
      },
      expression: "securityNumForm.firstCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.secondCode,
      "prop": "secondCode"
    }
  }, [_c('el-input', {
    staticClass: "input-class",
    attrs: {
      "placeholder": _vm.attrText.enterCode
    },
    model: {
      value: (_vm.securityNumForm.secondCode),
      callback: function($$v) {
        _vm.securityNumForm.secondCode = $$v
      },
      expression: "securityNumForm.secondCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.activeName === 'scanGet') ? _c('el-col', {
    staticClass: "ewm",
    attrs: {
      "span": 10,
      "offset": 1
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.securityNumForm.mfaEwm,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.activeName === 'handleGet') ? _c('el-col', {
    staticClass: "hand-get handle",
    attrs: {
      "span": 10,
      "offset": 1
    }
  }, [_c('p', [_c('translate', [_vm._v("Authentication information")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("user name")]), _vm._v(": " + _vm._s(_vm.secret.account))], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("Key")]), _vm._v(": " + _vm._s(_vm.secret.secret))], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("Please enter the above information manually in the MFA application to obtain the security code")])], 1)]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.changeInfo) ? _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onChangeInfo()
      }
    }
  }, [_c('translate', [_vm._v("Confirm")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.bindMfa = false
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.changeInfo) ? _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onConfirmOpen()
      }
    }
  }, [_c('translate', [_vm._v("Confirm To Open")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.bindMfa = false;
        _vm.changeInfo = true
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(59)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Powered by\n      "), _c('a', {
    staticClass: "text-primary new-block",
    attrs: {
      "href": "https://cloudcare.cn/",
      "target": "_blank"
    }
  }, [_vm._v("cloudcare.cn")])])
}]}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseReport
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Generate Report")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_vm._v("\n    report\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": function($event) {
        _vm.onCloseChange()
      }
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Change Password")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "passForm",
    staticClass: "demo-ruleForm resetPassword-ruleForm",
    attrs: {
      "model": _vm.passWordForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.password,
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": _vm.attrText.password
    },
    model: {
      value: (_vm.passWordForm.pass),
      callback: function($$v) {
        _vm.passWordForm.pass = $$v
      },
      expression: "passWordForm.pass"
    }
  }), _vm._v(" "), _c('translate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_password_warning && _vm.company_password_strength == 1),
      expression: "show_password_warning && company_password_strength == 1"
    }]
  }, [_vm._v("The administrator has enabled the password strength setting. The password must be at least 6 characters long and must contain two of uppercase letters, lowercase letters, and special characters.")]), _vm._v(" "), _c('translate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_password_warning && _vm.company_password_strength == 2),
      expression: "show_password_warning && company_password_strength == 2"
    }]
  }, [_vm._v("The administrator has enabled the password strength setting. The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.repeatpass,
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": _vm.attrText.repeatpass
    },
    model: {
      value: (_vm.passWordForm.checkPass),
      callback: function($$v) {
        _vm.passWordForm.checkPass = $$v
      },
      expression: "passWordForm.checkPass"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('div', {
    staticClass: "btn-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmitForm('passForm')
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs.rightPanel.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel-add",
    attrs: {
      "datas": _vm.connects,
      "items": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitAddForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Add Team Member")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ssh-key"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_vm._v("SSH KEY")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowAdd()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('translate', [_vm._v("Add")])], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.sshKeyList,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name,
      "prop": "title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.latestVerifiTiem
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "log-list-name"
        }, [_c('p', [_vm._v(_vm._s(_vm._f("moment")(!scope.row.last_time ? '-' : scope.row.last_time * 1000, "YYYY-MM-DD HH:mm:ss")))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.addTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "log-list-name"
        }, [_c('p', [_vm._v(_vm._s(_vm._f("moment")(scope.row.create_time * 1000, "YYYY-MM-DD HH:mm:ss")))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delSshkey(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Delete")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.totalCount > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.totalCount,
      "current-page": _vm.currentPage,
      "page-size": 10
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.getSshKeys
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "log-content"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('h3', [_c('translate', [_vm._v("Viewing Of Log Content")])], 1), _vm._v(" "), _c('div', [_c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.logContent),
      expression: "logContent",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }],
    attrs: {
      "type": "text"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.downLoad()
      }
    }
  }, [_c('translate', [_vm._v("Download")])], 1)], 1)]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.logContent))]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "日志解冻",
      "visible": _vm.freezeShow,
      "top": "20px"
    },
    on: {
      "update:visible": function($event) {
        _vm.freezeShow = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pollingLoading),
      expression: "pollingLoading"
    }],
    staticClass: "dialog-content",
    attrs: {
      "element-loading-text": "日志正在解冻中，请稍等..."
    }
  }, [(_vm.pollingCode == 'OSSFileAvailable') ? _c('p', {
    staticClass: "text"
  }, [_vm._v("解冻完成，文件正在下载...")]) : _c('p', {
    staticClass: "text"
  }, [_vm._v("检测到您所选择的日志文件目前处于\"冷冻\"归档状态，如您需要继续\"下载\"，请点击\"确认\"发起解冻请求。日志文件\"解冻\"通常需要5-10分钟左右，请耐心等待。")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.pollingLoading,
      "link": ""
    },
    on: {
      "click": function($event) {
        _vm.freezeShow = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.pollingLoading || _vm.pollingCode == 'OSSFileArchived') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.pollingLoading
    },
    on: {
      "click": _vm.handleFreezeConfirm
    }
  }, [_vm._v("确认")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Connect Logs")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "work-log-view",
    attrs: {
      "infinite-scroll-disabled": "busy",
      "infinite-scroll-distance": "10"
    },
    slot: "content"
  }, [_c('el-row', {
    staticClass: "connect-log-row log-title",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "p-l-5",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("UserName")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('translate', [_vm._v("Connection IP")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('translate', [_vm._v("Connection Time")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('translate', [_vm._v("Duration")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('translate', [_vm._v("Action")])], 1)], 1), _vm._v(" "), (_vm.logs && _vm.logs.length < 1) ? _c('el-row', {
    staticClass: "connect-log-row",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "no-data"
  }, [_c('translate', [_vm._v("No Data")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.logs) ? _c('el-row', {
    staticClass: "connect-log-row",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('img', {
    staticClass: "loading",
    attrs: {
      "src": __webpack_require__(89)
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.logs), function(log) {
    return (_vm.logs && _vm.logs.length > 0) ? _c('el-row', {
      key: log.id,
      staticClass: "connect-log-row",
      attrs: {
        "type": "flex",
        "justify": "center"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "avatar-box"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm._f("resetURL")(log.avatar),
        "border": "0"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pull-left avatar-info"
    }, [_c('div', {
      staticClass: "wrap"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(log.account_name) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "p-t-5 text-ellipsis"
    }, [_vm._v(_vm._s(log.account))])])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('div', {
      staticStyle: {
        "color": "red",
        "line-height": "36px"
      }
    }, [(log.unsafe_mode === 1) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": _vm.attrText.unsafeMode,
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle warn"
    })]) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
      staticClass: "flex-box",
      attrs: {
        "span": 5
      }
    }, [_c('span', [_vm._v(_vm._s(log.client_ip_address || '-'))])]), _vm._v(" "), _c('el-col', {
      staticClass: "flex-box text-center",
      attrs: {
        "span": 5
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("moment")((log.start_date * 1000), 'YYYY-MM-DD HH:mm:ss')))])]), _vm._v(" "), _c('el-col', {
      staticClass: "flex-box text-right",
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(log.totalTime))]), _vm._v(" "), _c('el-col', {
      staticClass: "flex-box text-center",
      attrs: {
        "span": 3
      }
    }, [(log.way != 'rds' && log.way != 'mysql' && log.way != 'mssql' && log.way != 'postgresql' && log.way != 'oracle' && log.way != 'transfer' && log.play != 0 && log.date > log.start_date) ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": log.playbackLink
      }
    }, [_c('translate', [_vm._v("Play")])], 1) : _vm._e(), _vm._v(" "), (log.way == 'transfer') ? _c('a', {
      staticClass: "view-url",
      on: {
        "click": function($event) {
          _vm.viewLog(log)
        }
      }
    }, [_c('translate', [_vm._v("View")])], 1) : _vm._e(), _vm._v(" "), ((log.way == 'rds' || log.way == 'mysql' || log.way == 'mssql' || log.way == 'postgresql' || log.way == 'oracle') && log.date >= log.start_date) ? _c('a', {
      attrs: {
        "href": log.downloadLink
      }
    }, [_c('translate', [_vm._v("Download")])], 1) : _vm._e()])], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onShowAll()
      }
    }
  }, [_c('translate', [_vm._v("Show All")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "my-sql-apply-modal",
    attrs: {
      "datas": _vm.mySqlDetailObj,
      "hideFooter": _vm.mySqlDetailObj && _vm.mySqlDetailObj.isHideFooter
    },
    on: {
      "onClose": function($event) {
        _vm.onClose()
      }
    }
  }, [(_vm.mySqlDetailObj) ? _c('div', {
    slot: "header"
  }, [(_vm.mySqlDetailObj.viewType === 'my') ? _c('div', [_c('translate', [_vm._v("The Details Of My Application")])], 1) : _vm._e(), _vm._v(" "), (_vm.mySqlDetailObj.viewType !== 'my') ? _c('div', [_c('translate', [_vm._v("Show The Details Of The Application")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mySqlDetailObj) ? _c('div', {
    slot: "content"
  }, [_c('div', {
    staticClass: "mySqlDatail"
  }, [(_vm.mySqlDetailObj.viewType === 'my' && _vm.mySqlDetailObj.status !== 'approving') ? _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Approver")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_vm._v(_vm._s(_vm.mySqlDetailObj.approved_account.name) + " (" + _vm._s(_vm.mySqlDetailObj.approved_account.account) + ")")])], 1) : _vm._e(), _vm._v(" "), (_vm.mySqlDetailObj.viewType !== 'my') ? _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Applyer")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.mySqlDetailObj.application_account.name) + "(" + _vm._s(_vm.mySqlDetailObj.application_account.account) + ")")])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Resource")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_vm._v(_vm._s(_vm.mySqlDetailObj.resource.name) + "(" + _vm._s(_vm.mySqlDetailObj.resource.ip_address) + ")")])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Target DataBase")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_vm._v(_vm._s(_vm.mySqlDetailObj.database || '-'))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Project")]), _c('span')], 1), _vm._v(" "), (_vm.mySqlDetailObj.project) ? _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_vm._v(_vm._s(_vm.mySqlDetailObj.project.project_name))]) : _vm._e(), _vm._v(" "), (!_vm.mySqlDetailObj.project) ? _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_vm._v("-")]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Status")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_vm._v(_vm._s(_vm.sqlApplyStatusText[_vm.mySqlDetailObj.status] || _vm.mySqlDetailObj.status))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Create Time")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_vm._v(_vm._s(_vm._f("moment")((_vm.mySqlDetailObj.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("SQL:")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_vm._v(_vm._s(_vm.mySqlDetailObj.sql))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('img', {
    staticStyle: {
      "width": "17px",
      "cursor": "pointer",
      "margin-right": "5px"
    },
    attrs: {
      "src": __webpack_require__(167),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.previewSQL()
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.mySqlDetailObj.sql),
      expression: "mySqlDetailObj.sql",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticStyle: {
      "width": "17px",
      "cursor": "pointer"
    },
    attrs: {
      "src": __webpack_require__(166),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Comment")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_vm._v(_vm._s(_vm.mySqlDetailObj.comment))])], 1), _vm._v(" "), (_vm.mySqlDetailObj.status === 'failed') ? _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("reason")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_vm._v(_vm._s(_vm.mySqlDetailObj.result ? _vm.mySqlDetailObj.result : 'Unknown cause'))])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [(_vm.mySqlDetailObj) ? _c('div', [(_vm.mySqlDetailObj.viewType === 'my' && _vm.mySqlDetailObj.status === 'approving') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cancelSqlApply(_vm.mySqlDetailObj.id)
      }
    }
  }, [_c('translate', [_vm._v("Cancel the application")])], 1) : _vm._e(), _vm._v(" "), (_vm.mySqlDetailObj.viewType === 'approve' && _vm.mySqlDetailObj.status === 'approving') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.doExecute(_vm.mySqlDetailObj.id)
      }
    }
  }, [_c('translate', [_vm._v("Execute")])], 1) : _vm._e(), _vm._v(" "), (_vm.mySqlDetailObj.viewType === 'approve' && _vm.mySqlDetailObj.status === 'approving') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.doReject(_vm.mySqlDetailObj.id)
      }
    }
  }, [_c('translate', [_vm._v("Reject")])], 1) : _vm._e()], 1) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-titel"
  }, [_c('translate', [_vm._v("Verify the MFA device")])], 1), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.enterCode
    },
    on: {
      "change": _vm.onInputCode
    },
    model: {
      value: (_vm.securityCode),
      callback: function($$v) {
        _vm.securityCode = $$v
      },
      expression: "securityCode"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "submitBtn",
    attrs: {
      "type": "primary",
      "disabled": !_vm.isCansubmit
    },
    on: {
      "click": function($event) {
        _vm.onSubmitVerify()
      }
    }
  }, [_c('translate', [_vm._v("Submit validation")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.bindMfa = true
      }
    }
  }, [_c('translate', [_vm._v("(MFA verify notes)")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "copyright clearfix small"
  }, [_c('div', [_vm._v("Copyright 2013-2017 "), _c('translate', [_vm._v("Shanghai Zhuyun Information Technology Co.,Ltd")])], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "MFA验证须知",
      "visible": _vm.bindMfa
    },
    on: {
      "update:visible": function($event) {
        _vm.bindMfa = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("1. You must install the MFA application on your smart device to continue.")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("2. Common applications that support MFA on smart devices are ")]), _c('a', {
    staticStyle: {
      "color": "#20a0ff"
    },
    attrs: {
      "href": "https://promotion.aliyun.com/ntms/mobile.html",
      "target": "view_window"
    }
  }, [_c('translate', [_vm._v("Identity")])], 1), _c('translate', [_vm._v(", Microsoft Authenticator, Google Authenticator.")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("3. If your account has been shared by multiple people, then when you successfully bind MFA, other unbound MFA people will not be able to log in. The solution is to let other people also install the MFA application and scan the 2D code for this page, or save the 2D code picture for others to follow the sweep. But from the security best practice, we recommend that you cancel the multiplayer account.")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("4. If you can not verify for some reason, such as missing or mistakenly deleted MFA applications, you can manually unmarshal MFA binding by dialing 021-50653160.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.bindMfa = false
      }
    }
  }, [_c('translate', [_vm._v("Comfirm")])], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(59)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Powered by\n      "), _c('a', {
    staticClass: "text-primary new-block",
    attrs: {
      "href": "https://cloudcare.cn/",
      "target": "_blank"
    }
  }, [_vm._v("cloudcare.cn")])])
}]}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    ref: "chart"
  })])
},staticRenderFns: []}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "rightPanelSet",
    attrs: {
      "datas": _vm.memberInfo
    },
    on: {
      "onClose": function($event) {
        _vm.onCloseForm()
      },
      "onSubmit": function($event) {
        _vm.onChangeMember(_vm.memberInfo.id, 'setMemberForm')
      }
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Base Info")])], 1), _vm._v(" "), (_vm.memberInfo) ? _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('div', {
    staticClass: "detail-wrapper"
  }, [_c('el-form', {
    ref: "setMemberForm",
    staticClass: "demo-ruleForm team-MemberForm",
    attrs: {
      "model": _vm.setMember,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    class: [1, 3].includes(_vm.$store.getters.account.is_admin) ? '' : 'fixed-text',
    attrs: {
      "label": _vm.attrText.displayNickname
    }
  }, [([1, 3].includes(_vm.$store.getters.account.is_admin)) ? _c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.setMember.name),
      callback: function($$v) {
        _vm.setMember.name = $$v
      },
      expression: "setMember.name"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.memberInfo.name))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fixed-text",
    attrs: {
      "label": _vm.attrText.account
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.memberInfo.account) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.pwd,
      "prop": "password"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "password"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.attrText.empty,
      "auto-complete": "new-password",
      "name": "new-password"
    },
    model: {
      value: (_vm.setMember.password),
      callback: function($$v) {
        _vm.setMember.password = $$v
      },
      expression: "setMember.password"
    }
  }), _vm._v(" "), _c('translate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_password_warning && _vm.company_password_strength == 1),
      expression: "show_password_warning && company_password_strength == 1"
    }]
  }, [_vm._v("The administrator has enabled the password strength setting. The password must be at least 6 characters long and must contain two of uppercase letters, lowercase letters, and special characters.")]), _vm._v(" "), _c('translate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_password_warning && _vm.company_password_strength == 2),
      expression: "show_password_warning && company_password_strength == 2"
    }]
  }, [_vm._v("The administrator has enabled the password strength setting. The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.repwd,
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "new-password",
      "name": "new-password-check"
    },
    model: {
      value: (_vm.setMember.checkPass),
      callback: function($$v) {
        _vm.setMember.checkPass = $$v
      },
      expression: "setMember.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select-role",
    attrs: {
      "label": _vm.attrText.role
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.memberInfo.id === _vm.$store.getters.account.id || _vm.memberInfo.account === _vm.$store.getters.team.setting.email,
      "placeholder": _vm.attrText.selectRole
    },
    model: {
      value: (_vm.setMember.is_admin),
      callback: function($$v) {
        _vm.setMember.is_admin = $$v
      },
      expression: "setMember.is_admin"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.admin,
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.optAdmin,
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.auditAdmin,
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.safeAdmin,
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.ordinary,
      "value": "0"
    }
  })], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onChangeMember(_vm.memberInfo.id, 'setMemberForm')
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs.rightPanelSet.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": function($event) {
        _vm.onCloseChange()
      }
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Log Detail")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [(_vm.connects) ? _c('div', {
    staticClass: "alarmLogDetail"
  }, [_c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Operation Time")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.connects.operation_time))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Users")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.connects.account_name))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Source IP")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.connects.con_ip))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Operation Obj")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.connects.resource_name))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("In Work Group")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.connects.project_name))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Connect Type")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.connects.way))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Trigger Strategy")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.connects.match_command))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Event Desc")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.connects.command))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('img', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.connects.command),
      expression: "connects.command",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticStyle: {
      "width": "17px",
      "cursor": "pointer"
    },
    attrs: {
      "src": __webpack_require__(166),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Notify Obj")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [(_vm.connects.notice_accounts) ? _c('div', _vm._l((JSON.parse(_vm.connects.notice_accounts)), function(i) {
    return _c('p', {
      key: i
    }, [_vm._v(_vm._s(i))])
  })) : _vm._e()])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('div', {
    staticClass: "btn-wrapper"
  })])])
},staticRenderFns: []}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload",
    class: _vm.fileInfo ? 'disabled' : ''
  }, [_c('a', {
    staticClass: "a-upload",
    class: _vm.fileInfo ? 'disabled' : '',
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('translate', [_vm._v("Choose File")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "disabled": _vm.fileInfo,
      "id": "file",
      "accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    on: {
      "change": _vm.onChange
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "log"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Log")])], 1), _vm._v(" "), _c('div', {
    staticClass: "log-search"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": _vm.attrText.command
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearch(_vm.searchForm)
      }
    },
    model: {
      value: (_vm.searchForm.keywords),
      callback: function($$v) {
        _vm.searchForm.keywords = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "searchForm.keywords"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    on: {
      "click": function($event) {
        _vm.onSearch(_vm.searchForm)
      }
    }
  }, [_c('translate', [_vm._v("Search")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowLogSearch()
      }
    }
  }, [_c('translate', [_vm._v("Advanced Search")])], 1), _vm._v(" "), _c('div', {
    staticClass: "search-right"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.getTranTest(_vm.log.totalNum)) + "\n\t\t\t\t\t"), _c('a', {
    attrs: {
      "href": _vm.importUrl,
      "disabled": !_vm.log.totalNum,
      "target": "_blank"
    }
  }, [_c('translate', [_vm._v("Download Report")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#20a0ff",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.videoReply
    }
  }, [_c('translate', [_vm._v("Video Reply")])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper"
  }, [(_vm.log.tags.length) ? _c('div', {
    staticClass: "searchTag"
  }, _vm._l((_vm.log.tags), function(tag, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "closable": true
      },
      on: {
        "close": function($event) {
          _vm.onCloseTag(tag)
        }
      }
    }, [(tag.val == 'transfer') ? _c('span', [_vm._v(_vm._s(((tag.text) + ":文件传输")))]) : _c('span', [_vm._v(_vm._s(tag.key === 'unsafe_mode' ? tag.text : ((tag.text) + ":" + (tag.val))))])])
  })) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.log.list,
      "height": _vm.tableMaxHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.operator
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "avatar-wrapper"
        }, [_c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.avatar)
          }
        }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(scope.row.account_name) + "（" + _vm._s(scope.row.client_ip_address) + "）")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.account))])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.workgroup,
      "prop": "project_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.operationObj
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-start"
        }, [(scope.row.os === 'linux') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Linux",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin": "3px 5px 0 0"
          },
          attrs: {
            "src": "../../../static/images/linux.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os === 'win32') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Windows",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin": "3px 5px 0 0"
          },
          attrs: {
            "src": "../../../static/images/win32.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'postgresql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "PostgreSQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin": "3px 5px 0 0"
          },
          attrs: {
            "src": "../../../static/images/postgresql.png",
            "width": "16",
            "height": "16",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mysql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MySQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin": "3px 5px 0 0"
          },
          attrs: {
            "src": "../../../static/images/mysql.png",
            "alt": "",
            "width": "16",
            "height": "16"
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mssql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "SQL Server",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin": "3px 5px 0 0"
          },
          attrs: {
            "src": "../../../static/images/mssql.png",
            "alt": "",
            "width": "16",
            "height": "14"
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'oracle') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Oracle",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin": "3px 5px 0 0"
          },
          attrs: {
            "src": "../../../static/images/oracle.png",
            "alt": "",
            "width": "16",
            "height": "14"
          }
        })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.resource_name) + "（" + _vm._s(scope.row.resource_ip_address) + "）")])], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(scope.row.login_username || '-'))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin": "0 5px"
          }
        }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.wayMap(scope.row.way)))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.operationTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("开始：" + _vm._s(_vm._f("moment")((scope.row.start_date * 1000), 'YYYY-MM-DD HH:mm:ss')))]), _vm._v(" "), _c('p', [_vm._v("结束：" + _vm._s(_vm._f("moment")((scope.row.date * 1000), 'YYYY-MM-DD HH:mm:ss')))]), _vm._v(" "), _c('p', [_vm._v("时长：" + _vm._s(_vm.durTime(scope.row.date, scope.row.start_date)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.way != 'rds' && scope.row.way != 'mysql' && scope.row.way != 'mssql' && scope.row.way !== 'transfer' && scope.row.way != 'postgresql' && scope.row.way != 'oracle' && scope.row.play != 0) ? _c('a', {
          staticClass: "play play-url",
          attrs: {
            "href": scope.row.playbackLink,
            "target": "_blank"
          }
        }, [_c('translate', [_vm._v("Play")])], 1) : _vm._e(), _vm._v(" "), (scope.row.way != 'rdp') ? _c('a', {
          staticClass: "view-url",
          on: {
            "click": function($event) {
              _vm.viewLog(scope.row, false)
            }
          }
        }, [_c('translate', [_vm._v("View")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "down-url",
          on: {
            "click": function($event) {
              _vm.downLog(scope.row, false)
            }
          }
        }, [_c('translate', [_vm._v("Download")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.log.totalPage > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.log.totalPage,
      "page-size": 10,
      "current-page": _vm.log.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.log.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.onSearch
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "日志解冻",
      "visible": _vm.freezeShow,
      "top": "20px"
    },
    on: {
      "update:visible": function($event) {
        _vm.freezeShow = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pollingLoading),
      expression: "pollingLoading"
    }],
    staticClass: "dialog-content",
    attrs: {
      "element-loading-text": "日志正在解冻中，请稍等..."
    }
  }, [(_vm.pollingCode == 'OSSFileAvailable') ? _c('p', {
    staticClass: "text"
  }, [_vm._v("解冻完成，文件正在下载...")]) : _c('p', {
    staticClass: "text"
  }, [_vm._v("检测到您所选择的日志文件目前处于\"冷冻\"归档状态，如您需要继续\"下载\"，请点击\"确认\"发起解冻请求。日志文件\"解冻\"通常需要5-10分钟左右，请耐心等待。")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.pollingLoading,
      "link": ""
    },
    on: {
      "click": function($event) {
        _vm.freezeShow = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.pollingLoading || _vm.pollingCode == 'OSSFileArchived') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.pollingLoading
    },
    on: {
      "click": _vm.handleFreezeConfirm
    }
  }, [_vm._v("确认")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "日志内容查看",
      "visible": _vm.viewLogShow,
      "width": "90%",
      "top": "20px"
    },
    on: {
      "update:visible": function($event) {
        _vm.viewLogShow = $event
      },
      "close": _vm.closeViewLogDialog
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.viewLogLoading),
      expression: "viewLogLoading"
    }],
    staticClass: "log-view-content",
    attrs: {
      "element-loading-text": "加载日志内容中..."
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.logContent))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.logContent),
      expression: "logContent",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.viewLogShow = false
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCsos),
      expression: "showCsos"
    }]
  }, [(_vm.showCsos) ? _c('router-view') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sql-editor"
  }, [_c('div', {
    staticClass: "header-tools"
  }, [_c('ul', {
    staticClass: "tools-list"
  }, [_c('li', {
    staticClass: "tools-item",
    on: {
      "click": _vm.onFormatSQL
    }
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v("\n\t\t\t\t格式化\n\t\t\t")])])]), _vm._v(" "), _c('textarea', {
    ref: "codeMirror"
  })])
},staticRenderFns: []}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.resourceId
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitForm
    }
  }, [_c('div', {
    slot: "header"
  }, [(!_vm.moreForm.moreSet) ? _c('translate', [_vm._v("Basic information")]) : _vm._e(), _vm._v(" "), (_vm.moreForm.moreSet) ? _c('translate', [_vm._v("SQL Application")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [(!_vm.moreForm.moreSet) ? _c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.resourceName,
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.parentId
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.addForm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.innerIp
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.ipAddress),
      callback: function($$v) {
        _vm.addForm.ipAddress = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.ipAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.port
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.port),
      callback: function($$v) {
        _vm.addForm.port = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.port"
    }
  })], 1), _vm._v(" "), (_vm.addForm.os === 'oracle') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.connectIdentifierType,
      "prop": "serviceNameType"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.parentId
    },
    model: {
      value: (_vm.addForm.serviceNameType),
      callback: function($$v) {
        _vm.addForm.serviceNameType = $$v
      },
      expression: "addForm.serviceNameType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Service Name",
      "value": "service_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SID",
      "value": "sid"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.os === 'oracle') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.connectIdentifier,
      "prop": "serviceName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.serviceName),
      callback: function($$v) {
        _vm.addForm.serviceName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.serviceName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "word-wrap": "break-word"
    },
    attrs: {
      "label": _vm.attrText.database,
      "prop": "database"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.database),
      callback: function($$v) {
        _vm.addForm.database = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.database"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.os
    }
  }, [(_vm.addForm.os === 'mssql') ? _c('span', [_vm._v("SQL Server")]) : (_vm.addForm.os === 'postgresql') ? _c('span', [_vm._v("PostgreSQL")]) : (_vm.addForm.os === 'oracle') ? _c('span', [_vm._v("Oracle")]) : _c('span', [_vm._v("MySQL")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.userName
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disEditUsername
    },
    model: {
      value: (_vm.addForm.username),
      callback: function($$v) {
        _vm.addForm.username = $$v
      },
      expression: "addForm.username"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.parentId
    },
    on: {
      "click": function($event) {
        _vm.disEditUsername = !_vm.disEditUsername
        _vm.addForm.username = _vm.databaseObj.username
      }
    }
  }, [(_vm.disEditUsername) ? _c('translate', [_vm._v("Change")]) : _c('translate', [_vm._v("Cancel")])], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.password
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "如无需修改密码，则密码留空。",
      "disabled": _vm.disEditPassword
    },
    model: {
      value: (_vm.addForm.password),
      callback: function($$v) {
        _vm.addForm.password = $$v
      },
      expression: "addForm.password"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.parentId
    },
    on: {
      "click": function($event) {
        _vm.disEditPassword = !_vm.disEditPassword
        _vm.addForm.password = ''
      }
    }
  }, [(_vm.disEditPassword) ? _c('translate', [_vm._v("Change")]) : _c('translate', [_vm._v("Cancel")])], 1)], 1)]), _vm._v(" "), _c('a', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.moreForm.moreSet = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("More")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "database-wrapper"
  }, [(_vm.moreForm.moreSet) ? _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.moreForm,
      "label-width": "120px",
      "show-message": false
    }
  }, [(!_vm.parentId) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.interceptionCommand
    }
  }, [_c('el-select', {
    staticClass: "inter-select",
    attrs: {
      "placeholder": _vm.attrText.select
    },
    model: {
      value: (_vm.moreForm.action),
      callback: function($$v) {
        _vm.moreForm.action = $$v
      },
      expression: "moreForm.action"
    }
  }, _vm._l((_vm.moreForm.interceptsCommand), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item[0],
        "value": item[0]
      }
    })
  })), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.tableName,
      "disabled": _vm.addTable
    },
    model: {
      value: (_vm.moreForm.cellName),
      callback: function($$v) {
        _vm.moreForm.cellName = $$v
      },
      expression: "moreForm.cellName"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "offset": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.moreForm.action === ''
    },
    on: {
      "click": function($event) {
        _vm.addCommand()
      }
    }
  }, [_c('translate', [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-command"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.moreForm.interception,
      "stripe": "",
      "empty-text": _vm.attrText.notCommand
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "op",
      "label": _vm.attrText.command
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "table",
      "label": _vm.attrText.tableName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.table ? scope.row.table : 'All') + "\n\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.moreForm.setRadio === '0'
          },
          on: {
            "click": function($event) {
              _vm.removeCommand(scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.sqlApprover
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1",
      "disabled": _vm.moreForm.setRadio === '0'
    },
    model: {
      value: (_vm.moreForm.sqlApprover),
      callback: function($$v) {
        _vm.moreForm.sqlApprover = $$v
      },
      expression: "moreForm.sqlApprover"
    }
  }, [_c('translate', [_vm._v("on")])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0",
      "disabled": _vm.moreForm.setRadio === '0'
    },
    model: {
      value: (_vm.moreForm.sqlApprover),
      callback: function($$v) {
        _vm.moreForm.sqlApprover = $$v
      },
      expression: "moreForm.sqlApprover"
    }
  }, [_c('translate', [_vm._v("off")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.approver
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.attrText.selected,
      "disabled": _vm.moreForm.sqlApprover === '0'
    },
    model: {
      value: (_vm.moreForm.name),
      callback: function($$v) {
        _vm.moreForm.name = $$v
      },
      expression: "moreForm.name"
    }
  }, _vm._l((_vm.moreForm.nameList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": ((item.name) + "(" + (item.account) + ")"),
        "value": item.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "offset": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.moreForm.sqlApprover === '0'
    },
    on: {
      "click": function($event) {
        _vm.addApprover()
      }
    }
  }, [_c('translate', [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.moreForm.approver,
      "stripe": "",
      "empty-text": _vm.attrText.noApprover
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.attrText.approver
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.moreForm.sqlApprover === '0'
          },
          on: {
            "click": function($event) {
              _vm.removeApprover(scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.sqlAlarmIntruct
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.moreForm.sqlAlarmIntruct),
      callback: function($$v) {
        _vm.moreForm.sqlAlarmIntruct = $$v
      },
      expression: "moreForm.sqlAlarmIntruct"
    }
  }, [_c('translate', [_vm._v("on")])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.moreForm.sqlAlarmIntruct),
      callback: function($$v) {
        _vm.moreForm.sqlAlarmIntruct = $$v
      },
      expression: "moreForm.sqlAlarmIntruct"
    }
  }, [_c('translate', [_vm._v("off")])], 1)], 1), _vm._v(" "), (!_vm.parentId) ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.alarmInstruction
    }
  }, [_c('el-select', {
    staticClass: "inter-select",
    attrs: {
      "placeholder": _vm.attrText.select,
      "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
    },
    model: {
      value: (_vm.moreForm.alarmAction),
      callback: function($$v) {
        _vm.moreForm.alarmAction = $$v
      },
      expression: "moreForm.alarmAction"
    }
  }, _vm._l((_vm.moreForm.interceptsCommand), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item[0],
        "value": item[0]
      }
    })
  })), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.tableName,
      "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
    },
    model: {
      value: (_vm.moreForm.alarmCellName),
      callback: function($$v) {
        _vm.moreForm.alarmCellName = $$v
      },
      expression: "moreForm.alarmCellName"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "offset": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
    },
    on: {
      "click": function($event) {
        _vm.addAlarmCommand()
      }
    }
  }, [_c('translate', [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-command"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.moreForm.alarmInterception,
      "stripe": "",
      "empty-text": _vm.attrText.notAlarmCommand
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "op",
      "label": _vm.attrText.command
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "table",
      "label": _vm.attrText.tableName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.table ? scope.row.table : 'All') + "\n\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
          },
          on: {
            "click": function($event) {
              _vm.removeAlarmCommand(scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.notifier
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.attrText.selected,
      "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
    },
    model: {
      value: (_vm.moreForm.notifier),
      callback: function($$v) {
        _vm.moreForm.notifier = $$v
      },
      expression: "moreForm.notifier"
    }
  }, _vm._l((_vm.moreForm.nameList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": ((item.name) + "(" + (item.account) + ")"),
        "value": item.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "offset": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
    },
    on: {
      "click": function($event) {
        _vm.addNotifier()
      }
    }
  }, [_c('translate', [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.moreForm.notifierList,
      "stripe": "",
      "empty-text": _vm.attrText.noNotifier
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.attrText.notifier
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.moreForm.sqlAlarmIntruct === '0'
          },
          on: {
            "click": function($event) {
              _vm.removeNotifier(scope.$index)
            }
          }
        }, [_c('translate', [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": (_vm.moreForm.sqlApprover === '1' && _vm.moreForm.approver.length === 0) || (_vm.moreForm.sqlAlarmIntruct === '1' && (_vm.moreForm.notifierList.length === 0 || _vm.moreForm.alarmInterception.length === 0))
    },
    on: {
      "click": function($event) {
        _vm.onSubmitForm()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cluster"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Cluster List")])], 1), _vm._v(" "), _c('div', {
    staticClass: "cluster-wrapper"
  }, [_c('div', {
    staticClass: "add-cluster"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowCreateCluster()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('translate', [_vm._v("New cluster")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-select', {
    staticClass: "searchSelect",
    attrs: {
      "placeholder": _vm.attrText.select
    },
    on: {
      "change": _vm.clearSearchInput
    },
    model: {
      value: (_vm.search.condition),
      callback: function($$v) {
        _vm.search.condition = $$v
      },
      expression: "search.condition"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.name,
      "value": "q_name"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "disabled": !_vm.search.condition
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearch()
      }
    },
    model: {
      value: (_vm.search.name),
      callback: function($$v) {
        _vm.search.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "search.name"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    on: {
      "click": _vm.onSearch
    }
  }, [_c('translate', [_vm._v("Search")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.cluster.list,
      "show-header": false,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'clusterDetail',
              params: {
                id: scope.row.id
              },
              query: {
                type: scope.row.agent_version ? (_vm.isNewVersion(scope.row.agent_version) || scope.row.parent_id ? 'ecs' : 'settings') : 'settings'
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.name) + "\n\t\t\t\t\t\t")])], 1), _vm._v(" "), (scope.row.parent_id) ? _c('span', {
          staticClass: "share-cluster"
        }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(("( " + (scope.row.parent_company.full_name) + " )")) + "\n\t\t\t\t\t\t"), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.shareCluster,
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-share-alt-square"
        })])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: scope.row.agent_status === 1 ? 'available' : 'unavailable'
        }, [_c('i', {
          staticClass: "fa fa-lg",
          class: scope.row.agent_status === 1 ? 'fa-check-circle-o' : 'fa-times-circle-o'
        }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(scope.row.agent_status === 1 ? _vm.attrText.available : _vm.attrText.unavailable) + "\n\t\t\t\t\t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.getTranTest(scope.row.resource_count)) + "\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.agent_version && !_vm.isNewVersion(scope.row.agent_version) && !scope.row.parent_id) ? _c('p', [_c('i', {
          staticClass: "el-icon-warning",
          staticStyle: {
            "color": "#fda541",
            "font-size": "14px",
            "top": "2px"
          }
        }), _vm._v(" "), _c('translate', {
          staticStyle: {
            "color": "#fda541"
          }
        }, [_vm._v("The current control node agent is lower, please update")])], 1) : _vm._e(), _vm._v(" "), (!scope.row.agent_version || _vm.isNewVersion(scope.row.agent_version) || scope.row.parent_id) ? _c('p', [_vm._v("-")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "text-right",
    attrs: {
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.exportCluster(scope.row.project_id)
            }
          }
        }, [_c('translate', [_vm._v("Export")])], 1), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              name: 'clusterDetail',
              params: {
                id: scope.row.id
              },
              query: {
                type: scope.row.agent_version ? (_vm.isNewVersion(scope.row.agent_version) || scope.row.parent_id ? 'ecs' : 'settings') : 'settings'
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('translate', [_vm._v("Details")])], 1)], 1), _vm._v(" "), (scope.row.parent_id) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.returnCluster(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Return")])], 1) : _vm._e(), _vm._v(" "), (!scope.row.parent_id) ? _c('el-button', {
          attrs: {
            "type": "text",
            "loading": scope.row.deleting
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteCluster(scope.row)
            }
          }
        }, [(!scope.row.deleting) ? _c('translate', [_vm._v("Delete")]) : _vm._e()], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.cluster.totalPage > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.cluster.totalPage,
      "page-size": 10,
      "current-page": _vm.cluster.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.cluster.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.getClusterList
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects,
      "hideFooter": true
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Online Sessions")])], 1), _vm._v(" "), _c('div', {
    staticClass: "online",
    slot: "content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.onlineConnection
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.member
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "account-photo",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.account.avatar)
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.account.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "20",
      "label": " "
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(!scope.row.safe_mode) ? _c('el-tooltip', {
          staticClass: "unsafe-icon",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.unsafeMode,
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-exclamation-circle warn"
        })]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tunnel_code",
      "label": "Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.wetty_ip ? scope.row.wetty_ip : scope.row.peer_ip) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": _vm.attrText.createTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "width": "80px",
            "white-space": "normal"
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("moment")(scope.row.create_time * 1000, 'YYYY-MM-DD HH:mm:ss')) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(_vm.resourceType === 'ecs' && scope.row.agentVersion < '3.0.0') ? _c('el-button', {
          attrs: {
            "disabled": !(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp)),
            "type": "text",
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              _vm.onLinkhref(scope.row.linkHref)
            }
          }
        }, [_c('translate', [_vm._v("Monitor")])], 1) : _vm._e(), _vm._v(" "), (_vm.resourceType === 'ecs' && scope.row.agentVersion >= '3.0.0') ? _c('el-button', {
          attrs: {
            "disabled": !(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp)),
            "type": "text",
            "target": "_blank"
          }
        }, [(scope.row.way === 'terminal' || scope.row.way === 'wetty') ? _c('span', {
          on: {
            "click": function($event) {
              _vm.createShadow(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("assistance")])], 1) : _vm._e(), _vm._v(" "), ((scope.row.way === 'rdp' && scope.row.showRdp)) ? _c('span', {
          on: {
            "click": function($event) {
              _vm.onLinkhref(scope.row.linkHref)
            }
          }
        }, [_c('translate', [_vm._v("monitor")])], 1) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.cutOnline(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Disconnect")])], 1)]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects,
      "hideFooter": true
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [(_vm.connects) ? _c('div', {
    slot: "header"
  }, [_vm._v("\n    " + _vm._s(_vm.connects.assistType === 'Manual' ? _vm.attrText.manualAssist : _vm.attrText.operationAssist) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.initLoading) ? _c('div', {
    staticClass: "loading",
    slot: "content"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(89)
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initLoading) ? _c('div', {
    staticClass: "assist-content",
    slot: "content"
  }, [_c('translate', {
    staticClass: "tip-name",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Connection Info")]), _vm._v(" "), _c('div', {
    staticClass: "connect-detail"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "detail-tip",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Host")]), _vm._v("\n          :\n        ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.connectionInfo.host))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.connectionInfo.host),
      expression: "connectionInfo.host",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticClass: "copy",
    attrs: {
      "span": 4
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "detail-tip",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Port")]), _vm._v("\n          :\n        ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.connectionInfo.port))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.connectionInfo.port),
      expression: "connectionInfo.port",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticClass: "copy",
    attrs: {
      "span": 4
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "detail-tip",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Username")]), _vm._v("\n          :\n        ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.connectionInfo.username))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.connectionInfo.username),
      expression: "connectionInfo.username",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticClass: "copy",
    attrs: {
      "span": 4
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "detail-tip",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("SSH command")]), _vm._v("\n          :\n        ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.sshLink
    }
  }, [_vm._v(_vm._s(_vm.sshCommand))])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.sshCommand),
      expression: "sshCommand",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticClass: "copy",
    attrs: {
      "span": 4
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "detail-tip detail-usename",
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("Connect Username")]), _vm._v("\n          :\n        ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-input', {
    staticClass: "user-input",
    model: {
      value: (_vm.connectionInfo.defaultName),
      callback: function($$v) {
        _vm.connectionInfo.defaultName = $$v
      },
      expression: "connectionInfo.defaultName"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "copy",
    attrs: {
      "span": 4
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('el-button', {
    staticClass: "connect-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.connectHost()
      }
    }
  }, [_c('translate', [_vm._v("Connect")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "tip-name"
  }, [_c('translate', [_vm._v("Assistance Info")])], 1), _vm._v(" "), (_vm.connects && _vm.connects.assistType === 'Manual') ? _c('div', {
    staticClass: "get-assist-info"
  }, [(!_vm.assistInfo) ? _c('translate', {
    staticClass: "connect-host",
    attrs: {
      "tag": "h5"
    }
  }, [_vm._v("\n        Please connect to the host for assistance information\n      ")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "height": "300px"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.assistInfo) ? _c('el-button', {
    staticClass: "re-get",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.getAssistInfo(_vm.connectionInfo.code)
      }
    }
  }, [_c('translate', [_vm._v("Get Again")])], 1) : _vm._e(), _vm._v(" "), (_vm.assistInfo) ? _c('div', [_c('div', {
    staticClass: "assist-detail"
  }, [_c('translate', {
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Temporary assistance link are created successfully and can be sent to assistants!\n          ")]), _vm._v(" "), _c('p', [_c('translate', [_vm._v("Assistance address")]), _vm._v("\n            : " + _vm._s(_vm.assistLink) + " "), _c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.assistLink),
      expression: "assistLink",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    staticClass: "copy",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)], 1), _vm._v(" "), _c('translate', {
    staticClass: "tip-msg",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("\n            (Valid time:30 minutes or the main connection is disconnected)\n          ")])], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.connects && _vm.connects.assistType === 'Operation') ? _c('div', {
    staticClass: "get-assist-info"
  }, [_c('translate', {
    staticClass: "connect-host",
    attrs: {
      "tag": "h5"
    }
  }, [_vm._v("Please connect to the host for assistance information")]), _vm._v(" "), (!_vm.loading && !_vm.assistInfo) ? _c('el-button', {
    staticClass: "re-get",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.getAssistInfo(_vm.connectionInfo.code)
      }
    }
  }, [_c('translate', [_vm._v("Get Again")])], 1) : _vm._e(), _vm._v(" "), (_vm.loading && !_vm.assistInfo || _vm.assistInfo) ? _c('div', [_c('div', {
    staticClass: "assist-ewm"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "img-cover"
  }, [_c('img', {
    staticClass: "img-cover-bg",
    attrs: {
      "src": __webpack_require__(439),
      "width": "168",
      "height": "168"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-bg"
  }, [_c('div', {
    staticClass: "loadEffect"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])]) : _vm._e(), _vm._v(" "), (_vm.assistInfo) ? _c('qr-code', {
    staticClass: "ewm-img",
    attrs: {
      "text": _vm.assistInfo.url,
      "size": 150,
      "color": "#000",
      "bg-color": "#fff",
      "error-level": "L",
      "title": "333"
    }
  }) : _vm._e(), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Use the operation and maintenance assistant to scan the above two-dimensional code\n          ")]), _vm._v(" "), _c('translate', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Please download ")]), _vm._v(" "), _c('img', {
    staticClass: "app-store",
    attrs: {
      "src": __webpack_require__(438),
      "alt": "app 下载"
    }
  })], 1)]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Operation Statistic")])], 1), _vm._v(" "), _c('div', {
    staticClass: "view-content"
  }, [_c('div', {
    staticClass: "csos-tabs"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card",
      "active-name": _vm.activeTabName
    },
    on: {
      "tab-click": _vm.onChangeTab
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [(_vm.statistic.type != 'overview') ? _c('div', {
    staticClass: "clearfix panel-search"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "change": _vm.onChangeDateLen
    },
    model: {
      value: (_vm.statistic.dataLen),
      callback: function($$v) {
        _vm.statistic.dataLen = $$v
      },
      expression: "statistic.dataLen"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.within7Day,
      "value": 7
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.within30Day,
      "value": 30
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.within90Day,
      "value": 90
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.statistic.type === 'overview') ? _c('div', {
    staticClass: "filter-bar"
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_c('span', {
    staticClass: "filter-label"
  }, [_vm._v("成员")]), _vm._v(" "), _c('el-select', {
    staticClass: "filter-select",
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.summaryFilter.account_id),
      callback: function($$v) {
        _vm.summaryFilter.account_id = $$v
      },
      expression: "summaryFilter.account_id"
    }
  }, _vm._l((_vm.filterList.memberList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('span', {
    staticClass: "filter-label"
  }, [_vm._v("资源类型")]), _vm._v(" "), _c('el-select', {
    staticClass: "filter-select",
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.summaryFilter.resource_type),
      callback: function($$v) {
        _vm.summaryFilter.resource_type = $$v
      },
      expression: "summaryFilter.resource_type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Linux（SSH）",
      "value": "terminal"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Windows（RDP）",
      "value": "rdp"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "MySQL",
      "value": "mysql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SQL Server",
      "value": "mssql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "PostgreSQL",
      "value": "postgresql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Oracle",
      "value": "oracle"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('span', {
    staticClass: "filter-label"
  }, [_vm._v("工作组")]), _vm._v(" "), _c('el-select', {
    staticClass: "filter-select",
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.summaryFilter.project_id),
      callback: function($$v) {
        _vm.summaryFilter.project_id = $$v
      },
      expression: "summaryFilter.project_id"
    }
  }, _vm._l((_vm.filterList.workGroupList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('span', {
    staticClass: "filter-label"
  }, [_vm._v("集群")]), _vm._v(" "), _c('el-select', {
    staticClass: "filter-select",
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.summaryFilter.network_id),
      callback: function($$v) {
        _vm.summaryFilter.network_id = $$v
      },
      expression: "summaryFilter.network_id"
    }
  }, _vm._l((_vm.filterList.clusterList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('span', {
    staticClass: "filter-label"
  }, [_vm._v("资源")]), _vm._v(" "), _c('el-select', {
    staticClass: "filter-select",
    attrs: {
      "filterable": "",
      "clearable": "",
      "popper-class": "resource-select"
    },
    model: {
      value: (_vm.summaryFilter.resource_id),
      callback: function($$v) {
        _vm.summaryFilter.resource_id = $$v
      },
      expression: "summaryFilter.resource_id"
    }
  }, _vm._l((_vm.filterList.resourceList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.ip_address))])])
  }))], 1), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "选择日期范围",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.changeTimes
    },
    model: {
      value: (_vm.filterTimes),
      callback: function($$v) {
        _vm.filterTimes = $$v
      },
      expression: "filterTimes"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "export-btn",
    on: {
      "click": _vm.handleExport
    }
  }, [_vm._v("导出PDF")])], 1) : _vm._e(), _vm._v(" "), (_vm.statistic.type === 'resource') ? _c('div', [_c('el-button', {
    attrs: {
      "disabled": _vm.loading,
      "type": _vm.statistic.chart === 'networkproject' ? 'primary' : ''
    },
    on: {
      "click": function($event) {
        _vm.onChangeChart('networkproject')
      }
    }
  }, [_c('translate', [_vm._v("All")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading,
      "type": _vm.statistic.chart === 'network' ? 'primary' : ''
    },
    on: {
      "click": function($event) {
        _vm.onChangeChart('network')
      }
    }
  }, [_c('translate', [_vm._v("Cluster")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading,
      "type": _vm.statistic.chart === 'project' ? 'primary' : ''
    },
    on: {
      "click": function($event) {
        _vm.onChangeChart('project')
      }
    }
  }, [_c('translate', [_vm._v("WorkGroup")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.statistic.type === 'company') ? _c('div', [_c('el-button', {
    attrs: {
      "disabled": _vm.loading,
      "type": _vm.statistic.chart === 'connect' ? 'primary' : ''
    },
    on: {
      "click": function($event) {
        _vm.onChangeChart('connect')
      }
    }
  }, [_c('translate', [_vm._v("Numbers Of Connections")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading,
      "type": _vm.statistic.chart === 'dateLen' ? 'primary' : ''
    },
    on: {
      "click": function($event) {
        _vm.onChangeChart('dateLen')
      }
    }
  }, [_c('translate', [_vm._v("The Duration Of The Operation")])], 1)], 1) : _vm._e()])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.overview,
      "name": "overview"
    }
  }, [_c('statisticsOverview', {
    attrs: {
      "filter-params": _vm.summaryFilter
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.team,
      "name": "company"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "height": "300px"
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "chart-panel"
  }, [(_vm.statistic.chart === 'connect') ? _c('div', {
    staticClass: "total-chart chart"
  }, [(_vm.statisticData.company.totalChartData) ? _c('nvd3-line-chart', {
    attrs: {
      "options": _vm.statisticData.company.totalChartData.options,
      "data": _vm.statisticData.company.totalChartData.data
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "people-chart chart clearfix",
    attrs: {
      "gutter": 10
    }
  }, [(_vm.statistic.chart !== 'connect' && _vm.statisticData.company.peopleChartData ? !_vm.statisticData.company.peopleChartData.length : false) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "line-height": "220px",
      "text-align": "center"
    }
  }, [_c('translate', [_vm._v("No Data")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.statisticData.company.peopleChartData), function(chart, index) {
    return _c('el-col', {
      key: index,
      staticClass: "people-chart-item",
      attrs: {
        "xs": 24,
        "sm": 24,
        "md": 12,
        "lg": 12
      }
    }, [_c('div', [_c('div', {
      staticClass: "chart-item-header text-center"
    }, [_c('div', {
      staticClass: "photo"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("resetURL")(chart.avatar),
        "border": "0"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_c('span', [_vm._v(_vm._s(chart.name))]), _vm._v(" "), _c('span', [_vm._v(" ( " + _vm._s(chart.account) + " ) ")])])]), _vm._v(" "), _c('nvd3-line-chart', {
      attrs: {
        "options": chart.options,
        "data": chart.data
      }
    })], 1)])
  })], 2)], 1) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.resource,
      "name": "resource"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "height": "300px"
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "chart-panel"
  }, [(_vm.statistic.chart === 'networkproject') ? _c('div', {
    staticClass: "chart bar-chart"
  }, [(_vm.statisticData.resource.networkProject.data ? !_vm.statisticData.resource.networkProject.data[0].values.length : false) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "line-height": "220px",
      "text-align": "center"
    }
  }, [_c('translate', [_vm._v("No Data")])], 1) : _vm._e(), _vm._v(" "), (_vm.statisticData.resource.networkProject.data ? _vm.statisticData.resource.networkProject.data[0].values.length : false) ? _c('nvd3-bar-chart', {
    attrs: {
      "options": _vm.statisticData.resource.networkProject.options,
      "data": _vm.statisticData.resource.networkProject.data
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.statistic.chart !== 'networkproject') ? _c('div', [_c('el-row', {
    staticClass: "people-chart chart bar-chart clearfix",
    attrs: {
      "gutter": 10
    }
  }, [(_vm.statisticData.resource.networkOrProject ? !_vm.statisticData.resource.networkOrProject.length : false) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "line-height": "220px",
      "text-align": "center"
    }
  }, [_c('translate', [_vm._v("No Data")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.statisticData.resource.networkOrProject), function(chart, index) {
    return _c('el-col', {
      key: index,
      staticClass: "people-chart-item",
      attrs: {
        "xs": 24,
        "sm": 24,
        "md": 12,
        "lg": 12
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "padding": "10px 10px 0 10px",
        "width": "100%"
      }
    }, [_c('span', [_vm._v(_vm._s(chart.name))])]), _vm._v(" "), (!chart.hasData) ? _c('div', {
      staticStyle: {
        "width": "100%",
        "margin-top": "-10px",
        "height": "220px",
        "text-align": "center",
        "padding": "60px 0"
      }
    }, [_c('translate', [_vm._v("No Data")])], 1) : _vm._e(), _vm._v(" "), (chart.hasData) ? _c('div', {
      staticStyle: {
        "width": "100%",
        "padding": "10px",
        "margin-top": "-10px",
        "height": "220px",
        "overflow-y": "auto"
      }
    }, [_c('nvd3-bar-chart', {
      attrs: {
        "options": chart.options,
        "data": chart.data
      }
    })], 1) : _vm._e()])])
  })], 2)], 1) : _vm._e()]) : _vm._e()])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right"
  }, [_c('ul', {
    staticClass: "nav clearfix"
  }, [(_vm.planTime !== null) ? _c('li', [_c('span', {
    staticClass: "el-dropdown-link dropdown-padding",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'alarmNotify',
          query: {
            notice_accounts: _vm.$store.getters.account.name
          }
        })
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon-14 fa fa-envelope-open"
  }), _vm._v(" "), _c('translate', [_vm._v("Alarm")]), _vm._v(" "), (_vm.$store.getters.logs.alarmNotifyUnreadCounts) ? _c('span', {
    staticClass: "link-num"
  }, [_vm._v(" " + _vm._s(_vm.$store.getters.logs.alarmNotifyUnreadCounts) + " ")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.planTime !== null) ? _c('li', [_c('span', {
    staticClass: "el-dropdown-link dropdown-padding",
    on: {
      "click": _vm.showConnectList
    }
  }, [_c('a', [_c('i', {
    staticClass: "icon-14 fa fa-link"
  }), _vm._v(" "), _c('translate', [_vm._v("Online Sessions")]), _vm._v(" "), (_vm.currentConnectCount) ? _c('span', {
    staticClass: "link-num"
  }, [_vm._v(" " + _vm._s(_vm.currentConnectCount) + " ")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$language.current === 'zh_CN') ? _c('li', [_c('a', {
    staticClass: "dropdown-padding",
    attrs: {
      "href": "https://mrdoc.cloudcare.cn/doc/261/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon-14 material-icons"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('translate', [_vm._v("Help")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.planTime !== null && _vm.$language.current === 'zh_CN') ? _c('li', [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "dropdown-padding"
  }, [_c('i', {
    staticClass: "icon-14 material-icons"
  }, [_vm._v("group")]), _vm._v(" "), _c('a', [_c('translate', [_vm._v("Contact US")])], 1)]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('p', [_c('translate', [_vm._v("Customer Service")]), _vm._v(":\n\t\t\t\t\t\t\t"), _c('a', {
    staticClass: "wang-item btn",
    attrs: {
      "target": "_blank",
      "href": "https://work.weixin.qq.com/kfid/kfc63de878415ef9ba5"
    }
  }, [_c('translate', {
    attrs: {
      "tag": "span"
    }
  }, [_vm._v("Immediate Consultation")])], 1)], 1)]), _vm._v(" "), _c('el-dropdown-item', [_c('p', [_c('translate', [_vm._v("Contact Number")]), _vm._v(": "), _c('span', [_vm._v("021-50653160")])], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.planTime !== null) ? _c('li', [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.onSelectLanguage
    }
  }, [_c('a', {
    staticClass: "el-dropdown-link dropdown-padding"
  }, [_c('i', {
    staticClass: "fa fa-globe fa-lg"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$language.current === 'zh_CN' ? '简体中文' : 'English'))])]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "en_US"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "zh_CN"
    }
  }, [_vm._v(" 简体中文 ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('el-tooltip', {
    attrs: {
      "placement": "bottom",
      "effect": "light"
    }
  }, [_c('div', {
    slot: "content"
  }, [_c('span', [_vm._v("套餐到期时间：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.memberExpireTime.text))])]), _vm._v(" "), _c('a', {
    staticClass: "el-dropdown-link dropdown-padding",
    class: _vm.memberExpireTime.isExpire || _vm.memberExpireTime.matured ? 'isExpire' : ''
  }, [_c('i', {
    staticClass: "fa fa-id-card-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.packageInfo.current_plan ? _vm.packageInfo.current_plan.name : ''))]), _vm._v(" "), (_vm.memberExpireTime.isExpire) ? _c('span', [_vm._v("（即将到期）")]) : _vm._e(), _vm._v(" "), (_vm.memberExpireTime.matured) ? _c('span', [_vm._v("（已到期）")]) : _vm._e()])])], 1), _vm._v(" "), _c('li', [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleClickMenu
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link dropdown-padding"
  }, [_c('a', {
    staticClass: "photo clearfix"
  }, [_c('img', {
    attrs: {
      "src": _vm._f("resetURL")(_vm.account.avatar),
      "border": "0"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.account.name))])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right caret-download"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "logout"
    }
  }, [_c('translate', [_vm._v("Logout")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.account.unique_id) ? _c('li', [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "title": _vm.attrText.onlineSessions,
      "custom-class": "onlineUserDialiog",
      "visible": _vm.connectListDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.connectListDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "add-ssk"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.batchDel.length
    },
    on: {
      "click": function($event) {
        _vm.cutOnline(_vm.batchDel)
      }
    }
  }, [_c('translate', [_vm._v("Disconnect")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "stripe": "",
      "data": _vm.currentConnectList,
      "empty-text": _vm.attrText.noSession
    },
    on: {
      "selection-change": _vm.selectMultiple
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "prop": "account.name",
      "label": _vm.attrText.member
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(!scope.row.account ? '' : scope.row.account.name) + "\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50",
      "label": " "
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.safe_mode) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.unsafeMode,
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-exclamation-circle warn"
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resource_name",
      "label": _vm.attrText.resource
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resource_ip_address",
      "label": _vm.attrText.resourceIp
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "way",
      "label": _vm.attrText.resourceWay
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.resourceWayMap[scope.row.way]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "project_name",
      "label": _vm.attrText.workgroup
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": _vm.attrText.updateTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(scope.row.createTime ? scope.row.createTime : '') + "\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.agentVersion < '3.0.0') ? _c('el-button', {
          attrs: {
            "disabled": !scope.row.linkHref || !(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp)),
            "type": "text",
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              _vm.onLinkhref(scope.row.linkHref)
            }
          }
        }, [_c('translate', [_vm._v("Monitor")])], 1) : _vm._e(), _vm._v(" "), (scope.row.agentVersion >= '3.0.0') ? _c('el-button', {
          attrs: {
            "disabled": !(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp)),
            "type": "text",
            "target": "_blank"
          }
        }, [(scope.row.way === 'terminal' || scope.row.way === 'wetty') ? _c('span', {
          on: {
            "click": function($event) {
              _vm.createShadow(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("assistance")])], 1) : _vm._e(), _vm._v(" "), (scope.row.way === 'rdp' && scope.row.showRdp) ? _c('span', {
          on: {
            "click": function($event) {
              _vm.onLinkhref(scope.row.linkHref)
            }
          }
        }, [_c('translate', [_vm._v("monitor")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.cutOnline([scope.row.id])
            }
          }
        }, [_c('translate', [_vm._v("Disconnect")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.currentConnectCount > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.currentConnectCount,
      "page-size": 10,
      "current-page": _vm.currentConnectPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentConnectPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-padding",
    attrs: {
      "id": "widget-notify-list"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  })])
}]}

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("欢迎使用")]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("CloudLinker 密码修改")]), _vm._v(" "), _c('el-form', {
    ref: "passForm",
    staticClass: "resetPassword-ruleForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('el-form-item', {
    staticClass: "list-group-item",
    attrs: {
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.formData.pass),
      callback: function($$v) {
        _vm.formData.pass = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "formData.pass"
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_password_warning && _vm.company_password_strength == 1),
      expression: "show_password_warning && company_password_strength == 1"
    }],
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('translate', [_vm._v("The administrator has enabled the password strength setting. The password must be at least 6 characters long and must contain two of uppercase letters, lowercase letters, and special characters.")])], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_password_warning && _vm.company_password_strength == 2),
      expression: "show_password_warning && company_password_strength == 2"
    }],
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('translate', [_vm._v("The administrator has enabled the password strength setting. The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters.")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "list-group-item",
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "重复密码"
    },
    model: {
      value: (_vm.formData.checkPass),
      callback: function($$v) {
        _vm.formData.checkPass = $$v
      },
      expression: "formData.checkPass"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.formData.pass != '' && _vm.formData.checkPass != '' ? false : true
    },
    on: {
      "click": function($event) {
        _vm.onSubmitForm('passForm')
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("登录")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('span', [_c('span', [_vm._v("登录中")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _vm._e()])], 1)], 1)], 1)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(59)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright clearfix small"
  }, [_c('div', [_vm._v("Copyright 上海驻云信息科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\tPowered by\n\t\t\t"), _c('a', {
    staticClass: "text-primary new-block",
    attrs: {
      "href": "https://www.cloudcare.cn",
      "target": "_blank"
    }
  }, [_vm._v("cloudcare.cn")])])])
}]}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-group"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Work Group")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header-nav"
  }, [(_vm.mode) ? _c('div', {
    staticClass: "clearfix pull-right"
  }, [_c('el-select', {
    staticClass: "search-select",
    attrs: {
      "placeholder": _vm.attrText.select
    },
    on: {
      "change": _vm.clearSearchInput
    },
    model: {
      value: (_vm.searchCondition),
      callback: function($$v) {
        _vm.searchCondition = $$v
      },
      expression: "searchCondition"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.name,
      "value": "q_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IP",
      "value": "q_ip"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.searchCondition
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearch(1)
      }
    },
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "searchKey"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSearch(1)
      }
    }
  }, [_c('translate', [_vm._v("Search")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    class: {
      'el-button--primary': _vm.mode,
      'el-button--default': !_vm.mode
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onChangeMode(1)
      }
    }
  }, [_c('translate', [_vm._v("All Work Group")])], 1), _vm._v(" "), _c('el-button', {
    class: {
      'el-button--primary': !_vm.mode,
      'el-button--default': _vm.mode
    },
    attrs: {
      "disabled": !_vm.favourites || !_vm.favourites.length
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onChangeMode(0)
      }
    }
  }, [_c('translate', [_vm._v("Star Work Group")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, [(_vm.favourites && _vm.favourites.length) ? _c('div', {
    staticClass: "favourites-workgroup"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-header": false,
      "data": _vm.favourites
    },
    on: {
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.name) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "desc"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "class-name": "text-right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.getTranTest(scope.row.resource_count)) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "class-name": "text-right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "icon-box"
        }, [_c('i', {
          staticClass: "el-icon-star-on",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.setFavourite(scope.row, 0)
            }
          }
        }), _vm._v(" "), _c('a', {
          staticClass: "export-excel-icon",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.exportExcel(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        })])])]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.mode) ? _c('div', {
    staticClass: "list-workgroup"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-header": false,
      "data": _vm.workgroup.objects
    },
    on: {
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.name) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "desc"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "class-name": "text-right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.getTranTest(scope.row.resource_count)) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "class-name": "text-right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "icon-box"
        }, [_c('i', {
          staticClass: "el-icon-star-on",
          class: {
            active: scope.row.favourite,
            default: !scope.row.favourite
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.setFavourite(scope.row, !scope.row.favourite)
            }
          }
        }), _vm._v(" "), _c('a', {
          staticClass: "export-excel-icon",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.exportExcel(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link",
          attrs: {
            "aria-hidden": "true"
          }
        })])])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.workgroup.total > 9) ? _c('div', {
    staticClass: "text-right"
  }, [_c('el-pagination', {
    attrs: {
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage,
      "layout": "total, prev, pager, next",
      "total": _vm.workgroup.total
    },
    on: {
      "current-change": _vm.onCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects,
      "hideFooter": true
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Check")])], 1), _vm._v(" "), _c('div', {
    staticClass: "check",
    slot: "content"
  }, [_c('div', {
    staticClass: "b-b b-t"
  }, [_c('translate', [_vm._v("Connection Information")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Name")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.connects.name || '-'))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.connects.name),
      expression: "connects.name",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Type")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.connects.type || '-'))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.connects.type),
      expression: "connects.type",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Address")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.connects.ip || '-'))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.connects.ip),
      expression: "connects.ip",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Port")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(" " + _vm._s(_vm.connects.port || '-') + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Code")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.hideStr(_vm.contact.code) || '-'))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.connects.login_user ? _vm.connects.login_user[0] : '-'))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Report Type")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.connectInfo.type),
      callback: function($$v) {
        _vm.connectInfo.type = $$v
      },
      expression: "connectInfo.type"
    }
  }, _vm._l((_vm.reportTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "offset": 8,
      "span": 16
    }
  }, [(_vm.o.os == 'mysql') ? _c('div', {
    staticClass: "tips"
  }, [_c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  }, [_vm._v("Diagnostic connection users must have the following rights")]), _vm._v(" "), _c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  }, [_vm._v("grant select on information_schema.* to 'select'@'%';")]), _vm._v(" "), _c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  }, [_vm._v("grant process on *.* to 'select'@'%';")])], 1) : _vm._e(), _vm._v(" "), (_vm.o.os == 'mssql') ? _c('div', {
    staticClass: "tips"
  }, [_c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  }, [_vm._v("A diagnostic connection user must have at least one of the following role permissions for the diagnostic database")]), _vm._v(" "), _c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  }, [_vm._v("- db_owner")]), _vm._v(" "), _c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  }, [_vm._v("- sysadmin")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10,
      "offset": 8
    }
  }, [(!_vm.btnLoading) ? _c('el-button', {
    staticClass: "w-full m-t",
    attrs: {
      "disabled": !_vm.connectInfo.type
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sendCheck($event)
      }
    }
  }, [_vm._v("发起诊断")]) : _vm._e(), _vm._v(" "), (_vm.btnLoading) ? _c('el-button', {
    staticClass: "w-full m-t",
    attrs: {
      "loading": _vm.btnLoading,
      "disabled": ""
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "b-t m-t"
  }, [_c('translate', [_vm._v("Diagnostic Report List")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.m
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.reportname
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.name || '-') + " ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.hostname,
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.connects.name) + " ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.checktime,
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("moment")(scope.row.data_create_time, 'YYYY-MM-DD HH:mm:ss')) + " ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.tasks_status !== 'working') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.view(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("View")])], 1) : _vm._e(), _vm._v(" "), (scope.row.tasks_status === 'working') ? _c('el-button', {
          attrs: {
            "type": "text",
            "loading": ""
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.pageList.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.pageList.totalPage,
      "page-size": 10,
      "current-page": _vm.pageList.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.pageList.currentPage = $event
      },
      "current-change": _vm.changePage
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('h4', {
    staticClass: "content-titel"
  }, [_vm._v("设置密码")]), _vm._v(" "), _c('el-form', {
    ref: "resetPsw",
    staticClass: "resetPswForm",
    attrs: {
      "model": _vm.resetPsw,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('el-form-item', {
    staticClass: "list-group-item",
    attrs: {
      "prop": "domain"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "readonly"
    },
    model: {
      value: (_vm.resetPsw.account),
      callback: function($$v) {
        _vm.resetPsw.account = $$v
      },
      expression: "resetPsw.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "list-group-item",
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.resetPsw.password),
      callback: function($$v) {
        _vm.resetPsw.password = $$v
      },
      expression: "resetPsw.password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetPsw.show_password_warning && _vm.resetPsw.company_password_strength == 1),
      expression: "resetPsw.show_password_warning && resetPsw.company_password_strength == 1"
    }]
  }, [_vm._v("管理员开启了密码强度设置，密码长度最少6位，必须包含大写字母、小写字母、特殊字符中的两项")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetPsw.show_password_warning && _vm.resetPsw.company_password_strength == 2),
      expression: "resetPsw.show_password_warning && resetPsw.company_password_strength == 2"
    }]
  }, [_vm._v("管理员开启了密码强度设置，密码长度最少8位，必须包含大写字母、小写字母、特殊字符")])])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "list-group-item",
    attrs: {
      "prop": "repeat_pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "确认密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.resetPsw.repeat_pwd),
      callback: function($$v) {
        _vm.resetPsw.repeat_pwd = $$v
      },
      expression: "resetPsw.repeat_pwd"
    }
  }), _vm._v(" "), (_vm.pass.tipReset) ? _c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.pass.tipReset))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onResetPsw()
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("设置密码")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('span', [_c('span', [_vm._v("设置中")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _vm._e()])], 1)], 1)], 1)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(59)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright clearfix small"
  }, [_c('div', [_vm._v("Copyright 2013-2022 上海驻云信息科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\tPowered by\n\t\t\t"), _c('a', {
    staticClass: "text-primary new-block",
    attrs: {
      "href": "https://cloudcare.cn/",
      "target": "_blank"
    }
  }, [_vm._v("cloudcare.cn")])])])
}]}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Change Host")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "hostForm",
    staticClass: "hostForm",
    attrs: {
      "model": _vm.hostForm,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.loginUsername,
      "prop": "loginUsername"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "380px",
      "min-width": "100%"
    },
    attrs: {
      "multiple": "",
      "value-key": "",
      "filterable": ""
    },
    model: {
      value: (_vm.hostForm.loginUsername),
      callback: function($$v) {
        _vm.hostForm.loginUsername = $$v
      },
      expression: "hostForm.loginUsername"
    }
  }, _vm._l((_vm.connects), function(item, index) {
    return _c('el-option', {
      key: index,
      staticStyle: {
        "width": "380px",
        "min-width": "100%"
      },
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.hostForm.loginUsername.length
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Add Group")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    staticStyle: {
      "height": "100%"
    },
    slot: "content"
  }, [_c('el-form', {
    ref: "groupForm",
    staticClass: "groupForm",
    attrs: {
      "model": _vm.groupForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.group,
      "prop": "value"
    }
  }, [_c('el-select', {
    ref: "groups",
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": _vm.attrText.inputName
    },
    on: {
      "change": _vm.onChangeSelect
    },
    model: {
      value: (_vm.groupForm.groupId),
      callback: function($$v) {
        _vm.groupForm.groupId = $$v
      },
      expression: "groupForm.groupId"
    }
  }, _vm._l((_vm.groupForm.list), function(item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "select-item",
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.enableSubmitting
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "rightPanelSet",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Set The Security Mode")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('div', {
    staticClass: "safe-mode"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.safeMode,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.setstatus
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.safeMode.setRadio),
      callback: function($$v) {
        _vm.safeMode.setRadio = $$v
      },
      expression: "safeMode.setRadio"
    }
  }, [_c('translate', [_vm._v("on")])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.safeMode.setRadio),
      callback: function($$v) {
        _vm.safeMode.setRadio = $$v
      },
      expression: "safeMode.setRadio"
    }
  }, [_c('translate', [_vm._v("off")])], 1), _vm._v(" "), _c('p', {
    staticClass: "set-text"
  }, [_c('translate', [_vm._v(" Security mode can only block Linux command operations, not including scripts and other ways. ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.blockCommand
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.safeMode.setRadio === '0',
      "placeholder": ""
    },
    model: {
      value: (_vm.safeMode.command),
      callback: function($$v) {
        _vm.safeMode.command = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "safeMode.command"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.safeMode.setRadio === '0'
    },
    on: {
      "click": function($event) {
        _vm.addCommand()
      }
    }
  }, [_c('translate', [_vm._v("Add")])], 1)], 1), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Please enter a command to block, including multiple commands separated by \",\" ")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.safeMode.blockCommand,
      "stripe": "",
      "empty-text": _vm.attrText.notCommand
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "command",
      "label": _vm.attrText.Command
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.safeMode.setRadio === '0'
          },
          on: {
            "click": function($event) {
              _vm.removeCommand(scope.row.command)
            }
          }
        }, [_c('translate', [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.safemode
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1",
      "disabled": _vm.safeMode.setRadio === '0'
    },
    model: {
      value: (_vm.safeMode.safeRadio),
      callback: function($$v) {
        _vm.safeMode.safeRadio = $$v
      },
      expression: "safeMode.safeRadio"
    }
  }, [_c('translate', [_vm._v("on")])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0",
      "disabled": _vm.safeMode.setRadio === '0'
    },
    model: {
      value: (_vm.safeMode.safeRadio),
      callback: function($$v) {
        _vm.safeMode.safeRadio = $$v
      },
      expression: "safeMode.safeRadio"
    }
  }, [_c('translate', [_vm._v("off")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.approver
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.attrText.selected,
      "disabled": _vm.safeMode.safeRadio === '0'
    },
    model: {
      value: (_vm.safeMode.name),
      callback: function($$v) {
        _vm.safeMode.name = $$v
      },
      expression: "safeMode.name"
    }
  }, _vm._l((_vm.safeMode.nameList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": ((item.name) + "(" + (item.account) + ")"),
        "value": item.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.safeMode.safeRadio === '0'
    },
    on: {
      "click": function($event) {
        _vm.addApprover()
      }
    }
  }, [_c('translate', [_vm._v("Add")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "50px"
    },
    attrs: {
      "data": _vm.safeMode.approver,
      "stripe": "",
      "empty-text": _vm.attrText.noApprover
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.attrText.approver
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.safeMode.safeRadio === '0'
          },
          on: {
            "click": function($event) {
              _vm.removeApprover(scope.row.name)
            }
          }
        }, [_c('translate', [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.systemCommandAlarm
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.alarmMode.alarmRadio),
      callback: function($$v) {
        _vm.alarmMode.alarmRadio = $$v
      },
      expression: "alarmMode.alarmRadio"
    }
  }, [_c('translate', [_vm._v("on")])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.alarmMode.alarmRadio),
      callback: function($$v) {
        _vm.alarmMode.alarmRadio = $$v
      },
      expression: "alarmMode.alarmRadio"
    }
  }, [_c('translate', [_vm._v("off")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.alarmInstruction
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.alarmMode.alarmRadio === '0',
      "placeholder": ""
    },
    model: {
      value: (_vm.alarmMode.command),
      callback: function($$v) {
        _vm.alarmMode.command = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "alarmMode.command"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.alarmMode.alarmRadio === '0'
    },
    on: {
      "click": function($event) {
        _vm.addAlarmCommand()
      }
    }
  }, [_c('translate', [_vm._v("Add")])], 1)], 1), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Please enter a command to alarm, including multiple commands separated by \",\" ")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.alarmMode.blockCommand,
      "stripe": "",
      "empty-text": _vm.attrText.notAlarmCommand
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "command",
      "label": _vm.attrText.Command
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.alarmMode.alarmRadio === '0'
          },
          on: {
            "click": function($event) {
              _vm.removeAlarmCommand(scope.row.command)
            }
          }
        }, [_c('translate', [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.notifier
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.attrText.selected,
      "disabled": _vm.alarmMode.alarmRadio === '0'
    },
    model: {
      value: (_vm.alarmMode.name),
      callback: function($$v) {
        _vm.alarmMode.name = $$v
      },
      expression: "alarmMode.name"
    }
  }, _vm._l((_vm.alarmMode.nameList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": ((item.name) + "(" + (item.account) + ")"),
        "value": item.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.alarmMode.alarmRadio === '0'
    },
    on: {
      "click": function($event) {
        _vm.addNotifier()
      }
    }
  }, [_c('translate', [_vm._v("Add")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "50px"
    },
    attrs: {
      "data": _vm.alarmMode.notifier,
      "stripe": "",
      "empty-text": _vm.attrText.noNotifier
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.attrText.notifier
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.alarmMode.alarmRadio === '0'
          },
          on: {
            "click": function($event) {
              _vm.removeNotifier(scope.row.name)
            }
          }
        }, [_c('translate', [_vm._v("Remove")])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.safeMode.safeRadio === '1' && _vm.safeMode.approver.length === 0,
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.onSubmitSafeMode()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs.rightPanelSet.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "safe-apply-modal",
    attrs: {
      "datas": _vm.safeObj,
      "hideFooter": _vm.safeObj && _vm.safeObj.isHideFooter
    },
    on: {
      "onClose": function($event) {
        _vm.onClose()
      }
    }
  }, [(_vm.safeObj) ? _c('div', {
    slot: "header"
  }, [(_vm.safeObj.viewType === 'my') ? _c('div', [_c('translate', [_vm._v("The Details Of My Application")])], 1) : _vm._e(), _vm._v(" "), (_vm.safeObj.viewType !== 'my') ? _c('div', [_c('translate', [_vm._v("Show The Details Of The Application")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    slot: "content"
  }, [(_vm.safeObj) ? _c('div', {
    staticClass: "mySqlDatail"
  }, [(_vm.safeObj.viewType === 'my' && (_vm.safeObj.app_status === 1 || _vm.safeObj.app_status === 2)) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Approver")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), (_vm.safeObj.approver_id) ? _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.safeObj.approver.name) + "(" + _vm._s(_vm.safeObj.approver.account) + ")")]) : _vm._e(), _vm._v(" "), (_vm.safeObj.reject_id) ? _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.safeObj.reject.name) + "(" + _vm._s(_vm.safeObj.reject.account) + ")")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.safeObj.viewType === 'approve') ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Applyer")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.safeObj.account.name) + "(" + _vm._s(_vm.safeObj.account.account) + ")")])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Resource")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.safeObj.resource.name) + "(" + _vm._s(_vm.safeObj.resource.ip_address) + ")")])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Project")]), _vm._v(" "), _c('span', [_vm._v(":")])], 1), _vm._v(" "), (_vm.safeObj.project) ? _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.safeObj.project.project_name))]) : _vm._e(), _vm._v(" "), (!_vm.safeObj.project) ? _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("-")]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Status")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s((_vm.safeApplyStatusText[_vm.safeObj.app_status] || _vm.safeObj.app_status)))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Create Time")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.safeObj.create_time * 1000, 'YYYY-MM-DD HH:mm:ss')))])], 1), _vm._v(" "), (_vm.safeObj.app_status === 1 || _vm.safeObj.app_status === 2) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Update Time")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.safeObj.update_time * 1000, 'YYYY-MM-DD HH:mm:ss')))])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("The reason for the application")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.safeObj.reason))])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "view-right",
    attrs: {
      "span": 10
    }
  }, [_c('translate', [_vm._v("Non-security mode expiration time")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.safeObj.expire_time * 1000, 'YYYY-MM-DD HH:mm:ss')))])], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.safeObj) ? _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [(_vm.safeObj.viewType === 'my' && _vm.safeObj.app_status === 0) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.cancelLoading),
      expression: "cancelLoading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cancelSafeApply(_vm.safeObj.id)
      }
    }
  }, [_c('translate', [_vm._v("Cancel the application")])], 1) : _vm._e(), _vm._v(" "), (_vm.safeObj.viewType === 'approve' && _vm.safeObj.app_status === 0) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.passLoading),
      expression: "passLoading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.doExecute(_vm.safeObj.id)
      }
    }
  }, [_c('translate', [_vm._v("Pass")])], 1) : _vm._e(), _vm._v(" "), (_vm.safeObj.viewType === 'approve' && _vm.safeObj.app_status === 0) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.rejectLoading),
      expression: "rejectLoading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.doReject(_vm.safeObj.id)
      }
    }
  }, [_c('translate', [_vm._v("Reject")])], 1) : _vm._e()], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-mfa-panel",
    attrs: {
      "datas": _vm.connects,
      "items": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Unbind MFA")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Setting WorkGroup")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "workgropForm",
    attrs: {
      "model": _vm.setting,
      "rules": _vm.rules,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.name,
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.setting.name),
      callback: function($$v) {
        _vm.setting.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "setting.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.desc,
      "prop": "desc"
    }
  }, [_c('el-input', {
    staticClass: "right-panel-textarea",
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.setting.desc),
      callback: function($$v) {
        _vm.setting.desc = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "setting.desc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.setting.isCanSubmit
    },
    on: {
      "click": function($event) {
        _vm.onSubmitForm()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./index.js": 749
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 652;

/***/ }),
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('remote-script', {
  render: function render(createElement) {
    var self = this;
    return createElement('script', {
      attrs: {
        type: 'text/javascript',
        src: this.src
      },
      on: {
        load: function load(event) {
          self.$emit('load', event);
        },
        error: function error(event) {
          self.$emit('error', event);
        },
        readystatechange: function readystatechange(event) {
          if (this.readyState === 'complete') {
            self.$emit('load', event);
          }
        }
      }
    });
  },
  props: {
    src: {
      type: String,
      required: true
    }
  }
});

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "telNumberFormat", function() { return telNumberFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetURL", function() { return resetURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatTimeLong", function() { return formatTimeLong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatDuration", function() { return formatDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "translate", function() { return translate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);



var telNumberFormat = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('telNumberFormat', function (num) {
  if (num) {
    var str = num.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    return str;
  }
  return num;
});

var resetURL = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('resetURL', function (url) {
  if (url) {
    return '' + __WEBPACK_IMPORTED_MODULE_1__config__["a" /* baseUrl */].apiUrl + url;
  } else {
    return '/static/images/avatar.png';
  }
});

var formatTimeLong = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatTimeLong', function (timeLong, timeType) {
  timeType = timeType || 'minutes';
  var days = Math.floor(timeLong / (24 * 60 * 60 * 1000));
  var hours = Math.floor(timeLong % (24 * 60 * 60 * 1000) / (60 * 60 * 1000));
  var minutes = Math.floor(timeLong % (60 * 60 * 1000) / (60 * 1000));
  var seconds = Math.floor(timeLong % (60 * 1000) / 1000);
  var constr = '';
  if (days) {
    constr += days + '\u5929';
  }
  if (hours) {
    constr += hours + '\u5C0F\u65F6';
  }
  if (minutes) {
    constr += minutes + '\u5206';
  }
  if (timeType === 'seconds' && seconds) {
    constr += seconds + '\u79D2';
  }
  return constr.length > 0 ? constr : '0分';
});

var formatDuration = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDuration', function (timeLong) {
  var add0 = function add0(m) {
    if (+m < 10) {
      m = '0' + m;
    } else {
      return m;
    }
    return m;
  };
  var hours = Math.floor(timeLong / (60 * 60 * 1000));
  var minutes = Math.floor((timeLong - hours * (60 * 60 * 1000)) / 60);
  var seconds = Math.floor(timeLong % 60);
  var duration = add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
  return duration;
});

var translate = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('translate', function (str, $gettext) {
  if (!$gettext) {
    $gettext = function $gettext(t) {
      return t;
    };
  }
  return $gettext(str);
});

var version = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('version', function (version) {
  if (version) {
    var firstVersionNum = version.split('-')[0];
    return firstVersionNum;
  }
});



/***/ }),
/* 913 */,
/* 914 */,
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_account__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_approval__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_cluster__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_dashboard__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_document__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_logs__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_sshkey__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_team__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_workgroup__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_review__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mutations__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__getters__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugins_logger__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuex__ = __webpack_require__(175);




















__WEBPACK_IMPORTED_MODULE_14_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vuex__["b" /* default */]);

var debug = "production" !== 'production';

var store = new __WEBPACK_IMPORTED_MODULE_15_vuex__["b" /* default */].Store({
  mutations: __WEBPACK_IMPORTED_MODULE_10__mutations__,
  actions: __WEBPACK_IMPORTED_MODULE_11__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_12__getters__,
  modules: {
    account: __WEBPACK_IMPORTED_MODULE_0__modules_account__["a" /* default */],
    approval: __WEBPACK_IMPORTED_MODULE_1__modules_approval__["a" /* default */],
    cluster: __WEBPACK_IMPORTED_MODULE_2__modules_cluster__["a" /* default */],
    dashboard: __WEBPACK_IMPORTED_MODULE_3__modules_dashboard__["a" /* default */],
    document: __WEBPACK_IMPORTED_MODULE_4__modules_document__["a" /* default */],
    logs: __WEBPACK_IMPORTED_MODULE_5__modules_logs__["a" /* default */],
    sshkey: __WEBPACK_IMPORTED_MODULE_6__modules_sshkey__["a" /* default */],
    team: __WEBPACK_IMPORTED_MODULE_7__modules_team__["a" /* default */],
    workgroup: __WEBPACK_IMPORTED_MODULE_8__modules_workgroup__["a" /* default */],
    review: __WEBPACK_IMPORTED_MODULE_9__modules_review__["a" /* default */]
  },
  strict: debug,
  plugins: debug ? [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__plugins_logger__["a" /* default */])()] : []
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 916 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(967),
  /* template */
  __webpack_require__(1439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(968),
  /* template */
  __webpack_require__(1432),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 924 */,
/* 925 */,
/* 926 */
/***/ (function(module, exports) {

module.exports = {"en_US":{},"zh_CN":{": Block":": 拦截中",": block/not passed":": 拦截中/未通过",": block/passed":": 拦截中/已通过",": block/pending audit":": 拦截中/待审核",": green light/passed":": 放行中/已通过","’ indicates authorization all the database":"’ 表示授权该实例的所有数据库","(1)When CloudLinker permission is enabled, webssh does not support KEY authentication":"(1) 当CloudLinker权限开启时，webssh 不支持 KEY 验证的方式","(2)When your CloudLinker password authentication mode is CloudLinker password, the target machine can not be authenticated by the local password":"(2) 当您的权限认证方式为 CloudLinker 密码时，目标机的验证方式不可为本机密码","(MFA verify notes)":"( MFA 验证须知)","(The password of %{upload.username} for the destination host)":"(该目标机%{upload.username}用户名的密码)","(Valid time:30 minutes or the main connection is disconnected)":"(有效时间：30分钟或主链接中断)","*":"*","1. You must install the MFA application on your smart device to continue.":"1.您必须在智能设备上安装MFA应用程序，才能继续操作。","1.You must install the MFA application on your smart device to continue":"1.您必须在智能设备上安装MFA应用程序，才能继续操作","1) Network recommends configuration 2 cores 4G,40GB disk,10Mbps network bandwidth.(Recommended configuration:4 cores,4G,40GB disk,20Mbps or higher network bandwidth)":"1）管控节点最低配置 2核 4G、磁盘 40GB、网络带宽 10Mbps。（推荐配置 4核 4G、磁盘 40GB、网络带宽 20Mbps及以上）","2. Common applications that support MFA on smart devices are":"2.在智能设备上支持 MFA 的常用应用程序有 ","2) To ensure the normal operation of the control node functions, the remaining disk space must be greater than 5GB.":"2）为保障管控节点功能正常运行，剩余磁盘空间须大于 5GB。","3. If your account has been shared by multiple people, then when you successfully bind MFA, other unbound MFA people will not be able to log in. The solution is to let other people also install the MFA application and scan the 2D code for this page, or save the 2D code picture for others to follow the sweep. But from the security best practice, we recommend that you cancel the multiplayer account.":"3.如果您的账号已被多人共享使用，那么当您成功绑定 MFA 之后，其他未绑定 MFA 的人将无法登录。解决方法是让其他人也安装 MFA 应用程序并扫描此页的二维码，或者保存此二维码图片供其他人后续进行扫码。但从安全最佳实践来看，我们建议您取消多人共享账号。","3.If your account has been shared by multiple people, when you successfully bind MFA, other unbound MFA people will not be able to log in. Other people must also install the MFA application and scan the 2D code for this page, or save the 2D code picture for others to scan. In consideration of account security, we recommend that you cancel the multiplayer account.":"3.如果您的账号已被多人共享使用，那么当您成功绑定 MFA 之后，其他未绑定 MFA 的人将无法登录。解决方法是让其他人也安装 MFA 应用程序并扫描此页的二维码，或者保存此二维码图片供其他人后续进行扫码。但从安全最佳实践来看，我们建议您取消多人共享账号。","3) After executing the installation script, CloudLinker will use the public IP of your host as the control node IP. If there are any special requirements, please replace \"default\" with the IP or domain name you want to specify. If you need to modify the connection port of the control node, replace the default port number with the new one.":"3）执行安装脚本后 CloudLinker 会将您主机的公网 IP 作为管控节点 IP，若有特殊需求，请将 default 替换为您想要指定的 IP 或者域名，如需修改管控节点连接端口，请用新的端口号替换默认的端口号。","4. If you can not verify for some reason, such as missing or mistakenly deleted MFA applications, you can manually unmarshal MFA binding by dialing 021-50653160.":"4. 如您因为某些原因（如手机丢失或误删除MFA应用等）无法进行验证，可以通过拨打021-50653160人工解除MFA绑定。","4) In consideration of the system performance, it is recommended that the server of agent don’t be used for other purposes.":"4）为不影响性能，该管控节点尽量不要作其它使用。","5) Make sure that wget and curl are installed on your server.":"5）请确保您的机器上已装有 wget 以及 curl。","6) Other:":"6）其他：","Control Node Function Description Document":"管控节点功能说明文档","A Week Operation Statistic":"一周运维统计","A Week TOP Member":"一周TOP成员","A Week TOP Resource":"一周TOP资源","After the team token is updated, the original team token will become invalid and the CloudCare workspace bound to it will also be unbound. Exercise caution when performing this operation.":"团队token更新后，原团队token将会失效，同时其绑定的CloudCare工作空间也将会解绑，请谨慎操作。","After the CloudCare workspace is unbound, historical diagnosis reports cannot be viewed. Exercise caution when performing this operation.":"CloudCare工作空间解绑后，该空间将无法查看历史诊断报告，请谨慎操作。","Confirm Whether To Reset The Member Mfa Account?":"确认是否重置该成员账号MFA？","Reset MFA":"重置MFA","Account Info":"账号信息","Account Information":"账号信息","Account Security":"账号安全","Action":"操作","Add":"添加","Add Database":"添加数据库","Add Group":"分配群组","Add Host":"添加主机","Add Instance":"添加主机","Change Host":"修改主机","Login Username":"可登录用户","Add Log Filter":"添加日志过滤","Add Member":"添加成员","Add Members":"添加成员","Join WorkGroup":"加入工作组","Add SSH KEY":"添加 SSH KEY","Add Team Member":"添加团队成员","Add The Database In Bulk":"批量添加数据库","Add The Host In Bulk":"批量添加主机","Advanced Search":"高级搜索","After the KEY upload, Login to the host using the local password":"请确认 KEY 配置成功后，使用本机密码登录该主机","CloudLinker team account password":"CloudLinker团队账号密码","Agent Update":"更新管控节点","Back Agent":"回退管控节点","All":"全部","All Work Group":"所有工作组","and installed the RDP client (Windows only support)":"并安装了 RDP 客户端（只支持 Windows)","Application":"审批","Apply Non-security mode":"非安全模式审核","Applyer":"发起人","Approver":"审批人","Notifier":"通知人","Notify Obj":"通知对象","Are you sure to start 1 instances?":"您确定要对以下 1 个实例进行启动操作吗？","Are you sure to stop 1 instances?":"您确定要对以下 1 个实例进行停止操作吗？","Are you sure to Turn On Instance?":"您确定启动实例吗？","Function update, click Save to synchronize authentication data":"功能更新，点击“保存”同步认证数据","assistance":"协助","Assistance":"协助","Assistance address":"协助地址","Assistance Info":"协助信息","Attention:":"注:","Authentication information":"身份验证信息","Authentication settings":"认证设置","Host Authentication Mode":"主机认证方式","Authentication Mode":"认证方式","Clipboard":"剪切板","Host Password":"主机密码","Team Account":"团队账号","Password-Free Login":"免密登录","avatar":"头像","Back":"返回","Base Info":"基础信息","Basic information":"基础信息","Batch Import":"批量导入","Bind Immediately":"立即绑定","Bind MFA":"绑定  MFA","Bind Mobile":"绑定手机","Block":"拦截中","block/not passed":"拦截中/未通过","block/passed":"拦截中/已通过","block/pending audit":"拦截中/待审批","Cancel":"取消","Cancel Share":"取消分享","Cancel the application":"取消申请","Change":"修改","Change ClusterName":"修改名称","Change Members":"修改成员","Change Name":"修改姓名","Change Nickname":"修改显示昵称","Change Password":"修改密码","No more reminders within 7 days":"已知晓（7天内不再提醒）","Choose File":"选择文件","clear":"清除","Close":"关闭","Closed":"已关闭","Cluster":"集群","Cluster List":"集群列表","Cluster Manage":"集群管理","Comfirm":"确定","Comment":"备注","Config":"配置","Configuration":"配置","Configuration Information":"配置信息","Confirm":"确定","Confirm To Open":"确定开启","Connect":"连接","Connect Logs":"连接日志","Connect to the host":"连接该主机","Connect Username":"连接用户名","Connection Info":"连接信息","Connection Information":"连接信息","Connection IP":"连接 IP","Source IP":"来源IP","Notice Accounts":"通知对象","ChangePassword":"修改密码","Connection Time":"连接时间","Contact Number":"联系电话","Contact US":"联系我们","Control node IP:":"管控节点IP:","Control node version:":"管控节点版本:","Copy":"复制","CPU":"CPU","CPU Monitoring":"CPU 监控","Create":"创建","Create Cluster":"创建集群","Create Group":"创建群组","Create Time":"创建时间","Create WorkGroup":"创建工作组","Created New Workgrounp":"新建工作组","CloudLinker Authentication":"CloudLinker 权限认证","Current Version:":"当前版本:","Customize":"自定义","Dashboard":"概要","Data Disk":"数据盘","Default":"不设置","Default Username":"默认用户名","Delete":"删除","Delete Cluster":"删除集群","Destination Host Authentication":"目标机登录方式","Details":"查看","Disconnect":"断开连接","Disk Monitoring":"磁盘监控","Distribute":"分配","Exit":"退出","Exit Confirm":"退出确认","Document":"文档","download":"下载","Download":"下载","Download Report":"导出报告","Export":"导出","Video Reply":"本地日志回放","Download The Database List, Fill In The Database Information":"下载数据库列表模板,批量填写数据库信息","Download The Host List, Fill In The Host Information":"下载主机列表模板, 批量填写主机信息","Duration":"时长","Execute":"执行","Export Ansible":"导出 Ansible","Fill in the client with Code and connect to your Windows server.":"将 Code 填入客户端中使用即可连接您的 Windows 服务器。","First Step":"第一步","Forced Restart":"强制重启","Forced To Stop":"强制停止","General Situation":"概况","Generate Report":"生成报告","Get Again":"重新获取","Green Light":"放行中","green light/passed":"放行中/已通过","Help":"帮助","Hide the same resources as the IP in the cluster":"隐藏与集群中IP相同的资源","Host":"主机","Identity":"身份宝","If the administrator has opened the team MFA certification, you must bind MFA to log in normally!":"管理员已开启团队MFA认证,必须绑定MFA才可以正常登录!","Import":"导入","Information":"信息","Instance Detail":"实例详情","Instance ID":"实例 ID","Instance Name":"实例名称","Intranet IP":"私网 IP","IPs are separated by semicolons \";\", and there is no limit if left blank":"IP 间以英文分号“;”分隔，如不填写则不限制","Key":"密钥","Last Login IP:":"最后登录 IP:","Last Login Time:":"最后登录时间:","Load More":"加载更多","Log":"日志","Log in resource need to generate a code, every code has a effective period,This term set the maximum effective period that user can set.":"登录资源都需要生成 code，每个 code 都有有效期，最大有效时间指该集群下资源的连接 code 有效期只能在设置的范围内。","Login":"登录","login account:":"登录账号:","Login to the host using the local password":"请使用本机密码登录该主机","Logout":"退出登录","Make Sure To Restart":"确定重启","Make Sure To Stop":"确定停止","Manage Code":"code管理","Check":"诊断","Manual assistance":"人工协助","Manual input":"手动输入","Mass import":"批量导入","Cloud Account Import":"云账号导入","Please Select Tthe Type":"请选择类型","medium":"中","Member":"成员","MFA Verification Instructions":"MFA 验证须知","Min. 30 min. 480 min":"最小30分钟，最大480分钟","minutes":"分钟","minutes)":"分钟）","monitor":"监视","Monitor":"监视","More":"更多","Multiple database with semicolons ‘;’ ‘":"多个以英文’;’分隔，’","Multiple users with semicolons ‘;’":"多用户以英文’;’分隔","Name:":"姓名:","Network Monitoring":"网络监控","New cluster":"新建集群","New Version:":"新版本:","Next":"下一步","No Data":"暂无数据","No Monitoring Information Is Available":"没有查询到监控数据","No More Data":"没有更多数据","No resource selected":"没有选择资源","No Resource Type":"暂无资源类型","Numbers Of Connections":"连接次数","No time":"暂无","Node:":"注:","Non-Security Mode Connection":"非安全模式","Non-security mode expiration time":"非安全模式有效时间","Note:":"注:","Notes for Attention:":"注意事项：","Note: The link is only available once (Valid time:":"注：该链接仅一次有效 （有效时间：","Note: The user and password are only available once (Valid time:":"注 : 该用户名和密码仅一次有效 (有效时间：","Use MySQL client to connect to the current database":"使用 MySQL 客户端连接当前数据库","Use SQL Server client to connect to the current database":"使用 SQL Server 客户端连接当前数据库","Use PostgreSQL client to connect to the current database":"使用 PostgreSQL 客户端连接当前数据库","A diagnostic connection user must have at least one of the following role permissions for the diagnostic database":"诊断连接用户对诊断库需具备以下至少一项角色权限：","Diagnostic connection users must have the following rights":"诊断连接用户需具备以下权限：","off":"关闭","Ok":"确定","on":"开启","Online Sessions":"在线连接","Open the target KEY authentication, please confirm that the KEY has been uploaded to the machine, control node connected to the local authentication KEY":"打开目标 KEY 认证，请确认 KEY 已经上传到机器，控制节点连接到本地认证 KEY","For SSH KEY authentication or team account authentication on the target host, ensure that the host user password has been verified.":"目标主机 SSH KEY 认证或团队账号认证，请先确认已通过主机用户密码校验。","For password free login or team account authentication on the target host, ensure that the host user password has been verified.":"目标主机免密登录或团队账号认证，请先确认已通过主机用户密码校验。","Opening":"开启中","Operation":"运维","Operation assistant":"运维助手","Operation Statistic":"运维统计","Pass":"通过","Personal":"个人","Play":"播放","Please confirm":"请确认","Please connect to the host for assistance information":"请先连接主机,获取协助信息!","Please download":"请先下载","Please enter a command to block, including multiple commands separated by \",\"":"请输入要拦截的指令，多个指令以”,”号分开","Please enter a command to alarm, including multiple commands separated by \",\"":"请输入要告警的指令，多个指令以”,”号分开","Please enter the above information manually in the MFA application to obtain the security code":"请在 MFA 应用程序中手动输入以上信息获取安全码","Please enter the two consecutive security codes you have obtained from the MFA application":"请输入您从 MFA 应用程序获取的连续两组安全码","Please execute the following script on a server in the current cluster (recommended using CentOS 7.9, 64 Bit) to configure the machine as a managed node.":"请您在当前集群中的一台服务器（推荐使用 CentOS 7.9, 64 Bit）上执行以下脚本，将该机器配置为管控节点。","Please perform the following script on the control node to update the control node to the latest version":"请您在管控节点上执行以下脚本更新管控节点到最新版","Please perform the following script on the control node to roll back the management node":"请您在管控节点上执行以下脚本回退管控节点","Please use the MFA application on your smartphone to scan":"请使用智能手机上的MFA应用程序进行扫描","Port":"端口","Project":"工作组","Public Network IP":"公网 IP","RAM":"内存","Reapply":"重新申请","reason":"原因","Reboot":"重启","Region":"地域","Reject":"拒绝","Remind Me Later":"稍后提醒我","Remove":"移除","Reset":"重置","Resource":"资源","Resource Type":"资源类型","Return":"退回","Return The Cluster":"退回集群","Save":"保存","Scan":"扫描","Scan again":"重新扫描","Scan Import":"扫描导入","Scan the two-dimensional code":"扫描二维码","Search":"搜索","Second Step":"第二步","Security mode":"安全模式","Security Mode":"安全模式","Security mode can only block Linux command operations, not including scripts and other ways.":"安全模式仅能够拦截 Linux 的指令操作，不包括脚本等其他方式。","Set Cluster":"设置集群","Configuration File":"配置文件","File Format Error":"文件格式错误","Cluster Does Not Exist":"集群不存在","Node Not Bound Or Does Not Exist":"节点未绑定或不存在","Set The Security Mode":"设置安全模式","Set The Security Mode:":"安全模式:","Setting":"设置","Setting Team Group":"设置群组","Setting WorkGroup":"设置工作组","Shanghai Zhuyun Information Technology Co.,Ltd":"上海驻云信息科技有限公司","Sharing Cluster":"分享集群","Show All":"查看全部","Show The Details Of The Application":"审批申请详情","SQL Application":"SQL 审批","SQL:":"SQL:","Preview SQL":"预览SQL","Checking SQL":"检查SQL","SSH command":"SSH 命令","SSH Command":"SSH 指令","Star Work Group":"星标工作组","Start":"启动","Start Application":"发起申请","Statistic":"运维统计","Status":"状态","Stop":"停止","strong":"强","Submit":"提交","Submit validation":"提交验证","Submiting":"提交中","Switch":"切换","System":"系统","System Disk":"系统盘","System Log":"系统日志","Alarm Notify":"告警通知","Alarm":"告警","System Logs":"系统日志","Target DataBase":"目标数据库","Team":"团队","Overview":"概览","Team code:":"团队代码:","Team Manage":"团队管理","Team member password complexity is not required":"团队成员的密码复杂度不作要求","Team Name:":"团队名称:","Team Name":"团队名称","Technical support":"技术支持","Customer Service":"客服服务","Immediate Consultation":"立即咨询","Temporary assistance link are created successfully and can be sent to assistants!":"临时协助链接创建成功，可发送协助方!","Temporary Authorize":"临时授权","Temporary password":"临时密码","Temporary user":"临时用户","Test":"测试","Test failed":"测试失败","Test passed":"测试通过","The administrator has enabled the password strength setting. The password must be at least 6 characters long and must contain two of uppercase letters, lowercase letters, and special characters.":"管理员已开启密码强度校验：至少6位长度，且须包含大小写字母、特殊字符中至少两项","The administrator has enabled the password strength setting. The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters.":"管理员已开启密码强度校验：至少8位长度，且须包含大小写字母、特殊字符","The agent has alive users,please disconnect them to continue.":"当前管控节点存在在线连接的用户，请断开连接再进行该操作。","The Aliyun Official Image Which We Support":"支持的阿里云官方镜像","The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible":"当前资源所在集群的管控节点版本过低，请尽快提醒管理员进行升级","The control node agent has released a new version, please update,":"管控节点发布了新版本, 为了更好的提供服务, 请尽快更新到最新版本，","can click":"可点击","update log":"更新日志","for detail.":"查看详情。","The current control node agent is lower, please update":"当前管控节点版本过低,请尽快更新","The Details Of My Application":"我的申请详情","The Duration Of The Operation":"连接时长","The forced restart server will causes the virtual host to lose data that is not currently saved.":"强制重启模式，会导致虚拟主机实例当前未保存的数据丢失。","The forced stop server will causes the virtual host to lose data that is not currently saved.":"强制停止模式，会导致虚拟主机实例当前未保存的数据丢失。","The Instance Is Starting Up":"实例正在启动中","The Instance Is Stopping":"实例正在停止中","The network has successfully installed the agent. If you need to change, please click \"Uninstall Agent\".":"该集群已绑定管控节点，如需迁移，请先点击「解绑管控节点」。","The password must be at least 6 characters long and must contain two types of three:uppercase letters, lowercase letters, and special characters. (the existing member will be forced to change the password when logging in. Please notify the relevant member to change the password. )":"密码长度最低6位，必须包含大写字母、小写字母、特殊字符中的两项（设置成功后，已有成员如果不满足密码强度将会在登录时强制要求修改密码，请提前通知相关成员修改密码)","The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters. (the existing member will be forced to change the password when logging in. Please notify the relevant member to change the password. )":"密码长度最低8位，必须包含大写字母、小写字母、特殊字符（设置成功后，已有成员如果不满足密码强度将会在登录时强制要求修改密码，请提前通知相关成员修改密码）","The reason for the application":"申请理由","The Way Of Start:":"开启方式","The Way Of Stop:":"停止方式","The Way Of Verification":"认证方式","This expiration time is not limited by the SSH or RDP timeout set on the host.":"该有效时间不受主机上设置的SSH或RDP超时时间限制。","To":"至","Unbind MFA":"解绑 MFA","Unbind":"解绑","Unbind successfully!":"解绑成功！","Reset successfully!":"重置成功！","Unbound phone number":"未绑定手机号","Uninstall Agent":"解绑管控节点","Unregister":"取消登录","Update Now":"立即更新","Update Time":"更新时间","Import And Restart":"导入并重启","Upload":"上传","Upload The Database List":"上传填写好的数据库列表","Upload The Host List":"上传填写好的主机列表","Uploading":"上传中","Use the CloudLinker password or KEY to verify":"请使用 CloudLinker 密码或 KEY 验证连接该主机","Use the operation and maintenance assistant to scan the above two-dimensional code":"使用运维小助手扫描以上二维码","Use the RDP client to connect to the current host":"使用 RDP 客户端连接当前主机","user name":"姓名","Username":"用户名","UserName":"用户名","Verify Security":"认证安全","Verify the MFA device":"验证 MFA 设备","Version 2.0 upgrade to Version 3.0 will disable the old connection code, please be prepared":"2.0的版本升级到3.0及以上的版本会导致连接code失效，请提前做好准备","View":"查看","View Members":"查看成员","Virtual MFA":"虚拟 MFA","weak":"弱","When permissions is enabled, webssh does not support KEY authentication.":"开启时，webssh 不支持KEY验证的方式.","Work Group":"工作组","Work Group List":"工作组列表","WorkGroup":"工作组","WorkGroup Manage":"工作组管理","You have bound":"你已绑定","Zone":"可用区","Report Type":"报告类型","Check Time":"诊断时间","Host Name":"主机名称","Report Name":"报告名称","Diagnostic Report List":"诊断报告列表","RequestTimeout":"请求超时","unknow error":"未知错误","Need login.":"请先登录。","Need privilege.":"需要授权。","Domain in use.":"公司代码已被占用。","Login failed.":"登录失败。","Verify failed.":"验证失败。","Already send SMS.":"已经发送验证码。","File is not found.":"文件未找到。","Quick links is not found.":"没有找到快速链接。","Workgroup Resource is not found.":"工作组资源未找到。","Log Filter is not found.":"日志过滤未找到。","Workgroup is not found.":"工作组未找到。","Cluster is not found.":"集群未找到。","Plan is not found.":"套餐未找到。","Sku is not found.":"Sku 未找到。","Bill is not found.":"账单未找到。","Note is not found.":"Node 未找到。","You should have at least one endpoint in your resource pool.":"您的资源池中应至少有一个端点。","Parameter name is invalid.":"参数名称无效.","One or more parameters invalid in batch create.":"批量创建时参数无效。","Error occured when batch delete.":"批量删除出错。","LDAP error, please contact your system administrator.":"LDAP 错误，请联系您的系统管理员。","Company is not found.":"团队 未找到。","Account is not found.":"用户未找到.","Account is exist.":"账号已存在.","You cannot delete yourself.":"你不能删除自己.","Your account has been locked.":"您的账号已被锁定。","Resource is not found.":"资源未找到。","Tunnel is online.":"已在线.","Tunnel is not found.":"连接未找到.","Tunnel is expired.":"连接已失效.","Cluster Exceeded.":"集群数超限。","Cluster still has resources.":"集群中还有资源.","Cluster has been shared.":"集群已经被分享.","Account Exceeded.":"账号数超限。","ResourceExceeded.":"资源超过上限","Subscription is not found.":"订阅未找到。","NetmaskTooSmall":"子网掩码过小","Reset Link Has Expire":"重置链接已过期","Captcha Incorrect":"验证码不正确","Register failed!":"注册失败!","Verification Code Incorrect.":"验证码不正确.","Subscribe Forbidden":"不允许订阅","Email send fail.":"邮件发送失败。","SMS send fail.":"短信发送失败.","Workgroup Name is exist.":"工作组名称已存在","Cluster Name is exist.":"集群名已存在.","Cluster unavailable.":"集群不可用.","Expire Time Too Big.":"有效时间不能超过1年.","sql application not found.":"sql 应用未找到.","You cannot remove your self.":"你不能删除你自己.","there is already one have installed, please unbund the exist one on cloudlinker.":"已经有一个已经安装，请在cloudlinker上解除存在的一个。","Shared cluster cannot change log filter rules.":"分享集群不能修改日志过滤规则.","Shared cluster cannot share to other company.":"分享集群不能分享其他团队.","Cluster already shared to the company or own is yourself.":"集群已共享给该团队或者共享的团队就是当前团队。","Must be Linux Server.":"必须是 Linux 主机.","Set auto login failed.":"登录失败.","Upgrade subscription failed.":"升级订阅失败。","Cannot upgrade subscription.":"无法升级订阅.","Subscribe overtime. The maximum length of subscription is 12.":"订阅过大 订阅的最大长度是12。","Subscription failed.":"登录失败.","Timeout.":"超时.","Need future time":"需要更多的时间","Hosts type error":"主机类型错误","Need to renew or update":"需要续费或升级","Need to check invoice title":"需要检查发票标题","Need invoice title and address":"需要发票标题和地址","Need invoice subscriptions":"需要发票订阅","Xiaoshouyi Error":"销售仪错误","Command exist":"指令已存在","cluster safe_mode is not open":"当前集群未开启安全模式","cluster safe_mode application exist":"当前集群已经申请了非安全模式","need apply safe mode":"非安全模式已过期，请刷新后重新申请","need right mfa code":"验证码输入错误","need right mfa key":"密钥输入错误","need mfa login":"请选登录","account pubkey not found":"用户 SSHKEY 未找到","account pubkey error":"用户 SSHKEY 错误","account pubkey is exist":"用户 sshkey 已存在","Tunnel connection is not found.":"连接未找到。","Refresh token is not exists.":"刷新令牌不存在.","InvalidToken":"令牌无效","The Time Frame Cannot Exceed One Year. Please Adjust It And Try Again.":"时间范围不能超过一年，请调整后再次尝试。","The account is bound to the primary account. Please change the bound administrator account in the team's Settings then delete it.":"该帐号绑定了主账号，请在团队的「设置」中更换绑定的管理员帐号后再删除","Workgroup Account Exist":"工作组成员已存在","Agent is not online.":"当前管控节点不可用.","The current status of the resource does not support this operation.":"资源现在不支持此操作","Can not create more than 5 shadows":"最多只允许创建5个在线协助会话","The specified InstanceId does not exist.":"当前管控节点存在在线连接的用户，请断开连接再进行该操作","Connection ID not found":"此连接已关闭","Task expired":"扫描结束，暂无数据。","You have entered the wrong password 10 times. Please try again in 1 hour or change the password by find the password feature.":"你已连续输错密码10次，请1个小时后再尝试或者通过找回密码功能修改密码。","Group Exist":"群组已存在","Group Name is exist":"群组名称已存在","Group not found":"群组未找到","Project Group Exist":"工作组群组已存在","Project Group not found":"工作组群组未找到","Group Account Exist":"群组成员已存在","Group Account not found":"群组成员未找到","Resource Name is exist":"资源名称已存在","Password error":"密码错误","IP is not in white list":"IP不在白名单内","User disabled":"用户已禁用","Please Confirm Whether Ak And Sk Are Correct":"请确认ak、sk是否正确","Insufficient Data Access Rights. Please Grant IAM.ECS.ReadOnlyAccess":"获取数据权限不足，请授予IAM.ECS.ReadOnlyAccess","Failed to obtain interface data. Please check if the parameters are correct!":"获取接口数据失败，请检查参数是否正确！","Project Name is exist":"工作组名称已存在","Invalid Resource Info":"无效的资源信息","AddUser":"添加用户","DeleteUser":"删除用户","CreateGroup":"创建群组","DeleteGroup":"删除群组","AddGroupMember":"添加群组成员","DeleteGroupMember":"删除群组成员","ModifySafeModeNotice":"修改安全模式","AddPostgreSQLDatabase":"添加PostgreSQL数据库","AddNoticeInstruction":"添加拦截告警","NoticeSecurityMode":"开启安全审批模式","Administrator":"管理员","Opt Admin":"配置管理员","Safe Admin":"安全管理员","Audit Admin":"审计管理员","Account Edited":"编辑用户","CreateCluster":"创建集群","DeleteCluster":"删除集群","AddLinuxServer":"添加Linux主机","DeleteLinuxServer":"删除Linux主机","AddWinServer":"添加win主机","DeleteWinServer":"删除win主机","AddMySQLDatabase":"添加MySQL数据库","DeleteMySQLDatabase":"移除MySQL数据库","AddSQLServerDatabase":"添加SQL Server数据库","DeleteSQLServerDatabase":"移除SQL Server数据库","ShareCluster":"分享集群","CloseSecurityMode":"关闭安全模式","OpenSecurityMode":"开启安全模式","AuditSecurityMode":"开启安全模式审核","UnauditSecurityMode":"关闭安全模式审核","AddInterceptInstruction":"添加拦截指令","RemoveInterceptInstruction":"移除拦截指令","ModifySecurityModeAuditor":"修改安全模式审核人","Account":"账号","Resource Name":"资源名称","Cluster Name":"集群名称","AddWorkgroupAccount":"添加工作组成员","DeleteWorkgroupAccount":"删除工作组成员","AddWorkgroupAdmin":"添加工作组管理员","DeleteWorkgroupAdmin":"删除工作组管理员","AddWorkgroupGroup":"添加工作组群组","DeleteWorkgroupGroup":"删除工作组群组","DeleteWorkgroup":"删除工作组","CreateWorkgroup":"创建工作组","AddLinuxServerToWorkgroup":"分配Linux主机","RemoveLinuxServerFromWorkgroup":"取消分配Linux主机","RemoveWinServerFromWorkgroup":"取消分配win主机","AddWinServerToWorkgroup":"分配win主机","AddMySQLDatabaseToWorkgroup":"分配sql数据库","RemoveMySQLDatabaseFromWorkgroup":"取消分配sql数据库","AddSQLServerDatabaseToWorkgroup":"分配SQL Server数据库","RemoveSQLServerDatabaseFromWorkgroup":"取消分配SQL Server数据库","Workgroup Name":"工作组名称","China East 1(Hangzhou)":"华东 1（杭州)","China East 2(Shanghai)":"华东 2（上海)","China South 1(Shenzhen)":"华南 1（深圳)","China North 1(Qingdao)":"华北 1（青岛)","China North 2(Beijing)":"华北 2（北京)","Hong Kong":"香港","Asia Pacific SE 1(Singapore)":"亚太 1  (新加坡)","US East 1(Virginia)":"美东 1（弗吉尼亚)","US West 1(Silicon Valley)":"美西 1（硅谷)","Curl must be installed":"需要手动安装curl","The password strength requirement is: the password length is lowest 6 bits , must contain two of uppercase letters, lowercase letters, and special characters.":"密码强度要求为：密码长度最低6位，必须包含大写字母，小写字母、特殊字符中的两项","The password strength requirement is: the password length is lowest 8 bits, must contain uppercase letter, lowercase letter, special character.":"密码强度要求为：密码长度最低8位，必须包含大写字母，小写字母、特殊字符","The password must be at least 6 characters long and must contain two uppercase letters, lowercase letters, and special characters.":"密码长度最低6位，必须包含大写字母、小写字母、特殊字符中的两项","The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters.":"密码长度最低8位，必须包含大写字母、小写字母、特殊字符","prompt":"提示","Your current login password complexity does not meet the password strength requirements set by the team administrator. Please change the password before continuing to use.":"您当前登录密码复杂度不符合团队管理员设置的密码强度要求，请修改密码后再继续使用","Submitted successfully! Please click the link in the message to set the password. ":"提交成功！请点击邮件中的链接设置密码 ","Unsafe Mode":"非安全模式","Check success!":"校验成功！","Check failed!":"校验失败！","Workgroup":"工作组","Resource IP":"资源IP","Resource Way":"资源类型","no online sessions":"当前无在线连接","Are you sure to disconnect this connection?":"你确定要断开连接吗?","Disconnect connection confirm":"确认断开连接","Disconnect successfully!":"断开连接成功!","LoginOut successfully!":"退出登录成功!","Login Successfully!":"登录成功!","Register Successfully!":"注册成功!","First column verification code":"第一组验证码","Second column verification code":"第二组验证码","Enter the 6-digit security code":"请填写 6 位数字安全码","Bind Mfa":"绑定  MFA","Open success!":"开启成功!","Duration/minute":"时长/分","Number":"次数","Number of Connections/number":"总连接数/次","Duration of Connections/hour":"连接时长/小时","File Name":"文件名称","Size":"大小","Users":"用户","Date":"日期","The maximum supported file size is 10M.":"最大支持10M的文件。","Upload successfully!":"上传成功!","Are you sure to delete the document?":"是否确认删除该文档?","Delete Confirm":"删除确认","Delete successfully!":"删除成功!","Exit successfully!":"退出成功!","%{ n } record":"%{ n } 条记录","Input history command":"输入历史指令","Command":"指令","Now":"现在","hour":"小时","minute":"分","second":"秒","Commission Team":"代运维团队名称","From":"从","unSafeMode":"非安全模式","End Time":"结束时间","timeRange":"时间范围","Save successfully!":"保存成功！","The Range Of Time":"时间范围","Unlimited":"不限","Within one day":"最近一天","Within one mouth":"最近一个月","Within seven days":"最近七天","Please input":"请输入","Start Time":"开始时间","select":"请选择","Allow IP":"允许 IP","Create Time / Expire Time":"起止时间","Are you sure to delete code ":"是否确认删除 ","Delete code confirm":"删除code确认","OK":"确定","Delete successfully":"删除成功","approving":"待审批","approved":"已通过","rejected":"未通过","success":"成功","failed":"失败","Viewing Of Log Content":"日志内容查看","Are you sure to delete current application?":"是否确认删除该申请？","Delete SQL application confirm":"删除 SQL 申请确认","Cancel successfully!":"取消申请成功！","Are you sure to execute current SQL?":"是否确认执行当前 SQL？","Execute SQL application confirm":"执行 SQL 申请确认","Submit success, you can check result later.":"提交成功，请稍后查看结果。","Are you sure to reject current application?":"是否确认拒绝当前申请？","Reject SQL application confirm":"拒绝 SQL 申请确认","Are you sure you want to cancel non-security mode application?":"确定要取消该申请？","Please confirm?":"请确认?","Through current non-security mode application?":"是否确认通过当前非安全模式申请?","Through non-security mode application":"通过非安全模式申请确认","Reject the current non-security mode application?":"是否确认拒绝当前非安全模式申请?","Reject non-safe mode application":"拒绝非安全模式申请确认","Please input sql":"请输入 sql","Please input comment":"请输入备注","Please input applicate reason":"请输入申请原因","Please select date":"请选择时间","Please input target database":"请输入目标数据库","Create successfully!":"创建成功！","The Reasons For The Application":"申请理由","Valid Time":"有效时间","My Application":"我发起的","General":"概况","Created Time":"创建时间","Pending Application":"待审批的","My Approved":"我已审批","Please Select Date":"请选择时间","Target Database":"目标数据库","Copy successfully!":"复制成功!","Please select workgroup":"请选择工作组","Please select resource":"请选择资源","The approval permission for the resource has been canceled":"你已被取消该资源的审批权限","In order to ensure the availability of the code, the maximum effective time cannot be less than 1 minutes":"为了保证code的可用性，有效时间不能低于 1 分钟","the effective time has exceeded the maximum effective time of the code set by the administrator: ":"有效时间已经超过管理员设置的code的最大有效时间：","Please input the username":"请输入用户名","Please input the password":"请输入密码","please input the right IP":"请输入正确的IP","Please input the expire time":"请输入有效时间","Server User":"主机用户","Server Password":"主机密码","Thirty minutes":"30 分钟","Name":"名称","Database Name":"数据库名称","Instance":"主机","Avaliable Code":"可用 Code","Connection Log":"连接日志","Database":"数据库","Create Code":"创建 Code","Modify Code":"修改 code","Temporary Password":"临时密码","Connection Address":"连接地址","one day later":"一天后","one month later":"一个月后","customize":"自定义","Please input the allow IP":"请输入允许IP","Unavailable":"不可用","Available":"可用","The new version of the agent does not support the database connection, coming soon.":"新版agent暂不支持数据库连接，敬请期待。","Copy Failed!":"复制失败!","Set failed.The admin has set the cluster's effective time to no more than ":"修改失败，管理员已设置当前主机所属集群的最大有效时间不能超过 ","Create code suceessfully!":"创建 code 成功!","Modify code successfully!":"修改 code 成功!","Creation failed, the effective time has exceeded the maximum effective time of the code set by the administrator":"创建失败，有效时间已经超过管理员设置的code的最大有效时间","%{ n } resource":"%{ n } 资源","please input search key":"请输入关键字","The maximum supported file size is 1M.":"最大支持1M的文件。","Change avatar successfully!":"修改头像成功！","wrong file type":"文件类型错误","Please input the name":"请输入名称","length is within 20 characters":"长度 20 个字以内","Enabled":"已开启","Unopened":"未开启","Off":"关闭","On":"开启","Disable":"禁用","Enable":"启用","Security Code":"安全码","Retry After":"后重发","Send Verify Code":"发送验证码","Change Mobile":"修改手机号","Mobile Number":"手机号码","Verify Code":"验证码","Verify":"校验","Please input mobile number":"请输入手机号","Please input verify code":"请输入验证码","Change successful":"修改成功","Verification code error":"验证码错误","Please enter your password!":"请输入密码!","Please enter your password again!":"请再次输入密码!","Two passwords are not consistent!":"两个密码不一致！","Password":"密码","repeat password":"重复密码","Modify password successfully,Please Re Login":"密码修改成功,请重新登录","You Have A New Alert Notification. Please Check It Promptly.":"您有新的告警通知，请及时查看。","Close Successfully!":"关闭成功!","Add Successfully!":"添加成功!","The Time Of Latest Verification":"最后验证时间","Add Time":"添加时间","Confirm to delete the SSH KEY?":"确定删除 SSH KEY?","successfully deleted!":"删除成功!","Please input the sshkey":"请输入sshkey","Please select the name":"请选择名称","Please input the key ID":"请输入key id","Please input the key secret":"请输入key secret","Please select the region":"请选择地域","yes":"是","no":"否","Servers":"主机","Databases":"数据库","Share Cluster":"分享集群","Log Filter":"日志过滤","OS":"操作系统","Specification":"规格","Type":"类型","Connectivity":"连通性","Operating System":"操作系统","region":"地域","Cloud Name":"云名称","Team Id":"团队代码","Team Full Name":"团队名称","SSO":"单点登录","Clock":"时钟","Sync":"同步","NTP Server":"NTP服务器","Current Time":"当前时间","Sync Cycle":"同步周期","Sync Countdown":"倒计时","NTP sync success!":"NTP同步成功！","NTP sync failed!":"NTP同步失败！","Please upload the metadata document.":"请上传元数据文档","Enable Password Login":"启用账密登录","ID Vendor":"身份供应商","Login URL":"登录地址","Assertion URL":"断言地址","Writer Metadata Document":"元数据文档","Access Restrictions":"访问限制","please input the ID Vendor":"请输入身份供应商","The maximum length can be up to 64 characters.":"长度最多可达 64 个字符。","Update SSO config successfully!":"更新SSO配置成功！","Only the xml file format is supported. The file size should not exceed 5MB and a maximum of 1 file can be uploaded.":"仅支持上传xml文件格式，文件大小不超过5MB，最大上传输了为1个。","Support inputting multiple email domain addresses, for example: cloudcare.cn. Multiple domains should be separated by commas.":"支持输入多个邮箱域名地址，例如：cloudcare.cn，多个域名用逗号分隔","Emails with the same domain suffix have the permission to obtain the single sign-on access link for this identity provider. When users log in for the first time, the system will dynamically create a CloudLinker member account, eliminating the need to create it in the system in advance.":"相同域名后缀的邮箱才有权限获取此身份提供商单点登录访问链接。用户首次登录时系统会动态创建CloudLinker成员账号，无需提前在系统内创建。","The default account permission is: Ordinary Member":"默认账号权限为：普通成员","Sharing Time":"分享时间","Filters Operation":"操作符","Condition":"条件","Upload SSH KEY":"上传 SSH KEY","ssh key verification":"SSH KEY 认证","Password Free Authentication":"免密认证","CloudLinker Authority Authentication":"团队账号认证","aliyun":"阿里云","Stop The Instance":"停止实例","Reboot Instance":"重启实例","Need to re input database password":"需要重新设置数据库密码","Turn On Instance":"启动实例","Not available now,coming soon.":"暂不可用，敬请期待。","Update Tip":"更新提示","IP/Connection Address":"IP/连接地址","Are you sure to delete this Cluster?":"是否确认删除此集群?","Return the current cluster?":"是否确认退回当前集群?","Please Confirm":"请确认","Return successfully!":"退回成功!","Are you sure to delete this resouce?":"是否确认删除该资源?","Delete Resource Comfirm":"删除资源确认","Already latest version.":"已经是最新版本.","Disconnect all connections ":"确认断开连接","Upgrade later":"稍后更新","Please Uninstall Agent Before!":"请先解绑管控节点!","Not Latest version, you can run script below again to update.":"不是最新版本,你可以运行下面脚本更新.","Disconnect successfully! Please Uninstall Agent Before!":"断开成功! 请先解绑管控节点!","Disconnect successfully! you can run script below again to update.":"断开成功!你可以运行下面脚本更新.","The current control node has %{ n } online connection. Please disconnect all connections and update it":"当前管控节点还有 %{ n }个在线连接,请断开所有连接后再更新","Are you sure to uninstall this agent?":"你确定要解绑管控节点?","Uninstall Agent Confirm":"解绑管控节点确认","unBind successfully!":"解绑成功!","Are you sure to cancel this sharing?":"你确定要取消分享?","Cancel Share Confirm":"确定取消分享","Cancel Share successfully!":"取消分享成功！","Are you sure to delete this Filters Operation ?":"是否确认删除此操作符?","Delete Prompt":"删除提示","Are you sure to delete selected resource?":"是否确认删除选择的资源?","Delete Resource Confirm":"删除资源确认","Upload failed":"上传失败","Upload success":"上传成功","Team code":"团队代码","Please input the team code":"请输入团队代码","Please input the condition":"请输入过滤条件","Fileter Operator":"操作符","shared cluster":"共享的集群","Return the current network?":"是否确认退回当前集群?","Are you sure to delete the cluster?":"是否确认删除集群?","Please input the cluster name":"请输入集群名称","length is within 50 characters":"长度 50 个字以内","Note: A cluster can add up to 1000 resources":"注：一个集群最多可添加1000个资源","Please input the resource name":"请输入资源名称","Please input the ip/link address":"请输入 ip/连接 地址","Please input the userName":"请输入用户名","Please input the port":"请输入端口","Resource name":"资源名称","IP or connection string":"IP或连接地址","Database name format is incorrect":"数据库名称格式错误","Please input the databaseName":"请输入数据库名称","Please input the instance_id":"请输入实例 ID","Please input the Inner IP":"请输入内网","please input the right Inner IP":"请输入正确的内网","please input the right port":"请输入正确的端口","Please input the flavor descroption":"请输入规格描述","Confirm that agent has integrated AK":"请确认管控节点已配置AK权限","Inner IP":"内网 IP","Address":"地址","Flavor Descroption":"规格描述","1 core 1G etc.":"如1核1G等信息。","Create cluster successfully!":"创建集群成功!","The resource list is empty. Please check again!":"资源列表为空，请检查确认!","Exceeding the maximum number of resources":"超过资源数量上限","Please upload the correct form!":"请上传正确模板的表格!","Intranet IP:":"私网IP:","exist!":"已存在!","Change successfully!":"修改成功!","Version":"版本","cloud":"普通云盘","cloud_efficiency":"高效云盘","cloud_ssd":"SSDs云盘","ephemeral_ssd":"本地SSD盘","ephemeral":"本地磁盘","Basic Information":"基础信息","Monitoring Information":"监控信息","One Hour":"1小时","Six Hours":"6小时","One Day":"1天","Seven Days":"7天","Cpu usage (%)":"Cpu 使用率(%)","Total Out Flow (kbytes)":"总流出流量(kbytes)","Total In Flow (kbytes)":"总流入流量(kbytes)","Disk Read Bandwidth (KByte/s)":"磁盘读带宽(KByte/s)","Disk write bandwidth (KByte/s)":"磁盘写带宽(KByte/s)","Table Name":"表名称","Read":"已读","Unread":"未读","SQL Interception":"SQL 拦截","Interception Command":"拦截指令","SQL Approver":"SQL 审批人","Not set approver":"没有添加审批人","Not set notifier":"没有添加通知人","Not add block command":"没有添加拦截指令","The availability of key":"KEY 的可用性","Account Name":"用户名","Availability":"可用","Please select":"请选择","Set Status":"设置状态","System command alarm":"系统指令告警","Alarm instruction":"告警指令","SQL Alarm instruction":"SQL指令告警","Block Command":"拦截指令","Security Mode Application":"安全模式审批","Not set up block command":"没有添加拦截指令","Not set up alarm command":"没有添加告警指令","Remove successfully!":"移除成功！","Please input the Cidr Block":"请输入网段地址","Please input the AK":"请输入AK","Please input the SK":"请输入SK","Please select the cloud platform":"请选择云平台","Cloud Platform":"云平台","Area":"区域","e.g. 10.0.0.0/24, and only supports 24-32":"格式如10.0.0.0/24,且只支持24-32","Please select the os":"请选择操作系统","Cidr Block":"网段地址","Network, e.g. 10.0.0.0/24":"网段, 如10.0.0.0/24","userName":"用户名","Scan success":"扫描成功","No available instance found":"未找到可用实例","Available; Split multiple usernames":"可用；分割多个用户名","IP / Connection Address":"IP / 连接地址","Instance Name / Instance ID":"实例名称 / 实例ID","Select The Host":"选择主机","Select The Database":"选择数据库","Huawei Cloud(China)":"华为云（中国站）","Huawei Cloud(International)":"华为云（国际站）","Alibaba Cloud(China)":"阿里云（中国站）","Alibaba Cloud(International)":"阿里云（国际站）","AWS(International)":"亚马逊云（国际站）","AWS(China)":"亚马逊云（中国站）","Volcengine":"火山引擎","Scan Type":"扫描方式","Full Scan":"全部","Block Imported IP":"屏蔽已导入的IP","Import success":"导入成功","Effective time cannot exceed 1 year":"有效时间不能超过1年","In order to ensure the availability of the code, the maximum effective time cannot be less than 30 minutes":"为了保证code的可用性，最大有效时间不能低于 30 分钟","day":"天","Please enter the numeric type":"请输入数值类型","Cluster Name :":"集群名称 ：","Cluster IP :":"集群IP ：","The maximum effective time of code :":"code可设置的最大有效时间 :","IP Name":"网关策略","Origin Port":"原始规则","Map Port":"映射数值","Service Port Mapping":"服务端口映射","Note: After enabling the service connection mapping function, the IP and port displayed during actual connection will be subject to the current mapping rules.":"注意：启用服务连接映射功能后，实际连接时显示的IP及端口将以当前映射规则为准。","The port mapping rules cannot have duplicate ports":"端口映射规则中不能有重复的端口","Create group successfully!":"创建群组成功！","Please input members name":"请输入成员名称","Please input workgroup name":"请输入工作组名称","Please input members name or account search":"请输入成员名称或者账号搜索","Please input workgroup name search":"请输入工作组名称搜索","Member is found":"成员未找到","Workgroup is found":"工作组未找到","Add success":"添加成功","Please input the group name":"请输入群组名称","length is within 140 characters":"长度在140个字符以内","Group Name":"群组名称","Ordinary User":"普通用户","Full Name":"名称","Display Nickname":"显示昵称","Display Nickname:":"显示昵称:","Email":"邮箱","Repeat Password":"重复密码","Role":"角色","Select Role":"请选择","update account success":"更新账户成功","Please confirm your password":"请确认您的密码","Group":"群组","Please input group name search":"输入群组名称搜索","Group is not found":"群组未找到","administrator":"管理员","Ordinary Member":"普通成员","Change success":"修改成功","Create workgroup success":"创建工作组成功","Database name/ IP":"数据库名称/IP","Please input the workgroup name":"请输入工作组名称","2-255 characters":"2-255位字符","Workgoup Name":"工作组名称","Describe":"描述","User Name":"用户名","Are you sure to remove selected?":"是否确认移除已选择的?","Remove Confirm":"移除确认","Enterprise":"企业版","Ultimate":"至尊版","Basic":"基础版","Premium":"高级版","Trial":"试用版","please input the team name":"请输入团队名称","please input the contact name":"请输入联系人","please input the contact phone":"请输入联系电话","please input the right contact phone":"请输入正确格式的联系电话","please input the contact address":"请输入联系地址","please input the ip whitelist, CIDR address is not allowed":"请输入白名单, 不能为CIDR地址","please input the ip whitelist":"请输入白名单","%{ n } day":"%{ n } 天","expired":"已过期","Please input Group Name to Search":"输入群组名称搜索","Account Type":"用户类型","Select":"请选择","Members Number":"成员数","Team ID":"团队代码","Contact Name":"联系人","Contact Phone":"联系电话","Contact Address":"联系地址","IP Whitelist":"IP 白名单","Admin IP Whitelist":"管理员IP白名单","Code IP Whitelist":"Code IP 白名单","The creator's IP is added automatically; only whitelisted IPs can connect":"创建人IP自动加入，仅白名单IP可连","Login Hold Time":"登录保持时长","It takes effect after you log in again":"重新登录后生效","Team MFA Certification":"团队MFA认证","Team Token":"团队Token","Update":"更新","Update successfully!":"更新成功！","Binded Workspace":"已绑工作空间","Compel Change Password":"密码定期更改","Team members request password changes every 90 days":"团队成员每隔90天要求更改密码","Login Lockout":"登录锁定","If you enter the password incorrectly 10 times in a row, your account will be locked for 1 hour":"密码连续输入错误 10 次，账号锁定 1 小时","Leave blank":"留空","Multiple IP to separate":"多个IP以, 分隔","Resources:":"资源:","users:":"用户:","Clusters:":"集群:","Shared Clusters:":"分享集群:","Shared Resources:":"分享资源:","remaining time:":"剩余时间:","Motify":"修改","The maximum amount of resources for a single network in the current version is":"当前版本单个集群的资源上限是","Password Strength":"密码强度","Master Account Binding Administrator":"主账号绑定的管理员","Modify team info successfully!":"修改团队信息成功!","Are you sure to delete this account!":"是否确认删除此成员!","There are members in the group, please delete all members before delete the group!":"群组中还有成员，请清空成员后再删除群组！","Are you sure to delete this group!":"是否确认删除该群组?","2-20 characters":"2-20位字符","Please input the email":"请输入邮箱","Please input the right email":"请输入正确的邮箱","2-16 characters":"2-16位字符","Please select the role":"请选择角色","ordinary user":"普通用户","adminstrator":"管理员","DataBases":"数据库","IP/Connection String":"IP/连接地址","default workgroup":"默认工作组","Select Cluster":"选择集群","Select Resource":"选择资源","Selected Instance":"已选主机","Selected Database":"已选数据库","Host name / IP":"主机名称 / IP","Are you sure to delete selected?":"是否确认删除已选择的?","Are You Sure To Exit The Selected Working Group?":"是否确认退出已选择的工作组?","%{ n } member":"%{ n } 成员","Please input WokGroup Name":"请输入工作组名称","Are you sure to delete this project?":"是否确认删除此工作组?","Note: A workgroup can allocate up to 1000 resources":"注：一个工作组最多可分配1000个资源","Within 7 Days":"最近7天","Within 30 Days":"最近30天","Within 90 Days":"最近90天","Number of Connections":"总连接次数","Duration of Connections":"连接时长","The total number of connections":"总连接次数","The total length of connections":"总连接时长","others":"其他","Login Log":"登录日志","Team Log":"团队日志","Cluster Log":"集群日志","Workgroup Logs":"工作组日志","Event Notice":"事件通知","Alarm Log":"告警日志","Remove Event Notice":"删除事件通知","Whether to confirm deleting event notifications?":"是否确认删除事件通知？","Create Event Notice":"新建事件通知","Log Detail":"日志详情","Edit Event Notice":"编辑事件通知","Event Type":"事件类型","Event":"事件","Please input account":"请输入账号","Time":"时间","Login Ip":"登录 Ip","Login Status":"登录状态","Group Edited":"编辑群组","Operation Time":"操作时间","Operation Obj":"运维对象","Operator":"操作人","In Work Group":"所属工作组","Connect Type":"连接方式","Trigger Strategy":"触发策略","Event Desc":"事件描述","Desc":"备注","File Transfer":"文件传输","Service Name / SID":"服务名称 / SID","Connection identifier type":"连接标识类型","Please select the connection identifier type":"请选择连接标识类型","Please input the Service Name / SID":"请输入服务名称 / SID","Oracle only supports web connections":"Oracle 仅支持 Web 连接","AddOracleDatabase":"添加Oracle数据库","DeleteOracleDatabase":"移除Oracle数据库","AddOracleDatabaseToWorkgroup":"分配Oracle数据库","RemoveOracleDatabaseFromWorkgroup":"取消分配Oracle数据库"}}

/***/ }),
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    done: {
      type: Function,
      default: function _default() {}
    }
  },

  methods: {
    onChange: function onChange(e) {
      var _this = this;

      var files = e.target.files;

      var allFiles = [];

      var _loop = function _loop() {

        var file = files[i];

        var reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = function () {
          var fileInfo = {
            name: file.name,
            type: file.type,
            size: Math.round(file.size / 1000) + ' kB',
            base64: reader.result,
            file: file
          };

          allFiles.push(fileInfo);

          if (allFiles.length == files.length) {
            if (_this.multiple) _this.done(allFiles);else _this.done(allFiles[0]);
          }
        };
      };

      for (var i = 0; i < files.length; i++) {
        _loop();
      }
    }
  }
});

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__);



/* harmony default export */ __webpack_exports__["default"] = ({

    props: {
        text: { type: String, required: true },
        size: { type: Number, required: false, default: 256 },
        color: { type: String, required: false, default: '#000' },
        bgColor: { type: String, required: false, default: '#FFF' },
        errorLevel: {
            type: String,
            validator: function validator(value) {
                return value === 'L' || value === 'M' || value === 'Q' || value === 'H';
            },
            required: false,
            default: 'H'
        }
    },

    watch: {
        text: function text() {
            this.clear();
            this.makeCode(this.text);
        }
    },

    data: function data() {
        return {
            qrCode: {}
        };
    },
    mounted: function mounted() {
        this.qrCode = new __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a(this.$el, {
            text: this.text,
            width: this.size,
            height: this.size,
            colorDark: this.color,
            colorLight: this.bgColor,
            correctLevel: __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a.CorrectLevel[this.errorLevel]
        });
    },


    methods: {
        clear: function clear() {
            this.qrCode.clear();
        },
        makeCode: function makeCode(text) {
            this.qrCode.makeCode(text);
        }
    }
});

/***/ }),
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(90);


/* harmony default export */ __webpack_exports__["a"] = ({
	getClusterList: function getClusterList(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/network', 'get', params);
	},
	getClusterListV1: function getClusterListV1(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('v1/network/list', 'get', params);
	},
	addCluster: function addCluster(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/network', 'post', params);
	},
	deleteCluster: function deleteCluster(id) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/network/' + id, 'delete');
	},
	getClusterDetail: function getClusterDetail(id) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/network/' + id);
	},
	changeCluster: function changeCluster(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/network/' + params.id, 'patch', { data: params.data });
	},
	getInstancesList: function getInstancesList(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/resource', 'get', params);
	},
	getClusterResourceList: function getClusterResourceList(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/network/' + params.network_id + '/resource', 'get', { params: params.data });
	},
	getInterceptsCommand: function getInterceptsCommand(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/intercepts', 'get', { params: params });
	},
	getDetailResource: function getDetailResource(id) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/resource/' + id);
	},
	patchDetailResource: function patchDetailResource(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/resource/' + params.id, 'patch', params.data);
	},
	delDetailResource: function delDetailResource(ids) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/resource/' + ids, 'delete');
	},
	batchDeleteResource: function batchDeleteResource(ids) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/batch/resource/' + ids, 'delete');
	},
	addClusterResource: function addClusterResource(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/resource', 'post', params);
	},
	updateAgent: function updateAgent() {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/check_update');
	},
	getSharing: function getSharing(id) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/network/' + id + '/sharing');
	},
	addSharing: function addSharing(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/network/' + params.id + '/sharing', 'patch', { data: params.data });
	},
	cancelShareCluster: function cancelShareCluster(id) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/network/' + id, 'delete');
	},
	addLogFilter: function addLogFilter(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/log_filter', 'post', params);
	},
	delLogFilter: function delLogFilter(id) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/log_filter/' + id, 'delete');
	},
	batchDelLogFilter: function batchDelLogFilter(ids) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/batch/log_filter/' + ids, 'delete');
	},
	getSafeApprover: function getSafeApprover(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/account', 'get', { params: params });
	},
	addIntercept: function addIntercept(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/need_intercept_command/batch', 'post', params);
	},
	deleteIntercept: function deleteIntercept(ids) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/need_intercept_command/batch/' + ids, 'delete');
	},
	deleteAlarmIntercept: function deleteAlarmIntercept(ids) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/need_intercept_command/batch_notice/' + ids, 'delete');
	},
	scanImportStart: function scanImportStart(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/service_discovery_start', 'get', { params: params });
	},
	scanImportQuery: function scanImportQuery(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/service_discovery_query', 'get', { params: params });
	},
	postBatchResource: function postBatchResource(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/batch/resource', 'post', { data: params });
	},
	cloudImportECS: function cloudImportECS(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/network/load_ecs_from_ak', 'post', { data: params });
	},
	cloudImportRDS: function cloudImportRDS(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/network/load_rds_from_ak', 'post', { data: params });
	},
	testConnection: function testConnection(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/service_connection_test', 'get', { params: params });
	},
	queryTestConnection: function queryTestConnection(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/query_service_connection_test', 'get', { params: params });
	},
	getNewAgentQuery: function getNewAgentQuery(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/service_discovery_query_v1', 'get', { params: params }, true);
	},
	testKeyAvaliable: function testKeyAvaliable(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/resource/' + params.id + '/test_autologin', 'get', { params: params.params });
	},
	queryTestAvaliable: function queryTestAvaliable(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/resource/' + params.id + '/test_autologin_query', 'get', { params: params.params });
	},
	xlsxBatchImport: function xlsxBatchImport(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/file/batch/resource', 'post', { data: params });
	},
	getClusterResourceStatistic: function getClusterResourceStatistic(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/statistic/network_project_v1', 'GET', { params: params });
	},
	getClusterStatistic: function getClusterStatistic(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/statistic/network_v1', 'GET', { params: params });
	},
	getResourceStatistic: function getResourceStatistic(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/statistic/project_v1', 'GET', { params: params });
	},
	uploadSshkey: function uploadSshkey(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/resource/' + params.resourceId + '/autologin', 'post', { data: params.data });
	},
	queryUploadSshkey: function queryUploadSshkey(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/resource/' + params.resourceId + '/autologin_query', 'get', { params: params.params });
	},
	getEcsAliyunInfo: function getEcsAliyunInfo(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/resource/' + params.id + '/aliyun/ecs', 'get', { params: params.params });
	},
	batchDelOnlineUser: function batchDelOnlineUser(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/tunnel_connection/delete_all', 'post', { data: params });
	},
	getCloudRegions: function getCloudRegions(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/network/regions/' + params.source + '/' + params.language, 'get');
	},
	scanInstance: function scanInstance(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/network/get_instance_list', 'post', { data: data });
	},
	loadInstance: function loadInstance(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/network/load_instances', 'post', { data: data });
	},
	getResourceList: function getResourceList(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/resource/list', 'get', { params: params });
	},
	exportClusterConfig: function exportClusterConfig(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/agent/config/export', 'get', { params: params });
	},
	importClusterConfig: function importClusterConfig(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/agent/config/import', 'post', { data: params });
	},
	pollingClusterConfig: function pollingClusterConfig(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/agent/config/query', 'get', { params: params });
	}
});

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(90);



/* harmony default export */ __webpack_exports__["a"] = ({
  getOnlineConnectCount: function getOnlineConnectCount(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/v1/tunnel_connection/count', 'get', { params: params });
  },
  getOnlineConnectList: function getOnlineConnectList(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/v1/tunnel_connection/list', 'get', { params: params });
  },
  cutOnlineConnent: function cutOnlineConnent(id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/tunnel_connection/' + id, 'delete');
  },
  cutOnlineConnentMultiple: function cutOnlineConnentMultiple(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/tunnel_connection/delete_all', 'post', { data: params });
  },
  getStatistics: function getStatistics(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/v1/summary', 'get', { params: params });
  },
  getTopMembers: function getTopMembers(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/statistic/account_v1', 'get', { params: params });
  },
  getTopResources: function getTopResources(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/statistic/resource_v1', 'get', { params: params });
  },
  getConnectNumbers: function getConnectNumbers(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/connect/numbers', 'get', { params: params });
  },
  getWeekOperationStatistic: function getWeekOperationStatistic(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/statistic/overview_v1', 'GET', { params: params });
  },
  getResourceTypeStatistic: function getResourceTypeStatistic(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/instances_summary', 'GET', { params: params });
  },
  getStatisticSummary: function getStatisticSummary(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* axiosAjax */])('/statistic/summary', 'GET', { params: params });
  }
});

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(90);

/* harmony default export */ __webpack_exports__["a"] = ({
  getDocumentList: function getDocumentList(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/file_manage', 'get', params);
  },
  delDocument: function delDocument(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/file/manage', 'delete', { data: params });
  },
  uploadFile: function uploadFile(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/file/manage', 'post', { data: params });
  }
});

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(90);


/* harmony default export */ __webpack_exports__["a"] = ({
	getLogin: function getLogin(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/event/get_login_log', 'get', params);
	},
	getTeam: function getTeam(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/event/get_account_log', 'get', params);
	},
	getCluster: function getCluster(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/event/get_net_log', 'get', params);
	},
	getResource: function getResource(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/event/get_project_log', 'get', params);
	},
	getAlarmLog: function getAlarmLog(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/event/get_notice_log', 'get', params);
	},
	handleEventNotice: function handleEventNotice(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/event/alarm', 'post', params);
	},
	getActionList: function getActionList(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/search_tunnel', 'get', params);
	},
	getAllMenber: function getAllMenber(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/account/list', 'get', { params: params });
	},
	getAllResourceName: function getAllResourceName(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/resource/all_name', 'get', { params: params });
	},
	unFreezeLog: function unFreezeLog(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/unfreeze_tunnel_log', 'get', params);
	},
	getAlarmNotifyUnreadCounts: function getAlarmNotifyUnreadCounts(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/notice', 'get', { params: params });
	},
	closeAlarmNotify: function closeAlarmNotify() {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/remove_notice', 'post');
	},
	viewLog: function viewLog(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/download_tunnel_log', 'get', params);
	}
});

/***/ }),
/* 989 */,
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(90);


/* harmony default export */ __webpack_exports__["a"] = ({
  getProject: function getProject(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project', 'get', { params: params });
  },
  getResourceList: function getResourceList(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project_resource', 'get', { params: params });
  },
  createSqlApplication: function createSqlApplication(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/sql_application_resource', 'post', { data: params });
  },
  getMySqlApplication: function getMySqlApplication(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/sql_application_resource', 'get', { params: params });
  },
  getApprovingApplication: function getApprovingApplication(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/sql_application/approving', 'get', { params: params });
  },
  getApprovedApplication: function getApprovedApplication(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/sql_application/approved', 'get', { params: params });
  },
  getSafeApplication: function getSafeApplication(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project/need_safe_mode', 'get', { params: params });
  },
  createSafeModeApply: function createSafeModeApply(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/safe_mode_application', 'post', { data: params });
  },
  getMySafeModeApply: function getMySafeModeApply(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/safe_mode_application', 'get', { params: params });
  },
  getSafeApprovingApply: function getSafeApprovingApply(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/safe_mode_application/approving', 'get', { params: params });
  },
  getSafeApprovedApply: function getSafeApprovedApply(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/safe_mode_application/approved', 'get', { params: params });
  },
  getMyApplyDetail: function getMyApplyDetail(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/sql_application/detail', 'get', { params: params });
  },
  deleteSqlDetail: function deleteSqlDetail(applicationId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/sql_application_resource/' + applicationId, 'delete');
  },
  excuteSqlApplication: function excuteSqlApplication(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/passing/sql_application', 'get', { params: params });
  },
  rejectSqlApplication: function rejectSqlApplication(params, id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/sql_application_resource/' + id, 'patch', { data: params });
  },
  getSafeDetail: function getSafeDetail(id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/safe_mode_application/' + id, 'get', null, true);
  },
  deleteSafeApply: function deleteSafeApply(id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/safe_mode_application/' + id, 'delete');
  },
  doSafeExcute: function doSafeExcute(params, id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/safe_mode_application/' + id, 'patch', { data: params });
  },
  doSafeReject: function doSafeReject(params, id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/safe_mode_application/' + id, 'patch', { data: params });
  }
});

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(90);


/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/account_pubkey', 'get', params);
  },
  delKey: function delKey(id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/account_pubkey/' + id, 'delete');
  },
  addKey: function addKey(params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/account_pubkey', 'post', params);
  }
});

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(90);


/* harmony default export */ __webpack_exports__["a"] = ({
	getCurrent: function getCurrent() {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/current_company');
	},
	setTeam: function setTeam(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/current_company', 'patch', params);
	},
	getList: function getList(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/account', 'get', params);
	},
	getMemberList: function getMemberList(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/account/list', 'get', params);
	},
	addMember: function addMember(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/account', 'post', params);
	},
	getMember: function getMember(id) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/account/' + id);
	},
	editMember: function editMember(params) {
		console.log('--pa', params);
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/account/' + params.data.id, 'patch', params.data);
	},
	deleteMember: function deleteMember(id) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/account/' + id, 'delete');
	},
	getGroupList: function getGroupList(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/group/list', 'get', params);
	},
	getGroupMemberList: function getGroupMemberList(params) {
		console.log('--params--', params);
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/group/members/' + params.id, 'get', { params: params.data });
	},
	addGroup: function addGroup(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/group', 'post', params);
	},
	editGroup: function editGroup(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/group/' + params.group_id, 'patch', params.data);
	},
	deleteGroup: function deleteGroup(id) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/group/' + id, 'delete');
	},
	getGroup: function getGroup(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/group/' + params.id, 'get', { params: params.data });
	},
	groupAddMember: function groupAddMember(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/group/members/' + params.group_id, 'post', { data: params.data });
	},
	deleteGroupMember: function deleteGroupMember(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/group/members/' + params.group_id, 'delete', { data: params.data });
	},
	getStatistic: function getStatistic(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/statistic/company_account_v1', 'GET', { timeout: 8000, params: params });
	},
	getResourceStatistic: function getResourceStatistic(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/statistic/company_resource_v1', 'GET', { timeout: 8000, params: params });
	},
	getPlanInfo: function getPlanInfo() {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/summary');
	},
	updateTeamToken: function updateTeamToken() {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/company/update_domain_token', 'post');
	},
	unBindWorkSpace: function unBindWorkSpace(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/company/ee/unbind', 'post', params);
	},
	resetMFA: function resetMFA(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/account/reset_mfa?account_id=' + params.id, 'get', params);
	},
	getSSOConfig: function getSSOConfig() {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/sso/config', 'get');
	},
	updateSSOConfig: function updateSSOConfig(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/sso/update_config', 'patch', { data: data });
	},
	getNTPConfig: function getNTPConfig() {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/company/ntp', 'get');
	},
	updateNTPConfig: function updateNTPConfig(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/company/ntp', 'post', { data: data });
	}
});

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(90);

var assistUrl = 'http://120.27.135.41:9527/api';

/* harmony default export */ __webpack_exports__["a"] = ({
	getWorkGroupResource: function getWorkGroupResource(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/project/resources/' + params.id, 'GET', { params: params.params });
	},
	getFavouriteWorkGroup: function getFavouriteWorkGroup(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project/favourite', 'GET', { params: params });
	},
	getWorkGroupList: function getWorkGroupList(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/project/list', 'GET', { params: params });
	},
	setFavourite: function setFavourite(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project/' + params.id + '/favourite', 'PUT', { data: params });
	},
	getWorkGroupDetail: function getWorkGroupDetail(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/project/' + params.id, 'GET');
	},
	getTunnelCode: function getTunnelCode(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/tunnel', 'GET', { params: params });
	},
	getVersionByType: function getVersionByType(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/report/get_version_by_type', 'GET', { params: params });
	},
	createCsosReport: function createCsosReport(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/report/create_csos_report', 'post', { data: data });
	},
	getCsosReport: function getCsosReport(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/report/get_csos_report', 'GET', { params: params });
	},
	getCsosReportState: function getCsosReportState(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/report/task_status', 'GET', { params: params });
	},
	delWorkGroupResource: function delWorkGroupResource(id) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/project/' + id, 'delete');
	},
	createdWorkGroupResource: function createdWorkGroupResource(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/project', 'post', { data: params });
	},
	patchWorkGroupResource: function patchWorkGroupResource(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/project/' + params.id, 'patch', { data: params.data });
	},
	getConnectLog: function getConnectLog(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/search_tunnel', 'get', { params: params });
	},
	getTunnelInfo: function getTunnelInfo(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/tunnel', 'post', { data: data });
	},
	testPasswordConnection: function testPasswordConnection(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/tunnel/test_password_connection', 'post', { data: data });
	},
	updateTunnel: function updateTunnel(code, data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/tunnel/' + code, 'patch', { data: data });
	},
	addWorkgroupResource: function addWorkgroupResource(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/project/resources/' + params.projectId, 'post', { data: params.data });
	},
	batchDelWorkgroupResource: function batchDelWorkgroupResource(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/project/resources/' + params.projectId, 'delete', { data: params.data });
	},
	delWorkGroupMember: function delWorkGroupMember(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project/' + params.projectId + '/member', 'delete', { params: params.data });
	},
	addWorkgroupMember: function addWorkgroupMember(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project/' + params.projectId + '/member', 'post', { data: params.data });
	},
	getWorkgroupMemberList: function getWorkgroupMemberList(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/project/members/' + params.id, 'GET', { params: params.data });
	},
	getWorkgroupGroup: function getWorkgroupGroup(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project/' + params.projectId + '/group', 'GET', { params: params.data });
	},
	getWorkgroupGroupList: function getWorkgroupGroupList(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/project/groups/' + params.id, 'GET', { params: params.data });
	},
	delWorkgroupGroup: function delWorkgroupGroup(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project/' + params.projectId + '/group', 'delete', { params: params.data });
	},
	addWorkgroupGroup: function addWorkgroupGroup(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project/' + params.projectId + '/group', 'post', { data: params.data });
	},
	patchWorkGroupMember: function patchWorkGroupMember(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project/' + params.projectId + '/member', 'patch', { data: params.data });
	},
	getWorkgroupMemberAdmin: function getWorkgroupMemberAdmin(projectId) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project/' + projectId + '/admin');
	},
	getPeojectResourceInfo: function getPeojectResourceInfo(id) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project_resource/' + id, 'get');
	},
	changeLoginUser: function changeLoginUser(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project_resource/' + params.id + '/login_username', 'post', { data: params.data });
	},
	getClientIp: function getClientIp() {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/client_ip', 'get');
	},
	createCode: function createCode(data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/tunnel', 'post', { data: data });
	},
	deleteCode: function deleteCode(code, data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/tunnel/' + code, 'patch', { data: data });
	},
	getCodeInfo: function getCodeInfo(code) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/tunnel/' + code, 'get');
	},
	modifyCode: function modifyCode(code, data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/tunnel/' + code, 'patch', { data: data });
	},
	setProjectDafaultName: function setProjectDafaultName(id, data) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project_resource/' + id + '/default_username', 'put', { data: data });
	},
	getCodeVersion: function getCodeVersion(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/tunnel', 'get', { params: params });
	},
	getResourceOnlineConnects: function getResourceOnlineConnects(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/tunnel_connection/list', 'get', { params: params });
	},
	getLiteConnectInfo: function getLiteConnectInfo(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/tunnel', 'post', { baseURL: assistUrl, data: params });
	},
	getAssistInfo: function getAssistInfo(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/tunnel/connections', 'get', { baseURL: assistUrl, params: params });
	},
	getShadowConnect: function getShadowConnect(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/tunnel/shadow', 'post', { baseURL: assistUrl, data: params });
	},
	queryCsosConnect: function queryCsosConnect(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/tunnel/connections', 'get', { params: params });
	},
	getCsosShadow: function getCsosShadow(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/tunnel/shadow/code', 'post', { data: params });
	},
	verifySQL: function verifySQL(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/sql_application/verify', 'post', { data: params });
	},
	getAccountWorkgroupList: function getAccountWorkgroupList(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/v1/project/get_project_by_account/' + params.id, 'get', params);
	},
	addAccountWorkgroup: function addAccountWorkgroup(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project/bulk_add_project', 'post', { data: params });
	},
	deleteAccountWorkgroup: function deleteAccountWorkgroup(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/project/bulk_delete_project', 'delete', { data: params });
	},
	getWorkGroupListByGroup: function getWorkGroupListByGroup(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/group/' + params.id + '/project', 'GET');
	},
	addGroupWorkgroup: function addGroupWorkgroup(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/group/' + params.id + '/project', 'post', { data: params });
	},
	deleteGroupWorkgroup: function deleteGroupWorkgroup(params) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* axiosAjax */])('/group/' + params.id + '/project', 'delete', { data: params });
	}
});

/***/ }),
/* 994 */,
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_index_css__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_css__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nvd3_build_nv_d3_css__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nvd3_build_nv_d3_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nvd3_build_nv_d3_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_design_icons_iconfont_material_icons_css__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_design_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_design_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_axios__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_gettext__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_gettext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_gettext__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_en__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sugar_dist_sugar_js__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sugar_dist_sugar_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sugar_dist_sugar_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_clipboard2__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_file_upload__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_infinite_scroll__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_file_base64__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_file_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_file_base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_qrcode_component__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_qrcode_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_qrcode_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__App__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__router__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__filter__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__static_language_translation_json__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__static_language_translation_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__static_language_translation_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_common_remote_script__ = __webpack_require__(911);






























__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_8_axios___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_sugar_dist_sugar_js___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_file_upload___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_file_base64___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('qr-code', __WEBPACK_IMPORTED_MODULE_20_vue_qrcode_component___default.a);

if (localStorage.getItem('currentLanguage')) {
  if (localStorage.getItem('currentLanguage') === 'en_US') {
    __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_en___default.a);
  } else {
    __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_zh_CN___default.a);
  }
} else {
  __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_locale_lang_zh_CN___default.a);
}

Object.forEach(__WEBPACK_IMPORTED_MODULE_24__filter__, function (key, val) {
  __WEBPACK_IMPORTED_MODULE_5_vue__["default"].filter(key, val);
});

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_gettext___default.a, {
  availableLanguages: {
    zh_CN: '简体中文',
    en_US: 'English'
  },
  defaultLanguage: localStorage.getItem('currentLanguage') || 'zh_CN',
  translations: __WEBPACK_IMPORTED_MODULE_25__static_language_translation_json___default.a,
  silent: true
});

__WEBPACK_IMPORTED_MODULE_8_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error && error.response) {
    var data = error.response.data;
    if (data.code === 'NeedLogin') {
      __WEBPACK_IMPORTED_MODULE_22__router__["a" /* default */].push('/login');
    }
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.productionTip = false;

var vm = new __WEBPACK_IMPORTED_MODULE_5_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_22__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_21__App___default.a }
});

window.rootVue = vm;

/***/ }),
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createLogger;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(3);



function createLogger() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === undefined ? true : _ref$collapsed,
      _ref$transformer = _ref.transformer,
      transformer = _ref$transformer === undefined ? function (state) {
    return state;
  } : _ref$transformer,
      _ref$mutationTransfor = _ref.mutationTransformer,
      mutationTransformer = _ref$mutationTransfor === undefined ? function (mut) {
    return mut;
  } : _ref$mutationTransfor;

  return function (store) {
    var prevState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["k" /* deepCopy */])(store.state);
    store.subscribe(function (mutation, state) {
      if (typeof console === 'undefined') {
        return;
      }
      var nextState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["k" /* deepCopy */])(state);
      var time = new Date();
      var formattedTime = ' @ ' + pad(time.getHours(), 2) + ':' + pad(time.getMinutes(), 2) + ':' + pad(time.getSeconds(), 2) + '.' + pad(time.getMilliseconds(), 3);
      var formattedMutation = mutationTransformer(mutation);
      var message = 'mutation ' + mutation.type + formattedTime;
      var startMessage = collapsed ? console.groupCollapsed : console.group;

      try {
        startMessage.call(console, message);
      } catch (e) {
        console.log(message);
      }
      console.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
      console.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
      console.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
      try {
        console.groupEnd();
      } catch (e) {
        console.log('—— log end ——');
      }
      prevState = nextState;
    });
  };
}

function repeat(str, times) {
  return new Array(times + 1).join(str);
}

function pad(num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num;
}

/***/ }),
/* 1001 */,
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_account__ = __webpack_require__(97);




var _mutations, _actions;




var state = {
	account: {},
	suchAccount: {}
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.CURRENT, function (state, account) {
	state.account = account;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.UPDATE, function (state, options) {
	state.account = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, state.account, options);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.GET_SUCH_ACCOUNT, function (state, suchAccount) {
	state.suchAccount = suchAccount;
}), _mutations);

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.LOGIN, function (_ref, data) {
	var commit = _ref.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].login(data).then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.CURRENT, res.data);
			resolve(res.data);
		}, function (err) {
			console.log('err', err);
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.LOGIN_SSO, function (_ref2, data) {
	var commit = _ref2.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].loginSSO(data).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.LOGOUT, function (_ref3) {
	var commit = _ref3.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].logout().then(function (res) {
			resolve(res.data);
			commit(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.CURRENT, {});
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.RSET_PSWD, function (_ref4, params) {
	var commit = _ref4.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].resetPassword(params).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.COMPEL_CHANGE_PSWD, function (_ref5, params) {
	var commit = _ref5.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].compelChangePassword(params).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.CURRENT, function (_ref6) {
	var commit = _ref6.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].getCurrent().then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.CURRENT, res.data);
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.CAANGE_AVATAR, function (_ref7, params) {
	var commit = _ref7.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].changeAvatar(params).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.GET_SUCH_ACCOUNT, function (_ref8, id) {
	var commit = _ref8.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].getSuchAccount(id).then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.GET_SUCH_ACCOUNT, res.data);
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.UPDATE, function (_ref9, params) {
	var commit = _ref9.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].updateAccount(params).then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.UPDATE, res.data);
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.GET_MFA_SECRET, function (_ref10) {
	var commit = _ref10.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].getMfaSecret().then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.POST_MFA_CODE, function (_ref11, params) {
	var commit = _ref11.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].postMfaCode(params).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.VERIFY_MFA_CODE, function (_ref12, params) {
	var commit = _ref12.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].verifyMfa(params).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.CODE, function (_ref13) {
	var commit = _ref13.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].getCode().then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.VERIFY, function (_ref14, params) {
	var commit = _ref14.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].verifiCode(params).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.FORGRTPASSWORD, function (_ref15, params) {
	var commit = _ref15.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].forgotPassword(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.SHOW_CAPTCHA, function (_ref16, params) {
	var commit = _ref16.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].showCaptcha(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.NOTIFY_BANNER, function (_ref17, params) {
	var commit = _ref17.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].notifyBanner(params).then(function (res) {
			resolve(res.data.data);
		}, function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].ACCOUNT.CHECK_SSO, function (_ref18, params) {
	var commit = _ref18.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_account__["a" /* default */].checkSSO(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err);
		});
	});
}), _actions);

var getters = {
	account: function account(state) {
		return state.account;
	},
	suchAccount: function suchAccount(state) {
		return state.suchAccount;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
});

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var state = {
  approval: {
    sqlList: [],
    securityList: []
  }
};

var mutations = {};

var actions = {};

var getters = {
  approval: function approval(state) {
    return state.approval;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_cluster__ = __webpack_require__(985);




var _mutations, _actions;




var state = {
	cluster: {
		newAgentVersion: '',
		list: [],
		detail: {
			info: {},
			settings: {
				logFilters: [],
				shares: [],
				cloudName: '',
				accessKeyId: '',
				accessKeySecret: '',
				region: {
					id: '',
					name: ''
				}
			}
		},

		configPollingInstance: null
	}
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET, function (state, list) {
	state.cluster.list = list;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_DETAIL, function (state, detail) {
	state.cluster.detail.info = detail;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.UPDATE_DETAIL, function (state, info) {
	state.cluster.detail.info = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, state.cluster.detail.info, info);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_SHARING, function (state, list) {
	state.cluster.detail.settings.shares = list;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.AGENT_VERSION, function (state, version) {
	state.cluster.newAgentVersion = version;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.SET_CONFIG_POLLING_INSTANCE, function (state, instance) {
	state.configPollingInstance = instance;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE, function (state) {
	state.configPollingInstance = null;
}), _mutations);

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET, function (_ref, params) {
	var commit = _ref.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getClusterList(params).then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET, res.data.objects);
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_CLUSTER, function (_ref2, params) {
	var commit = _ref2.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getClusterListV1(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.ADD, function (_ref3, params) {
	var commit = _ref3.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].addCluster(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.DELETE, function (_ref4, id) {
	var commit = _ref4.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].deleteCluster(id).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.CHANGE, function (_ref5, params) {
	var commit = _ref5.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].changeCluster(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_DETAIL, function (_ref6, id) {
	var commit = _ref6.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getClusterDetail(id).then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_DETAIL, res.data);
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.DETAIL_LIST, function (_ref7, params) {
	var commit = _ref7.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getInstancesList(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_CLUSTER_RESOURCE, function (_ref8, params) {
	var commit = _ref8.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getClusterResourceList(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.DELETE_RESOURCE, function (_ref9, ids) {
	var commit = _ref9.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].delDetailResource(ids).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.BATCH_DELETE_RESOURCE, function (_ref10, ids) {
	var commit = _ref10.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].batchDeleteResource(ids).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.ADD_RESOURCE, function (_ref11, params) {
	var commit = _ref11.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].addClusterResource(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.CHECK_AGENT, function (_ref12) {
	var commit = _ref12.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].updateAgent().then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.AGENT_VERSION, res.data.version);
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_SHARING, function (_ref13, id) {
	var commit = _ref13.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getSharing(id).then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_SHARING, res.data.networks);
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.ADD_SHARING, function (_ref14, params) {
	var commit = _ref14.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].addSharing(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.CANCEL_SHARE, function (_ref15, id) {
	var commit = _ref15.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].cancelShareCluster(id).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.ADD_LOG_FILTER, function (_ref16, params) {
	var commit = _ref16.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].addLogFilter(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.DEL_LOG_FILTER, function (_ref17, id) {
	var commit = _ref17.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].delLogFilter(id).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.DEL_BARCH_LOG_FILTER, function (_ref18, ids) {
	var commit = _ref18.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].batchDelLogFilter(ids).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_INTERCEPTS_COMMADN, function (_ref19, params) {
	var commit = _ref19.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getInterceptsCommand(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_RESOURCE_DETAIL, function (_ref20, id) {
	var commit = _ref20.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getDetailResource(id).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.PATCH_RESOURCE, function (_ref21, params) {
	var commit = _ref21.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].patchDetailResource(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_SAFE_APPROVER, function (_ref22, params) {
	var commit = _ref22.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getSafeApprover(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.ADD_INTERCEPT, function (_ref23, params) {
	var commit = _ref23.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].addIntercept(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.DEL_INTERCEPT, function (_ref24, ids) {
	var commit = _ref24.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].deleteIntercept(ids).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.DEL_ALARM_INTERCEPT, function (_ref25, ids) {
	var commit = _ref25.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].deleteAlarmIntercept(ids).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.SCAN_SATRT, function (_ref26, params) {
	var commit = _ref26.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].scanImportStart(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.SCAN_QUERY, function (_ref27, params) {
	var commit = _ref27.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].scanImportQuery(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.SCAN_NEW_QUERY, function (_ref28, params) {
	var commit = _ref28.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getNewAgentQuery(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.POST_BATCH_RESOURCE, function (_ref29, params) {
	var commit = _ref29.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].postBatchResource(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.CLOUD_IMPORT_ECS, function (_ref30, params) {
	var commit = _ref30.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].cloudImportECS(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.CLOUD_IMPORT_RDS, function (_ref31, params) {
	var commit = _ref31.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].cloudImportRDS(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.TEST_CONNECTION, function (_ref32, params) {
	var commit = _ref32.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].testConnection(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.QUERY_TEST, function (_ref33, params) {
	var commit = _ref33.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].queryTestConnection(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.TEST_KEY_AVALIABLE, function (_ref34, params) {
	var commit = _ref34.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].testKeyAvaliable(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.QUERY_KEY_AVALIABLE, function (_ref35, params) {
	var commit = _ref35.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].queryTestAvaliable(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.XLSX_BATCH_IMPORT, function (_ref36, params) {
	var commit = _ref36.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].xlsxBatchImport(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_CLUSTER_RESOURCE_STATISTIC, function (_ref37, params) {
	var commit = _ref37.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getClusterResourceStatistic(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_CLUSTER_STATISTIC, function (_ref38, params) {
	var commit = _ref38.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getClusterStatistic(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_RESOURCE_STATISTIC, function (_ref39, params) {
	var commit = _ref39.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getResourceStatistic(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.UOLOAD_SSHKEY, function (_ref40, params) {
	var commit = _ref40.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].uploadSshkey(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.QUERY_SSHKEY, function (_ref41, params) {
	var commit = _ref41.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].queryUploadSshkey(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_ALIYUN_ECS, function (_ref42, params) {
	var commit = _ref42.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getEcsAliyunInfo(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.BAECH_DELETE_ONLINE_USER, function (_ref43, params) {
	var commit = _ref43.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].batchDelOnlineUser(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.CLOUD_GET_REGIONS, function (_ref44, params) {
	var commit = _ref44.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getCloudRegions(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.SCAN_INSTANCE, function (_ref45, params) {
	var commit = _ref45.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].scanInstance(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.LOAD_INSTANCE, function (_ref46, params) {
	var commit = _ref46.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].loadInstance(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.GET_RESOURCE_LISTS, function (_ref47, params) {
	var commit = _ref47.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].getResourceList(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.EXPORT_CLUSTER_CONFIG, function (_ref48, params) {
	var commit = _ref48.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].exportClusterConfig(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.IMPORT_CLUSTER_CONFIG, function (_ref49, params) {
	var commit = _ref49.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].importClusterConfig(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* default */].CLUSTER.POLLING_CLUSTER_CONFIG, function (_ref50, params) {
	var commit = _ref50.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_4__api_cluster__["a" /* default */].pollingClusterConfig(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), _actions);

var getters = {
	cluster: function cluster(state) {
		return state.cluster;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
});

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_dashboard__ = __webpack_require__(986);





var _mutations, _actions;




var state = {
  dashboard: {
    statistics: {},
    resourceTypes: [],
    operations: [],
    onlineMembers: [],
    onlineMembersCount: '',
    topMembers: [],
    topResources: []
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT_COUNTS, function (state, onlineMemberCount) {
  state.dashboard.onlineMembersCount = onlineMemberCount;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT, function (state, onlineMemberList) {
  state.dashboard.onlineMembers = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(onlineMemberList));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.GET_STATISTICS, function (state, statistics) {
  state.dashboard.statistics = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, state.dashboard.statistics, statistics);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.LIST_TOP_MEMBERS, function (state, topMembers) {
  state.dashboard.topMembers = topMembers;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.LIST_TOP_RESOURCES, function (state, topResources) {
  state.dashboard.topResources = topResources;
}), _mutations);

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT_COUNTS, function (_ref, params) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__api_dashboard__["a" /* default */].getOnlineConnectCount(params).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT_COUNTS, res.data.count);
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT, function (_ref2, params) {
  var commit = _ref2.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__api_dashboard__["a" /* default */].getOnlineConnectList(params).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.LIST_ONLINE_CONNECT, res.data.objects);
      resolve(res.data.objects);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.GET_ONLINE_CONNECT, function (_ref3, params) {
  var commit = _ref3.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__api_dashboard__["a" /* default */].getOnlineConnectList(params).then(function (res) {
      resolve(res.data.objects);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.GET_STATISTICS, function (_ref4, params) {
  var commit = _ref4.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__api_dashboard__["a" /* default */].getStatistics(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.GET_STATISTICS).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.GET_STATISTICS, res.data);
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.LIST_TOP_MEMBERS, function (_ref5, params) {
  var commit = _ref5.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__api_dashboard__["a" /* default */].getTopMembers(params).then(function (res) {
      resolve(res.data.result);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.LIST_TOP_RESOURCES, function (_ref6, params) {
  var commit = _ref6.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__api_dashboard__["a" /* default */].getTopResources(params).then(function (res) {
      resolve(res.data.result);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.CUT_ONLINE, function (_ref7, id) {
  var commit = _ref7.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__api_dashboard__["a" /* default */].cutOnlineConnent(id).then(function (res) {
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.CUT_ONLINE_MULTIPLE, function (_ref8, id) {
  var commit = _ref8.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__api_dashboard__["a" /* default */].cutOnlineConnentMultiple(id).then(function (res) {
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.GET_CONNECT_NUMBER, function (_ref9, params) {
  var commit = _ref9.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__api_dashboard__["a" /* default */].getConnectNumbers(params).then(function (res) {
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.GET_OPERATION_WEEK, function (_ref10, params) {
  var commit = _ref10.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__api_dashboard__["a" /* default */].getWeekOperationStatistic(params).then(function (res) {
      resolve(res.data.result);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.GET_RESOURCE_TYPE_STATISTIC, function (_ref11, params) {
  var commit = _ref11.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__api_dashboard__["a" /* default */].getResourceTypeStatistic(params).then(function (res) {
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* default */].DASHBOARD.GET_STATISTIC_SUMMARY, function (_ref12, params) {
  var commit = _ref12.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__api_dashboard__["a" /* default */].getStatisticSummary(params).then(function (res) {
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), _actions);

var getters = {
  dashboard: function dashboard(state) {
    return state.dashboard;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_document__ = __webpack_require__(987);



var _actions;




var state = {
  document: []
};

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].DOCUMENT.GET_LIST, function (state, list) {
  state.document = list;
});

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].DOCUMENT.GET_LIST, function (_ref, params) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_document__["a" /* default */].getDocumentList(params).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].DOCUMENT.GET_LIST, res.data.objects);
      resolve(res.data);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].DOCUMENT.DEL, function (_ref2, params) {
  var commit = _ref2.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_document__["a" /* default */].delDocument(params).then(function (res) {
      resolve(res.data);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].DOCUMENT.UPLOAD, function (_ref3, params) {
  var commit = _ref3.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_document__["a" /* default */].uploadFile(params).then(function (res) {
      resolve(res.data);
    });
  });
}), _actions);

var getters = {
  document: function document(state) {
    return state.document;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_logs__ = __webpack_require__(988);



var _mutations, _actions;




var state = {
  logs: {
    loginLogs: {},
    teamLogs: {},
    clusterLogs: {},
    resourceLogs: {},
    alarmLogs: {},
    alarmNotifyUnreadCounts: 0
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.LOGIN, function (state, log) {
  state.logs.loginLogs = log;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.TEAM, function (state, log) {
  state.logs.teamLogs = log;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.CLUSTER, function (state, log) {
  state.logs.clusterLogs = log;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.RESOURCE, function (state, log) {
  state.logs.resourceLogs = log;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.ALARM, function (state, notice) {
  state.logs.alarmLogs = notice;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.UNREAD_COUNTS, function (state, counts) {
  state.logs.alarmNotifyUnreadCounts = counts;
}), _mutations);

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.LOGIN, function (_ref, params) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_logs__["a" /* default */].getLogin(params).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.LOGIN, res.data);
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.TEAM, function (_ref2, params) {
  var commit = _ref2.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_logs__["a" /* default */].getTeam(params).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.TEAM, res.data);
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.CLUSTER, function (_ref3, params) {
  var commit = _ref3.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_logs__["a" /* default */].getCluster(params).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.CLUSTER, res.data);
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.RESOURCE, function (_ref4, params) {
  var commit = _ref4.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_logs__["a" /* default */].getResource(params).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.RESOURCE, res.data);
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.ALARM, function (_ref5, params) {
  var commit = _ref5.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_logs__["a" /* default */].getAlarmLog(params).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.ALARM, res.data);
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.HANDLE_NOTICE, function (_ref6, params) {
  var commit = _ref6.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_logs__["a" /* default */].handleEventNotice(params).then(function (res) {
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.ACTION, function (_ref7, params) {
  var commit = _ref7.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_logs__["a" /* default */].getActionList(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.UNFREEZE, function (_ref8, params) {
  var commit = _ref8.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_logs__["a" /* default */].unFreezeLog(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.VIEW_LOG, function (_ref9, params) {
  var commit = _ref9.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_logs__["a" /* default */].viewLog(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.GET_ACCOUNT_NAME, function (_ref10, params) {
  var commit = _ref10.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_logs__["a" /* default */].getAllMenber(params).then(function (res) {
      resolve(res.data);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.GET_RESOURCE_NAME, function (_ref11, params) {
  var commit = _ref11.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_logs__["a" /* default */].getAllResourceName(params).then(function (res) {
      resolve(res.data);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.GET_ALARM_NOTIFY_UNREAD_COUNTS, function (_ref12, params) {
  var commit = _ref12.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_logs__["a" /* default */].getAlarmNotifyUnreadCounts(params).then(function (res) {
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].LOG.CLOSE_ALARM_NOTIFY, function (_ref13, params) {
  var commit = _ref13.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_logs__["a" /* default */].closeAlarmNotify(params).then(function (res) {
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
}), _actions);

var getters = {
  logs: function logs(state) {
    return state.logs;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_review__ = __webpack_require__(990);



var _actions;




var state = {};

var mutations = {};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.GET_PROJECT_LIST, function (_ref, params) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].getProject(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.GET_RESOURCE_LIST, function (_ref2, params) {
  var commit = _ref2.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].getResourceList(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.CREATE_SQL_APPLICATION, function (_ref3, params) {
  var commit = _ref3.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].createSqlApplication(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.GET_MY_SQL_APPLICATION, function (_ref4, params) {
  var commit = _ref4.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].getMySqlApplication(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.GET_SQL_APPROVING_APPLICATION, function (_ref5, params) {
  var commit = _ref5.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].getApprovingApplication(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.GET_SQL_APPROVED_APPLICATION, function (_ref6, params) {
  var commit = _ref6.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].getApprovedApplication(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.GET_SAFE_APPLICATION, function (_ref7, params) {
  var commit = _ref7.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].getSafeApplication(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.CREATE_SAFE_APPLY, function (_ref8, params) {
  var commit = _ref8.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].createSafeModeApply(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.GET_MY_SAFE_APPLY, function (_ref9, params) {
  var commit = _ref9.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].getMySafeModeApply(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.GET_SAFE_APPROVING_APPLY, function (_ref10, params) {
  var commit = _ref10.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].getSafeApprovingApply(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.GET_SAFE_APPROVED_APPLY, function (_ref11, params) {
  var commit = _ref11.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].getSafeApprovedApply(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.GET_MY_APPLY_DETAIL, function (_ref12, params) {
  var commit = _ref12.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].getMyApplyDetail(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.DELETE_SQL_APPLY, function (_ref13, id) {
  var commit = _ref13.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].deleteSqlDetail(id).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.EXECUTE_SQL_APPLICATION, function (_ref14, params) {
  var commit = _ref14.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].excuteSqlApplication(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.REJECT_SQL_APPLICATION, function (_ref15, id) {
  var commit = _ref15.commit;

  var params = {
    status: 'rejected'
  };
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].rejectSqlApplication(params, id).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.GET_SAFE_DETAIL, function (_ref16, id) {
  var commit = _ref16.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].getSafeDetail(id).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.DELETE_SAFE_APPLY, function (_ref17, id) {
  var commit = _ref17.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].deleteSafeApply(id).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.DO_SAFE_EXCUTE, function (_ref18, id) {
  var commit = _ref18.commit;

  var params = {
    app_status: 1
  };
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].doSafeExcute(params, id).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].REVIEW.DO_SAFE_REJECT, function (_ref19, id) {
  var commit = _ref19.commit;

  var params = {
    app_status: 2
  };
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_review__["a" /* default */].doSafeReject(params, id).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}), _actions);

var getters = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_sshkey__ = __webpack_require__(991);



var _actions;




var state = {
  sshKey: []
};

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].SSHKEY.GET, function (state, sshKey) {
  state.sshKey = sshKey;
});

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].SSHKEY.GET, function (_ref, params) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_sshkey__["a" /* default */].getList(params).then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].SSHKEY.GET, res.data.objects);
      resolve(res.data);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].SSHKEY.ADD, function (_ref2, params) {
  var commit = _ref2.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_sshkey__["a" /* default */].addKey(params).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      reject(err.data);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].SSHKEY.DEL, function (_ref3, id) {
  var commit = _ref3.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__api_sshkey__["a" /* default */].delKey(id).then(function (res) {
      resolve(res.data);
    });
  });
}), _actions);

var getters = {
  sshKey: function sshKey(state) {
    return state.sshKey;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_team__ = __webpack_require__(992);



var _mutations, _actions;




var state = {
	team: {
		list: [],
		members: {},
		setting: {},
		groupList: [],
		group: []
	}
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.LIST, function (state, list) {
	state.team.list = list;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.CURRENT, function (state, setting) {
	state.team.setting = setting;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GET_MEMBER, function (state, members) {
	state.team.members = members;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GROUP_LIST, function (state, groupList) {
	state.team.groupList = groupList;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GET_GROUP, function (state, group) {
	state.team.group = group;
}), _mutations);

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.LIST, function (_ref, params) {
	var commit = _ref.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].getList(params).then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.LIST, res.data.objects);
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GET_MEMBER_LIST, function (_ref2, params) {
	var commit = _ref2.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].getMemberList(params).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.ADD, function (_ref3, params) {
	var commit = _ref3.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].addMember(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.CURRENT, function (_ref4) {
	var commit = _ref4.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].getCurrent().then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.CURRENT, res.data);
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.SET, function (_ref5, params) {
	var commit = _ref5.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].setTeam(params).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GET_MEMBER, function (_ref6, id) {
	var commit = _ref6.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].getMember(id).then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GET_MEMBER, res.data);
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.EDIT_MEMBER, function (_ref7, params) {
	var commit = _ref7.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].editMember(params).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.DELETE, function (_ref8, id) {
	var commit = _ref8.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].deleteMember(id).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GROUP_LIST, function (_ref9, params) {
	var commit = _ref9.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].getGroupList(params).then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GROUP_LIST, res.data.objects);
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GET_GROUP_MEMBERS, function (_ref10, params) {
	var commit = _ref10.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].getGroupMemberList(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.ADD_GROUP, function (_ref11, params) {
	var commit = _ref11.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].addGroup(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.EDIT_GROUP, function (_ref12, params) {
	var commit = _ref12.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].editGroup(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.DELETE_GROUP, function (_ref13, id) {
	var commit = _ref13.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].deleteGroup(id).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GET_GROUP, function (_ref14, params) {
	var commit = _ref14.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].getGroup(params).then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GET_GROUP, res.data.members);
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GROUP_ADD_MEMBER, function (_ref15, params) {
	var commit = _ref15.commit;

	console.log('aa');
	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].groupAddMember(params).then(function (res) {
			console.log('succ');
			resolve(res.data);
		}).catch(function (err) {
			console.log('err');
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.DEL_GROUP_MEMBER, function (_ref16, params) {
	var commit = _ref16.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].deleteGroupMember(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GET_STATISTIC_TEAM, function (_ref17, params) {
	var commit = _ref17.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].getStatistic(params).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GET_RESOURCE_STATISTIC_TEAM, function (_ref18, params) {
	var commit = _ref18.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].getResourceStatistic(params).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GET_PLAN, function (_ref19, id) {
	var commit = _ref19.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].getPlanInfo(id).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.UPDATE_TEAM_TOKEN, function (_ref20, params) {
	var commit = _ref20.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].updateTeamToken(params).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.UNBIND_WORKSPACE, function (_ref21, params) {
	var commit = _ref21.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].unBindWorkSpace(params).then(function (res) {
			resolve(res.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.RESET_MFA, function (_ref22, params) {
	var commit = _ref22.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].resetMFA(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GET_SSO_CONFIG, function (_ref23) {
	var commit = _ref23.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].getSSOConfig().then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.UPDATE_SSO_CONFIG, function (_ref24, data) {
	var commit = _ref24.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].updateSSOConfig(data).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.GET_NTP_CONFIG, function (_ref25) {
	var commit = _ref25.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].getNTPConfig().then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].TEAM.UPDATE_NTP_CONFIG, function (_ref26, data) {
	var commit = _ref26.commit;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_team__["a" /* default */].updateNTPConfig(data).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), _actions);

var getters = {
	team: function team(state) {
		return state.team;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
});

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_workgroup__ = __webpack_require__(993);



var _actions;




var state = {
	workgroup: {
		instances: [],
		databases: [],
		members: []
	}
};

var mutations = {};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP_RESOURCE, function (_ref, params) {
	var commit = _ref.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getWorkGroupResource(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.LIST_WORKGROUP, function (_ref2, params) {
	var commit = _ref2.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getWorkGroupList(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.LIST_FAVOURITE_WORKGROUP, function (_ref3, params) {
	var commit = _ref3.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getFavouriteWorkGroup(params).then(function (res) {
			resolve(res.data.objects);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.SET_FAVOURITE, function (_ref4, params) {
	var commit = _ref4.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].setFavourite(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_WORKGROUP_DETAIL, function (_ref5, params) {
	var commit = _ref5.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getWorkGroupDetail(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_TUNNEL_CODE, function (_ref6, params) {
	var commit = _ref6.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getTunnelCode(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_VERSION_BY_TYPE, function (_ref7, params) {
	var commit = _ref7.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getVersionByType(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.CREATE_CSOS_REPORT, function (_ref8, params) {
	var commit = _ref8.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].createCsosReport(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_CSOS_REPORT, function (_ref9, params) {
	var commit = _ref9.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getCsosReport(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_CSOS_REPORT_STATE, function (_ref10, params) {
	var commit = _ref10.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getCsosReportState(params).then(function (res) {
			console.log(res, 'res');
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.DELETE_WORKGROUP, function (_ref11, id) {
	var commit = _ref11.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].delWorkGroupResource(id).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_CONNECT_LOG, function (_ref12, params) {
	var commit = _ref12.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getConnectLog(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.CREATED_WORKGROUP, function (_ref13, params) {
	var commit = _ref13.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].createdWorkGroupResource(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_TUNNEL_INFO, function (_ref14, params) {
	var commit = _ref14.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getTunnelInfo(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.TEST_PASSWORD_CONNECTION, function (_ref15, params) {
	var commit = _ref15.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].testPasswordConnection(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.PATCH_WORKGROUP, function (_ref16, id) {
	var commit = _ref16.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].patchWorkGroupResource(id).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.UPDATE_TUNNEL, function (_ref17, params) {
	var commit = _ref17.commit;

	var data = {
		safe_mode: params.safe_mode
	};
	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].updateTunnel(params.code, data).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.DEL_WORKGROUP_RESOURCE, function (_ref18, ids) {
	var commit = _ref18.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].batchDelWorkgroupResource(ids).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_PROJECT_RESOURCE_INFO, function (_ref19, id) {
	var commit = _ref19.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getPeojectResourceInfo(id).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.ADD_WORKGTOUP_RESOURCE, function (_ref20, params) {
	var commit = _ref20.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].addWorkgroupResource(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_CLIENT_IP, function (_ref21) {
	var commit = _ref21.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getClientIp().then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_MEMBER_LIST, function (_ref22, params) {
	var commit = _ref22.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getWorkgroupMemberList(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.ADD_MEMBER, function (_ref23, params) {
	var commit = _ref23.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].addWorkgroupMember(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.CREATE_CODE, function (_ref24, data) {
	var commit = _ref24.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].createCode(data).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.DEL_MEMBER, function (_ref25, params) {
	var commit = _ref25.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].delWorkGroupMember(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_WORKGROUP_GROUP, function (_ref26, params) {
	var commit = _ref26.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getWorkgroupGroup(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_GROUP_LIST, function (_ref27, params) {
	var commit = _ref27.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getWorkgroupGroupList(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.ADD_GROUP, function (_ref28, params) {
	var commit = _ref28.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].addWorkgroupGroup(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.CHANGE_LOGIN_USER, function (_ref29, params) {
	var commit = _ref29.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].changeLoginUser(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.DEL_GROUP, function (_ref30, params) {
	var commit = _ref30.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].delWorkgroupGroup(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.DELETE_CODE, function (_ref31, code) {
	var commit = _ref31.commit;

	var params = {
		status: 'disable'
	};
	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].deleteCode(code, params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.PATCH_MEMBER, function (_ref32, params) {
	var commit = _ref32.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].patchWorkGroupMember(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_CODE_INFO, function (_ref33, code) {
	var commit = _ref33.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getCodeInfo(code).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_MEMBER_ADMIN, function (_ref34, id) {
	var commit = _ref34.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getWorkgroupMemberAdmin(id).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.MODIFY_CODE, function (_ref35, obj) {
	var commit = _ref35.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].modifyCode(obj.code, obj.data).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.SET_PROJECT_DEFAULT_NAME, function (_ref36, obj) {
	var commit = _ref36.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].setProjectDafaultName(obj.project_resource_id, obj.data).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_CODE_VERSION, function (_ref37, params) {
	var commit = _ref37.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getCodeVersion(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_WORKGROUP_RESOURCE_ONLINE_CONNECTS, function (_ref38, params) {
	var commit = _ref38.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getResourceOnlineConnects(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_LITE_CONNECT_INFO, function (_ref39, data) {
	var commit = _ref39.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getLiteConnectInfo(data).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_ASSIST_INFO, function (_ref40, params) {
	var commit = _ref40.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getAssistInfo(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_SHADOW_CONNECT, function (_ref41, params) {
	var commit = _ref41.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getShadowConnect(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_CSOS_SHADOW, function (_ref42, params) {
	var commit = _ref42.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getCsosShadow(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.QUERY_CSOS_CONNECT, function (_ref43, params) {
	var commit = _ref43.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].queryCsosConnect(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.VERIFY_SQL, function (_ref44, params) {
	var commit = _ref44.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].verifySQL(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_ACCOUNT_WORKGROUP_LIST, function (_ref45, params) {
	var commit = _ref45.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getAccountWorkgroupList(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.ADD_ACCOUNT_WORKGROUP, function (_ref46, params) {
	var commit = _ref46.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].addAccountWorkgroup(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.DEL_ACCOUNT_WORKGROUP, function (_ref47, params) {
	var commit = _ref47.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].deleteAccountWorkgroup(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.GET_WORKGROUP_LIST_BY_GROUP, function (_ref48, params) {
	var commit = _ref48.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].getWorkGroupListByGroup(params).then(function (res) {
			resolve(res.data);
		}).catch(function (err) {
			reject(err);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.ADD_GROUP_WORKGROUP, function (_ref49, params) {
	var commit = _ref49.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].addGroupWorkgroup(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* default */].WORKGROUP.DEL_GROUP_WORKGROUP, function (_ref50, params) {
	var commit = _ref50.commit;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_3__api_workgroup__["a" /* default */].deleteGroupWorkgroup(params).then(function (res) {
			resolve(res.data);
		}, function (err) {
			reject(err.data);
		});
	});
}), _actions);

var getters = {
	workgroup: function workgroup(state) {
		return state.workgroup;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
});

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "file",
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.onChange
    }
  })
},staticRenderFns: []}

/***/ })
],[995]);


// WEBPACK FOOTER //
// static/js/console.6a5f1683c78ed5f7839d.js